(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 74107:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_IconFont)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/config.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var config = {
  isIntl: false
};
var getConfig = function getConfig() {
  return _objectSpread({}, config);
};
var setConfig = function setConfig(params) {
  for (var key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      var typedKey = key;
      config[typedKey] = params[typedKey];
    }
  }
};
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/iconHash.js
// ⚠️ 此文件由 scripts/gen-icon-hash.ts 自动生成，请勿手动修改
var ICON_HASH = '7a358203';
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js
/* provided dependency */ var process = __webpack_require__(34155);
function IconFont_typeof(obj) { "@babel/helpers - typeof"; return IconFont_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, IconFont_typeof(obj); }
var _excluded = ["name", "className", "color", "fontSize", "style", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function IconFont_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function IconFont_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IconFont_ownKeys(Object(source), !0).forEach(function (key) { IconFont_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IconFont_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function IconFont_defineProperty(obj, key, value) { key = IconFont_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function IconFont_toPropertyKey(arg) { var key = IconFont_toPrimitive(arg, "string"); return IconFont_typeof(key) === "symbol" ? key : String(key); }
function IconFont_toPrimitive(input, hint) { if (IconFont_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (IconFont_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == IconFont_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var iconCache = new Map();
var pendingFetches = new Map();
var IconFont = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var name = props.name,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    color = props.color,
    fontSize = props.fontSize,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    onClick = props.onClick,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = (0,react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    svgContent = _useState2[0],
    setSvgContent = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _getConfig = getConfig(),
    isIntl = _getConfig.isIntl;
  (0,react.useEffect)(function () {
    var _process$env;
    if (!name) return;
    var isMounted = true;
    var isDev = typeof process !== 'undefined' && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.UMI_APP_ENV) === 'development'; // 兼容SSR环境
    var cdnPrefix = isIntl ? 'https://x-design-static-release.stariicloud.com' : 'https://pc.meitudata.com';
    var nameOriginal = name.charAt(0).toLowerCase() + name.slice(1);
    var url = isDev ? "/x-design-icons/icons/".concat(nameOriginal, ".svg") : "".concat(cdnPrefix, "/x-design-icons/").concat(ICON_HASH, "/").concat(nameOriginal, ".svg");
    var loadSVG = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var content, fetchPromise, svg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!iconCache.has(name)) {
                _context2.next = 3;
                break;
              }
              setSvgContent(iconCache.get(name));
              return _context2.abrupt("return");
            case 3:
              if (!pendingFetches.has(name)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 6;
              return pendingFetches.get(name);
            case 6:
              content = _context2.sent;
              if (isMounted) setSvgContent(content);
              return _context2.abrupt("return");
            case 9:
              fetchPromise = fetch(url).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var svgText, parser, doc, svg;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (res.ok) {
                          _context.next = 2;
                          break;
                        }
                        throw new Error("Failed to load ".concat(name));
                      case 2:
                        _context.next = 4;
                        return res.text();
                      case 4:
                        svgText = _context.sent;
                        // 用 DOMParser 解析 SVG 内容为 DOM
                        parser = new DOMParser();
                        doc = parser.parseFromString(svgText, 'image/svg+xml');
                        svg = doc.querySelector('svg');
                        if (svg) {
                          _context.next = 10;
                          break;
                        }
                        throw new Error("Invalid SVG content for icon [".concat(name, "]"));
                      case 10:
                        // 设置 width/height 为 1em
                        svg.setAttribute('width', '1em');
                        svg.setAttribute('height', '1em');

                        // 设置 fill="currentColor"（排除 fill="none"）
                        svg.querySelectorAll('[fill]').forEach(function (el) {
                          var fill = el.getAttribute('fill');
                          if (fill && fill.toLowerCase() !== 'none') {
                            el.setAttribute('fill', 'currentColor');
                          }
                        });

                        // 移除 <defs> 节点
                        svg.querySelectorAll('defs').forEach(function (defs) {
                          return defs.remove();
                        });

                        // 移除 clip-path、mask、filter 属性
                        ['clip-path', 'mask', 'filter'].forEach(function (attr) {
                          svg.querySelectorAll("[".concat(attr, "]")).forEach(function (el) {
                            el.removeAttribute(attr);
                          });
                        });
                        return _context.abrupt("return", svg.outerHTML);
                      case 16:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()).then(function (svg) {
                iconCache.set(name, svg);
                return svg;
              }).catch(function (err) {
                console.error("Icon load error [".concat(name, "]:"), err);
                setError(true);
                return '';
              });
              pendingFetches.set(name, fetchPromise);
              _context2.next = 13;
              return fetchPromise;
            case 13:
              svg = _context2.sent;
              if (isMounted) setSvgContent(svg);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function loadSVG() {
        return _ref.apply(this, arguments);
      };
    }();
    loadSVG();
    return function () {
      isMounted = false;
    };
  }, [name]);
  var size = style.fontSize || fontSize || 12;
  return /*#__PURE__*/react.createElement("span", _extends({
    className: "iconfont icon-".concat(name, " ").concat(className)
    // eslint-disable-next-line
    ,
    "alias-name": name,
    style: IconFont_objectSpread({
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: color,
      fontSize: size
    }, style),
    dangerouslySetInnerHTML: svgContent && !error ? {
      __html: svgContent
    } : undefined,
    ref: ref
  }, restProps, {
    onClick: onClick
  }));
});
/* harmony default export */ const dist_IconFont = (/*#__PURE__*/react.memo(IconFont));

/***/ }),

/***/ 93379:
/***/ ((module) => {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),

/***/ 79742:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 58509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qp": () => (/* binding */ disableBodyScroll),
/* harmony export */   "tG": () => (/* binding */ enableBodyScroll)
/* harmony export */ });
/* unused harmony export clearAllBodyScrollLocks */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPosition = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

var setPositionFixed = function setPositionFixed() {
  return window.requestAnimationFrame(function () {
    // If previousBodyPosition is already set, don't set it again.
    if (previousBodyPosition === undefined) {
      previousBodyPosition = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };

      // Update the dom inside an animation frame 
      var _window = window,
          scrollY = _window.scrollY,
          scrollX = _window.scrollX,
          innerHeight = _window.innerHeight;

      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY;
      document.body.style.left = -scrollX;

      setTimeout(function () {
        return window.requestAnimationFrame(function () {
          // Attempt to check if the bottom bar appeared due to the position change
          var bottomBarHeight = innerHeight - window.innerHeight;
          if (bottomBarHeight && scrollY >= innerHeight) {
            // Move the content further up so that the bottom bar doesn't hide it
            document.body.style.top = -(scrollY + bottomBarHeight);
          }
        });
      }, 300);
    }
  });
};

var restorePositionSetting = function restorePositionSetting() {
  if (previousBodyPosition !== undefined) {
    // Convert the position from "px" to Int
    var y = -parseInt(document.body.style.top, 10);
    var x = -parseInt(document.body.style.left, 10);

    // Restore styles
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;

    // Restore scroll
    window.scrollTo(x, y);

    previousBodyPosition = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  }
};

var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });

    if (documentListenerAdded) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }

  locks = [];
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
};



/***/ }),

/***/ 48764:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var isArray = __webpack_require__(5826)

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = __webpack_require__.g.TYPED_ARRAY_SUPPORT !== undefined
  ? __webpack_require__.g.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
__webpack_unused_export__ = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


/***/ }),

/***/ 25730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ ((module) => {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ ((module) => {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {import('.')} */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ ((module) => {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	// eslint-disable-next-line no-extra-parens
	var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic([intrinsic]);
	}
	return intrinsic;
};


/***/ }),

/***/ 78249:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(42480);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 98269:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 63465:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Hex;

}));

/***/ }),

/***/ 55743:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),

/***/ 68398:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(62783), __webpack_require__(89824));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA1;

}));

/***/ }),

/***/ 88010:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(52153), __webpack_require__(89824));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),

/***/ 89824:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 62783:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 52153:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 53879:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var prefix = __webpack_require__(87236)
var toCamelCase = __webpack_require__(6189)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(93379)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),

/***/ 96504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 94501:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g3": () => (/* binding */ StoreProvider),
  "aD": () => (/* binding */ action),
  "MT": () => (/* binding */ dist_createStore),
  "tl": () => (/* binding */ createTypedHooks)
});

// UNUSED EXPORTS: actionOn, computed, createContextStore, createStoreActionsHook, createStoreDispatchHook, createStoreRehydratedHook, createStoreStateHook, createTransform, debug, effectOn, generic, initializeUseStoreState, persist, reducer, thunk, thunkOn, useLocalStore, useStore, useStoreActions, useStoreDispatch, useStoreRehydrated, useStoreState

// EXTERNAL MODULE: ./node_modules/easy-peasy/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(19509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ const es = (thunk);
;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ const immer_esm = ((/* unused pure expression or super */ null && (fn)));
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/fast-deep-equal/es6/index.js
var es6 = __webpack_require__(62991);
var es6_default = /*#__PURE__*/__webpack_require__.n(es6);
;// CONCATENATED MODULE: ./node_modules/easy-peasy/dist/index.js








var StoreContext = (0,react.createContext)();

var useNotInitialized = function useNotInitialized() {
  throw new Error('uSES not initialized!');
};
var useSyncExternalStoreWithSelector = useNotInitialized;
var initializeUseStoreState = function initializeUseStoreState(fn) {
  useSyncExternalStoreWithSelector = fn;
};
var refEquality = function refEquality(a, b) {
  return a === b;
};
function createStoreStateHook(Context) {
  return function useStoreState(mapState, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }
    if (false) {}
    var store = (0,react.useContext)(Context);

    /*
    function useSyncExternalStoreWithSelector<Snapshot, Selection>(
        subscribe: (onStoreChange: () => void) => () => void,
        getSnapshot: () => Snapshot,
        getServerSnapshot: undefined | null | (() => Snapshot),
        selector: (snapshot: Snapshot) => Selection,
        isEqual?: (a: Selection, b: Selection) => boolean,
    ): Selection;
    */
    var selectedState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState,
    // getServerSnapshot = getState
    mapState, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
var useStoreState = createStoreStateHook(StoreContext);
function createStoreActionsHook(Context) {
  return function useStoreActions(mapActions) {
    var store = (0,react.useContext)(Context);
    return mapActions(store.getActions());
  };
}
var useStoreActions = createStoreActionsHook(StoreContext);
function createStoreDispatchHook(Context) {
  return function useStoreDispatch() {
    var store = (0,react.useContext)(Context);
    return store.dispatch;
  };
}
var useStoreDispatch = createStoreDispatchHook(StoreContext);
function useStore() {
  return (0,react.useContext)(StoreContext);
}
function createStoreRehydratedHook(Context) {
  return function useStoreRehydrated() {
    var store = (0,react.useContext)(Context);
    var _useState = (0,react.useState)(false),
      rehydrated = _useState[0],
      setRehydrated = _useState[1];
    (0,react.useEffect)(function () {
      store.persist.resolveRehydration().then(function () {
        return setRehydrated(true);
      });
    }, []);
    return rehydrated;
  };
}
var useStoreRehydrated = createStoreRehydratedHook(StoreContext);
function createTypedHooks() {
  return {
    useStoreActions: useStoreActions,
    useStoreDispatch: useStoreDispatch,
    useStoreState: useStoreState,
    useStoreRehydrated: useStoreRehydrated,
    useStore: useStore
  };
}

var actionSymbol = '$_a';
var actionOnSymbol = '$_aO';
var computedSymbol = '$_c';
var effectOnSymbol = '$_e';
var persistSymbol = '$_p';
var reducerSymbol = '$_r';
var thunkOnSymbol = '$_tO';
var thunkSymbol = '$_t';

var debug = function debug(state) {
  if (isDraft(state)) {
    return current(state);
  }
  return state;
};
var actionOn = function actionOn(targetResolver, fn, config) {
  var _ref;
  return _ref = {}, _ref[actionOnSymbol] = true, _ref.fn = fn, _ref.targetResolver = targetResolver, _ref.config = config, _ref;
};
var action = function action(fn, config) {
  var _ref2;
  return _ref2 = {}, _ref2[actionSymbol] = true, _ref2.fn = fn, _ref2.config = config, _ref2;
};
var defaultStateResolvers = [function (state) {
  return state;
}];
var computed = function computed(fnOrStateResolvers, fn) {
  var _ref4;
  if (typeof fn === 'function') {
    var _ref3;
    return _ref3 = {}, _ref3[computedSymbol] = true, _ref3.fn = fn, _ref3.stateResolvers = fnOrStateResolvers, _ref3;
  }
  return _ref4 = {}, _ref4[computedSymbol] = true, _ref4.fn = fnOrStateResolvers, _ref4.stateResolvers = defaultStateResolvers, _ref4;
};
function effectOn(dependencyResolvers, fn) {
  var _ref5;
  return _ref5 = {}, _ref5[effectOnSymbol] = true, _ref5.dependencyResolvers = dependencyResolvers, _ref5.fn = fn, _ref5;
}
function generic(value) {
  return value;
}
var persist = function persist(model, config) {
  var _objectSpread2;
  return (
    // if we are not running in a browser context this becomes a no-op
    typeof window === 'undefined' ? model : _objectSpread(_objectSpread({}, model), {}, (_objectSpread2 = {}, _objectSpread2[persistSymbol] = config, _objectSpread2))
  );
};
var thunkOn = function thunkOn(targetResolver, fn) {
  var _ref6;
  return _ref6 = {}, _ref6[thunkOnSymbol] = true, _ref6.fn = fn, _ref6.targetResolver = targetResolver, _ref6;
};
var dist_thunk = function thunk(fn) {
  var _ref7;
  return _ref7 = {}, _ref7[thunkSymbol] = true, _ref7.fn = fn, _ref7;
};
var reducer = function reducer(fn, config) {
  var _ref8;
  return _ref8 = {}, _ref8[reducerSymbol] = true, _ref8.fn = fn, _ref8.config = config, _ref8;
};

/**
 * We create our own immer instance to avoid potential issues with autoFreeze
 * becoming default enabled everywhere. We want to disable autofreeze as it
 * does not suit the design of Easy Peasy.
 * https://github.com/immerjs/immer/issues/681#issuecomment-705581111
 */
var easyPeasyImmer;
function dist_isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}
function clone(source) {
  function recursiveClone(current) {
    var next = Object.keys(current).reduce(function (acc, key) {
      if (Object.getOwnPropertyDescriptor(current, key).get == null) {
        acc[key] = current[key];
      }
      return acc;
    }, {});
    Object.keys(next).forEach(function (key) {
      if (dist_isPlainObject(next[key])) {
        next[key] = recursiveClone(next[key]);
      }
    });
    return next;
  }
  return recursiveClone(source);
}
function isPromise(x) {
  return x != null && typeof x === 'object' && typeof x.then === 'function';
}
function get(path, target) {
  return path.reduce(function (acc, cur) {
    return dist_isPlainObject(acc) ? acc[cur] : undefined;
  }, target);
}
function newify(currentPath, currentState, finalValue) {
  if (currentPath.length === 0) {
    return finalValue;
  }
  var newState = (0,objectSpread2/* default */.Z)({}, currentState);
  var key = currentPath[0];
  if (currentPath.length === 1) {
    newState[key] = finalValue;
  } else {
    newState[key] = newify(currentPath.slice(1), newState[key], finalValue);
  }
  return newState;
}
function set(path, target, value) {
  if (path.length === 0) {
    if (typeof value === 'object') {
      Object.keys(target).forEach(function (key) {
        delete target[key];
      });
      Object.keys(value).forEach(function (key) {
        target[key] = value[key];
      });
    }
    return;
  }
  path.reduce(function (acc, cur, idx) {
    if (idx + 1 === path.length) {
      acc[cur] = value;
    } else {
      acc[cur] = acc[cur] || {};
    }
    return acc[cur];
  }, target);
}
function createSimpleProduce(disableImmer) {
  if (disableImmer === void 0) {
    disableImmer = false;
  }
  return function simpleProduce(path, state, fn, config) {
    if (config && 'immer' in config ? (config == null ? void 0 : config.immer) === false : disableImmer) {
      var _current = get(path, state);
      var next = fn(_current);
      if (_current !== next) {
        return newify(path, state, next);
      }
      return state;
    }
    if (!easyPeasyImmer) {
      easyPeasyImmer = new un({
        // We need to ensure that we disable proxies if they aren't available
        // on the environment. Users need to ensure that they use the enableES5
        // feature of immer.
        useProxies: typeof Proxy !== 'undefined' && typeof Proxy.revocable !== 'undefined' && typeof Reflect !== 'undefined',
        // Autofreezing breaks easy-peasy, we need a mixed version of immutability
        // and mutability in order to apply updates to our computed properties
        autoFreeze: false
      });
    }
    if (path.length === 0) {
      var _draft = easyPeasyImmer.createDraft(state);
      var _result = fn(_draft);
      if (_result) {
        return r(_result) ? easyPeasyImmer.finishDraft(_result) : _result;
      }
      return easyPeasyImmer.finishDraft(_draft);
    }
    var parentPath = path.slice(0, path.length - 1);
    var draft = easyPeasyImmer.createDraft(state);
    var parent = get(parentPath, state);
    var current = get(path, draft);
    var result = fn(current);
    if (result) {
      parent[path[path.length - 1]] = result;
    }
    return easyPeasyImmer.finishDraft(draft);
  };
}
var pReduce = function pReduce(iterable, reducer, initialValue) {
  return new Promise(function (resolve, reject) {
    var iterator = iterable[Symbol.iterator]();
    var index = 0;
    var next = function next(total) {
      var element = iterator.next();
      if (element.done) {
        resolve(total);
        return;
      }
      Promise.all([total, element.value]).then(function (value) {
        return (
          // eslint-disable-next-line no-plusplus
          next(reducer(value[0], value[1], index++))
        );
      }).catch(function (err) {
        return reject(err);
      });
    };
    next(initialValue);
  });
};
var pSeries = function pSeries(tasks) {
  var results = [];
  return pReduce(tasks, function (_, task) {
    return task().then(function (value) {
      results.push(value);
    });
  }).then(function () {
    return results;
  });
};
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i += 1) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }
  return true;
}
function useMemoOne(
// getResult changes on every call,
getResult,
// the inputs array changes on every call
inputs) {
  // using useState to generate initial value as it is lazy
  var initial = React.useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = React.useRef(initial);

  // persist any uncommitted changes after they have been committed

  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));

  // create a new cache if required
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };

  // commit the cache
  React.useEffect(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
var logEventListenerError = function logEventListenerError(type, err) {
  // eslint-disable-next-line no-console
  console.log("Error in " + type);
  // eslint-disable-next-line no-console
  console.log(err);
};
var handleEventDispatchErrors = function handleEventDispatchErrors(type, dispatcher) {
  return function () {
    try {
      var result = dispatcher.apply(void 0, arguments);
      if (isPromise(result)) {
        result.catch(function (err) {
          logEventListenerError(type, err);
        });
      }
    } catch (err) {
      logEventListenerError(type, err);
    }
  };
};

function createReducer(disableImmer, _aRD, _cR, _cP) {
  var simpleProduce = createSimpleProduce(disableImmer);
  var runActionReducerAtPath = function runActionReducerAtPath(state, action, actionReducer, path, config) {
    return simpleProduce(path, state, function (draft) {
      return actionReducer(draft, action.payload);
    }, config);
  };
  var reducerForActions = function reducerForActions(state, action) {
    var actionReducer = _aRD[action.type];
    if (actionReducer) {
      return runActionReducerAtPath(state, action, actionReducer, actionReducer.def.meta.parent, actionReducer.def.config);
    }
    return state;
  };
  var reducerForCustomReducers = function reducerForCustomReducers(state, action) {
    return _cR.reduce(function (acc, _ref) {
      var parentPath = _ref.parentPath,
        key = _ref.key,
        reducer = _ref.reducer,
        config = _ref.config;
      return simpleProduce(parentPath, acc, function (draft) {
        draft[key] = reducer(r(draft[key]) ? e(draft[key]) : draft[key], action);
        return draft;
      }, config);
    }, state);
  };
  var rootReducer = function rootReducer(state, action) {
    var stateAfterActions = reducerForActions(state, action);
    var next = _cR.length > 0 ? reducerForCustomReducers(stateAfterActions, action) : stateAfterActions;
    if (state !== next) {
      _cP.forEach(function (_ref2) {
        var parentPath = _ref2.parentPath,
          bindComputedProperty = _ref2.bindComputedProperty;
        var parentState = get(parentPath, next);
        if (parentState != null) bindComputedProperty(parentState, next);
      });
    }
    return next;
  };
  return rootReducer;
}

var migrate = function migrate(data, migrations) {
  var _data$_migrationVersi;
  sn(false);
  var version = (_data$_migrationVersi = data._migrationVersion) != null ? _data$_migrationVersi : 0;
  var toVersion = migrations.migrationVersion;
  if (typeof version !== "number" || typeof toVersion !== 'number') {
    throw new Error('No migration version found');
  }
  while (version < toVersion) {
    var nextVersion = version + 1;
    var migrator = migrations[nextVersion];
    if (!migrator) {
      throw new Error("No migrator found for `migrationVersion` " + nextVersion);
    }
    data = fn(data, migrator);
    data._migrationVersion = nextVersion;
    version = data._migrationVersion;
  }
  sn(true);
  return data;
};

var noopStorage = {
  getItem: function getItem() {
    return undefined;
  },
  setItem: function setItem() {
    return undefined;
  },
  removeItem: function removeItem() {
    return undefined;
  }
};
var getBrowserStorage = function getBrowserStorage(storageName) {
  var storageCache;
  return function () {
    if (!storageCache) {
      try {
        if (typeof window !== 'undefined' && typeof window[storageName] !== 'undefined') {
          storageCache = window[storageName];
        }
      } catch (_) {
        // swallow the failure
      }
      if (!storageCache) {
        storageCache = noopStorage;
      }
    }
    return storageCache;
  };
};
var localStorage = getBrowserStorage('localStorage');
var sessionStorage = getBrowserStorage('sessionStorage');
function createStorageWrapper(storage, transformers, migrations) {
  if (transformers === void 0) {
    transformers = [];
  }
  if (migrations === void 0) {
    migrations = {};
  }
  if (storage == null) {
    storage = sessionStorage();
  }
  if (typeof storage === 'string') {
    if (storage === 'localStorage') {
      storage = localStorage();
    } else if (storage === 'sessionStorage') {
      storage = sessionStorage();
    } else {
      if (false) {}
      storage = noopStorage;
    }
  }
  var outTransformers = [].concat(transformers).reverse();
  var serialize = function serialize(data) {
    if (transformers.length > 0 && data != null && typeof data === 'object') {
      Object.keys(data).forEach(function (key) {
        data[key] = transformers.reduce(function (acc, cur) {
          return cur.in(acc, key, data);
        }, data[key]);
      });
    }
    return storage === localStorage() || storage === sessionStorage() ? JSON.stringify({
      data: data
    }) : data;
  };
  var deserialize = function deserialize(data) {
    var storageData = storage === localStorage() || storage === sessionStorage() ? JSON.parse(data).data : data;
    var hasMigrations = Object.keys(migrations).length > 0;
    var result = hasMigrations ? migrate(storageData, migrations) : storageData;
    if (outTransformers.length > 0 && result != null && typeof result === 'object') {
      Object.keys(result).forEach(function (key) {
        result[key] = outTransformers.reduce(function (acc, cur) {
          return cur.out(acc, key, result);
        }, result[key]);
      });
    }
    return result;
  };
  var isAsync = isPromise(storage.getItem('_'));
  return {
    getItem: function getItem(key) {
      if (isAsync) {
        return storage.getItem(key).then(function (wrapped) {
          return wrapped != null ? deserialize(wrapped) : undefined;
        });
      }
      var wrapped = storage.getItem(key);
      return wrapped != null ? deserialize(wrapped) : undefined;
    },
    setItem: function setItem(key, data) {
      return storage.setItem(key, serialize(data));
    },
    removeItem: function removeItem(key) {
      return storage.removeItem(key);
    }
  };
}
function extractPersistConfig(path, persistdef) {
  if (persistdef === void 0) {
    persistdef = {};
  }
  return {
    path: path,
    config: {
      allow: persistdef.allow || [],
      deny: persistdef.deny || [],
      mergeStrategy: persistdef.mergeStrategy || 'mergeDeep',
      storage: createStorageWrapper(persistdef.storage, persistdef.transformers, persistdef.migrations)
    }
  };
}
function resolvePersistTargets(target, allow, deny) {
  var targets = Object.keys(target);
  if (allow.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (allow.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return [].concat(acc, [cur]);
      }
      return acc;
    }, []);
  }
  if (deny.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (deny.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return acc;
      }
      return [].concat(acc, [cur]);
    }, []);
  }
  return targets;
}
function createPersistenceClearer(persistKey, _r) {
  return function () {
    if (_r._i._persistenceConfig.length === 0) {
      return Promise.resolve();
    }
    return pSeries(_r._i._persistenceConfig.map(function (_ref) {
      var path = _ref.path,
        config = _ref.config;
      return function () {
        return Promise.resolve(config.storage.removeItem(persistKey(path)));
      };
    }));
  };
}
function createPersistor(persistKey, _r) {
  var persistPromise = Promise.resolve();
  var isPersisting = false;
  var nextPersistOperation;
  var timingMethod = typeof window === 'undefined' ? function (fn) {
    return fn();
  } : window.requestIdleCallback != null ?
  // We need to wrap requestIdleCallback, because it doesn't work without
  // a second parameter on iOS with ReactNative
  function (fn) {
    return window.requestIdleCallback(fn, {
      timeout: 0
    });
  } : window.requestAnimationFrame;
  var persist = function persist(nextState) {
    if (_r._i._persistenceConfig.length === 0) {
      return;
    }
    var operation = function operation() {
      isPersisting = true;
      persistPromise = new Promise(function (resolve) {
        timingMethod(function () {
          pSeries(_r._i._persistenceConfig.map(function (_ref2) {
            var path = _ref2.path,
              config = _ref2.config;
            return function () {
              var storage = config.storage,
                allow = config.allow,
                deny = config.deny;
              var persistRootState = clone(get(path, nextState));
              var persistTargets = resolvePersistTargets(persistRootState, allow, deny);
              var stateToPersist = {};
              persistTargets.map(function (key) {
                var targetPath = [].concat(path, [key]);
                var rawValue = get(targetPath, nextState);
                var value = dist_isPlainObject(rawValue) ? clone(rawValue) : rawValue;
                stateToPersist[key] = value;
              });
              return Promise.resolve(storage.setItem(persistKey(path), stateToPersist));
            };
          })).finally(function () {
            isPersisting = false;
            if (nextPersistOperation) {
              var next = nextPersistOperation;
              nextPersistOperation = null;
              next();
            } else {
              resolve();
            }
          });
        });
      });
    };
    if (isPersisting) {
      nextPersistOperation = operation;
    } else {
      operation();
    }
  };
  return {
    persist: persist,
    clear: createPersistenceClearer(persistKey, _r),
    flush: function flush() {
      if (nextPersistOperation) {
        nextPersistOperation();
      }
      return persistPromise;
    }
  };
}
function createPersistMiddleware(persistor, _r) {
  return function (_ref3) {
    var getState = _ref3.getState;
    return function (next) {
      return function (action) {
        var state = next(action);
        if (action && action.type !== '@action.ePRS' && _r._i._persistenceConfig.length > 0) {
          persistor.persist(getState());
        }
        return state;
      };
    };
  };
}
function rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, root) {
  if (_r._i._persistenceConfig.length === 0) {
    return Promise.resolve();
  }
  var state = clone(_r._i._dS);
  var rehydrating = false;
  return pSeries(_r._i._persistenceConfig.map(function (persistInstance) {
    return function () {
      var path = persistInstance.path,
        config = persistInstance.config;
      var mergeStrategy = config.mergeStrategy,
        storage = config.storage;
      if (root && (path.length < 1 || path[0] !== root)) {
        return Promise.resolve();
      }
      var hasDataModelChanged = function hasDataModelChanged(dataModel, rehydratingModelData) {
        return dataModel != null && rehydratingModelData != null && (typeof dataModel !== typeof rehydratingModelData || Array.isArray(dataModel) && !Array.isArray(rehydratingModelData));
      };
      var applyRehydrationStrategy = function applyRehydrationStrategy(persistedState) {
        if (mergeStrategy === 'overwrite') {
          set(path, state, persistedState);
        } else if (mergeStrategy === 'mergeShallow') {
          var targetState = get(path, state);
          Object.keys(persistedState).forEach(function (key) {
            if (hasDataModelChanged(targetState[key], persistedState[key])) ; else {
              targetState[key] = persistedState[key];
            }
          });
        } else if (mergeStrategy === 'mergeDeep') {
          var _targetState = get(path, state);
          var setAt = function setAt(currentTargetState, currentPersistedState) {
            Object.keys(currentPersistedState).forEach(function (key) {
              if (hasDataModelChanged(currentTargetState[key], currentPersistedState[key])) ; else if (dist_isPlainObject(currentPersistedState[key])) {
                currentTargetState[key] = currentTargetState[key] || {};
                setAt(currentTargetState[key], currentPersistedState[key]);
              } else {
                currentTargetState[key] = currentPersistedState[key];
              }
            });
          };
          setAt(_targetState, persistedState);
        }
      };
      var rehydate = function rehydate(persistedState) {
        if (persistedState != null) {
          applyRehydrationStrategy(persistedState);
          rehydrating = true;
        }
      };
      var getItemResult = storage.getItem(persistKey(path));
      if (isPromise(getItemResult)) {
        return getItemResult.then(rehydate);
      }
      return Promise.resolve(rehydate(getItemResult));
    };
  })).then(function () {
    if (rehydrating) {
      replaceState(state);
    }
  });
}

function createActionCreator(def, _r) {
  function actionCreator(payload) {
    var action = {
      type: def.meta.type,
      payload: payload,
      config: def.config
    };
    if (def[actionOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }
    return _r.dispatch(action);
  }

  // We bind the types to the creator for easy reference by consumers
  actionCreator.type = def.meta.type;
  return actionCreator;
}

function createThunkHandler(def, _r, injections, _aC) {
  return function (payload, fail) {
    var helpers = {
      dispatch: _r.dispatch,
      fail: fail,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };
    if (def[thunkOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }
    return def.fn(get(def.meta.parent, _aC), payload, helpers);
  };
}
function createThunkActionsCreator(def, _r) {
  var actionCreator = function actionCreator(payload) {
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        payload: payload
      });
    });
    var dispatchFail = handleEventDispatchErrors(def.meta.failType, function (err) {
      return _r.dispatch({
        type: def.meta.failType,
        payload: payload,
        error: err
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function (result) {
      return _r.dispatch({
        type: def.meta.successType,
        payload: payload,
        result: result
      });
    });
    dispatchStart();
    var failure = null;
    var fail = function fail(_failure) {
      failure = _failure || new Error();
    };
    var result = _r.dispatch(function () {
      return def.thunkHandler(payload, fail);
    });
    if (isPromise(result)) {
      return result.then(function (resolved) {
        if (failure) {
          dispatchFail(failure);
        } else {
          dispatchSuccess(resolved);
        }
        return resolved;
      });
    }
    if (failure) {
      dispatchFail(failure);
    } else {
      dispatchSuccess(result);
    }
    return result;
  };
  actionCreator.type = def.meta.type;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  actionCreator.startType = def.meta.startType;
  return actionCreator;
}

function createListenerMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        var result = next(action);
        if (action && _r._i._lAM[action.type] && _r._i._lAM[action.type].length > 0) {
          var sourceAction = _r._i._aCD[action.type];
          _r._i._lAM[action.type].forEach(function (actionCreator) {
            actionCreator({
              type: sourceAction ? sourceAction.def.meta.type : action.type,
              payload: action.payload,
              error: action.error,
              result: action.result
            });
          });
        }
        return result;
      };
    };
  };
}
function bindListenerdefs(listenerdefs, _aC, _aCD, _lAM) {
  listenerdefs.forEach(function (def) {
    var targets = def.targetResolver(get(def.meta.parent, _aC), _aC);
    var targetTypes = (Array.isArray(targets) ? targets : [targets]).reduce(function (acc, target) {
      if (typeof target === 'function' && target.def.meta.type && _aCD[target.def.meta.type]) {
        if (target.def.meta.successType) {
          acc.push(target.def.meta.successType);
        } else {
          acc.push(target.def.meta.type);
        }
      } else if (typeof target === 'string') {
        acc.push(target);
      }
      return acc;
    }, []);
    def.meta.resolvedTargets = targetTypes;
    targetTypes.forEach(function (targetType) {
      var listenerReg = _lAM[targetType] || [];
      listenerReg.push(_aCD[def.meta.type]);
      _lAM[targetType] = listenerReg;
    });
  });
}

function createComputedPropertyBinder(key, def, _r) {
  var hasRunOnce = false;
  var prevInputs = [];
  var prevValue;
  var prevStoreState;
  var performingEqualityCheck = false;
  var areEqual = function areEqual(a, b) {
    performingEqualityCheck = true;
    var result = es6_default()(a, b);
    performingEqualityCheck = false;
    return result;
  };
  return function createComputedProperty(parentState, storeState) {
    Object.defineProperty(parentState, key, {
      configurable: true,
      enumerable: true,
      get: function get() {
        if (performingEqualityCheck) {
          return prevValue;
        }
        var inputs = def.stateResolvers.map(function (resolver) {
          return resolver(parentState, storeState);
        });
        if (hasRunOnce && (storeState === prevStoreState && areInputsEqual(inputs, prevInputs) ||
        // We don't want computed properties resolved every time an action
        // is handled by the reducer. They need to remain lazy, only being
        // computed when used by a component or getState call;
        _r._i._cS.isInReducer &&
        // This is to account for strange errors that may occur via immer;
        new Error().stack.match(/shallowCopy/gi) !== null)) {
          return prevValue;
        }
        var newValue = def.fn.apply(def, inputs);
        if (!areEqual(newValue, prevValue)) {
          prevValue = newValue;
        }
        prevInputs = inputs;
        prevStoreState = storeState;
        hasRunOnce = true;
        return prevValue;
      }
    });
  };
}
function createComputedPropertiesMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        _r._i._cS.isInReducer = true;
        var result = next(action);
        _r._i._cS.isInReducer = false;
        return result;
      };
    };
  };
}

function createEffectsMiddleware(_r) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (_r._i._e.length === 0) {
          return next(action);
        }
        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();
        if (prevState !== nextState) {
          _r._i._e.forEach(function (def) {
            var prevLocal = get(def.meta.parent, prevState);
            var nextLocal = get(def.meta.parent, nextState);
            var prevDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(prevLocal, prevState);
            });
            var nextDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(nextLocal, nextState);
            });
            var hasChanged = prevDependencies.some(function (dependency, idx) {
              return dependency !== nextDependencies[idx];
            });
            if (hasChanged) {
              def.actionCreator(prevDependencies, nextDependencies, action);
            }
          });
        }
        return result;
      };
    };
  };
}
var logEffectError = function logEffectError(err) {
  // As users can't get a handle on effects we need to report the error
  // eslint-disable-next-line no-console
  console.error(err);
};
function createEffectHandler(def, _r, injections, _aC) {
  var dispose;
  return function (change) {
    var helpers = {
      dispatch: _r.dispatch,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };
    if (dispose !== undefined) {
      var disposeResult = dispose();
      dispose = undefined;
      if (isPromise(disposeResult)) {
        disposeResult.catch(logEffectError);
      }
    }
    var actions = get(def.meta.parent, _aC);
    var effectResult = def.fn(actions, change, helpers);
    if (isPromise(effectResult)) {
      return effectResult.then(function (resolved) {
        if (typeof resolved === 'function') {
          if (false) {}
        }
      });
    }
    if (typeof effectResult === 'function') {
      dispose = effectResult;
    }
    return undefined;
  };
}
function createEffectActionsCreator(def, _r, effectHandler) {
  var actionCreator = function actionCreator(previousDependencies, nextDependencies, action) {
    var change = {
      prev: previousDependencies,
      current: nextDependencies,
      action: action
    };
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        change: change
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function () {
      return _r.dispatch({
        type: def.meta.successType,
        change: change
      });
    });
    dispatchStart();
    try {
      var result = _r.dispatch(function () {
        return effectHandler(change);
      });
      if (isPromise(result)) {
        return result.then(function (resolved) {
          dispatchSuccess(resolved);
          return resolved;
        }, logEffectError);
      }
      dispatchSuccess(result);
      return result;
    } catch (err) {
      logEffectError(err);
    }
    return undefined;
  };
  actionCreator.type = def.meta.type;
  actionCreator.startType = def.meta.startType;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  return actionCreator;
}

function extractDataFromModel(model, initialState, injections, _r) {
  var _dS = initialState;
  var _aCD = {};
  var _aC = {};
  var _aRD = {};
  var _cP = [];
  var _cR = [];
  var _e = [];
  var _lAC = {};
  var _lAM = {};
  var listenerdefs = [];
  var _persistenceConfig = [];
  var _cS = {
    isInReducer: false
  };
  var recursiveExtractFromModel = function recursiveExtractFromModel(current, parentPath) {
    return Object.keys(current).forEach(function (key) {
      var value = current[key];
      var path = [].concat(parentPath, [key]);
      var meta = {
        parent: parentPath,
        path: path,
        key: key
      };
      var handleValueAsState = function handleValueAsState() {
        var initialParentRef = get(parentPath, initialState);
        if (initialParentRef && key in initialParentRef) {
          set(path, _dS, initialParentRef[key]);
        } else {
          set(path, _dS, value);
        }
      };
      if (key === persistSymbol) {
        _persistenceConfig.push(extractPersistConfig(parentPath, value));
        return;
      }
      if (value != null && typeof value === 'object') {
        if (value[actionSymbol] || value[actionOnSymbol]) {
          var def = (0,objectSpread2/* default */.Z)({}, value);

          // Determine the category of the action
          var category = def[actionSymbol] ? '@action' : '@actionOn';

          // Establish the meta data describing the action
          def.meta = {
            actionName: meta.key,
            category: category,
            type: category + "." + meta.path.join('.'),
            parent: meta.parent,
            path: meta.path
          };

          // Create the "action creator" function
          def.actionCreator = createActionCreator(def, _r);

          // Create a bidirectional relationship of the def/actionCreator
          def.actionCreator.def = def;

          // Create a bidirectional relationship of the def/reducer
          def.fn.def = def;

          // Add the action creator to lookup map
          _aCD[def.meta.type] = def.actionCreator;

          // Add the reducer to lookup map
          _aRD[def.meta.type] = def.fn;

          // We don't want to expose the internal action to consumers
          if (meta.key !== 'ePRS') {
            // Set the action creator in the "actions" object tree for
            // either the listeners object tree, or the standard actions/thunks
            // object tree
            if (def[actionOnSymbol]) {
              listenerdefs.push(def);
              set(path, _lAC, def.actionCreator);
            } else {
              set(path, _aC, def.actionCreator);
            }
          }
        } else if (value[thunkSymbol] || value[thunkOnSymbol]) {
          var _def = (0,objectSpread2/* default */.Z)({}, value);

          // Determine the category of the thunk
          var _category = _def[thunkSymbol] ? '@thunk' : '@thunkOn';

          // Establish the meta data describing the thunk
          var type = _category + "." + meta.path.join('.');
          _def.meta = {
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            type: type,
            startType: type + "(start)",
            successType: type + "(success)",
            failType: type + "(fail)"
          };

          // Create the function that will handle, i.e. be executed, when
          // the thunk action is created/dispatched
          _def.thunkHandler = createThunkHandler(_def, _r, injections, _aC);

          // Create the "action creator" function
          _def.actionCreator = createThunkActionsCreator(_def, _r);

          // Create a bidirectional relationship of the def/actionCreator
          _def.actionCreator.def = _def;

          // Register the action creator within the lookup map
          _aCD[_def.meta.type] = _def.actionCreator;

          // Set the action creator in the "actions" object tree for
          // either the listeners object tree, or the standard actions/thunks
          // object tree
          if (_def[thunkOnSymbol]) {
            listenerdefs.push(_def);
            set(path, _lAC, _def.actionCreator);
          } else {
            set(path, _aC, _def.actionCreator);
          }
        } else if (value[computedSymbol]) {
          var parent = get(parentPath, _dS);
          var bindComputedProperty = createComputedPropertyBinder(key, value, _r);
          bindComputedProperty(parent, _dS);
          _cP.push({
            key: key,
            parentPath: parentPath,
            bindComputedProperty: bindComputedProperty
          });
        } else if (value[reducerSymbol]) {
          _cR.push({
            key: key,
            parentPath: parentPath,
            reducer: value.fn,
            config: value.config
          });
        } else if (value[effectOnSymbol]) {
          var _def2 = (0,objectSpread2/* default */.Z)({}, value);

          // Establish the meta data describing the effect
          var _type = "@effectOn." + meta.path.join('.');
          _def2.meta = {
            type: _type,
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            startType: _type + "(start)",
            successType: _type + "(success)",
            failType: _type + "(fail)"
          };
          var effectHandler = createEffectHandler(_def2, _r, injections, _aC);
          var actionCreator = createEffectActionsCreator(_def2, _r, effectHandler);
          _def2.actionCreator = actionCreator;
          _e.push(_def2);
        } else if (dist_isPlainObject(value)) {
          var existing = get(path, _dS);
          if (existing == null) {
            set(path, _dS, {});
          }
          recursiveExtractFromModel(value, path);
        } else {
          handleValueAsState();
        }
      } else {
        handleValueAsState();
      }
    });
  };
  _persistenceConfig = _persistenceConfig.sort(function (a, b) {
    var aPath = a.path.join('.');
    var bPath = b.path.join('.');
    if (aPath < bPath) {
      return -1;
    }
    if (aPath > bPath) {
      return 1;
    }
    return 0;
  });
  recursiveExtractFromModel(model, []);
  bindListenerdefs(listenerdefs, _aC, _aCD, _lAM);
  return {
    _aCD: _aCD,
    _aC: _aC,
    _aRD: _aRD,
    _cP: _cP,
    _cR: _cR,
    _cS: _cS,
    _dS: _dS,
    _e: _e,
    _lAC: _lAC,
    _lAM: _lAM,
    _persistenceConfig: _persistenceConfig
  };
}

function dist_createStore(model, options) {
  if (options === void 0) {
    options = {};
  }
  var modelClone = clone(model);
  var _options = options,
    compose$1 = _options.compose,
    _options$devTools = _options.devTools,
    devTools = _options$devTools === void 0 ? "production" !== 'production' : _options$devTools,
    _options$disableImmer = _options.disableImmer,
    disableImmer = _options$disableImmer === void 0 ? false : _options$disableImmer,
    _options$enhancers = _options.enhancers,
    enhancers = _options$enhancers === void 0 ? [] : _options$enhancers,
    _options$initialState = _options.initialState,
    initialState = _options$initialState === void 0 ? undefined : _options$initialState,
    _options$injections = _options.injections,
    injections = _options$injections === void 0 ? {} : _options$injections,
    _options$middleware = _options.middleware,
    middleware = _options$middleware === void 0 ? [] : _options$middleware,
    _options$mockActions = _options.mockActions,
    mockActions = _options$mockActions === void 0 ? false : _options$mockActions,
    _options$name = _options.name,
    storeName = _options$name === void 0 ? "EasyPeasyStore" : _options$name,
    _options$version = _options.version,
    version = _options$version === void 0 ? 0 : _options$version,
    _options$reducerEnhan = _options.reducerEnhancer,
    reducerEnhancer = _options$reducerEnhan === void 0 ? function (rootReducer) {
      return rootReducer;
    } : _options$reducerEnhan;
  var bindReplaceState = function bindReplaceState(modelDef) {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, modelDef), {}, {
      ePRS: action(function (_, payload) {
        return payload;
      })
    });
  };
  var _r = {};
  var modeldef = bindReplaceState(modelClone);
  var mockedActions = [];
  var persistKey = function persistKey(targetPath) {
    return "[" + storeName + "][" + version + "]" + (targetPath.length > 0 ? "[" + targetPath.join('.') + "]" : '');
  };
  var persistor = createPersistor(persistKey, _r);
  var persistMiddleware = createPersistMiddleware(persistor, _r);
  var replaceState = function replaceState(nextState) {
    return _r._i._aCD['@action.ePRS'](nextState);
  };
  var bindStoreInternals = function bindStoreInternals(state) {
    if (state === void 0) {
      state = {};
    }
    var data = extractDataFromModel(modeldef, state, injections, _r);
    _r._i = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data), {}, {
      reducer: reducerEnhancer(createReducer(disableImmer, data._aRD, data._cR, data._cP))
    });
  };
  var mockActionsMiddleware = function mockActionsMiddleware() {
    return function () {
      return function (action) {
        if (action != null) {
          mockedActions.push(action);
        }
        return undefined;
      };
    };
  };
  var devToolConfig = devTools === true ? {} : devTools;
  var composeEnhancers = compose$1 || (devTools && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__((0,objectSpread2/* default */.Z)({
    name: storeName
  }, devToolConfig)) : compose);
  bindStoreInternals(initialState || {});
  var easyPeasyMiddleware = [createComputedPropertiesMiddleware(_r)].concat(middleware, [es, createListenerMiddleware(_r), createEffectsMiddleware(_r), persistMiddleware]);
  if (mockActions) {
    easyPeasyMiddleware.push(mockActionsMiddleware);
  }
  var store = createStore(_r._i.reducer, _r._i._dS, composeEnhancers.apply(void 0, [applyMiddleware.apply(void 0, easyPeasyMiddleware)].concat(enhancers)));
  store.subscribe(function () {
    _r._i._cS.isInReducer = false;
  });
  _r.dispatch = store.dispatch;
  _r.getState = store.getState;
  var bindActionCreators = function bindActionCreators() {
    Object.keys(store.dispatch).forEach(function (actionsKey) {
      delete store.dispatch[actionsKey];
    });
    Object.keys(_r._i._aC).forEach(function (key) {
      store.dispatch[key] = _r._i._aC[key];
    });
  };
  bindActionCreators();
  var rebindStore = function rebindStore(removeKey) {
    var currentState = store.getState();
    if (removeKey) {
      delete currentState[removeKey];
    }
    bindStoreInternals(currentState);
    store.replaceReducer(_r._i.reducer);
    replaceState(_r._i._dS);
    bindActionCreators();
  };
  var _resolveRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r);
  return Object.assign(store, {
    addModel: function addModel(key, modelForKey) {
      if (modeldef[key] && "production" !== 'production') {}
      modeldef[key] = modelForKey;
      rebindStore();
      // There may have been persisted state for a dynamic model. We should try
      // and rehydrate the specifc node
      var addModelRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, key);
      return {
        resolveRehydration: function resolveRehydration() {
          return addModelRehydration;
        }
      };
    },
    clearMockedActions: function clearMockedActions() {
      mockedActions = [];
    },
    getActions: function getActions() {
      return _r._i._aC;
    },
    getListeners: function getListeners() {
      return _r._i._lAC;
    },
    getMockedActions: function getMockedActions() {
      return [].concat(mockedActions);
    },
    persist: {
      clear: persistor.clear,
      flush: persistor.flush,
      resolveRehydration: function resolveRehydration() {
        return _resolveRehydration;
      }
    },
    reconfigure: function reconfigure(newModel) {
      modeldef = bindReplaceState(newModel);
      rebindStore();
    },
    removeModel: function removeModel(key) {
      if (!modeldef[key]) {
        return;
      }
      delete modeldef[key];
      rebindStore(key);
    }
  });
}

function createContextStore(model, config) {
  if (config === void 0) {
    config = {};
  }
  // We create a mutable injections reference to allow updating it
  var _config = config,
    _config$injections = _config.injections,
    mutableInjections = _config$injections === void 0 ? {} : _config$injections;
  var StoreContext = createContext();
  function Provider(_ref) {
    var children = _ref.children,
      runtimeModel = _ref.runtimeModel,
      injections = _ref.injections;
    // If the user provided injections we need to ensure our mutable ref
    // is up to date. We could consider doing a shallow compare here?
    if (injections != null) {
      var nextInjections = typeof injections === 'function' ? injections(mutableInjections) : injections;
      var nextKeys = Object.keys(nextInjections);
      var removeKeys = Object.keys(mutableInjections).filter(function (k) {
        return !nextKeys.includes(k);
      });
      removeKeys.forEach(function (k) {
        delete mutableInjections[k];
      });
      Object.assign(mutableInjections, nextInjections);
    }
    var store = useMemoOne(function () {
      return dist_createStore(typeof model === 'function' ? model(runtimeModel) : model, _objectSpread(_objectSpread({}, config), {}, {
        originalInjections: mutableInjections
      }));
    }, []);
    return /*#__PURE__*/React.createElement(StoreContext.Provider, {
      value: store
    }, children);
  }
  function useStore() {
    return useContext(StoreContext);
  }
  return {
    Provider: Provider,
    useStore: useStore,
    useStoreState: createStoreStateHook(StoreContext),
    useStoreActions: createStoreActionsHook(StoreContext),
    useStoreDispatch: createStoreDispatchHook(StoreContext),
    useStoreRehydrated: createStoreRehydratedHook(StoreContext)
  };
}

/**
 * This file has been copied from redux-persist.
 * The intention being to support as much of the redux-persist API as possible.
 */

function createTransform(inbound, outbound, config) {
  if (config === void 0) {
    config = {};
  }
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;
  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }
  return {
    in: function _in(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(data, key, fullState) : data;
    },
    out: function out(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(data, key, fullState) : data;
    }
  };
}

/* eslint-disable react/prop-types */
function StoreProvider(_ref) {
  var children = _ref.children,
    store = _ref.store;
  return /*#__PURE__*/react.createElement(StoreContext.Provider, {
    value: store
  }, children);
}

function useLocalStore(modelCreator, dependencies, configCreator) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  if (configCreator === void 0) {
    configCreator = null;
  }
  var storeRef = useRef();
  var configRef = useRef();
  var store = useMemoOne(function () {
    var previousState = storeRef.current != null ? storeRef.current.getState() : undefined;
    var config = configCreator != null ? configCreator(previousState, configRef.current) : undefined;
    var _store = dist_createStore(modelCreator(previousState), config);
    configRef.current = config;
    storeRef.current = _store;
    return _store;
  }, dependencies);
  var _useState = useState(function () {
      return store.getState();
    }),
    currentState = _useState[0],
    setCurrentState = _useState[1];
  useEffect(function () {
    setCurrentState(store.getState());
    return store.subscribe(function () {
      var nextState = store.getState();
      if (currentState !== nextState) {
        setCurrentState(nextState);
      }
    });
  }, [store]);
  return [currentState, store.getActions(), store];
}

// React 18 requires the use of the useSyncExternalStore hook for external
initializeUseStoreState(with_selector.useSyncExternalStoreWithSelector);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 98364:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 50968:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(99378);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 99378:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(98364);
} else {}


/***/ }),

/***/ 19509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(50968);
} else {}


/***/ }),

/***/ 24429:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17187:
/***/ ((module) => {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ 62991:
/***/ ((module) => {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 40001:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

const Token = __webpack_require__(83416);
const strtok3 = __webpack_require__(35849);
const {
	stringToBytes,
	tarHeaderChecksumMatches,
	uint32SyncSafeToken
} = __webpack_require__(76188);
const supported = __webpack_require__(49898);

const minimumBytes = 4100; // A fair amount of file-types are detectable within this range

async function fromStream(stream) {
	const tokenizer = await strtok3.fromStream(stream);
	try {
		return await fromTokenizer(tokenizer);
	} finally {
		await tokenizer.close();
	}
}

async function fromBuffer(input) {
	if (!(input instanceof Uint8Array || input instanceof ArrayBuffer || Buffer.isBuffer(input))) {
		throw new TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`Buffer\` or \`ArrayBuffer\`, got \`${typeof input}\``);
	}

	const buffer = input instanceof Buffer ? input : Buffer.from(input);

	if (!(buffer && buffer.length > 1)) {
		return;
	}

	const tokenizer = strtok3.fromBuffer(buffer);
	return fromTokenizer(tokenizer);
}

function _check(buffer, headers, options) {
	options = {
		offset: 0,
		...options
	};

	for (const [index, header] of headers.entries()) {
		// If a bitmask is set
		if (options.mask) {
			// If header doesn't equal `buf` with bits masked off
			if (header !== (options.mask[index] & buffer[index + options.offset])) {
				return false;
			}
		} else if (header !== buffer[index + options.offset]) {
			return false;
		}
	}

	return true;
}

async function fromTokenizer(tokenizer) {
	try {
		return _fromTokenizer(tokenizer);
	} catch (error) {
		if (!(error instanceof strtok3.EndOfStreamError)) {
			throw error;
		}
	}
}

async function _fromTokenizer(tokenizer) {
	let buffer = Buffer.alloc(minimumBytes);
	const bytesRead = 12;
	const check = (header, options) => _check(buffer, header, options);
	const checkString = (header, options) => check(stringToBytes(header), options);

	// Keep reading until EOF if the file size is unknown.
	if (!tokenizer.fileInfo.size) {
		tokenizer.fileInfo.size = Number.MAX_SAFE_INTEGER;
	}

	await tokenizer.peekBuffer(buffer, {length: bytesRead, mayBeLess: true});

	// -- 2-byte signatures --

	if (check([0x42, 0x4D])) {
		return {
			ext: 'bmp',
			mime: 'image/bmp'
		};
	}

	if (check([0x0B, 0x77])) {
		return {
			ext: 'ac3',
			mime: 'audio/vnd.dolby.dd-raw'
		};
	}

	if (check([0x78, 0x01])) {
		return {
			ext: 'dmg',
			mime: 'application/x-apple-diskimage'
		};
	}

	if (check([0x4D, 0x5A])) {
		return {
			ext: 'exe',
			mime: 'application/x-msdownload'
		};
	}

	if (check([0x25, 0x21])) {
		await tokenizer.peekBuffer(buffer, {length: 24, mayBeLess: true});

		if (checkString('PS-Adobe-', {offset: 2}) &&
			checkString(' EPSF-', {offset: 14})) {
			return {
				ext: 'eps',
				mime: 'application/eps'
			};
		}

		return {
			ext: 'ps',
			mime: 'application/postscript'
		};
	}

	if (
		check([0x1F, 0xA0]) ||
		check([0x1F, 0x9D])
	) {
		return {
			ext: 'Z',
			mime: 'application/x-compress'
		};
	}

	// -- 3-byte signatures --

	if (check([0xFF, 0xD8, 0xFF])) {
		return {
			ext: 'jpg',
			mime: 'image/jpeg'
		};
	}

	if (check([0x49, 0x49, 0xBC])) {
		return {
			ext: 'jxr',
			mime: 'image/vnd.ms-photo'
		};
	}

	if (check([0x1F, 0x8B, 0x8])) {
		return {
			ext: 'gz',
			mime: 'application/gzip'
		};
	}

	if (check([0x42, 0x5A, 0x68])) {
		return {
			ext: 'bz2',
			mime: 'application/x-bzip2'
		};
	}

	if (checkString('ID3')) {
		await tokenizer.ignore(6); // Skip ID3 header until the header size
		const id3HeaderLen = await tokenizer.readToken(uint32SyncSafeToken);
		if (tokenizer.position + id3HeaderLen > tokenizer.fileInfo.size) {
			// Guess file type based on ID3 header for backward compatibility
			return {
				ext: 'mp3',
				mime: 'audio/mpeg'
			};
		}

		await tokenizer.ignore(id3HeaderLen);
		return fromTokenizer(tokenizer); // Skip ID3 header, recursion
	}

	// Musepack, SV7
	if (checkString('MP+')) {
		return {
			ext: 'mpc',
			mime: 'audio/x-musepack'
		};
	}

	if (
		(buffer[0] === 0x43 || buffer[0] === 0x46) &&
		check([0x57, 0x53], {offset: 1})
	) {
		return {
			ext: 'swf',
			mime: 'application/x-shockwave-flash'
		};
	}

	// -- 4-byte signatures --

	if (check([0x47, 0x49, 0x46])) {
		return {
			ext: 'gif',
			mime: 'image/gif'
		};
	}

	if (checkString('FLIF')) {
		return {
			ext: 'flif',
			mime: 'image/flif'
		};
	}

	if (checkString('8BPS')) {
		return {
			ext: 'psd',
			mime: 'image/vnd.adobe.photoshop'
		};
	}

	if (checkString('WEBP', {offset: 8})) {
		return {
			ext: 'webp',
			mime: 'image/webp'
		};
	}

	// Musepack, SV8
	if (checkString('MPCK')) {
		return {
			ext: 'mpc',
			mime: 'audio/x-musepack'
		};
	}

	if (checkString('FORM')) {
		return {
			ext: 'aif',
			mime: 'audio/aiff'
		};
	}

	if (checkString('icns', {offset: 0})) {
		return {
			ext: 'icns',
			mime: 'image/icns'
		};
	}

	// Zip-based file formats
	// Need to be before the `zip` check
	if (check([0x50, 0x4B, 0x3, 0x4])) { // Local file header signature
		try {
			while (tokenizer.position + 30 < tokenizer.fileInfo.size) {
				await tokenizer.readBuffer(buffer, {length: 30});

				// https://en.wikipedia.org/wiki/Zip_(file_format)#File_headers
				const zipHeader = {
					compressedSize: buffer.readUInt32LE(18),
					uncompressedSize: buffer.readUInt32LE(22),
					filenameLength: buffer.readUInt16LE(26),
					extraFieldLength: buffer.readUInt16LE(28)
				};

				zipHeader.filename = await tokenizer.readToken(new Token.StringType(zipHeader.filenameLength, 'utf-8'));
				await tokenizer.ignore(zipHeader.extraFieldLength);

				// Assumes signed `.xpi` from addons.mozilla.org
				if (zipHeader.filename === 'META-INF/mozilla.rsa') {
					return {
						ext: 'xpi',
						mime: 'application/x-xpinstall'
					};
				}

				if (zipHeader.filename.endsWith('.rels') || zipHeader.filename.endsWith('.xml')) {
					const type = zipHeader.filename.split('/')[0];
					switch (type) {
						case '_rels':
							break;
						case 'word':
							return {
								ext: 'docx',
								mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
							};
						case 'ppt':
							return {
								ext: 'pptx',
								mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
							};
						case 'xl':
							return {
								ext: 'xlsx',
								mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
							};
						default:
							break;
					}
				}

				if (zipHeader.filename.startsWith('xl/')) {
					return {
						ext: 'xlsx',
						mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					};
				}

				if (zipHeader.filename.startsWith('3D/') && zipHeader.filename.endsWith('.model')) {
					return {
						ext: '3mf',
						mime: 'model/3mf'
					};
				}

				// The docx, xlsx and pptx file types extend the Office Open XML file format:
				// https://en.wikipedia.org/wiki/Office_Open_XML_file_formats
				// We look for:
				// - one entry named '[Content_Types].xml' or '_rels/.rels',
				// - one entry indicating specific type of file.
				// MS Office, OpenOffice and LibreOffice may put the parts in different order, so the check should not rely on it.
				if (zipHeader.filename === 'mimetype' && zipHeader.compressedSize === zipHeader.uncompressedSize) {
					const mimeType = await tokenizer.readToken(new Token.StringType(zipHeader.compressedSize, 'utf-8'));

					switch (mimeType) {
						case 'application/epub+zip':
							return {
								ext: 'epub',
								mime: 'application/epub+zip'
							};
						case 'application/vnd.oasis.opendocument.text':
							return {
								ext: 'odt',
								mime: 'application/vnd.oasis.opendocument.text'
							};
						case 'application/vnd.oasis.opendocument.spreadsheet':
							return {
								ext: 'ods',
								mime: 'application/vnd.oasis.opendocument.spreadsheet'
							};
						case 'application/vnd.oasis.opendocument.presentation':
							return {
								ext: 'odp',
								mime: 'application/vnd.oasis.opendocument.presentation'
							};
						default:
					}
				}

				// Try to find next header manually when current one is corrupted
				if (zipHeader.compressedSize === 0) {
					let nextHeaderIndex = -1;

					while (nextHeaderIndex < 0 && (tokenizer.position < tokenizer.fileInfo.size)) {
						await tokenizer.peekBuffer(buffer, {mayBeLess: true});

						nextHeaderIndex = buffer.indexOf('504B0304', 0, 'hex');
						// Move position to the next header if found, skip the whole buffer otherwise
						await tokenizer.ignore(nextHeaderIndex >= 0 ? nextHeaderIndex : buffer.length);
					}
				} else {
					await tokenizer.ignore(zipHeader.compressedSize);
				}
			}
		} catch (error) {
			if (!(error instanceof strtok3.EndOfStreamError)) {
				throw error;
			}
		}

		return {
			ext: 'zip',
			mime: 'application/zip'
		};
	}

	if (checkString('OggS')) {
		// This is an OGG container
		await tokenizer.ignore(28);
		const type = Buffer.alloc(8);
		await tokenizer.readBuffer(type);

		// Needs to be before `ogg` check
		if (_check(type, [0x4F, 0x70, 0x75, 0x73, 0x48, 0x65, 0x61, 0x64])) {
			return {
				ext: 'opus',
				mime: 'audio/opus'
			};
		}

		// If ' theora' in header.
		if (_check(type, [0x80, 0x74, 0x68, 0x65, 0x6F, 0x72, 0x61])) {
			return {
				ext: 'ogv',
				mime: 'video/ogg'
			};
		}

		// If '\x01video' in header.
		if (_check(type, [0x01, 0x76, 0x69, 0x64, 0x65, 0x6F, 0x00])) {
			return {
				ext: 'ogm',
				mime: 'video/ogg'
			};
		}

		// If ' FLAC' in header  https://xiph.org/flac/faq.html
		if (_check(type, [0x7F, 0x46, 0x4C, 0x41, 0x43])) {
			return {
				ext: 'oga',
				mime: 'audio/ogg'
			};
		}

		// 'Speex  ' in header https://en.wikipedia.org/wiki/Speex
		if (_check(type, [0x53, 0x70, 0x65, 0x65, 0x78, 0x20, 0x20])) {
			return {
				ext: 'spx',
				mime: 'audio/ogg'
			};
		}

		// If '\x01vorbis' in header
		if (_check(type, [0x01, 0x76, 0x6F, 0x72, 0x62, 0x69, 0x73])) {
			return {
				ext: 'ogg',
				mime: 'audio/ogg'
			};
		}

		// Default OGG container https://www.iana.org/assignments/media-types/application/ogg
		return {
			ext: 'ogx',
			mime: 'application/ogg'
		};
	}

	if (
		check([0x50, 0x4B]) &&
		(buffer[2] === 0x3 || buffer[2] === 0x5 || buffer[2] === 0x7) &&
		(buffer[3] === 0x4 || buffer[3] === 0x6 || buffer[3] === 0x8)
	) {
		return {
			ext: 'zip',
			mime: 'application/zip'
		};
	}

	//

	// File Type Box (https://en.wikipedia.org/wiki/ISO_base_media_file_format)
	// It's not required to be first, but it's recommended to be. Almost all ISO base media files start with `ftyp` box.
	// `ftyp` box must contain a brand major identifier, which must consist of ISO 8859-1 printable characters.
	// Here we check for 8859-1 printable characters (for simplicity, it's a mask which also catches one non-printable character).
	if (
		checkString('ftyp', {offset: 4}) &&
		(buffer[8] & 0x60) !== 0x00 // Brand major, first character ASCII?
	) {
		// They all can have MIME `video/mp4` except `application/mp4` special-case which is hard to detect.
		// For some cases, we're specific, everything else falls to `video/mp4` with `mp4` extension.
		const brandMajor = buffer.toString('binary', 8, 12).replace('\0', ' ').trim();
		switch (brandMajor) {
			case 'avif':
				return {ext: 'avif', mime: 'image/avif'};
			case 'mif1':
				return {ext: 'heic', mime: 'image/heif'};
			case 'msf1':
				return {ext: 'heic', mime: 'image/heif-sequence'};
			case 'heic':
			case 'heix':
				return {ext: 'heic', mime: 'image/heic'};
			case 'hevc':
			case 'hevx':
				return {ext: 'heic', mime: 'image/heic-sequence'};
			case 'qt':
				return {ext: 'mov', mime: 'video/quicktime'};
			case 'M4V':
			case 'M4VH':
			case 'M4VP':
				return {ext: 'm4v', mime: 'video/x-m4v'};
			case 'M4P':
				return {ext: 'm4p', mime: 'video/mp4'};
			case 'M4B':
				return {ext: 'm4b', mime: 'audio/mp4'};
			case 'M4A':
				return {ext: 'm4a', mime: 'audio/x-m4a'};
			case 'F4V':
				return {ext: 'f4v', mime: 'video/mp4'};
			case 'F4P':
				return {ext: 'f4p', mime: 'video/mp4'};
			case 'F4A':
				return {ext: 'f4a', mime: 'audio/mp4'};
			case 'F4B':
				return {ext: 'f4b', mime: 'audio/mp4'};
			case 'crx':
				return {ext: 'cr3', mime: 'image/x-canon-cr3'};
			default:
				if (brandMajor.startsWith('3g')) {
					if (brandMajor.startsWith('3g2')) {
						return {ext: '3g2', mime: 'video/3gpp2'};
					}

					return {ext: '3gp', mime: 'video/3gpp'};
				}

				return {ext: 'mp4', mime: 'video/mp4'};
		}
	}

	if (checkString('MThd')) {
		return {
			ext: 'mid',
			mime: 'audio/midi'
		};
	}

	if (
		checkString('wOFF') &&
		(
			check([0x00, 0x01, 0x00, 0x00], {offset: 4}) ||
			checkString('OTTO', {offset: 4})
		)
	) {
		return {
			ext: 'woff',
			mime: 'font/woff'
		};
	}

	if (
		checkString('wOF2') &&
		(
			check([0x00, 0x01, 0x00, 0x00], {offset: 4}) ||
			checkString('OTTO', {offset: 4})
		)
	) {
		return {
			ext: 'woff2',
			mime: 'font/woff2'
		};
	}

	if (check([0xD4, 0xC3, 0xB2, 0xA1]) || check([0xA1, 0xB2, 0xC3, 0xD4])) {
		return {
			ext: 'pcap',
			mime: 'application/vnd.tcpdump.pcap'
		};
	}

	// Sony DSD Stream File (DSF)
	if (checkString('DSD ')) {
		return {
			ext: 'dsf',
			mime: 'audio/x-dsf' // Non-standard
		};
	}

	if (checkString('LZIP')) {
		return {
			ext: 'lz',
			mime: 'application/x-lzip'
		};
	}

	if (checkString('fLaC')) {
		return {
			ext: 'flac',
			mime: 'audio/x-flac'
		};
	}

	if (check([0x42, 0x50, 0x47, 0xFB])) {
		return {
			ext: 'bpg',
			mime: 'image/bpg'
		};
	}

	if (checkString('wvpk')) {
		return {
			ext: 'wv',
			mime: 'audio/wavpack'
		};
	}

	if (checkString('%PDF')) {
		await tokenizer.ignore(1350);
		const maxBufferSize = 10 * 1024 * 1024;
		const buffer = Buffer.alloc(Math.min(maxBufferSize, tokenizer.fileInfo.size));
		await tokenizer.readBuffer(buffer, {mayBeLess: true});

		// Check if this is an Adobe Illustrator file
		if (buffer.includes(Buffer.from('AIPrivateData'))) {
			return {
				ext: 'ai',
				mime: 'application/postscript'
			};
		}

		// Assume this is just a normal PDF
		return {
			ext: 'pdf',
			mime: 'application/pdf'
		};
	}

	if (check([0x00, 0x61, 0x73, 0x6D])) {
		return {
			ext: 'wasm',
			mime: 'application/wasm'
		};
	}

	// TIFF, little-endian type
	if (check([0x49, 0x49, 0x2A, 0x0])) {
		if (checkString('CR', {offset: 8})) {
			return {
				ext: 'cr2',
				mime: 'image/x-canon-cr2'
			};
		}

		if (check([0x1C, 0x00, 0xFE, 0x00], {offset: 8}) || check([0x1F, 0x00, 0x0B, 0x00], {offset: 8})) {
			return {
				ext: 'nef',
				mime: 'image/x-nikon-nef'
			};
		}

		if (
			check([0x08, 0x00, 0x00, 0x00], {offset: 4}) &&
			(check([0x2D, 0x00, 0xFE, 0x00], {offset: 8}) ||
				check([0x27, 0x00, 0xFE, 0x00], {offset: 8}))
		) {
			return {
				ext: 'dng',
				mime: 'image/x-adobe-dng'
			};
		}

		buffer = Buffer.alloc(24);
		await tokenizer.peekBuffer(buffer);
		if (
			(check([0x10, 0xFB, 0x86, 0x01], {offset: 4}) || check([0x08, 0x00, 0x00, 0x00], {offset: 4})) &&
			// This pattern differentiates ARW from other TIFF-ish file types:
			check([0x00, 0xFE, 0x00, 0x04, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x03, 0x01], {offset: 9})
		) {
			return {
				ext: 'arw',
				mime: 'image/x-sony-arw'
			};
		}

		return {
			ext: 'tif',
			mime: 'image/tiff'
		};
	}

	// TIFF, big-endian type
	if (check([0x4D, 0x4D, 0x0, 0x2A])) {
		return {
			ext: 'tif',
			mime: 'image/tiff'
		};
	}

	if (checkString('MAC ')) {
		return {
			ext: 'ape',
			mime: 'audio/ape'
		};
	}

	// https://github.com/threatstack/libmagic/blob/master/magic/Magdir/matroska
	if (check([0x1A, 0x45, 0xDF, 0xA3])) { // Root element: EBML
		async function readField() {
			const msb = await tokenizer.peekNumber(Token.UINT8);
			let mask = 0x80;
			let ic = 0; // 0 = A, 1 = B, 2 = C, 3 = D

			while ((msb & mask) === 0 && mask !== 0) {
				++ic;
				mask >>= 1;
			}

			const id = Buffer.alloc(ic + 1);
			await tokenizer.readBuffer(id);
			return id;
		}

		async function readElement() {
			const id = await readField();
			const lenField = await readField();
			lenField[0] ^= 0x80 >> (lenField.length - 1);
			const nrLen = Math.min(6, lenField.length); // JavaScript can max read 6 bytes integer
			return {
				id: id.readUIntBE(0, id.length),
				len: lenField.readUIntBE(lenField.length - nrLen, nrLen)
			};
		}

		async function readChildren(level, children) {
			while (children > 0) {
				const e = await readElement();
				if (e.id === 0x4282) {
					return tokenizer.readToken(new Token.StringType(e.len, 'utf-8')); // Return DocType
				}

				await tokenizer.ignore(e.len); // ignore payload
				--children;
			}
		}

		const re = await readElement();
		const docType = await readChildren(1, re.len);

		switch (docType) {
			case 'webm':
				return {
					ext: 'webm',
					mime: 'video/webm'
				};

			case 'matroska':
				return {
					ext: 'mkv',
					mime: 'video/x-matroska'
				};

			default:
				return;
		}
	}

	// RIFF file format which might be AVI, WAV, QCP, etc
	if (check([0x52, 0x49, 0x46, 0x46])) {
		if (check([0x41, 0x56, 0x49], {offset: 8})) {
			return {
				ext: 'avi',
				mime: 'video/vnd.avi'
			};
		}

		if (check([0x57, 0x41, 0x56, 0x45], {offset: 8})) {
			return {
				ext: 'wav',
				mime: 'audio/vnd.wave'
			};
		}

		// QLCM, QCP file
		if (check([0x51, 0x4C, 0x43, 0x4D], {offset: 8})) {
			return {
				ext: 'qcp',
				mime: 'audio/qcelp'
			};
		}
	}

	if (checkString('SQLi')) {
		return {
			ext: 'sqlite',
			mime: 'application/x-sqlite3'
		};
	}

	if (check([0x4E, 0x45, 0x53, 0x1A])) {
		return {
			ext: 'nes',
			mime: 'application/x-nintendo-nes-rom'
		};
	}

	if (checkString('Cr24')) {
		return {
			ext: 'crx',
			mime: 'application/x-google-chrome-extension'
		};
	}

	if (
		checkString('MSCF') ||
		checkString('ISc(')
	) {
		return {
			ext: 'cab',
			mime: 'application/vnd.ms-cab-compressed'
		};
	}

	if (check([0xED, 0xAB, 0xEE, 0xDB])) {
		return {
			ext: 'rpm',
			mime: 'application/x-rpm'
		};
	}

	if (check([0xC5, 0xD0, 0xD3, 0xC6])) {
		return {
			ext: 'eps',
			mime: 'application/eps'
		};
	}

	if (check([0x28, 0xB5, 0x2F, 0xFD])) {
		return {
			ext: 'zst',
			mime: 'application/zstd'
		};
	}

	// -- 5-byte signatures --

	if (check([0x4F, 0x54, 0x54, 0x4F, 0x00])) {
		return {
			ext: 'otf',
			mime: 'font/otf'
		};
	}

	if (checkString('#!AMR')) {
		return {
			ext: 'amr',
			mime: 'audio/amr'
		};
	}

	if (checkString('{\\rtf')) {
		return {
			ext: 'rtf',
			mime: 'application/rtf'
		};
	}

	if (check([0x46, 0x4C, 0x56, 0x01])) {
		return {
			ext: 'flv',
			mime: 'video/x-flv'
		};
	}

	if (checkString('IMPM')) {
		return {
			ext: 'it',
			mime: 'audio/x-it'
		};
	}

	if (
		checkString('-lh0-', {offset: 2}) ||
		checkString('-lh1-', {offset: 2}) ||
		checkString('-lh2-', {offset: 2}) ||
		checkString('-lh3-', {offset: 2}) ||
		checkString('-lh4-', {offset: 2}) ||
		checkString('-lh5-', {offset: 2}) ||
		checkString('-lh6-', {offset: 2}) ||
		checkString('-lh7-', {offset: 2}) ||
		checkString('-lzs-', {offset: 2}) ||
		checkString('-lz4-', {offset: 2}) ||
		checkString('-lz5-', {offset: 2}) ||
		checkString('-lhd-', {offset: 2})
	) {
		return {
			ext: 'lzh',
			mime: 'application/x-lzh-compressed'
		};
	}

	// MPEG program stream (PS or MPEG-PS)
	if (check([0x00, 0x00, 0x01, 0xBA])) {
		//  MPEG-PS, MPEG-1 Part 1
		if (check([0x21], {offset: 4, mask: [0xF1]})) {
			return {
				ext: 'mpg', // May also be .ps, .mpeg
				mime: 'video/MP1S'
			};
		}

		// MPEG-PS, MPEG-2 Part 1
		if (check([0x44], {offset: 4, mask: [0xC4]})) {
			return {
				ext: 'mpg', // May also be .mpg, .m2p, .vob or .sub
				mime: 'video/MP2P'
			};
		}
	}

	if (checkString('ITSF')) {
		return {
			ext: 'chm',
			mime: 'application/vnd.ms-htmlhelp'
		};
	}

	// -- 6-byte signatures --

	if (check([0xFD, 0x37, 0x7A, 0x58, 0x5A, 0x00])) {
		return {
			ext: 'xz',
			mime: 'application/x-xz'
		};
	}

	if (checkString('<?xml ')) {
		return {
			ext: 'xml',
			mime: 'application/xml'
		};
	}

	if (check([0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C])) {
		return {
			ext: '7z',
			mime: 'application/x-7z-compressed'
		};
	}

	if (
		check([0x52, 0x61, 0x72, 0x21, 0x1A, 0x7]) &&
		(buffer[6] === 0x0 || buffer[6] === 0x1)
	) {
		return {
			ext: 'rar',
			mime: 'application/x-rar-compressed'
		};
	}

	if (checkString('solid ')) {
		return {
			ext: 'stl',
			mime: 'model/stl'
		};
	}

	// -- 7-byte signatures --

	if (checkString('BLENDER')) {
		return {
			ext: 'blend',
			mime: 'application/x-blender'
		};
	}

	if (checkString('!<arch>')) {
		await tokenizer.ignore(8);
		const str = await tokenizer.readToken(new Token.StringType(13, 'ascii'));
		if (str === 'debian-binary') {
			return {
				ext: 'deb',
				mime: 'application/x-deb'
			};
		}

		return {
			ext: 'ar',
			mime: 'application/x-unix-archive'
		};
	}

	// -- 8-byte signatures --

	if (check([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) {
		// APNG format (https://wiki.mozilla.org/APNG_Specification)
		// 1. Find the first IDAT (image data) chunk (49 44 41 54)
		// 2. Check if there is an "acTL" chunk before the IDAT one (61 63 54 4C)

		// Offset calculated as follows:
		// - 8 bytes: PNG signature
		// - 4 (length) + 4 (chunk type) + 13 (chunk data) + 4 (CRC): IHDR chunk

		await tokenizer.ignore(8); // ignore PNG signature

		async function readChunkHeader() {
			return {
				length: await tokenizer.readToken(Token.INT32_BE),
				type: await tokenizer.readToken(new Token.StringType(4, 'binary'))
			};
		}

		do {
			const chunk = await readChunkHeader();
			if (chunk.length < 0) {
				return; // Invalid chunk length
			}

			switch (chunk.type) {
				case 'IDAT':
					return {
						ext: 'png',
						mime: 'image/png'
					};
				case 'acTL':
					return {
						ext: 'apng',
						mime: 'image/apng'
					};
				default:
					await tokenizer.ignore(chunk.length + 4); // Ignore chunk-data + CRC
			}
		} while (tokenizer.position + 8 < tokenizer.fileInfo.size);

		return {
			ext: 'png',
			mime: 'image/png'
		};
	}

	if (check([0x41, 0x52, 0x52, 0x4F, 0x57, 0x31, 0x00, 0x00])) {
		return {
			ext: 'arrow',
			mime: 'application/x-apache-arrow'
		};
	}

	if (check([0x67, 0x6C, 0x54, 0x46, 0x02, 0x00, 0x00, 0x00])) {
		return {
			ext: 'glb',
			mime: 'model/gltf-binary'
		};
	}

	// `mov` format variants
	if (
		check([0x66, 0x72, 0x65, 0x65], {offset: 4}) || // `free`
		check([0x6D, 0x64, 0x61, 0x74], {offset: 4}) || // `mdat` MJPEG
		check([0x6D, 0x6F, 0x6F, 0x76], {offset: 4}) || // `moov`
		check([0x77, 0x69, 0x64, 0x65], {offset: 4}) // `wide`
	) {
		return {
			ext: 'mov',
			mime: 'video/quicktime'
		};
	}

	// -- 9-byte signatures --

	if (check([0x49, 0x49, 0x52, 0x4F, 0x08, 0x00, 0x00, 0x00, 0x18])) {
		return {
			ext: 'orf',
			mime: 'image/x-olympus-orf'
		};
	}

	if (checkString('gimp xcf ')) {
		return {
			ext: 'xcf',
			mime: 'image/x-xcf'
		};
	}

	// -- 12-byte signatures --

	if (check([0x49, 0x49, 0x55, 0x00, 0x18, 0x00, 0x00, 0x00, 0x88, 0xE7, 0x74, 0xD8])) {
		return {
			ext: 'rw2',
			mime: 'image/x-panasonic-rw2'
		};
	}

	// ASF_Header_Object first 80 bytes
	if (check([0x30, 0x26, 0xB2, 0x75, 0x8E, 0x66, 0xCF, 0x11, 0xA6, 0xD9])) {
		async function readHeader() {
			const guid = Buffer.alloc(16);
			await tokenizer.readBuffer(guid);
			return {
				id: guid,
				size: Number(await tokenizer.readToken(Token.UINT64_LE))
			};
		}

		await tokenizer.ignore(30);
		// Search for header should be in first 1KB of file.
		while (tokenizer.position + 24 < tokenizer.fileInfo.size) {
			const header = await readHeader();
			let payload = header.size - 24;
			if (_check(header.id, [0x91, 0x07, 0xDC, 0xB7, 0xB7, 0xA9, 0xCF, 0x11, 0x8E, 0xE6, 0x00, 0xC0, 0x0C, 0x20, 0x53, 0x65])) {
				// Sync on Stream-Properties-Object (B7DC0791-A9B7-11CF-8EE6-00C00C205365)
				const typeId = Buffer.alloc(16);
				payload -= await tokenizer.readBuffer(typeId);

				if (_check(typeId, [0x40, 0x9E, 0x69, 0xF8, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
					// Found audio:
					return {
						ext: 'asf',
						mime: 'audio/x-ms-asf'
					};
				}

				if (_check(typeId, [0xC0, 0xEF, 0x19, 0xBC, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
					// Found video:
					return {
						ext: 'asf',
						mime: 'video/x-ms-asf'
					};
				}

				break;
			}

			await tokenizer.ignore(payload);
		}

		// Default to ASF generic extension
		return {
			ext: 'asf',
			mime: 'application/vnd.ms-asf'
		};
	}

	if (check([0xAB, 0x4B, 0x54, 0x58, 0x20, 0x31, 0x31, 0xBB, 0x0D, 0x0A, 0x1A, 0x0A])) {
		return {
			ext: 'ktx',
			mime: 'image/ktx'
		};
	}

	if ((check([0x7E, 0x10, 0x04]) || check([0x7E, 0x18, 0x04])) && check([0x30, 0x4D, 0x49, 0x45], {offset: 4})) {
		return {
			ext: 'mie',
			mime: 'application/x-mie'
		};
	}

	if (check([0x27, 0x0A, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], {offset: 2})) {
		return {
			ext: 'shp',
			mime: 'application/x-esri-shape'
		};
	}

	if (check([0x00, 0x00, 0x00, 0x0C, 0x6A, 0x50, 0x20, 0x20, 0x0D, 0x0A, 0x87, 0x0A])) {
		// JPEG-2000 family

		await tokenizer.ignore(20);
		const type = await tokenizer.readToken(new Token.StringType(4, 'ascii'));
		switch (type) {
			case 'jp2 ':
				return {
					ext: 'jp2',
					mime: 'image/jp2'
				};
			case 'jpx ':
				return {
					ext: 'jpx',
					mime: 'image/jpx'
				};
			case 'jpm ':
				return {
					ext: 'jpm',
					mime: 'image/jpm'
				};
			case 'mjp2':
				return {
					ext: 'mj2',
					mime: 'image/mj2'
				};
			default:
				return;
		}
	}

	if (
		check([0xFF, 0x0A]) ||
		check([0x00, 0x00, 0x00, 0x0C, 0x4A, 0x58, 0x4C, 0x20, 0x0D, 0x0A, 0x87, 0x0A])
	) {
		return {
			ext: 'jxl',
			mime: 'image/jxl'
		};
	}

	// -- Unsafe signatures --

	if (
		check([0x0, 0x0, 0x1, 0xBA]) ||
		check([0x0, 0x0, 0x1, 0xB3])
	) {
		return {
			ext: 'mpg',
			mime: 'video/mpeg'
		};
	}

	if (check([0x00, 0x01, 0x00, 0x00, 0x00])) {
		return {
			ext: 'ttf',
			mime: 'font/ttf'
		};
	}

	if (check([0x00, 0x00, 0x01, 0x00])) {
		return {
			ext: 'ico',
			mime: 'image/x-icon'
		};
	}

	if (check([0x00, 0x00, 0x02, 0x00])) {
		return {
			ext: 'cur',
			mime: 'image/x-icon'
		};
	}

	if (check([0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1])) {
		// Detected Microsoft Compound File Binary File (MS-CFB) Format.
		return {
			ext: 'cfb',
			mime: 'application/x-cfb'
		};
	}

	// Increase sample size from 12 to 256.
	await tokenizer.peekBuffer(buffer, {length: Math.min(256, tokenizer.fileInfo.size), mayBeLess: true});

	// -- 15-byte signatures --

	if (checkString('BEGIN:')) {
		if (checkString('VCARD', {offset: 6})) {
			return {
				ext: 'vcf',
				mime: 'text/vcard'
			};
		}

		if (checkString('VCALENDAR', {offset: 6})) {
			return {
				ext: 'ics',
				mime: 'text/calendar'
			};
		}
	}

	// `raf` is here just to keep all the raw image detectors together.
	if (checkString('FUJIFILMCCD-RAW')) {
		return {
			ext: 'raf',
			mime: 'image/x-fujifilm-raf'
		};
	}

	if (checkString('Extended Module:')) {
		return {
			ext: 'xm',
			mime: 'audio/x-xm'
		};
	}

	if (checkString('Creative Voice File')) {
		return {
			ext: 'voc',
			mime: 'audio/x-voc'
		};
	}

	if (check([0x04, 0x00, 0x00, 0x00]) && buffer.length >= 16) { // Rough & quick check Pickle/ASAR
		const jsonSize = buffer.readUInt32LE(12);
		if (jsonSize > 12 && buffer.length >= jsonSize + 16) {
			try {
				const header = buffer.slice(16, jsonSize + 16).toString();
				const json = JSON.parse(header);
				// Check if Pickle is ASAR
				if (json.files) { // Final check, assuring Pickle/ASAR format
					return {
						ext: 'asar',
						mime: 'application/x-asar'
					};
				}
			} catch (_) {
			}
		}
	}

	if (check([0x06, 0x0E, 0x2B, 0x34, 0x02, 0x05, 0x01, 0x01, 0x0D, 0x01, 0x02, 0x01, 0x01, 0x02])) {
		return {
			ext: 'mxf',
			mime: 'application/mxf'
		};
	}

	if (checkString('SCRM', {offset: 44})) {
		return {
			ext: 's3m',
			mime: 'audio/x-s3m'
		};
	}

	if (check([0x47], {offset: 4}) && (check([0x47], {offset: 192}) || check([0x47], {offset: 196}))) {
		return {
			ext: 'mts',
			mime: 'video/mp2t'
		};
	}

	if (check([0x42, 0x4F, 0x4F, 0x4B, 0x4D, 0x4F, 0x42, 0x49], {offset: 60})) {
		return {
			ext: 'mobi',
			mime: 'application/x-mobipocket-ebook'
		};
	}

	if (check([0x44, 0x49, 0x43, 0x4D], {offset: 128})) {
		return {
			ext: 'dcm',
			mime: 'application/dicom'
		};
	}

	if (check([0x4C, 0x00, 0x00, 0x00, 0x01, 0x14, 0x02, 0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x46])) {
		return {
			ext: 'lnk',
			mime: 'application/x.ms.shortcut' // Invented by us
		};
	}

	if (check([0x62, 0x6F, 0x6F, 0x6B, 0x00, 0x00, 0x00, 0x00, 0x6D, 0x61, 0x72, 0x6B, 0x00, 0x00, 0x00, 0x00])) {
		return {
			ext: 'alias',
			mime: 'application/x.apple.alias' // Invented by us
		};
	}

	if (
		check([0x4C, 0x50], {offset: 34}) &&
		(
			check([0x00, 0x00, 0x01], {offset: 8}) ||
			check([0x01, 0x00, 0x02], {offset: 8}) ||
			check([0x02, 0x00, 0x02], {offset: 8})
		)
	) {
		return {
			ext: 'eot',
			mime: 'application/vnd.ms-fontobject'
		};
	}

	if (check([0x06, 0x06, 0xED, 0xF5, 0xD8, 0x1D, 0x46, 0xE5, 0xBD, 0x31, 0xEF, 0xE7, 0xFE, 0x74, 0xB7, 0x1D])) {
		return {
			ext: 'indd',
			mime: 'application/x-indesign'
		};
	}

	// Increase sample size from 256 to 512
	await tokenizer.peekBuffer(buffer, {length: Math.min(512, tokenizer.fileInfo.size), mayBeLess: true});

	// Requires a buffer size of 512 bytes
	if (tarHeaderChecksumMatches(buffer)) {
		return {
			ext: 'tar',
			mime: 'application/x-tar'
		};
	}

	if (check([0xFF, 0xFE, 0xFF, 0x0E, 0x53, 0x00, 0x6B, 0x00, 0x65, 0x00, 0x74, 0x00, 0x63, 0x00, 0x68, 0x00, 0x55, 0x00, 0x70, 0x00, 0x20, 0x00, 0x4D, 0x00, 0x6F, 0x00, 0x64, 0x00, 0x65, 0x00, 0x6C, 0x00])) {
		return {
			ext: 'skp',
			mime: 'application/vnd.sketchup.skp'
		};
	}

	if (checkString('-----BEGIN PGP MESSAGE-----')) {
		return {
			ext: 'pgp',
			mime: 'application/pgp-encrypted'
		};
	}

	// Check MPEG 1 or 2 Layer 3 header, or 'layer 0' for ADTS (MPEG sync-word 0xFFE)
	if (buffer.length >= 2 && check([0xFF, 0xE0], {offset: 0, mask: [0xFF, 0xE0]})) {
		if (check([0x10], {offset: 1, mask: [0x16]})) {
			// Check for (ADTS) MPEG-2
			if (check([0x08], {offset: 1, mask: [0x08]})) {
				return {
					ext: 'aac',
					mime: 'audio/aac'
				};
			}

			// Must be (ADTS) MPEG-4
			return {
				ext: 'aac',
				mime: 'audio/aac'
			};
		}

		// MPEG 1 or 2 Layer 3 header
		// Check for MPEG layer 3
		if (check([0x02], {offset: 1, mask: [0x06]})) {
			return {
				ext: 'mp3',
				mime: 'audio/mpeg'
			};
		}

		// Check for MPEG layer 2
		if (check([0x04], {offset: 1, mask: [0x06]})) {
			return {
				ext: 'mp2',
				mime: 'audio/mpeg'
			};
		}

		// Check for MPEG layer 1
		if (check([0x06], {offset: 1, mask: [0x06]})) {
			return {
				ext: 'mp1',
				mime: 'audio/mpeg'
			};
		}
	}
}

const stream = readableStream => new Promise((resolve, reject) => {
	// Using `eval` to work around issues when bundling with Webpack
	const stream = eval('require')('stream'); // eslint-disable-line no-eval

	readableStream.on('error', reject);
	readableStream.once('readable', async () => {
		// Set up output stream
		const pass = new stream.PassThrough();
		let outputStream;
		if (stream.pipeline) {
			outputStream = stream.pipeline(readableStream, pass, () => {
			});
		} else {
			outputStream = readableStream.pipe(pass);
		}

		// Read the input stream and detect the filetype
		const chunk = readableStream.read(minimumBytes) || readableStream.read() || Buffer.alloc(0);
		try {
			const fileType = await fromBuffer(chunk);
			pass.fileType = fileType;
		} catch (error) {
			reject(error);
		}

		resolve(outputStream);
	});
});

const fileType = {
	fromStream,
	fromTokenizer,
	fromBuffer,
	stream
};

Object.defineProperty(fileType, 'extensions', {
	get() {
		return new Set(supported.extensions);
	}
});

Object.defineProperty(fileType, 'mimeTypes', {
	get() {
		return new Set(supported.mimeTypes);
	}
});

module.exports = fileType;


/***/ }),

/***/ 97769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const strtok3 = __webpack_require__(26597);
const core = __webpack_require__(40001);

async function fromFile(path) {
	const tokenizer = await strtok3.fromFile(path);
	try {
		return await core.fromTokenizer(tokenizer);
	} finally {
		await tokenizer.close();
	}
}

const fileType = {
	fromFile
};

Object.assign(fileType, core);

Object.defineProperty(fileType, 'extensions', {
	get() {
		return core.extensions;
	}
});

Object.defineProperty(fileType, 'mimeTypes', {
	get() {
		return core.mimeTypes;
	}
});

module.exports = fileType;


/***/ }),

/***/ 49898:
/***/ ((module) => {

"use strict";


module.exports = {
	extensions: [
		'jpg',
		'png',
		'apng',
		'gif',
		'webp',
		'flif',
		'xcf',
		'cr2',
		'cr3',
		'orf',
		'arw',
		'dng',
		'nef',
		'rw2',
		'raf',
		'tif',
		'bmp',
		'icns',
		'jxr',
		'psd',
		'indd',
		'zip',
		'tar',
		'rar',
		'gz',
		'bz2',
		'7z',
		'dmg',
		'mp4',
		'mid',
		'mkv',
		'webm',
		'mov',
		'avi',
		'mpg',
		'mp2',
		'mp3',
		'm4a',
		'oga',
		'ogg',
		'ogv',
		'opus',
		'flac',
		'wav',
		'spx',
		'amr',
		'pdf',
		'epub',
		'exe',
		'swf',
		'rtf',
		'wasm',
		'woff',
		'woff2',
		'eot',
		'ttf',
		'otf',
		'ico',
		'flv',
		'ps',
		'xz',
		'sqlite',
		'nes',
		'crx',
		'xpi',
		'cab',
		'deb',
		'ar',
		'rpm',
		'Z',
		'lz',
		'cfb',
		'mxf',
		'mts',
		'blend',
		'bpg',
		'docx',
		'pptx',
		'xlsx',
		'3gp',
		'3g2',
		'jp2',
		'jpm',
		'jpx',
		'mj2',
		'aif',
		'qcp',
		'odt',
		'ods',
		'odp',
		'xml',
		'mobi',
		'heic',
		'cur',
		'ktx',
		'ape',
		'wv',
		'dcm',
		'ics',
		'glb',
		'pcap',
		'dsf',
		'lnk',
		'alias',
		'voc',
		'ac3',
		'm4v',
		'm4p',
		'm4b',
		'f4v',
		'f4p',
		'f4b',
		'f4a',
		'mie',
		'asf',
		'ogm',
		'ogx',
		'mpc',
		'arrow',
		'shp',
		'aac',
		'mp1',
		'it',
		's3m',
		'xm',
		'ai',
		'skp',
		'avif',
		'eps',
		'lzh',
		'pgp',
		'asar',
		'stl',
		'chm',
		'3mf',
		'zst',
		'jxl',
		'vcf'
	],
	mimeTypes: [
		'image/jpeg',
		'image/png',
		'image/gif',
		'image/webp',
		'image/flif',
		'image/x-xcf',
		'image/x-canon-cr2',
		'image/x-canon-cr3',
		'image/tiff',
		'image/bmp',
		'image/vnd.ms-photo',
		'image/vnd.adobe.photoshop',
		'application/x-indesign',
		'application/epub+zip',
		'application/x-xpinstall',
		'application/vnd.oasis.opendocument.text',
		'application/vnd.oasis.opendocument.spreadsheet',
		'application/vnd.oasis.opendocument.presentation',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'application/zip',
		'application/x-tar',
		'application/x-rar-compressed',
		'application/gzip',
		'application/x-bzip2',
		'application/x-7z-compressed',
		'application/x-apple-diskimage',
		'application/x-apache-arrow',
		'video/mp4',
		'audio/midi',
		'video/x-matroska',
		'video/webm',
		'video/quicktime',
		'video/vnd.avi',
		'audio/vnd.wave',
		'audio/qcelp',
		'audio/x-ms-asf',
		'video/x-ms-asf',
		'application/vnd.ms-asf',
		'video/mpeg',
		'video/3gpp',
		'audio/mpeg',
		'audio/mp4', // RFC 4337
		'audio/opus',
		'video/ogg',
		'audio/ogg',
		'application/ogg',
		'audio/x-flac',
		'audio/ape',
		'audio/wavpack',
		'audio/amr',
		'application/pdf',
		'application/x-msdownload',
		'application/x-shockwave-flash',
		'application/rtf',
		'application/wasm',
		'font/woff',
		'font/woff2',
		'application/vnd.ms-fontobject',
		'font/ttf',
		'font/otf',
		'image/x-icon',
		'video/x-flv',
		'application/postscript',
		'application/eps',
		'application/x-xz',
		'application/x-sqlite3',
		'application/x-nintendo-nes-rom',
		'application/x-google-chrome-extension',
		'application/vnd.ms-cab-compressed',
		'application/x-deb',
		'application/x-unix-archive',
		'application/x-rpm',
		'application/x-compress',
		'application/x-lzip',
		'application/x-cfb',
		'application/x-mie',
		'application/mxf',
		'video/mp2t',
		'application/x-blender',
		'image/bpg',
		'image/jp2',
		'image/jpx',
		'image/jpm',
		'image/mj2',
		'audio/aiff',
		'application/xml',
		'application/x-mobipocket-ebook',
		'image/heif',
		'image/heif-sequence',
		'image/heic',
		'image/heic-sequence',
		'image/icns',
		'image/ktx',
		'application/dicom',
		'audio/x-musepack',
		'text/calendar',
		'text/vcard',
		'model/gltf-binary',
		'application/vnd.tcpdump.pcap',
		'audio/x-dsf', // Non-standard
		'application/x.ms.shortcut', // Invented by us
		'application/x.apple.alias', // Invented by us
		'audio/x-voc',
		'audio/vnd.dolby.dd-raw',
		'audio/x-m4a',
		'image/apng',
		'image/x-olympus-orf',
		'image/x-sony-arw',
		'image/x-adobe-dng',
		'image/x-nikon-nef',
		'image/x-panasonic-rw2',
		'image/x-fujifilm-raf',
		'video/x-m4v',
		'video/3gpp2',
		'application/x-esri-shape',
		'audio/aac',
		'audio/x-it',
		'audio/x-s3m',
		'audio/x-xm',
		'video/MP1S',
		'video/MP2P',
		'application/vnd.sketchup.skp',
		'image/avif',
		'application/x-lzh-compressed',
		'application/pgp-encrypted',
		'application/x-asar',
		'model/stl',
		'application/vnd.ms-htmlhelp',
		'model/3mf',
		'image/jxl',
		'application/zstd'
	]
};


/***/ }),

/***/ 76188:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.stringToBytes = string => [...string].map(character => character.charCodeAt(0));

/**
Checks whether the TAR checksum is valid.

@param {Buffer} buffer - The TAR header `[offset ... offset + 512]`.
@param {number} offset - TAR header offset.
@returns {boolean} `true` if the TAR checksum is valid, otherwise `false`.
*/
exports.tarHeaderChecksumMatches = (buffer, offset = 0) => {
	const readSum = parseInt(buffer.toString('utf8', 148, 154).replace(/\0.*$/, '').trim(), 8); // Read sum in header
	if (isNaN(readSum)) {
		return false;
	}

	let sum = 8 * 0x20; // Initialize signed bit sum

	for (let i = offset; i < offset + 148; i++) {
		sum += buffer[i];
	}

	for (let i = offset + 156; i < offset + 512; i++) {
		sum += buffer[i];
	}

	return readSum === sum;
};

/**
ID3 UINT32 sync-safe tokenizer token.
28 bits (representing up to 256MB) integer, the msb is 0 to avoid "false syncsignals".
*/
exports.uint32SyncSafeToken = {
	get: (buffer, offset) => {
		return (buffer[offset + 3] & 0x7F) | ((buffer[offset + 2]) << 7) | ((buffer[offset + 1]) << 14) | ((buffer[offset]) << 21);
	},
	len: 4
};


/***/ }),

/***/ 17648:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();
var getDunderProto = __webpack_require__(96504);

var getProto = (typeof Reflect === 'function' && Reflect.getPrototypeOf)
	|| $Object.getPrototypeOf
	|| getDunderProto;

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 40690:
/***/ ((module) => {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 41405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ ((module) => {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 48824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 80645:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 5826:
/***/ ((module) => {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 59738:
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.floor;


/***/ }),

/***/ 52264:
/***/ ((module) => {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ ((module) => {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ ((module) => {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 6840:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(16505);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45801:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/svip_badage.fa062dc7.png","height":32,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/Ab/93FMCAgKaAgACEvz9/P/7+wYA/v8SAfn2CO7/9wJmAcb/4vPc2NYM3dHa/wYKFAEGCxsA29PX/ysjNQEvIzLzAcL/5PLh2eQNzcLY/wwNEwEaFSIA17y+/zctQgEmIir0AbP16VP++w6aAfoIEgLv/v8I9AAACfoCAQH5AO78+/9mEcZAwZw5emwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 1880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": () => (/* binding */ getAppKey),
/* harmony export */   "Cu": () => (/* binding */ getIntranetHost),
/* harmony export */   "Em": () => (/* binding */ getWsHostname),
/* harmony export */   "OG": () => (/* binding */ getPrePageFix),
/* harmony export */   "R": () => (/* binding */ TITLE),
/* harmony export */   "SR": () => (/* binding */ WORKBENCH_DESCRIPTION),
/* harmony export */   "X6": () => (/* binding */ getPreFix),
/* harmony export */   "Z8": () => (/* binding */ WORKBENCH_KEYWORDS),
/* harmony export */   "ce": () => (/* binding */ MODULE_ID),
/* harmony export */   "cr": () => (/* binding */ MATRIX_CHANNEL),
/* harmony export */   "e3": () => (/* binding */ HOME_KEYWORDS),
/* harmony export */   "hg": () => (/* binding */ getPPTUrl),
/* harmony export */   "i4": () => (/* binding */ PREVIEW_MODE),
/* harmony export */   "jN": () => (/* binding */ HOME_DESCRIPTION),
/* harmony export */   "kU": () => (/* binding */ getClientID),
/* harmony export */   "vX": () => (/* binding */ SCENE),
/* harmony export */   "y$": () => (/* binding */ getDesignHome)
/* harmony export */ });
/* unused harmony exports CLIENT_ID, getApiHostForWeb */
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3269);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);


const MODULE_ID = "hbsj";
const SCENE = "aippt";
const CLIENT_ID = "1189857523";
const getClientID = ()=>{
    const query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_1__/* .getQuery */ .pm)();
    return (query === null || query === void 0 ? void 0 : query.clientId) || CLIENT_ID;
};
const getAppKey = (oid)=>{
    const identity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)();
    if (oid !== null && oid !== void 0 ? oid : identity === null || identity === void 0 ? void 0 : identity.oid) {
        return  true ? "3EDDE044EAA4A219" : 0;
    }
    return  true ? "C5F34252F04B6D50" : 0;
};
// 1 为(预发布+正式),0 或者不传 为正式模式
const PREVIEW_MODE =  true ? 0 : 0;
const MATRIX_CHANNEL = "mtsjs_web";
const getPreFix = ()=>{
    let preFix = "release";
    if (preFix === "release") {
        preFix = "";
    }
    return preFix;
};
const getPrePageFix = ()=>{
    let preFix = "release";
    if (preFix === "release") {
        preFix = "www";
    }
    return preFix;
};
const getPPTUrl = ()=>{
    return "https://".concat(getPrePageFix(), ".designkit.cn/ppt");
};
const getApiHostForWeb = ()=>{
    return "https://".concat(getPreFix(), "webapi.designkit.cn");
};
// api内网域名
const getIntranetHost = ()=>{
    // 开发环境继续走公网
    if (true) {
        return getApiHostForWeb();
    }
    return "http://".concat(getPreFix(), "webapi-pc.m.com");
};
const getWsHostname = ()=>{
    let preFix = "release";
    return preFix === "pre" ? "wss://prewebsocket-design.meitu.com" : preFix === "beta" ? "wss://betawebsocket-design.meitu.com" : "wss://websocket-design.meitu.com";
};
const getDesignHome = ()=>{
    if (false) {}
    let preFix = "release";
    if (preFix === "release") {
        preFix = "www";
    }
    return "https://".concat(preFix, ".designkit.cn");
};
const TITLE = "美图设计室LivePPT";
const WORKBENCH_DESCRIPTION = "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";
const WORKBENCH_KEYWORDS = "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";
const HOME_DESCRIPTION = "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";
const HOME_KEYWORDS = "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";


/***/ }),

/***/ 40313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$i": () => (/* binding */ UPLOAD_FILE_MEMBER_FORMAT),
/* harmony export */   "$p": () => (/* binding */ FOOTER_TABS),
/* harmony export */   "AI": () => (/* binding */ MTCCDataScene),
/* harmony export */   "Ag": () => (/* binding */ TIP_TEXT),
/* harmony export */   "G7": () => (/* binding */ TABS),
/* harmony export */   "H1": () => (/* binding */ generateMap),
/* harmony export */   "HZ": () => (/* binding */ FILE_TEXT_MAX_LEN),
/* harmony export */   "M4": () => (/* binding */ FooterTabKey),
/* harmony export */   "Mh": () => (/* binding */ lenMap),
/* harmony export */   "NG": () => (/* binding */ MIN_PAGE_COUNT),
/* harmony export */   "Ph": () => (/* binding */ MAX_PAGE_COUNT),
/* harmony export */   "Rc": () => (/* binding */ TabKey),
/* harmony export */   "WU": () => (/* binding */ StepType),
/* harmony export */   "aR": () => (/* binding */ RICH_TEXT_MAX_LEN),
/* harmony export */   "gA": () => (/* binding */ MTCCData),
/* harmony export */   "gV": () => (/* binding */ SDK_PLATFORM),
/* harmony export */   "pR": () => (/* binding */ BTN_UUID),
/* harmony export */   "pZ": () => (/* binding */ TRACK_MAP),
/* harmony export */   "pf": () => (/* binding */ MESSAGE_KEY),
/* harmony export */   "re": () => (/* binding */ PPTProcessStatus),
/* harmony export */   "sB": () => (/* binding */ SdkModuleName),
/* harmony export */   "xs": () => (/* binding */ Scene)
/* harmony export */ });
/* unused harmony exports DownloadImgType, DOWNLOAD_SELECT */
/* harmony import */ var _assets_images_svip_badage_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45801);

var DownloadImgType;
(function(DownloadImgType) {
    DownloadImgType["jpg"] = "jpg";
    DownloadImgType["png"] = "png";
    DownloadImgType["ppt"] = "ppt";
    DownloadImgType["pdf"] = "pdf";
})(DownloadImgType || (DownloadImgType = {}));
const RICH_TEXT_MAX_LEN = 20000;
const BTN_UUID = "create_ppt_submit";
const FILE_TEXT_MAX_LEN = 30000;
var StepType;
(function(StepType) {
    StepType[StepType[/**
   * 前置输入，一句话，导入文件，粘贴文本
   */ "write"] = 0] = "write";
    StepType[StepType[/**
   * 生成大纲
   */ "outline"] = 1] = "outline";
    StepType[StepType[/**
   * 生成PPT
   */ "ppt"] = 2] = "ppt";
    StepType[StepType[/**
   * 选择模板
   */ "template"] = 3] = "template";
    StepType[StepType[/**
   * 分段分页
   */ "page"] = 4] = "page";
})(StepType || (StepType = {}));
var TabKey;
(function(TabKey) {
    TabKey["inAWord"] = "0";
    TabKey["pasteText"] = "1";
    TabKey["importFile"] = "2";
})(TabKey || (TabKey = {}));
const lenMap = {
    short: "1",
    medium: "2",
    long: "3"
};
const generateMap = {
    retain: "2",
    simplify: "1",
    expand: "3"
};
const TABS = [
    {
        key: TabKey.inAWord,
        icon: "MagicWandBold",
        title: "一句话生成"
    },
    {
        key: TabKey.pasteText,
        icon: "TextSquareBold",
        title: "已有文本生成"
    },
    {
        key: TabKey.importFile,
        icon: "UploadFlowBold",
        title: "导入文件生成",
        tag: _assets_images_svip_badage_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
    }
];
var FooterTabKey;
(function(FooterTabKey) {
    FooterTabKey["record"] = "0";
    FooterTabKey["template"] = "1";
})(FooterTabKey || (FooterTabKey = {}));
const FOOTER_TABS = [
    {
        key: FooterTabKey.record,
        title: "历史记录",
        forceLogin: true
    },
    {
        key: FooterTabKey.template,
        title: "PPT模板"
    }
];
const TRACK_MAP = {
    [TabKey.inAWord]: "one_sentence_subject",
    [TabKey.pasteText]: "text_subject",
    [TabKey.importFile]: "upload_file"
};
const DOWNLOAD_SELECT = [
    {
        type: DownloadImgType.jpg,
        title: "JPG",
        message: "文件较小，不支持透明背景"
    },
    {
        type: DownloadImgType.png,
        title: "PNG",
        message: "无损图片，文件较大，不支持透明背景"
    },
    {
        type: DownloadImgType.ppt,
        title: "PPT",
        message: "文件较大，可编辑"
    },
    {
        type: DownloadImgType.pdf,
        title: "PDF",
        message: "比 PPT 文件大，不可编辑"
    }
];
var PPTProcessStatus;
(function(PPTProcessStatus) {
    PPTProcessStatus[PPTProcessStatus[// 不存在该记录
    "noExist"] = 0] = "noExist";
    PPTProcessStatus[PPTProcessStatus[// 投递成功待处理
    "pending"] = 1] = "pending";
    PPTProcessStatus[PPTProcessStatus[// 处理进行中
    "processing"] = 10] = "processing";
    PPTProcessStatus[PPTProcessStatus[// 处理失败
    "fail"] = 20] = "fail";
    PPTProcessStatus[PPTProcessStatus[// 处理成功
    "success"] = 30] = "success";
})(PPTProcessStatus || (PPTProcessStatus = {}));
const MESSAGE_KEY = "MESSAGE_KEY";
const MAX_PAGE_COUNT = 30;
const MIN_PAGE_COUNT = 1;
var SdkModuleName;
(function(SdkModuleName) {
    SdkModuleName["aippt"] = "aippt-sdk";
})(SdkModuleName || (SdkModuleName = {}));
var Scene;
(function(Scene) {
    Scene["AiPPT"] = "aippt";
})(Scene || (Scene = {}));
const SDK_PLATFORM = {
    "221": "roboneo"
};
const MTCCDataScene = {
    aippt: "00119"
};
// 成本分摊埋点 https://cf.meitu.com/confluence/pages/viewpage.action?pageId=416230853
const MTCCData = {
    // 生成完整 PPT
    "/ppt/apply": {
        positionKey: "",
        function: MTCCDataScene["aippt"],
        position: {
            default: MTCCDataScene["aippt"]
        }
    }
};
const TIP_TEXT = "您的内容已加密，生成后将自动删除";
/**
 * 上传文件需要会员的格式
 */ const UPLOAD_FILE_MEMBER_FORMAT = [
    "txt",
    "pdf",
    "docx"
];


/***/ }),

/***/ 16505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14222);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_globals_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94501);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25344);
/* harmony import */ var _appLogic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79319);





Promise.all(/* import() */[__webpack_require__.e(938), __webpack_require__.e(7512), __webpack_require__.e(8339), __webpack_require__.e(5882)]).then(__webpack_require__.bind(__webpack_require__, 67055)).then((param)=>{
    let { initResignedListener  } = param;
    initResignedListener();
});
const MyApp = (param)=>{
    let { Component , pageProps  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(easy_peasy__WEBPACK_IMPORTED_MODULE_2__/* .StoreProvider */ .g3, {
        store: _store__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_appLogic__WEBPACK_IMPORTED_MODULE_4__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...pageProps
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MyApp);


/***/ }),

/***/ 79319:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ appLogic)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(32711);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(25344);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(46718);
;// CONCATENATED MODULE: ./src/services/enterprise/index.ts



async function initEnterprise() {
    (0,configProvider/* setConfigPartial */.qK)({
        client_id: (0,constants/* getClientID */.kU)(),
        env: "release"
    });
    // 企业相关配置，目前主要使用到上传app
    const res = await (0,teamInfo/* enterpriseInit */.P3)();
}
// 是否企业标识
const isEnterprise = ()=>!!getEnterpriseID();

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/constants.js
/**
 * ABTest 环境变量
 */
var ABTestEnv;
(function (ABTestEnv) {
    /** 正式环境 */
    ABTestEnv["Release"] = "release";
    /** 测试环境 */
    ABTestEnv["Beta"] = "beta";
    /** 预发环境 */
    ABTestEnv["Test"] = "test";
})(ABTestEnv || (ABTestEnv = {}));
/**
 * ABTest code信息列表接口请求地址
 */
const ABTestApi = {
    [ABTestEnv.Release]: 'https://meepo.meitustat.com/ab_allot_web_v2',
    [ABTestEnv.Beta]: 'https://test-meepo.meitustat.com/ab_allot_web_v2', // https://api-mock.meitu-int.com/mock/14/ab_allot  http://test.meepo.meitustat.com/ab_allot_web
    [ABTestEnv.Test]: 'https://test-meepo.meitustat.com/ab_allot_web_v2'
};
/**
 * 本地存储 key
 *
 * @since 1.3.0
 *
 * @deprecated 已弃用，请改用 `cacheKey` 属性替代
 */
const LS_AB_TEST = 'abTest';
/**
 * 埋点统计sdk 存储的 本地缓存 为了取 wgid;
 *
 *  @since 1.3.0
 */
const MTSTAT_COOKIE_NAME = 'meitustat';
/**
 * ABTest Web 服务端设备标记 cookie 名称
 *
 * @since 1.3.0
 */
const COOKIE_NAME_WEB_SERVER_ID = '__mt_ab_test_wsid__';
/**
 * ABTest Web 服务端进入实验 code cookie 名称
 *
 * @since 1.3.0
 */
const COOKIE_NAME_SERVER_IN_TEST_CODE = '__mt_ab_test_server_codes__';
/**
 * 协议版本 目前 Web 是传 3
 */
const ProtocolVersion = 3;
/**
 * ABTest 进入实验 默认上报的事件名称
 */
const ABCODE_ENTER_TEST = 'abcode_enter_test';
/**
 * 控制台日志前缀
 *
 * @since 1.2.0
 */
const LOG_PREFIX = '[@meitu/ab-test]';
/**
 * 实验状态
 */
var ExperimentStatus;
(function (ExperimentStatus) {
    /** 已创建 */
    ExperimentStatus[ExperimentStatus["Created"] = 0] = "Created";
    /** 进行中 */
    ExperimentStatus[ExperimentStatus["InProgress"] = 1] = "InProgress";
    /** 已完成 */
    ExperimentStatus[ExperimentStatus["Completed"] = 2] = "Completed";
    /** 人为终止 */
    ExperimentStatus[ExperimentStatus["Terminated"] = 3] = "Terminated";
    /** 一键发布 */
    ExperimentStatus[ExperimentStatus["Publish"] = 4] = "Publish";
    /** 已发布 */
    ExperimentStatus[ExperimentStatus["Published"] = 5] = "Published";
    /** 已结束 */
    ExperimentStatus[ExperimentStatus["End"] = 6] = "End";
})(ExperimentStatus || (ExperimentStatus = {}));
/**
 * 实验类型
 */
var ExperimentType;
(function (ExperimentType) {
    /** 客户端实验 */
    ExperimentType[ExperimentType["Client"] = 1] = "Client";
    /** 客户端本地实验 */
    ExperimentType[ExperimentType["ClientLocal"] = 2] = "ClientLocal";
    /** 服务端实验 */
    ExperimentType[ExperimentType["Server"] = 3] = "Server";
    /** 异步实验-通用实验 */
    ExperimentType[ExperimentType["AsyncCommon"] = 4] = "AsyncCommon";
    /** 异步实验-push */
    ExperimentType[ExperimentType["AsyncPush"] = 5] = "AsyncPush";
    /** 异步实验-推荐 */
    ExperimentType[ExperimentType["AsyncRecommend"] = 6] = "AsyncRecommend";
})(ExperimentType || (ExperimentType = {}));
/**
 * 标识类型
 */
var IdentifyType;
(function (IdentifyType) {
    /** 用户id */
    IdentifyType["Uid"] = "type1";
    /** app gid */
    IdentifyType["AppGid"] = "type2";
    /** web gid */
    IdentifyType["WebGid"] = "type3";
    /** pc gid */
    IdentifyType["PcGid"] = "type4";
    /** Mac 地址 */
    IdentifyType["MacAddress"] = "type5";
    /**
     * Web 服务端设备标记
     *
     * @since 1.3.0
     **/
    IdentifyType["WebServerId"] = "type6";
})(IdentifyType || (IdentifyType = {}));

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/types.js

/**
 * 获取 ABTest 类的默认配置选项
 *
 * @since 1.2.0
 */
function getDefaultABTestOptions() {
    return {
        appKey: '',
        gid: '',
        wgid: '',
        custom: [],
        env: ABTestEnv.Release
    };
}
/**
 * 验证配置项是否有效
 *
 * @since 1.3.1
 */
function validateOptions(options) {
    var _a, _b;
    if (!((_b = (_a = options === null || options === void 0 ? void 0 : options.appKey) === null || _a === void 0 ? void 0 : _a.trim) === null || _b === void 0 ? void 0 : _b.call(_a))) {
        throw new Error('appKey 为必传参数');
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/utils.js
/**
 * 将字符串转成十六进制
 *
 * @param str 需要转成十六进制的字符串
 */
function strToHex(str) {
    let val = '';
    for (let i = 0; i < str.length; i++) {
        val += str.charCodeAt(i).toString(16);
    }
    return val.toUpperCase();
}
/**
 * 打平设备自定义标识数组
 *
 * @since 1.3.0
 */
function flatIdentify(custom) {
    return custom.reduce((acc, current) => {
        const { type, value } = current;
        acc[type] = value;
        return acc;
    }, {});
}
/**
 * 转换成特定的命名法
 * @param transform 转换函数
 * @param input 输入值
 *
 * @since 1.3.0
 */
function toSpecificCase(transform, input) {
    if (Array.isArray(input)) {
        return input.map(toSpecificCase.bind(null, transform));
    }
    if (typeof input === 'object' && input !== null) {
        return Object.keys(input).reduce((acc, key) => Object.assign(acc, {
            [transform(key)]: toSpecificCase(transform, input[key])
        }), {});
    }
    return input;
}
/**
 * 转换为小驼峰
 * @param input 输入
 *
 * @since 1.3.0
 * @example
 * // returns { eventProduct: '美图秀秀社区后台' }
 * // toCamelCase<{ eventProduct: string; }>({ event_product: '美图秀秀社区后台' })
 */
function toCamelCase(input) {
    return toSpecificCase(camelCase, input);
}
/**
 * 将给定的字符串转换为小驼峰
 */
function camelCase(str) {
    const words = str
        .replace(/[^a-zA-Z0-9]+/g, ' ')
        .split(' ')
        .filter(Boolean);
    return words
        .map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join('');
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/AbTest.js



/**
 * A/B 测试核心 / 基类
 */
class ABTestCore {
    /**
     * Web 服务端设备标记
     *
     * @readonly
     * @since 1.3.0
     */
    get webServerId() {
        return '';
    }
    /**
     * Web 服务端进入实验测试 codes
     *
     * @readonly
     * @since 1.3.0
     */
    get webServerTestCodes() {
        return [];
    }
    constructor(options) {
        /**
         * ABTest 配置
         */
        this.options = getDefaultABTestOptions();
        /**
         * 是否已经初始化完成
         *
         * 异步请求 A/B 测试数据之后才能调用其他相关的接口
         *
         * @default false
         */
        this.initialize = false;
        this.options = Object.assign(Object.assign({}, this.options), options);
        validateOptions(this.options);
        this._storage = this.createStorageCache();
    }
    /**
     * 版本号
     *
     * @getter
     * @readonly
     * @since 1.2.0
     */
    get version() {
        return '1.3.1';
    }
    /**
     * 当前运行环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env || ABTestEnv.Release;
    }
    /**
     * 存储实例对象
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get storage() {
        return this._storage;
    }
    /**
     * 不同环境变量对应请求的 api 地址
     *
     * @getter
     * @readonly
     */
    get url() {
        return ABTestApi[this.env];
    }
    /**
     * 自定义设备标识列表
     *
     * @getter
     * @readonly
     */
    get custom() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.custom) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * 平铺后的自定义设备标识列表
     *
     * @getter
     * @readonly
     * @protected
     */
    get identifyMap() {
        return flatIdentify(this.custom);
    }
    /**
     * 本地存储 key
     *
     * 不同 appKey 之间对应不同的存储 key
     * @getter
     * @readonly
     * @since 1.3.1
     */
    get cacheKey() {
        return `${LS_AB_TEST}_${this.options.appKey}`;
    }
    /**
     * A/B 测试编码列表（本地缓存）
     *
     * @getter
     * @protected
     * @readonly
     */
    get abCodes() {
        // 兼容旧数据
        const oldCodes = this.storage.getItem(LS_AB_TEST);
        return this.storage.getItem(this.cacheKey, oldCodes !== null && oldCodes !== void 0 ? oldCodes : []);
    }
    /**
     * A/B 测试编码列表映射对象（按 code）
     *
     * @getter
     * @protected
     * @readonly
     */
    get abCodesMap() {
        return this.abCodes.reduce((codes, ab) => {
            codes[ab.abCode] = ab;
            return codes;
        }, {});
    }
    /**
     * 检查是否已经初始化完毕 ABTest SDK
     *
     * @since 1.3.0
     */
    checkHasInit(methodName = '该') {
        if (!this.initialize) {
            console.warn(LOG_PREFIX, `尚未初始化成功，请确保初始化完毕再调用 【${methodName}】 方法`);
        }
        return this.initialize;
    }
    /**
     * 判断当前 code 是否进入 A/B 实验当中
     *
     * @param code A/B 实验编码
     */
    isInABTesting(code) {
        var _a, _b;
        if (!this.checkHasInit('isInABTesting')) {
            return false;
        }
        const abCodes = this.abCodes;
        const index = abCodes.findIndex(({ abCode }) => abCode === code);
        if (index >= 0) {
            const count = ((_a = abCodes[index]) === null || _a === void 0 ? void 0 : _a.count) || 0;
            if (count === 0) {
                // 第一次进入实验 上报默认埋点事件 abcode_enter_test
                const code = ((_b = abCodes[index]) === null || _b === void 0 ? void 0 : _b.abCode) || 0;
                if (code) {
                    this.reportABCodeEnterTest(code);
                }
            }
            abCodes[index].count += 1;
            this.storage.setItem(this.cacheKey, abCodes); // count 进入实验后 自增 1 并更新本地缓存
            return true;
        }
        return false;
    }
    /**
     * 获取进入 A/B 测试实验的编码
     *
     * @param codes 做实验的整组 code [1001,1002,1003] | example: 实验组 1 code = 1001, 实验组 2 code = 1002, 对照组 3 code = 1003
     * @returns 返回命中的 AB Test code 值；返回值为 0 表示没有命中
     */
    inABTestingCode(codes) {
        if (!this.checkHasInit('inABTestingCode')) {
            return 0;
        }
        const codeMap = this.abCodesMap;
        const code = codes.find((code) => codeMap[code]);
        if (code) {
            this.isInABTesting(code); // 如果进入实验需要更新 本地 count 并上报默认事件
        }
        return code || 0;
    }
    /**
     * 获取服务端实验中的 A/B 测试编码列表
     */
    getABTestingServerCodes() {
        if (!this.checkHasInit('getABTestingServerCodes')) {
            return [];
        }
        const abCodes = this.abCodes;
        return abCodes.reduce((acc, current) => {
            const { abCode, et: experimentType } = current;
            const types = [
                ExperimentType.Server,
                ExperimentType.AsyncCommon,
                ExperimentType.AsyncPush,
                ExperimentType.AsyncRecommend
            ];
            if (types.indexOf(experimentType) >= 0) {
                acc.push(abCode);
            }
            return acc;
        }, []);
    }
    /**
     * 设置服务端实验中的 A/B 测试码
     *
     * 更新本地缓存中对应实验中 count 计数 目前 count 由前端维护 代表进入实验的次数
     *
     * 作用：
     *
     * 1. `count` => 1 需要上报，默认的 `abcode_enter_test` 事件 通过埋点sdk 上报 当作进入实验的指标
     * 2. 预留以后需要统计进入`实验次数`这个口子
     *
     */
    setABTestingServerCodes(codes) {
        if (!(codes === null || codes === void 0 ? void 0 : codes.length)) {
            console.warn(LOG_PREFIX, `setABTestingServerCodes: codes is empty`);
            return;
        }
        if (!this.checkHasInit('setABTestingServerCodes')) {
            return;
        }
        codes.forEach((code) => {
            this.isInABTesting(code);
        });
    }
    /**
     * 获取 A/B 测试（关键）信息
     */
    getABInfo() {
        const codes = this.abCodes.reduce((acc, { abCode, status, count }) => {
            if (status === ExperimentStatus.InProgress) {
                acc.push({
                    code: abCode,
                    count
                });
            }
            return acc;
        }, []);
        return {
            // eslint-disable-next-line camelcase
            ab_codes: codes, // 此处用 snakeCase 是为了用户调用接口获取到的数据，可以直接用作 WebSDK 上报的行为日志
            version: this.version
        };
    }
    /**
     * 设置本地缓存 abCodes 信息
     *
     * @protected
     * @since 1.3.0
     */
    cacheABInfo(codes = []) {
        const codeMap = this.abCodesMap;
        const abInfo = codes.map(({ abCode, et, status, v }) => {
            const localABInfo = ((codeMap === null || codeMap === void 0 ? void 0 : codeMap[abCode]) || {});
            const count = (localABInfo === null || localABInfo === void 0 ? void 0 : localABInfo.v) === v ? localABInfo.count || 0 : 0; // 当版本变更时需要重置 count 为 0；
            return {
                abCode,
                et,
                status,
                v,
                count
            };
        });
        this.storage.setItem(this.cacheKey, abInfo); // 设置本地缓存
    }
    /**
     * 生成请求 ABCode 接口参数
     *
     * @protected
     */
    toQueryParams() {
        const { identifyMap } = this;
        const { appKey, gid, uid } = this.options;
        const result = {
            appKey,
            version: ProtocolVersion
        };
        if (gid) {
            result[IdentifyType.AppGid] = gid;
            console.warn(LOG_PREFIX, 'uid 将在未来的版本中废弃，请使用 `custom` 来自定义标识类型');
        }
        if (uid) {
            result[IdentifyType.Uid] = uid;
            console.warn(LOG_PREFIX, 'uid 将在未来的版本中废弃，请使用 `custom` 来自定义标识类型');
        }
        return Object.assign(Object.assign({}, result), identifyMap);
    }
    /**
     * 获取所有实验中的 A/B 测试编码列表
     */
    getABTestingCodes() {
        if (!this.checkHasInit('getABTestingCodes')) {
            return [];
        }
        const abCodes = this.abCodes;
        return abCodes.reduce((acc, current) => {
            const { abCode, status } = current;
            if (status === ExperimentStatus.InProgress) {
                acc.push(abCode);
            }
            return acc;
        }, []);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-core/dist/esm/index.js





// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/storage.js
const storage = typeof window !== 'undefined' && window.localStorage;
/**
 * 设置本地存储项
 * @param key 键
 * @param value 值
 */
function setItem(key, value) {
    storage.setItem(key, JSON.stringify(value === undefined ? null : value));
}
/**
 * 获取本地存储项
 * @param key 键
 */
function getItem(key, defaultValue) {
    try {
        const item = storage.getItem(key);
        const value = item == null ? null : JSON.parse(item);
        return value !== null && value !== void 0 ? value : defaultValue;
    }
    catch (err) {
        return defaultValue;
    }
}
/**
 * 移除本地存储项
 * @param key 键
 */
function removeItem(key) {
    storage.removeItem(key);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/AbTest.js

/// <reference types="@meitu/mtstat-sdk" />



/**
 * A/B 测试类
 */
class ABTest extends ABTestCore {
    /**
     * 通过埋点统计 Web SDK 生成的设备标识
     *
     * @getter
     * @readonly
     */
    get wgid() {
        var _a, _b;
        let webGid = '';
        try {
            webGid = (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.getDeviceId();
        }
        catch (err) {
            console.warn(err);
        }
        return (((_b = this.identifyMap) === null || _b === void 0 ? void 0 : _b[IdentifyType.WebGid]) || webGid) + ''; // 默认使用 WebSDK 里的 wgid,如果自定传入 wgid 的话再覆盖
    }
    /**
     * Web 服务端设备标记
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get webServerId() {
        var _a, _b;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.wsid) {
            return (_b = this.options) === null || _b === void 0 ? void 0 : _b.wsid;
        }
        const webServerIdValue = js_cookie/* default.get */.Z.get(COOKIE_NAME_WEB_SERVER_ID) || '';
        try {
            const value = JSON.parse(webServerIdValue);
            return value[this.options.appKey] || '';
        }
        catch (error) {
            console.warn(error);
            return webServerIdValue;
        }
    }
    /**
     * Web 服务端进入实验测试 codes
     *
     * @getter
     * @readonly
     * @since 1.3.0
     */
    get webServerTestCodes() {
        var _a, _b;
        const codesValue = (_a = js_cookie/* default.get */.Z.get(COOKIE_NAME_SERVER_IN_TEST_CODE)) !== null && _a !== void 0 ? _a : '';
        let abCodes = [];
        if (!codesValue) {
            return abCodes;
        }
        try {
            const value = JSON.parse(codesValue);
            abCodes = Array.isArray(value)
                ? value
                : (_b = value[this.options.appKey]) !== null && _b !== void 0 ? _b : [];
        }
        catch (error) {
            console.warn(error);
        }
        return abCodes;
    }
    createStorageCache() {
        return {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem
        };
    }
    /**
     * 合并目标 ABTestCode 数组与结果 ABTestCode 数组。
     *
     * @since 1.3.0
     */
    mergeAbTestCodes(abCodes, target) {
        const map = abCodes.reduce((acc, item) => {
            acc[item.abCode] = Object.assign({ count: 0 }, item);
            return acc;
        }, {});
        target.forEach((item) => {
            if (!map[item.abCode]) {
                // 没有的话，直接添加
                map[item.abCode] = Object.assign(Object.assign({}, item), { count: 0 });
            }
        });
        return Object.values(map);
    }
    // 保证主包 JS API 文档的正确生成
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init(options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            let abCodes = [];
            // 保证初始化【埋点统计SDK】并生成 wgid 之后再初始化【ABTest SDK】
            if (window.mtstat &&
                typeof window.mtstat.init === 'function' &&
                this.wgid) {
                try {
                    const abInfo = yield this.fetchABCodes(); // 获取服务端abCodes
                    abCodes = this.mergeAbTestCodes(abInfo.abCodes, this.webServerTestCodes);
                }
                catch (err) {
                    console.error(err);
                }
                this.cacheABInfo(abCodes); // 设置本地缓存
                // 在这里先设置初始化完毕是为了能够在 setABTestingServerCodes 中 count + 1，让后上报
                this.initialize = true; // 初始化完毕
                if (this.webServerTestCodes.length) {
                    if (this.webServerId) {
                        // 有接收服务器给的 ab code 时，需要提前设置 abInfo 后续才能上报
                        const abInfo = this.getABInfo();
                        (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.setABInfo(abInfo);
                    }
                    // 有接收服务器给的 ab code 时，需要 count + 1
                    this.setABTestingServerCodes(this.webServerTestCodes.map((item) => item.abCode));
                    try {
                        const codesValue = js_cookie/* default.get */.Z.get(COOKIE_NAME_SERVER_IN_TEST_CODE);
                        const value = JSON.parse(codesValue);
                        if (Array.isArray(value)) {
                            js_cookie/* default.remove */.Z.remove(COOKIE_NAME_SERVER_IN_TEST_CODE);
                        }
                        else {
                            delete value[this.options.appKey];
                            js_cookie/* default.set */.Z.set(COOKIE_NAME_SERVER_IN_TEST_CODE, JSON.stringify(value));
                        }
                    }
                    catch (error) {
                        console.warn(error);
                    }
                }
            }
            else {
                console.warn(LOG_PREFIX, '请确保先引入埋点统计 JS SDK（@meitu/mtstat-sdk），并调用 mtstat.init() 初始化之后，再进行 ABTest SDK 的初始化');
            }
            return abCodes;
        });
    }
    fetchABCodes() {
        if (typeof fetch === 'undefined') {
            throw new Error('Fetch API undefined');
        }
        const postData = this.toQueryParams();
        if (this.webServerId) {
            postData[IdentifyType.WebServerId] = this.webServerId;
        }
        const hexStr = strToHex(JSON.stringify(Object.assign(Object.assign({}, postData), { [IdentifyType.WebGid]: this.wgid })));
        return new Promise((resolve, reject) => {
            fetch === null || fetch === void 0 ? void 0 : fetch(this.url, {
                method: 'POST',
                body: hexStr
            }).then((res) => (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
                const result = yield res.json();
                resolve(toCamelCase(result));
            })).catch((error) => reject(error));
        });
    }
    /**
     * 获取 A/B 测试（关键）信息
     */
    getABInfo() {
        const abInfo = super.getABInfo();
        return this.webServerId
            ? Object.assign(Object.assign({}, abInfo), { 
                // eslint-disable-next-line camelcase
                ab_wsid: this.webServerId }) : abInfo;
    }
    /**
     * 第一次进入实验 上报默认埋点事件 `abcode_enter_test`
     *
     * 埋点事件数据示例：`{event_id: "abcode_enter_test", params: { current_abcode: 100x }}`
     */
    reportABCodeEnterTest(code) {
        var _a;
        if (!this.checkHasInit('reportABCodeEnterTest')) {
            return;
        }
        (_a = window.mtstat) === null || _a === void 0 ? void 0 : _a.track(ABCODE_ENTER_TEST, {
            // eslint-disable-next-line camelcase
            current_abcode: code
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test-web/dist/esm/index.js



;// CONCATENATED MODULE: ./node_modules/@meitu/ab-test/dist/esm/index.js


;// CONCATENATED MODULE: ./src/utils/abtest.ts

let abInfo = {};
let abTest = null;
const initABTest = async ()=>{
    var // 通过websdk 设置ab_info的信息
    ref;
    const abTestParams = {
        /** Web项目id */ appKey: "C5F34252F04B6D50",
        /** 环境变量 不传默认选择正式环境*/ env: ABTestEnv.Release
    };
    // 实例化 ABTest SDK
    const abTestInstance = new ABTest(abTestParams);
    await abTestInstance.init(); // 初始化 ABTest SDK
    abTest = abTestInstance;
    abInfo = abTest.getABInfo();
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.setABInfo(abInfo);
};
const getAbInfo = ()=>{
    return abInfo;
};
/**
 * 是否开启deepsSeek
 */ const isOpenDeepSeek = async ()=>{
    if (!abTest) await initABTest();
    // 对照组，默认开启
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(25314)) {
        ;
        return true;
    }
    // 实验组，默认关闭
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(25315)) {
        ;
        return false;
    }
    ;
    return true;
};
/**
 * ppt商业化
 */ const isOpenPptCommercialization = async ()=>{
    if (!abTest) await initABTest();
    // 对照组，默认关闭
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27220)) {
        return {
            isHitGroupOne: false,
            isHitGroupTwo: false
        };
    }
    // 实验组1
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27221)) {
        return {
            isHitGroupOne: true,
            isHitGroupTwo: false
        };
    }
    // 实验组2
    if (abTest === null || abTest === void 0 ? void 0 : abTest.isInABTesting(27222)) {
        return {
            isHitGroupOne: false,
            isHitGroupTwo: true
        };
    }
    return {
        isHitGroupOne: false,
        isHitGroupTwo: false
    };
};

// EXTERNAL MODULE: ./src/utils/sdk.ts
var sdk = __webpack_require__(82345);
;// CONCATENATED MODULE: ./src/pages/appLogic.tsx










const AppLogic = ()=>{
    const finishWidgetsConfig = (0,store/* useStoreActions */.WX)((action)=>action.finishWidgetsConfig);
    const setIsOpenDeepSeek = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenDeepSeek);
    const setIsOpenPptCommercialization = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenPptCommercialization);
    const finishTrack = (0,store/* useStoreState */.Kw)((state)=>state.finishTrack);
    const userInfo = (0,store/* useStoreState */.Kw)((state)=>state.userModel.userInfo);
    const finishFetchUserInfo = (0,store/* useStoreState */.Kw)((state)=>state.userModel.isRequested);
    const handleInitAbTest = async ()=>{
        await initABTest();
        if ((0,utils/* isMobile */.tq)()) {
            setIsOpenDeepSeek(true);
            return;
        }
        if ((0,sdk/* checkIsInSdk */.X)()) {
            setIsOpenDeepSeek(false);
        } else {
            isOpenDeepSeek().then((isOpen)=>{
                setIsOpenDeepSeek(isOpen);
            });
        }
        isOpenPptCommercialization().then((isOpen)=>{
            setIsOpenPptCommercialization(isOpen);
        });
    };
    (0,react.useEffect)(()=>{
        // xdesign-widgets组件公共参数
        (0,configProvider/* setConfig */.v6)("client_id", (0,constants/* getClientID */.kU)());
        (0,configProvider/* setConfig */.v6)("env", "release");
        (0,configProvider/* setConfig */.v6)("app_key", (0,constants/* getAppKey */.AJ)());
        (0,configProvider/* setConfig */.v6)("module_id", constants/* MODULE_ID */.ce);
        (0,configProvider/* setConfig */.v6)("theme", "light");
        (0,configProvider/* setConfig */.v6)("isTeam", true);
        finishWidgetsConfig();
        // 依赖上面env的设置
        (0,uidKit/* initLocalUid */.sw)();
        const initFn = async ()=>{
            // 定制企业版逻辑
            await initEnterprise();
            const is = await __webpack_require__.e(/* import() */ 3074).then(__webpack_require__.bind(__webpack_require__, 33074));
            if (is.isMobile && (is.isXiuXiu || is.isPoster) && is.isIOS) {
                window.addEventListener("WebviewJsBridgeReady", ()=>{
                    ;
                    // 初始化埋点SDK逻辑
                    (0,mtstat/* initMtstat */.jt)(handleInitAbTest);
                });
            } else {
                // 初始化埋点SDK逻辑
                (0,mtstat/* initMtstat */.jt)(handleInitAbTest);
            }
        };
        initFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //埋点初始化完成并且用户信息请求完成
    (0,react.useEffect)(()=>{
        ;
        if (finishTrack && finishFetchUserInfo) {
            (0,mtstat/* setUserCommonParams */.xT)({
                isVip: userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip,
                availableAmount: userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_amount
            });
        }
    }, [
        finishTrack,
        finishFetchUserInfo,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.available_amount,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip
    ]);
    (0,react.useEffect)(()=>{
        if (userInfo) {
            (0,configProvider/* setConfig */.v6)("userInfo", userInfo);
        }
    }, [
        userInfo
    ]);
    return null;
};
/* harmony default export */ const appLogic = (AppLogic);


/***/ }),

/***/ 25344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ src_store),
  "WX": () => (/* binding */ useStoreActions),
  "Kw": () => (/* binding */ useStoreState)
});

// UNUSED EXPORTS: useStoreDispatch

// EXTERNAL MODULE: ./node_modules/easy-peasy/dist/index.js + 3 modules
var dist = __webpack_require__(94501);
;// CONCATENATED MODULE: ./src/store/userModel/index.ts

const userModel = {
    userInfo: undefined,
    setUserInfo: (0,dist/* action */.aD)((state, value)=>{
        state.userInfo = value;
    }),
    meidouInfo: null,
    setMeidouInfo: (0,dist/* action */.aD)((state, value)=>{
        state.meidouInfo = value;
    }),
    cutoutInfo: null,
    setCutoutInfo: (0,dist/* action */.aD)((state, value)=>{
        state.cutoutInfo = value;
    }),
    isRequested: false,
    setIsRequested: (0,dist/* action */.aD)((state, value)=>{
        state.isRequested = value;
    })
};

;// CONCATENATED MODULE: ./src/store/index.ts


const store = (0,dist/* createStore */.MT)({
    userModel: userModel,
    isWidgetsConfigDone: false,
    finishWidgetsConfig: (0,dist/* action */.aD)((state)=>{
        state.isWidgetsConfigDone = true;
    }),
    isOpenDeepSeek: true,
    setIsOpenDeepSeek: (0,dist/* action */.aD)((state, payload)=>{
        state.isOpenDeepSeek = payload;
    }),
    finishTrack: false,
    setFinishTrack: (0,dist/* action */.aD)((state, payload)=>{
        state.finishTrack = payload;
    }),
    isOpenPptCommercialization: undefined,
    setIsOpenPptCommercialization: (0,dist/* action */.aD)((state, payload)=>{
        state.isOpenPptCommercialization = payload;
    })
});
const typedHooks = (0,dist/* createTypedHooks */.tl)();
const useStoreState = typedHooks.useStoreState;
const useStoreActions = typedHooks.useStoreActions;
const useStoreDispatch = typedHooks.useStoreDispatch;
/* harmony default export */ const src_store = (store);


/***/ }),

/***/ 83353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ waitUntilGetGid)
/* harmony export */ });
/* unused harmony export getUnionDeviceId */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57632);

let wgid = "";
let iframeDom = {};
/**
 * 同步主站(designkit.com)的wgid
 *
 * @return {*}  {Promise<string>}
 * const deviceId = await getUnionDeviceId();
 */ function getUnionDeviceId() {
    var ref, ref1;
    const gid = ((ref = window.mtstat) === null || ref === void 0 ? void 0 : (ref1 = ref.getStatsMarker) === null || ref1 === void 0 ? void 0 : ref1.call(ref)) || "";
    return gid;
}
/**
 * 循环取gid, 如果1s内没取到就随机生成(可能遇到埋点web sdk初始化失败)
 * @returns Promise<string>  返回gid
 */ const waitUntilGetGid = ()=>{
    return new Promise((resolve)=>{
        if (wgid) {
            resolve(wgid);
            return;
        }
        let loopTimes = 4;
        const getData = async ()=>{
            wgid = await getUnionDeviceId();
            if (!wgid && loopTimes === 0) {
                wgid = (0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
                resolve(wgid);
            } else if (!wgid) {
                setTimeout(()=>{
                    loopTimes = loopTimes - 1;
                    getData();
                }, 500);
            } else {
                resolve(wgid);
            }
        };
        getData();
    });
};


/***/ }),

/***/ 45332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": () => (/* binding */ isAndroid),
/* harmony export */   "FZ": () => (/* binding */ isPcPlatform),
/* harmony export */   "G6": () => (/* binding */ isSafari),
/* harmony export */   "GP": () => (/* binding */ isQQ),
/* harmony export */   "Hq": () => (/* binding */ workerSleep),
/* harmony export */   "Lt": () => (/* binding */ filterParams),
/* harmony export */   "MH": () => (/* binding */ isFromHuaweiCustom),
/* harmony export */   "Q1": () => (/* binding */ thumbnail),
/* harmony export */   "R$": () => (/* binding */ isSupportWebp),
/* harmony export */   "T5": () => (/* binding */ getMatrixChannel),
/* harmony export */   "WY": () => (/* binding */ isJsonStr),
/* harmony export */   "_v": () => (/* binding */ sleep),
/* harmony export */   "b5": () => (/* binding */ getSource),
/* harmony export */   "fP": () => (/* binding */ getOsType),
/* harmony export */   "gn": () => (/* binding */ isIOS),
/* harmony export */   "iX": () => (/* binding */ getJSONByUrl),
/* harmony export */   "mr": () => (/* binding */ getChannel),
/* harmony export */   "qW": () => (/* binding */ isWeiXin),
/* harmony export */   "tq": () => (/* binding */ isMobile)
/* harmony export */ });
/* unused harmony exports loadScript, is, isNumber, getCookies, getClientInfo */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1880);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81167);


const getSessionStorage = (key)=>{
    return window.sessionStorage.getItem(key) && decodeURIComponent(window.sessionStorage.getItem(key));
};
const getChannel = ()=>{
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(window.location.search);
    return params.channel && decodeURIComponent(params.channel) || getSessionStorage("channel") || "";
};
/**
 * 动态创建script标签
 * @param url
 * @param callback
 */ const loadScript = (url, callback)=>{
    const eleScript = document.createElement("script");
    eleScript.type = "text/javascript";
    eleScript.src = url;
    document.getElementsByTagName("head")[0].appendChild(eleScript);
    if (eleScript.readyState) {
        eleScript.onreadystatechange = function() {
            if (eleScript.readyState === "loaded" || eleScript.readyState === "complete") {
                eleScript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        eleScript.onload = function() {
            callback();
        };
    }
};
const getMatrixChannel = ()=>{
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parse */ .Z.parse(window.location.search);
    return params.matrix_channel || window.sessionStorage.getItem("matrix_channel") || _constants__WEBPACK_IMPORTED_MODULE_0__/* .MATRIX_CHANNEL */ .cr;
};
const is = (val, type)=>{
    return toString.call(val) === "[object ".concat(type, "]");
};
const isNumber = (val)=>{
    return is(val, "Number");
};
function getCookies(cookies) {
    try {
        if (!cookies) return {};
        const list = cookies.split(";");
        const params = {};
        for(let i = 0; i < list.length; i++){
            const [key, value] = list[i].split("=");
            params[key.trim()] = decodeURIComponent(value);
        }
        return params;
    } catch (e) {
        ;
        return {};
    }
}
const isMobile = ()=>{
    if (false) {}
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const sleep = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
// 判断gpt_content 是否为json字符串
const isJsonStr = (str)=>{
    if (typeof str === "string") {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
    return false;
};
const isSafari = ()=>{
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
// 判断是否来自华为PC预装定制版内嵌
const isFromHuaweiCustom = ()=>{
    if (false) {}
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes("channel:zhyshop");
};
let supportWebp = undefined;
const isSupportWebp = ()=>{
    if (false) {}
    if (supportWebp === void 0) {
        supportWebp = document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }
    return supportWebp;
};
const thumbnail = function(url, width) {
    let quality = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 80;
    var ref, ref1, ref2;
    if (/\.svg$/.test(url) || /\.(webp)$/.test(url)) return url;
    const params = query_string__WEBPACK_IMPORTED_MODULE_1__/* ["default"].parseUrl */ .Z.parseUrl(url);
    // imageView2 加上这个后，会导致不校验 token
    // 暂时不处理 token 地址
    if (params === null || params === void 0 ? void 0 : (ref = params.query) === null || ref === void 0 ? void 0 : ref.token) return url;
    // 加签参数需要保留
    const signString = (params === null || params === void 0 ? void 0 : (ref1 = params.query) === null || ref1 === void 0 ? void 0 : ref1.k) && (params === null || params === void 0 ? void 0 : (ref2 = params.query) === null || ref2 === void 0 ? void 0 : ref2.t) ? "&k=".concat(params.query.k, "&t=").concat(params.query.t) : "";
    // 分割参数，转 webp 将会被丢弃
    const uri = url.split("?");
    // 分割缩略图 https://material-center-pre.meitudata.com/material/image/6462f5d0f05f84631.png!thumb-w240
    const realUrl = uri[0].split("!");
    const currentUrl = "".concat(realUrl[0], "?imageView2/2").concat(width ? "/w/" + width : "");
    if (isSupportWebp()) {
        return "".concat(currentUrl, "/format/webp/q/").concat(quality, "/ignore-error/1").concat(signString);
    }
    return "".concat(currentUrl, "/q/").concat(quality, "/ignore-error/1").concat(signString);
};
const isAndroid = ()=>{
    if (false) {}
    return /Android/i.test(navigator.userAgent);
};
const isQQ = ()=>{
    if (false) {}
    return /QQ/i.test(navigator.userAgent);
};
const isWeiXin = ()=>{
    if (false) {}
    // 微信浏览器 或者 企业微信浏览器
    return /MicroMessenger/i.test(navigator.userAgent) || /wxwork/i.test(navigator.userAgent);
};
const workerScript = "\n    onmessage = function(event) {\n        const { timeout } = event.data;\n\n        setTimeout(() => {\n            postMessage('done');\n        }, timeout);\n    };\n";
const workerSleep = function() {
    let timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
    return new Promise((resolve)=>{
        const blob = new Blob([
            workerScript
        ], {
            type: "application/javascript"
        });
        const worker = new Worker(URL.createObjectURL(blob));
        worker.onmessage = function() {
            resolve();
            worker.terminate(); // 结束工作者线程
        };
        worker.postMessage({
            timeout
        });
    });
};
const getJSONByUrl = async (url)=>{
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "json";
        xhr.onload = ()=>{
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error("请求失败，状态码：".concat(xhr.status)));
            }
        };
        xhr.onerror = ()=>{
            reject(new Error("网络错误"));
        };
        xhr.send();
    });
};
const isIOS = ()=>{
    if (false) {}
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
const filterParams = (params)=>{
    let paramsStr = "?";
    for(const key in params){
        paramsStr += "".concat(key, "=").concat(key === "tool_url" ? encodeURIComponent(params[key]) : params[key], "&");
    }
    return paramsStr.slice(0, -1);
};
let clientInfo = undefined;
const getClientInfo = async ()=>{
    if (!clientInfo && "object" !== "undefined") {
        clientInfo = await __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23)).then((res)=>res.clientInfo);
    }
    return clientInfo;
};
const isPcPlatform = async ()=>{
    if (!clientInfo && "object" !== "undefined") {
        clientInfo = await getClientInfo();
    }
    if (clientInfo === null || clientInfo === void 0 ? void 0 : clientInfo.isClient) {
        return true;
    }
    return false;
};
const getOsType = async ()=>{
    let osType = "web";
    if ((await getClientInfo()).isClient) {
        osType = (await getClientInfo()).isMac ? "macos" : "windows";
    }
    return osType;
};
const getSource = async ()=>{
    const clientInfo = await getClientInfo();
    let source = "";
    if (clientInfo.isMac || clientInfo.isMacAppStore) {
        source = "MTXX-MAC";
    } else if (clientInfo.isPC) {
        source = "MTXX-PC";
    } else if (clientInfo.isLinux) {
        source = "MTXX-LINUX";
    } else {
        source = "MTXX-WEB";
    }
    return source;
};


/***/ }),

/***/ 32711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SF": () => (/* binding */ statTrack),
/* harmony export */   "hP": () => (/* binding */ getOperateSource),
/* harmony export */   "jt": () => (/* binding */ initMtstat),
/* harmony export */   "xT": () => (/* binding */ setUserCommonParams)
/* harmony export */ });
/* unused harmony export getParameterValue */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1880);
/* harmony import */ var _gid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83353);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10275);
/* harmony import */ var _meitu_xdesign_widgets_dist_overseasAccessModal_jumpQuery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30106);
/* harmony import */ var _meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46718);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3269);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25344);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82345);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40313);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31955);










const getParameterValue = (inputString, key)=>{
    // 构造正则表达式，匹配 "key=值" 的模式
    const regex = new RegExp("".concat(key, "=([^&]*)"));
    // 使用正则表达式查找匹配项
    const match = inputString.match(regex);
    // 如果匹配成功，返回匹配的值，否则返回 null
    return match ? decodeURIComponent(match[1]) : "";
};
const initMtstat = async (callback)=>{
    const sdkAppId = (0,_sdk__WEBPACK_IMPORTED_MODULE_4__/* .checkIsInSdk */ .X)() ? _sdk__WEBPACK_IMPORTED_MODULE_4__/* .getAppId */ .r : ()=>Promise.resolve({
            app_id: ""
        });
    Promise.all([
        (0,_gid__WEBPACK_IMPORTED_MODULE_1__/* .waitUntilGetGid */ .S)(),
        sdkAppId()
    ]).then(async (param)=>{
        let [wgid, { app_id  }] = param;
        var ref;
        ;
        // 团队id
        const oid = String(((ref = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_2__/* .getLocalIdentity */ .u5)()) === null || ref === void 0 ? void 0 : ref.oid) || "");
        const query = (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)();
        const tool_url = decodeURIComponent(decodeURIComponent(query.tool_url || ""));
        const is = await __webpack_require__.e(/* import() */ 3074).then(__webpack_require__.bind(__webpack_require__, 33074));
        if (app_id) {
            if (_constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SDK_PLATFORM */ .gV[app_id]) {
                if (true) {
                    window._appId = app_id;
                }
            }
        }
        const mtxxWebGid = js_cookie__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("mtxx_web_gid".concat( false ? 0 :  false ? 0 : ""));
        const jumpQuery = (0,_meitu_xdesign_widgets_dist_overseasAccessModal_jumpQuery__WEBPACK_IMPORTED_MODULE_8__/* .getJumpQuery */ .H)();
        // 埋点信息配置
        const statConfig = {
            appKey: (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getAppKey */ .AJ)(),
            env:  true ? "release" : 0,
            moduleId: _constants__WEBPACK_IMPORTED_MODULE_0__/* .MODULE_ID */ .ce,
            app_id: app_id,
            is_sdk: query.origin === _constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SdkModuleName.aippt */ .sB.aippt && (0,_sdk__WEBPACK_IMPORTED_MODULE_4__/* .checkIsInSdk */ .X)() ? query.origin : "",
            company_key: _constants_workbench__WEBPACK_IMPORTED_MODULE_5__/* .SDK_PLATFORM */ .gV[app_id] || query.platform || "",
            channel: query.hb_position || query.hb_operation ? "app" : query.channel && decodeURIComponent(query.channel) || window.sessionStorage.getItem("channel") || "",
            hb_position: (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)().hb_position || getParameterValue(tool_url, "hb_position") || "",
            hb_operation: (0,_query__WEBPACK_IMPORTED_MODULE_7__/* .getQuery */ .pm)().hb_operation || getParameterValue(tool_url, "hb_operation") || "",
            indtool_source: query.indtool_source || "",
            operate_source: await getOperateSource(),
            from_app: is.isMobile && is.isXiuXiu ? "mtxx_app" : is.isMobile && is.isPoster ? "mtsjs_app" : "browser",
            funcEnter: "",
            abTestKey: "",
            sdkModuleName: "",
            customizedStatsMarker: false,
            oid,
            user_mode: (0,_meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__/* .getEnterpriseID */ .DG)() ? "1" : "",
            enterprise_id: (0,_meitu_xdesign_widgets_dist_teamExports__WEBPACK_IMPORTED_MODULE_9__/* .getEnterpriseID */ .DG)() || "",
            mtxx_web_gid: mtxxWebGid || "",
            initAbTest: ()=>{
                callback === null || callback === void 0 ? void 0 : callback();
            },
            successCallback: ()=>{
                _store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getActions */ .ZP.getActions().setFinishTrack(true);
            },
            ...jumpQuery
        };
        if (is.isMobile && (is.isXiuXiu || is.isPoster)) {
            try {
                const hogger = await Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(2991)]).then(__webpack_require__.bind(__webpack_require__, 50228));
                const [appInfo] = await hogger.getAppInfo();
                statConfig.gid = appInfo.gid;
            } catch (e) {
                ;
            }
        }
        // 实例化埋点
        __webpack_require__.e(/* import() */ 9741).then(__webpack_require__.bind(__webpack_require__, 59741)).then((res)=>{
            new res.SaasMTStat(statConfig);
        });
    });
};
const getOperateSource = async ()=>{
    const is = await __webpack_require__.e(/* import() */ 3074).then(__webpack_require__.bind(__webpack_require__, 33074));
    if (is.isMobile) return "h5";
    const clientInfo = await __webpack_require__.e(/* import() */ 1022).then(__webpack_require__.t.bind(__webpack_require__, 21022, 23)).then((res)=>res.clientInfo);
    let operate_source = "web";
    if (clientInfo.isClient) {
        operate_source = clientInfo.isMac ? "macos" : "windows";
    }
    return operate_source;
};
/**
 * 埋点上报函数
 * @param eventName 事件名
 * @param args 参数
 */ function statTrack(eventName, args) {
    if (!window._stat_track) {
        if (!window.__stat_stack) {
            window.__stat_stack = [];
        }
        window.__stat_stack.push({
            name: eventName,
            options: args
        });
    } else {
        var ref;
        (ref = window._stat_track) === null || ref === void 0 ? void 0 : ref.call(window, eventName, args);
    }
}
/**
 * 设置用户公共参数
 * @param userInfo
 */ const setUserCommonParams = (param)=>{
    let { isVip , availableAmount  } = param;
    var // 1）user_type（用户vip类型）：0非会员，1svip，2未登陆
    // 2) residual_meidou：剩余美豆数，未登陆上报no_login
    ref;
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.setCommonParams({
        user_type: isVip == null ? "2" : isVip ? "1" : "0",
        residual_meidou: availableAmount == null ? "no_login" : String(availableAmount)
    });
};


/***/ }),

/***/ 3269:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": () => (/* binding */ appendQueryParams),
/* harmony export */   "Ow": () => (/* binding */ deleteQueryParams),
/* harmony export */   "pm": () => (/* binding */ getQuery)
/* harmony export */ });
/* unused harmony exports stringifyQuery, parseQueryString, getQueryParam */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);

/**
 * 获取地址参数对象
 * @return
 */ const getQuery = ()=>{
    if (false) {}
    return parseQueryString(window.location.search);
};
function stringifyQuery(params) {
    let sort = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return qs.stringify(params, sort ? {
        sort: (a, b)=>a.localeCompare(b)
    } : undefined);
}
function parseQueryString(query) {
    // Remove any leading '?' from the query string
    if (query.startsWith("?")) {
        query = query.slice(1);
    }
    return qs__WEBPACK_IMPORTED_MODULE_0___default().parse(query);
}
/**
 * 获取指定的参数
 * @param key
 * @param defaultValue
 * @param query
 * @return
 */ const getQueryParam = (key, defaultValue, query)=>{
    const q = query || getQuery();
    return q[key] || defaultValue;
};
const appendQueryParams = function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const url = new URL(window.location.href);
    Object.entries(params).forEach((param)=>{
        let [key, value] = param;
        if (value !== undefined && value !== null) {
            url.searchParams.set(key, value);
        }
    });
    const newUrl = url.toString();
    window.history.replaceState({}, "", newUrl);
};
const deleteQueryParams = (keys)=>{
    const url = new URL(window.location.href);
    const keyList = Array.isArray(keys) ? keys : [
        keys
    ];
    keyList.forEach((key)=>{
        url.searchParams.delete(key);
    });
    const newUrl = url.toString();
    window.history.replaceState({}, "", newUrl);
};


/***/ }),

/***/ 82345:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ checkIsInSdk),
/* harmony export */   "r": () => (/* binding */ getAppId)
/* harmony export */ });
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81167);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40313);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3269);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1880);




const checkIsInSdk = ()=>{
    var ref;
    const origin = (ref = query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].parse */ .Z.parse(window.location.search)) === null || ref === void 0 ? void 0 : ref.origin;
    return origin === _constants_workbench__WEBPACK_IMPORTED_MODULE_0__/* .SdkModuleName.aippt */ .sB.aippt && window.self !== window.top;
};
const getAppId = ()=>{
    const query = (0,_query__WEBPACK_IMPORTED_MODULE_3__/* .getQuery */ .pm)();
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                    const res = JSON.parse(xhr.responseText);
                    if (res.data && res.data.app_id !== void 0) {
                        resolve(res.data);
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            }
        };
        xhr.open("get", "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getIntranetHost */ .Cu)(), "/common/get_app_id?client_id=").concat((0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getClientID */ .kU)()), true);
        xhr.setRequestHeader("access_token", query.accessToken || "");
        xhr.send(null);
    });
};


/***/ }),

/***/ 10275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": () => (/* binding */ getRequestIdentityHeader),
/* harmony export */   "LW": () => (/* binding */ setMemoryIdentity),
/* harmony export */   "Nz": () => (/* binding */ setLocalOriginUid),
/* harmony export */   "Rw": () => (/* binding */ getIdentityFromCookie),
/* harmony export */   "Yb": () => (/* binding */ disableTeamIdentity),
/* harmony export */   "kF": () => (/* binding */ setLocalIdentity),
/* harmony export */   "lD": () => (/* binding */ enableTeamIdentity),
/* harmony export */   "lQ": () => (/* binding */ addStorageChangeListener),
/* harmony export */   "mK": () => (/* binding */ removeLocalIdentity),
/* harmony export */   "pB": () => (/* binding */ getLocalRecentIdentity),
/* harmony export */   "tK": () => (/* binding */ removeLocalRecentIdentity),
/* harmony export */   "u5": () => (/* binding */ getLocalIdentity)
/* harmony export */ });
/* unused harmony exports LOCAL_OUID_KEY, setLocalRecentIdentity */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

// 当前身份的缓存key
var LOCAL_USER_IDENTITY_KEY = "user_identity".concat(getSuffix());
// 最近登录身份的缓存key
var LOCAL_USER_IDENTITY_RECENT_KEY = "user_identity_recent".concat(getSuffix());
// origin_uid缓存key
var LOCAL_ORIGIN_UID_KEY = "origin_uid".concat(getSuffix());
// 当前身份下的uid
var LOCAL_OUID_KEY = "ouid".concat(getSuffix());
var isNode = "object" === "undefined";
// 同步历史身份缓存到cookie中
if (!isNode) {
    try {
        var oldVersionValue = window.localStorage.getItem(LOCAL_USER_IDENTITY_KEY);
        if (oldVersionValue) {
            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_KEY, oldVersionValue, {
                domain: getRootDomain(),
                expires: 36500
            });
            window.localStorage.removeItem(LOCAL_USER_IDENTITY_KEY);
        }
    } catch (e) {
        ;
    }
}
var personalIdentity = {
    oid: 0,
    groupId: 0
};
var localInit = isNode ? personalIdentity : getIdentityFromCookie();
var local_oid = (localInit === null || localInit === void 0 ? void 0 : localInit.oid) || 0;
var local_groupId = (localInit === null || localInit === void 0 ? void 0 : localInit.groupId) || 0;
var changeHandle;
if (!isNode) {
    var workerCode = '\n    self.onmessage = function(event) {\n      setInterval(() => {\n        // 向主线程发送消息\n        postMessage("");\n      }, 1000);\n    };\n  ';
    var blob = new Blob([
        workerCode
    ], {
        type: "application/javascript"
    });
    // 创建一个新的 Worker
    var worker = new Worker(URL.createObjectURL(blob));
    // 接收 Worker 发来的消息
    worker.onmessage = function() {
        var curValue = getIdentityFromCookie();
        if (curValue.oid !== local_oid && local_groupId !== curValue.groupId) {
            // 发生变化
            changeHandle === null || changeHandle === void 0 ? void 0 : changeHandle(curValue.oid, curValue.groupId);
        }
    };
    // 发送消息给 Worker，启动定时器
    worker.postMessage("");
}
var isDisableTeam = false;
/**
 * 禁用团队功能
 */ function disableTeamIdentity() {
    isDisableTeam = true;
}
/**
 * 开启团队功能
 */ function enableTeamIdentity() {
    isDisableTeam = false;
}
/**
 * 更新内存的身份信息
 * @param oid
 * @param groupId
 */ function setMemoryIdentity(oid, groupId) {
    local_oid = oid;
    local_groupId = groupId;
}
function addStorageChangeListener(cb) {
    changeHandle = cb;
}
/**
 * 获取cookie最新的身份
 * @returns
 */ function getIdentityFromCookie() {
    return JSON.parse(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_USER_IDENTITY_KEY) || "".concat(JSON.stringify(personalIdentity)));
}
/**
 * 获取缓存中的身份
 * @returns
 */ function getLocalIdentity() {
    if (isDisableTeam) return personalIdentity;
    return {
        oid: local_oid,
        groupId: local_groupId
    };
}
/**
 * 获取缓存中的最近身份信息
 * @returns
 */ function getLocalRecentIdentity() {
    var _a, _b, _c, _d;
    if (isDisableTeam) return {
        oid: 0,
        groupId: 0,
        ouid: 0,
        originUid: 0
    };
    var localStr = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_USER_IDENTITY_RECENT_KEY);
    if (!localStr) {
        return null;
    }
    var list = [];
    try {
        list = JSON.parse(localStr);
    } catch (e) {}
    return {
        oid: (_a = list[0]) === null || _a === void 0 ? void 0 : _a.oid,
        groupId: (_b = list[0]) === null || _b === void 0 ? void 0 : _b.groupId,
        ouid: (_c = list[0]) === null || _c === void 0 ? void 0 : _c.ouid,
        originUid: (_d = list[0]) === null || _d === void 0 ? void 0 : _d.originUid
    };
}
/**
 * 移除缓存
 */ function removeLocalIdentity() {
    local_oid = 0;
    local_groupId = 0;
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(LOCAL_USER_IDENTITY_KEY, {
        domain: getRootDomain()
    });
}
/**
 * 移除最近登录身份信息缓存
 */ function removeLocalRecentIdentity() {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(LOCAL_USER_IDENTITY_RECENT_KEY, {
        domain: getRootDomain()
    });
}
/**
 * 写入身份缓存
 * @param oid
 * @param groupId
 * @param shouldUpateRecent 是否需要更新最近登录身份的数据
 */ function setLocalIdentity(oid, groupId, shouldUpateRecent) {
    if (shouldUpateRecent === void 0) {
        shouldUpateRecent = true;
    }
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_KEY, JSON.stringify({
        oid: oid,
        groupId: groupId
    }), {
        domain: getRootDomain(),
        expires: 36500
    });
    if (shouldUpateRecent) {
        setLocalRecentIdentity(oid, groupId);
    }
    if (oid !== local_oid && local_groupId !== groupId) {
        // 发生变化
        changeHandle === null || changeHandle === void 0 ? void 0 : changeHandle(oid, groupId);
    }
}
/**
 * 写入最近登录身份的缓存
 * @param oid
 * @param groupId
 */ function setLocalRecentIdentity(oid, groupId) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_USER_IDENTITY_RECENT_KEY, JSON.stringify([
        {
            oid: oid,
            groupId: groupId,
            ouid: Number(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_OUID_KEY) || 0),
            originUid: Number(js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LOCAL_ORIGIN_UID_KEY) || 0)
        }
    ]), {
        domain: getRootDomain(),
        expires: 36500
    });
}
/**
 * 写入origin_uid缓存
 * @param uid
 */ function setLocalOriginUid(uid) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(LOCAL_ORIGIN_UID_KEY, String(uid), {
        domain: getRootDomain(),
        expires: 36500
    });
}
/**
 * 获取请求头部
 * @returns
 */ function getRequestIdentityHeader() {
    var _a, _b;
    return {
        "Client-OID": ((_a = getLocalIdentity()) === null || _a === void 0 ? void 0 : _a.oid) || 0,
        "Client-OGroupID": ((_b = getLocalIdentity()) === null || _b === void 0 ? void 0 : _b.oid) || 0
    };
}
/**
 * 当前地址的环境: pre/beta/release
 */ function getSuffix() {
    if (false) {}
    if (window.location.origin.includes("//localhost")) {
        return "--local";
    } else if (window.location.origin.includes("//pre")) {
        return "--pre";
    } else if (window.location.origin.includes("//beta")) {
        return "--beta";
    } else {
        return "";
    }
}
/**
 * 获取根域名
 * @returns
 */ function getRootDomain() {
    var hostname = window.location.hostname;
    // 分割域名为各个部分
    var parts = hostname.split(".").reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    var commonTlds = [
        "co",
        "com",
        "org",
        "net",
        "gov",
        "edu",
        "mil"
    ];
    // 获取根域名
    var rootDomain = parts[1] + "." + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + "." + rootDomain;
    }
    return rootDomain;
}


/***/ }),

/***/ 51811:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports basicPrefix, getPrefix */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

var basicPrefix = "mt-design-rc";
var getPrefix = function getPrefix(subPrefix) {
    return "".concat(basicPrefix, "-").concat(subPrefix);
};
var getClsWithPrefix = function getClsWithPrefix(subPrefix) {
    var prefix = getPrefix(subPrefix);
    var cls = function cls() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (args.length === 0) return prefix;
        return classnames__WEBPACK_IMPORTED_MODULE_0___default()(args.map(function(arg) {
            if (typeof arg === "string") {
                return arg === "" ? prefix : "".concat(prefix, "__").concat(arg);
            } else if (Array.isArray(arg)) {
                return arg.map(function(a) {
                    return cls(a);
                }).join(" ");
            }
            return Object.entries(arg).filter(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), _ = _ref2[0], v = _ref2[1];
                return v;
            }).map(function(_ref3) {
                var _ref4 = _slicedToArray(_ref3, 1), arg = _ref4[0];
                return arg === "" ? prefix : "".concat(prefix, "__").concat(arg);
            });
        }));
    };
    return cls;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getClsWithPrefix);


/***/ }),

/***/ 40451:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58509);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73935);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51811);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3965);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_4__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}






var subPrefix = "CommonModal";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(subPrefix);
var CommonModal = function CommonModal(_ref) {
    var _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$wrapClassName = _ref.wrapClassName, wrapClassName = _ref$wrapClassName === void 0 ? "" : _ref$wrapClassName, wrapProps = _ref.wrapProps, metaNode = _ref.metaNode, children = _ref.children, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, _ref$maskClosable = _ref.maskClosable, maskClosable = _ref$maskClosable === void 0 ? false : _ref$maskClosable, _ref$destroyOnClose = _ref.destroyOnClose, destroyOnClose = _ref$destroyOnClose === void 0 ? false : _ref$destroyOnClose, onClose = _ref.onClose, _ref$lockScroll = _ref.lockScroll, lockScroll = _ref$lockScroll === void 0 ? true : _ref$lockScroll;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (open && lockScroll) {
            (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .disableBodyScroll */ .Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return function() {
                (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .enableBodyScroll */ .tG)(document.body);
            };
        }
    }, [
        open,
        lockScroll
    ]);
    if (!open && destroyOnClose) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", _extends({}, wrapProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(cls$(), wrapClassName),
        style: _objectSpread({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            "--zindex": zIndex,
            display: open ? undefined : "none"
        }, wrapProps === null || wrapProps === void 0 ? void 0 : wrapProps.style)
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: cls$("mask"),
        onClick: function onClick(e) {
            // 阻止蒙层点击透传到后面的dom
            e.stopPropagation();
            e.preventDefault();
            if (maskClosable) onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(cls$("inner"), className)
    }, children), metaNode), document.body);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonModal);


/***/ }),

/***/ 20134:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74107);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29372);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24996);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _cls__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51811);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77477);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_5__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "key"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}








var subPrefix = "Message";
var cls$ = (0,_cls__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(subPrefix);
var defaultDuration = 3;
var MessageUI = function MessageUI(_ref) {
    var _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? defaultDuration : _ref$duration, icon = _ref.icon, content = _ref.content;
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (duration === 0) return;
        var timer = setTimeout(function() {
            setOpen(false);
        }, duration * 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        duration
    ]);
    var edgeCss = {
        padding: 0,
        height: 0,
        opacity: 0
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(rc_motion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        motionName: cls$("move"),
        visible: open,
        onAppearStart: function onAppearStart() {
            return edgeCss;
        },
        onEnterStart: function onEnterStart() {
            return edgeCss;
        },
        onLeaveActive: function onLeaveActive() {
            return edgeCss;
        }
    }, function(_ref2) {
        var style = _ref2.style, motionClassName = _ref2.className;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(cls$(), motionClassName),
            style: style
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("inner")
        }, !!icon && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("icon")
        }, icon), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
            className: cls$("content")
        }, content)));
    });
};
var MessageListWrapper = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.forwardRef(function(_, ref) {
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), _useState4 = _slicedToArray(_useState3, 2), messageList = _useState4[0], setMessageList = _useState4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useImperativeHandle)(ref, function() {
        return {
            open: function open(_ref3) {
                var _ref3$key = _ref3.key, key = _ref3$key === void 0 ? "".concat(Date.now()) : _ref3$key, cfg = _objectWithoutProperties(_ref3, _excluded);
                setMessageList((0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)([].concat(_toConsumableArray(messageList), [
                    {
                        key: key,
                        cfg: cfg
                    }
                ]), "key"));
            }
        };
    }, [
        setMessageList
    ]);
    if (!messageList.length) return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, null);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        className: cls$("list")
    }, messageList.map(function(_ref4) {
        var key = _ref4.key, _ref4$cfg = _ref4.cfg, icon = _ref4$cfg.icon, content = _ref4$cfg.content, _ref4$cfg$duration = _ref4$cfg.duration, duration = _ref4$cfg$duration === void 0 ? defaultDuration : _ref4$cfg$duration;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(MessageUI, {
            key: key,
            icon: icon,
            content: content,
            duration: duration
        });
    }));
});
var messageWrapperEl;
var commonMessage = function commonMessage(cfg) {
    if (!messageWrapperEl || !document.contains(messageWrapperEl)) {
        messageWrapperEl = document.createElement("div");
        document.body.appendChild(messageWrapperEl);
    }
    (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_3__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(MessageListWrapper, {
        ref: function ref(_ref5) {
            return _ref5 === null || _ref5 === void 0 ? void 0 : _ref5.open(cfg);
        }
    }), messageWrapperEl);
};
var getSuccessLikeFn = function getSuccessLikeFn(_ref6) {
    var defaultIconName = _ref6.defaultIconName, defaultIconColor = _ref6.defaultIconColor;
    return function(config) {
        var defaultIcon = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            name: defaultIconName,
            fontSize: 20,
            color: defaultIconColor
        });
        commonMessage(typeof config === "string" ? {
            icon: defaultIcon,
            content: config
        } : _objectSpread({
            icon: defaultIcon
        }, config));
    };
};
var message = {
    config: commonMessage,
    success: getSuccessLikeFn({
        defaultIconName: "CheckCircleFillBold",
        defaultIconColor: "var(--content-system-info-icon-success, #4FC62B)"
    }),
    info: getSuccessLikeFn({
        defaultIconName: "InfoCircleBoldFill",
        defaultIconColor: "var(--content-system-info-icon-regular, #8CC0FF)"
    }),
    error: getSuccessLikeFn({
        defaultIconName: "ExclamationMarkCircleBoldFill",
        defaultIconColor: "var(--content-system-info-icon-warning, #F74640)"
    })
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (message);


/***/ }),

/***/ 97303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ ENV_ENUM),
/* harmony export */   "ZR": () => (/* binding */ useConfig),
/* harmony export */   "iE": () => (/* binding */ getConfig),
/* harmony export */   "qK": () => (/* binding */ setConfigPartial),
/* harmony export */   "v6": () => (/* binding */ setConfig)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1798);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var ConfigUpdateEvent = "xdesign-widgets__config-update-event";
var ENV_ENUM = /*#__PURE__*/ function(ENV_ENUM) {
    ENV_ENUM["dev"] = "dev";
    ENV_ENUM["pre"] = "pre";
    ENV_ENUM["beta"] = "beta";
    ENV_ENUM["release"] = "release";
    return ENV_ENUM;
}({});
var _configState = {
    theme: "light",
    env: ENV_ENUM.release,
    client_id: "",
    gid: "",
    device_id: "",
    channel: "",
    country_code: "",
    app_key: "",
    module_id: "",
    silent_token_key: "access_token",
    lang: "zh-Hans",
    isIntl: false,
    isTeam: false,
    isCutoutGlobal: false,
    appName: "x-design",
    colorGroupCommonConfig: {
        openVipModal: lodash__WEBPACK_IMPORTED_MODULE_0__.noop,
        ifNoOnToggleBizTabProp: lodash__WEBPACK_IMPORTED_MODULE_0__.noop
    },
    loginIdentitySwitchModalConfig: {
        /** 编辑器都需要加这个提示 */ showEditorSaveTip: false
    },
    meituAccountInstance: null,
    userInfo: {
        screen_name: "",
        id: 0
    }
};
var getConfig = function getConfig() {
    return _objectSpread({}, _configState);
};
var setConfig = function setConfig(key, value) {
    _configState[key] = value;
    if (key === "env" && value === ENV_ENUM.dev) {
        _configState["env"] = ENV_ENUM.pre;
    }
    pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().publish(ConfigUpdateEvent);
};
var setConfigPartial = function setConfigPartial(params) {
    for(var key in params){
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            // @ts-ignore
            setConfig(key, params[key]);
        }
    }
};
var useConfig = function useConfig() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_configState), _useState2 = _slicedToArray(_useState, 2), ctx = _useState2[0], setCtx = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var onSub = function onSub() {
            setCtx(_objectSpread({}, _configState));
        };
        pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().subscribe(ConfigUpdateEvent, onSub);
        return function() {
            pubsub_js__WEBPACK_IMPORTED_MODULE_1___default().unsubscribe(onSub);
        };
    }, []);
    return ctx;
};
var ConfigProvider = function ConfigProvider(_ref) {
    var value = _ref.value, children = _ref.children;
    var isFirst = useRef(true);
    if (isFirst.current) {
        setConfigPartial(value);
        isFirst.current = false;
    }
    useEffect(function() {
        setConfigPartial(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ConfigProvider)));


/***/ }),

/***/ 84704:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IK": () => (/* binding */ getLocaleStore),
  "bU": () => (/* binding */ useLocale),
  "Ee": () => (/* binding */ useLocaleStore)
});

// UNUSED EXPORTS: initLocaleStore

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/en.js
/* harmony default export */ const en = ({
    "satisfaction": {
        "effectSatisfaction": "Satisfaction",
        "noWarn": "Don't show again",
        "dissatisfied": "Dissatisfied",
        "normal": "Neutral",
        "satisfied": "Satisfied",
        "placeholder": "Enter feedback (200 character limit)",
        "submitBtn": "Submit"
    },
    "userInfo": {
        "notVipTip": "X-Design Pro subscription grants access to extensive copyrighted elements and features.",
        "notLoginText": "You are not yet a member",
        "businessText": "Online consultation",
        "feedbackText": "Feedback",
        "downloadText": "Download App",
        "settingText": "Settings",
        "loginText": "Log in",
        "copyText": "Copy",
        "svipExpires": "X-Design Pro expiration date: ${0}",
        "renewalText": "Renew",
        "openText": "Subscribe",
        "tips": "Enjoy worry-free commercial use of copyrighted works during your membership period.",
        "logoutText": "Log out",
        "lightText": "Light",
        "dartText": "Dark",
        "teamExpires": "Team membership expires on: ${0}",
        "teamNotVipTitle": "Subscribe to Team Membership",
        "teamNotVipTip": "Enjoy exclusive membership benefits and team collaboration",
        "teamExpiresDays": "Your team membership expired ${0} days ago",
        "copySuccess": "Copied!",
        "notVipTipTitle": "Become a member to access all design resources and tools",
        "notVipTipSubscript": "Commercial rights covered",
        "teamVersion": "Team",
        "personalVersion": "Personal",
        "vipExpiresDays": "Your subscription expired ${0} days ago",
        "countAmount": "Cutout amount",
        "meidouAmount": "Credits",
        "owner": "Super Admin",
        "admin": "Administrator",
        "vipValidUntil": "Expires on: ${0}",
        "teamNotVipTip2": "Experience SVIP benefits and exclusive features",
        "enterpriseVersion": "Enterprise",
        "freeTeamVersion": "Free",
        "initialFreeDesc": "Become a member to access all design resources and tools",
        "initialFreeTeamDesc": "Subscribe to share team resources and tools",
        "languageSwitch": "Language",
        "pro": "Pro Plan",
        "plus": "Plus Plan",
        "renewOn": "Renew on",
        "tryProForFree": "Try Pro For Free",
        "expiresOn": "Expires on",
        "upgradeToPro": "Upgrade to Pro",
        "credit": "Credit",
        "manageSubscriptions": "Manage Subscriptions",
        "termsAndPolicies": "Terms and Policies",
        "benefitsUpgraded": "Benefits Upgraded",
        "basic": "Basic",
        "startFreeTrial": "Start Free Trial",
        "upgradeNow": "Upgrade Now"
    },
    "utils": {
        "requestErrorText": "Network error. Unable to connect to the server."
    },
    "upload": {
        "errorText": "Failed to upload",
        "cancelText": "Cancel",
        "uploadingText": "Uploading...",
        "fileText": "File",
        "picText": "Images",
        "blockText": "Upload canceled",
        "cancelUploadText": "Cancel upload",
        "maxLengthTips": "You can upload up to 20 images at the same time",
        "formatFailTips": "Upload of ${0} images failed. Currently, only images in ${1} formats are supported.",
        "formatFailTips1": "Only supports images in ${0} format for now",
        "formatFailTips2": "Upload of ${0} images failed. Currently, only images in JPG, JPEG and PNG formats are supported.",
        "sizeFailTips": "Upload of ${0} images failed. Please ensure each image is under 20 MB and no larger than 8000\xd78000 pixels.",
        "sizeFailTips1": "Please ensure each image is under 20 MB and no larger than 8000\xd78000 pixels.",
        "widthHeightFailTips": "Only supports images no larger than 8000\xd78000 pixels",
        "sizeFailTips2": "Only supports images up to ${0} MB"
    },
    "meidouInfo": {
        "emptyText": "Top up",
        "buyText": "Purchase credits plan",
        "openText": "Subscribe",
        "rechargeText": "Top up",
        "remainingText": "My credits",
        "tips1": "Prioritize expiring credits for consumption.",
        "tips2": "Your purchased credits will never expire",
        "tips3": "Including ${0} permanently-valid paid credits.",
        "tips4": "Credits will be automatically deducted with each generation.",
        "detailText": "Details",
        "whatIsMeidou": "What are credits?",
        "giftTips": "40 credits added to your account!",
        "giftTips1": "Expires at the end of today. Don’t forget to use them!",
        "genText": "Generate",
        "deductionTips": "${0} credits will be deducted for this generation. Do you want to continue?",
        "genBtnText": "Generate",
        "inadequateTips": "Insufficient credits. Please top up at least ${0} credits first.",
        "inadequateTipsForNoVip": "Insufficient credits. Subscribe for more.",
        "inadequateTipsForVip": "Insufficient credits. Top up for more.",
        "tryTimes": "Trial times ${0} /${1}",
        "meidouCountModalTitle": "Remaining credits",
        "meidouCountModalTips": "Expiring credits will be used first.",
        "meidouCountModalTips1": "About Credits",
        "meidouCountModalEmpty": "No credits. Purchase now!",
        "meidouCountModalBtn": "OK",
        "meidouCountModalPermanent": "Permanently valid",
        "meidouCountModalExpired": "Expire in ${0} day(s)",
        "creditTransactionDetails": "Credit Overview",
        "deductionTipsIntl": "Need to consume ${0} credits",
        "deductionTips2Intl": "${0} credits will be deducted for this generation. Do you want to continue?",
        "autoDeductCredits": "Automatically deduct credits",
        "generate": "Generate",
        "close": "Close",
        "creditsBalance": "Credits Balance",
        "whatAreCredits": "What are credits?",
        "usageDetail": "Usage details",
        "getMoreCredits": "Get More Credits"
    },
    "floatHelp": {
        "modalTitle": "Meitu Assistant",
        "businessTitle": "Online Consultation",
        "communityText1": "Use WeChat or Wecom to scan the QR code to join",
        "communityText2": "Join [X-Design User Group]",
        "communityText3": "As an early beta user, your feedback is crucial. Share your thoughts with us.",
        "feedbackTitle": "Feedback"
    },
    "designCreater": {
        "tab1": "Create",
        "tab2": "Upload",
        "uploadFail": "Failed to upload",
        "uploadDragTips": 'Click the "Upload" button or drag and drop here',
        "uploadBtn": "Upload",
        "uploadTips": "Tips: We recommend uploading JPG or PNG images within 20 MB.",
        "unitPxText": "Pixels",
        "unitMmText": "mm",
        "unitCmText": "cm",
        "sizeMinText": "Smaller than the required size of ${0} * ${1}",
        "sizeMaxText": "Exceeds the required size of ${0} * ${1}",
        "createBtn": "Create",
        "widthText": "W",
        "widthText1": "W",
        "heightText": "H",
        "heightText1": "H",
        "customText": "Custom",
        "uploadDragTips_v2": "Upload or drop images here",
        "uploadBtn_v2": "Upload",
        "uploadTips_v2": "JPG and PNG images within 20 MB are supported",
        "sizeMinText_v2": "Smaller than the required size of ${0} * ${1} ${2}",
        "sizeMaxText_v2": "Exceeds the required size of ${0} * ${1} ${2}",
        "canvasSize": "Canvas size",
        "canvasBackground": "Background"
    },
    "space": {
        "onlyU": "Only you",
        "anyone": "Anyone with the link",
        "viewAble": "View",
        "editAble": "Edit",
        "viewAble2": "Visit",
        "shareTitle": "Share your creation",
        "copyLink": "Copy link",
        "copied": "Copied"
    },
    "imageBatchUpload": {
        "buttonText": "Upload",
        "uploadDirText": "Upload folder >",
        "buttonDescription": "Paste or drag an image or URL here.",
        "buttonDescription1": "Batch process up to ${0} images",
        "batchButtonText": "Batch upload",
        "upperUploadLimit": "You can upload up to ${0} images",
        "errTipTitle": "Files exceed upload limits or are out of format",
        "errTipSubTitle": "Please upload ${1} images within ${0} MB.",
        "maxValueAndSize": "Only supports images with a maximum file size of ${0} MB",
        "maxWidthAndHeight": "Only supports images no larger than ${0} pixels",
        "errTipUpload": "Upload",
        "errTipConfirm": "Got it",
        "getFormatText": "Only supports images in ${0} format for now",
        "heicResolveFailed": "The HEIC image failed to load. We recommend converting it to another image format before uploading.",
        "imageUploadFailed": "Failed to upload",
        "cvDescription": "Paste image",
        "demoDesc": "Try one of these"
    },
    "logo": {
        "homeTip": "Click to navigate to the homepage",
        "toolTip": "Drag X-Design\\'s logo to the bookmarks bar for convenient access in the future."
    },
    "cutoutInfo": {
        "remainingText": "Remaining number of cutouts",
        "openText": "Subscribe",
        "rechargeText": "Top up",
        "emptyText": "Top up"
    },
    "textFontFamily": {
        "empty": "No content",
        "changeSearchWord": "Try using a different search term",
        "fontFamily": "Font",
        "searchFont": "Search font",
        "buyVipEnjoyFontFamily": "Free for commercial use",
        "currentFontFamily": "Fonts used in this template"
    },
    "infiniteScroll": {
        "loading": "Loading..."
    },
    "colorGroup": {
        "emptyText": "Empty",
        "upgradeTeamEdition": "Upgrade",
        "systemColor": "System color",
        "teamColor": "Brand color card",
        "cover": "Fill",
        "repeat": "Tiling",
        "fillingMode": "Display mode",
        "recommendedTexture": "Recommended",
        "uploadImage": "Upload",
        "replaceImage": "Replace"
    },
    "downloadBtn": {
        "downloadBtnTxt": "Download",
        "modalTitle": "Download",
        "editMoreTitle": "Advanced Editing",
        "downloadNow": "Download",
        "addTxt": "Add Text",
        "addMaterial": "Add Element",
        "eraser": "Eraser",
        "cutout": "Background Remover",
        "quality": "Image Enhancer",
        "editMore": "Photo Editor",
        "customSize": "Custom",
        "customSizeInputTips": "Enter size limit",
        "customSizeError": "Please fill in file size",
        "processing": "Processing...",
        "aicp": "AI Background Generator",
        "upscale": "Image Upscaler"
    },
    "interceptModal": {
        "title": "Allow pop-up windows for X-Design.",
        "desc": "Authorize X-Design to open multiple windows in your browser.",
        "stepTitle": "Step ${0}",
        "btnText": "Got it",
        "firstStep": "Click the blocking alert that appears in the top right of your browser",
        "secondStep": 'Click "Always allow pop-ups and redirects".',
        "thirdStep": 'Click "Done" to start using X-Design.',
        "xDesignTitle": "Allow pop-up windows for X-Design.",
        "xDesignDesc": "Authorize X-Design to open multiple windows in your browser.",
        "xDesignThirdStep": 'Click "Done" to start using X-Design.',
        "safariFirstStep": "Click the menu bar on the left > Safari, then select designkit.com.",
        "safariSecondStep": "In the pop-up window, select “Pop-ups” > “Allow” to access X-Design features smoothly."
    },
    "workListPanel": {
        "history": "Creations",
        "upload": "Upload",
        "failed": "Failed",
        "pending": "Loading...",
        "cancelText": "Cancel",
        "confirmText": "Confirm",
        "deleteText": "After deletion, the generated results will be lost. Are you sure you want to delete?",
        "generating": "Generating"
    },
    "feedbackVoting": {
        "defaultText": "Rate the result",
        "thanks": "Thanks for your feedback.",
        "modalTitle": "Feedback",
        "modalDesc": "Your feedback will help us improve our service.",
        "modalIpt": "Please describe which part you are not satisfied with",
        "iptMaxLength": "Content exceeds the limit. Please keep it under ${0} characters or contact customer service.",
        "cancel": "Close",
        "submit": "Submit",
        "other": "Other"
    },
    "newDesignCreater": {
        "title": "Create blank canvas",
        "allCategory": "All",
        "openImage": "Upload",
        "openFile": "File",
        "pleaseInputSize": "Enter the size",
        "categorySection": {
            "lookMore": "More",
            "canvasSize": {
                "create": "Create"
            }
        },
        "create": "Create",
        "commonSize": "Common size"
    },
    "psdModal": {
        "uploadTemplate": "Upload",
        "uploadFile": "Upload",
        "uploadSuccess": "Uploaded",
        "uploadFailed": "Failed to upload",
        "uploadPSD": "Upload PSD"
    },
    "userPolicy": {
        "btnTomorrow": "Not now",
        "btnVip": "Update now",
        "btnMy": "Get More Credits",
        "buyVip": "Daily trial limit reached. Go VIP for unlimited access!",
        "buyMy": "You’ve reached your trial limit. Get more credits to keep going!",
        "buyVipOrBackTomorrow": "Daily trial limit reached. Go VIP for unlimited access!",
        "backTomorrow": "Daily trial limit reached. Go VIP for unlimited access!",
        "trialLimitReached": "Trial Limit Reached"
    },
    "batchTaskList": {
        "loading": "Loading",
        "fail": "Generation failed",
        "batchEdit": "Batch edit",
        "upload": "Upload More"
    },
    "navVipEntrance": {
        "getFreePro": "Get Free Pro",
        "unlockPro": "Unlock Pro",
        "renewNow": "Renew Now",
        "upgradeToPro": "Upgrade to Pro",
        "upgradeForFree": "Upgrade for Free"
    },
    "brandSDK": {
        "bgInput": {
            "placeholder": "Describe your brand concept, industry, and style preference."
        },
        "brandCard": {
            "nameLimitTip": "Enter a name (up to 10 characters)"
        },
        "delBrandSureModal": {
            "okText": "Confirm",
            "cancelText": "Cancel",
            "title": "Delete this brand kit?",
            "message": "Applied designs will not be affected."
        },
        "brandList": {
            "createBrandText": "Add",
            "emptyText": "Empty"
        },
        "logoCard": {
            "coverCornerText1": "Cover",
            "coverCornerText2": "Main logo",
            "delSureModal": {
                "okText": "Confirm",
                "cancelText": "Cancel",
                "title": "Delete this logo?"
            },
            "nameLimitTip": "Enter a name (up to ${0} characters)",
            "replaceText": "Replace"
        },
        "colorList": {
            "countLimitTip": "Add up to ${0} color(s) to each color palette"
        },
        "colorCard": {
            "colorCountLimitTip": "Add up to ${0} color(s) to each color palette",
            "nameLimitTip": "Enter a name (up to ${0} characters)",
            "nameInputPlaceholder": "Enter a name (up to ${0} characters)",
            "colorEmptyText": "Empty"
        },
        "page": {
            "brandStandards": "Brand Kit",
            "createStandard": "Add",
            "createBrand": "Brand Kit"
        },
        "editBrand": {
            "sections": {
                "logo": "Logos",
                "colorCard": "Color systems",
                "textStyle": "Text styles",
                "template": "Templates",
                "reference": "Reference",
                "primaryColor": "Main color",
                "secondaryColor": "Secondary color"
            },
            "brandBackground": "Brand description",
            "nameLimitTip": "Enter a name (up to 10 characters)",
            "saveLastStyle": "Save changes to continue",
            "saveLastColorCard": "Save changes to continue",
            "saveLastElement": "Save changes to continue",
            "addColorCard": "Add new",
            "addStyle": "Add new",
            "addPrimaryColor": "Add main color",
            "addSecondaryColor": "Add secondary color",
            "referenceDesc": "Upload your posters and favorite reference images — X-Design will learn their style to craft unique visual assets that reflect your taste.",
            "bgInput": {
                "openBtnText": "Expand",
                "foldBtnText": "Collapse",
                "title": "Style Guide"
            },
            "addPrimaryLogo": "Add main logo"
        },
        "textCard": {
            "nameLimitTip": "Enter a name (up to ${0} characters)",
            "selectFont": "Select a font",
            "selectFontSize": "Select font size",
            "fontSizePlaceholder": "Size",
            "save": "Save",
            "fontSize": "",
            "bold": "Bold",
            "standard": "Standard",
            "italic": "Italic",
            "defaultCategoryName": "General"
        },
        "templateCard": {
            "delSureModal": {
                "title": "Delete this item?",
                "okText": "Confirm",
                "cancelText": "Cancel"
            },
            "nameLimitTip": "Enter a name (up to ${0} characters)",
            "defaultName": "Templates"
        },
        "selectBrandElementModal": {
            "brandAssets": "Brand Kit",
            "localUpload": "Upload from Device",
            "brandLogo": "Logos",
            "brandTemplate": "Templates",
            "reference": "Reference",
            "uploadImage": "Upload",
            "uploadDragTips": "Upload or drop images here",
            "uploadTips": "Upload up to ${1} JPG or PNG images (max ${0} MB each)"
        },
        "tooltip": {
            "message": "The Brand Poster feature is now live!",
            "desc": "Upload your brand posters and let AI Agent take a peek. It’ll learn your vibe and create future visuals that match your brand’s style!"
        }
    },
    "userReviews": {
        "hello": "Hi ${0},",
        "wordsOfThanks": "Thanks for being part of X-Design!",
        "desc": "Your feedback means the world to us. If you’re enjoying X-Design, we’d love it if you could leave us a review on Trustpilot — it really helps us grow and improve.",
        "leave": "Leave a Review"
    },
    "aih5DownloadBtn": {
        "signInText": "Sign in",
        "fullQualityText": "Full Quality",
        "previewText": "Preview",
        "freeText": "Free",
        "downloadText": "Download",
        "fullQualityLimitReached": "Full-quality limit reached. Please come back tomorrow.",
        "todayLimitReached": "Today's limit reached. Come back tomorrow or upgrade now."
    }
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/figma/de.js
/* harmony default export */ const de = ({
    "Tips_Adding": "Verarbeitung l\xe4uft...",
    "Tips_Loading": "Wird geladen...",
    "Tips_Creating": "Verarbeitung l\xe4uft...",
    "Tips_Downloading": "Wird heruntergeladen...",
    "Tips_Sending": "Wird gesendet...",
    "Tips_AddSuccess": "Erfolgreich hinzugef\xfcgt",
    "Tips_MakeSameError": "Kann nicht neu erstellt werden",
    "Tips_UnsupportedGradientColor": "Farbverl\xe4ufe werden nicht unterst\xfctzt",
    "Tips_CanNotAdding": "Hinzuf\xfcgen fehlgeschlagen",
    "Tips_Uninitialized": "Nachrichten konnten nicht gesendet werden",
    "Tips_UploadFailed": "Hochladen fehlgeschlagen. Versuchen es erneut.",
    "Tips_UploadMaxCountLimit": "Laden Sie bis zu ${n} ${type} Datei(en) hoch",
    "Tips_UploadMaxFileSize": "Die Datei ${file} konnte nicht hochgeladen werden. Bitte verwenden Sie eine Datei mit einer maximalen Gr\xf6\xdfe von ${n} MB.",
    "Tips_UploadImageAndVideoLimit": "Sie k\xf6nnen gleichzeitig ein Bild und ein Video hochladen.",
    "Tips_UnsupportedSvgFile": "SVG-Dateien werden nicht unterst\xfctzt",
    "Tips_UnsupportedUploadFileFormats:": "Das Format Ihrer Datei ${files} wird nicht unterst\xfctzt.",
    "Tips_CanNotAddSameFileTips": "Diese Datei ist bereits vorhanden",
    "Tips_TextMinLengthTips": "Geben Sie mindestens ${n} Zeichen ein",
    "Tips_TextMaxLengthTips": "Geben Sie bis zu ${n} Zeichen ein. Chinesische Schriftzeichen und Emojis z\xe4hlen als 2 Zeichen.",
    "Tips_AccessDenied": "Zugriff verweigert",
    "Tips_CreateFailed": "Chat-Initiierung fehlgeschlagen",
    "Tips_Error": "Ein Fehler ist aufgetreten",
    "Tips_NotFound": "Der Chat ist nicht verf\xfcgbar",
    "Tips_RequestAgentModelListError": "Die Abfrage der Agenten-Modell-Liste ist fehlgeschlagen.",
    "Desc_Ended": "Ende",
    "Button_PeopleUse_Agent": "${n} Personen verwendet",
    "Dropdown_AddToChat": "Zum Chat hinzuf\xfcgen",
    "Dropdown_AddToBrandKit": "Zum Marken-Kit hinzuf\xfcgen",
    "Dropdown_SaveAsBrandLogo": "Als Markenlogo speichern",
    "Dropdown_SaveAsBrandTemplate": "Als Markenvorlage speichern",
    "Title_Design_Agent": "Entwurf",
    "Title_MainColor": "Hauptfarbe",
    "Title_SecondaryColor": "Zweitfarbe",
    "Bitton_ViewTheBrandKit": "Klicken Sie, um das Marken-Kit anzuzeigen.",
    "Dropdown_InportImages": "Bilder importieren",
    "Desc_RunOutOfUsesForToday_Pro": "Heute keine kostenlosen Nutzungen mehr. Versuchen Sie es morgen erneut.",
    "Desc_PurchaseCompleted_Pro": "Kauf abgeschlossen",
    "Desc_ContinueDesign_Pro": "Sie k\xf6nnen jetzt mit Ihrem Entwurf fortfahren!",
    "Title_Upgrade_Pro": "Aktualisieren",
    "Desc_SubscribeToUnlock_Pro": "Abonnieren Sie, um mehr freizuschalten!",
    "Desc_RunOutOfFreeUses_Pro": "Sie haben keine kostenlosen Nutzungen mehr.",
    "Button_UnlockNow": "Abonnieren",
    "Dropdown_AddImage": "Bild hinzuf\xfcgen",
    "Dropdown_AddVideo": "Video hinzuf\xfcgen",
    "Dropdown_AddDocument": "Dokument hinzuf\xfcgen",
    "Dropdown_SupportedFormatFile": "Unterst\xfctzt Word-, Excel-, Text- und PDF-Dateien.",
    "Tips_Uninitialized_chat": "Nachrichten konnten nicht gesendet werden",
    "Title_Models_Dropdown": "Modelle",
    "Switch_Auto": "Automatisch",
    "Tab_Image": "Bild",
    "Tab_Video": "Video",
    "Desc_GeminiNanoBanana": "Schnelle, bearbeitbare und einheitliche Bilderzeugung.",
    "Desc_MidjourneyImage": "K\xfcnstlerische und einfallsreiche Bildgenerierung.",
    "Desc_Seedream": "Realistische und detaillierte Bilderzeugung.",
    "Desc_SeedEdit": "Pr\xe4zise und naturgetreue Bildbearbeitung.",
    "Desc_MidjourneyVideo": "Kreative und k\xfcnstlerische Videogenerierung.",
    "Desc_Seedance": "Realistische und ausdrucksstarke Videoerzeugung.",
    "Tips_Uninitialized_Chat": "Nachrichten konnten nicht gesendet werden",
    "Tips_NotFound_Chat": "Der Chat ist nicht verf\xfcgbar",
    "Dropdown_BrandKit_Title": "Marken-Kit",
    "Dropdown_BrandKit_Desc": "W\xe4hlen Sie einen Markenstil als Referenz f\xfcr dieses Design aus.",
    "Dropdown_NoReference_Option": "Keine Referenz verf\xfcgbar",
    "Dropdown_Example_Option": "Beispiel",
    "Action_SeeAll": "Alle ansehen",
    "Dropdown_Models_Title": "Modelle",
    "Tool_ImageBgRemover": "Bild-Hintergrundentferner",
    "Tool_AiBgGenerator": "KI-Hintergrunderzeuger",
    "Tool_ImageEnhancer": "Bildverbesserung",
    "Tool_AiObjectsRemover": "KI-Objektentferner",
    "Tool_AiImageExtender": "KI-Bilderweiterung",
    "Tool_AiLogoGenerator": "KI-Logo-Erzeuger",
    "Tool_AiModelMannequin": "KI-Model − Mannequin",
    "Tool_AiModelFlatlay": "KI-Model − Draufsicht",
    "Tool_AiImageRecolor": "KI-Bildfarbenwechsler",
    "Tool_FootwearModel": "Schuh-Model",
    "Tool_ImageUpscaler": "KI-Bildhochskalierer",
    "Tool_ImageTranslation": "Bild\xfcbersetzung",
    "Tool_BatchImageBgRemover": "Stapel-Bild-Hintergrundentferner",
    "Tool_BatchImageEnhancer": "Stapel-Bildverbesserung",
    "Tool_BatchAiObjectsRemover": "KI-Stapelentfernung von Objekten",
    "Tool_VideoEnhancer": "Videoverbesserung",
    "Tool_VideoBgRemover": "Video-Hintergrundentferner",
    "Tool_VideoWatermarkRemover": "Video-Wasserzeichenentferner",
    "Dropdown_AdvancedFeatures_Title": "Erweiterte Funktionen",
    "Dropdown_AdvancedFeatures_Conent": "Voller Zugriff auf alle KI-gest\xfctzten Tools zur Steigerung Ihrer Effizienz.",
    "Dropdown_MassiveContent_Title": "Umfangreicher Inhalt",
    "Dropdown_MassiveContent_Content": "Unbegrenzter Zugriff auf Premium-Vorlagen und eine gro\xdfe Auswahl an Plus-Stock-Assets.",
    "Dropdown_CommercialRights_Title": "Gewerbliche Schutzrechte",
    "Dropdown_CommercialRights_Content": "Nutzen Sie Ihre pers\xf6nlichen Kreationen mit Zuversicht, gest\xfctzt durch garantierten Urheberrechtsschutz.",
    "Popup_SubscribeIntl_Desc": "Nutzen Sie X-Design optimal mit Pro",
    "Popup_SubscribeIntl_Desc1": "Mehr Sch\xf6pfungen mit Credits freischalten",
    "Popup_SubscribeIntl_Detail": "Details zum Tarif und Hilfe anzeigen",
    "Popup_StripeCheckout": "Stripe-Kasse",
    "Popup_LiveSupport": "Live-Support",
    "Popup_CancelAnytime": "Jederzeit k\xfcndigen",
    "Menu_ManageSubscriptions": "Abonnements verwalten",
    "Menu_ReferralLink": "Empfehlungslink",
    "Menu_Language": "Sprache",
    "Menu_BenefitsUpgraded": "Leistungen",
    "Menu_TermsPolicies": "Bedingungen und Richtlinien",
    "Menu_AccountManagement": "Konto",
    "Title_ReferralCode": "Empfehlungscode",
    "Title_ReferralLink": "Empfehlungslink",
    "Desc_NoActiveSubscription": "Kein aktives Abo vorhanden",
    "Button_ClickToSubscibe": "Hier klicken, um zu abonnieren",
    "Title_SubscriptionCancel": "Ihr Abonnement wurde gek\xfcndigt",
    "Title_SeeYou": "Schade, dass Sie gehen \uD83D\uDE2D",
    "Desc_NextBillingDate": "Verl\xe4ngerung am",
    "Desc_EstimatedAmount": "Gesch\xe4tzte Gesamtsumme",
    "Button_CancelSubscription": "Abo k\xfcndigen",
    "Button_Cancel": "Abbrechen",
    "Button_Delete": "L\xf6schen",
    "Button_StaySubscribed": "Abo beibehalten",
    "Title_ReasonCancelling": "Bitte w\xe4hlen Sie einen Grund f\xfcr die Stornierung aus:",
    "Desc_BenefitsContinue": "Sie k\xf6nnen Ihre Mitgliedervorteile bis zum Ende des Abonnements weiterhin nutzen.",
    "Desc_GiftedCredits": "Nach Ablauf Ihres Abonnements – geschenkte Credits",
    "Desc_SeeYou": "Danke, dass Sie bei uns waren − wir bedauern, dass Sie uns verlassen.",
    "Desc_NoNoreCharges": "Ihnen wird nichts mehr berechnet, Ihre Mitgliedschaft bleibt aktiv bis",
    "Desc_MayBeRevoked": "k\xf6nnen widerrufen werden.",
    "Desc_CancelingNoRefund": "Die K\xfcndigung beinhaltet <span>keine R\xfcckerstattung</span>. Bei Fragen zur R\xfcckerstattung wenden Sie sich bitte an den Online-Kundendienst.",
    "Button_Pro": "Pro kostenlos holen",
    "Tab_Design": "Entwerfen",
    "Button_Send": "Senden",
    "Input_Describe_Workspace": "Beschreiben Sie Ihr Bild und ich werde es f\xfcr Sie kreieren",
    "Tab_AgentCase": "Agenten-Portfolio",
    "Tab_RecentCreations": "Neueste",
    "Tag_Hot": "Gerade beliebt",
    "Tag_BrandDesign": "Markendesign",
    "Tag_Logo": "Logos",
    "Tag_Posters": "Poster",
    "Tag_All": "Alle",
    "Tag_Design": "Entwurf",
    "Sidebar_Tools": "KI-Werkzeuge",
    "Sidebar_Create": "Startseite",
    "Sidebar_Batch": "Stapel-Editor",
    "Sidebar_MyDesigns": "Meine Entw\xfcrfe",
    "Sidebar_Inspire": "Inspiriere mich",
    "Sidebar_Brand": "Marken-Kit",
    "Sidebar_Unfold": "Seitenleiste \xf6ffnen",
    "Tab_Agent": "Agent",
    "Tool_AiPhotoEditor": "Bild-Editor",
    "Button_Upload": "Hochladen",
    "Tool_Designer": "Designer",
    "Button_BlankCanvas": "Erstellen",
    "Title_AiTool": "KI-Werkzeuge",
    "Tool_ImageBackgroundRemover": "KI-Hintergrundentferner",
    "Tool_AiBackgroundGenerator": "KI-Hintergrunderzeuger",
    "Tool_AiLogo": "KI-Logo-Erzeuger",
    "Tab_RecentlyCreated": "Neueste",
    "Tab_GenerateRecords": "Sch\xf6pfungen",
    "Menu_Edit": "Bearbeiten",
    "Menu_Download": "Herunterladen",
    "Menu_Delete": "L\xf6schen",
    "Sidebar_PackUp": "Seitenleiste schlie\xdfen",
    "Menu_DueToday": "T\xe4glicher Credit-Bonus",
    "Menu_DueToday_Explain": "G\xfcltig bis Ende des Tages.",
    "Menu_Else": "Sonstige Credits",
    "Menu_Else_Explain_AgentCredits": "Credits aus anderen Quellen. F\xfcr einen l\xe4ngeren Zeitraum g\xfcltig.",
    "Title_Total_AgentCredits": "Agenten-Credits insgesamt",
    "Menu_Total_Explain_AgentCredits": "Nur f\xfcr KI-Agenten, werden zuerst ausgegeben.",
    "Tips_Credit_Explain_Agent": "Was sind Agenten-Credits?",
    "Title_Total_PaidCredits": "Gekaufte Credits insgesamt",
    "Menu_Total_Explain_PaidCredits": "F\xfcr alle Funktionen und g\xfcltig f\xfcr die gesamte Dauer der Mitgliedschaft.",
    "Menu_Pro": "Abo-Credits",
    "Menu_Pro_Explain": "F\xfcr die gesamte Dauer der Mitgliedschaft g\xfcltig.",
    "Menu_Else_Explain_PaidCredits": "Credits aus anderen Quellen. G\xfcltig f\xfcr die Dauer der Mitgliedschaft.",
    "Menu_UsageDetail": "Details zur Nutzung",
    "Tips_Credit_Explain_Paid": "Was sind gekaufte Credits?",
    "Title_Total_InactiveCredits": "Inaktive Credits insgesamt",
    "Menu_Total_Explain_SuspendCredits": "Nicht verf\xfcgbar, bis Ihre Mitgliedschaft reaktiviert wurde.",
    "Button_GoPro_GetMore": "Mehr Credits holen",
    "Menu_SuspendCredits": "Inaktive Credits",
    "Menu_AgentCredits": "Agenten-Credits",
    "Menu_Credits": "Credits",
    "Tab_Invite": "Einladen",
    "Tab_Reward": "Pr\xe4mien",
    "Title_AgentCreditForRewards": "Pr\xe4mien aus Agenten-Credits:",
    "Table_Time": "Zeit",
    "Table_Invitee": "Eingeladene",
    "Table_AgentCredit": "Agenten-Credits",
    "Title_ShareWithFriends": "Mit Freunden teilen",
    "Title_ShareWithFriends_ExplainOne": '<span style="color:#616266;">Laden Sie einen Freund ein und Sie beide erhalten </span><span style="color:#2D990C;">${0} Agenten-Credits!</span>',
    "Title_ShareWithFriends_ExplainTwo": '<span style="color:#616266;">Sie k\xf6nnen bis zu </span><span style="color:#2D990C;">${0} neue Freunde einladen</span><span style="color:#616266;"> und maximal ${1} Agenten-Credits verdienen!</span>',
    "Title_InvitationLink": "Teilen Sie diesen Link mit Freunden",
    "Button_Copy": "Kopieren",
    "Title_Tips": "Tipps",
    "Title_Tips_ExplainOne": "1. Agenten-Credits k\xf6nnen nur f\xfcr den Zugriff auf KI-Agenten-Funktionen ausgegeben werden. Pr\xe4mien-Credits sind zwei Jahre lang g\xfcltig.",
    "Title_Tips_ExplainTwo": "2. Neue Freunde erhalten nach erfolgreicher Registrierung eine Belohnung. Wenn Sie Fragen haben, wenden Sie sich bitte an unser Kundendienst-Team.",
    "Title_FailedToReceiveReward": "Vorgang fehlgeschlagen",
    "Title_YouCannotUseYourOwnLink": "Eigene Links sind nicht zul\xe4ssig",
    "Title_FailedToReceiveReward_Explain": "Wenn Sie Fragen haben, wenden Sie sich bitte an unser Kundendienst-Team.",
    "Button_Ok": "Verstanden",
    "Button_Invite": "Einladen",
    "Title_AgentCredits": "+50 Agenten-Credits",
    "Title_GetRewarded": "Einladung erfolgreich!",
    "Title_GetRewarded_Explain": "Credits k\xf6nnen nur f\xfcr den Zugriff auf KI-Agenten-Funktionen ausgegeben werden und sind zwei Jahre lang g\xfcltig.",
    "Tips_Copied": "Kopiert!",
    "Menu_Total": "Gesamt",
    "Menu_Else_AgentCredits": "Sonstige Credits",
    "Input_Describe_workspace": "Beschreiben Sie Ihr Bild und ich werde es f\xfcr Sie kreieren",
    "Tool_AiBackgroundGenrator": "KI-Hintergrunderzeuger",
    "Input_Models": "Modell",
    "Button_TryItNow": "Jetzt ausprobieren",
    "\xa0Tab_RecentCreations_Agent": "Agent",
    "\xa0Tab_RecentCreations_Design": "Intelligente Werkzeuge",
    "Account_Pricing": "Preise",
    "Account_Language": "Sprache",
    "Account_Language_English": "Englisch",
    "Account_Language_Chinese": "Chinesisch",
    "Dropdown_SaveToBrandKit": "Als Markenlogo speichern",
    "Dropdown_SaveToBrandTemplate": "Als Markenvorlage speichern",
    "Tab_RecentCreations_Agent": "Agent",
    "Tab_RecentCreations_Design": "Intelligente Werkzeuge",
    "Menu_FunctionalPricing": "Agenten-Preise",
    "Title_FeaturePricing": "Agenten-Preise",
    "Tab_Category": "Kategorie",
    "Tab_TaskType": "Aufgabe",
    "Tab_Consume": "Preis (Credits)",
    "Tab_ExampleContent": "Beispiele",
    "Tips_CreditExplain_Inactive": "Was sind inaktive Credits?",
    "Title_NanoPro": "\uD83C\uDF4C\uD83C\uDF4CNano Banana Pro ist jetzt auf X-Design verf\xfcgbar.",
    "Title_Workspace": "Ihr kreativer KI-Agent f\xfcr die Markenstrategie",
    "Menu_InviteReward": "Belohnung f\xfcr eingeladene Personen",
    "Title_NoDesigns": "Noch keine Entw\xfcrfe vorhanden.",
    "Title_NoGenerations": "Noch keine Generierungen vorhanden.",
    "Desc_NoDesigns": "Ihre Entw\xfcrfe erscheinen hier.",
    "Desc_NoGenerations": "Ihre erzeugten Elemente erscheinen hier.",
    "Title_DeleteDesign": "Diesen Entwurf l\xf6schen",
    "Popup_DeleteDesign": "Dieses Muster endg\xfcltig l\xf6schen? Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
    "Title_LoginPopup": " Anmelden, um Ihre kostenlose Testversion freizuschalten.",
    "SubTitle_LoginPopup": "Noch heute mit dem Sch\xf6pfen in X-Design beginnen",
    "Button_GotIt": "Verstanden",
    "Title_Congrats": "Gl\xfcckwunsch",
    "SubTitle_BrandCreate": "Sie haben Ihr erstes Marken-Kit zusammengestellt − Zeit, sein Potenzial zu entdecken!",
    "Button_CheckUse": "Jetzt ansehen",
    "Chat_Prompt_Brand": "Werbeposter erstellen",
    "Tooltip_UseBrand": "Hier k\xf6nnen Sie Ihr Marken-Kit wechseln oder hinzuf\xfcgen!",
    "Tooltip_PosterBrand": "Antippen, um Ihr erstes Poster mit Ihrem Marken-Kit zu erstellen",
    "Popup_CreateBrand": "Marke von Grund auf erschaffen",
    "Desc_CreateBrand": "Erstellen Sie beeindruckende, originelle Logos mit unserem KI-Agenten.",
    "Popup_UploadBrand": "Eigene Markeninformation hochladen",
    "Desc_UploadBrand": "Laden Sie Ihre Marke hoch – X-Design sorgt daf\xfcr, dass alle Designs aufeinander abgestimmt sind.",
    "Title_BrandEntry": "Holen Sie sich jetzt ein ma\xdfgeschneidertes Markensystem",
    "Desc_BrandEntry": "Machen Sie unsere KI zur Ihrem Stylisten. Beantworten Sie ein paar Fragen und erhalten Sie ein komplettes Markensystem, das Ihrer Vision entspricht.",
    "Tooltip_UseBrand_Agent": "Nach der \xdcbernahme des Marken-Kits wird das Design automatisch auf das Logo, die Farbpalette und den allgemeinen Stil Bezug nehmen.",
    "Tooltip_PosterBrand_Agent": "Sie sind nun bestens auf die Gestaltung mit Ihrem Marken-Kit vorbereitet",
    "MenuItem_AiChange": "KI-Bearbeitung",
    "MenuItem_AiExpend": "KI-Erweiterung",
    "MenuItem_AiHD": "KI-Klarheit",
    "MenuItem_Eliminate": "KI-Entfernung",
    "MenuItem_SplitLayers": "Schichten teilen",
    "MenuItem_Cutout": "HG-Entferner",
    "MenuItem_ChangeText": "Text ersetzen",
    "MenuItem_AddToChat": "Zum Chat hinzuf\xfcgen",
    "MenuItem_AddToBrand": "Zum Marken-Kit hinzuf\xfcgen",
    "MenuItem_AddToBrandLogo": "Als Markenlogo speichern",
    "MenuItem_AddToBrandTemplate": "Als Markenvorlage speichern",
    "Button_ExportImage": "Bilder importieren",
    "Button_ExportMedia": "Videos importieren",
    "Placeholder_ChatInput": "Auf geht’s!",
    "Tooltip_Grab": "Handwerkzeug",
    "Placeholder_ImageFusion": "Lassen Sie mich wissen, wie die Bilder montiert werden sollen",
    "Button_ImageFusion": "Montieren",
    "Button_AiChange": "Bearbeiten",
    "Placeholder_AiChange": "Lassen Sie mich wissen, was Sie \xe4ndern m\xf6chten",
    "BatchProcessTable_ImageType": "Bildtyp",
    "BatchProcessTable_PictureRequirement": "Details zum Design",
    "BatchProcessTable_CopywritingRequirements": "Produktbeschreibung",
    "BatchProcessTable_Actions": "Aktion",
    "BatchProcessTable_AddOneRow": "Hinzuf\xfcgen",
    "EditBatchProcess_Tip": "Jegliche \xc4nderungen an den Vorgaben wirken sich auf die erzeugten Ergebnisse aus.",
    "EditBatchProcess_Start": "Mit einer Vorgabe beginnen",
    "EditBatchProcess_GenerateTip": "Laden Sie Ihre Produktbilder hoch, und die Entw\xfcrfe werden anhand der Vorgaben erstellt.",
    "Title_Request": "Chat",
    "Title_ChooseImageType": "W\xe4hlen Sie den Typ des zu erzeugenden Bildes (mehrere Optionen m\xf6glich)",
    "Text_ChatCancelStatus": "Aufgabe abgebrochen",
    "langding_more_bg_remover": "Hintergrundentferner",
    "langding_more_enhancer": "Bildverbesserung",
    "langding_more_objects_remover": "KI-Objektentferner",
    "langding_more_bg_generator": "KI-Hintergrunderzeuger",
    "Title_More1_Home": "Bildverbesserer",
    "Title_More2_Home": "KI-Objektentferner",
    "Title_More3_Home": "KI-Hintergrunderzeuger",
    "Title_More4_Home": "KI-Hintergrundentferner",
    "Title_More5_Home": "Stapel-Bildwerkzeuge",
    "Title_Home": "Ihr KI-Agent f\xfcr <span>Online-Shop-</span>Design",
    "Placeholder_Input_Home": "Beschreiben Sie Ihr Bild – ich kreiere es f\xfcr Sie.",
    "Title_Card4_Home": "Illustrationen f\xfcr Amazon",
    "Title_Card1_Home": "Bilder zur Anprobe von Kleidung und Accessoires",
    "Title_Card3_Home": "Bilder f\xfcr Produktdetailseite",
    "Title_Card2_Home": "Hintergrunderzeuger",
    "Desc_Features1_Home": "Die KI extrahiert automatisch Produktmerkmale und Stilvorlieben, um die idealen Designl\xf6sungen zu ermitteln.",
    "Desc_Features2_Home": "Geben Sie einfach einen Satz ein, und die KI generiert eine vollst\xe4ndige Sammlung von Bildern f\xfcr den Online-Shop, einschlie\xdflich des Hauptbildes, erg\xe4nzender Bilder und einer vollst\xe4ndigen Produktdetailseite.",
    "Text_Btn_Home": "Kostenlos beginnen",
    "Desc_Features3_Home": "Erstellen Sie automatisch plattformgerechtes Bildmaterial, das auf Amazon, Etsy, TEMU, eBay und andere Plattformen zugeschnitten ist, und stellen Sie sicher, dass die Bilder immer so optimiert sind, dass sie die richtige Zielgruppe ansprechen.",
    "Desc_Features4_Home": "Geben Sie einfach eine Anforderung ein, und die KI passt Sprache, Stil, Ton und kulturelle Elemente an, um lokalisierte Versionen f\xfcr jeden Zielmarkt zu erstellen.",
    "Desc_Features5_Home": "Speichern Sie Ihren Design-Workflow als wiederverwendbare Vorlage, und lassen Sie die KI automatisch Bilder f\xfcr alle Ihre SKUs stapelweise erzeugen.",
    "Desc_Features6_Home": "Ob Sie mit 10 oder 1.000 Produkten arbeiten – erstellen Sie schnell und einfach eine vollst\xe4ndige, einheitliche visuelle Suite.",
    "Title_Qualification_Home": "\xdcber 5 Millionen Online-Shop-Verk\xe4ufer vertrauen uns!",
    "Text_Btn_Qualification_Home": "Zertifikate anzeigen",
    "Title_Carousel_Home": "Weitere KI-Werkzeuge",
    "Title_Footer_Home": "Ihr KI-Agent f\xfcr Online-Shop-Design",
    "Title_Footer1_Home": "Social-Media-Konto",
    "Subtitle_Footer1_Home": "YouTube",
    "Subtitle_Footer2_Home": "X",
    "Subtitle_Footer3_Home": "Instagram",
    "Subtitle_Footer4_Home": "TikTok",
    "Title_Footer2_Home": "Hilfe und Rechtliches",
    "Subtitle_Footer5_Home": "Nutzungsbedingungen",
    "Subtitle_Footer6_Home": "Datenschutzerkl\xe4rung",
    "Copyright_Footer_Home": "Copyright ${0} Meitu, Inc.",
    "Desc_Evaluation1_Home": "Ich sch\xe4tze Designkit sehr! Die KI-Lifestyle-Bilder wirken nat\xfcrlich – gem\xfctlich und nordisch, ideal f\xfcr meinen Kerzenladen. Meine Angebote sehen hochwertig aus und die Verkaufszahlen sind gestiegen. Lohnt sich.",
    "Job_Evaluation5_Home": "TEMU-Verk\xe4ufer in Mexiko",
    "Job_Evaluation6_Home": "Amazon-Spezialist",
    "Job_Evaluation12_Home": "Filialleiter eines Multi-SKU-Amazon-Shops in Indonesien",
    "Job_Evaluation2_Home": "Inhaber eines Amazon- und Mercado Libre-Shops ",
    "Name_Evaluation12_Home": "Arif",
    "Desc_Evaluation11_Home": "Die Bilder der Lifestyle-Szenen sehen sehr nat\xfcrlich aus, fast so, als w\xe4ren sie professionell aufgenommen worden. Meine Kunden scheinen sie auch zu lieben, und ich habe tats\xe4chlich einen Anstieg meiner Umsetzungsrate festgestellt.",
    "Name_Evaluation11_Home": "Siti",
    "Job_Evaluation10_Home": "Grenz\xfcberschreitender Ladenbesitzer auf Lazada & Shopee (Indonesien)",
    "Name_Evaluation10_Home": "Nina",
    "Job_Evaluation3_Home": "DTC-Online-Shop-Designer",
    "Job_Evaluation8_Home": "Ladeninhaber eines „Walmart Outdoor Products“ in Amerika",
    "Name_Evaluation8_Home": "Jason",
    "Job_Evaluation9_Home": "Mercado Libre-Verk\xe4ufer in Argentinien",
    "Desc_Evaluation7_Home": "Die Szenen f\xfcr Tierprodukte, die die KI erzeugt, sind super-s\xfc\xdf! Die Katzen und Hunde sehen perfekt proportioniert und nat\xfcrlich aus. Au\xdferdem passen Gr\xf6\xdfe und Ma\xdfstab zu den Anforderungen der Plattform, so dass die Bilder wirklich einfach zu verwenden sind.",
    "Job_Evaluation7_Home": "Inhaber eines Mercado Libre-Gesch\xe4fts in Brasilien",
    "Desc_Evaluation8_Home": "Die Camping-Szenen f\xfcr meine Zelte sehen wirklich realistisch aus. Die Beleuchtung und die Winkel f\xfchlen sich nat\xfcrlich an, und die Proportionen stimmen genau. Ich spare so viel Zeit, wenn ich nicht alles selbst aufnehmen muss.",
    "Name_Evaluation7_Home": "Thiago",
    "Desc_Evaluation9_Home": "Das Werkzeug ist wirklich schnell, und die Bilder, die es erzeugt, k\xf6nnen im Grunde direkt auf Mercado Libre und Amazon hochgeladen werden, ohne dass weitere Anpassungen erforderlich sind.",
    "Desc_Evaluation6_Home": "Ich habe mir Sorgen gemacht, dass die KI die Stofftexturen verunstalten w\xfcrde, aber sie sehen kaum anders aus als im Original. Strickwaren sehen aus wie Strickwaren, Jeans wie Jeans. Die Bildanforderungen von Amazon werden auch erf\xfcllt. Die Einf\xfchrung neuer Produkte ist so viel schneller geworden.",
    "Name_Evaluation9_Home": "Lucas",
    "Name_Evaluation6_Home": "Emma",
    "Desc_Evaluation5_Home": "Die von der KI erzeugten Produktbilder sind wirklich genau. Die Kabell\xe4ngen und Steckertypen sind richtig, und sie entsprechen sogar dem Stil von TEMU. Das ist eine enorme Zeitersparnis im Vergleich zum Selbstfotografieren.",
    "Desc_Evaluation12_Home": "Mit nur einer Eingabeaufforderung erhalte ich sofort brauchbare Grafiken, was viel schneller ist, als auf einen Designer zu warten. Es ist wirklich super praktisch.",
    "Name_Evaluation3_Home": "Chloe",
    "Name_Evaluation1_Home": "Sofia",
    "Desc_Evaluation4_Home": "Die metallischen Texturen und strukturellen Details sind wirklich scharf – das l\xe4sst die Bilder professionell aussehen. Ich kann sie sofort verwenden, ohne sie bearbeiten zu m\xfcssen.",
    "Name_Evaluation4_Home": "Leon",
    "Desc_Evaluation10_Home": "Die Stapel-Erzeugung ist sehr praktisch. Ich kann Dutzende von Artikeln auf einmal verarbeiten, und das geht viel schneller, als alles von Hand zu machen.",
    "Name_Evaluation2_Home": "Mariana",
    "Desc_Evaluation3_Home": "Ich verkaufe Kleidung und hatte Bedenken, dass die KI die Farben oder Stoffstrukturen verf\xe4lschen k\xf6nnte. Sie hat aber hervorragende Arbeit geleistet. Die Posen der Models wirken nat\xfcrlich und die Bilder sind im Grunde genommen sofort einsatzbereit.",
    "Job_Evaluation1_Home": "SHEIN-Ladenfachkraft",
    "Name_Evaluation5_Home": "Diego",
    "Job_Evaluation11_Home": "Amazon Operations Specialist",
    "Desc_Evaluation2_Home": "Das Tool ist \xe4u\xdferst schnell und die Bilder k\xf6nnen direkt auf Mercado Libre oder Amazon hochgeladen werden. Es passt sogar Hintergr\xfcnde und Models an lokale Vorlieben an, und die Ergebnisse sehen absolut professionell aus.",
    "Job_Evaluation4_Home": "eBay-Verk\xe4ufer in Deutschland",
    "Title_Evaluation_Home": "Ihre Geschichten",
    "Title_Introduction_Home": "Hochwertiges KI-Design, das den Umsatz steigert",
    "Desc_Qualification_Home": "Zertifizierter Amazon SPN Service-Anbieter",
    "Title_Seo_Home": "KI-Produktbild- und Video-Erzeuger f\xfcr Online-Shops",
    "Desc_Seo_Home": "Mit dem KI-Agenten von Designkit k\xf6nnen Sie im Handumdrehen Produktbilder, Poster und Videos f\xfcr Amazon, TikTok und andere Online-Shops erstellen. Jetzt kostenlos mit dem Gestalten beginnen!<br>",
    "Keywords_Seo_Home": "KI-Agent f\xfcr Online-Shops, KI-Werkzeuge f\xfcr Online-Shops, KI-Produktbilderzeuger, KI-Produktvideoerzeuger, KI-Produktfoto-Editor, KI-Hintergrundentferner",
    "Title_Features1_Home": "Von einer einzelnen Anfrage zu einem kompletten Satz von Bildmaterial",
    "Title_Features2_Home": "Vollst\xe4ndig automatisierte Lokalisierung f\xfcr den weltweiten Verkauf Ihrer Produkte \xfcber mehrere Plattformen",
    "Title_Features3_Home": "Erzeugen Sie stapelweise automatisch Bilder f\xfcr mehrere SKUs und schlagen Sie Ihre Konkurrenten auf dem Markt!",
    "Title_Designkit_Home": "Designkit",
    "Tips_AboveTheFold2_Home": "Zum Erkunden scrollen",
    "Button_Export": "Herunterladen",
    "Title_Layer": "Schichten",
    "InputNumber_Opacity": "Deckkraft",
    "Buttom_Comfirm": "Best\xe4tigen",
    "Button_Share": "Teilen",
    "Tip_ModalTitle": "Erinnerung",
    "TipContent_HistoryDelete": "Nach dem L\xf6schen kann dieser Datensatz nicht wiederhergestellt werden. Wirklich l\xf6schen?",
    "Title_Logo": "Logo",
    "Title_BrandKit": "Vorlagen",
    "Tab_BrandKit": "Marken-Kit",
    "Tab_UploadLocal": "Aus Album ausw\xe4hlen",
    "Button_UploadImage": "Bilder hochladen",
    "Tip_ClickDragParseImage": "Hier k\xf6nnen Sie Bilder hochladen, ablegen oder einf\xfcgen.",
    "Tooltip_SwitchBrandKit": "Marken-Kit wechseln",
    "Discribe_BrandKitSelect": "W\xe4hlen Sie einen Markenstil als Referenz f\xfcr dieses Design aus.",
    "Title_Models": "Modelle",
    "MenuItem_Crop": "Bildgr\xf6\xdfe",
    "Tooltip_Layer": "Schichten",
    "Tooltip_Select": "Ausw\xe4hlen",
    "Tooltip_Redo": "Wiederherstellen",
    "Tooltip_Undo": "R\xfcckg\xe4ngig machen",
    "Tooltip_Add": "Hinzuf\xfcgen",
    "Tooltip_ShowAll": "Alle anzeigen",
    "Tip_UploadType": "Nicht unterst\xfctztes Dateiformat",
    "Tip_UploadSize": "Es werden nur Dateien bis zu ${0} MB unterst\xfctzt",
    "Tip_UploadWH": "Vergewissern Sie sich, dass jedes Bild nicht gr\xf6\xdfer als ${0}\xd7${1} Pixel ist.",
    "Tip_UploadTypeTranslate": "Dateiformat konnte nicht ge\xe4ndert werden",
    "Tip_UploadFail": "Hochladen fehlgeschlagen",
    "Tooltip_AddText": "Text hinzuf\xfcgen",
    "Text_AddDefault": "Dies ist ein Beispieltext.",
    "Tooltip_OverflowImageSize": "Bitte \xe4ndern Sie die Gr\xf6\xdfe Ihres Bildes auf maximal ${0} Pixel",
    "Button_Eliminate": "Radierer",
    "Label_OriginSize": "Original",
    "Label_CropRadio": "Bildformat",
    "Button_Free": "Gratis",
    "Button_Origin": "Original",
    "Button_Crop": "Zuschneiden",
    "Placeholder_ChangeText": "Text eingeben. Beispiel: Hallo",
    "Button_ChangeText": "Best\xe4tigen",
    "InputNumber_PanSize": "Pinselgr\xf6\xdfe",
    "Label_TargetSize": "Ziel",
    "Tooltip_ImageFusion": "Sie k\xf6nnen ${0}bis ${1} Bilder montieren",
    "Button_ClearSelection": "Auswahl aufheben",
    "Button_Confirm": "Best\xe4tigen",
    "Message_Processing": "Verarbeitung l\xe4uft...",
    "Title_Opacity": "Deckkraft",
    "Button_ExpandImage": "Erweiterung",
    "Button_ExpandRadio": "Bildformat",
    "Message_SaveFail": "Speichern fehlgeschlagen",
    "Title_Pricing": "W\xe4hlen Sie den richtigen Tarif f\xfcr Sie",
    "Title_Tags1_Pricing": "Monatlich",
    "Title_Tags2_Pricing": "J\xe4hrlich",
    "Title_Plan1_Pricing": "Gratis",
    "BatchProcessTable_Proportion": "Bildformat",
    "BatchProcessList_DeleteError": "L\xf6schen fehlgeschlagen",
    "BatchProcessList_SurePrompt": "Diese Vorgaben l\xf6schen?",
    "BatchProcessList_SurePrompt_SureText": "Best\xe4tigen",
    "BatchProcessList_SurePrompt_CancelText": "Abbrechen",
    "BatchProcessList_EmptyText": "Leer",
    "EditBatchProcess_NameLimitTip": "Geben Sie einen Namen ein (maximal 10 Zeichen)",
    "Button_Continue": "Weiter",
    "Button_EditContent": "Nachricht bearbeiten",
    "Button_BatchGenerate": "Best\xe4tigt. F\xfchren Sie die Vorlage jetzt aus.",
    "Text_ChatRespondedStatus": "Verarbeitung von Aufgaben",
    "Title_CreateBrand": "Sie haben noch keine Marke?",
    "Title_UploadBrand": "Sie haben bereits ein Logo?",
    "Button_CreateBrand": "Eine Marke erstellen",
    "Button_UnlockPro": "Profi freischalten",
    "Button_UpgradeToPro": "Upgrade auf Profi",
    "Button_RenewNow": "Jetzt erneuern",
    "Tips_Material1_Home": "Bildersatz f\xfcr die Auflistung",
    "Tips_Material2_Home": "Virtuelle Anprobe",
    "Tips_Material3_Home": "A+ Inhalt",
    "Tips_Material4_Home": "Hintergrundgenerator",
    "Free_Button_Home": "Kostenlos ausprobieren",
    "Title_Header1_Home": "Produkt",
    "Title_Header2_Home": "L\xf6sung",
    "Title_Header3_Home": "Inspiration",
    "Title_Header4_Home": "Lernen",
    "Title_Header5_Home": "Preise",
    "SecondTitle_Header1_Home": "KI-Agent f\xfcr Online-Shops",
    "SecondTitle_Header2_Home": "KI-Bildwerkzeuge",
    "SecondTitle_Header3_Home": "KI-Videowerkzeuge",
    "SecondTitle_Header4_Home": "Amazon-Designl\xf6sung",
    "SecondTitle_Header5_Home": "Online-Shop-L\xf6sung f\xfcr soziale Medien",
    "Text_Discount_Pricing": "${0} Rabatt",
    "Current_Plan_Pricing": "Aktueller Tarif",
    "Title_Instruction1_Pricing": "20 Credits f\xfcr Ihre erste Anmeldung",
    "Title_Instruction2_Pricing": "Bis zu 20 Bilder mit KI-Agent generieren",
    "Title_Instruction3_Pricing": "Bis zu 10 Bilder mit dem KI-Hintergrundgenerator erstellen",
    "Title_Rights1_Pricing": "Eingeschr\xe4nkte Entfernung von Objekten und Hintergr\xfcnden",
    "Title_Rights3_Pricing": "Eingeschr\xe4nkte HD-Bildverbesserung",
    "Title_Plan2_Pricing": "Basis-Abo",
    "Month_Plan_Pricing": "Monat",
    "Title_Button1_Pricing": "Abonnieren",
    "Title_Instruction4_Pricing": "500 Credits / Monat",
    "Title_Instruction5_Pricing": "Bis zu 500 Bilder mit KI-Agent generieren",
    "Title_Instruction6_Pricing": "Bis zu 250 Bilder mit dem KI-Hintergrundgenerator erstellen",
    "Title_Plan3_Pricing": "Profi-Abo",
    "Desc_Plan_Pricing": "7 Tage kostenlose Testversion. Danach nur ${0}/Jahr.",
    "Title_Button2_Pricing": "7 Tage kostenlose Testversion",
    "Title_Instruction7_Pricing": "1.500 Credits / Monat",
    "Title_Instruction8_Pricing": "Bis zu 1.500 Bilder mit KI-Agent generieren",
    "Title_Instruction9_Pricing": "Bis zu 750 Bilder mit dem KI-Hintergrundgenerator erstellen",
    "Title_Rights4_Pricing": "Uneingeschr\xe4nktes Entfernen von Hintergr\xfcnden oder Objekten",
    "Title_Rights5_Pricing": "Unbegrenzte Nutzung der KI-Entfernungsfunktion",
    "Title_Rights6_Pricing": "Uneingeschr\xe4nkte UHD-Bildverbesserung",
    "Title_Rights7_Pricing": "Werkzeuge zur Stapelverarbeitung",
    "Title_Best_Pricing": "Von 90 % der Nutzer bevorzugt",
    "Title_AllFeatures_Pricing": "Vergleich von kostenlosem und kostenpflichtigem Abo",
    "Desc_AllFeatures_Pricing": "Schalten Sie Premium frei, um mit fortschrittlichen KI-Werkzeugen m\xfchelos atemberaubende Designs zu gestalten.",
    "Month_AllFeatures_Pricing": "Monat",
    "Title_Features1_Pricing": "KI-Agent",
    "SubTitle_Features1_Pricing": "Bildbearbeitung",
    "SubTitle_Features15_Pricing": "Bis zu ${0} Bilder erstellen",
    "SubTitle_Features16_Pricing": "Bis zu ${0} Bilder/Monat erstellen",
    "SubTitle_Features2_Pricing": "Bilderstellung",
    "SubTitle_Features3_Pricing": "Bilderstellung f\xfcr Online-Shops",
    "SubTitle_Features4_Pricing": "Poster-Erstellung",
    "Title_Features2_Pricing": "KI-Bildwerkzeuge",
    "SubTitle_Features5_Pricing": "KI-Hintergrundentferner",
    "SubTitle_Features17_Pricing": "Eingeschr\xe4nkte Nutzung",
    "SubTitle_Features19_Pricing": "Unbegrenzte Nutzung",
    "SubTitle_Features6_Pricing": "KI-Objektentferner",
    "SubTitle_Features7_Pricing": "Bildverbesserung",
    "SubTitle_Features18_Pricing": "Eingeschr\xe4nkte Nutzung (HD)",
    "SubTitle_Features20_Pricing": "Unbegrenzte Nutzung (HD/UHD)",
    "SubTitle_Features8_Pricing": "KI-Bildhochskalierer",
    "SubTitle_Features9_Pricing": "KI-Bilderweiterung",
    "SubTitle_Features10_Pricing": "KI-Hintergrunderzeuger",
    "Title_Features3_Pricing": "Weitere Designfunktionen",
    "SubTitle_Features11_Pricing": "Erweiterte Funktionen und Vorlagen",
    "SubTitle_Features12_Pricing": "Wasserzeichen entfernen",
    "SubTitle_Features13_Pricing": "KI-Stapelbildwerkzeuge",
    "SubTitle_Features14_Pricing": "Grundlegende Designfunktionen",
    "Title_Credits_Pricing": "Sind Ihre Credits fast aufgebraucht? Kein Problem.",
    "Desc_Credits_Pricing": "Einmaliger Kauf, kein Abonnement erforderlich.",
    "TransactionPrice_Credits_Pricing": "Preis: ${0}",
    "Credit_Credits_Pricing": "Credits",
    "Popular_Credits_Pricing": "Am beliebtesten",
    "Buy_Credits_Pricing": "Jetzt kaufen",
    "Title_FAQ_Pricing": "H\xe4ufig gestellte Fragen",
    "Title_Button4_Pricing": "Jetzt Upgrade vornehmen und 7 Tage lang kostenlos testen",
    "Title_Button3_Pricing   ": "Verf\xfcgbare Vorteile",
    "SubTitle_FAQ1_Pricing": "Was sind Credits?",
    "Content_FAQ1_Pricing": "Mit Credits k\xf6nnen Sie weiterhin auf KI-Werkzeuge zugreifen. Die erforderliche Anzahl an Credits variiert je nach Werkzeug.",
    "Content_FAQ2_Pricing": "Erworbene Credits sind ein Jahr lang g\xfcltig.",
    "Content_FAQ3_Pricing": "Mitgliedschafts-Credits sind w\xe4hrend der Dauer der Mitgliedschaft g\xfcltig.",
    "SubTitle_FAQ2_Pricing": "Wie kann ich mein Abonnement k\xfcndigen, und was geschieht nach der K\xfcndigung mit meinen Credits?",
    "Content_FAQ4_Pricing": "Nach der K\xfcndigung Ihres Abonnements",
    "Content_FAQ5_Pricing": "bleiben Ihre Mitgliedschafts-Credits bis zum Ablauf Ihrer Mitgliedschaft g\xfcltig. Separat erworbene Credits sind davon nicht betroffen.",
    "Content_FAQ6_Pricing": "Sollten Sie Ihr Abonnement k\xfcndigen wollen, befolgen Sie bitte mindestens 24 Stunden vor Beginn des n\xe4chsten Abrechnungszeitraums die folgenden Schritte:",
    "Content_FAQ7_Pricing": "1. Rufen Sie Designkit auf und melden Sie sich an.",
    "Content_FAQ8_Pricing": "2. \xd6ffnen Sie das Popup-Fenster f\xfcr das Abonnement.",
    "Content_FAQ9_Pricing": "3. W\xe4hlen Sie „Abonnements verwalten”.",
    "Content_FAQ10_Pricing": "4. W\xe4hlen Sie Ihren aktuellen Tarif aus und klicken Sie auf „Abonnement k\xfcndigen”.",
    "Content_FAQ11_Pricing": "Ihr Abonnement bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv. Wenn die K\xfcndigung nicht m\xf6glich ist, machen Sie bitte einen Screenshot und kontaktieren Sie unseren Online-Kundendienst so schnell wie m\xf6glich.",
    "SubTitle_FAQ3_Pricing": "Wie ist Ihre R\xfcckerstattungsrichtlinie?",
    "Content_FAQ12_Pricing": "1. 7-Tage-Geld-zur\xfcck-Garantie:",
    "SubTitle_FAQ4_Pricing": "Wie kann ich ein Up- oder Downgrade f\xfcr mein Abonnement vornehmen?",
    "Content_FAQ25_Pricing": "1. Aktualisierung: Sie k\xf6nnen einfach einen h\xf6herwertigen Tarif abonnieren, der sofort in Kraft tritt. Ihr altes Abonnement wird gek\xfcndigt und das verbleibende Guthaben wird zur\xfcckerstattet.",
    "SubTitle_FAQ5_Pricing": "Kann ich eine Rechnung erhalten?",
    "Content_FAQ27_Pricing": "Ja! Nach einer erfolgreichen Zahlung erhalten Sie vom Zahlungsanbieter eine E-Mail mit einer elektronischen Rechnung. Sollten Sie keine Rechnung erhalten, wenden Sie sich bitte an unseren Kundendienst.",
    "SubTitle_FAQ6_Pricing": "Welche Zahlungsarten unterst\xfctzen Sie?",
    "Content_FAQ28_Pricing": "Wir nutzen Stripe, um Zahlungen und Abonnements zu verwalten. Wir akzeptieren alle g\xe4ngigen Kreditkarten, PayPal und Google Pay.",
    "SubTitle_FAQ7_Pricing": "Wie kann ich mich an den Kundendienst wenden?",
    "Content_FAQ29_Pricing": "E-Mail: support@designkit.com. Bearbeitungszeit: 3–10 Werktage.",
    "Content_FAQ13_Pricing": "Wenn Sie Abonnements erworben und diese nicht innerhalb von 7 Tagen genutzt haben, haben Sie m\xf6glicherweise Anspruch auf eine vollst\xe4ndige R\xfcckerstattung.",
    "Content_FAQ14_Pricing": "Wenn Sie Credits gekauft haben, k\xf6nnen Sie innerhalb von 7 Tagen eine R\xfcckerstattung f\xfcr nicht genutzte Credits beantragen.",
    "Content_FAQ15_Pricing": "2. Unzufriedenheit mit dem Service",
    "Content_FAQ16_Pricing": "Wenn Sie mit den Ergebnissen nicht zufrieden sind, wenden Sie sich bitte an unseren Online-Kundendienst. Je nach den Umst\xe4nden k\xf6nnen wir Ihnen eine Entsch\xe4digung oder eine R\xfcckerstattung anbieten.",
    "Content_FAQ17_Pricing": "3. Kauf \xfcber Google Play oder App Store",
    "Content_FAQ18_Pricing": "Wenn Sie ein Abonnement \xfcber den Google Play Store oder den App Store erworben haben, m\xfcssen Sie eine R\xfcckerstattung direkt bei Google oder Apple beantragen.",
    "Content_FAQ19_Pricing": "Wichtige Hinweise:",
    "Content_FAQ20_Pricing": "Diese R\xfcckerstattungsrichtlinie gilt nicht f\xfcr API-Nutzer. Wenn Sie unsere API nutzen, wenden Sie sich bitte an uns, um eine R\xfcckerstattung zu erhalten.",
    "Content_FAQ21_Pricing": "Wir behalten uns das Recht vor, R\xfcckerstattungen in F\xe4llen von Missbrauch oder Verst\xf6\xdfen gegen unsere Bedingungen zu verweigern.",
    "Content_FAQ22_Pricing": "Die Bearbeitung von R\xfcckerstattungen kann je nach Zahlungsart mehrere Werktage in Anspruch nehmen.",
    "Content_FAQ23_Pricing": "Wir k\xf6nnen diese R\xfcckerstattungsrichtlinie von Zeit zu Zeit aktualisieren. Bitte schauen Sie regelm\xe4\xdfig nach \xc4nderungen.",
    "Content_FAQ24_Pricing": "Wenn Sie weitere Hilfe ben\xf6tigen, wenden Sie sich bitte an unseren Kundendienst.",
    "Content_FAQ26_Pricing": "2. Downgrade: K\xfcndigen Sie zun\xe4chst Ihr aktuelles Abonnement. Sobald Ihr aktueller Abrechnungszeitraum endet, k\xf6nnen Sie einen neuen Tarif abonnieren.",
    "Content_Modal_Pricing": "Vielen Dank f\xfcr Ihre Unterst\xfctzung! Machen Sie sich bereit, Ihre Kreativit\xe4t auf die n\xe4chste Stufe zu bringen.",
    "Tip_Modal_Pricing": "Tipp: Laden Sie die Seite neu, wenn Ihre Mitgliedschaft noch nicht angezeigt wird.",
    "Title_Modal_Pricing": "Erfolgreich erworben",
    "Title_Rights2_Pricing": "Begrenzte Nutzung der KI-Entfernungsfunktion",
    "Title_Button3_Pricing": "Verf\xfcgbare Vorteile",
    "Title_Button5_Pricing": "Upgrade",
    "BatchProcess_SaveSuccessTip": "Ihre Workflow-Kits werden hier gespeichert.",
    "BatchProcess_createText": "Workflow-Kit",
    "Label_NormalMode": "Einfach:",
    "Label_AdvancedMode": "Erweitert:",
    "Text_NormalMode": "Einfach",
    "Text_AdvancedMode": "Erweitert",
    "BatchProcess_DefaultPrompt": "Bilder erstellen",
    "BatchProcess_EditContent": "Inhalt bearbeiten",
    "BatchProcess_PleaseSelect": "Workflow-Kit ausw\xe4hlen",
    "BatchProcess_SelectTip": "Alle hochgeladenen Bilder werden mithilfe des ausgew\xe4hlten Workflow-Kits stapelweise erstellt.",
    "BatchProcess_ListEmptyTip": "Speichern Sie das Workflow-Kit nach der Erstellung, um \xe4hnliche Sets sofort stapelweise zu erstellen.",
    "BatchProcess_Tip": "Workflow-Kit",
    "BatchProcess_Generate": "Jetzt verwenden",
    "BatchProcess_Save": "Speichern",
    "BatchProcess_GeneratingFormula": "Workflow-Kit wird erstellt...",
    "BatchProcess_GenerateCancel": "Abbrechen",
    "BatchProcess_WorkFlowCreateError": "Erstellung fehlgeschlagen",
    "ProductInfo_PleaseUploadImage": "Produktbilder hochladen",
    "BatchProcess_IntelligenceGenerate": "Workflow-Kit erstellen",
    "BatchProcess_CreateWorkflow": "Erstellen",
    "BatchProcess_Formula": "Workflow-Kit",
    "BatchProcess_WorkFlowSaveSuccess": "Workflow-Kit gespeichert",
    "ProductInfo_ImageSizeLimit": "Bilder bis zu einer Gr\xf6\xdfe von ${0} MB werden unterst\xfctzt.",
    "ProductInfo_ImageUpload": "Produktbild hinzuf\xfcgen",
    "ProductInfo_UploadDemo": "Beispielfotos",
    "ProductInfo_ECPlatform": "Plattform",
    "ProductInfo_PleaseSelect": "Bitte ausw\xe4hlen",
    "ProductInfo_InputCustomize": "Benutzerdefiniert",
    "ProductInfo_CountryAndLanguage": "Zielregion/Sprache",
    "ProductInfo_Name": "Produktname",
    "ProductInfo_Desc": "Produktdetails (Eigenschaften/Gr\xf6\xdfe/Anwendungsszenarien)",
    "ProductInfo_DescPlaceholder": "Geben Sie Produktinformationen wie Eigenschaften, Gr\xf6\xdfe, Anwendungsszenarien, Zielgruppe usw. ein.",
    "ProductInfo_NamePrompt": "Der Produktname lautet ${0};",
    "ProductInfo_ECPlatformPrompt": "Die Zielplattform ist ${0};",
    "ProductInfo_CountryAndLanguagePrompt": "Die Sprache ist ${0};",
    "ProductInfo_DescPrompt": "Die Produktdetails lauten ${0}.",
    "ProductInfo_PleaseInput": "Bitte eingeben",
    "AgentEmpty_CaseUseBtn": "Verwenden",
    "AgentEmpty_CaseRefreshBtn": "Aktualisieren",
    "MenuItem_Effect": "Effekte",
    "MenuItem_Shadow": "Schatten",
    "MenuItem_Stroke": "Konturen",
    "Button_Logout": "Abmelden",
    "Tip_UploadMax": "Laden Sie JPG-, JPEG- oder PNG-Dateien mit einer Gr\xf6\xdfe von bis zu ${0} MB hoch. Sie k\xf6nnen maximal N Bilder hochladen.",
    "Menu_ManageSubscription": "Abonnements verwalten",
    "Menu_TermsPolices": "Bedingungen und Richtlinien",
    "Title_ChangeText": "Text ersetzen",
    "Message_ExtractText": "Text wird extrahiert",
    "Message_ExtractTextError": "Text konnte nicht extrahiert werden. Versuchen Sie es erneut.",
    "Tip_CreditConsume": "Bei dieser Generierung werden ${0} Credits verwendet.",
    "BatchProcess_SaveSuccessTip_GotIt": "Verstanden",
    "BatchProcess_SaveSuccessTip_Title": "Using Workflow Kits",
    "BatchProcess_SaveSuccessTip_Desc": "Ihre Workflow-Kits werden hier gespeichert. W\xe4hlen Sie ein Kit aus, um mithilfe der gespeicherten Vorlagen schnell Bilder zu erstellen.",
    "BatchProcess_tutorial": "Anleitung",
    "Text_Model_Pricing": "Modelpreise",
    "Text_Pro_discount": "Pro-Plan: Videoproduktion zum halben Preis",
    "Dropdown_AddFromBrandkit": "Aus dem Marken-Kit hinzuf\xfcgen",
    "Button_ExportFromBrandkit": "Aus dem Marken-Kit importieren",
    "Text_TemplatePrompt": "Beginnen wir mit Inspirationen",
    "Text_Hi": "Hi, ${0}!",
    "Text_Account_Popup_Left": "Lernen Sie Ihren engagierten KI-Designassistenten f\xfcr den E-Commerce kennen. Entwickelt f\xfcr Fachleute, die schnellere Markteinf\xfchrungen, \xfcberzeugendere Pr\xe4sentationen und h\xf6here Rentabilit\xe4t anstreben.",
    "Tip_EstimatedTime": "In etwa ${0} Minuten fertig.",
    "Text_HandTool": "Handwerkzeug",
    "Text_Function": "Funktion",
    "Text_WindowsSystem": "Windows-System",
    "Text_MacSystem": "Mac-System",
    "Menu_KeyboardShortcuts": "Verkn\xfcpfungen",
    "Title_KeyboardShortcuts": "Verkn\xfcpfungen",
    "Text_Undo": "R\xfcckg\xe4ngig machen",
    "Text_MouseLeft": "Linke Maustaste",
    "Text_Redo": "Wiederherstellen",
    "Text_Delete": "L\xf6schen",
    "Text_Cut": "Ausschneiden",
    "Text_Copy": "Kopieren",
    "Text_Paste": "Einf\xfcgen",
    "Text_PasteFixed": "Paste in place",
    "Text_CreateCopy": "Eine Kopie erstellen",
    "Text_SelectAll": "Alle ausw\xe4hlen",
    "Text_SelectMultiple": "Mehrfachauswahl",
    "Text_Group": "Gruppe",
    "Text_Ungroup": "Gruppe aufl\xf6sen",
    "Text_LockLayer": "Sperren",
    "Text_Save": "Speichern",
    "Text_Move": "Bewegen",
    "Text_MoveWithCombinedKeys": "Quick move",
    "Text_NewText": "Neuer Text",
    "Text_NewLine": "Neue Linie",
    "Text_NewRectangle": "Neues Rechteck",
    "Text_NewCircle": "Neuer Kreis",
    "Text_ExitFullScreen": "Vollbildmodus beenden",
    "Text_MoveUpOneLayer": "Nach vorn legen",
    "Text_MoveDownOneLayer": "R\xfcckw\xe4rts senden",
    "Text_Top": "Nach vorn holen",
    "Text_Bottom": "Nach hinten senden",
    "Text_ToggleReferenceLine": "Hilfslinien ein-/ausblenden",
    "Text_ToggleRulerBar": "Lineale ein-/ausblenden",
    "Text_ArrowKey": "Pfeiltasten",
    "Text_CanvasShowAll": "Alle Leinw\xe4nde anzeigen",
    "Title_Unsupported_Multilayer": "Diese Funktion ist nur f\xfcr eine einzelne Ebene verf\xfcgbar.",
    "Btn_CreateBatchProcessFormula": "Erstellen",
    "Button_Hide_Otherlayers": "Erste Ebene beibehalten und fortfahren",
    "Button_Merge_Alllayers": "Alle Ebenen zusammenf\xfchren und fortfahren",
    "Checkbox_Disable_Remind": "Nicht mehr anzeigen",
    "Button_Tool": "Werkzeuge",
    "Button_Custom_Ratio": "Benutzerdefiniert",
    "Label_Spacing": "Abstand",
    "Button_Download_Whole": "Als Bild exportieren",
    "Button_Download_Layer": "Export nach Ebene",
    "Button_Origin_Ratio": "Original",
    "Text_TouchEdit_Title": "Punkt bearbeiten",
    "Text_TouchEdit_Description": "Zeigen Sie auf ein Objekt und beschreiben Sie Ihre \xc4nderungen. Das Bild wird genau nach Ihren Vorgaben bearbeitet. ",
    "Tooltip_TouchEdit_Max_Count": "Sie k\xf6nnen bis zu ${0} Bereiche markieren.",
    "Tooltip_TouchEdit_Usage": "Verkn\xfcpfung zum Bearbeiten: ${0} + Klick",
    "Text_TouchEdit_Recognition_Custom": "Benutzerdefiniert",
    "Text_TouchEdit_Recognition_Title1": "Erkennen und identifizieren",
    "Text_TouchEdit_Recognition_Title2": "Kein Ziel gefunden. Objektname eingeben.",
    "Text_TouchEdit_Name": "Punkt bearbeiten",
    "Btn_LoginToViewBatchProcess": "Anmelden, um das Workflow-Kit anzuzeigen",
    "Btn_Login": "Anmelden",
    "Menu_Main_Beautify": "Verfeinern",
    "Text_PleaseWaitImageUploaded": "Bitte fahren Sie fort, sobald der Upload abgeschlossen ist.",
    "Menu_Redeem_Rights": "Einl\xf6sen",
    "Text_Redeem_Now": "Jetzt einl\xf6sen",
    "Text_Redeem_Placeholder": "Den Einl\xf6sungscode eingeben, dabei die Gro\xdf- und Kleinschreibung beachten",
    "Text_Redeem_Success": "Die Einl\xf6sung war erfolgreich!",
    "Text_Redeem_Use": "Code einl\xf6sen",
    "Tooltip_BrandAutoUse": "Ihr neues Marken-Kit wurde erfolgreich angewendet.",
    "Redeem_Redeem_Note": "Note: \nPlease log in and enter the redemption code.\nOnce the redemption is successful, you can enjoy the corresponding benefits and services.\nPlease use the redemption code within its validity period. Expired codes will be invalidated and are non-refundable.\nPlease protect your code. We are not responsible for lost, leaked, or incorrectly used codes. \nThis code may not be resold or transferred, cannot be exchanged for cash, and is not eligible for invoicing.",
    "Sidebar_NewDesign": "Neuer Chat",
    "Text_Appeal_ReGenerate": "Bearbeitete Ergebnisse k\xf6nnen nicht \xfcberpr\xfcft werden.",
    "Modal_Button_Known": "OK",
    "MenuItem_Appeal": "Ergebnis\xfcberpr\xfcfung",
    "Text_Appeal_Left": "Attempts left this month\n<i>${0}</i>/${1}",
    "Text_Appeal_Confirm": "Ja",
    "Text_Appeal_Refunded": "Die Credits wurden Ihrem Konto gutgeschrieben.",
    "Modal_Button_GotIt": "Zustimmen",
    "Modal_Button_Later": "Sp\xe4ter",
    "Text_Vip_Open": "Abonnieren",
    "Menu_Title_Invite": "Einen Freund empfehlen",
    "Text_Button_Invite": "Credits verdienen",
    "Title_Dialog_Invite": "Einen Freund empfehlen",
    "Desc_Dialog_Invite": "Teilen Sie Ihren Link mit Freunden oder in sozialen Medien. Wenn sich ein Freund \xfcber Ihren Link anmeldet, erhalten sowohl Sie als auch Ihr Freund Credits in H\xf6he von ${0}. Wenn sie sich anmelden, erhalten Sie jeweils bis zu ${1} zus\xe4tzliche Credits.",
    "Detail_Dialog_Invite": "Details",
    "Text_Copy_Invite": "Link kopieren",
    "Title_Rewards_Invite": "Pr\xe4mien",
    "SubTitle_Rewards1_Invite": "Gesamtzahl erworbener Credits",
    "SubTitle_Rewards2_Invite": "Empfohlene kostenlose Nutzer",
    "SubTitle_Rewards3_Invite": "Empfohlene zahlende Nutzer",
    "Success_Copy_Invite": "Link kopiert",
    "Title1_Invited_Invite": "Sie wurden eingeladen!",
    "Text_Rule1_Invite": "F\xfcr jeden Freund, der sich \xfcber Ihren Link anmeldet, erhalten Sie beide <strong>${0} Credits</strong>.",
    "Text_Rule2_Invite": "Wenn Ihr Freund ein Abo abschlie\xdft, erhaltet ihr beide zus\xe4tzliche Credits (<strong>${0} f\xfcr Plus, ${1} f\xfcr Pro</strong>).",
    "Text_Rule3_Invite": "Gekaufte Abonnements k\xf6nnen nicht erstattet werden, wenn das Abo genutzt wurde oder gew\xe4hrte Credits aufgebraucht wurden. Au\xdferdem k\xf6nnen kostenlose Credits nach ihrer Verwendung nicht widerrufen werden.",
    "Text_Rule4_Invite": "Jeder Nutzer kann bis zu ${0} Freunde einladen.",
    "Text_Rule5_Invite": "F\xfcr Empfehlungen mit bestehenden Konten, Selbstempfehlungen, doppelte Konten oder betr\xfcgerische Aktivit\xe4ten werden keine Pr\xe4mien gew\xe4hrt.",
    "Text_Rule6_Invite": "${0} beh\xe4lt sich das Recht vor, das Programm anzupassen und Pr\xe4mien voerd\xe4chtiger Konten zu widerrufen.",
    "Text_Divider_Invite": "or share the link",
    "Title2_Invited_Invite": "Bei ${0} anmelden und Pr\xe4mien beanspruchen",
    "SubTitle1_Invited_Invite": "Ein Freund hat Sie eingeladen, unseren professionellen Kl-Agenten auszuprobieren. Erstellen Sie m\xfchelos hochwertige Markenmarketing-Designs wie Logos, Poster, Men\xfcs und Social-Media-Assets.",
    "SubTitle2_Invited_Invite": "<strong>Jetzt anmelden</strong> und sowohl Sie als auch Ihr Freund<strong> erhalten ${0} Credits</strong>.<strong> Bei einer Anmeldung</strong> erhalten Sie zus\xe4tzlich Credits entsprechend dem gew\xe4hlten Plan (<strong>${1} Credits bei Plus oder ${2} Credits bei Pro</strong>). Melden Sie sich jetzt an, um Ihre Pr\xe4mien zu erhalten.",
    "Button_Invited_Invite": "Melden Sie sich an, um Ihre Pr\xe4mien zu beanspruchen",
    "Success_Invited_Invite": "Sie haben sich \xfcber eine Empfehlung angemeldet und ${0} Credits erhalten.",
    "Error_Invited_Invite": "Sie haben bereits ein Konto.",
    "Text_Share_Invite": "Ich nutze ${0}, um Logos, Grafiken und Videos sehr schnell zu erstellen. Melden Sie sich \xfcber meinen Link an, und wir erhalten beide Bonus-Credits.",
    "Title_Share_Invite": "Melden Sie sich bei ${0} an und verdienen Sie gemeinsam Credits!",
    "Share_Email_Invite": "E-Mail",
    "Text_Rule7_Invite": "Sie k\xf6nnen die Credits f\xfcr KI-Agenten verwenden. Die Credits verfallen nach einem Monat. ",
    "Text_AdvanceSetting": "Experte",
    "Text_MainImage": "Hauptbild",
    "Text_ProductAgentUploadGuide1": "1. Laden Sie Fotos aus verschiedenen Blickwinkeln hoch, damit die KI Produktdetails genau erkennen und wiederherstellen kann.",
    "Text_ProductAgentUploadGuide2": "2. Sie k\xf6nnen bis zu 10 Fotos hochladen. Das erste Foto wird als Hauptbild verwendet. Wir empfehlen Ihnen, ein Foto zu w\xe4hlen, auf dem das gesamte Produkt deutlich zu sehen ist.",
    "Text_Optional": "(Optional)",
    "Tip_ClickDragImageWithSize": "Hochladen oder ablegen von JPEG-, JPG- oder PNG-Bildern bis zu ${0} MB.",
    "Button_AddReferenceImage": "Hochladen",
    "Title_ReferenceImage": "Referenzbild",
    "Input_Placeholder": "Bitte ausw\xe4hlen",
    "Radio_ReferenceColor": "Bezugsfarbe",
    "Radio_ReferenceLayout": "Referenz-Layout",
    "Tag_FirstImage": "Erstes Bild",
    "Tag_FirstImageNoPartial": "Erstes Bild teilweise",
    "Tag_Blur": "Verschwommen",
    "Tag_Jigsaw": "Collage",
    "Button_Understood": "Verstanden",
    "Text_ReferenceImageIndex": "Bild ${0} dient als Referenz",
    "Text_ReferenceDimensions": "${0} aus Referenz benutzen",
    "Tag_Cropped": "Zugeschnitten",
    "Tag_Underexposed": "Unterbelichtet",
    "Tag_Blurry": "Verschwommen",
    "SelectOption_ColorPalette": "Farbpalette",
    "SelectOption_Layout": "Layout",
    "SelectOption_Fonts": "Schriftarten",
    "SelectOption_Style": "Stil",
    "SelectOption_ShapeElements": "Form-Elemente",
    "Text_SocialMediaAgentUploadGuide": "Laden Sie zuerst Ihre Produktvorstellung hoch. Achten Sie darauf, dass das Bild klar und vollst\xe4ndig ist.",
    "Menu_Manage_Subscriptions": "Abonnements verwalten",
    "Menu_Text_Subscriptions": "Abonnements",
    "Menu_View_Subscriptions": "Abonnements anzeigen",
    "Text_Download_XdesignApp": "Bitte laden Sie die <span>X-Design</span>-App herunter, um die Funktionen nutzen zu k\xf6nnen.",
    "Text_Free_Trial": "Herunterladen f\xfcr eine 7-t\xe4gige kostenlose Testversion",
    "Text_Install_App": "App installieren",
    "Text_Scan_Download": "Scannen zum Herunterladen",
    "Text_Download_the": "Herunterladen auf",
    "Text_Available_On": "Verf\xfcgbar auf",
    "SecondTitle_Header6_Home": "AI Product Image Generator",
    "SecondTitle_Header7_Home": "AI Fashion Model Generator",
    "SecondTitle_Header8_Home": "Kleidung-Farbenwechsler",
    "SecondTitle_Header9_Home": "Product Video Generator",
    "SecondTitle_Header10_Home": "KI-Werkzeuge",
    "SecondTitle_Header11_Home": "KI-Foto-Editor",
    "SecondTitle_Header12_Home": "AI Photo Editor Online",
    "SecondTitle_Header13_Home": "Bulk Photo Editor",
    "SecondTitle_Header14_Home": "Massen-KI-Foto-Editor",
    "SecondTitle_Header15_Home": "Stapel-Bildverbesserer",
    "SecondTitle_Header16_Home": "Stapel-Wasserzeichen-Entferner",
    "SecondTitle_Header17_Home": "Massen-Hintergrunderzeuger",
    "SecondTitle_Header18_Home": "Stapel-Bild-Hintergrundentferner",
    "Title_Footer3_Home": "Designer-Werkzeuge",
    "Subtitle_Footer8_Home": "KI-Bild-Editor",
    "Subtitle_Footer7_Home": "AI Background Changer",
    "Subtitle_Footer9_Home": "Transparent Background",
    "Subtitle_Footer10_Home": "Hintergrundfarbe \xe4ndern",
    "Subtitle_Footer11_Home": "Bild-Wasserzeichenentferner",
    "Subtitle_Footer12_Home": "Text aus Bild entfernen",
    "Subtitle_Footer13_Home": "Add Stickers to Photos",
    "Subtitle_Footer14_Home": "Add Watermark to Photos",
    "Title_Footer4_Home": "Image Models",
    "Subtitle_Footer15_Home": "Nano Banana Pro (Gemini 3.0 Pro)",
    "Title_Footer5_Home": "Kostenlos herunterladen",
    "Subtitle_Footer16_Home": "iOS-APP",
    "Subtitle_Footer17_Home": "Android-APP",
    "Title_Footer6_Home": "Follow Us",
    "Subtitle_Footer18_Home": "Kling 3.0",
    "Subtitle_Footer19_Home": "Seedance 2.0",
    "Title_Footer7_Home": "Video Models",
    "Video_SR_Success": "Video clarity enhanced",
    "Video_Desubtitle_Success": "",
    "Video_Dewatermark_Success": "",
    "Video_Process_Failed": "Processing failed. The credits will be refunded to your account.",
    "Video_SR": "KI-Klarheit",
    "Video_Dewatermark": "Wasserzeichen entfernen",
    "Video_Desubtitle": "",
    "Text_TouchEditFastMode": "Quick Point to Edit",
    "Text_Pan": "Pan",
    "Title_Canvas": "Leinwand",
    "Title_Edit": "Bearbeiten",
    "Title_Elements": "Elemente",
    "Title_Tools": "Werkzeuge",
    "Text_CanvasZoom": "Zoom in/Zoom out",
    "Tooltip_Color_Fill": "Farbe",
    "Tootip_StartPoint": "Starten",
    "Tootip_ChangePoint": "Wechseln",
    "Tootip_EndPoint": "Ende",
    "Retouch_Filter_Clear": "Klarheit",
    "Retouch_Filter_Enhance": "Vivid",
    "Retouch_Filter_Dehaze": "Dunst entfernen",
    "Retouch_Filter_Texture": "Textur",
    "Retouch_Filter_Nature": "Nat\xfcrlich",
    "Retouch_Filter_Fade": "Verblassen",
    "Tooltip_Downloading": "Wird heruntergeladen...",
    "Tooltip_Download_Video": "Download videos separately, one at a time.",
    "Tooltip_Download_NoneSelected": "Please select the content you want to download",
    "Text_AI_Thinking": "AI is working on it...",
    "Text_Server_Busy": "The server is busy. Please try again later.",
    "Text_Prompt_Help_Placeholder": "Type your keywords, and I'll turn them into a ready-to-use prompt.",
    "Text_Prompt_Helping": "Verarbeitung l\xe4uft... Bitte warten.",
    "Button_Retry": "Erneut versuchen",
    "Button_Rewrite": "Versuchen Sie es erneut",
    "Button_Start_Prompt_Help": "Start writing",
    "Title_Prompt_Helper": "KI-Schreibstil",
    "Desc_ExpireDate": "L\xe4uft ab am: ",
    "DownloadApp_Title_Widgets": "Please download the ${0} app to use features",
    "DownloadApp_SubTitle_Widgets": "Download for a ${0}-day Free Trial",
    "InstallApp_Title_Widgets": "App installieren",
    "InstallApp_Desc_Widgets": "Scannen zum Herunterladen",
    "AppStore_Desc_Widgets": "Herunterladen auf",
    "GooglePlay_Desc_Widgets": "Verf\xfcgbar auf",
    "Video_Task_Price_Estimate": "${0} credits required",
    "Video_SR_Start": "Enhancing clarity... ${0} credits will be used.",
    "Video_Dewatermark_Start": "Removing watermarks... ${0} credits will be used.",
    "Video_Desubtitle_Start": "Removing subtitles... ${0} credits will be used.",
    "Text_Help_Center": "Hilfecenter"
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/figma/en.js
/* harmony default export */ const figma_en = ({
    "Tab_Design": "Design",
    "Button_Send": "Send",
    "Input_Describe_Workspace": "Describe your image and I will create it for you",
    "Tab_AgentCase": "Agent case",
    "Tab_RecentCreations": "Recents",
    "Tag_Hot": "Trending",
    "Tag_BrandDesign": "Brand Design",
    "Tag_Logo": "Logos",
    "Tag_Posters": "Posters",
    "Tab_Agent": "Agent",
    "Tool_AiPhotoEditor": "Image Editor",
    "Button_Upload": "Upload",
    "Tool_Designer": "Designer",
    "Title_AiTool": "AI Tools",
    "Tool_ImageBackgroundRemover": "AI Background Remover",
    "Tool_AiBackgroundGenerator": "AI Background Generator",
    "Tool_ImageEnhancer": "Image Enhancer",
    "Tool_AiObjectsRemover": "AI Object Remover",
    "Tool_AiModelMannequin": "AI Model - Mannequin",
    "Tool_AiModelFlatlay": "AI Model - Flatlay",
    "Tool_AiImageRecolor": "AI Image Recolor",
    "Tool_AiImageExtender": "AI Image Extender",
    "Tool_ImageUpscaler": "AI Image Upscaler",
    "Tool_AiLogo": "AI Logo Generator",
    "Button_BlankCanvas": "Create",
    "Sidebar_Create": "Home",
    "Sidebar_Tools": "AI Tools",
    "Sidebar_Batch": "Bulk Editor",
    "Sidebar_MyDesigns": "My Designs",
    "Sidebar_Inspire": "Inspire Me",
    "Sidebar_Brand": "Brand Kit",
    "Sidebar_PackUp": "Close sidebar",
    "Tag_All": "All",
    "Tag_Design": "Design",
    "Sidebar_Unfold": "Open sidebar",
    "Menu_Edit": "Edit",
    "Menu_Download": "Download",
    "Menu_Delete": "Delete",
    "Tab_RecentlyCreated": "Recents",
    "Tab_GenerateRecords": "Creations",
    "Menu_Total": "Total",
    "Menu_Total_Explain_AgentCredits": "For AI Agent only and will be used first.",
    "Menu_DueToday": "Daily bonus credits",
    "Menu_DueToday_Explain": "Valid until the end of the day.",
    "Menu_Else_AgentCredits": "Other credits",
    "Button_GoPro_GetMore": "Get more credits",
    "Menu_Total_Explain_PaidCredits": "For all features and valid through membership period.",
    "Menu_Pro": "Subscription credits",
    "Menu_Pro_Explain": "Valid through membership period.",
    "Menu_Else": "Other credits",
    "Menu_Else_Explain_PaidCredits": "Credits from other sources. Valid through membership period.",
    "Menu_Else_Explain_AgentCredits": "Credits from other sources. Valid for a longer period.",
    "Menu_UsageDetail": "Usage details",
    "Menu_Total_Explain_SuspendCredits": "Unavailable until your membership is reactivated.",
    "Tab_Invite": "Invite",
    "Menu_InviteReward": "Invite Friends Reward",
    "Tab_Reward": "Rewards",
    "Title_AgentCreditForRewards": "Agent credit rewards: ",
    "Table_Time": "Time",
    "Table_Invitee": "Invitee",
    "Title_ShareWithFriends": "Share with your friends",
    "Title_ShareWithFriends_ExplainOne": '<span style="color:#616266;">Invite a friend and both of you will receive </span><span style="color:#2D990C;">${0} Agent Credits!</span>',
    "Title_InvitationLink": "Share this link with your friends",
    "Button_Copy": "Copy",
    "Title_Tips": "Tips",
    "Title_Tips_ExplainOne": "1. Agent Credits can only be used to access AI Agent features. Reward credits are valid for two years.",
    "Title_Tips_ExplainTwo": "2. New friends will receive a reward after successful registration. If you have any questions, please contact our support team.",
    "Title_GetRewarded": "Successful invitation!",
    "Title_GetRewarded_Explain": "Credits can only be used for AI Agent features and are valid for two years.",
    "Button_Ok": "Got it",
    "Title_FailedToReceiveReward": "Operation failed",
    "Title_FailedToReceiveReward_Explain": "If you have any questions, please contact our support team.",
    "Input_Describe_workspace": "Describe your image and I will create it for you",
    "Tool_AiBackgroundGenrator": "AI Background Generator",
    "Title_YouCannotUseYourOwnLink": "Private links are not allowed",
    "Table_AgentCredit": "Agent Credits",
    "Title_ShareWithFriends_ExplainTwo": '<span style="color:#616266;">You can invite up to </span><span style="color:#2D990C;">${0} new friends</span><span style="color:#616266;"> and earn a maximum of ${1} Agent Credits!</span>',
    "Button_Invite": "Invite",
    "Menu_Title_Invite": "Refer a Friend",
    "Text_Button_Invite": "Earn Credits",
    "Title_Dialog_Invite": "Refer a Friend",
    "Desc_Dialog_Invite": "Share your link with friends or on social media. When a friend signs up via your link, both you and your friend will receive ${0} credits. If they subscribe, you will each receive up to ${1} extra credits.  ",
    "Detail_Dialog_Invite": "Details",
    "Text_Copy_Invite": "Copy link",
    "Title_Rewards_Invite": "Rewards",
    "SubTitle_Rewards1_Invite": "Total earned credits",
    "SubTitle_Rewards2_Invite": "Referred free users",
    "SubTitle_Rewards3_Invite": "Referred paid users",
    "Success_Copy_Invite": "Link copied",
    "Title1_Invited_Invite": "You've been invited!",
    "Text_Rule1_Invite": "For every friend who signs up using your link, you both earn <strong>${0} credits</strong>.",
    "Text_Rule2_Invite": "If your friend subscribes, you each get extra credits (<strong>${0} for Plus, ${1} for Pro</strong>).",
    "Text_Rule3_Invite": "Purchased subscriptions cannot be refunded if the plan has been used or any granted credits have been spent. Also, free credits cannot be revoked once used.",
    "Text_Rule4_Invite": "Each user can invite up to ${0} friends.",
    "Text_Rule5_Invite": "Rewards are not granted for referrals with existing accounts, self-referrals, duplicate accounts, or fraudulent activity.",
    "Text_Rule6_Invite": "${0} reserves the right to adjust the program and revoke rewards from abnormal accounts.",
    "Text_Divider_Invite": "or share the link",
    "Title2_Invited_Invite": "Join ${0} and claim your rewards",
    "SubTitle1_Invited_Invite": "A friend invited you to try our professional brand Al agent. Create high-quality brand marketing designs such as logos, posters, menus, and social media assets with ease. ",
    "SubTitle2_Invited_Invite": "<strong>Sign up now</strong> and both you and your friend will <strong>receive ${0} credits</strong>.<strong> If you subscribe,</strong> you will each receive additional credits based on the plan you choose (<strong>${1} credits with Plus or ${2} credits with Pro</strong>). Sign up now to claim your rewards.",
    "Button_Invited_Invite": "Sign up to claim your rewards",
    "Success_Invited_Invite": "You joined via a referral and received ${0} credits.",
    "Error_Invited_Invite": "You already have an account.",
    "Text_Share_Invite": "I’ve been using ${0} to create logos, visuals, and videos really fast. Sign up with my link and we’ll both get bonus credits.",
    "Title_Share_Invite": "Join ${0} and earn credits together!",
    "Share_Email_Invite": "Email",
    "Text_Rule7_Invite": "You can use the credits for AI Agent. Credits expire after one month. ",
    "Title_AgentCredits": "+50 Agent Credits",
    "Input_Models": "Model",
    "Button_TryItNow": "Try it now",
    "\xa0Tab_RecentCreations_Agent": "Agent",
    "\xa0Tab_RecentCreations_Design": "Smart Tools",
    "Account_Pricing": "Pricing",
    "Account_Language": "Language",
    "Account_Language_English": "English",
    "Account_Language_Chinese": "Chinese",
    "Tips_Adding": "Processing...",
    "Tips_Loading": "Loading...",
    "Tips_Creating": "Processing...",
    "Tips_Downloading": "Downloading…",
    "Tips_Sending": "Sending…",
    "Tips_AddSuccess": "Added successfully",
    "Tips_MakeSameError": "Unable to recreate",
    "Tips_UnsupportedGradientColor": "Gradients are not supported",
    "Tips_CanNotAdding": "Failed to add",
    "Tips_Uninitialized": "Failed to send messages",
    "Tips_UploadFailed": "Upload failed. Please try again.",
    "Tips_UploadMaxCountLimit": "Upload up to ${n} ${type} file(s)",
    "Tips_UploadMaxFileSize": "Unable to upload file ${file}. Please use a file up to ${n} MB.",
    "Tips_UploadImageAndVideoLimit": "You can upload 1 image and 1 video at the same time",
    "Tips_UnsupportedSvgFile": "SVG files are not supported",
    "Tips_UnsupportedUploadFileFormats:": "The format of your file ${files} is not supported",
    "Tips_CanNotAddSameFileTips": "This file already exists",
    "Tips_TextMinLengthTips": "Enter at least ${n} characters",
    "Tips_TextMaxLengthTips": "Enter up to ${n} characters. Each Chinese character or emoji counts as 2.",
    "Tips_AccessDenied": "Access denied",
    "Tips_CreateFailed": "Chat initiation failed",
    "Tips_Error": "An error occurred",
    "Tips_NotFound": "Chat does not exist",
    "Tips_RequestAgentModelListError": "Failed to request the Agent model list",
    "Desc_Ended": "End",
    "Button_PeopleUse_Agent": "${n} users tried",
    "Dropdown_AddToChat": "Add to Chat",
    "Dropdown_AddToBrandKit": "Add to Brand Kit",
    "Dropdown_SaveToBrandKit": "Save as brand logo",
    "Dropdown_SaveToBrandTemplate": "Save as brand template",
    "Title_Design_Agent": "Design",
    "Title_MainColor": "Main color",
    "Title_SecondaryColor": "Secondary color",
    "Bitton_ViewTheBrandKit": "Click to view the brand kit",
    "Dropdown_InportImages": "Import images",
    "Title_Upgrade_Pro": "Upgrade",
    "Desc_SubscribeToUnlock_Pro": "Subscribe to unlock more!",
    "Desc_RunOutOfFreeUses_Pro": "You've run out of free uses.",
    "Desc_RunOutOfUsesForToday_Pro": "You've run out of free uses for today. Come back tomorrow.",
    "Desc_PurchaseCompleted_Pro": "Purchase complete",
    "Desc_ContinueDesign_Pro": "Now you can continue your design!",
    "Button_UnlockNow": "Subscribe",
    "Tips_Copied": "Copied!",
    "Tips_Credit_Explain_Paid": "What are purchased credits?",
    "Title_Total_InactiveCredits": "Total inactive credits",
    "Title_Total_PaidCredits": "Total purchased credits",
    "Menu_SuspendCredits": "Inactive credits",
    "Menu_Credits": "Credits",
    "Tab_RecentCreations_Agent": "Agent",
    "Tab_RecentCreations_Design": "Smart Tools",
    "Menu_FunctionalPricing": "Agent Pricing",
    "Title_Total_AgentCredits": "Total - Agent credits",
    "Tips_Credit_Explain_Agent": "What are Agent credits?",
    "Title_FeaturePricing": "Agent Pricing",
    "Tab_Category": "Category",
    "Tab_TaskType": "Task",
    "Tab_Consume": "Price (Credits)",
    "Tab_ExampleContent": "Examples",
    "Tips_CreditExplain_Inactive": "What are inactive credits?",
    "langding_more_bg_remover": "Background Remover",
    "langding_more_enhancer": "Image Enhancer",
    "langding_more_objects_remover": "AI Object Remover",
    "langding_more_bg_generator": "AI Background Generator",
    "Title_More1_Home": "Image Enhancer",
    "Title_More2_Home": "AI Object Remover",
    "Title_More3_Home": "AI Background Generator",
    "Title_More4_Home": "AI Background Remover",
    "Title_More5_Home": "Batch Image Tools",
    "Title_Home": "Your <span>E-Commerce</span> Design AI Agent",
    "Placeholder_Input_Home": "Describe your image and I will create it for you.",
    "Title_Card4_Home": "Visuals for Amazon",
    "Title_Card1_Home": "Apparel & Accessory Try-on Images",
    "Title_Card3_Home": "Product Detail Page Images",
    "Title_Card2_Home": "Background Generator",
    "Desc_Features1_Home": "AI automatically extracts product features and style preferences to determine the ideal design solutions.",
    "Desc_Features2_Home": "Just enter one sentence, and the AI will generate a complete collection of e-commerce images, including the main image, supporting visuals, and a full product detail page.",
    "Text_Btn_Home": "Get Started for Free",
    "Desc_Features3_Home": "Automatically create platform-ready visuals tailored to Amazon, Etsy, TEMU, eBay, and more, ensuring images are always optimized to attract the right audience.",
    "Desc_Features4_Home": "Just enter your request, and the AI will adapt the language, style, tone, and cultural elements to produce localized versions for each target market.",
    "Desc_Features5_Home": "Save your design workflow as a reusable template, and let the AI automatically generate images for all your SKUs in bulk.",
    "Desc_Features6_Home": "Whether you’re working with 10 products or 1,000, you can quickly produce a complete, consistent visual suite with ease.",
    "Title_Qualification_Home": "Trusted by Over 5 Million E-commerce Sellers!",
    "Text_Btn_Qualification_Home": "View Certification",
    "Title_Carousel_Home": "More AI tools",
    "Title_Footer_Home": "Your E-Commerce Design AI Agent",
    "Title_Footer1_Home": "Social Media Account",
    "Subtitle_Footer1_Home": "YouTube",
    "Subtitle_Footer2_Home": "X",
    "Subtitle_Footer3_Home": "Instagram",
    "Subtitle_Footer4_Home": "TikTok",
    "Title_Footer2_Home": "Help & Legal",
    "Subtitle_Footer5_Home": "Terms of Service",
    "Subtitle_Footer6_Home": "Privacy Policy",
    "Copyright_Footer_Home": "Copyright ${0} Meitu, Inc.",
    "Desc_Evaluation1_Home": "Love Designkit! The AI lifestyle images are natural — cozy and Nordic, perfect for my candle shop. My listings look polished and sales have increased. Worth it.",
    "Job_Evaluation5_Home": "TEMU seller in Mexico",
    "Job_Evaluation6_Home": "Amazon operations specialist",
    "Job_Evaluation12_Home": "Store manager of a multi-SKU Amazon shop in Indonesia",
    "Job_Evaluation2_Home": "Amazon & Mercado Libre store owner ",
    "Name_Evaluation12_Home": "Arif",
    "Desc_Evaluation11_Home": "The lifestyle scene images look really natural, almost like they were professionally shot. My customers seem to love them too, and I’ve actually seen my conversion rates go up.",
    "Name_Evaluation11_Home": "Siti",
    "Job_Evaluation10_Home": "Cross-border store owner on Lazada & Shopee (Indonesia)",
    "Name_Evaluation10_Home": "Nina",
    "Job_Evaluation3_Home": "DTC E-commerce Designer",
    "Job_Evaluation8_Home": "Walmart Outdoor Products store owner in America ",
    "Name_Evaluation8_Home": "Jason",
    "Job_Evaluation9_Home": "Mercado Libre seller in Argentina",
    "Desc_Evaluation7_Home": "The pet product scenes the AI generates are super cute! The cats and dogs look perfectly proportioned and natural. Plus, the size and scale fit platform requirements, so the images are really easy to use right away.",
    "Job_Evaluation7_Home": "Mercado Libre store owner in Brazil",
    "Desc_Evaluation8_Home": "The camping scenes for my tents look really realistic. The lighting and angles feel natural, and the proportions are spot on. It saves me so much time compared to shooting everything myself.",
    "Name_Evaluation7_Home": "Thiago",
    "Desc_Evaluation9_Home": "The tool is really fast, and the images it generates can basically be uploaded straight to Mercado Libre and Amazon without any extra tweaks.",
    "Desc_Evaluation6_Home": "I used to worry that AI would mess up the fabric textures, but they barely look different from the original. Knitwear looks like knitwear, denim like denim, and it even meets Amazon's image requirements. Launching new products has become so much faster.",
    "Name_Evaluation9_Home": "Lucas",
    "Name_Evaluation6_Home": "Emma",
    "Desc_Evaluation5_Home": "The AI-generated product images are really accurate. The cable length and connector shapes are spot on, and they even match TEMU’s style. It’s a huge time-saver compared to taking the photos myself.",
    "Desc_Evaluation12_Home": "With just one prompt, I can get usable graphics instantly, which is way faster than waiting for a designer. It’s honestly super convenient.",
    "Name_Evaluation3_Home": "Chloe",
    "Name_Evaluation1_Home": "Sofia",
    "Desc_Evaluation4_Home": "The metallic textures and structural details are really clear, which makes the images look professional. I can use them straight away without any edits.",
    "Name_Evaluation4_Home": "Leon",
    "Desc_Evaluation10_Home": "Batch generation is super convenient. I can process dozens of SKUs at once, and it’s way faster than doing everything manually like before.",
    "Name_Evaluation2_Home": "Mariana",
    "Desc_Evaluation3_Home": "I sell clothing, and I was worried that AI might mess up the colors or fabric textures,but it actually did great! The model poses look natural, and the images are basically ready to use right away.",
    "Job_Evaluation1_Home": "SHEIN store operations specialist",
    "Name_Evaluation5_Home": "Diego",
    "Job_Evaluation11_Home": "Amazon Operations Specialist",
    "Desc_Evaluation2_Home": "The tool is super fast, and the images are basically ready to upload to Mercado Libre or Amazon. It even adapts backgrounds and models to local tastes, and the results look totally professional.",
    "Job_Evaluation4_Home": "eBay seller in Germany",
    "Title_Evaluation_Home": "Their Stories",
    "Title_Introduction_Home": "Premium AI design that drives stronger sales",
    "Desc_Qualification_Home": "Amazon SPN Certified Service Provider",
    "Title_Seo_Home": "AI Product Image & Video Generator for E-commerce",
    "Desc_Seo_Home": "Instantly generate product images, posters, and videos for Amazon, TikTok, and more online shops with Designkit's AI Agent. Start designing for free today!<br>",
    "Keywords_Seo_Home": "AI Agent for E-commerce, E-commerce AI tools, AI Product Image Generator, AI Product Video Generator, AI Product Photo Editor, AI Background Remover",
    "Title_Features1_Home": "From a single request to a complete set of visuals",
    "Title_Features2_Home": "Fully automated localization to sell your products globally across multiple platforms",
    "Title_Features3_Home": "Automatically generate images in bulk for multiple SKUs and beat competitors to market!",
    "Title_Designkit_Home": "Designkit",
    "Tips_AboveTheFold2_Home": "Scroll to explore",
    "Tips_Material1_Home": "Listing image set",
    "Tips_Material2_Home": "Virtual try-on",
    "Tips_Material3_Home": "A+ content",
    "Tips_Material4_Home": "Background generator",
    "Free_Button_Home": "Try for free",
    "Title_Header1_Home": "Product",
    "Title_Header2_Home": "solution",
    "Title_Header3_Home": "Inspiration",
    "Title_Header4_Home": "Learn",
    "Title_Header5_Home": "Pricing",
    "SecondTitle_Header1_Home": "AI E-Commerce Agent",
    "SecondTitle_Header2_Home": "AI Image Tools",
    "SecondTitle_Header3_Home": "AI Video Tools",
    "SecondTitle_Header4_Home": "Amazon Design Solution",
    "SecondTitle_Header5_Home": "Social Media E-Commerce Solution",
    "SecondTitle_Header6_Home": "AI Product Image Generator",
    "SecondTitle_Header7_Home": "AI Fashion Model Generator",
    "SecondTitle_Header8_Home": "Clothes Color Changer",
    "SecondTitle_Header9_Home": "Product Video Generator",
    "SecondTitle_Header10_Home": "AI Tools",
    "SecondTitle_Header11_Home": "AI Photo Editor",
    "SecondTitle_Header12_Home": "AI Photo Editor Online",
    "SecondTitle_Header13_Home": "Bulk Photo Editor",
    "SecondTitle_Header14_Home": "Bulk AI Photo Editor",
    "SecondTitle_Header15_Home": "Bulk Image Enhancer",
    "SecondTitle_Header16_Home": "Bulk Watermark Remover",
    "SecondTitle_Header17_Home": "Bulk Background Generator",
    "SecondTitle_Header18_Home": "Bulk Image Background Remover",
    "Title_Footer3_Home": "Design Tools",
    "Subtitle_Footer8_Home": "AI Image Editor",
    "Subtitle_Footer7_Home": "AI Background Changer",
    "Subtitle_Footer9_Home": "Transparent Background",
    "Subtitle_Footer10_Home": "Change Background Color",
    "Subtitle_Footer11_Home": "Image Watermark Remover",
    "Subtitle_Footer12_Home": "Remove Text from Image",
    "Subtitle_Footer13_Home": "Add Stickers to Photos",
    "Subtitle_Footer14_Home": "Add Watermark to Photos",
    "Title_Footer4_Home": "Image Models",
    "Subtitle_Footer15_Home": "Nano Banana Pro (Gemini 3.0 Pro)",
    "Title_Footer5_Home": "Download for Free",
    "Subtitle_Footer16_Home": "iOS APP",
    "Subtitle_Footer17_Home": "Android APP",
    "Title_Footer6_Home": "Follow Us",
    "Subtitle_Footer18_Home": "Kling 3.0",
    "Subtitle_Footer19_Home": "Seedance 2.0",
    "Title_Footer7_Home": "Video Models",
    "Button_Export": "Download",
    "Title_Layer": "Layers",
    "InputNumber_Opacity": "Opacity",
    "Buttom_Comfirm": "Confirm",
    "Button_Share": "Share",
    "Button_Delete": "Delete",
    "Title_LoginPopup": " Log in to unlock your free trial",
    "SubTitle_LoginPopup": "Start creating with X-Design today",
    "Tip_ModalTitle": "Reminder",
    "TipContent_HistoryDelete": "Once deleted, this record cannot be restored. Confirm deletion?",
    "Title_Logo": "Logo",
    "Title_BrandKit": "Templates",
    "Tab_BrandKit": "Brand Kit",
    "Tab_UploadLocal": "Choose from album",
    "Button_UploadImage": "Upload Images",
    "Tip_ClickDragParseImage": "Upload, drop or paste images here.",
    "Tip_UploadMax": "Upload JPG, JPEG, or PNG files up to ${0} MB, with a maximum of N images.",
    "Tooltip_SwitchBrandKit": "Switch brand kit",
    "Discribe_BrandKitSelect": "Select a brand style as the reference for this design.",
    "Title_Models": "Models",
    "Switch_Auto": "Auto",
    "Tab_Image": "Image",
    "Tab_Video": "Video",
    "MenuItem_AddToBrandLogo": "Save as brand logo",
    "MenuItem_AddToBrandTemplate": "Save as brand template",
    "Button_ExportImage": "Import images",
    "Button_ExportMedia": "Import videos",
    "Button_ExportFromBrandkit": "Import from Brand Kit",
    "Dropdown_AddFromBrandkit": "Add from Brand Kit",
    "Placeholder_ChatInput": "Let's get started!",
    "MenuItem_AiChange": "AI Editing",
    "MenuItem_AiExpend": "AI Extender",
    "MenuItem_AiHD": "AI Clarity",
    "MenuItem_Eliminate": "AI Removal",
    "MenuItem_SplitLayers": "Split Layers",
    "MenuItem_Cutout": "BG Remover",
    "MenuItem_ChangeText": "Replace Text",
    "MenuItem_Crop": "Image Size",
    "MenuItem_AddToChat": "Add to Chat",
    "MenuItem_AddToBrand": "Add to Brand Kit",
    "Tooltip_Layer": "Layers",
    "Tooltip_Grab": "Hand tool",
    "Tooltip_Select": "Select",
    "Tooltip_Redo": "Redo",
    "Tooltip_Undo": "Undo",
    "Tooltip_Add": "Add",
    "Tooltip_ShowAll": "Show all",
    "Tip_UploadType": "Unsupported file format",
    "Tip_UploadSize": "Only files up to ${0} MB are supported",
    "Tip_UploadWH": "Please ensure each image is no larger than ${0}\xd7${1} pixels",
    "Tip_UploadTypeTranslate": "Failed to change file format",
    "Tip_UploadFail": "Upload failed",
    "Tooltip_AddText": "Add text",
    "Text_AddDefault": "This is sample text.",
    "Tooltip_OverflowImageSize": "Please resize your image to within ${0} pixels",
    "Placeholder_ImageFusion": "Let me know how you'd like the images blended",
    "Button_ImageFusion": "Blend",
    "Button_Cancel": "Cancel",
    "Button_AiChange": "Edit",
    "Placeholder_AiChange": "Let me know what you want to change",
    "Button_Eliminate": "Eraser",
    "Label_OriginSize": "Original",
    "Label_CropRadio": "Aspect ratio",
    "Button_Free": "Free",
    "Button_Origin": "Original",
    "Button_Crop": "Crop",
    "Placeholder_ChangeText": "Enter text. Example: Hello",
    "Button_ChangeText": "Confirm",
    "InputNumber_PanSize": "Brush size",
    "Label_TargetSize": "Target",
    "Tooltip_ImageFusion": "You can blend ${0}-${1} images",
    "Title_Workspace": "Your Creative AI Agent for Branding",
    "Button_Pro": "Get Free Pro",
    "Title_NanoPro": "\uD83C\uDF4C\uD83C\uDF4CNano Banana Pro is now available on X-Design.",
    "Dropdown_AdvancedFeatures_Title": "Advanced Features",
    "Dropdown_AdvancedFeatures_Conent": "Full access to all AI-powered tools to enhance your efficiency.",
    "Dropdown_MassiveContent_Title": "Extensive Content",
    "Dropdown_MassiveContent_Content": "Unlimited access to premium templates and a vast array of Plus stock assets.",
    "Dropdown_CommercialRights_Title": "Commercial Rights",
    "Dropdown_CommercialRights_Content": "Use your personal creations with confidence, backed by guaranteed copyright protection.",
    "Popup_SubscribeIntl_Desc": "Get the most from X-Design with Pro",
    "Popup_SubscribeIntl_Desc1": "Unlock more creations with credits",
    "Popup_SubscribeIntl_Detail": "View plan details & Help",
    "Popup_StripeCheckout": "Stripe checkout",
    "Popup_LiveSupport": "Live support",
    "Popup_CancelAnytime": "Cancel anytime",
    "Menu_Language": "Language",
    "Menu_ManageSubscription": "Manage Subscriptions",
    "Menu_TermsPolices": "Terms and Policies",
    "Menu_ManageSubscriptions": "Manage Subscriptions",
    "Menu_ReferralLink": "Referral Link",
    "Menu_BenefitsUpgraded": "Benefits",
    "Menu_TermsPolicies": "Terms and Policies",
    "Menu_AccountManagement": "Account",
    "Title_ReferralCode": "Referral Code",
    "Title_ReferralLink": "Referral Link",
    "Desc_NoActiveSubscription": "No active subscription",
    "Button_ClickToSubscibe": "Click here to subscribe",
    "Title_SubscriptionCancel": "Your subscription has been cancelled",
    "Title_SeeYou": "Sorry to see you go...\uD83D\uDE2D",
    "Desc_NextBillingDate": "Renews on",
    "Desc_EstimatedAmount": "Estimated total",
    "Button_CancelSubscription": "Cancel subscription",
    "Button_StaySubscribed": "Keep subscription",
    "Title_ReasonCancelling": "Please select a reason for cancelling:",
    "Desc_BenefitsContinue": "You can still enjoy your membership benefits until the end of the subscription.",
    "Desc_GiftedCredits": "After your subscription expires, the gifted credits",
    "Desc_SeeYou": "Thanks for being with us. We're sorry to see you go.",
    "Desc_NoNoreCharges": "You won't be charged again, and your membership remains active until",
    "Desc_MayBeRevoked": "may be revoked.",
    "Desc_CancelingNoRefund": "Cancellation does <span>not include a refund<span>. For refund inquiries, please contact online support.",
    "Button_ClearSelection": "Unselect",
    "Button_Confirm": "Confirm",
    "Message_Processing": "Processing...",
    "Title_Opacity": "Opacity",
    "Button_ExpandImage": "Extender",
    "Button_ExpandRadio": "Aspect ratio",
    "Title_NoDesigns": "No designs yet.",
    "Title_NoGenerations": "No generations yet.",
    "Desc_NoDesigns": "Your designs will show up here.",
    "Desc_NoGenerations": "Your generations will show up here.",
    "Title_DeleteDesign": "Delete this design",
    "Popup_DeleteDesign": "Are you sure you want to delete this design permanently? This action can't be undone.",
    "Message_SaveFail": "Failed to save",
    "Title_Pricing": "Choose the Right Plan for You",
    "Title_Tags1_Pricing": "Monthly",
    "Text_Discount_Pricing": "${0} off",
    "Title_Tags2_Pricing": "Yearly",
    "Title_Plan1_Pricing": "Free",
    "Current_Plan_Pricing": "Current plan",
    "Title_Instruction1_Pricing": "Get 20 credits for first login",
    "Title_Instruction2_Pricing": "Generate up to 20 images with AI Agent",
    "Title_Instruction3_Pricing": "Generate up to 10 images with AI Background Generator",
    "Title_Rights1_Pricing": "Limited background or object removal",
    "Title_Rights3_Pricing": "Limited HD image enhancement",
    "Title_Plan2_Pricing": "Basic Plan",
    "Month_Plan_Pricing": "month",
    "Title_Button1_Pricing": "Subscribe",
    "Title_Instruction4_Pricing": "500 credits/mo",
    "Title_Instruction5_Pricing": "Generate up to 500 images with AI Agent",
    "Title_Instruction6_Pricing": "Generate up to 250 images with AI Background Generator",
    "Title_Plan3_Pricing": "Pro Plan",
    "Desc_Plan_Pricing": "7-day free trial. Then ${0}/year.",
    "Title_Button2_Pricing": "7-day free trial",
    "Title_Instruction7_Pricing": "1,500 credits/mo",
    "Title_Instruction8_Pricing": "Generate up to 1,500 images with AI Agent",
    "Title_Instruction9_Pricing": "Generate up to 750 images with AI Background Generator",
    "Title_Rights4_Pricing": "Unlimited background or object removal",
    "Title_Rights5_Pricing": "Unlimited use of AI removal feature",
    "Title_Rights6_Pricing": "Unlimited UHD image enhancement",
    "Title_Rights7_Pricing": "Batch processing tools",
    "Title_Best_Pricing": "Chosen by 90% of users",
    "Title_AllFeatures_Pricing": "Compare Free and Paid Plans",
    "Desc_AllFeatures_Pricing": "Unlock Premium to create stunning designs effortlessly with advanced AI tools",
    "Month_AllFeatures_Pricing": "month",
    "Title_Features1_Pricing": "AI Agent",
    "SubTitle_Features1_Pricing": "Image Editing",
    "SubTitle_Features15_Pricing": "Generate up to ${0} images",
    "SubTitle_Features16_Pricing": "Generate up to ${0} images/mo",
    "SubTitle_Features2_Pricing": "Image Generation",
    "SubTitle_Features3_Pricing": "E-commerce Image Generation",
    "SubTitle_Features4_Pricing": "Poster Generation",
    "Title_Features2_Pricing": "AI Image Tools",
    "SubTitle_Features5_Pricing": "AI Background Remover",
    "SubTitle_Features17_Pricing": "Limited use",
    "SubTitle_Features19_Pricing": "Unlimited use",
    "SubTitle_Features6_Pricing": "AI Object Remover",
    "SubTitle_Features7_Pricing": "Image Enhancer",
    "SubTitle_Features18_Pricing": "Limited use (HD)",
    "SubTitle_Features20_Pricing": "Unlimited use (HD/UHD)",
    "SubTitle_Features8_Pricing": "AI Image Upscaler",
    "SubTitle_Features9_Pricing": "AI Image Extender",
    "SubTitle_Features10_Pricing": "AI Background Generator",
    "Title_Features3_Pricing": "More Design Features",
    "SubTitle_Features11_Pricing": "Advanced Features and Templates",
    "SubTitle_Features12_Pricing": "Remove Watermark",
    "SubTitle_Features13_Pricing": "Bulk AI Image Tools",
    "SubTitle_Features14_Pricing": "Basic Design Features",
    "Title_Credits_Pricing": "Running low on credits? We've got you covered.",
    "Desc_Credits_Pricing": "One-time purchase, no subscription needed.",
    "TransactionPrice_Credits_Pricing": "Price: ${0}",
    "Credit_Credits_Pricing": "Credits",
    "Popular_Credits_Pricing": "Most Popular",
    "Buy_Credits_Pricing": "Purchase Now",
    "Title_FAQ_Pricing": "FAQs",
    "Title_Button4_Pricing": "Upgrade now for a 7-day free trial",
    "Title_Button3_Pricing   ": "Available benefits",
    "SubTitle_FAQ1_Pricing": "What are credits?",
    "Content_FAQ1_Pricing": "Credits allow you to continue accessing AI tools. The number of credits required varies depending on the specific tool.",
    "Content_FAQ2_Pricing": "Purchased credits are valid for one year.",
    "Content_FAQ3_Pricing": "Membership credits are valid during the membership period.",
    "SubTitle_FAQ2_Pricing": "How do I cancel my subscription and what happens to my credits after cancellation?",
    "Content_FAQ4_Pricing": "After canceling your subscription,",
    "Content_FAQ5_Pricing": "your membership credits will remain valid until your membership expires. Any credits you've purchased separately will not be affected.",
    "Content_FAQ6_Pricing": "If you need to cancel your subscription, please follow the steps below at least 24 hours before the next billing cycle begins:",
    "Content_FAQ7_Pricing": "1. Go to Designkit and log in.",
    "Content_FAQ8_Pricing": "2. Enter the subscription pop-up window.",
    "Content_FAQ9_Pricing": '3. Select "Manage Subscriptions".',
    "Content_FAQ10_Pricing": '4. Select your current plan and click "Cancel Subscription".',
    "Content_FAQ11_Pricing": "Your subscription will remain active until the end of the current billing cycle. If you are unable to cancel, please take a screenshot and contact our online support as soon as possible.",
    "SubTitle_FAQ3_Pricing": "What is your refund policy?",
    "Content_FAQ12_Pricing": "1. 7-Day Money-Back Guarantee:",
    "SubTitle_FAQ4_Pricing": "How can I upgrade or downgrade my subscription?",
    "Content_FAQ25_Pricing": "1. Upgrade: You can simply subscribe to a higher-tier plan, and it will take effect immediately. Your old subscription will be cancelled, and any remaining balance will be refunded.",
    "SubTitle_FAQ5_Pricing": "Can I get a copy of my invoice?",
    "Content_FAQ27_Pricing": "Yes! After a successful payment, you will receive an email from the payment provider containing an electronic invoice. If you do not receive an invoice, please contact our support team.",
    "SubTitle_FAQ6_Pricing": "What payment methods do you support?",
    "Content_FAQ28_Pricing": "We use Stripe to manage payments and subscriptions. We accept all major credit cards, PayPal, and Google Pay.",
    "SubTitle_FAQ7_Pricing": "How can I contact support?",
    "Content_FAQ29_Pricing": "Email: support@designkit.com. Response time: 3-10 business days.",
    "Content_FAQ13_Pricing": "If you purchased subscriptions and have not used them within 7 days, you may be eligible for a full refund.",
    "Content_FAQ14_Pricing": "If you purchased credits, you may be eligible for a refund for any unused credits within 7 days.",
    "Content_FAQ15_Pricing": "2. Dissatisfaction with Service",
    "Content_FAQ16_Pricing": "If you're unsatisfied with the results, please contact our online support team. We may provide compensation or a refund depending on the circumstances.",
    "Content_FAQ17_Pricing": "3. Purchases via Google Play or App Store",
    "Content_FAQ18_Pricing": "If you subscribed through Google Play Store or the App Store, you need to request a refund directly from Google or Apple.",
    "Content_FAQ19_Pricing": "Important Notes:",
    "Content_FAQ20_Pricing": "This refund policy does not apply to API users. If you use our API, please contact us for refund eligibility.",
    "Content_FAQ21_Pricing": "We reserve the right to deny refunds in cases of misuse, abuse, or violations of our terms.",
    "Content_FAQ22_Pricing": "Refunds may take several business days to process, depending on your payment method.",
    "Content_FAQ23_Pricing": "We may update this refund policy from time to time. Please check it periodically for any changes.",
    "Content_FAQ24_Pricing": "For further assistance, please contact our support team.",
    "Content_FAQ26_Pricing": "2. Downgrade: First, cancel your current subscription. Once your current billing period ends, subscribe to a new plan.",
    "Content_Modal_Pricing": "Thank you for your support! Get ready to take your creativity to the next level.",
    "Tip_Modal_Pricing": "Tips: If your membership isn't showing up yet, please refresh the page.",
    "Title_Modal_Pricing": "Successfully purchased",
    "Title_Rights2_Pricing": "Limited use of AI Removal feature",
    "Title_Button3_Pricing": "Available benefits",
    "Title_Button5_Pricing": "Upgrade",
    "Tool_ImageBgRemover": "Image Background Remover",
    "Tool_AiBgGenerator": "Al Background Generator",
    "Tool_AiLogoGenerator": "AI LOGO Generator",
    "Tool_FootwearModel": "Footwear Model",
    "Tool_ImageTranslation": "Image Translation",
    "Tool_BatchImageBgRemover": "Batch Image Background Remover",
    "Tool_BatchImageEnhancer": "Batch Image Enhancer",
    "Tool_BatchAiObjectsRemover": "Batch AI Object Remover",
    "Tool_VideoEnhancer": "Video Enhancer",
    "Tool_VideoBgRemover": "Video Background Remover",
    "Tool_VideoWatermarkRemover": "Video Watermark Remover",
    "Title_Models_Dropdown": "Models",
    "Tips_Uninitialized_Chat": "Failed to send messages",
    "Tips_Uninitialized_chat": "Failed to send messages",
    "Dropdown_AddImage": "Add image",
    "Action_SeeAll": "See all",
    "Desc_Seedream": "Realistic and detailed image creation.",
    "Dropdown_AddVideo": "Add video",
    "Tips_NotFound_Chat": "Chat does not exist",
    "Desc_Seedance": "Realistic and expressive video creation.",
    "Dropdown_SupportedFormatFile": "Supports Word, Excel, Text and PDF files.",
    "Dropdown_Example_Option": "Example",
    "Dropdown_NoReference_Option": "No reference available",
    "Menu_AgentCredits": "Agent Credits",
    "Desc_SeedEdit": "Precise and natural image editing.",
    "Dropdown_BrandKit_Title": "Brand Kit",
    "Desc_GeminiNanoBanana": "Fast, editable, and consistent image generation.",
    "Dropdown_Models_Title": "Models",
    "Dropdown_AddDocument": "Add document",
    "Dropdown_BrandKit_Desc": "Select a brand style as the reference for this design.",
    "Desc_MidjourneyVideo": "Creative and artistic video generation.",
    "Desc_MidjourneyImage": "Artistic and imaginative image generation.",
    "Dropdown_SaveAsBrandTemplate": "Save as brand template",
    "Dropdown_SaveAsBrandLogo": "Save as brand logo",
    "BatchProcessTable_ImageType": "Image type",
    "BatchProcessTable_PictureRequirement": "Design details",
    "BatchProcessTable_CopywritingRequirements": "Product description",
    "BatchProcessTable_Proportion": "Aspect ratio",
    "BatchProcessTable_Actions": "Action",
    "BatchProcessTable_AddOneRow": "Add",
    "BatchProcessList_DeleteError": "Deletion failed",
    "BatchProcessList_SurePrompt": "Delete this guideline?",
    "BatchProcessList_SurePrompt_SureText": "Confirm",
    "BatchProcessList_SurePrompt_CancelText": "Cancel",
    "BatchProcessList_EmptyText": "Empty",
    "EditBatchProcess_NameLimitTip": "Enter a name (up to 10 characters)",
    "EditBatchProcess_Tip": "Any changes to the guidelines will affect the generated results.",
    "EditBatchProcess_Start": "Start with a guideline",
    "EditBatchProcess_GenerateTip": "Upload your product images, and designs will be generated based on the guidelines.",
    "Text_AdvanceSetting": "Expert",
    "Text_MainImage": "Main image",
    "Text_ProductAgentUploadGuide1": "1. Upload photos from different angles so the AI can accurately recognize and restore product details.",
    "Text_ProductAgentUploadGuide2": "2. You can upload up to 10 photos. The first one will be used as the main image. We recommend choosing a photo that clearly shows the full product.",
    "Text_Optional": " (Optional)",
    "Tip_ClickDragImageWithSize": "Upload or drop JPEG, JPG, or PNG images up to ${0} MB.",
    "Button_AddReferenceImage": "Upload",
    "Title_ReferenceImage": "Reference image",
    "Input_Placeholder": "Please select",
    "Radio_ReferenceColor": "Reference color",
    "Radio_ReferenceLayout": "Reference layout",
    "Tag_FirstImage": "First image",
    "Tag_FirstImageNoPartial": "Partial first image",
    "Tag_Blur": "Blurry",
    "Tag_Jigsaw": "Collage",
    "Button_Understood": "Got it",
    "Text_ReferenceImageIndex": "Image ${0} is for reference",
    "Text_ReferenceDimensions": "Use ${0} from reference",
    "Tag_Cropped": "Cropped",
    "Tag_Underexposed": "Underexposed",
    "Tag_Blurry": "Blurry",
    "SelectOption_ColorPalette": "Color Palette",
    "SelectOption_Layout": "Layout",
    "SelectOption_Fonts": "Fonts",
    "SelectOption_Style": "Style",
    "SelectOption_ShapeElements": "Shape Elements",
    "Text_SocialMediaAgentUploadGuide": "Upload your featured product first. Ensure the picture is clear and complete.",
    "Video_SR_Success": "Video clarity enhanced",
    "Video_Desubtitle_Success": "Subtitle removed",
    "Video_Dewatermark_Success": "Watermark removed",
    "Video_Process_Failed": "Processing failed. The credits will be refunded to your account.",
    "Video_SR": "AI Clarity",
    "Video_Dewatermark": "Remove Watermark",
    "Video_Desubtitle": "Remove Subtitle",
    "Video_Task_Price_Estimate": "${0} credits required",
    "Video_SR_Start": "Enhancing clarity... ${0} credits will be used.",
    "Video_Dewatermark_Start": "Removing watermarks... ${0} credits will be used.",
    "Video_Desubtitle_Start": "Removing subtitles... ${0} credits will be used.",
    "Text_Help_Center": "Help Center",
    "Title_Request": "Chat",
    "Button_Continue": "Continue",
    "Button_EditContent": "Edit message",
    "Title_ChooseImageType": "Select generated image type (Multiple options)",
    "Button_BatchGenerate": "Confirmed. Run the template now.",
    "Text_ChatCancelStatus": "Task terminated",
    "Text_ChatRespondedStatus": "Task processing",
    "BatchProcess_SaveSuccessTip": "Your workflow kits are saved here.",
    "Button_GotIt": "Got it",
    "Title_Congrats": "Congrats",
    "SubTitle_BrandCreate": "You've built your first brand kit—time to explore its potential!",
    "Button_CheckUse": "Check it out now",
    "Chat_Prompt_Brand": "Create a promo poster",
    "Tooltip_UseBrand": "You can switch or add your brand kit here!",
    "Tooltip_PosterBrand": "Tap to create your first poster based on your brand kit",
    "Popup_CreateBrand": "Create a brand from scratch",
    "Desc_CreateBrand": "Create stunning, original logos with our AI Agent.",
    "Popup_UploadBrand": "Upload your brand information",
    "Desc_UploadBrand": "Upload it and X-Design will keep every design aligned.",
    "Title_BrandEntry": "Get a tailored brand system now",
    "Desc_BrandEntry": "Let our Al be your stylist. Answer a few questions and receive a complete brand system tailored to your vision.",
    "Tooltip_UseBrand_Agent": "Once the brand kit is applied, the design will automatically reference the logo, color palette, and overall style.",
    "Tooltip_PosterBrand_Agent": "You're all set to design with your brand kit",
    "BatchProcess_createText": "Workflow Kit",
    "Label_NormalMode": "Basic:",
    "Label_AdvancedMode": "Advanced:",
    "Text_NormalMode": "Basic",
    "Text_AdvancedMode": "Advanced",
    "BatchProcess_DefaultPrompt": "Generate Images",
    "Title_CreateBrand": "Don't have a brand?",
    "Title_UploadBrand": "Already have a logo?",
    "Button_CreateBrand": "Create a brand",
    "BatchProcess_EditContent": "Edit content",
    "BatchProcess_PleaseSelect": "Select a workflow kit",
    "BatchProcess_SelectTip": "All uploaded images will be generated in batch using the selected workflow kit.",
    "BatchProcess_ListEmptyTip": "Save workflow kit after generating to instantly create similar sets in batches.",
    "BatchProcess_Tip": "Workflow Kit",
    "BatchProcess_Generate": "Use it now",
    "BatchProcess_Save": "Save",
    "BatchProcess_GeneratingFormula": "Generating workflow kit...",
    "BatchProcess_GenerateCancel": "Cancel",
    "BatchProcess_WorkFlowCreateError": "Creation Failed",
    "ProductInfo_PleaseUploadImage": "Upload product images",
    "BatchProcess_IntelligenceGenerate": "Create workflow kit",
    "BatchProcess_CreateWorkflow": "Create",
    "BatchProcess_Formula": "Workflow Kit",
    "BatchProcess_WorkFlowSaveSuccess": "Workflow kit saved",
    "ProductInfo_ImageSizeLimit": "Images within ${0} MB are supported",
    "ProductInfo_ImageUpload": "Add product image",
    "ProductInfo_UploadDemo": "Example photos",
    "ProductInfo_ECPlatform": "Platform",
    "ProductInfo_PleaseSelect": "Please select",
    "ProductInfo_InputCustomize": "Custom",
    "ProductInfo_CountryAndLanguage": "Target region/language",
    "ProductInfo_Name": "Product name",
    "ProductInfo_Desc": "Product details (Features/Size/Usage scenarios)",
    "ProductInfo_DescPlaceholder": "Enter product information including features, size, usage scenarios, target audience, etc.",
    "ProductInfo_NamePrompt": "The product name is ${0};",
    "ProductInfo_ECPlatformPrompt": "The target platform is ${0};",
    "ProductInfo_CountryAndLanguagePrompt": "The language is ${0};",
    "ProductInfo_DescPrompt": "The product details are ${0}.",
    "ProductInfo_PleaseInput": "Please enter",
    "Button_UnlockPro": "Unlock Pro",
    "Button_UpgradeToPro": "Upgrade to Pro",
    "Button_RenewNow": "Renew Now",
    "AgentEmpty_CaseUseBtn": "Use",
    "AgentEmpty_CaseRefreshBtn": "Refresh",
    "MenuItem_Effect": "Effects",
    "MenuItem_Shadow": "Shadows",
    "MenuItem_Stroke": "Stroke",
    "Title_ChangeText": "Replace Text",
    "Button_Logout": "Log out",
    "Message_ExtractText": "Extracting text",
    "Message_ExtractTextError": "Failed to extract the text. Please try again.",
    "Tip_CreditConsume": "This generation uses ${0} credits",
    "Tip_EstimatedTime": "Ready in about ${0} minutes",
    "BatchProcess_SaveSuccessTip_GotIt": "Got it",
    "BatchProcess_SaveSuccessTip_Title": "Using Workflow Kits",
    "BatchProcess_SaveSuccessTip_Desc": "Your workflow kits are saved here. Choose one to quickly generate images using the saved templates.",
    "BatchProcess_tutorial": "Tutorial",
    "Text_HandTool": "Hand tool",
    "Text_Function": "Function",
    "Text_WindowsSystem": "Windows system",
    "Text_MacSystem": "Mac system",
    "Menu_KeyboardShortcuts": "Shortcuts",
    "Title_KeyboardShortcuts": "Shortcuts",
    "Text_Undo": "Undo",
    "Text_MouseLeft": "Left mouse button",
    "Text_Redo": "Redo",
    "Text_Delete": "Delete",
    "Text_Cut": "Cut",
    "Text_Copy": "Copy",
    "Text_Paste": "Paste",
    "Text_PasteFixed": "Paste in place",
    "Text_CreateCopy": "Create a copy",
    "Text_SelectAll": "Select all",
    "Text_SelectMultiple": "Multi-select",
    "Text_Group": "Group",
    "Text_Ungroup": "Ungroup",
    "Text_LockLayer": "Lock",
    "Text_Save": "Save",
    "Text_Move": "Move",
    "Text_MoveWithCombinedKeys": "Quick move",
    "Text_TouchEditFastMode": "Quick Point to Edit",
    "Text_Pan": "Pan",
    "Title_Canvas": "Canvas",
    "Title_Edit": "Edit",
    "Title_Elements": "Elements",
    "Title_Tools": "Tools",
    "Text_NewText": "New text",
    "Text_NewLine": "New line",
    "Text_NewRectangle": "New rectangle",
    "Text_NewCircle": "New circle",
    "Text_ExitFullScreen": "Exit full screen",
    "Text_MoveUpOneLayer": "Bring forward",
    "Text_MoveDownOneLayer": "Send backward",
    "Text_Top": "Bring to front",
    "Text_Bottom": "Send to back",
    "Text_CanvasZoom": "Zoom in/Zoom out",
    "Text_ToggleReferenceLine": "Show/hide guides",
    "Text_ToggleRulerBar": "Show/hide rulers",
    "Text_ArrowKey": "Arrow keys",
    "Text_CanvasShowAll": "Show all canvas",
    "Title_Unsupported_Multilayer": "This feature works with a single layer only.",
    "Btn_CreateBatchProcessFormula": "Create",
    "Button_Hide_Otherlayers": "Keep first layer and continue",
    "Button_Merge_Alllayers": "Merge all layers and continue",
    "Checkbox_Disable_Remind": "Don't show again",
    "Button_Tool": "Tools",
    "Button_Custom_Ratio": "Custom",
    "Label_Spacing": "Spacing",
    "Button_Download_Whole": "Export as Image",
    "Button_Download_Layer": "Export by Layer",
    "Button_Origin_Ratio": "Original",
    "Text_TouchEdit_Title": "Point to Edit",
    "Text_TouchEdit_Description": "Point to an object and describe your changes. The image will be edited exactly as you specify. ",
    "Tooltip_TouchEdit_Max_Count": "You can point out up to ${0} areas",
    "Tooltip_TouchEdit_Usage": "Point to Edit shortcut: ${0} + click",
    "Text_TouchEdit_Recognition_Custom": "Custom",
    "Text_TouchEdit_Recognition_Title1": "Detect and recognize",
    "Text_TouchEdit_Recognition_Title2": "No target found. Enter the object's name.",
    "Text_TouchEdit_Name": "Point to Edit",
    "Btn_LoginToViewBatchProcess": "Log in to view the workflow kit",
    "Btn_Login": "Log in",
    "Menu_Main_Beautify": "Refine",
    "Text_Model_Pricing": "Model Pricing",
    "Text_Pro_discount": "Pro Plan: Half-Price Video Generation",
    "Text_TemplatePrompt": "Let’s start with inspirations",
    "Text_Hi": "Hi, ${0}!",
    "Text_Account_Popup_Left": "Meet your dedicated AI design assistant for e-commerce. Crafted for professionals who seek faster launches, stronger presentation, and higher profitability.",
    "Text_PleaseWaitImageUploaded": "Please proceed after the upload is complete",
    "Menu_Redeem_Rights": "Redeem",
    "Text_Redeem_Now": "Redeem Now",
    "Text_Redeem_Placeholder": "Enter the redemption code, case sensitive",
    "Text_Redeem_Success": "Redeemed successfully!",
    "Text_Redeem_Use": "Redeem your code",
    "Tooltip_BrandAutoUse": "Your new brand kit is applied!",
    "Redeem_Redeem_Note": "Note: \nPlease log in and enter the redemption code.\nOnce the redemption is successful, you can enjoy the corresponding benefits and services.\nPlease use the redemption code within its validity period. Expired codes will be invalidated and are non-refundable.\nPlease protect your code. We are not responsible for lost, leaked, or incorrectly used codes. \nThis code may not be resold or transferred, cannot be exchanged for cash, and is not eligible for invoicing.",
    "Tooltip_Color_Fill": "Color",
    "Tootip_StartPoint": "Start",
    "Tootip_ChangePoint": "Switch",
    "Tootip_EndPoint": "End",
    "Sidebar_NewDesign": "New chat",
    "Retouch_Filter_Clear": "Clear",
    "Retouch_Filter_Enhance": "Vivid",
    "Retouch_Filter_Dehaze": "Dehaze",
    "Retouch_Filter_Texture": "Texture",
    "Retouch_Filter_Nature": "Natural",
    "Retouch_Filter_Fade": "Fade",
    "Modal_Button_Known": "OK",
    "Modal_Button_GotIt": "Accept",
    "Modal_Button_Later": "Later",
    "Text_Appeal_Confirm": "Yes",
    "Text_Vip_Open": "Subscribe",
    "Text_Appeal_ReGenerate": "Edited results are not eligible for review.",
    "Text_Appeal_Left": "Attempts left this month\n<i>${0}</i>/${1}",
    "Text_Appeal_Refunded": "The credits have been refunded to your account.",
    "MenuItem_Appeal": "Result Review",
    "Tooltip_Downloading": "Downloading…",
    "Tooltip_Download_Video": "Download videos separately, one at a time.",
    "Tooltip_Download_NoneSelected": "Please select the content you want to download",
    "Text_AI_Thinking": "AI is working on it...",
    "Text_Server_Busy": "The server is busy. Please try again later.",
    "Text_Prompt_Help_Placeholder": "Type your keywords, and I'll turn them into a ready-to-use prompt.",
    "Text_Prompt_Helping": "Processing... Please wait.",
    "Button_Retry": "Retry",
    "Button_Rewrite": "Try again",
    "Button_Start_Prompt_Help": "Start writing",
    "Title_Prompt_Helper": "AI Writing",
    "Menu_Text_Subscriptions": "Subscriptions",
    "Menu_View_Subscriptions": "View Subscriptions",
    "Text_Download_XdesignApp": "Please download the <span>X-Design</span> app to use features",
    "Text_Free_Trial": "Download for a 7-day Free Trial",
    "Text_Install_App": "Install App",
    "Text_Scan_Download": "Scan to download",
    "Text_Download_the": "Download on the",
    "Text_Available_On": "Available on",
    "Desc_ExpireDate": "Expires on",
    "DownloadApp_Title_Widgets": "Please download the ${0} app to use features",
    "DownloadApp_SubTitle_Widgets": "Download for a ${0}-day Free Trial",
    "InstallApp_Title_Widgets": "Install App",
    "InstallApp_Desc_Widgets": "Scan to download",
    "AppStore_Desc_Widgets": "Download on the",
    "GooglePlay_Desc_Widgets": "Available on"
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/figma/es-MX.js
/* harmony default export */ const es_MX = ({
    "Tips_Adding": "Procesando…",
    "Tips_Loading": "Cargando…",
    "Tips_Creating": "Procesando…",
    "Tips_Downloading": "Descargando…",
    "Tips_Sending": "Enviando…",
    "Tips_AddSuccess": "Se agreg\xf3 correctamente",
    "Tips_MakeSameError": "No se puede volver a crear",
    "Tips_UnsupportedGradientColor": "No se admiten gradientes",
    "Tips_CanNotAdding": "Error al agregar",
    "Tips_Uninitialized": "Error al enviar el mensajes",
    "Tips_UploadFailed": "Error al cargar. Int\xe9ntalo de nuevo.",
    "Tips_UploadMaxCountLimit": "Sube hasta ${n}\xa0archivo(s) ${type}",
    "Tips_UploadMaxFileSize": "No se pudo subir el archivo ${file}. Usa un archivo de hasta ${n}\xa0MB.",
    "Tips_UploadImageAndVideoLimit": "Puedes subir 1\xa0imagen y 1\xa0video a la vez",
    "Tips_UnsupportedSvgFile": "No se admiten archivos SVG",
    "Tips_UnsupportedUploadFileFormats:": "No se admite el formato de tu archivo ${files}",
    "Tips_CanNotAddSameFileTips": "Este archivo ya existe",
    "Tips_TextMinLengthTips": "Ingresa al menos ${n}\xa0caracteres",
    "Tips_TextMaxLengthTips": "Ingresa hasta ${n}\xa0caracteres. Cada car\xe1cter chino o emoji cuenta por 2.",
    "Tips_AccessDenied": "Acceso denegado",
    "Tips_CreateFailed": "Error al iniciar el chat",
    "Tips_Error": "Ocurri\xf3 un error",
    "Tips_NotFound": "El chat no existe",
    "Tips_RequestAgentModelListError": "Error al solicitar la lista de modelos de Agente",
    "Desc_Ended": "Fin",
    "Button_PeopleUse_Agent": "${n} usuarios lo probaron",
    "Dropdown_AddToChat": "Agregar al chat",
    "Dropdown_AddToBrandKit": "Agregar al Kit de marca",
    "Dropdown_SaveAsBrandLogo": "Guardar como logotipo de marca",
    "Dropdown_SaveAsBrandTemplate": "Guardar como plantilla de marca",
    "Title_Design_Agent": "Dise\xf1o",
    "Title_MainColor": "Color principal",
    "Title_SecondaryColor": "Color secundario",
    "Bitton_ViewTheBrandKit": "Haz clic para ver el kit de marca",
    "Dropdown_InportImages": "Importar im\xe1genes",
    "Desc_RunOutOfUsesForToday_Pro": "Te has quedado sin usos gratuitos por hoy. Regresa ma\xf1ana.",
    "Desc_PurchaseCompleted_Pro": "Compra completada",
    "Desc_ContinueDesign_Pro": "\xa1Ahora puedes continuar con tu dise\xf1o!",
    "Title_Upgrade_Pro": "Actualizar",
    "Desc_SubscribeToUnlock_Pro": "\xa1Suscr\xedbete para desbloquear m\xe1s!",
    "Desc_RunOutOfFreeUses_Pro": "Se te acabaron los usos gratuitos.",
    "Button_UnlockNow": "Suscr\xedbete",
    "Dropdown_AddImage": "Agregar imagen",
    "Dropdown_AddVideo": "Agregar video",
    "Dropdown_AddDocument": "Agregar documento",
    "Dropdown_SupportedFormatFile": "Admite archivos de Word, Excel, texto y PDF.",
    "Tips_Uninitialized_chat": "Error al enviar mensajes",
    "Title_Models_Dropdown": "Modelos",
    "Switch_Auto": "Autom\xe1tico",
    "Tab_Image": "Imagen",
    "Tab_Video": "Video",
    "Desc_GeminiNanoBanana": "Generaci\xf3n de imagen r\xe1pida, editable y uniforme.",
    "Desc_MidjourneyImage": "Generaci\xf3n de imagen art\xedstica e imaginativa.",
    "Desc_Seedream": "Creaci\xf3n de imagen realista y detallada.",
    "Desc_SeedEdit": "Edici\xf3n de imagen precisa y natural.",
    "Desc_MidjourneyVideo": "Generaci\xf3n de video creativa y art\xedstica.",
    "Desc_Seedance": "Creaci\xf3n de video realista y expresiva.",
    "Tips_Uninitialized_Chat": "Error al enviar mensajes",
    "Tips_NotFound_Chat": "El chat no existe",
    "Dropdown_BrandKit_Title": "Kit de marca",
    "Dropdown_BrandKit_Desc": "Selecciona un estilo de marca como referencia para este dise\xf1o.",
    "Dropdown_NoReference_Option": "No hay referencia disponible",
    "Dropdown_Example_Option": "Ejemplo",
    "Action_SeeAll": "Ver todo",
    "Dropdown_Models_Title": "Modelos",
    "Tool_ImageBgRemover": "Borrador de fondos",
    "Tool_AiBgGenerator": "Generador de fondos con IA",
    "Tool_ImageEnhancer": "Mejorador de imagen",
    "Tool_AiObjectsRemover": "Borrador de objetos con IA",
    "Tool_AiImageExtender": "Ampliador de imagen con IA",
    "Tool_AiLogoGenerator": "Generador de logotipos con IA",
    "Tool_AiModelMannequin": "Modelo de IA: Maniqu\xed",
    "Tool_AiModelFlatlay": "Modelo de IA: Flatlay",
    "Tool_AiImageRecolor": "Recolorear im\xe1genes con IA",
    "Tool_FootwearModel": "Modelo de calzado",
    "Tool_ImageUpscaler": "Refinador de im\xe1genes con IA",
    "Tool_ImageTranslation": "Traducci\xf3n de im\xe1genes",
    "Tool_BatchImageBgRemover": "Borrador de fondos de imagen por lotes",
    "Tool_BatchImageEnhancer": "Mejorador de im\xe1genes por lotes",
    "Tool_BatchAiObjectsRemover": "Borrador de objetos IA por lotes",
    "Tool_VideoEnhancer": "Mejorar el video",
    "Tool_VideoBgRemover": "Borrador de fondos de video",
    "Tool_VideoWatermarkRemover": "Borrador de marca de agua en video",
    "Dropdown_AdvancedFeatures_Title": "Funciones avanzadas",
    "Dropdown_AdvancedFeatures_Conent": "Acceso total a todas las herramientas potenciadas por IA para mejorar tu eficiencia.",
    "Dropdown_MassiveContent_Title": "Gran cantidad de contenido",
    "Dropdown_MassiveContent_Content": "Acceso ilimitado a plantillas premium y a una gran colecci\xf3n de recursos de stock Plus.",
    "Dropdown_CommercialRights_Title": "Derechos comerciales",
    "Dropdown_CommercialRights_Content": "Usa tus creaciones personales con confianza, con protecci\xf3n de derechos de autor garantizada.",
    "Popup_SubscribeIntl_Desc": "Aprovecha al m\xe1ximo X-Design con Pro",
    "Popup_SubscribeIntl_Desc1": "Desbloquea m\xe1s creaciones con cr\xe9ditos",
    "Popup_SubscribeIntl_Detail": "Consulta los detalles de los planes y Ayuda",
    "Popup_StripeCheckout": "Pago con Stripe",
    "Popup_LiveSupport": "Asistencia en vivo",
    "Popup_CancelAnytime": "Cancela en cualquier momento",
    "Menu_ManageSubscriptions": "Administrar suscripciones",
    "Menu_ReferralLink": "Enlace de referencia",
    "Menu_Language": "Idioma",
    "Menu_BenefitsUpgraded": "Beneficios",
    "Menu_TermsPolicies": "T\xe9rminos y pol\xedticas",
    "Menu_AccountManagement": "Cuenta",
    "Title_ReferralCode": "C\xf3digo de referencia",
    "Title_ReferralLink": "Enlace de referencia",
    "Desc_NoActiveSubscription": "No hay una suscripci\xf3n activa",
    "Button_ClickToSubscibe": "Haz clic aqu\xed para suscribirte",
    "Title_SubscriptionCancel": "Tu suscripci\xf3n ha sido cancelada",
    "Title_SeeYou": "Lamentamos que te vayas…\uD83D\uDE2D",
    "Desc_NextBillingDate": "Se renueva el",
    "Desc_EstimatedAmount": "Total estimado",
    "Button_CancelSubscription": "Cancelar suscripci\xf3n",
    "Button_Cancel": "Cancelar",
    "Button_Delete": "Borrar",
    "Button_StaySubscribed": "Mantener suscripci\xf3n",
    "Title_ReasonCancelling": "Selecciona un motivo para cancelar:",
    "Desc_BenefitsContinue": "Puedes seguir disfrutando de los beneficios de tu membres\xeda hasta el fin de la suscripci\xf3n.",
    "Desc_GiftedCredits": "Una vez que venza tu suscripci\xf3n, los cr\xe9ditos de regalo",
    "Desc_SeeYou": "Gracias por acompa\xf1arnos. Lamentamos que te vayas.",
    "Desc_NoNoreCharges": "No se te volver\xe1 a cobrar, tu membres\xeda se mantendr\xe1 activa hasta el",
    "Desc_MayBeRevoked": "podr\xedan revocarse.",
    "Desc_CancelingNoRefund": "Cancelar <span>no incluye un reembolso</span>. Para realizar consultas sobre reembolsos, comun\xedcate con el servicio de asistencia en l\xednea.",
    "Button_Pro": "Obt\xe9n Pro gratis",
    "Tab_Design": "Dise\xf1o",
    "Button_Send": "Enviar",
    "Input_Describe_Workspace": "Describe tu imagen y la crear\xe9 por ti",
    "Tab_AgentCase": "Caso de Agente",
    "Tab_RecentCreations": "Recientes",
    "Tag_Hot": "Tendencias",
    "Tag_BrandDesign": "Dise\xf1o de marca",
    "Tag_Logo": "Logotipos",
    "Tag_Posters": "P\xf3steres",
    "Tag_All": "Todo",
    "Tag_Design": "Dise\xf1o",
    "Sidebar_Tools": "Herramientas de IA",
    "Sidebar_Create": "Inicio",
    "Sidebar_Batch": "Editor por lotes",
    "Sidebar_MyDesigns": "Mis dise\xf1os",
    "Sidebar_Inspire": "Insp\xedrame",
    "Sidebar_Brand": "Kit de marca",
    "Sidebar_Unfold": "Abrir barra lateral",
    "Tab_Agent": "Agente",
    "Tool_AiPhotoEditor": "Editor de imagen",
    "Button_Upload": "Subir",
    "Tool_Designer": "Dise\xf1ador",
    "Button_BlankCanvas": "Crear",
    "Title_AiTool": "Herramientas de IA",
    "Tool_ImageBackgroundRemover": "Eliminador de fondos con IA",
    "Tool_AiBackgroundGenerator": "Generador de fondos con IA",
    "Tool_AiLogo": "Generador de logotipos con IA",
    "Tab_RecentlyCreated": "Recientes",
    "Tab_GenerateRecords": "Creaciones",
    "Menu_Edit": "Editar",
    "Menu_Download": "Descargar",
    "Menu_Delete": "Eliminar",
    "Sidebar_PackUp": "Cerrar barra lateral",
    "Menu_DueToday": "Cr\xe9ditos de bonificaci\xf3n diarios",
    "Menu_DueToday_Explain": "V\xe1lidos hasta el final del d\xeda.",
    "Menu_Else": "Otros cr\xe9ditos",
    "Menu_Else_Explain_AgentCredits": "Cr\xe9ditos de otras fuentes. V\xe1lidos por m\xe1s tiempo.",
    "Title_Total_AgentCredits": "Total: cr\xe9ditos de Agente",
    "Menu_Total_Explain_AgentCredits": "Solo para el Agente de IA y se usar\xe1n primero.",
    "Tips_Credit_Explain_Agent": "\xbfQu\xe9 son los cr\xe9ditos de Agente?",
    "Title_Total_PaidCredits": "Cr\xe9ditos totales comprados",
    "Menu_Total_Explain_PaidCredits": "Para todas las funciones, v\xe1lidos durante la vigencia de la membres\xeda.",
    "Menu_Pro": "Cr\xe9ditos de suscripci\xf3n",
    "Menu_Pro_Explain": "V\xe1lido durante la vigencia de la membres\xeda.",
    "Menu_Else_Explain_PaidCredits": "Cr\xe9ditos de otras fuentes. V\xe1lidos durante la vigencia de la membres\xeda.",
    "Menu_UsageDetail": "Detalles de uso",
    "Tips_Credit_Explain_Paid": "\xbfQu\xe9 son los cr\xe9ditos comprados?",
    "Title_Total_InactiveCredits": "Cr\xe9ditos inactivos totales",
    "Menu_Total_Explain_SuspendCredits": "No estar\xe1n disponibles hasta que se reactive tu membres\xeda.",
    "Button_GoPro_GetMore": "Obt\xe9n m\xe1s cr\xe9ditos",
    "Menu_SuspendCredits": "Cr\xe9ditos inactivos",
    "Menu_AgentCredits": "Cr\xe9ditos de Agente",
    "Menu_Credits": "Cr\xe9ditos",
    "Tab_Invite": "Invitar",
    "Tab_Reward": "Recompensas",
    "Title_AgentCreditForRewards": "Recompensas de cr\xe9ditos de Agente: ",
    "Table_Time": "Fecha y hora",
    "Table_Invitee": "Invitado",
    "Table_AgentCredit": "Cr\xe9ditos de Agente",
    "Title_ShareWithFriends": "Comparte con tus amigos",
    "Title_ShareWithFriends_ExplainOne": '<span style="color:#616266;">\xa1Invita a un amigo y ambos recibir\xe1n </span><span style="color:#2D990C;">${0} cr\xe9ditos de Agente!</span>',
    "Title_ShareWithFriends_ExplainTwo": '<span style="color:#616266;">\xa1Puedes invitar hasta </span><span style="color:#2D990C;">${0} amigos nuevos </span><span style="color:#616266;"> y obtener un m\xe1ximo de ${1} cr\xe9ditos de Agente!</span>',
    "Title_InvitationLink": "Comparte este enlace con tus amigos",
    "Button_Copy": "Copiar",
    "Title_Tips": "Consejos",
    "Title_Tips_ExplainOne": "1. Los cr\xe9ditos de Agente solo se pueden usar para acceder a las funciones del Agente de IA. Los cr\xe9ditos de recompensa son v\xe1lidos por dos a\xf1os.",
    "Title_Tips_ExplainTwo": "2. Los amigos nuevos recibir\xe1n una recompensa despu\xe9s de completar su registro. Si tienes preguntas, comun\xedcate con nuestro equipo de asistencia.",
    "Title_FailedToReceiveReward": "Error en la operaci\xf3n",
    "Title_YouCannotUseYourOwnLink": "No se permiten los enlaces privados",
    "Title_FailedToReceiveReward_Explain": "Si tienes preguntas, comun\xedcate con nuestro equipo de asistencia.",
    "Button_Ok": "Entendido",
    "Button_Invite": "Invitar",
    "Title_AgentCredits": "+50 cr\xe9ditos de Agente",
    "Title_GetRewarded": "\xa1Invitaci\xf3n exitosa!",
    "Title_GetRewarded_Explain": "Los cr\xe9ditos solo se pueden usar para las funciones del Agente de IA y son v\xe1lidos por dos a\xf1os.",
    "Tips_Copied": "\xa1Copiado!",
    "Menu_Total": "Total",
    "Menu_Else_AgentCredits": "Otros cr\xe9ditos",
    "Input_Describe_workspace": "Describe tu imagen y la crear\xe9 por ti",
    "Tool_AiBackgroundGenrator": "Generador de fondos con IA",
    "Input_Models": "Modelo",
    "Button_TryItNow": "Pru\xe9balo ahora",
    "\xa0Tab_RecentCreations_Agent": "Agente",
    "\xa0Tab_RecentCreations_Design": "Herramientas inteligentes",
    "Account_Pricing": "Precios",
    "Account_Language": "Idioma",
    "Account_Language_English": "Ingl\xe9s",
    "Account_Language_Chinese": "Chino",
    "Dropdown_SaveToBrandKit": "Guardar como logotipo de marca",
    "Dropdown_SaveToBrandTemplate": "Guardar como plantilla de marca",
    "Tab_RecentCreations_Agent": "Agente",
    "Tab_RecentCreations_Design": "Herramientas inteligentes",
    "Menu_FunctionalPricing": "Precios del Agente",
    "Title_FeaturePricing": "Precios del Agente",
    "Tab_Category": "Categor\xeda",
    "Tab_TaskType": "Tarea",
    "Tab_Consume": "Precio (cr\xe9ditos)",
    "Tab_ExampleContent": "Ejemplos",
    "Tips_CreditExplain_Inactive": "\xbfQu\xe9 son los cr\xe9ditos inactivos?",
    "Title_NanoPro": "\uD83C\uDF4C\uD83C\uDF4CNano Banana Pro ya est\xe1 disponible en X-Design.",
    "Title_Workspace": "Tu Agente creativo de IA para el branding",
    "Menu_InviteReward": "Recompensa por invitar amigos",
    "Title_NoDesigns": "A\xfan no hay dise\xf1os.",
    "Title_NoGenerations": "A\xfan no hay generaciones.",
    "Desc_NoDesigns": "Tus dise\xf1os aparecer\xe1n aqu\xed.",
    "Desc_NoGenerations": "Tus generaciones aparecer\xe1n aqu\xed.",
    "Title_DeleteDesign": "Borrar este dise\xf1o",
    "Popup_DeleteDesign": "\xbfDeseas borrar este dise\xf1o de forma permanente? Esta acci\xf3n no se puede deshacer.",
    "Title_LoginPopup": "Inicia sesi\xf3n para desbloquear tu prueba gratuita",
    "SubTitle_LoginPopup": "Comienza a crear con X-Design hoy",
    "Button_GotIt": "Entendido",
    "Title_Congrats": "Felicitaciones",
    "SubTitle_BrandCreate": "Creaste tu primer kit de marca: \xa1es hora de explorar su potencial!",
    "Button_CheckUse": "Echa un vistazo ahora",
    "Chat_Prompt_Brand": "Crea un p\xf3ster promocional",
    "Tooltip_UseBrand": "\xa1Aqu\xed puedes cambiar o agregar tu kit de marca!",
    "Tooltip_PosterBrand": "Toca para crear tu primer p\xf3ster a partir de tu kit de marca",
    "Popup_CreateBrand": "Crea una marca desde cero",
    "Desc_CreateBrand": "Crea sorprendentes logotipos originales con nuestro Agente de IA.",
    "Popup_UploadBrand": "Sube la informaci\xf3n de tu marca",
    "Desc_UploadBrand": "S\xfabelo y X-Design mantendr\xe1 todos los dise\xf1os alineados.",
    "Title_BrandEntry": "Obt\xe9n un sistema de marca personalizado ahora",
    "Desc_BrandEntry": "Deja que nuestra IA se encargue del estilo. Responde unas cuantas preguntas y recibe un sistema de marca completo que se adapte a tu visi\xf3n.",
    "Tooltip_UseBrand_Agent": "Una vez que se aplique el kit de marca, el dise\xf1o se remitir\xe1 autom\xe1ticamente al logotipo, la paleta de color y el estilo general.",
    "Tooltip_PosterBrand_Agent": "Todo listo para que dise\xf1es con tu kit de marca",
    "MenuItem_AiChange": "Edici\xf3n con IA",
    "MenuItem_AiExpend": "Ampliador con IA",
    "MenuItem_AiHD": "Claridad con IA",
    "MenuItem_Eliminate": "Eliminaci\xf3n con IA",
    "MenuItem_SplitLayers": "Dividir capas",
    "MenuItem_Cutout": "Eliminador de fondos",
    "MenuItem_ChangeText": "Reemplazar texto",
    "MenuItem_AddToChat": "Agregar al chat",
    "MenuItem_AddToBrand": "Agregar al Kit de marca",
    "MenuItem_AddToBrandLogo": "Guardar como logotipo de marca",
    "MenuItem_AddToBrandTemplate": "Guardar como plantilla de marca",
    "Button_ExportImage": "Importar im\xe1genes",
    "Button_ExportMedia": "Importar videos",
    "Placeholder_ChatInput": "\xa1Comencemos!",
    "Tooltip_Grab": "Herramienta de mano",
    "Placeholder_ImageFusion": "Dime c\xf3mo te gustar\xeda que se fusionen las im\xe1genes",
    "Button_ImageFusion": "Fusionar",
    "Button_AiChange": "Editar",
    "Placeholder_AiChange": "Dime qu\xe9 quieres cambiar",
    "BatchProcessTable_ImageType": "Tipo de imagen",
    "BatchProcessTable_PictureRequirement": "Detalles de dise\xf1o",
    "BatchProcessTable_CopywritingRequirements": "Descripci\xf3n del producto",
    "BatchProcessTable_Actions": "Acci\xf3n",
    "BatchProcessTable_AddOneRow": "Agregar",
    "EditBatchProcess_Tip": "Cualquier cambio a las directrices afectar\xe1 los resultados generados.",
    "EditBatchProcess_Start": "Comienza con una directriz",
    "EditBatchProcess_GenerateTip": "Sube tus im\xe1genes de producto y se generar\xe1n dise\xf1os basados en las directrices.",
    "Title_Request": "Chat",
    "Title_ChooseImageType": "Selecciona el tipo de imagen generada (m\xfaltiples opciones)",
    "Text_ChatCancelStatus": "Tarea terminada",
    "langding_more_bg_remover": "Eliminador de fondo",
    "langding_more_enhancer": "Mejorador de imagen",
    "langding_more_objects_remover": "Borrador de objetos con IA",
    "langding_more_bg_generator": "Generador de fondos con IA",
    "Title_More1_Home": "Mejorador de imagen",
    "Title_More2_Home": "Borrador de objetos con IA",
    "Title_More3_Home": "Generador de fondos con IA",
    "Title_More4_Home": "Eliminador de fondos con IA",
    "Title_More5_Home": "Herramientas de im\xe1genes por lotes",
    "Title_Home": "Tu Agente de IA para el dise\xf1o de <span>e-commerce</span>",
    "Placeholder_Input_Home": "Describe tu imagen y la crear\xe9 por ti.",
    "Title_Card4_Home": "Recursos visuales para Amazon",
    "Title_Card1_Home": "Im\xe1genes de prueba de ropa y accesorios",
    "Title_Card3_Home": "Im\xe1genes de la p\xe1gina de detalles del producto",
    "Title_Card2_Home": "Generador de fondos",
    "Desc_Features1_Home": "La IA extrae autom\xe1ticamente las caracter\xedsticas del producto y las preferencias de estilo para determinar las soluciones ideales de dise\xf1o.",
    "Desc_Features2_Home": "Solo ingresa una oraci\xf3n y la IA generar\xe1 una colecci\xf3n completa de im\xe1genes para e-commerce, incluyendo la imagen principal, recursos visuales de apoyo y una p\xe1gina completa de detalles del producto.",
    "Text_Btn_Home": "Comienza gratis",
    "Desc_Features3_Home": "Crea autom\xe1ticamente recursos visuales listos para distintas plataformas, como Amazon, Etsy, TEMU, eBay y m\xe1s. Esto garantiza que las im\xe1genes siempre est\xe9n optimizadas para atraer al p\xfablico adecuado.",
    "Desc_Features4_Home": "Solo ingresa tu solicitud y la IA adaptar\xe1 el lenguaje, estilo, tono y los elementos culturales para producir versiones localizadas para cada mercado objetivo.",
    "Desc_Features5_Home": "Guarda el flujo de trabajo de tu dise\xf1o como una plantilla reutilizable y deja que la IA genere autom\xe1ticamente im\xe1genes por lotes para todos tus SKU.",
    "Desc_Features6_Home": "Sin importar si trabajas con 10 o 1,000\xa0productos, puedes producir r\xe1pidamente un conjunto visual completo y uniforme.",
    "Title_Qualification_Home": "\xa1Avalado por m\xe1s de 5\xa0millones de vendedores de e-commerce!",
    "Text_Btn_Qualification_Home": "Ver certificaci\xf3n",
    "Title_Carousel_Home": "M\xe1s herramientas de IA",
    "Title_Footer_Home": "Tu Agente de IA para el dise\xf1o de e-commerce",
    "Title_Footer1_Home": "Cuenta de redes sociales",
    "Subtitle_Footer1_Home": "YouTube",
    "Subtitle_Footer2_Home": "X",
    "Subtitle_Footer3_Home": "Instagram",
    "Subtitle_Footer4_Home": "TikTok",
    "Title_Footer2_Home": "Ayuda y legal",
    "Subtitle_Footer5_Home": "T\xe9rminos de servicio",
    "Subtitle_Footer6_Home": "Pol\xedtica de privacidad",
    "Copyright_Footer_Home": "Copyright ${0} Meitu, Inc.",
    "Desc_Evaluation1_Home": "\xa1Me encanta Designkit! Las im\xe1genes de estilo de vida generadas con IA son naturales: c\xe1lidas y de estilo n\xf3rdico, perfectas para mi tienda de velas. Mis publicaciones se ven incre\xedbles y las ventas aumentaron. Vale la pena.",
    "Job_Evaluation5_Home": "Vendedora de TEMU en M\xe9xico",
    "Job_Evaluation6_Home": "Especialista de operaciones de Amazon",
    "Job_Evaluation12_Home": "Gerente de una tienda de Amazon con m\xfaltiples SKU en Indonesia",
    "Job_Evaluation2_Home": "Due\xf1o de tienda en Amazon y Mercado Libre",
    "Name_Evaluation12_Home": "Arif",
    "Desc_Evaluation11_Home": "Las im\xe1genes de estilo de vida se ven muy naturales, casi como si las hubiera tomado un profesional. A mis clientes tambi\xe9n les encantan, pues he notado que mis tasas de conversi\xf3n est\xe1n subiendo.",
    "Name_Evaluation11_Home": "Siti",
    "Job_Evaluation10_Home": "Propietario de una tienda transfronteriza en Lazada y Shopee (Indonesia)",
    "Name_Evaluation10_Home": "Nina",
    "Job_Evaluation3_Home": "Dise\xf1ador de e-commerce DTC",
    "Job_Evaluation8_Home": "Propietario de una tienda de productos de exteriores para Walmart en Estados Unidos",
    "Name_Evaluation8_Home": "Jason",
    "Job_Evaluation9_Home": "Vendedor de Mercado Libre en Argentina",
    "Desc_Evaluation7_Home": "\xa1Las escenas de los productos para mascotas que genera la IA son s\xfaper lindas! Los perros y gatos se ven perfectamente proporcionados y naturales. Adem\xe1s, el tama\xf1o y la escala coinciden con los requisitos de la plataforma, por lo que las im\xe1genes son realmente f\xe1ciles de usar de inmediato.",
    "Job_Evaluation7_Home": "Propietario de una tienda de Mercado Libre en Brasil",
    "Desc_Evaluation8_Home": "Las escenas que uso para mis tiendas de campa\xf1a son muy realistas. La iluminaci\xf3n y los \xe1ngulos se ven naturales, y las proporciones son exactas. Me ahorra much\xedsimo tiempo en comparaci\xf3n con hacerlo todo por mi cuenta.",
    "Name_Evaluation7_Home": "Thiago",
    "Desc_Evaluation9_Home": "La herramienta es realmente r\xe1pida y las im\xe1genes que genera pueden subirse casi directamente a Mercado Libre y Amazon sin modificaciones.",
    "Desc_Evaluation6_Home": "Antes me preocupaba que la IA hiciera un desastre con las texturas de la tela, pero apenas se ven diferentes del original. Los tejidos parecen tejidos, la mezclilla parece mezclilla e incluso cumple los requisitos de imagen de Amazon. Lanzar productos nuevos ahora es mucho m\xe1s r\xe1pido.",
    "Name_Evaluation9_Home": "Lucas",
    "Name_Evaluation6_Home": "Emma",
    "Desc_Evaluation5_Home": "Las im\xe1genes de producto generadas con IA son realmente precisas. La longitud del cable y la forma de los conectores son exactas, e incluso coinciden con el estilo de TEMU. Es un gran ahorro de tiempo en comparaci\xf3n con tomar las fotos yo mismo.",
    "Desc_Evaluation12_Home": "Con una sola indicaci\xf3n, puedo obtener gr\xe1ficos utilizables al instante, lo cual es mucho m\xe1s r\xe1pido que esperar al dise\xf1ador. Honestamente, es s\xfaper conveniente.",
    "Name_Evaluation3_Home": "Chloe",
    "Name_Evaluation1_Home": "Sofia",
    "Desc_Evaluation4_Home": "Las texturas met\xe1licas y los detalles estructurales son muy claros, as\xed que las im\xe1genes se ven profesionales. Puedo usarlas al instante sin editarlas.",
    "Name_Evaluation4_Home": "Le\xf3n",
    "Desc_Evaluation10_Home": "La generaci\xf3n por lotes es s\xfaper conveniente. Puedo procesar decenas de SKU a la vez, y es mucho m\xe1s r\xe1pido que hacer todo manualmente como antes.",
    "Name_Evaluation2_Home": "Mariana",
    "Desc_Evaluation3_Home": "Vendo ropa y me preocupaba que la IA hiciera un desastre con los colores o las texturas de las telas, pero de hecho lo hizo muy bien. Las poses de la modelo se ven naturales y las im\xe1genes quedan pr\xe1cticamente listas para usarse al instante.",
    "Job_Evaluation1_Home": "Especialista de operaciones de una tienda de SHEIN",
    "Name_Evaluation5_Home": "Diego",
    "Job_Evaluation11_Home": "Especialista de operaciones de Amazon",
    "Desc_Evaluation2_Home": "La herramienta es s\xfaper r\xe1pida y las im\xe1genes quedan pr\xe1cticamente listas para subir a Mercado Libre o Amazon. Incluso adapta los fondos y los modelos a los gustos locales, y los resultados se ven totalmente profesionales.",
    "Job_Evaluation4_Home": "Vendedor de eBay en Alemania",
    "Title_Evaluation_Home": "Sus historias",
    "Title_Introduction_Home": "Dise\xf1o premium con IA que impulsa las ventas",
    "Desc_Qualification_Home": "Proveedor certificado de servicios SPN de Amazon",
    "Title_Seo_Home": "Generador de imagen y video de producto con IA para e-commerce",
    "Desc_Seo_Home": "Genera instant\xe1neamente im\xe1genes de producto, p\xf3steres y videos para Amazon, TikTok y otras tiendas en l\xednea con el Agente de IA de Designkit. \xa1Comienza a dise\xf1ar sin costo hoy!<br>",
    "Keywords_Seo_Home": "Agente de IA para e-commerce, Herramientas de IA para e-commerce, Generador de imagen de producto con IA, Generador de video de producto con IA, Editor de foto de producto con IA, Eliminador fondo con IA",
    "Title_Features1_Home": "De una sola solicitud a un conjunto completo de recursos visuales",
    "Title_Features2_Home": "Localizaci\xf3n completamente automatizada para vender tus productos a nivel global en m\xfaltiples plataformas",
    "Title_Features3_Home": "Genera autom\xe1ticamente im\xe1genes por lotes para m\xfaltiples SKU, \xa1y vence a la competencia!",
    "Title_Designkit_Home": "Designkit",
    "Tips_AboveTheFold2_Home": "Despl\xe1zate para explorar",
    "Button_Export": "Descargar",
    "Title_Layer": "Capas",
    "InputNumber_Opacity": "Opacidad",
    "Buttom_Comfirm": "Confirmar",
    "Button_Share": "Compartir",
    "Tip_ModalTitle": "Recordatorio",
    "TipContent_HistoryDelete": "Despu\xe9s de borrarlo, no se podr\xe1 restablecer este registro. \xbfConfirmas que deseas borrarlo?",
    "Title_Logo": "Logotipo",
    "Title_BrandKit": "Plantillas",
    "Tab_BrandKit": "Kit de marca",
    "Tab_UploadLocal": "Elegir del \xe1lbum",
    "Button_UploadImage": "Subir im\xe1genes",
    "Tip_ClickDragParseImage": "Sube, suelta o pega im\xe1genes aqu\xed.",
    "Tooltip_SwitchBrandKit": "Cambiar el kit de marca",
    "Discribe_BrandKitSelect": "Selecciona un estilo de marca como referencia para este dise\xf1o.",
    "Title_Models": "Modelos",
    "MenuItem_Crop": "Tama\xf1o de la imagen",
    "Tooltip_Layer": "Capas",
    "Tooltip_Select": "Seleccionar",
    "Tooltip_Redo": "Rehacer",
    "Tooltip_Undo": "Deshacer",
    "Tooltip_Add": "Agregar",
    "Tooltip_ShowAll": "Mostrar todo",
    "Tip_UploadType": "Formato de archivo no admitido",
    "Tip_UploadSize": "Solo se admiten archivos de hasta ${0}\xa0MB",
    "Tip_UploadWH": "Aseg\xfarate de que cada imagen tenga menos de ${0}\xd7${1} p\xedxeles",
    "Tip_UploadTypeTranslate": "Error al cambiar el formato de archivo",
    "Tip_UploadFail": "Error al subir",
    "Tooltip_AddText": "Agregar texto",
    "Text_AddDefault": "Esto es un texto de muestra.",
    "Tooltip_OverflowImageSize": "Cambia el tama\xf1o de tu imagen a menos de ${0}\xa0p\xedxeles",
    "Button_Eliminate": "Borrador",
    "Label_OriginSize": "Original",
    "Label_CropRadio": "Relaci\xf3n de aspecto",
    "Button_Free": "Gratis",
    "Button_Origin": "Original",
    "Button_Crop": "Recortar",
    "Placeholder_ChangeText": "Ingresa texto. Ejemplo: Hola",
    "Button_ChangeText": "Confirmar",
    "InputNumber_PanSize": "Tama\xf1o del pincel",
    "Label_TargetSize": "Objetivo",
    "Tooltip_ImageFusion": "Puedes fusionar de ${0} a ${1}\xa0im\xe1genes",
    "Button_ClearSelection": "Deseleccionar",
    "Button_Confirm": "Confirmar",
    "Message_Processing": "Procesando…",
    "Title_Opacity": "Opacidad",
    "Button_ExpandImage": "Ampliador",
    "Button_ExpandRadio": "Relaci\xf3n de aspecto",
    "Message_SaveFail": "Error al guardar",
    "Title_Pricing": "Elige el plan adecuado para ti",
    "Title_Tags1_Pricing": "Mensual",
    "Title_Tags2_Pricing": "Anual",
    "Title_Plan1_Pricing": "Gratis",
    "BatchProcessTable_Proportion": "Relaci\xf3n de aspecto",
    "BatchProcessList_DeleteError": "Error al borrar",
    "BatchProcessList_SurePrompt": "\xbfDeseas borrar esta directriz?",
    "BatchProcessList_SurePrompt_SureText": "Confirmar",
    "BatchProcessList_SurePrompt_CancelText": "Cancelar",
    "BatchProcessList_EmptyText": "Vac\xedo",
    "EditBatchProcess_NameLimitTip": "Ingresa un nombre (hasta 10\xa0caracteres)",
    "Button_Continue": "Continuar",
    "Button_EditContent": "Editar mensaje",
    "Button_BatchGenerate": "Confirmado. Ejecuta la plantilla ahora.",
    "Text_ChatRespondedStatus": "Procesamiento de tarea",
    "Title_CreateBrand": "\xbfNo tienes una marca?",
    "Title_UploadBrand": "\xbfYa tienes un logotipo?",
    "Button_CreateBrand": "Crear una marca",
    "Button_UnlockPro": "Desbloquear Pro",
    "Button_UpgradeToPro": "Actualizar a Pro",
    "Button_RenewNow": "Renovar ahora",
    "Tips_Material1_Home": "Conjunto de im\xe1genes para publicaciones",
    "Tips_Material2_Home": "Prueba virtual",
    "Tips_Material3_Home": "Contenido A+",
    "Tips_Material4_Home": "Generador de fondos",
    "Free_Button_Home": "Probar gratis",
    "Title_Header1_Home": "Producto",
    "Title_Header2_Home": "soluci\xf3n",
    "Title_Header3_Home": "Inspiraci\xf3n",
    "Title_Header4_Home": "Aprender",
    "Title_Header5_Home": "Precios",
    "SecondTitle_Header1_Home": "Agente de e-commerce con IA",
    "SecondTitle_Header2_Home": "Herramientas de imagen con IA",
    "SecondTitle_Header3_Home": "Herramientas de video con IA",
    "SecondTitle_Header4_Home": "Soluci\xf3n de dise\xf1o de Amazon",
    "SecondTitle_Header5_Home": "Soluci\xf3n de e-commerce para redes sociales",
    "Text_Discount_Pricing": "${0} de descuento",
    "Current_Plan_Pricing": "Plan actual",
    "Title_Instruction1_Pricing": "Obt\xe9n 20 cr\xe9ditos por el primer inicio de sesi\xf3n",
    "Title_Instruction2_Pricing": "Genera hasta 20 im\xe1genes con el Agente de IA",
    "Title_Instruction3_Pricing": "Genera hasta 10 im\xe1genes con el Generador de fondos con IA",
    "Title_Rights1_Pricing": "Eliminaci\xf3n limitada de fondos u objetos",
    "Title_Rights3_Pricing": "Mejora limitada de im\xe1genes en HD",
    "Title_Plan2_Pricing": "Plan B\xe1sico",
    "Month_Plan_Pricing": "mes",
    "Title_Button1_Pricing": "Suscr\xedbete",
    "Title_Instruction4_Pricing": "500 cr\xe9ditos/mes",
    "Title_Instruction5_Pricing": "Genera hasta 500 im\xe1genes con el Agente de IA",
    "Title_Instruction6_Pricing": "Genera hasta 250 im\xe1genes con el Generador de fondos con IA",
    "Title_Plan3_Pricing": "Plan Pro",
    "Desc_Plan_Pricing": "Prueba gratuita de 7 d\xedas. Luego ${0}/a\xf1o.",
    "Title_Button2_Pricing": "Prueba gratuita de 7 d\xedas",
    "Title_Instruction7_Pricing": "1,500 cr\xe9ditos/mes",
    "Title_Instruction8_Pricing": "Genera hasta 1,500 im\xe1genes con el Agente de IA",
    "Title_Instruction9_Pricing": "Genera hasta 750 im\xe1genes con el Generador de fondos con IA",
    "Title_Rights4_Pricing": "Eliminaci\xf3n ilimitada de fondos u objetos",
    "Title_Rights5_Pricing": "Uso ilimitado de la funci\xf3n Eliminaci\xf3n con IA",
    "Title_Rights6_Pricing": "Mejora de im\xe1genes en UHD ilimitada",
    "Title_Rights7_Pricing": "Herramientas de procesamiento por lotes",
    "Title_Best_Pricing": "Elegido por el 90 % de los usuarios",
    "Title_AllFeatures_Pricing": "Compara los planes Gratuito y Pago",
    "Desc_AllFeatures_Pricing": "Desbloquea Premium para crear dise\xf1os sorprendentes sin esfuerzo con herramientas avanzadas de IA",
    "Month_AllFeatures_Pricing": "mes",
    "Title_Features1_Pricing": "Agente de IA",
    "SubTitle_Features1_Pricing": "Edici\xf3n de im\xe1genes",
    "SubTitle_Features15_Pricing": "Genera hasta ${0}\xa0im\xe1genes",
    "SubTitle_Features16_Pricing": "Genera hasta ${0}\xa0im\xe1genes/mes",
    "SubTitle_Features2_Pricing": "Generaci\xf3n de im\xe1genes",
    "SubTitle_Features3_Pricing": "Generaci\xf3n de im\xe1genes para e-commerce",
    "SubTitle_Features4_Pricing": "Generaci\xf3n de p\xf3steres",
    "Title_Features2_Pricing": "Herramientas de imagen con IA",
    "SubTitle_Features5_Pricing": "Eliminador de fondos con IA",
    "SubTitle_Features17_Pricing": "Uso limitado",
    "SubTitle_Features19_Pricing": "Uso ilimitado",
    "SubTitle_Features6_Pricing": "Borrador de objetos con IA",
    "SubTitle_Features7_Pricing": "Mejorador de imagen",
    "SubTitle_Features18_Pricing": "Uso limitado (HD)",
    "SubTitle_Features20_Pricing": "Uso ilimitado (HD/UHD)",
    "SubTitle_Features8_Pricing": "Refinador de im\xe1genes con IA",
    "SubTitle_Features9_Pricing": "Ampliador de im\xe1genes con IA",
    "SubTitle_Features10_Pricing": "Generador de fondos con IA",
    "Title_Features3_Pricing": "M\xe1s funciones de dise\xf1o",
    "SubTitle_Features11_Pricing": "Funciones avanzadas y plantillas",
    "SubTitle_Features12_Pricing": "Eliminar marca de agua",
    "SubTitle_Features13_Pricing": "Herramientas de im\xe1genes con IA por lotes",
    "SubTitle_Features14_Pricing": "Funciones de dise\xf1o b\xe1sicas",
    "Title_Credits_Pricing": "\xbfTe est\xe1s quedando sin cr\xe9ditos? Nosotros nos encargamos.",
    "Desc_Credits_Pricing": "Compra \xfanica, no se requiere suscripci\xf3n.",
    "TransactionPrice_Credits_Pricing": "Precio: ${0}",
    "Credit_Credits_Pricing": "Cr\xe9ditos",
    "Popular_Credits_Pricing": "M\xe1s popular",
    "Buy_Credits_Pricing": "Comprar ahora",
    "Title_FAQ_Pricing": "Preguntas frecuentes",
    "Title_Button4_Pricing": "Actualiza ahora y obt\xe9n una prueba gratuita de 7\xa0d\xedas",
    "Title_Button3_Pricing   ": "Beneficios disponibles",
    "SubTitle_FAQ1_Pricing": "\xbfQu\xe9 son los cr\xe9ditos?",
    "Content_FAQ1_Pricing": "Los cr\xe9ditos te permiten seguir accediendo a las herramientas de IA. La cantidad de cr\xe9ditos necesaria var\xeda dependiendo de la herramienta espec\xedfica.",
    "Content_FAQ2_Pricing": "Los cr\xe9ditos comprados son v\xe1lidos por un a\xf1o.",
    "Content_FAQ3_Pricing": "Los cr\xe9ditos de membres\xeda son v\xe1lidos durante el per\xedodo de la membres\xeda.",
    "SubTitle_FAQ2_Pricing": "\xbfC\xf3mo cancelo mi suscripci\xf3n y qu\xe9 suceder\xe1 con mis cr\xe9ditos despu\xe9s de la cancelaci\xf3n?",
    "Content_FAQ4_Pricing": "Despu\xe9s de cancelar tu suscripci\xf3n,",
    "Content_FAQ5_Pricing": "los cr\xe9ditos de tu membres\xeda seguir\xe1n siendo v\xe1lidos hasta que expire tu membres\xeda. Los cr\xe9ditos que hayas comprado por separado no se ver\xe1n afectados.",
    "Content_FAQ6_Pricing": "Si necesitas cancelar tu suscripci\xf3n, sigue estos pasos al menos 24\xa0horas antes de que comience el siguiente ciclo de facturaci\xf3n:",
    "Content_FAQ7_Pricing": "1. Inicia sesi\xf3n en Designkit.",
    "Content_FAQ8_Pricing": "2. Ingresa a la ventana emergente de suscripci\xf3n.",
    "Content_FAQ9_Pricing": '3. Selecciona "Administrar suscripciones".',
    "Content_FAQ10_Pricing": '4. Selecciona tu plan actual y haz clic en "Cancelar suscripci\xf3n".',
    "Content_FAQ11_Pricing": "Tu suscripci\xf3n seguir\xe1 activa hasta el final del ciclo de facturaci\xf3n actual. Si no puedes cancelarla, toma una captura de pantalla y comun\xedcate con nuestro en servicio de asistencia en l\xednea lo antes posible",
    "SubTitle_FAQ3_Pricing": "\xbfCu\xe1l es su pol\xedtica de reembolsos?",
    "Content_FAQ12_Pricing": "1. Garant\xeda de devoluci\xf3n del dinero de 7\xa0d\xedas:",
    "SubTitle_FAQ4_Pricing": "\xbfC\xf3mo puedo aumentar o disminuir mi suscripci\xf3n?",
    "Content_FAQ25_Pricing": "1. Mejora: puedes suscribirte f\xe1cilmente a un plan de nivel superior, que entrar\xe1 en vigor inmediatamente. Tu suscripci\xf3n anterior se cancelar\xe1 y se reembolsar\xe1 el saldo restante.",
    "SubTitle_FAQ5_Pricing": "\xbfPuedo obtener una copia de mi factura?",
    "Content_FAQ27_Pricing": "\xa1S\xed! Una vez realizado el pago, recibir\xe1s un correo electr\xf3nico del proveedor de pago con una factura electr\xf3nica. Si no la recibes, comun\xedcate con nuestro equipo de asistencia.",
    "SubTitle_FAQ6_Pricing": "\xbfQu\xe9 m\xe9todos de pago aceptan?",
    "Content_FAQ28_Pricing": "Usamos Stripe para administrar pagos y suscripciones. Aceptamos las principales tarjetas de cr\xe9dito, PayPal y Google Pay.",
    "SubTitle_FAQ7_Pricing": "\xbfC\xf3mo me comunico con el servicio de asistencia?",
    "Content_FAQ29_Pricing": "Correo electr\xf3nico: support@designkit.com; tiempo de respuesta: de 3 a 10 d\xedas h\xe1biles.",
    "Content_FAQ13_Pricing": "Si compraste suscripciones y no las utilizaste en un plazo de 7\xa0d\xedas, podr\xedas recibir un reembolso total.",
    "Content_FAQ14_Pricing": "Si compraste cr\xe9ditos, podr\xedas recibir un reembolso por los cr\xe9ditos no utilizados en un plazo de 7\xa0d\xedas.",
    "Content_FAQ15_Pricing": "2. Disconformidad con el servicio",
    "Content_FAQ16_Pricing": "Si no te satisfacen los resultados, comun\xedcate con nuestro equipo de asistencia en l\xednea. Podr\xedamos ofrecerte una compensaci\xf3n o un reembolso dependiendo de las circunstancias.",
    "Content_FAQ17_Pricing": "3. Compras mediante Google Play o App Store",
    "Content_FAQ18_Pricing": "Si te suscribiste mediante Google Play Store o App Store, debes solicitar un reembolso directamente a Google o Apple.",
    "Content_FAQ19_Pricing": "Notas importantes:",
    "Content_FAQ20_Pricing": "Esta pol\xedtica de reembolso no aplica para usuarios de la API. Si usas nuestra API, comun\xedcate con nosotros para saber si cumples con los requisitos para un reembolso.",
    "Content_FAQ21_Pricing": "Nos reservamos el derecho a denegar reembolsos en casos de mal uso, abuso o incumplimiento de nuestros t\xe9rminos.",
    "Content_FAQ22_Pricing": "Los reembolsos pueden tomar varios d\xedas h\xe1biles en procesarse, dependiendo de tu m\xe9todo de pago.",
    "Content_FAQ23_Pricing": "Es posible que actualicemos esta pol\xedtica de reembolso de vez en cuando. Cons\xfaltala peri\xf3dicamente para conocer los cambios.",
    "Content_FAQ24_Pricing": "Para recibir ayuda adicional, comun\xedcate con nuestro equipo de asistencia.",
    "Content_FAQ26_Pricing": "2. Disminuci\xf3n: primero, cancela tu suscripci\xf3n actual. Cuando termine tu per\xedodo de facturaci\xf3n actual, suscr\xedbete al plan nuevo.",
    "Content_Modal_Pricing": "\xa1Gracias por tu apoyo! Prep\xe1rate para llevar tu creatividad al siguiente nivel.",
    "Tip_Modal_Pricing": "Sugerencias: si tu membres\xeda a\xfan no aparece, actualiza la p\xe1gina.",
    "Title_Modal_Pricing": "Compra realizada con \xe9xito",
    "Title_Rights2_Pricing": "Uso limitado de la funci\xf3n Eliminaci\xf3n con IA",
    "Title_Button3_Pricing": "Beneficios disponibles",
    "Title_Button5_Pricing": "Mejorar",
    "BatchProcess_SaveSuccessTip": "Tus kits de flujo de trabajo se guardan aqu\xed.",
    "BatchProcess_createText": "Kit de flujo de trabajo",
    "Label_NormalMode": "B\xe1sico:",
    "Label_AdvancedMode": "Avanzado:",
    "Text_NormalMode": "B\xe1sico",
    "Text_AdvancedMode": "Avanzado",
    "BatchProcess_DefaultPrompt": "Generar im\xe1genes",
    "BatchProcess_EditContent": "Editar contenido",
    "BatchProcess_PleaseSelect": "Selecciona un kit de flujo de trabajo",
    "BatchProcess_SelectTip": "Todas las im\xe1genes subidas se generar\xe1n en lote usando el kit de flujo de trabajo seleccionado.",
    "BatchProcess_ListEmptyTip": "Guarda el kit de flujo de trabajo despu\xe9s de generarlo para crear conjuntos similares en lotes al instante.",
    "BatchProcess_Tip": "Kit de flujo de trabajo",
    "BatchProcess_Generate": "\xdasalo ahora",
    "BatchProcess_Save": "Guardar",
    "BatchProcess_GeneratingFormula": "Generando kit de flujo de trabajo…",
    "BatchProcess_GenerateCancel": "Cancelar",
    "BatchProcess_WorkFlowCreateError": "Error al crear",
    "ProductInfo_PleaseUploadImage": "Sube im\xe1genes de producto",
    "BatchProcess_IntelligenceGenerate": "Crea un kit de flujo de trabajo",
    "BatchProcess_CreateWorkflow": "Crear",
    "BatchProcess_Formula": "Kit de flujo de trabajo",
    "BatchProcess_WorkFlowSaveSuccess": "Kit de flujo de trabajo guardado",
    "ProductInfo_ImageSizeLimit": "Se admiten im\xe1genes de menos de ${0}\xa0MB",
    "ProductInfo_ImageUpload": "Agrega imagen de producto",
    "ProductInfo_UploadDemo": "Fotos de ejemplo",
    "ProductInfo_ECPlatform": "Plataforma",
    "ProductInfo_PleaseSelect": "Selecciona",
    "ProductInfo_InputCustomize": "Personalizado",
    "ProductInfo_CountryAndLanguage": "Regi\xf3n/idioma de destino",
    "ProductInfo_Name": "Nombre del producto",
    "ProductInfo_Desc": "Detalles del producto (caracter\xedsticas/tama\xf1o/escenarios de uso)",
    "ProductInfo_DescPlaceholder": "Ingresa informaci\xf3n del producto como caracter\xedsticas, tama\xf1o, escenarios de uso, p\xfablico objetivo, etc.",
    "ProductInfo_NamePrompt": "El nombre del producto es ${0};",
    "ProductInfo_ECPlatformPrompt": "La plataforma de destino es ${0};",
    "ProductInfo_CountryAndLanguagePrompt": "El idioma es ${0};",
    "ProductInfo_DescPrompt": "Los detalles del producto son ${0}.",
    "ProductInfo_PleaseInput": "Por favor, ingresa",
    "AgentEmpty_CaseUseBtn": "Usar",
    "AgentEmpty_CaseRefreshBtn": "Actualizar",
    "MenuItem_Effect": "Efectos",
    "MenuItem_Shadow": "Sombras",
    "MenuItem_Stroke": "Trazo",
    "Button_Logout": "Cerrar sesi\xf3n",
    "Tip_UploadMax": "Sube archivos JPG, JPEG o PNG de hasta ${0}\xa0MB, con un m\xe1ximo de N im\xe1genes.",
    "Menu_ManageSubscription": "Administrar suscripciones",
    "Menu_TermsPolices": "T\xe9rminos y pol\xedticas",
    "Title_ChangeText": "Reemplazar texto",
    "Message_ExtractText": "Extrayendo texto",
    "Message_ExtractTextError": "Error al extraer texto. Por favor, int\xe9ntalo de nuevo.",
    "Tip_CreditConsume": "Esta generaci\xf3n usa ${0} cr\xe9ditos",
    "BatchProcess_SaveSuccessTip_GotIt": "Entendido",
    "BatchProcess_SaveSuccessTip_Title": "Usando kits de flujo de trabajo",
    "BatchProcess_SaveSuccessTip_Desc": "Aqu\xed se guardan tus kits de flujo de trabajo. Elige uno para generar im\xe1genes r\xe1pidamente usando las plantillas guardadas.",
    "BatchProcess_tutorial": "Tutoriales",
    "Text_Model_Pricing": "Precios de modelos",
    "Text_Pro_discount": "Plan pro: generaci\xf3n de videos a mitad de precio",
    "Dropdown_AddFromBrandkit": "A\xf1adir desde el kit de marca",
    "Button_ExportFromBrandkit": "Importar desde el kit de marca",
    "Text_TemplatePrompt": "Empecemos con inspiraciones",
    "Text_Hi": "\xa1Hola {0}!",
    "Text_Account_Popup_Left": "Conoce a tu asistente de dise\xf1o de IA dedicado al comercio electr\xf3nico. Creado para profesionales que buscan lanzamientos m\xe1s r\xe1pidos, presentaciones m\xe1s s\xf3lidas y mayor rentabilidad.",
    "Tip_EstimatedTime": "Estar\xe1 listo en alrededor de ${0}\xa0minutos",
    "Text_HandTool": "Herramienta de mano",
    "Text_Function": "Funci\xf3n",
    "Text_WindowsSystem": "Sistema de Windows",
    "Text_MacSystem": "Sistema de Mac",
    "Menu_KeyboardShortcuts": "Combinaciones de teclas",
    "Title_KeyboardShortcuts": "Combinaciones de teclas",
    "Text_Undo": "Deshacer",
    "Text_MouseLeft": "Bot\xf3n izquierdo del mouse",
    "Text_Redo": "Rehacer",
    "Text_Delete": "Borrar",
    "Text_Cut": "Cortar",
    "Text_Copy": "Copiar",
    "Text_Paste": "Pegar",
    "Text_PasteFixed": "Pegar en su lugar",
    "Text_CreateCopy": "Crear una copia",
    "Text_SelectAll": "Seleccionar todo",
    "Text_SelectMultiple": "Selecci\xf3n m\xfaltiple",
    "Text_Group": "Agrupar",
    "Text_Ungroup": "Desagrupar",
    "Text_LockLayer": "Bloquear",
    "Text_Save": "Guardar",
    "Text_Move": "Mover",
    "Text_MoveWithCombinedKeys": "Mover r\xe1pido",
    "Text_NewText": "Texto nuevo",
    "Text_NewLine": "L\xednea nueva",
    "Text_NewRectangle": "Rect\xe1ngulo nuevo",
    "Text_NewCircle": "C\xedrculo nuevo",
    "Text_ExitFullScreen": "Salir de pantalla completa",
    "Text_MoveUpOneLayer": "Traer adelante",
    "Text_MoveDownOneLayer": "Enviar atr\xe1s",
    "Text_Top": "Traer al frente",
    "Text_Bottom": "Enviar al fondo",
    "Text_ToggleReferenceLine": "Mostrar/ocultar gu\xedas",
    "Text_ToggleRulerBar": "Mostrar/ocultar reglas",
    "Text_ArrowKey": "Teclas de flecha",
    "Text_CanvasShowAll": "Mostrar todo el lienzo",
    "Title_Unsupported_Multilayer": "Esta funci\xf3n solo funciona con una sola capa.",
    "Btn_CreateBatchProcessFormula": "Crear",
    "Button_Hide_Otherlayers": "Mantener la primera capa y continuar",
    "Button_Merge_Alllayers": "Combinar todas las capas y continuar",
    "Checkbox_Disable_Remind": "No mostrar de nuevo",
    "Button_Tool": "Herramientas",
    "Button_Custom_Ratio": "Personalizado",
    "Label_Spacing": "Espacio",
    "Button_Download_Whole": "Exportar como imagen",
    "Button_Download_Layer": "Exportar como capa",
    "Button_Origin_Ratio": "Original",
    "Text_TouchEdit_Title": "Apuntar para editar",
    "Text_TouchEdit_Description": "Apunta a un objeto y describe tus cambios. La imagen se editar\xe1 exactamente como lo especifiques. ",
    "Tooltip_TouchEdit_Max_Count": "Puedes apuntar hasta ${0}\xa0\xe1reas",
    "Tooltip_TouchEdit_Usage": "Combinaci\xf3n de teclas de Apuntar para editar: ${0}\xa0+\xa0clic",
    "Text_TouchEdit_Recognition_Custom": "Personalizado",
    "Text_TouchEdit_Recognition_Title1": "Detectar y reconocer",
    "Text_TouchEdit_Recognition_Title2": "No se encontr\xf3 un objetivo. Ingresa el nombre del objeto.",
    "Text_TouchEdit_Name": "Apuntar para editar",
    "Btn_LoginToViewBatchProcess": "Inicia sesi\xf3n para ver el kit de flujo de trabajo",
    "Btn_Login": "Iniciar sesi\xf3n",
    "Menu_Main_Beautify": "Refinar",
    "Text_PleaseWaitImageUploaded": "Contin\xfaa despu\xe9s de que se complete la carga",
    "Menu_Redeem_Rights": "Canjear",
    "Text_Redeem_Now": "Canjea ahora",
    "Text_Redeem_Placeholder": "Ingresa el c\xf3digo de canje, respetando las may\xfasculas y min\xfasculas",
    "Text_Redeem_Success": "\xa1Canje exitoso!",
    "Text_Redeem_Use": "Canjea tu c\xf3digo",
    "Tooltip_BrandAutoUse": "\xa1Se aplic\xf3 tu kit nuevo!",
    "Redeem_Redeem_Note": "Nota: \nInicia sesi\xf3n e ingresa el c\xf3digo de canje.\nCuando se complete el canje, podr\xe1s disfrutar los beneficios y servicios correspondientes.\nUsa el c\xf3digo de canje durante su periodo de validez. Los c\xf3digos expirados no ser\xe1n v\xe1lidos y no son reembolsables.\nProtege tu c\xf3digo. Nos nos haremos responsables por c\xf3digo perdidos, divulgados o usados de manera incorrecta. \nEste c\xf3digo no es transferible ni se puede revender, intercambiar por dinero en efectivo ni es elegible para ser facturado.",
    "Sidebar_NewDesign": "Nuevo chat",
    "Text_Appeal_ReGenerate": "Los resultados editados no son cumplen las condiciones para su revisi\xf3n.",
    "Modal_Button_Known": "Aceptar",
    "MenuItem_Appeal": "Revisi\xf3n de resultados",
    "Text_Appeal_Left": "Intentos restantes este mes\n<i>${0}</i>/${1}",
    "Text_Appeal_Confirm": "S\xed",
    "Text_Appeal_Refunded": "Los cr\xe9ditos fueron reembolsados a tu cuenta.",
    "Modal_Button_GotIt": "Aceptar",
    "Modal_Button_Later": "M\xe1s tarde",
    "Text_Vip_Open": "Suscr\xedbete",
    "Menu_Title_Invite": "Refiere a un amigo",
    "Text_Button_Invite": "Obtener cr\xe9ditos",
    "Title_Dialog_Invite": "Refiere a un amigo",
    "Desc_Dialog_Invite": "Comparte tu enlace con tus amigos o en redes sociales. Cuando un amigo se registre mediante tu enlace, ambos recibir\xe1n ${0} cr\xe9ditos. Si se suscribe, ambos recibir\xe1n hasta ${1} cr\xe9ditos adicionales.",
    "Detail_Dialog_Invite": "Detalles",
    "Text_Copy_Invite": "Copiar enlace",
    "Title_Rewards_Invite": "Recompensas",
    "SubTitle_Rewards1_Invite": "Cr\xe9ditos totales obtenidos",
    "SubTitle_Rewards2_Invite": "Usuarios gratuitos referidos",
    "SubTitle_Rewards3_Invite": "Usuarios de pago referidos",
    "Success_Copy_Invite": "Enlace copiado",
    "Title1_Invited_Invite": "\xa1Recibiste una invitaci\xf3n!",
    "Text_Rule1_Invite": "Por cada amigo que se registre con tu enlace, ambos ganar\xe1n <strong>${0} cr\xe9ditos</strong>.",
    "Text_Rule2_Invite": "Si tu amigo se suscribe, ambos obtendr\xe1n cr\xe9ditos adicionales (<strong>${0} para Plus, ${1} para Pro</strong>).",
    "Text_Rule3_Invite": "Las suscripciones de pago no se pueden reembolsar si el plan se us\xf3 o se consumieron los cr\xe9ditos concedidos, en todo o en parte. Adem\xe1s, los cr\xe9ditos gratuitos no se pueden revocar una vez que se usan.",
    "Text_Rule4_Invite": "Cada usuario puede invitar a hasta ${0} amigos.",
    "Text_Rule5_Invite": "No se conceder\xe1n recompensas por referencias a cuentas existentes, autorreferencias, cuentas duplicadas o actividad fraudulenta.",
    "Text_Rule6_Invite": "${0} se reserva el derecho de ajustar el programa y revocar las recompensas de cuentas anormales.",
    "Text_Divider_Invite": "o comparte el enlace",
    "Title2_Invited_Invite": "\xdanete a ${0} y reclama tus recompensas",
    "SubTitle1_Invited_Invite": "Un amigo te invit\xf3 a probar nuestro agente profesional de IA para marcas. Crea f\xe1cilmente dise\xf1os para marketing de marca de alta calidad, como logos, posters, men\xfas y recursos para redes sociales. ",
    "SubTitle2_Invited_Invite": "<strong>Reg\xedstrate ahora</strong> y tanto t\xfa como tu amigo <strong>recibir\xe1n ${0} cr\xe9ditos</strong>. <strong>Si te suscribes</strong>, cada uno recibir\xe1 cr\xe9ditos adicionales seg\xfan el plan que elijas (<strong>${1} cr\xe9ditos con Plus o ${2} cr\xe9ditos con Pro</strong>). \xa1Reg\xedstrate ahora para reclamar tus recompensas!",
    "Button_Invited_Invite": "Reg\xedstrate para reclamar tus recompensas",
    "Success_Invited_Invite": "Te uniste mediante una referencia y recibiste ${0} cr\xe9ditos.",
    "Error_Invited_Invite": "Ya tienes una suscripci\xf3n activa.",
    "Text_Share_Invite": "Estoy usando ${0} para crear r\xe1pidamente logos, elementos visuales y videos. Reg\xedstrate con mi enlace y ambos obtendremos cr\xe9ditos adicionales.",
    "Title_Share_Invite": "\xa1\xdanete a ${0} y obtengamos cr\xe9ditos juntos!",
    "Share_Email_Invite": "Correo",
    "Text_Rule7_Invite": "Puedes usar los cr\xe9ditos para el Agente de IA. Los cr\xe9ditos expiran despu\xe9s de un mes. ",
    "Text_AdvanceSetting": "Especialista",
    "Text_MainImage": "Imagen principal",
    "Text_ProductAgentUploadGuide1": "1. Sube fotos desde diferentes \xe1ngulos para que la IA reconozca y restaure con precisi\xf3n los detalles del producto.",
    "Text_ProductAgentUploadGuide2": "2. Puedes subir hasta 10 fotos. La primera ser\xe1 la imagen principal; te recomendamos elegir una donde se vea el producto completo y con claridad.",
    "Text_Optional": " (Opcional)",
    "Tip_ClickDragImageWithSize": "Sube o arrastra im\xe1genes JPEG, JPG o PNG de hasta ${0}MB.",
    "Button_AddReferenceImage": "Subir",
    "Title_ReferenceImage": "Imagen de referencia",
    "Input_Placeholder": "Selecciona",
    "Radio_ReferenceColor": "Color de referencia",
    "Radio_ReferenceLayout": "Composici\xf3n de referencia",
    "Tag_FirstImage": "Primera imagen",
    "Tag_FirstImageNoPartial": "La primera foto est\xe1 incompleta",
    "Tag_Blur": "Borrosa",
    "Tag_Jigsaw": "Collage",
    "Button_Understood": "Entendido",
    "Text_ReferenceImageIndex": "La foto ${0}  es de referencia",
    "Text_ReferenceDimensions": "Usa ${0} de referencia",
    "Tag_Cropped": "Recortar",
    "Tag_Underexposed": "Subexpuesta",
    "Tag_Blurry": "Desenfoque",
    "SelectOption_ColorPalette": "Paleta de colores",
    "SelectOption_Layout": "Composici\xf3n",
    "SelectOption_Fonts": "Fuentes",
    "SelectOption_Style": "Estilo",
    "SelectOption_ShapeElements": "Figuras geom\xe9tricas",
    "Text_SocialMediaAgentUploadGuide": "Sube primero tu producto destacado. Aseg\xfarate de que la foto sea n\xedtida y est\xe9 completa.",
    "Menu_Manage_Subscriptions": "Administrar suscripciones",
    "Menu_Text_Subscriptions": "Suscripciones",
    "Menu_View_Subscriptions": "Ver suscripciones",
    "Text_Download_XdesignApp": "Descarga la aplicaci\xf3n de <span>X-Design</span> para usar las funciones",
    "Text_Free_Trial": "Descarga para obtener una prueba gratuita por 7\xa0d\xedas",
    "Text_Install_App": "Instalar la app",
    "Text_Scan_Download": "Escanea para descargar",
    "Text_Download_the": "Descargar en la",
    "Text_Available_On": "Disponible en",
    "SecondTitle_Header6_Home": "Generador de imagen de producto con IA",
    "SecondTitle_Header7_Home": "Generador de modelos de moda con IA",
    "SecondTitle_Header8_Home": "Cambiador de color de ropa",
    "SecondTitle_Header9_Home": "Generador de video de producto",
    "SecondTitle_Header10_Home": "Herramientas de IA",
    "SecondTitle_Header11_Home": "Editor de fotos con IA",
    "SecondTitle_Header12_Home": "Editor de fotos con IA en l\xednea",
    "SecondTitle_Header13_Home": "Editor de fotos masivo",
    "SecondTitle_Header14_Home": "Editor de fotos masivo con IA",
    "SecondTitle_Header15_Home": "Mejorador de imagen masivo",
    "SecondTitle_Header16_Home": "Eliminador de marcas de agua masivo",
    "SecondTitle_Header17_Home": "Generador de fondos masivo",
    "SecondTitle_Header18_Home": "Borrador de fondos de imagen masivo",
    "Title_Footer3_Home": "Herramientas de dise\xf1o",
    "Subtitle_Footer8_Home": "Editor de imagen con IA",
    "Subtitle_Footer7_Home": "Cambiador de fondos con IA",
    "Subtitle_Footer9_Home": "Fondo transparente",
    "Subtitle_Footer10_Home": "Cambiar el color de fondo",
    "Subtitle_Footer11_Home": "Eliminador de marcas de agua de imagen",
    "Subtitle_Footer12_Home": "Eliminar texto de la imagen",
    "Subtitle_Footer13_Home": "Agregar stickers a fotos",
    "Subtitle_Footer14_Home": "Agregar marca de agua en la foto",
    "Title_Footer4_Home": "Modelos de imagen",
    "Subtitle_Footer15_Home": "Nano Banana Pro (Gemini 3.0 Pro)",
    "Title_Footer5_Home": "Descargar gratis",
    "Subtitle_Footer16_Home": "Aplicaci\xf3n para iOS",
    "Subtitle_Footer17_Home": "Aplicaci\xf3n para Android",
    "Title_Footer6_Home": "S\xedguenos",
    "Subtitle_Footer18_Home": "Kling 3.0",
    "Subtitle_Footer19_Home": "Seedance 2.0",
    "Title_Footer7_Home": "Modelos de video",
    "Video_SR_Success": "Claridad de video mejorada",
    "Video_Desubtitle_Success": "Subt\xedtulo eliminado",
    "Video_Dewatermark_Success": "Marca de agua eliminada",
    "Video_Process_Failed": "Error al procesar. Los cr\xe9ditos se reembolsar\xe1n a tu cuenta.",
    "Video_SR": "Claridad con IA",
    "Video_Dewatermark": "Eliminar marca de agua",
    "Video_Desubtitle": "Eliminar subt\xedtulos",
    "Text_TouchEditFastMode": "Apuntar para editar r\xe1pidamente",
    "Text_Pan": "Paneo",
    "Title_Canvas": "Lienzo",
    "Title_Edit": "Editar",
    "Title_Elements": "Elementos",
    "Title_Tools": "Herramientas",
    "Text_CanvasZoom": "Acercar/alejar",
    "Tooltip_Color_Fill": "Color",
    "Tootip_StartPoint": "Comenzar",
    "Tootip_ChangePoint": "Cambiar",
    "Tootip_EndPoint": "Fin",
    "Retouch_Filter_Clear": "N\xedtido",
    "Retouch_Filter_Enhance": "V\xedvido",
    "Retouch_Filter_Dehaze": "Borrar neblina",
    "Retouch_Filter_Texture": "Textura",
    "Retouch_Filter_Nature": "Natural",
    "Retouch_Filter_Fade": "Desvanecer",
    "Tooltip_Downloading": "Descargando…",
    "Tooltip_Download_Video": "Descarga videos por separado, uno a la vez.",
    "Tooltip_Download_NoneSelected": "Selecciona el contenido que quieres descargar",
    "Text_AI_Thinking": "La IA est\xe1 trabajando en ello…",
    "Text_Server_Busy": "El servidor est\xe1 ocupado. Intenta de nuevo m\xe1s tarde.",
    "Text_Prompt_Help_Placeholder": "Escribe tus palabras clave y las convertir\xe9 en una indicaci\xf3n lista para usar.",
    "Text_Prompt_Helping": "Procesando… Espera un momento.",
    "Button_Retry": "Intentar de nuevo",
    "Button_Rewrite": "Intenta de nuevo",
    "Button_Start_Prompt_Help": "Comienza a escribir",
    "Title_Prompt_Helper": "Escritura con IA",
    "Desc_ExpireDate": "Expira el",
    "DownloadApp_Title_Widgets": "Descarga la aplicaci\xf3n de ${0} para usar las funciones",
    "DownloadApp_SubTitle_Widgets": "Descarga para obtener una prueba gratuita por ${0} d\xedas",
    "InstallApp_Title_Widgets": "Instalar la app",
    "InstallApp_Desc_Widgets": "Escanea para descargar",
    "AppStore_Desc_Widgets": "Descargar en la",
    "GooglePlay_Desc_Widgets": "Disponible en",
    "Video_Task_Price_Estimate": "Se requieren {0} cr\xe9ditos",
    "Video_SR_Start": "Mejorando la claridad… Se usar\xe1n ${0} cr\xe9ditos.",
    "Video_Dewatermark_Start": "Eliminando marcas de agua… Se usar\xe1n ${0} cr\xe9ditos.",
    "Video_Desubtitle_Start": "Eliminando subt\xedtulos… Se usar\xe1n ${0} cr\xe9ditos.",
    "Text_Help_Center": "Centro de ayuda"
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/figma/id.js
/* harmony default export */ const id = ({
    "Tips_Adding": "Memproses...",
    "Tips_Loading": "Memuat...",
    "Tips_Creating": "Memproses...",
    "Tips_Downloading": "Mengunduh...",
    "Tips_Sending": "Mengirim…",
    "Tips_AddSuccess": "Berhasil ditambahkan",
    "Tips_MakeSameError": "Tidak dapat membuat ulang",
    "Tips_UnsupportedGradientColor": "Gradien tidak didukung",
    "Tips_CanNotAdding": "Gagal ditambahkan",
    "Tips_Uninitialized": "Gagal mengirim pesan",
    "Tips_UploadFailed": "Gagal mengunggah. Harap coba lagi.",
    "Tips_UploadMaxCountLimit": "Unggah maksimal ${n} ${type} file",
    "Tips_UploadMaxFileSize": "Tidak dapat mengunggah file ${file}. Gunakan file maksimal ${n} MB.",
    "Tips_UploadImageAndVideoLimit": "Bisa mengunggah 1 foto dan 1 video sekaligus",
    "Tips_UnsupportedSvgFile": "File SVG tidak didukung",
    "Tips_UnsupportedUploadFileFormats:": "Format file ${files} tidak didukung",
    "Tips_CanNotAddSameFileTips": "File sudah ada",
    "Tips_TextMinLengthTips": "Masukkan maksimal ${n} karakter",
    "Tips_TextMaxLengthTips": "Masukkan maksimal ${n} karakter. Setiap karakter Mandarin atau emoji dihitung sebagai 2.",
    "Tips_AccessDenied": "Akses ditolak",
    "Tips_CreateFailed": "Inisiasi obrolan gagal",
    "Tips_Error": "Terjadi kesalahan",
    "Tips_NotFound": "Obrolan tidak ada",
    "Tips_RequestAgentModelListError": "Gagal meminta daftar model Agen",
    "Desc_Ended": "Selesai",
    "Button_PeopleUse_Agent": "${n} pengguna mencoba",
    "Dropdown_AddToChat": "Tambah ke Obrolan",
    "Dropdown_AddToBrandKit": "Tambah ke Kit Merek",
    "Dropdown_SaveAsBrandLogo": "Simpan sebagai logo merek",
    "Dropdown_SaveAsBrandTemplate": "Simpan sebagai templat merek",
    "Title_Design_Agent": "Desain",
    "Title_MainColor": "Warna primer",
    "Title_SecondaryColor": "Warna sekunder",
    "Bitton_ViewTheBrandKit": "Klik untuk melihat kit merek",
    "Dropdown_InportImages": "Impor foto",
    "Desc_RunOutOfUsesForToday_Pro": "Penggunaan gratis untuk hari ini sudah habis. Silakan kembali lagi besok.",
    "Desc_PurchaseCompleted_Pro": "Pembelian selesai",
    "Desc_ContinueDesign_Pro": "Sekarang desain bisa dilanjutkan!",
    "Title_Upgrade_Pro": "Upgrade",
    "Desc_SubscribeToUnlock_Pro": "Berlangganan dan dapatkan lebih banyak!",
    "Desc_RunOutOfFreeUses_Pro": "Penggunaan gratis sudah habis.",
    "Button_UnlockNow": "Berlangganan",
    "Dropdown_AddImage": "Tambah foto",
    "Dropdown_AddVideo": "Tambah video",
    "Dropdown_AddDocument": "Tambah dokumen",
    "Dropdown_SupportedFormatFile": "Mendukung file Word, Excel, Teks, dan PDF.",
    "Tips_Uninitialized_chat": "Gagal mengirim pesan",
    "Title_Models_Dropdown": "Model",
    "Switch_Auto": "Otomatis",
    "Tab_Image": "Foto",
    "Tab_Video": "Video",
    "Desc_GeminiNanoBanana": "Pembuatan gambar yang cepat, dapat diedit, dan konsisten.",
    "Desc_MidjourneyImage": "Pembuatan gambar yang artistik dan imajinatif.",
    "Desc_Seedream": "Pembuatan gambar yang realistis dan detail.",
    "Desc_SeedEdit": "Pengeditan foto yang presisi dan natural.",
    "Desc_MidjourneyVideo": "Pembuatan video yang kreatif dan artistik.",
    "Desc_Seedance": "Pembuatan video yang realistis dan ekspresif.",
    "Tips_Uninitialized_Chat": "Gagal mengirim pesan",
    "Tips_NotFound_Chat": "Obrolan tidak ada",
    "Dropdown_BrandKit_Title": "Kit Merek",
    "Dropdown_BrandKit_Desc": "Pilih gaya merek sebagai referensi untuk desain ini.",
    "Dropdown_NoReference_Option": "Tidak ada referensi tersedia",
    "Dropdown_Example_Option": "Contoh",
    "Action_SeeAll": "Lihat semua",
    "Dropdown_Models_Title": "Model",
    "Tool_ImageBgRemover": "Penghapus Background Foto",
    "Tool_AiBgGenerator": "AI Background",
    "Tool_ImageEnhancer": "Penyempurna Foto",
    "Tool_AiObjectsRemover": "AI Penghapus Objek",
    "Tool_AiImageExtender": "AI Perluas Gambar",
    "Tool_AiLogoGenerator": "AI Pembuat LOGO",
    "Tool_AiModelMannequin": "AI Model - Manekin",
    "Tool_AiModelFlatlay": "AI Model - Flatlay",
    "Tool_AiImageRecolor": "AI Mewarnai Foto",
    "Tool_FootwearModel": "Model Alas Kaki",
    "Tool_ImageUpscaler": "AI Zoom Foto",
    "Tool_ImageTranslation": "Penerjemah Gambar",
    "Tool_BatchImageBgRemover": "Penghapus Background Foto Banyak",
    "Tool_BatchImageEnhancer": "Penyempurna Foto Banyak",
    "Tool_BatchAiObjectsRemover": "AI Penghapus Objek Massal",
    "Tool_VideoEnhancer": "Penyempurna Video",
    "Tool_VideoBgRemover": "Penghapus Background Video",
    "Tool_VideoWatermarkRemover": "Penghapus Watermark Video",
    "Dropdown_AdvancedFeatures_Title": "Fitur Lanjutan",
    "Dropdown_AdvancedFeatures_Conent": "Akses penuh ke semua alat yang didukung AI untuk meningkatkan efisiensi.",
    "Dropdown_MassiveContent_Title": "Konten Lengkap",
    "Dropdown_MassiveContent_Content": "Akses premium sepuasnya ke templat dan jajaran aset stok Plus.",
    "Dropdown_CommercialRights_Title": "Hak Komersial",
    "Dropdown_CommercialRights_Content": "Gunakan kreasi pribadi dengan percaya diri, didukung oleh jaminan perlindungan hak cipta.",
    "Popup_SubscribeIntl_Desc": "Dapatkan manfaat maksimal dari X-Design dengan Pro",
    "Popup_SubscribeIntl_Desc1": "Lebih banyak berkreasi dengan kredit",
    "Popup_SubscribeIntl_Detail": "Lihat detail paket & Bantuan",
    "Popup_StripeCheckout": "Checkout Stripe",
    "Popup_LiveSupport": "Dukungan langsung",
    "Popup_CancelAnytime": "Bisa dibatalkan sewaktu-waktu",
    "Menu_ManageSubscriptions": "Kelola Langganan",
    "Menu_ReferralLink": "Tautan Referral",
    "Menu_Language": "Bahasa",
    "Menu_BenefitsUpgraded": "Manfaat",
    "Menu_TermsPolicies": "Ketentuan dan Kebijakan",
    "Menu_AccountManagement": "Akun",
    "Title_ReferralCode": "Kode Referral",
    "Title_ReferralLink": "Tautan Referral",
    "Desc_NoActiveSubscription": "Tidak ada langganan aktif",
    "Button_ClickToSubscibe": "Klik di sini untuk berlangganan",
    "Title_SubscriptionCancel": "Langganan telah dibatalkan",
    "Title_SeeYou": "Sedih sekali Anda pergi...\uD83D\uDE2D",
    "Desc_NextBillingDate": "Perpanjangan pada",
    "Desc_EstimatedAmount": "Estimasi total",
    "Button_CancelSubscription": "Batalkan langganan",
    "Button_Cancel": "Batal",
    "Button_Delete": "Hapus",
    "Button_StaySubscribed": "Tetap berlangganan",
    "Title_ReasonCancelling": "Harap pilih alasan pembatalan:",
    "Desc_BenefitsContinue": "Anda masih bisa menikmati manfaat keanggotaan hingga akhir periode langganan.",
    "Desc_GiftedCredits": "Setelah langganan berakhir, kredit yang diberikan",
    "Desc_SeeYou": "Terima kasih telah memilih kami. Kami sedih melihat Anda pergi.",
    "Desc_NoNoreCharges": "Anda tidak akan lagi ditagih biaya, dan keanggotaan akan tetap aktif hingga",
    "Desc_MayBeRevoked": "dapat ditarik kembali.",
    "Desc_CancelingNoRefund": "Pembatalan <span>tidak termasuk refund<span>. Untuk pertanyaan terkait refund, silakan hubungi layanan dukungan online.",
    "Button_Pro": "Dapatkan Pro Gratis",
    "Tab_Design": "Desain",
    "Button_Send": "Kirim",
    "Input_Describe_Workspace": "Tuliskan deskripsi gambar dan aku akan membuatnya",
    "Tab_AgentCase": "Kasus agen",
    "Tab_RecentCreations": "Terbaru",
    "Tag_Hot": "Hits",
    "Tag_BrandDesign": "Desain Merek",
    "Tag_Logo": "Logo",
    "Tag_Posters": "Poster",
    "Tag_All": "Semua",
    "Tag_Design": "Desain",
    "Sidebar_Tools": "Alat AI",
    "Sidebar_Create": "Beranda",
    "Sidebar_Batch": "Editor Massal",
    "Sidebar_MyDesigns": "Desain Saya",
    "Sidebar_Inspire": "Berikan Inspirasi",
    "Sidebar_Brand": "Kit Merek",
    "Sidebar_Unfold": "Buka bar samping",
    "Tab_Agent": "Agen",
    "Tool_AiPhotoEditor": "Editor Foto",
    "Button_Upload": "Unggah",
    "Tool_Designer": "Poster",
    "Button_BlankCanvas": "Buat",
    "Title_AiTool": "Alat AI",
    "Tool_ImageBackgroundRemover": "AI Penghapus Background",
    "Tool_AiBackgroundGenerator": "AI Background",
    "Tool_AiLogo": "AI Pembuat Logo",
    "Tab_RecentlyCreated": "Terbaru",
    "Tab_GenerateRecords": "Kreasi",
    "Menu_Edit": "Edit",
    "Menu_Download": "Unduh",
    "Menu_Delete": "Hapus",
    "Sidebar_PackUp": "Tutup bar samping",
    "Menu_DueToday": "Kredit bonus harian",
    "Menu_DueToday_Explain": "Berlaku satu hari hingga pukul 24.00.",
    "Menu_Else": "Kredit lainnya",
    "Menu_Else_Explain_AgentCredits": "Kredit dari sumber lain. Berlaku untuk jangka waktu lebih lama.",
    "Title_Total_AgentCredits": "Total - Kredit agen",
    "Menu_Total_Explain_AgentCredits": "Hanya untuk Agen AI dan akan digunakan terlebih dahulu.",
    "Tips_Credit_Explain_Agent": "Apa itu Kredit agen?",
    "Title_Total_PaidCredits": "Total kredit yang dibeli",
    "Menu_Total_Explain_PaidCredits": "Untuk semua fitur dan berlaku selama periode keanggotaan.",
    "Menu_Pro": "Kredit langganan",
    "Menu_Pro_Explain": "Berlaku selama periode keanggotaan.",
    "Menu_Else_Explain_PaidCredits": "Kredit dari sumber lain. Berlaku selama periode keanggotaan.",
    "Menu_UsageDetail": "Detail penggunaan",
    "Tips_Credit_Explain_Paid": "Apa itu kredit yang dibeli?",
    "Title_Total_InactiveCredits": "Total kredit tidak aktif",
    "Menu_Total_Explain_SuspendCredits": "Tidak tersedia hingga keanggotaan kembali aktif.",
    "Button_GoPro_GetMore": "Dapatkan lebih banyak kredit",
    "Menu_SuspendCredits": "Kredit tidak aktif",
    "Menu_AgentCredits": "Kredit Agen",
    "Menu_Credits": "Kredit",
    "Tab_Invite": "Undang",
    "Tab_Reward": "Hadiah",
    "Title_AgentCreditForRewards": "Hadiah kredit agen:",
    "Table_Time": "Waktu",
    "Table_Invitee": "Undangan",
    "Table_AgentCredit": "Kredit Agen",
    "Title_ShareWithFriends": "Bagikan dengan teman",
    "Title_ShareWithFriends_ExplainOne": '<span style="color:#616266;">Undang teman dan kalian berdua akan menerima </span><span style="color:#2D990C;">${0} Kredit Agen!</span>',
    "Title_ShareWithFriends_ExplainTwo": '<span style="color:#616266;">Undang maksimal </span><span style="color:#2D990C;">${0} teman baru</span><span style="color:#616266;"> dan dapatkan maksimal ${1} Kredit Agen!</span>',
    "Title_InvitationLink": "Bagikan tautan ini dengan teman",
    "Button_Copy": "Salin",
    "Title_Tips": "Tips",
    "Title_Tips_ExplainOne": "1. Kredit Agen hanya dapat digunakan untuk mengakses fitur Agen AI. Kredit hadiah berlaku selama dua tahun.",
    "Title_Tips_ExplainTwo": "2. Teman baru akan menerima hadiah setelah pendaftaran berhasil. Jika ada pertanyaan, silakan hubungi tim dukungan kami.",
    "Title_FailedToReceiveReward": "Operasi gagal",
    "Title_YouCannotUseYourOwnLink": "Tautan pribadi tidak diizinkan",
    "Title_FailedToReceiveReward_Explain": "Jika ada pertanyaan, silakan hubungi tim dukungan kami.",
    "Button_Ok": "Mengerti",
    "Button_Invite": "Undang",
    "Title_AgentCredits": "+50 Kredit Agen",
    "Title_GetRewarded": "Undangan berhasil!",
    "Title_GetRewarded_Explain": "Kredit hanya dapat digunakan untuk fitur Agen AI dan berlaku selama dua tahun.",
    "Tips_Copied": "Disalin!",
    "Menu_Total": "Total",
    "Menu_Else_AgentCredits": "Kredit lainnya",
    "Input_Describe_workspace": "Tuliskan deskripsi gambar dan aku akan membuatnya",
    "Tool_AiBackgroundGenrator": "AI Background",
    "Input_Models": "Model",
    "Button_TryItNow": "Coba sekarang",
    "\xa0Tab_RecentCreations_Agent": "Agen",
    "\xa0Tab_RecentCreations_Design": "Alat Pintar",
    "Account_Pricing": "Harga",
    "Account_Language": "Bahasa",
    "Account_Language_English": "Inggris",
    "Account_Language_Chinese": "Mandarin",
    "Dropdown_SaveToBrandKit": "Simpan sebagai logo merek",
    "Dropdown_SaveToBrandTemplate": "Simpan sebagai templat merek",
    "Tab_RecentCreations_Agent": "Agen",
    "Tab_RecentCreations_Design": "Alat Pintar",
    "Menu_FunctionalPricing": "Harga Agen",
    "Title_FeaturePricing": "Harga Agen",
    "Tab_Category": "Kategori",
    "Tab_TaskType": "Tugas",
    "Tab_Consume": "Harga (Kredit)",
    "Tab_ExampleContent": "Contoh",
    "Tips_CreditExplain_Inactive": "Apa itu kredit tidak aktif?",
    "Title_NanoPro": "\uD83C\uDF4C\uD83C\uDF4CNano Banana Pro kini tersedia di X-Design.",
    "Title_Workspace": "Agen AI Kreatif untuk Branding",
    "Menu_InviteReward": "Hadiah Undang Teman",
    "Title_NoDesigns": "Belum ada desain.",
    "Title_NoGenerations": "Belum membuat apa pun.",
    "Desc_NoDesigns": "Desain Anda akan ditampilkan di sini.",
    "Desc_NoGenerations": "Pemrosesan akan ditampilkan di sini.",
    "Title_DeleteDesign": "Hapus desain ini",
    "Popup_DeleteDesign": "Yakin ingin menghapus desain ini secara permanen? Tindakan ini tidak dapat dibatalkan.",
    "Title_LoginPopup": " Login dan dapatkan uji coba gratis",
    "SubTitle_LoginPopup": "Mulai berkarya dengan X-Design sekarang",
    "Button_GotIt": "Mengerti",
    "Title_Congrats": "Selamat",
    "SubTitle_BrandCreate": "Kit merek perdana telah dibuat, saatnya mengeksplorasi potensinya!",
    "Button_CheckUse": "Lihat sekarang",
    "Chat_Prompt_Brand": "Buat poster promo",
    "Tooltip_UseBrand": "Ganti atau tambahkan kit merek di sini!",
    "Tooltip_PosterBrand": "Ketuk untuk membuat poster pertama berdasarkan kit merek",
    "Popup_CreateBrand": "Buat merek dari awal",
    "Desc_CreateBrand": "Buat logo yang menarik dan original dengan Agen AI kami.",
    "Popup_UploadBrand": "Unggah informasi merek",
    "Desc_UploadBrand": "Unggah info dan X-Design akan mempertahankan konsistensi setiap desain.",
    "Title_BrandEntry": "Dapatkan personalisasi sistem merek sekarang",
    "Desc_BrandEntry": "AI juga bisa menjadi penata gaya. Jawab beberapa pertanyaan dan dapatkan sistem merek lengkap sesuai visi Anda.",
    "Tooltip_UseBrand_Agent": "Setelah kit merek diterapkan, desain akan secara otomatis mengacu pada logo, palet warna, dan gaya secara keseluruhan.",
    "Tooltip_PosterBrand_Agent": "Siap mendesain dengan kit merek Anda sendiri",
    "MenuItem_AiChange": "AI Pengeditan",
    "MenuItem_AiExpend": "AI Perluas",
    "MenuItem_AiHD": "AI Kejernihan",
    "MenuItem_Eliminate": "AI Penghapus",
    "MenuItem_SplitLayers": "Pisahkan Layer",
    "MenuItem_Cutout": "Penghapus BG",
    "MenuItem_ChangeText": "Ganti Teks",
    "MenuItem_AddToChat": "Tambah ke Obrolan",
    "MenuItem_AddToBrand": "Tambah ke Kit Merek",
    "MenuItem_AddToBrandLogo": "Simpan sebagai logo merek",
    "MenuItem_AddToBrandTemplate": "Simpan sebagai templat merek",
    "Button_ExportImage": "Impor foto",
    "Button_ExportMedia": "Impor video",
    "Placeholder_ChatInput": "Mari mulai!",
    "Tooltip_Grab": "Alat tangan",
    "Placeholder_ImageFusion": "Jelaskan bagaimana foto tersebut harus digabungkan",
    "Button_ImageFusion": "Gabungkan",
    "Button_AiChange": "Edit",
    "Placeholder_AiChange": "Jelaskan apa yang ingin diubah",
    "BatchProcessTable_ImageType": "Jenis gambar",
    "BatchProcessTable_PictureRequirement": "Detail desain",
    "BatchProcessTable_CopywritingRequirements": "Deskripsi produk",
    "BatchProcessTable_Actions": "Tindakan",
    "BatchProcessTable_AddOneRow": "Tambah",
    "EditBatchProcess_Tip": "Perubahan pada panduan akan memengaruhi hasil yang dibuat.",
    "EditBatchProcess_Start": "Mulai dengan panduan",
    "EditBatchProcess_GenerateTip": "Unggah foto produk dan desain akan dibuat berdasarkan panduan yang diberikan.",
    "Title_Request": "Obrolan",
    "Title_ChooseImageType": "Pilih jenis gambar yang dihasilkan (Beberapa opsi)",
    "Text_ChatCancelStatus": "Tugas dihentikan",
    "langding_more_bg_remover": "Penghapus Background",
    "langding_more_enhancer": "Penyempurna Foto",
    "langding_more_objects_remover": "AI Penghapus Objek",
    "langding_more_bg_generator": "AI Background",
    "Title_More1_Home": "Penyempurna Foto",
    "Title_More2_Home": "AI Penghapus Objek",
    "Title_More3_Home": "AI Background",
    "Title_More4_Home": "AI Penghapus Background",
    "Title_More5_Home": "Alat Foto Banyak",
    "Title_Home": "Agen AI Desain <span>E-Commerce</span>",
    "Placeholder_Input_Home": "Tuliskan deskripsi gambar dan aku akan membuatnya.",
    "Title_Card4_Home": "Visual untuk Amazon",
    "Title_Card1_Home": "Gambar Coba Pakaian & Aksesori",
    "Title_Card3_Home": "Gambar Halaman Detail Produk",
    "Title_Card2_Home": "Pembuat Background",
    "Desc_Features1_Home": "AI secara otomatis mengekstrak fitur produk dan preferensi gaya untuk menentukan solusi desain yang ideal.",
    "Desc_Features2_Home": "Cukup masukkan satu kalimat, dan AI akan menghasilkan koleksi foto untuk e-commerce, termasuk foto utama, visual pendukung, dan halaman detail produk lengkap.",
    "Text_Btn_Home": "Mulai Gratis",
    "Desc_Features3_Home": "Secara otomatis membuat visual platform yang disesuaikan untuk Amazon, Etsy, TEMU, eBay, dan lainnya, memastikan foto selalu dioptimalkan untuk menarik audiens yang tepat.",
    "Desc_Features4_Home": "Cukup masukkan prompt, dan AI akan menyesuaikan bahasa, gaya, dan elemen budaya untuk menghasilkan versi lokal untuk setiap pasar target.",
    "Desc_Features5_Home": "Simpan alur kerja desain sebagai templat yang dapat digunakan ulang, dan AI akan otomatis membuat foto untuk semua SKU secara massal.",
    "Desc_Features6_Home": "Menghasilkan rangkaian visual yang lengkap dan konsisten untuk 10 atau 1.000 produk dengan cepat dan mudah.",
    "Title_Qualification_Home": "Dipercaya oleh Lebih dari 5 Juta Online Seller!",
    "Text_Btn_Qualification_Home": "Lihat Sertifikasi",
    "Title_Carousel_Home": "Alat AI lainnya",
    "Title_Footer_Home": "Agen AI Desain E-Commerce",
    "Title_Footer1_Home": "Akun Media Sosial",
    "Subtitle_Footer1_Home": "YouTube",
    "Subtitle_Footer2_Home": "X",
    "Subtitle_Footer3_Home": "Instagram",
    "Subtitle_Footer4_Home": "TikTok",
    "Title_Footer2_Home": "Bantuan & Hukum",
    "Subtitle_Footer5_Home": "Ketentuan Layanan",
    "Subtitle_Footer6_Home": "Kebijakan Privasi",
    "Copyright_Footer_Home": "Hak Cipta ${0} Meitu, Inc.",
    "Desc_Evaluation1_Home": "Aku suka Designkit! Hasil fotonya terkesan real dan alami, nyaman dan bernuansa Nordik, cocok untuk toko lilinku. Daftar produk jadi terlihat rapi dan penjualan meningkat. Sangat sepadan.",
    "Job_Evaluation5_Home": "Seller TEMU di Meksiko",
    "Job_Evaluation6_Home": "Spesialis operasional Amazon",
    "Job_Evaluation12_Home": "Manajer toko dari toko Amazon di Indonesia dengan berbagai SKU",
    "Job_Evaluation2_Home": "Penilik toko Amazon & Mercado Libre ",
    "Name_Evaluation12_Home": "Arif",
    "Desc_Evaluation11_Home": "Gambar suasana lifestylenya terlihat sangat natural, mirip seperti hasil pemotretan profesional. Pelanggan saya sepertinya juga menyukainya, dan saya bahkan melihat pembelian makin meningkat.",
    "Name_Evaluation11_Home": "Siti",
    "Job_Evaluation10_Home": "Pemilik toko lintas batas di Lazada & Shopee (Indonesia)",
    "Name_Evaluation10_Home": "Nina",
    "Job_Evaluation3_Home": "Desainer E-commerce DTC",
    "Job_Evaluation8_Home": "Pemilik toko Produk Outdoor Walmart di Amerika",
    "Name_Evaluation8_Home": "Jason",
    "Job_Evaluation9_Home": "Seller Mercado Libre di Argentina",
    "Desc_Evaluation7_Home": "Foto produk hewan peliharaan yang dibuat AI itu sangat lucu! Kucing dan anjingnya terlihat proporsional dan alami. Selain itu, ukuran dan skalanya sesuai dengan persyaratan platform, jadi gambarnya bisa langsung digunakan.",
    "Job_Evaluation7_Home": "Pemilik toko Mercado Libre di Brasil",
    "Desc_Evaluation8_Home": "Foto berkemah untuk produk tenda saya terlihat sangat realistis. Pencahayaan dan sudutnya terasa natural, dan proporsinya tepat sekali. Benar-benar menghemat banyak waktu dibandingkan kalau memotret semuanya sendiri.",
    "Name_Evaluation7_Home": "Thiago",
    "Desc_Evaluation9_Home": "Alat ini sangat cepat, dan foto yang dihasilkan pada dasarnya bisa langsung diunggah ke Mercado Libre dan Amazon tanpa perlu penyesuaian tambahan.",
    "Desc_Evaluation6_Home": "Dulu saya khawatir AI tidak bisa menampilkan tekstur kain, tetapi ternyata teksturnya hampir tidak berbeda dari aslinya. Pakaian rajutan terlihat seperti aslinya, bahan denim juga, dan bahkan memenuhi persyaratan foto untuk Amazon. Saya bisa meluncurkan produk baru jauh lebih cepat.",
    "Name_Evaluation9_Home": "Lucas",
    "Name_Evaluation6_Home": "Emma",
    "Desc_Evaluation5_Home": "Foto produk yang dibuat AI sangat akurat. Panjang kabel dan bentuk konektornya tepat, bahkan sesuai dengan ketentuan TEMU. Sangat menghemat waktu dibandingkan kalau memotret sendiri.",
    "Desc_Evaluation12_Home": "Hanya dengan satu prompt, saya mendapatkan grafis yang bisa digunakan secara instan, jauh lebih cepat daripada menunggu desainer. Jujur saja, ini sangat praktis.",
    "Name_Evaluation3_Home": "Chloe",
    "Name_Evaluation1_Home": "Sofia",
    "Desc_Evaluation4_Home": "Tekstur metalik dan detail strukturalnya sangat jelas, sehingga membuat foto terlihat profesional. Saya bisa langsung menggunakannya tanpa perlu mengedit lagi.",
    "Name_Evaluation4_Home": "Leon",
    "Desc_Evaluation10_Home": "Pemrosesan massal sangat praktis. Saya bisa memproses puluhan SKU sekaligus, dan jauh lebih cepat daripada melakukannya secara manual.",
    "Name_Evaluation2_Home": "Mariana",
    "Desc_Evaluation3_Home": "Aku menjual pakaian, dan aku takut AI tidak bisa menampilkan warna atau tekstur kain dengan benar, tapi ternyata hasilnya luar biasa! Pose modelnya terlihat natural, dan pada dasarnya semua foto langsung siap digunakan.",
    "Job_Evaluation1_Home": "Spesialis operasional toko SHEIN",
    "Name_Evaluation5_Home": "Diego",
    "Job_Evaluation11_Home": "Spesialis Operasional Amazon",
    "Desc_Evaluation2_Home": "Alat ini sangat cepat, dan pada dasarnya hasil fotonya sudah siap diunggah ke Mercado Libre atau Amazon. Bahkan, alat ini bisa menyesuaikan latar belakang dan model dengan selera lokal, dan hasilnya terlihat sangat profesional.",
    "Job_Evaluation4_Home": "Seller eBay di Jerman",
    "Title_Evaluation_Home": "Kisah Pengguna",
    "Title_Introduction_Home": "Desain AI premium yang meningkatkan penjualan lebih tinggi",
    "Desc_Qualification_Home": "Penyedia Layanan Bersertifikasi SPN Amazon",
    "Title_Seo_Home": "AI Pembuat Foto & Video Produk untuk E-commerce",
    "Desc_Seo_Home": "Buat foto produk, poster, dan video secara instan untuk Amazon, TikTok, dan toko online lainnya dengan Agen AI Designkit. Mulai desain secara gratis sekarang!<br>",
    "Keywords_Seo_Home": "Agen AI untuk E-commerce, Alat AI E-commerce, AI Pembuat Foto Produk, AI Pembuat Video Produk, AI Editor Foto Produk, AI Penghapus Background",
    "Title_Features1_Home": "Dari satu permintaan menjadi satu rangkaian visual lengkap",
    "Title_Features2_Home": "Lokalisasi sepenuhnya otomatis untuk menjual produk secara global di berbagai platform",
    "Title_Features3_Home": "Buat foto otomatis dalam jumlah besar untuk beberapa SKU dan kalahkan para kompetitor!",
    "Title_Designkit_Home": "Designkit",
    "Tips_AboveTheFold2_Home": "Gulir untuk mengeksplorasi",
    "Button_Export": "Unduh",
    "Title_Layer": "Layer",
    "InputNumber_Opacity": "Keburaman",
    "Buttom_Comfirm": "Konfirmasi",
    "Button_Share": "Bagikan",
    "Tip_ModalTitle": "Pengingat",
    "TipContent_HistoryDelete": "Data yang telah dihapus tidak dapat dikembalikan. Konfirmasikan penghapusan?",
    "Title_Logo": "Logo",
    "Title_BrandKit": "Templat",
    "Tab_BrandKit": "Kit Merek",
    "Tab_UploadLocal": "Pilih dari album",
    "Button_UploadImage": "Unggah Foto",
    "Tip_ClickDragParseImage": "Unggah, seret, atau rekatkan foto di sini.",
    "Tooltip_SwitchBrandKit": "Ganti kit merek",
    "Discribe_BrandKitSelect": "Pilih gaya merek sebagai referensi untuk desain ini.",
    "Title_Models": "Model",
    "MenuItem_Crop": "Ukuran Gambar",
    "Tooltip_Layer": "Layer",
    "Tooltip_Select": "Pilih",
    "Tooltip_Redo": "Ulangi",
    "Tooltip_Undo": "Batalkan",
    "Tooltip_Add": "Tambah",
    "Tooltip_ShowAll": "Tampilkan semua",
    "Tip_UploadType": "Format file tidak didukung",
    "Tip_UploadSize": "Hanya mendukung file berukuran maks ${0} MB",
    "Tip_UploadWH": "Pastikan setiap gambar tidak lebih dari ${0}\xd7${1} piksel",
    "Tip_UploadTypeTranslate": "Gagal mengubah format file",
    "Tip_UploadFail": "Unggahan gagal",
    "Tooltip_AddText": "Tambah teks",
    "Text_AddDefault": "Ini adalah teks contoh.",
    "Tooltip_OverflowImageSize": "Ubah ukuran gambar sehingga maks ${0} piksel",
    "Button_Eliminate": "Penghapus",
    "Label_OriginSize": "Original",
    "Label_CropRadio": "Rasio aspek",
    "Button_Free": "Bebas",
    "Button_Origin": "Original",
    "Button_Crop": "Pangkas",
    "Placeholder_ChangeText": "Masukkan teks. Contoh: Halo",
    "Button_ChangeText": "Konfirmasi",
    "InputNumber_PanSize": "Ukuran kuas",
    "Label_TargetSize": "Target",
    "Tooltip_ImageFusion": "${0}-${1} gambar bisa digabungkan",
    "Button_ClearSelection": "Batal pilih",
    "Button_Confirm": "Konfirmasi",
    "Message_Processing": "Memproses...",
    "Title_Opacity": "Keburaman",
    "Button_ExpandImage": "Perluasan",
    "Button_ExpandRadio": "Rasio aspek",
    "Message_SaveFail": "Gagal menyimpan",
    "Title_Pricing": "Pilih Paket yang Tepat",
    "Title_Tags1_Pricing": "Bulanan",
    "Title_Tags2_Pricing": "Tahunan",
    "Title_Plan1_Pricing": "Bebas",
    "BatchProcessTable_Proportion": "Rasio aspek",
    "BatchProcessList_DeleteError": "Gagal menghapus",
    "BatchProcessList_SurePrompt": "Hapus panduan ini?",
    "BatchProcessList_SurePrompt_SureText": "Konfirmasi",
    "BatchProcessList_SurePrompt_CancelText": "Batal",
    "BatchProcessList_EmptyText": "Kosong",
    "EditBatchProcess_NameLimitTip": "Masukkan nama (maksimal 10 karakter)",
    "Button_Continue": "Lanjutkan",
    "Button_EditContent": "Edit pesan",
    "Button_BatchGenerate": "Dikonfirmasi. Jalankan templat sekarang.",
    "Text_ChatRespondedStatus": "Pemrosesan tugas",
    "Title_CreateBrand": "Tidak punya merek?",
    "Title_UploadBrand": "Sudah punya logo?",
    "Button_CreateBrand": "Buat merek",
    "Button_UnlockPro": "Dapatkan Pro",
    "Button_UpgradeToPro": "Upgrade ke Pro",
    "Button_RenewNow": "Perpanjang Sekarang",
    "Tips_Material1_Home": "Set foto daftar",
    "Tips_Material2_Home": "Coba pakaian virtual",
    "Tips_Material3_Home": "Konten A+",
    "Tips_Material4_Home": "Pembuat background",
    "Free_Button_Home": "Coba gratis",
    "Title_Header1_Home": "Produk",
    "Title_Header2_Home": "solusi",
    "Title_Header3_Home": "Inspirasi",
    "Title_Header4_Home": "Pelajari",
    "Title_Header5_Home": "Harga",
    "SecondTitle_Header1_Home": "AI Agen E-Commerce",
    "SecondTitle_Header2_Home": "AI Alat Foto",
    "SecondTitle_Header3_Home": "AI Alat Video",
    "SecondTitle_Header4_Home": "Solusi Desain Amazon",
    "SecondTitle_Header5_Home": "Solusi E-Commerce Media Sosial",
    "Text_Discount_Pricing": "Diskon ${0}",
    "Current_Plan_Pricing": "Paket saat ini",
    "Title_Instruction1_Pricing": "Dapatkan 20 kredit untuk login perdana",
    "Title_Instruction2_Pricing": "Buat maksimal 20 foto dengan Agen AI",
    "Title_Instruction3_Pricing": "Buat maksimal 10 foto dengan AI Background",
    "Title_Rights1_Pricing": "Penghapusan background atau objek terbatas",
    "Title_Rights3_Pricing": "Penyempurnaan gambar HD terbatas",
    "Title_Plan2_Pricing": "Paket Dasar",
    "Month_Plan_Pricing": "bulan",
    "Title_Button1_Pricing": "Berlangganan",
    "Title_Instruction4_Pricing": "500 kredit/bln",
    "Title_Instruction5_Pricing": "Buat maksimal 500 foto dengan Agen AI",
    "Title_Instruction6_Pricing": "Buat maksimal 250 foto dengan AI Background",
    "Title_Plan3_Pricing": "Paket Pro",
    "Desc_Plan_Pricing": "Uji coba gratis 7 hari. Lalu ${0}/tahun.",
    "Title_Button2_Pricing": "Uji coba gratis 7 hari",
    "Title_Instruction7_Pricing": "1.500 kredit/bln",
    "Title_Instruction8_Pricing": "Buat maksimal 1.500 foto dengan Agen AI",
    "Title_Instruction9_Pricing": "Buat maksimal 750 foto dengan AI Background",
    "Title_Rights4_Pricing": "Penghapusan background atau objek sepuasnya",
    "Title_Rights5_Pricing": "Gunakan fitur AI penghapus sepuasnya",
    "Title_Rights6_Pricing": "Penyempurnaan gambar UHD sepuasnya",
    "Title_Rights7_Pricing": "Alat pemrosesan massal",
    "Title_Best_Pricing": "Dipilih oleh 90% pengguna",
    "Title_AllFeatures_Pricing": "Bandingkan Paket Gratis dan Berbayar",
    "Desc_AllFeatures_Pricing": "Beli Premium untuk membuat desain menakjubkan dengan mudah menggunakan alat AI canggih",
    "Month_AllFeatures_Pricing": "bulan",
    "Title_Features1_Pricing": "Agen AI",
    "SubTitle_Features1_Pricing": "Pengeditan Gambar",
    "SubTitle_Features15_Pricing": "Buat maks ${0} gambar",
    "SubTitle_Features16_Pricing": "Buat maks ${0} gambar/bln",
    "SubTitle_Features2_Pricing": "Pembuatan Gambar",
    "SubTitle_Features3_Pricing": "Pembuatan Gambar E-commerce",
    "SubTitle_Features4_Pricing": "Pembuatan Poster",
    "Title_Features2_Pricing": "AI Alat Foto",
    "SubTitle_Features5_Pricing": "AI Penghapus Background",
    "SubTitle_Features17_Pricing": "Penggunaan terbatas",
    "SubTitle_Features19_Pricing": "Penggunaan sepuasnya",
    "SubTitle_Features6_Pricing": "AI Penghapus Objek",
    "SubTitle_Features7_Pricing": "Penyempurna Foto",
    "SubTitle_Features18_Pricing": "Penggunaan terbatas (HD)",
    "SubTitle_Features20_Pricing": "Penggunaan sepuasnya (HD/UHD)",
    "SubTitle_Features8_Pricing": "AI Zoom Foto",
    "SubTitle_Features9_Pricing": "AI Perluas Gambar",
    "SubTitle_Features10_Pricing": "AI Background",
    "Title_Features3_Pricing": "Fitur Desain Lainnya",
    "SubTitle_Features11_Pricing": "Fitur dan Templat Lanjutan",
    "SubTitle_Features12_Pricing": "Hapus Watermark",
    "SubTitle_Features13_Pricing": "AI Alat Foto Massal",
    "SubTitle_Features14_Pricing": "Fitur Desain Dasar",
    "Title_Credits_Pricing": "Kredit habis? Kami siap membantu.",
    "Desc_Credits_Pricing": "Pembelian satu kali, tanpa harus berlangganan.",
    "TransactionPrice_Credits_Pricing": "Harga: ${0}",
    "Credit_Credits_Pricing": "Kredit",
    "Popular_Credits_Pricing": "Terpopuler",
    "Buy_Credits_Pricing": "Beli Sekarang",
    "Title_FAQ_Pricing": "Tanya-Jawab",
    "Title_Button4_Pricing": "Upgrade sekarang untuk uji coba gratis 7 hari",
    "Title_Button3_Pricing   ": "Manfaat yang tersedia",
    "SubTitle_FAQ1_Pricing": "Apa itu kredit?",
    "Content_FAQ1_Pricing": "Kredit digunakan untuk mengakses alat AI. Jumlah kredit yang dibutuhkan bervariasi tergantung jenis alatnya.",
    "Content_FAQ2_Pricing": "Kredit yang dibeli berlaku selama satu tahun.",
    "Content_FAQ3_Pricing": "Kredit keanggotaan berlaku selama periode keanggotaan.",
    "SubTitle_FAQ2_Pricing": "Bagaimana cara membatalkan langganan dan bagaimana dengan kredit saya setelah pembatalan?",
    "Content_FAQ4_Pricing": "Setelah membatalkan langganan,",
    "Content_FAQ5_Pricing": "Kredit keanggotaan Anda akan tetap berlaku hingga masa keanggotaan berakhir. Kredit yang dibeli secara terpisah tidak akan terpengaruh.",
    "Content_FAQ6_Pricing": "Jika Anda perlu membatalkan langganan, silakan ikuti langkah-langkah di bawah ini setidaknya 24 jam sebelum siklus penagihan berikutnya dimulai:",
    "Content_FAQ7_Pricing": "1. Buka Designkit dan login.",
    "Content_FAQ8_Pricing": "2. Masuk ke jendela pop-up langganan.",
    "Content_FAQ9_Pricing": '3. Pilih "Kelola Langganan".',
    "Content_FAQ10_Pricing": '4. Pilih paket saat ini dan klik "Batalkan Langganan".',
    "Content_FAQ11_Pricing": "Langganan akan tetap aktif hingga akhir siklus penagihan saat ini. Jika Anda tidak dapat membatalkannya, harap ambil tangkapan layar dan segera hubungi dukungan online kami.",
    "SubTitle_FAQ3_Pricing": "Apakah ada kebijakan refund?",
    "Content_FAQ12_Pricing": "1. Garansi Uang Kembali 7 Hari:",
    "SubTitle_FAQ4_Pricing": "Bagaimana cara mengupgrade atau mendowngrade langganan?",
    "Content_FAQ25_Pricing": "1. Upgrade: Anda bisa langsung berlangganan ke paket yang lebih tinggi, dan akan berlaku segera. Langganan lama akan dibatalkan, dan sisa saldo yang ada akan direfund.",
    "SubTitle_FAQ5_Pricing": "Apakah akan ada salinan invoice?",
    "Content_FAQ27_Pricing": "Ada! Setelah pembayaran berhasil, Anda akan menerima email dari layanan penyedia pembayaran yang berisi invoice elektronik. Jika Anda tidak menerima email invoice, silakan hubungi tim dukungan kami.",
    "SubTitle_FAQ6_Pricing": "Apa saja metode pembayaran yang didukung?",
    "Content_FAQ28_Pricing": "Kami menggunakan Stripe untuk mengelola pembayaran dan langganan. Kami menerima semua kartu kredit utama, PayPal, dan Google Pay.",
    "SubTitle_FAQ7_Pricing": "Bagaimana cara menghubungi dukungan?",
    "Content_FAQ29_Pricing": "Email: support@designkit.com. Waktu respons: 3-10 hari kerja.",
    "Content_FAQ13_Pricing": "Jika Anda membeli langganan dan belum menggunakannya dalam 7 hari, Anda mungkin memenuhi syarat untuk refund penuh.",
    "Content_FAQ14_Pricing": "Jika Anda membeli kredit, Anda mungkin berhak mendapatkan refund untuk kredit yang tidak digunakan dalam waktu 7 hari.",
    "Content_FAQ15_Pricing": "2. Ketidakpuasan terhadap Layanan",
    "Content_FAQ16_Pricing": "Jika Anda tidak puas dengan hasilnya, silakan hubungi tim dukungan online kami. Kami mungkin memberikan kompensasi atau refund bergantung pada situasinya.",
    "Content_FAQ17_Pricing": "3. Pembelian via Google Play atau App Store",
    "Content_FAQ18_Pricing": "Jika Anda berlangganan melalui Google Play Store atau App Store, Anda perlu mengajukan refund langsung dari Google atau Apple.",
    "Content_FAQ19_Pricing": "Catatan Penting:",
    "Content_FAQ20_Pricing": "Kebijakan refund ini tidak berlaku untuk pengguna API. Jika Anda menggunakan API kami, silakan hubungi kami untuk kelayakan refund.",
    "Content_FAQ21_Pricing": "Kami berhak menolak refund dalam kasus penyalahgunaan atau pelanggaran terhadap ketentuan kami.",
    "Content_FAQ22_Pricing": "Refund dapat memerlukan beberapa hari kerja untuk diproses, tergantung metode pembayaran Anda.",
    "Content_FAQ23_Pricing": "Kami dapat memperbarui kebijakan refund dari waktu ke waktu. Harap periksa secara berkala untuk melihat adanya perubahan.",
    "Content_FAQ24_Pricing": "Untuk bantuan lebih lanjut, silakan hubungi tim dukungan kami.",
    "Content_FAQ26_Pricing": "2. Downgrade: Pertama, batalkan langganan saat ini. Setelah periode penagihan selesai, silakan berlangganan paket baru.",
    "Content_Modal_Pricing": "Terima kasih atas dukungan Anda! Bersiaplah untuk mengasah kreativitas Anda.",
    "Tip_Modal_Pricing": "Tips: Jika keanggotaan Anda belum muncul, silakan muat ulang halaman.",
    "Title_Modal_Pricing": "Berhasil dibeli",
    "Title_Rights2_Pricing": "Penggunaan terbatas fitur AI Penghapus",
    "Title_Button3_Pricing": "Manfaat yang tersedia",
    "Title_Button5_Pricing": "Upgrade",
    "BatchProcess_SaveSuccessTip": "Kit alur kerja Anda disimpan di sini.",
    "BatchProcess_createText": "Kit Alur Kerja",
    "Label_NormalMode": "Dasar:",
    "Label_AdvancedMode": "Lanjutan:",
    "Text_NormalMode": "Dasar",
    "Text_AdvancedMode": "Lanjutan",
    "BatchProcess_DefaultPrompt": "Buat Gambar",
    "BatchProcess_EditContent": "Edit konten",
    "BatchProcess_PleaseSelect": "Pilih kit alur kerja",
    "BatchProcess_SelectTip": "Semua gambar yang diunggah akan diproses secara massal menggunakan kit alur kerja yang dipilih.",
    "BatchProcess_ListEmptyTip": "Simpan kit alur kerja setelah dibuat untuk langsung membuat set serupa secara massal.",
    "BatchProcess_Tip": "Kit Alur Kerja",
    "BatchProcess_Generate": "Gunakan sekarang",
    "BatchProcess_Save": "Simpan",
    "BatchProcess_GeneratingFormula": "Membuat kit alur kerja...",
    "BatchProcess_GenerateCancel": "Batal",
    "BatchProcess_WorkFlowCreateError": "Gagal Membuat",
    "ProductInfo_PleaseUploadImage": "Unggah foto produk",
    "BatchProcess_IntelligenceGenerate": "Buat kit alur kerja",
    "BatchProcess_CreateWorkflow": "Buat",
    "BatchProcess_Formula": "Kit Alur Kerja",
    "BatchProcess_WorkFlowSaveSuccess": "Kit alur kerja disimpan",
    "ProductInfo_ImageSizeLimit": "Mendukung gambar maks ${0} MB",
    "ProductInfo_ImageUpload": "Tambah foto produk",
    "ProductInfo_UploadDemo": "Foto contoh",
    "ProductInfo_ECPlatform": "Platform",
    "ProductInfo_PleaseSelect": "Harap pilih",
    "ProductInfo_InputCustomize": "Kustom",
    "ProductInfo_CountryAndLanguage": "Wilayah/bahasa target",
    "ProductInfo_Name": "Nama produk",
    "ProductInfo_Desc": "Detail produk (Fitur/Ukuran/Skenario penggunaan)",
    "ProductInfo_DescPlaceholder": "Masukkan informasi produk termasuk fitur, ukuran, skenario penggunaan, target audiens, dan lain-lain.",
    "ProductInfo_NamePrompt": "Nama produk adalah ${0};",
    "ProductInfo_ECPlatformPrompt": "Platform target adalah ${0};",
    "ProductInfo_CountryAndLanguagePrompt": "Bahasanya adalah ${0};",
    "ProductInfo_DescPrompt": "Detail produk adalah ${0}.",
    "ProductInfo_PleaseInput": "Masukkan",
    "AgentEmpty_CaseUseBtn": "Gunakan",
    "AgentEmpty_CaseRefreshBtn": "Segarkan",
    "MenuItem_Effect": "Efek",
    "MenuItem_Shadow": "Bayangan",
    "MenuItem_Stroke": "Coretan",
    "Button_Logout": "Logout",
    "Tip_UploadMax": "Unggah file JPG, JPEG, atau PNG berukuran maks ${0} MB, maksimal N gambar.",
    "Menu_ManageSubscription": "Kelola Langganan",
    "Menu_TermsPolices": "Ketentuan dan Kebijakan",
    "Title_ChangeText": "Ganti Teks",
    "Message_ExtractText": "Mengekstrak teks",
    "Message_ExtractTextError": "Gagal mengekstrak teks. Coba lagi.",
    "Tip_CreditConsume": "Pemrosesan ini menggunakan ${0} kredit",
    "BatchProcess_SaveSuccessTip_GotIt": "Mengerti",
    "BatchProcess_SaveSuccessTip_Title": "Menggunakan Kit Alur Kerja",
    "BatchProcess_SaveSuccessTip_Desc": "Kit alur kerja Anda disimpan di sini. Pilih salah satu kit untuk membuat gambar dengan cepat menggunakan templat yang disimpan.",
    "BatchProcess_tutorial": "Tutorial",
    "Text_Model_Pricing": "Harga Model",
    "Text_Pro_discount": "Paket Pro: Pembuatan Video Setengah Harga",
    "Dropdown_AddFromBrandkit": "Tambahkan dari Kit Merek",
    "Button_ExportFromBrandkit": "Impor dari Kit Merek",
    "Text_TemplatePrompt": "Mari awali dengan inspirasi",
    "Text_Hi": "Hai, ${0}!",
    "Text_Account_Popup_Left": "Gunakan asisten AI desain khusus untuk e-commerce. Dirancang untuk para profesional yang menginginkan peluncuran lebih cepat, presentasi yang lebih kuat, dan profit yang lebih tinggi.",
    "Tip_EstimatedTime": "Siap dalam ${0} menit",
    "Text_HandTool": "Alat tangan",
    "Text_Function": "Fungsi",
    "Text_WindowsSystem": "Sistem Windows",
    "Text_MacSystem": "Sistem Mac",
    "Menu_KeyboardShortcuts": "Pintasan",
    "Title_KeyboardShortcuts": "Pintasan",
    "Text_Undo": "Batalkan",
    "Text_MouseLeft": "Tombol mouse kiri",
    "Text_Redo": "Ulangi",
    "Text_Delete": "Hapus",
    "Text_Cut": "Potong",
    "Text_Copy": "Salin",
    "Text_Paste": "Tempel",
    "Text_PasteFixed": "Tempel di tempat",
    "Text_CreateCopy": "Buat salinan",
    "Text_SelectAll": "Pilih semua",
    "Text_SelectMultiple": "Pilih banyak",
    "Text_Group": "Grup",
    "Text_Ungroup": "Pisahkan",
    "Text_LockLayer": "Kunci",
    "Text_Save": "Simpan",
    "Text_Move": "Pindahkan",
    "Text_MoveWithCombinedKeys": "Gerak cepat",
    "Text_NewText": "Teks baru",
    "Text_NewLine": "Baris baru",
    "Text_NewRectangle": "Kotak baru",
    "Text_NewCircle": "Lingkaran baru",
    "Text_ExitFullScreen": "Keluar layar penuh",
    "Text_MoveUpOneLayer": "Majukan",
    "Text_MoveDownOneLayer": "Mundurkan",
    "Text_Top": "Letakkan di depan",
    "Text_Bottom": "Letakkan di belakang",
    "Text_ToggleReferenceLine": "Tampilkan/sembunyikan panduan",
    "Text_ToggleRulerBar": "Tampilkan/sembunyikan penggaris",
    "Text_ArrowKey": "Tombol panah",
    "Text_CanvasShowAll": "Tampilkan semua kanvas",
    "Title_Unsupported_Multilayer": "Fitur ini hanya berfungsi pada satu layer.",
    "Btn_CreateBatchProcessFormula": "Buat",
    "Button_Hide_Otherlayers": "Pertahankan layer pertama dan lanjutkan",
    "Button_Merge_Alllayers": "Gabungkan semua layer dan lanjutkan",
    "Checkbox_Disable_Remind": "Jangan tampilkan lagi",
    "Button_Tool": "Alat",
    "Button_Custom_Ratio": "Kustom",
    "Label_Spacing": "Jarak",
    "Button_Download_Whole": "Ekspor sebagai Gambar",
    "Button_Download_Layer": "Ekspor Menurut Layer",
    "Button_Origin_Ratio": "Original",
    "Text_TouchEdit_Title": "Tunjuk untuk Mengedit",
    "Text_TouchEdit_Description": "Tunjuk objek dan jelaskan perubahan yang diinginkan. Foto akan diedit persis sesuai prompt.",
    "Tooltip_TouchEdit_Max_Count": "Bisa menunjuk maksimal ${0} area",
    "Tooltip_TouchEdit_Usage": "Pintasan Tunjuk untuk Mengedit: ${0} + klik",
    "Text_TouchEdit_Recognition_Custom": "Kustom",
    "Text_TouchEdit_Recognition_Title1": "Deteksi dan kenali",
    "Text_TouchEdit_Recognition_Title2": "Target tidak ditemukan. Masukkan nama objek.",
    "Text_TouchEdit_Name": "Tunjuk untuk Mengedit",
    "Btn_LoginToViewBatchProcess": "Login untuk melihat kit alur kerja",
    "Btn_Login": "Login",
    "Menu_Main_Beautify": "Sempurnakan",
    "Text_PleaseWaitImageUploaded": "Lanjutkan setelah unggahan selesai",
    "Menu_Redeem_Rights": "Tukarkan",
    "Text_Redeem_Now": "Tukarkan Sekarang",
    "Text_Redeem_Placeholder": "Masukkan kode penukaran, huruf besar dan kecil harus benar",
    "Text_Redeem_Success": "Penukaran berhasil",
    "Text_Redeem_Use": "Tukarkan kode",
    "Tooltip_BrandAutoUse": "Kit merek baru telah diterapkan!",
    "Redeem_Redeem_Note": "Catatan: \nSilakan login dan masukkan kode penukaran.\nSetelah penukaran berhasil, selamat menikmati manfaat dan layanan terkait.\nGunakan kode penukaran selama masih berlaku. Kode yang telah kedaluwarsa akan dibatalkan dan tidak dapat direfund.\nHarap simpan kode. Kami tidak bertanggung jawab jika kode hilang, bocor, atau digunakan tanpa izin.\nKode ini tidak dapat dijual kembali atau ditransfer kepada orang lain, tidak dapat ditukar dengan uang tunai, dan tidak bisa digunakan untuk faktur.",
    "Sidebar_NewDesign": "Obrolan baru",
    "Text_Appeal_ReGenerate": "Hasil editan tidak memenuhi syarat untuk ditinjau.",
    "Modal_Button_Known": "OK",
    "MenuItem_Appeal": "Tinjauan Hasil",
    "Text_Appeal_Left": "Sisa percobaan bulan ini\n<i>${0}</i>/${1}",
    "Text_Appeal_Confirm": "Ya",
    "Text_Appeal_Refunded": "Kredit telah dikembalikan ke akun.",
    "Modal_Button_GotIt": "Terima",
    "Modal_Button_Later": "Lain kali",
    "Text_Vip_Open": "Berlangganan",
    "Menu_Title_Invite": "Ajak Teman",
    "Text_Button_Invite": "Dapatkan Kredit",
    "Title_Dialog_Invite": "Ajak Teman",
    "Desc_Dialog_Invite": "Bagikan tautan dengan teman atau posting di media sosial. Ketika aada yang mendaftar setelah mengklik tautan tersebut, Anda dan teman tadi akan menerima ${0} kredit. Jika mereka berlangganan, maka masing-masing akan menerima hingga ${1} kredit lagi.  ",
    "Detail_Dialog_Invite": "Detail",
    "Text_Copy_Invite": "Salin tautan",
    "Title_Rewards_Invite": "Hadiah",
    "SubTitle_Rewards1_Invite": "Total kredit diperoleh",
    "SubTitle_Rewards2_Invite": "Pengguna gratis dari referal",
    "SubTitle_Rewards3_Invite": "Pengguna berbayar dari referal",
    "Success_Copy_Invite": "Tautan disalin",
    "Title1_Invited_Invite": "Anda diundang!",
    "Text_Rule1_Invite": "Untuk setiap teman yang mendaftar menggunakan tautan tersebut, masing-masing akan mendapatkan <strong>${0} kredit</strong>.",
    "Text_Rule2_Invite": "Jika teman berlangganan, masing-masing akan mendapatkan kredit tambahan (<strong>${0} untuk Plus, ${1} untuk Pro</strong>).",
    "Text_Rule3_Invite": "Langganan yang telah dibeli tidak dapat direfund jika paket atau kredit yang diberikan telah digunakan. Selain itu, kredit gratis tidak dapat dikembalikan setelah digunakan.",
    "Text_Rule4_Invite": "Setiap pengguna dapat mengundang maksimal ${0} teman.",
    "Text_Rule5_Invite": "Hadiah tidak akan diberikan untuk referal yang sudah punya akun, referensi ke diri sendiri, akun ganda, atau aktivitas penipuan.",
    "Text_Rule6_Invite": "${0} berhak menyesuaikan program dan mencabut hadiah dari akun yang teridentifikasi tidak wajar.",
    "Text_Divider_Invite": "atau bagikan tautan",
    "Title2_Invited_Invite": "Bergabunglah ke ${0} dan klaim hadiahnya",
    "SubTitle1_Invited_Invite": "Seorang teman mengundang Anda untuk mencoba agen Al merek profesional kami. Buat desain pemasaran merek berkualitas tinggi seperti logo, poster, menu, dan aset media sosial dengan mudah.",
    "SubTitle2_Invited_Invite": "<strong>Daftar sekarang</strong> dan masing-masing akan <strong> mendapatkan ${0} kredit</strong>.<strong> Jika berlangganan,</strong> masing-masing akan mendapatkan kredit tambahan sesuai dengan paket yang dipilih (<strong>${1} kredit untuk Plus atau ${2} kredit untuk Pro</strong>). Daftar sekarang dan klaim hadiahnya.",
    "Button_Invited_Invite": "Daftar dan klaim hadiahnya",
    "Success_Invited_Invite": "Anda bergabung melalui referal dan mendapatkan ${0} kredit.",
    "Error_Invited_Invite": "Anda sudah punya akun.",
    "Text_Share_Invite": "Aku menggunakan ${0} untuk membuat logo, visual, dan video dengan cepat dan mudah. Daftar melalui tautan ini dan kita berdua akan mendapatkan bonus kredit.",
    "Title_Share_Invite": "Bergabunglah ke ${0} dan dapatkan bonus kredit!",
    "Share_Email_Invite": "Email",
    "Text_Rule7_Invite": "Kamu bisa menggunakan kredit untuk Agen AI. Kredit akan kedaluwarsa setelah satu bulan.",
    "Text_AdvanceSetting": "Ahli",
    "Text_MainImage": "Gambar utama",
    "Text_ProductAgentUploadGuide1": "1. Unggah foto dari berbagai sudut agar AI dapat mengenali dan merestorasi detail produk dengan akurat.",
    "Text_ProductAgentUploadGuide2": "2. Unggah maksimal 10 foto. Foto pertama akan digunakan sebagai gambar utama. Sebaiknya pilih foto yang menunjukkan produk secara keseluruhan dengan jelas.",
    "Text_Optional": " (Opsional)",
    "Tip_ClickDragImageWithSize": "Unggah foto format JPEG, JPG, atau PNG berukuran maks ${0} MB.",
    "Button_AddReferenceImage": "Unggah",
    "Title_ReferenceImage": "Gambar referensi",
    "Input_Placeholder": "Harap pilih",
    "Radio_ReferenceColor": "Warna referensi",
    "Radio_ReferenceLayout": "Layout referensi",
    "Tag_FirstImage": "Gambar pertama",
    "Tag_FirstImageNoPartial": "Gambar pertama parsial",
    "Tag_Blur": "Blur",
    "Tag_Jigsaw": "Kolase",
    "Button_Understood": "Mengerti",
    "Text_ReferenceImageIndex": "Gambar ${0} sebagai referensi",
    "Text_ReferenceDimensions": "Gnakan ${0} dari referensi",
    "Tag_Cropped": "Dipangkas",
    "Tag_Underexposed": "Kurang terang",
    "Tag_Blurry": "Blur",
    "SelectOption_ColorPalette": "Palet Warna",
    "SelectOption_Layout": "Layout",
    "SelectOption_Fonts": "Fon",
    "SelectOption_Style": "Gaya",
    "SelectOption_ShapeElements": "Elemen Bentuk",
    "Text_SocialMediaAgentUploadGuide": "Unggah produk unggulan terlebih dahulu. Pastikan foto jelas dan lengkap.",
    "Menu_Manage_Subscriptions": "Kelola Langganan",
    "Menu_Text_Subscriptions": "Langganan",
    "Menu_View_Subscriptions": "Lihat Langganan",
    "Text_Download_XdesignApp": "Unduh aplikasi <span>X-Design</span> untuk menggunakan fitur",
    "Text_Free_Trial": "Unduh Uji Coba Gratis 7 Hari",
    "Text_Install_App": "Instal Aplikasi",
    "Text_Scan_Download": "Pindai untuk mengunduh",
    "Text_Download_the": "Unduh di",
    "Text_Available_On": "Tersedia di",
    "SecondTitle_Header6_Home": "AI Pembuat Foto Produk",
    "SecondTitle_Header7_Home": "AI Pembuat Model Fashion",
    "SecondTitle_Header8_Home": "Ganti Warna Baju",
    "SecondTitle_Header9_Home": "Pembuat Video Produk",
    "SecondTitle_Header10_Home": "Alat AI",
    "SecondTitle_Header11_Home": "AI Editor Foto",
    "SecondTitle_Header12_Home": "AI Editor Foto Online",
    "SecondTitle_Header13_Home": "Editor Foto Massal",
    "SecondTitle_Header14_Home": "AI Editor Foto Massal",
    "SecondTitle_Header15_Home": "Restorasi Foto Massal",
    "SecondTitle_Header16_Home": "Penghapus Watermark Massal",
    "SecondTitle_Header17_Home": "Pembuat Background Massal",
    "SecondTitle_Header18_Home": "Penghapus Background Foto Massal",
    "Title_Footer3_Home": "Alat Desain",
    "Subtitle_Footer8_Home": "AI Editor Foto",
    "Subtitle_Footer7_Home": "AI Ganti Background",
    "Subtitle_Footer9_Home": "Background Transparan",
    "Subtitle_Footer10_Home": "Ganti Warna Background",
    "Subtitle_Footer11_Home": "Penghapus Watermark Foto",
    "Subtitle_Footer12_Home": "Hapus Teks di Foto",
    "Subtitle_Footer13_Home": "Tambah Stiker di Foto",
    "Subtitle_Footer14_Home": "Tambah Watermark di Foto",
    "Title_Footer4_Home": "Model Foto",
    "Subtitle_Footer15_Home": "Nano Banana Pro (Gemini 3.0 Pro)",
    "Title_Footer5_Home": "Unduh Gratis",
    "Subtitle_Footer16_Home": "APP iOS",
    "Subtitle_Footer17_Home": "APP Android",
    "Title_Footer6_Home": "Follow Kami",
    "Subtitle_Footer18_Home": "Kling 3.0",
    "Subtitle_Footer19_Home": "Seedance 2.0",
    "Title_Footer7_Home": "Model Video",
    "Video_SR_Success": "Memperjelas video",
    "Video_Desubtitle_Success": "Menghapus subtitle",
    "Video_Dewatermark_Success": "Menghapus watermark",
    "Video_Process_Failed": "Pemrosesan gagal. Kredit akan dikembalikan ke akun.",
    "Video_SR": "AI Penjernih",
    "Video_Dewatermark": "Hapus Watermark",
    "Video_Desubtitle": "Hapus Subtitle",
    "Text_TouchEditFastMode": "Tunjuk untuk Mengedit Cepat",
    "Text_Pan": "Geser Horizontal",
    "Title_Canvas": "Kanvas",
    "Title_Edit": "Edit",
    "Title_Elements": "Elemen",
    "Title_Tools": "Alat",
    "Text_CanvasZoom": "Perbesar/Perkecil",
    "Tooltip_Color_Fill": "Warna",
    "Tootip_StartPoint": "Mulai",
    "Tootip_ChangePoint": "Ganti",
    "Tootip_EndPoint": "Selesai",
    "Retouch_Filter_Clear": "Bening",
    "Retouch_Filter_Enhance": "Nyata",
    "Retouch_Filter_Dehaze": "Hilangkan Kabut",
    "Retouch_Filter_Texture": "Tekstur",
    "Retouch_Filter_Nature": "Natural",
    "Retouch_Filter_Fade": "Pudar",
    "Tooltip_Downloading": "Mengunduh...",
    "Tooltip_Download_Video": "Unduh video secara terpisah, satu per satu.",
    "Tooltip_Download_NoneSelected": "Pilih konten yang ingin diunduh",
    "Text_AI_Thinking": "AI sedang bekerja...",
    "Text_Server_Busy": "Server sedang sibuk. Harap coba lagi nanti.",
    "Text_Prompt_Help_Placeholder": "Ketikkan kata kunci, saya akan mengubahnya menjadi prompt yang siap digunakan.",
    "Text_Prompt_Helping": "Sedang memproses... Harap tunggu.",
    "Button_Retry": "Coba lagi",
    "Button_Rewrite": "Coba lagi",
    "Button_Start_Prompt_Help": "Mulai menulis",
    "Title_Prompt_Helper": "AI Penulis",
    "Desc_ExpireDate": "Berakhir pada: ",
    "DownloadApp_Title_Widgets": "Unduh aplikasi ${0} untuk menggunakan fitur",
    "DownloadApp_SubTitle_Widgets": "Unduh Uji Coba Gratis ${0} Hari",
    "InstallApp_Title_Widgets": "Instal Aplikasi",
    "InstallApp_Desc_Widgets": "Pindai untuk mengunduh",
    "AppStore_Desc_Widgets": "Unduh di",
    "GooglePlay_Desc_Widgets": "Tersedia di",
    "Video_Task_Price_Estimate": "Diperlukan ${0} kredit",
    "Video_SR_Start": "Sedang mempertajam... ${0} kredit akan digunakan.",
    "Video_Dewatermark_Start": "Menghapus watermark... ${0} kredit akan digunakan.",
    "Video_Desubtitle_Start": "Menghapus subtitle... ${0} kredit akan digunakan.",
    "Text_Help_Center": "Pusat Bantuan"
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/figma/pt-BR.js
/* harmony default export */ const pt_BR = ({
    "Tips_Adding": "Processando...",
    "Tips_Loading": "Carregando...",
    "Tips_Creating": "Processando...",
    "Tips_Downloading": "Baixando...",
    "Tips_Sending": "Enviando...",
    "Tips_AddSuccess": "Adicionado com sucesso",
    "Tips_MakeSameError": "N\xe3o \xe9 poss\xedvel recriar",
    "Tips_UnsupportedGradientColor": "Os gradientes n\xe3o s\xe3o suportados",
    "Tips_CanNotAdding": "Falha ao adicionar",
    "Tips_Uninitialized": "Falha ao enviar mensagens",
    "Tips_UploadFailed": "Falha no carregamento. Por favor, tente novamente.",
    "Tips_UploadMaxCountLimit": "Carregue at\xe9 ${n} arquivo(s) ${type}",
    "Tips_UploadMaxFileSize": "N\xe3o foi poss\xedvel carregar o arquivo ${file}. Por favor, use um arquivo com tamanho m\xe1ximo de ${n} MB.",
    "Tips_UploadImageAndVideoLimit": "Voc\xea pode carregar 1 imagem e 1 v\xeddeo ao mesmo tempo",
    "Tips_UnsupportedSvgFile": "Arquivos SVG n\xe3o s\xe3o suportados",
    "Tips_UnsupportedUploadFileFormats:": "O formato do seu arquivo ${files} n\xe3o \xe9 compat\xedvel",
    "Tips_CanNotAddSameFileTips": "Este arquivo j\xe1 existe",
    "Tips_TextMinLengthTips": "Insira pelo menos ${n} caracteres",
    "Tips_TextMaxLengthTips": "Insira at\xe9 ${n} caracteres. Cada caractere chin\xeas ou emoji conta como 2.",
    "Tips_AccessDenied": "Acesso negado",
    "Tips_CreateFailed": "Falha ao iniciar o chat",
    "Tips_Error": "Ocorreu um erro",
    "Tips_NotFound": "O chat n\xe3o existe",
    "Tips_RequestAgentModelListError": "Falha ao solicitar a lista de modelos do agente",
    "Desc_Ended": "Fim",
    "Button_PeopleUse_Agent": "${n} usu\xe1rios experimentaram",
    "Dropdown_AddToChat": "Adicionar ao chat",
    "Dropdown_AddToBrandKit": "Adicionar ao kit de marca",
    "Dropdown_SaveAsBrandLogo": "Salvar como logotipo de marca",
    "Dropdown_SaveAsBrandTemplate": "Salvar como modelo de marca",
    "Title_Design_Agent": "Design",
    "Title_MainColor": "Cor principal",
    "Title_SecondaryColor": "Cor secund\xe1ria",
    "Bitton_ViewTheBrandKit": "Clique para ver o kit de marca",
    "Dropdown_InportImages": "Importar imagens",
    "Desc_RunOutOfUsesForToday_Pro": "Voc\xea esgotou seus usos gratuitos de hoje. Volte amanh\xe3.",
    "Desc_PurchaseCompleted_Pro": "Compra conclu\xedda",
    "Desc_ContinueDesign_Pro": "Agora voc\xea pode continuar seu projeto!",
    "Title_Upgrade_Pro": "Atualizar",
    "Desc_SubscribeToUnlock_Pro": "Assine para desbloquear mais!",
    "Desc_RunOutOfFreeUses_Pro": "Voc\xea esgotou suas utiliza\xe7\xf5es gratuitas.",
    "Button_UnlockNow": "Assinar",
    "Dropdown_AddImage": "Adicionar imagem",
    "Dropdown_AddVideo": "Adicionar v\xeddeo",
    "Dropdown_AddDocument": "Adicionar documento",
    "Dropdown_SupportedFormatFile": "Suporta arquivos do Word, Excel, PDF e de texto.",
    "Tips_Uninitialized_chat": "Falha ao enviar mensagens",
    "Title_Models_Dropdown": "Modelos",
    "Switch_Auto": "Auto",
    "Tab_Image": "Imagem",
    "Tab_Video": "V\xeddeo",
    "Desc_GeminiNanoBanana": "Gera\xe7\xe3o r\xe1pida, edit\xe1vel e consistente de imagens.",
    "Desc_MidjourneyImage": "Gera\xe7\xe3o de imagens art\xedsticas e criativas.",
    "Desc_Seedream": "Gera\xe7\xe3o de imagens realistas e detalhadas.",
    "Desc_SeedEdit": "Edi\xe7\xe3o precisa e natural de imagens.",
    "Desc_MidjourneyVideo": "Gera\xe7\xe3o de v\xeddeos art\xedsticos e criativos.",
    "Desc_Seedance": "Cria\xe7\xe3o de v\xeddeos realistas e expressivos.",
    "Tips_Uninitialized_Chat": "Falha ao enviar mensagens",
    "Tips_NotFound_Chat": "O chat n\xe3o existe",
    "Dropdown_BrandKit_Title": "Kit de marca",
    "Dropdown_BrandKit_Desc": "Selecione um estilo de marca como refer\xeancia para este design.",
    "Dropdown_NoReference_Option": "Sem refer\xeancias dispon\xedveis",
    "Dropdown_Example_Option": "Exemplo",
    "Action_SeeAll": "Ver tudo",
    "Dropdown_Models_Title": "Modelos",
    "Tool_ImageBgRemover": "Removedor de fundo de imagem",
    "Tool_AiBgGenerator": "Gerador de fundo com IA",
    "Tool_ImageEnhancer": "Aprimorador de imagem",
    "Tool_AiObjectsRemover": "Removedor de objeto com IA",
    "Tool_AiImageExtender": "Extensor de imagem com IA",
    "Tool_AiLogoGenerator": "Gerador de logotipo com IA",
    "Tool_AiModelMannequin": "Modelo de IA - Manequim",
    "Tool_AiModelFlatlay": "Modelo de IA - Flatlay",
    "Tool_AiImageRecolor": "Recolorir imagem com IA",
    "Tool_FootwearModel": "Modelo de cal\xe7ado",
    "Tool_ImageUpscaler": "Ampliador de imagem com IA",
    "Tool_ImageTranslation": "Tradu\xe7\xe3o de imagem",
    "Tool_BatchImageBgRemover": "Removedor de fundo de imagens em lote",
    "Tool_BatchImageEnhancer": "Aprimorador de imagens em lote",
    "Tool_BatchAiObjectsRemover": "Removedor de objetos em lote com IA",
    "Tool_VideoEnhancer": "Aprimorador de v\xeddeo",
    "Tool_VideoBgRemover": "Removedor de fundo de v\xeddeo",
    "Tool_VideoWatermarkRemover": "Removedor de marca d'\xe1gua de v\xeddeo",
    "Dropdown_AdvancedFeatures_Title": "Recursos avan\xe7ados",
    "Dropdown_AdvancedFeatures_Conent": "Acesso total a todas as ferramentas com tecnologia de IA para aumentar sua efici\xeancia.",
    "Dropdown_MassiveContent_Title": "Conte\xfado extensivo",
    "Dropdown_MassiveContent_Content": "Acesso ilimitado a modelos premium e a uma ampla gama de recursos Plus.",
    "Dropdown_CommercialRights_Title": "Direitos comerciais",
    "Dropdown_CommercialRights_Content": "Use suas cria\xe7\xf5es pessoais com confian\xe7a, respaldadas pela prote\xe7\xe3o garantida de copyright.",
    "Popup_SubscribeIntl_Desc": "Aproveite ao m\xe1ximo o X-Design com a vers\xe3o Pro",
    "Popup_SubscribeIntl_Desc1": "Desbloqueie mais cria\xe7\xf5es com cr\xe9ditos",
    "Popup_SubscribeIntl_Detail": "Ver detalhes do plano e Ajuda",
    "Popup_StripeCheckout": "Checkout com Stripe",
    "Popup_LiveSupport": "Suporte ao vivo",
    "Popup_CancelAnytime": "Cancele a qualquer momento",
    "Menu_ManageSubscriptions": "Gerenciar assinaturas",
    "Menu_ReferralLink": "Link de refer\xeancia",
    "Menu_Language": "Idioma",
    "Menu_BenefitsUpgraded": "Benef\xedcios",
    "Menu_TermsPolicies": "Termos e Pol\xedticas",
    "Menu_AccountManagement": "Conta",
    "Title_ReferralCode": "C\xf3digo de refer\xeancia",
    "Title_ReferralLink": "Link de refer\xeancia",
    "Desc_NoActiveSubscription": "Nenhuma assinatura ativa",
    "Button_ClickToSubscibe": "Clique aqui para assinar",
    "Title_SubscriptionCancel": "Sua assinatura foi cancelada",
    "Title_SeeYou": "Lamentamos sua partida...\uD83D\uDE2D",
    "Desc_NextBillingDate": "Renova em",
    "Desc_EstimatedAmount": "Total estimado",
    "Button_CancelSubscription": "Cancelar assinatura",
    "Button_Cancel": "Cancelar",
    "Button_Delete": "Excluir",
    "Button_StaySubscribed": "Manter assinatura",
    "Title_ReasonCancelling": "Selecione um motivo para cancelar:",
    "Desc_BenefitsContinue": "Voc\xea ainda pode aproveitar os benef\xedcios da sua assinatura at\xe9 ela terminar.",
    "Desc_GiftedCredits": "Depois que a assinatura expirar, os cr\xe9ditos concedidos",
    "Desc_SeeYou": "Agradecemos por estar conosco. Lamentamos sua partida.",
    "Desc_NoNoreCharges": "N\xe3o haver\xe1 outra cobran\xe7a, e sua assinatura permanecer\xe1 ativa at\xe9",
    "Desc_MayBeRevoked": "pode ser revogada.",
    "Desc_CancelingNoRefund": "O cancelamento <span>n\xe3o inclui reembolso</span>. Se voc\xea tiver d\xfavidas sobre reembolsos, entre em contato com o suporte online.",
    "Button_Pro": "Obtenha o Pro gratuitamente",
    "Tab_Design": "Design",
    "Button_Send": "Enviar",
    "Input_Describe_Workspace": "Descreva sua imagem e eu a criarei para voc\xea",
    "Tab_AgentCase": "Caso do agente",
    "Tab_RecentCreations": "Recentes",
    "Tag_Hot": "Tend\xeancia",
    "Tag_BrandDesign": "Design de marca",
    "Tag_Logo": "Logotipos",
    "Tag_Posters": "P\xf4steres",
    "Tag_All": "Tudo",
    "Tag_Design": "Design",
    "Sidebar_Tools": "Ferramentas de IA",
    "Sidebar_Create": "In\xedcio",
    "Sidebar_Batch": "Editor em lote",
    "Sidebar_MyDesigns": "Meus designs",
    "Sidebar_Inspire": "Me inspire",
    "Sidebar_Brand": "Kit de marca",
    "Sidebar_Unfold": "Abrir barra lateral ",
    "Tab_Agent": "Agente",
    "Tool_AiPhotoEditor": "Editor de imagem",
    "Button_Upload": "Carregar",
    "Tool_Designer": "Designer",
    "Button_BlankCanvas": "Criar",
    "Title_AiTool": "Ferramentas de IA",
    "Tool_ImageBackgroundRemover": "Removedor de fundo com IA",
    "Tool_AiBackgroundGenerator": "Gerador de fundo com IA",
    "Tool_AiLogo": "Gerador de logotipo com IA",
    "Tab_RecentlyCreated": "Recentes",
    "Tab_GenerateRecords": "Cria\xe7\xf5es",
    "Menu_Edit": "Editar",
    "Menu_Download": "Baixar",
    "Menu_Delete": "Excluir",
    "Sidebar_PackUp": "Fechar barra lateral",
    "Menu_DueToday": "Cr\xe9ditos de b\xf4nus di\xe1rios",
    "Menu_DueToday_Explain": "V\xe1lidos at\xe9 o final do dia.",
    "Menu_Else": "Outros cr\xe9ditos",
    "Menu_Else_Explain_AgentCredits": "Cr\xe9ditos de outras fontes. V\xe1lidos por um per\xedodo mais longo.",
    "Title_Total_AgentCredits": "Total - Cr\xe9ditos de Agente",
    "Menu_Total_Explain_AgentCredits": "Apenas para o agente de IA e ser\xe3o usados primeiro.",
    "Tips_Credit_Explain_Agent": "O que s\xe3o Cr\xe9ditos de Agente?",
    "Title_Total_PaidCredits": "Cr\xe9ditos totais adquiridos",
    "Menu_Total_Explain_PaidCredits": "Para todos os recursos e v\xe1lidos durante o per\xedodo de assinatura.",
    "Menu_Pro": "Cr\xe9ditos de assinatura",
    "Menu_Pro_Explain": "V\xe1lidos durante o per\xedodo de assinatura.",
    "Menu_Else_Explain_PaidCredits": "Cr\xe9ditos de outras fontes. V\xe1lidos durante o per\xedodo de assinatura.",
    "Menu_UsageDetail": "Detalhes de uso",
    "Tips_Credit_Explain_Paid": "O que s\xe3o cr\xe9ditos comprados?",
    "Title_Total_InactiveCredits": "Total de cr\xe9ditos inativos",
    "Menu_Total_Explain_SuspendCredits": "Indispon\xedveis at\xe9 que sua assinatura seja reativada.",
    "Button_GoPro_GetMore": "Obtenha mais cr\xe9ditos",
    "Menu_SuspendCredits": "Cr\xe9ditos inativos",
    "Menu_AgentCredits": "Cr\xe9ditos de Agente",
    "Menu_Credits": "Cr\xe9ditos",
    "Tab_Invite": "Convidar",
    "Tab_Reward": "Recompensas",
    "Title_AgentCreditForRewards": "Recompensas de Cr\xe9ditos de Agente:",
    "Table_Time": "Hora",
    "Table_Invitee": "Convidado",
    "Table_AgentCredit": "Cr\xe9ditos de Agente",
    "Title_ShareWithFriends": "Compartilhe com seus amigos",
    "Title_ShareWithFriends_ExplainOne": '<span style="color:#616266;">Convide um amigo e ambos receber\xe3o </span><span style="color:#2D990C;">${0} Cr\xe9ditos de Agente!</span>',
    "Title_ShareWithFriends_ExplainTwo": '<span style="color:#616266;">Voc\xea pode convidar at\xe9 </span><span style="color:#2D990C;">${0} novos amigos</span><span style="color:#616266;"> e ganhar no m\xe1ximo ${1} Cr\xe9ditos de Agente!</span>',
    "Title_InvitationLink": "Compartilhe este link com seus amigos",
    "Button_Copy": "Copiar",
    "Title_Tips": "Dicas",
    "Title_Tips_ExplainOne": "1. Os Cr\xe9ditos de Agente s\xf3 podem ser usados para acessar os recursos do Agente de IA. Cr\xe9ditos de recompensa s\xe3o v\xe1lidos por dois anos.",
    "Title_Tips_ExplainTwo": "2. Novos amigos receber\xe3o uma recompensa ap\xf3s se registrarem com sucesso. Se voc\xea tiver alguma d\xfavida, entre em contato com nossa equipe de suporte.",
    "Title_FailedToReceiveReward": "Falha na opera\xe7\xe3o",
    "Title_YouCannotUseYourOwnLink": "Links privados n\xe3o s\xe3o permitidos",
    "Title_FailedToReceiveReward_Explain": "Se voc\xea tiver alguma d\xfavida, entre em contato com nossa equipe de suporte.",
    "Button_Ok": "Entendi",
    "Button_Invite": "Convidar",
    "Title_AgentCredits": "+50 Cr\xe9ditos de Agente",
    "Title_GetRewarded": "Convite bem-sucedido!",
    "Title_GetRewarded_Explain": "Os cr\xe9ditos s\xf3 podem ser usados para recursos do Agente de IA e s\xe3o v\xe1lidos por dois anos.",
    "Tips_Copied": "Copiado!",
    "Menu_Total": "Total",
    "Menu_Else_AgentCredits": "Outros cr\xe9ditos",
    "Input_Describe_workspace": "Descreva a sua ideia de imagem e vou cri\xe1-la para voc\xea",
    "Tool_AiBackgroundGenrator": "Gerador de fundo com IA",
    "Input_Models": "Modelo",
    "Button_TryItNow": "Experimente agora",
    "\xa0Tab_RecentCreations_Agent": "Agente",
    "\xa0Tab_RecentCreations_Design": "Ferramentas inteligentes",
    "Account_Pricing": "Pre\xe7os",
    "Account_Language": "Idioma",
    "Account_Language_English": "Ingl\xeas",
    "Account_Language_Chinese": "Chin\xeas",
    "Dropdown_SaveToBrandKit": "Salvar como logotipo de marca",
    "Dropdown_SaveToBrandTemplate": "Salvar como modelo de marca",
    "Tab_RecentCreations_Agent": "Agente",
    "Tab_RecentCreations_Design": "Ferramentas inteligentes",
    "Menu_FunctionalPricing": "Pre\xe7os do agente",
    "Title_FeaturePricing": "Pre\xe7os do agente",
    "Tab_Category": "Categoria",
    "Tab_TaskType": "Tarefa",
    "Tab_Consume": "Pre\xe7o (Cr\xe9ditos)",
    "Tab_ExampleContent": "Exemplos",
    "Tips_CreditExplain_Inactive": "O que s\xe3o os cr\xe9ditos inativos?",
    "Title_NanoPro": "\uD83C\uDF4C\uD83C\uDF4CAgora, o Nano Banana Pro est\xe1 dispon\xedvel no X-Design.",
    "Title_Workspace": "Seu agente criativo de IA para branding",
    "Menu_InviteReward": "Recompensa por convidar amigos",
    "Title_NoDesigns": "Ainda n\xe3o h\xe1 designs.",
    "Title_NoGenerations": "Ainda n\xe3o h\xe1 gera\xe7\xf5es.",
    "Desc_NoDesigns": "Seus designs aparecer\xe3o aqui.",
    "Desc_NoGenerations": "Suas gera\xe7\xf5es aparecer\xe3o aqui.",
    "Title_DeleteDesign": "Excluir este design",
    "Popup_DeleteDesign": "Voc\xea tem certeza de que deseja excluir este design permanentemente? Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
    "Title_LoginPopup": "Fa\xe7a login para desbloquear seu teste gratuito",
    "SubTitle_LoginPopup": "Comece a criar com o X-Design hoje",
    "Button_GotIt": "Entendi",
    "Title_Congrats": "Parab\xe9ns",
    "SubTitle_BrandCreate": "Voc\xea criou seu primeiro kit de marca. Chegou a hora de explorar seu potencial!",
    "Button_CheckUse": "Confira agora mesmo",
    "Chat_Prompt_Brand": "Crie um cartaz promocional",
    "Tooltip_UseBrand": "Voc\xea pode trocar ou adicionar seu kit de marca aqui!",
    "Tooltip_PosterBrand": "Toque para criar seu primeiro cartaz com base no kit da sua marca",
    "Popup_CreateBrand": "Crie uma marca do zero",
    "Desc_CreateBrand": "Crie logos originais incr\xedveis com o nosso Agente de IA.",
    "Popup_UploadBrand": "Carregue as informa\xe7\xf5es da sua marca",
    "Desc_UploadBrand": "Fa\xe7a o upload, e o X-Design manter\xe1 todos os designs alinhados.",
    "Title_BrandEntry": "Obtenha agora um projeto de identidade visual personalizado",
    "Desc_BrandEntry": "Deixe que a nossa IA seja a sua especialista. Responda a algumas perguntas e receba um projeto de marca completo, personalizado de acordo com a sua vis\xe3o.",
    "Tooltip_UseBrand_Agent": "Uma vez aplicado o kit de marca, o design far\xe1 refer\xeancia autom\xe1tica ao logo, \xe0 paleta de cores e ao estilo geral.",
    "Tooltip_PosterBrand_Agent": "Voc\xea j\xe1 pode come\xe7ar a criar com seu kit de marca",
    "MenuItem_AiChange": "Edi\xe7\xe3o com IA",
    "MenuItem_AiExpend": "Extensor com IA",
    "MenuItem_AiHD": "Nitidez com IA",
    "MenuItem_Eliminate": "Remo\xe7\xe3o com IA",
    "MenuItem_SplitLayers": "Camadas divididas",
    "MenuItem_Cutout": "Removedor de fundo",
    "MenuItem_ChangeText": "Substituir texto",
    "MenuItem_AddToChat": "Adicionar ao chat",
    "MenuItem_AddToBrand": "Adicionar ao kit de marca",
    "MenuItem_AddToBrandLogo": "Salvar logo de marca",
    "MenuItem_AddToBrandTemplate": "Salvar modelo de marca",
    "Button_ExportImage": "Importar imagens",
    "Button_ExportMedia": "Importar v\xeddeos",
    "Placeholder_ChatInput": "Vamos come\xe7ar!",
    "Tooltip_Grab": "Ferramenta m\xe3o",
    "Placeholder_ImageFusion": "Me diga como voc\xea gostaria que as imagens fossem mescladas",
    "Button_ImageFusion": "Mesclar",
    "Button_AiChange": "Editar",
    "Placeholder_AiChange": "Diga o que voc\xea quer mudar",
    "BatchProcessTable_ImageType": "Tipo de imagem",
    "BatchProcessTable_PictureRequirement": "Detalhes do design",
    "BatchProcessTable_CopywritingRequirements": "Descri\xe7\xe3o do produto",
    "BatchProcessTable_Actions": "A\xe7\xe3o",
    "BatchProcessTable_AddOneRow": "Adicionar",
    "EditBatchProcess_Tip": "As altera\xe7\xf5es feitas nas diretrizes afetar\xe3o os resultados gerados.",
    "EditBatchProcess_Start": "Comece com uma diretriz",
    "EditBatchProcess_GenerateTip": "Envie as imagens do seu produto, e os designs ser\xe3o gerados com base nas diretrizes.",
    "Title_Request": "Chat",
    "Title_ChooseImageType": "Selecionar o tipo de imagem gerada (v\xe1rias op\xe7\xf5es)",
    "Text_ChatCancelStatus": "Tarefa conclu\xedda",
    "langding_more_bg_remover": "Removedor de fundo",
    "langding_more_enhancer": "Aprimorador de imagem",
    "langding_more_objects_remover": "Removedor de objeto com IA",
    "langding_more_bg_generator": "Gerador de fundo com IA",
    "Title_More1_Home": "Aprimorador de imagem",
    "Title_More2_Home": "Removedor de objeto com IA",
    "Title_More3_Home": "Gerador de fundo com IA",
    "Title_More4_Home": "Removedor de fundo com IA",
    "Title_More5_Home": "Ferramentas de imagens em lote",
    "Title_Home": "Seu agente de design com IA para <span>e-commerce</span>",
    "Placeholder_Input_Home": "Descreva sua imagem e vou cri\xe1-la para voc\xea.",
    "Title_Card4_Home": "Elementos visuais para a Amazon",
    "Title_Card1_Home": "Provador virtual de roupas e acess\xf3rios",
    "Title_Card3_Home": "Imagens para a p\xe1gina de detalhes de produto",
    "Title_Card2_Home": "Gerador de fundo",
    "Desc_Features1_Home": "A IA extrai automaticamente as caracter\xedsticas do produto e as prefer\xeancias de estilo para determinar as solu\xe7\xf5es ideais de design.",
    "Desc_Features2_Home": "Basta inserir uma frase e a IA gerar\xe1 uma cole\xe7\xe3o completa de imagens de e-commerce, incluindo a imagem principal, elementos visuais de apoio e uma p\xe1gina com detalhes completos sobre o produto.",
    "Text_Btn_Home": "Comece gratuitamente",
    "Desc_Features3_Home": "Crie automaticamente elementos personalizados prontos para plataformas como Amazon, Etsy, TEMU, eBay e muito mais, garantindo que as imagens sempre sejam otimizadas para atrair o p\xfablico certo.",
    "Desc_Features4_Home": "Basta inserir seu pedido, e a IA adaptar\xe1 a linguagem, o estilo, o tom e os elementos culturais para produzir vers\xf5es localizadas para cada mercado-alvo.",
    "Desc_Features5_Home": "Salve o fluxo de trabalho do seu design como um modelo reutiliz\xe1vel, e deixe que a IA gere imagens em lote automaticamente para todas as SKUs.",
    "Desc_Features6_Home": "N\xe3o faz diferen\xe7a se voc\xea est\xe1 trabalhando com 10 ou 1.000 produtos; gere rapidamente um conjunto visual completo e consistente com facilidade.",
    "Title_Qualification_Home": "Mais de 5 milh\xf5es de vendedores de e-commerce confiam!",
    "Text_Btn_Qualification_Home": "Exibir certificado",
    "Title_Carousel_Home": "Mais ferramentas de IA",
    "Title_Footer_Home": "Seu agente de design com IA para e-commerce",
    "Title_Footer1_Home": "Conta de m\xeddia social",
    "Subtitle_Footer1_Home": "YouTube",
    "Subtitle_Footer2_Home": "X",
    "Subtitle_Footer3_Home": "Instagram",
    "Subtitle_Footer4_Home": "TikTok",
    "Title_Footer2_Home": "Ajuda e informa\xe7\xf5es legais",
    "Subtitle_Footer5_Home": "Termos de Servi\xe7o",
    "Subtitle_Footer6_Home": "Pol\xedtica de Privacidade",
    "Copyright_Footer_Home": "Copyright ${0} Meitu, Inc.",
    "Desc_Evaluation1_Home": "Adoro Designkit! As imagens de estilo de vida da IA s\xe3o naturais, e o estilo n\xf3rdico aconchegante \xe9 perfeito para a minha loja de velas. As minhas publica\xe7\xf5es t\xeam um visual elegante e as vendas t\xeam aumentado. Vale muito a pena.",
    "Job_Evaluation5_Home": "Vendedor da TEMU no M\xe9xico",
    "Job_Evaluation6_Home": "Especialista em opera\xe7\xf5es da Amazon",
    "Job_Evaluation12_Home": "Gerente de uma loja com v\xe1rias SKUs na Amazon da Indon\xe9sia",
    "Job_Evaluation2_Home": "Propriet\xe1rio de loja na Amazon e no Mercado Libre",
    "Name_Evaluation12_Home": "Arif",
    "Desc_Evaluation11_Home": "As imagens de estilo de vida s\xe3o bem naturais, parecendo at\xe9 fotos tiradas por um profissional. Meus clientes tamb\xe9m parecem ador\xe1-las, e notei um aumento real nas vendas.",
    "Name_Evaluation11_Home": "Siti",
    "Job_Evaluation10_Home": "Propriet\xe1rio de loja internacional na Lazada e na Shopee (Indon\xe9sia)",
    "Name_Evaluation10_Home": "Nina",
    "Job_Evaluation3_Home": "Designer de e-commerce DTC",
    "Job_Evaluation8_Home": "Propriet\xe1rio de loja de produtos para \xe1reas externas do Walmart na Am\xe9rica",
    "Name_Evaluation8_Home": "Jason",
    "Job_Evaluation9_Home": "Vendedor do Mercado Livre da Argentina",
    "Desc_Evaluation7_Home": "As cenas de produtos para pets geradas por IA s\xe3o muito fofas! C\xe3es e gatos parecem perfeitamente proporcionais e naturais. Al\xe9m disso, o tamanho e a escala das imagens se adaptam aos requisitos de cada plataforma, facilitando o uso imediato.",
    "Job_Evaluation7_Home": "Propriet\xe1rio de loja no Mercado Livre do Brasil",
    "Desc_Evaluation8_Home": "As cenas de acampamento com as minhas barracas ficaram muito realistas. A ilumina\xe7\xe3o e os \xe2ngulos parecem naturais, e as propor\xe7\xf5es est\xe3o perfeitas. Eu economizo tanto tempo por n\xe3o precisar tirar as fotos!",
    "Name_Evaluation7_Home": "Thiago",
    "Desc_Evaluation9_Home": "A ferramenta \xe9 bem r\xe1pida, e as imagens que ela gera s\xe3o enviadas diretamente ao Mercado Livre e \xe0 Amazon sem nenhum outro ajuste.",
    "Desc_Evaluation6_Home": "Minha preocupa\xe7\xe3o era que a IA estragasse as texturas dos tecidos, mas \xe9 dif\xedcil perceber qualquer diferen\xe7a em compara\xe7\xe3o com o original. As malhas continuam parecendo malhas, o jeans parece jeans, e tudo atende aos requisitos de imagem da Amazon. Lan\xe7ar novos produtos nunca foi t\xe3o f\xe1cil.",
    "Name_Evaluation9_Home": "Lucas",
    "Name_Evaluation6_Home": "Emma",
    "Desc_Evaluation5_Home": "As imagens dos produtos geradas por IA s\xe3o muito precisas. O comprimento dos cabos e os formatos dos conectores s\xe3o perfeitos e seguem o estilo da TEMU. Eu economizo muito tempo agora que n\xe3o preciso tirar as fotos.",
    "Desc_Evaluation12_Home": "Com apenas um prompt, consigo gerar gr\xe1ficos prontos para usar imediatamente, o que \xe9 muito mais r\xe1pido do que esperar por um designer. \xc9 realmente superpr\xe1tico.",
    "Name_Evaluation3_Home": "Chloe",
    "Name_Evaluation1_Home": "Sofia",
    "Desc_Evaluation4_Home": "As texturas met\xe1licas e os detalhes estruturais s\xe3o muito n\xedtidos e deixam as imagens ainda mais profissionais. Posso usar tudo imediatamente, sem fazer nenhuma edi\xe7\xe3o.",
    "Name_Evaluation4_Home": "Leon",
    "Desc_Evaluation10_Home": "A gera\xe7\xe3o em lote \xe9 muito \xfatil. Posso processar dezenas de SKUs de uma vez; \xe9 muito mais r\xe1pido do que fazer tudo manualmente como fazia antes.",
    "Name_Evaluation2_Home": "Mariana",
    "Desc_Evaluation3_Home": "Eu vendo roupas e tinha medo que a IA estragasse as cores ou as texturas dos tecidos, mas tudo ficou \xf3timo! As poses das modelos s\xe3o naturais e as imagens v\xeam basicamente prontas para uso imediato.",
    "Job_Evaluation1_Home": "Especialista em opera\xe7\xf5es de loja da SHEIN",
    "Name_Evaluation5_Home": "Diego",
    "Job_Evaluation11_Home": "Especialista em opera\xe7\xf5es da Amazon",
    "Desc_Evaluation2_Home": "A ferramenta \xe9 super-r\xe1pida, e as imagens j\xe1 v\xeam praticamente prontas para serem enviadas ao Mercado Livre ou \xe0 Amazon. Ela at\xe9 adapta os fundos e os modelos \xe0 cultura local, e os resultados t\xeam um aspecto totalmente profissional.",
    "Job_Evaluation4_Home": "Vendedor do eBay na Alemanha",
    "Title_Evaluation_Home": "Suas hist\xf3rias",
    "Title_Introduction_Home": "Design premium com IA que gera mais vendas",
    "Desc_Qualification_Home": "Provedor de Servi\xe7os certificado pela SPN da Amazon",
    "Title_Seo_Home": "Gerador de imagens e v\xeddeos de produtos com IA para e-commerce",
    "Desc_Seo_Home": "Gere instantaneamente imagens, p\xf4steres e v\xeddeos de produtos para a Amazon, o TikTok e muitas outras lojas online com o Agente de IA do Designkit. Comece hoje mesmo a criar designs sem custos!<br>",
    "Keywords_Seo_Home": "Agente de IA para e-commerce, Ferramentas de IA para e-commerce, Gerador de imagens de produtos com IA, Gerador de v\xeddeos de produtos com IA, Editor de fotos de produtos com IA, Removedor de fundos com IA",
    "Title_Features1_Home": "De uma \xfanica solicita\xe7\xe3o a um conjunto completo de elementos visuais",
    "Title_Features2_Home": "Localiza\xe7\xe3o totalmente automatizada para vender seus produtos globalmente em v\xe1rias plataformas.",
    "Title_Features3_Home": "Gere imagens em lote automaticamente para v\xe1rios SKUs e supere a concorr\xeancia!",
    "Title_Designkit_Home": "Designkit",
    "Tips_AboveTheFold2_Home": "Role para explorar",
    "Button_Export": "Baixar",
    "Title_Layer": "Camadas",
    "InputNumber_Opacity": "Opacidade",
    "Buttom_Comfirm": "Confirmar",
    "Button_Share": "Compartilhar",
    "Tip_ModalTitle": "Lembrete",
    "TipContent_HistoryDelete": "Depois de exclu\xeddo, esse registro n\xe3o poder\xe1 ser restaurado. Confirmar a exclus\xe3o?",
    "Title_Logo": "Logotipo",
    "Title_BrandKit": "Modelos",
    "Tab_BrandKit": "Kit de marca",
    "Tab_UploadLocal": "Escolher do \xe1lbum",
    "Button_UploadImage": "Enviar imagens",
    "Tip_ClickDragParseImage": "Carregue, solte ou cole imagens aqui.",
    "Tooltip_SwitchBrandKit": "Trocar kit de marca",
    "Discribe_BrandKitSelect": "Selecione um estilo de marca como refer\xeancia para este design.",
    "Title_Models": "Modelos",
    "MenuItem_Crop": "Tamanho da imagem",
    "Tooltip_Layer": "Camadas",
    "Tooltip_Select": "Selecionar",
    "Tooltip_Redo": "Refazer",
    "Tooltip_Undo": "Desfazer",
    "Tooltip_Add": "Adicionar",
    "Tooltip_ShowAll": "Mostrar tudo",
    "Tip_UploadType": "Formato de arquivo n\xe3o suportado",
    "Tip_UploadSize": "Apenas arquivos com at\xe9 ${0} MB s\xe3o suportados",
    "Tip_UploadWH": "Certifique-se de que cada imagem n\xe3o tenha mais de ${0}\xd7${1} pixels",
    "Tip_UploadTypeTranslate": "N\xe3o foi poss\xedvel alterar o formato do arquivo",
    "Tip_UploadFail": "O envio falhou",
    "Tooltip_AddText": "Adicionar texto",
    "Text_AddDefault": "Este texto \xe9 um exemplo.",
    "Tooltip_OverflowImageSize": "Redimensione sua imagem para menos de ${0} pixels",
    "Button_Eliminate": "Borracha",
    "Label_OriginSize": "Original",
    "Label_CropRadio": "Propor\xe7\xe3o",
    "Button_Free": "Gr\xe1tis",
    "Button_Origin": "Original",
    "Button_Crop": "Cortar",
    "Placeholder_ChangeText": "Digite o texto. Exemplo: Ol\xe1",
    "Button_ChangeText": "Confirmar",
    "InputNumber_PanSize": "Tamanho do pincel",
    "Label_TargetSize": "Alvo",
    "Tooltip_ImageFusion": "Voc\xea pode mesclar de ${0} a ${1} imagens",
    "Button_ClearSelection": "Deselecionar",
    "Button_Confirm": "Confirmar",
    "Message_Processing": "Processando...",
    "Title_Opacity": "Opacidade",
    "Button_ExpandImage": "Extensor",
    "Button_ExpandRadio": "Propor\xe7\xe3o",
    "Message_SaveFail": "Falha ao salvar",
    "Title_Pricing": "Escolha o plano ideal para voc\xea",
    "Title_Tags1_Pricing": "Mensal",
    "Title_Tags2_Pricing": "Anual",
    "Title_Plan1_Pricing": "Gratuito",
    "BatchProcessTable_Proportion": "Propor\xe7\xe3o",
    "BatchProcessList_DeleteError": "Falha ao excluir",
    "BatchProcessList_SurePrompt": "Excluir esta diretriz?",
    "BatchProcessList_SurePrompt_SureText": "Confirmar",
    "BatchProcessList_SurePrompt_CancelText": "Cancelar",
    "BatchProcessList_EmptyText": "Vazio",
    "EditBatchProcess_NameLimitTip": "Insira um nome (at\xe9 10 caracteres)",
    "Button_Continue": "Continuar",
    "Button_EditContent": "Editar mensagem",
    "Button_BatchGenerate": "Confirmado. Execute o modelo agora.",
    "Text_ChatRespondedStatus": "Processamento de tarefas",
    "Title_CreateBrand": "N\xe3o tem uma marca?",
    "Title_UploadBrand": "J\xe1 tem um logotipo?",
    "Button_CreateBrand": "Criar uma marca",
    "Button_UnlockPro": "Desbloquear Pro",
    "Button_UpgradeToPro": "Atualizar para Pro",
    "Button_RenewNow": "Renovar agora",
    "Tips_Material1_Home": "Conjunto de imagens para venda",
    "Tips_Material2_Home": "Provador virtual",
    "Tips_Material3_Home": "Conte\xfado A+",
    "Tips_Material4_Home": "Gerador de fundos",
    "Free_Button_Home": "Experimente gratuitamente",
    "Title_Header1_Home": "Produto",
    "Title_Header2_Home": "solu\xe7\xe3o",
    "Title_Header3_Home": "Inspira\xe7\xe3o",
    "Title_Header4_Home": "Aprender",
    "Title_Header5_Home": "Pre\xe7os",
    "SecondTitle_Header1_Home": "Agente de e-commerce com IA",
    "SecondTitle_Header2_Home": "Ferramentas de imagem com IA",
    "SecondTitle_Header3_Home": "Ferramentas de v\xeddeo com IA",
    "SecondTitle_Header4_Home": "Solu\xe7\xe3o de design da Amazon",
    "SecondTitle_Header5_Home": "Solu\xe7\xf5es de e-commerce para redes sociais",
    "Text_Discount_Pricing": "${0} de desconto",
    "Current_Plan_Pricing": "Plano atual",
    "Title_Instruction1_Pricing": "Ganhe 20 cr\xe9ditos pelo primeiro login",
    "Title_Instruction2_Pricing": "Gere at\xe9 20 imagens com o Agente de IA",
    "Title_Instruction3_Pricing": "Gere at\xe9 10 imagens com o Gerador de fundos com IA",
    "Title_Rights1_Pricing": "Remo\xe7\xe3o limitada de fundos ou objetos",
    "Title_Rights3_Pricing": "Aprimoramento limitado de imagens HD",
    "Title_Plan2_Pricing": "Plano B\xe1sico",
    "Month_Plan_Pricing": "m\xeas",
    "Title_Button1_Pricing": "Assinar",
    "Title_Instruction4_Pricing": "500 cr\xe9ditos/m\xeas",
    "Title_Instruction5_Pricing": "Gere at\xe9 500 imagens com o Agente de IA",
    "Title_Instruction6_Pricing": "Gere at\xe9 250 imagens com o Gerador de fundos com IA",
    "Title_Plan3_Pricing": "Plano Profissional",
    "Desc_Plan_Pricing": "Teste gratuito por 7 dias. Depois, ${0}/ano.",
    "Title_Button2_Pricing": "Teste gr\xe1tis de 7 dias",
    "Title_Instruction7_Pricing": "1.500 cr\xe9ditos/m\xeas",
    "Title_Instruction8_Pricing": "Gere at\xe9 1.500 imagens com o Agente de IA",
    "Title_Instruction9_Pricing": "Gere at\xe9 750 imagens com o Gerador de fundos com IA",
    "Title_Rights4_Pricing": "Remo\xe7\xe3o ilimitada de fundos ou objetos",
    "Title_Rights5_Pricing": "Uso ilimitado do recurso de remo\xe7\xe3o com IA",
    "Title_Rights6_Pricing": "Aprimoramento ilimitado de imagens UHD",
    "Title_Rights7_Pricing": "Ferramentas de processamento em lote",
    "Title_Best_Pricing": "Escolhido por 90% dos usu\xe1rios",
    "Title_AllFeatures_Pricing": "Compare planos gratuitos e pagos",
    "Desc_AllFeatures_Pricing": "Desbloqueie o Premium para criar designs impressionantes e sem esfor\xe7o com ferramentas avan\xe7adas de IA",
    "Month_AllFeatures_Pricing": "m\xeas",
    "Title_Features1_Pricing": "Agente de IA",
    "SubTitle_Features1_Pricing": "Edi\xe7\xe3o de imagens",
    "SubTitle_Features15_Pricing": "Gere at\xe9 ${0} imagens",
    "SubTitle_Features16_Pricing": "Gere at\xe9 ${0} imagens/m\xeas",
    "SubTitle_Features2_Pricing": "Gera\xe7\xe3o de imagens",
    "SubTitle_Features3_Pricing": "Gera\xe7\xe3o de imagens para e-commerce",
    "SubTitle_Features4_Pricing": "Gera\xe7\xe3o de cartaz",
    "Title_Features2_Pricing": "Ferramentas de imagem com IA",
    "SubTitle_Features5_Pricing": "Removedor de fundo com IA",
    "SubTitle_Features17_Pricing": "Uso limitado",
    "SubTitle_Features19_Pricing": "Uso ilimitado",
    "SubTitle_Features6_Pricing": "Removedor de objeto com IA",
    "SubTitle_Features7_Pricing": "Aprimorador de imagem",
    "SubTitle_Features18_Pricing": "Uso limitado (HD)",
    "SubTitle_Features20_Pricing": "Uso ilimitado (HD/UHD)",
    "SubTitle_Features8_Pricing": "Upscaler de imagem com IA",
    "SubTitle_Features9_Pricing": "Extensor de imagem com IA",
    "SubTitle_Features10_Pricing": "Gerador de fundo com IA",
    "Title_Features3_Pricing": "Mais recursos de design",
    "SubTitle_Features11_Pricing": "Recursos avan\xe7ados e modelos",
    "SubTitle_Features12_Pricing": "Remover marca d'\xe1gua",
    "SubTitle_Features13_Pricing": "Ferramentas de imagens em lote com IA",
    "SubTitle_Features14_Pricing": "Caracter\xedsticas b\xe1sicas de design",
    "Title_Credits_Pricing": "Est\xe1 ficando sem cr\xe9ditos? N\xf3s ajudamos voc\xea.",
    "Desc_Credits_Pricing": "Compra \xfanica, sem necessidade de assinatura.",
    "TransactionPrice_Credits_Pricing": "Pre\xe7o: ${0}",
    "Credit_Credits_Pricing": "Cr\xe9ditos",
    "Popular_Credits_Pricing": "Mais popular",
    "Buy_Credits_Pricing": "Comprar agora",
    "Title_FAQ_Pricing": "Perguntas frequentes",
    "Title_Button4_Pricing": "Atualize agora para obter um teste gratuito de 7 dias",
    "Title_Button3_Pricing   ": "Benef\xedcios dispon\xedveis",
    "SubTitle_FAQ1_Pricing": "O que s\xe3o os cr\xe9ditos?",
    "Content_FAQ1_Pricing": "Os cr\xe9ditos permitem que voc\xea continue acessando as ferramentas de IA. O n\xfamero de cr\xe9ditos necess\xe1rios varia de acordo com a ferramenta espec\xedfica.",
    "Content_FAQ2_Pricing": "Os cr\xe9ditos comprados s\xe3o v\xe1lidos por um ano.",
    "Content_FAQ3_Pricing": "Os cr\xe9ditos de assinatura s\xe3o v\xe1lidos durante o per\xedodo de dura\xe7\xe3o da mesma.",
    "SubTitle_FAQ2_Pricing": "Como cancelo minha assinatura e o que acontece com meus cr\xe9ditos ap\xf3s o cancelamento?",
    "Content_FAQ4_Pricing": "Ap\xf3s cancelar sua assinatura,",
    "Content_FAQ5_Pricing": "seus cr\xe9ditos de membro permanecer\xe3o v\xe1lidos at\xe9 ao fim do seu per\xedodo de assinatura. Quaisquer cr\xe9ditos que tenha adquirido separadamente n\xe3o ser\xe3o afetados.",
    "Content_FAQ6_Pricing": "Se voc\xea precisar cancelar sua assinatura, siga as etapas abaixo pelo menos 24 horas antes do in\xedcio do pr\xf3ximo ciclo de cobran\xe7a:",
    "Content_FAQ7_Pricing": "1. Acesse o Designkit e fa\xe7a login.",
    "Content_FAQ8_Pricing": "2. Abra a janela pop-up de assinatura.",
    "Content_FAQ9_Pricing": "3. Selecione “Gerenciar assinaturas”.",
    "Content_FAQ10_Pricing": "4. Selecione seu plano atual e clique em “Cancelar assinatura”.",
    "Content_FAQ11_Pricing": "Sua assinatura permanecer\xe1 ativa at\xe9 o fim do ciclo de faturamento atual. Se n\xe3o conseguir cancelar, fa\xe7a uma captura de tela e entre em contato com nosso suporte online o mais r\xe1pido poss\xedvel.",
    "SubTitle_FAQ3_Pricing": "Qual \xe9 a sua pol\xedtica de reembolso?",
    "Content_FAQ12_Pricing": "1. Garantia de reembolso de 7 dias:",
    "SubTitle_FAQ4_Pricing": "Como posso mudar o plano da minha assinatura?",
    "Content_FAQ25_Pricing": "1. Upgrade: basta assinar um plano de n\xedvel superior, e ele entrar\xe1 em vigor imediatamente. Sua assinatura antiga ser\xe1 cancelada e qualquer saldo restante ser\xe1 reembolsado.",
    "SubTitle_FAQ5_Pricing": "Posso obter uma c\xf3pia da minha fatura?",
    "Content_FAQ27_Pricing": "Sim! Ap\xf3s um pagamento bem-sucedido, voc\xea receber\xe1 um e-mail do provedor de pagamentos contendo uma fatura eletr\xf4nica. Se voc\xea n\xe3o receber a fatura, entre em contato com nossa equipe de suporte.",
    "SubTitle_FAQ6_Pricing": "Quais m\xe9todos de pagamento voc\xeas aceitam?",
    "Content_FAQ28_Pricing": "Utilizamos o Stripe para gerenciar pagamentos e assinaturas. Aceitamos todos os principais cart\xf5es de cr\xe9dito, PayPal e Google Pay.",
    "SubTitle_FAQ7_Pricing": "Como posso entrar em contato com o suporte?",
    "Content_FAQ29_Pricing": "E-mail: support@designkit.com. Prazo de resposta: 3 a 10 dias \xfateis.",
    "Content_FAQ13_Pricing": "Se voc\xea adquiriu assinaturas e n\xe3o as utilizou dentro de 7 dias, poder\xe1 ter direito a um reembolso total.",
    "Content_FAQ14_Pricing": "Se voc\xea comprou cr\xe9ditos, poder\xe1 ter direito a um reembolso por quaisquer cr\xe9ditos n\xe3o utilizados dentro de 7 dias.",
    "Content_FAQ15_Pricing": "2. Insatisfa\xe7\xe3o com o servi\xe7o",
    "Content_FAQ16_Pricing": "Se voc\xea n\xe3o estiver satisfeito(a) com os resultados, entre em contato com nossa equipe de suporte online. Podemos oferecer uma compensa\xe7\xe3o ou reembolso, dependendo das circunst\xe2ncias.",
    "Content_FAQ17_Pricing": "3. Compras atrav\xe9s do Google Play ou da App Store",
    "Content_FAQ18_Pricing": "Se voc\xea assinou atrav\xe9s da Google Play Store ou da App Store, voc\xea precisa solicitar um reembolso diretamente ao Google ou \xe0 Apple.",
    "Content_FAQ19_Pricing": "Observa\xe7\xf5es importantes:",
    "Content_FAQ20_Pricing": "Esta pol\xedtica de reembolso n\xe3o se aplica a usu\xe1rios da API. Se voc\xea utiliza nossa API, entre em contato conosco para saber se tem direito a um reembolso.",
    "Content_FAQ21_Pricing": "Nos reservamos o direito de recusar reembolsos em casos de uso indevido, abuso ou viola\xe7\xe3o dos nossos termos.",
    "Content_FAQ22_Pricing": "Reembolsos podem levar v\xe1rios dias \xfateis para serem processados, dependendo do seu m\xe9todo de pagamento.",
    "Content_FAQ23_Pricing": "Podemos atualizar esta pol\xedtica de reembolso periodicamente. Por favor, verifique-a regularmente para saber se houve alguma altera\xe7\xe3o.",
    "Content_FAQ24_Pricing": "Para obter mais assist\xeancia, entre em contato com nossa equipe de suporte.",
    "Content_FAQ26_Pricing": "2. Downgrade: primeiro, cancele sua assinatura atual. Quando o per\xedodo de cobran\xe7a atual terminar, assine um novo plano de n\xedvel inferior.",
    "Content_Modal_Pricing": "Agradecemos seu apoio! Prepare-se para levar sua criatividade a um novo n\xedvel.",
    "Tip_Modal_Pricing": "Dicas: Se a sua assinatura ainda n\xe3o parecer ativa, atualize a p\xe1gina.",
    "Title_Modal_Pricing": "Compra realizada com sucesso",
    "Title_Rights2_Pricing": "Uso limitado do recurso de remo\xe7\xe3o por IA",
    "Title_Button3_Pricing": "Benef\xedcios dispon\xedveis",
    "Title_Button5_Pricing": "Upgrade",
    "BatchProcess_SaveSuccessTip": "Seus kits de fluxo de trabalho s\xe3o salvos aqui.",
    "BatchProcess_createText": "Kit de fluxo de trabalho",
    "Label_NormalMode": "B\xe1sico:",
    "Label_AdvancedMode": "Avan\xe7ado:",
    "Text_NormalMode": "B\xe1sico",
    "Text_AdvancedMode": "Avan\xe7ado",
    "BatchProcess_DefaultPrompt": "Gerar imagens",
    "BatchProcess_EditContent": "Editar conte\xfado",
    "BatchProcess_PleaseSelect": "Selecione um kit de fluxo de trabalho",
    "BatchProcess_SelectTip": "Todas as imagens carregadas ser\xe3o geradas em lote usando o kit de fluxo de trabalho selecionado.",
    "BatchProcess_ListEmptyTip": "Salve o kit de fluxo de trabalho ap\xf3s a gera\xe7\xe3o para criar instantaneamente conjuntos similares em lote.",
    "BatchProcess_Tip": "Kit de fluxo de trabalho",
    "BatchProcess_Generate": "Use agora",
    "BatchProcess_Save": "Salvar",
    "BatchProcess_GeneratingFormula": "Gerando kit de fluxo de trabalho...",
    "BatchProcess_GenerateCancel": "Cancelar",
    "BatchProcess_WorkFlowCreateError": "Falha na cria\xe7\xe3o",
    "ProductInfo_PleaseUploadImage": "Carregar imagens de produto",
    "BatchProcess_IntelligenceGenerate": "Criar kit de fluxo de trabalho",
    "BatchProcess_CreateWorkflow": "Criar",
    "BatchProcess_Formula": "Kit de fluxo de trabalho",
    "BatchProcess_WorkFlowSaveSuccess": "Kit de fluxo de trabalho salvo",
    "ProductInfo_ImageSizeLimit": "Imagens com tamanho inferior a ${0} MB s\xe3o suportadas",
    "ProductInfo_ImageUpload": "Adicionar imagem do produto",
    "ProductInfo_UploadDemo": "Fotos de exemplo",
    "ProductInfo_ECPlatform": "Plataforma",
    "ProductInfo_PleaseSelect": "Por favor, selecione",
    "ProductInfo_InputCustomize": "Personalizado",
    "ProductInfo_CountryAndLanguage": "Regi\xe3o/idioma-alvo",
    "ProductInfo_Name": "Nome do produto",
    "ProductInfo_Desc": "Detalhes do produto (caracter\xedsticas/tamanho/cen\xe1rios de uso)",
    "ProductInfo_DescPlaceholder": "Insira informa\xe7\xf5es sobre o produto, incluindo caracter\xedsticas, tamanho, cen\xe1rios de uso, p\xfablico-alvo, etc.",
    "ProductInfo_NamePrompt": "O nome do produto \xe9 ${0};",
    "ProductInfo_ECPlatformPrompt": "A plataforma de destino \xe9 ${0};",
    "ProductInfo_CountryAndLanguagePrompt": "O idioma \xe9 ${0};",
    "ProductInfo_DescPrompt": "Os detalhes do produto s\xe3o ${0}.",
    "ProductInfo_PleaseInput": "Insira, por favor",
    "AgentEmpty_CaseUseBtn": "Usar",
    "AgentEmpty_CaseRefreshBtn": "Atualizar",
    "MenuItem_Effect": "Efeitos",
    "MenuItem_Shadow": "Sombras",
    "MenuItem_Stroke": "Contorno",
    "Button_Logout": "Sair",
    "Tip_UploadMax": "Carregue arquivos JPG, JPEG ou PNG de at\xe9 ${0} MB, com um m\xe1ximo de N imagens.",
    "Menu_ManageSubscription": "Gerenciar assinaturas",
    "Menu_TermsPolices": "Termos e Pol\xedticas",
    "Title_ChangeText": "Substituir texto",
    "Message_ExtractText": "Extraindo texto",
    "Message_ExtractTextError": "Falha ao extrair o texto. Tente novamente.",
    "Tip_CreditConsume": "Essa gera\xe7\xe3o usa ${0} cr\xe9ditos",
    "BatchProcess_SaveSuccessTip_GotIt": "Entendi",
    "BatchProcess_SaveSuccessTip_Title": "Usando kits de fluxo de trabalho",
    "BatchProcess_SaveSuccessTip_Desc": "Seus kits de fluxo de trabalho s\xe3o salvos aqui. Escolha uma op\xe7\xe3o para gerar imagens rapidamente utilizando os modelos salvos.",
    "BatchProcess_tutorial": "Tutorial",
    "Text_Model_Pricing": "Pre\xe7os de modelos",
    "Text_Pro_discount": "Plano Pro: gera\xe7\xe3o de v\xeddeos pela metade do pre\xe7o",
    "Dropdown_AddFromBrandkit": "Adicionar do Kit de marca",
    "Button_ExportFromBrandkit": "Importar do Kit de marca",
    "Text_TemplatePrompt": "Vamos come\xe7ar com inspira\xe7\xf5es",
    "Text_Hi": "Ol\xe1, ${0}!",
    "Text_Account_Popup_Left": "Conhe\xe7a seu assistente de design dedicado com IA para e-commerce. Desenvolvido para profissionais que buscam lan\xe7amentos mais r\xe1pidos, apresenta\xe7\xf5es mais s\xf3lidas e lucratividade mais alta.",
    "Tip_EstimatedTime": "Pronto em cerca de ${0} minutos",
    "Text_HandTool": "Ferramenta m\xe3o",
    "Text_Function": "Fun\xe7\xe3o",
    "Text_WindowsSystem": "Sistema Windows",
    "Text_MacSystem": "Sistema Mac",
    "Menu_KeyboardShortcuts": "Atalhos",
    "Title_KeyboardShortcuts": "Atalhos",
    "Text_Undo": "Desfazer",
    "Text_MouseLeft": "Bot\xe3o esquerdo do mouse",
    "Text_Redo": "Refazer",
    "Text_Delete": "Excluir",
    "Text_Cut": "Cortar",
    "Text_Copy": "Copiar",
    "Text_Paste": "Colar",
    "Text_PasteFixed": "Colar no lugar",
    "Text_CreateCopy": "Criar uma c\xf3pia",
    "Text_SelectAll": "Selecionar tudo",
    "Text_SelectMultiple": "Multissele\xe7\xe3o",
    "Text_Group": "Grupo",
    "Text_Ungroup": "Desagrupar",
    "Text_LockLayer": "Travar",
    "Text_Save": "Salvar",
    "Text_Move": "Mover",
    "Text_MoveWithCombinedKeys": "Movimento r\xe1pido",
    "Text_NewText": "Novo texto",
    "Text_NewLine": "Nova linha",
    "Text_NewRectangle": "Novo ret\xe2ngulo",
    "Text_NewCircle": "Novo c\xedrculo",
    "Text_ExitFullScreen": "Sair da tela inteira",
    "Text_MoveUpOneLayer": "Trazer para a frente",
    "Text_MoveDownOneLayer": "Enviar para tr\xe1s",
    "Text_Top": "Trazer para frente",
    "Text_Bottom": "Enviar para tr\xe1s",
    "Text_ToggleReferenceLine": "Mostrar/ocultar guias",
    "Text_ToggleRulerBar": "Mostrar/ocultar r\xe9guas",
    "Text_ArrowKey": "Teclas de seta",
    "Text_CanvasShowAll": "Mostrar todas as telas",
    "Title_Unsupported_Multilayer": "Esse recurso funciona com uma \xfanica camada apenas.",
    "Btn_CreateBatchProcessFormula": "Criar",
    "Button_Hide_Otherlayers": "Manter a primeira camada e continuar",
    "Button_Merge_Alllayers": "Mesclar todas as camadas e continuar",
    "Checkbox_Disable_Remind": "N\xe3o mostrar novamente",
    "Button_Tool": "Ferramentas",
    "Button_Custom_Ratio": "Personalizado",
    "Label_Spacing": "Espa\xe7amento",
    "Button_Download_Whole": "Exportar como imagem",
    "Button_Download_Layer": "Exportar por camada",
    "Button_Origin_Ratio": "Original",
    "Text_TouchEdit_Title": "Apontar para editar",
    "Text_TouchEdit_Description": "Aponte para um objeto e descrava suas altera\xe7\xf5es. A imagem ser\xe1 editada exatamente como voc\xea especificar. ",
    "Tooltip_TouchEdit_Max_Count": "Voc\xea pode apontar para at\xe9 ${0} \xe1reas",
    "Tooltip_TouchEdit_Usage": "Aponte para o atalho Editar: ${0} + clique",
    "Text_TouchEdit_Recognition_Custom": "Personalizado",
    "Text_TouchEdit_Recognition_Title1": "Detectar e reconhecer",
    "Text_TouchEdit_Recognition_Title2": " Nenhum destino encontrado. Insira o nome do objeto.",
    "Text_TouchEdit_Name": "Apontar para editar",
    "Btn_LoginToViewBatchProcess": "Entre para visualizar o kit de fluxo de trabalho",
    "Btn_Login": "Entrar",
    "Menu_Main_Beautify": "Refinar",
    "Text_PleaseWaitImageUploaded": "Continue ap\xf3s a conclus\xe3o do carregamento",
    "Menu_Redeem_Rights": "Resgatar",
    "Text_Redeem_Now": "Resgatar agora",
    "Text_Redeem_Placeholder": "Insira o c\xf3digo de resgate, diferenciando mai\xfasculas e min\xfasculas",
    "Text_Redeem_Success": "Resgate bem-sucedido.",
    "Text_Redeem_Use": "Resgatar seu c\xf3digo",
    "Tooltip_BrandAutoUse": "Seu novo kit de marca foi aplicado.",
    "Redeem_Redeem_Note": "Nota: \nFa\xe7a login e insira o c\xf3digo de resgate.\nAp\xf3s o resgate bem-sucedido, voc\xea poder\xe1 aproveitar os benef\xedcios e servi\xe7os correspondentes.\nUse o c\xf3digo-de resgate dentro de seu per\xedodo de validade. C\xf3digos expirados ser\xe3o invalidados e n\xe3o reembols\xe1veis.\nProteja seu c\xf3digo. N\xe3o somos respons\xe1veis pela perda, vazamento ou uso incorreto de c\xf3digos. \nEsse c\xf3digo n\xe3o pode ser vendido ou transferido, nem trocado por dinheiro em esp\xe9cie, e n\xe3o est\xe1 eleg\xedvel para faturamento.",
    "Sidebar_NewDesign": "Novo chat",
    "Text_Appeal_ReGenerate": "Resultados editados n\xe3o est\xe3o qualificados para revis\xe3o.",
    "Modal_Button_Known": "OK",
    "MenuItem_Appeal": "Revis\xe3o de resultado",
    "Text_Appeal_Left": "Tentativas restantes este m\xeas\n<i>${0}</i>/${1}",
    "Text_Appeal_Confirm": "Sim",
    "Text_Appeal_Refunded": "Os cr\xe9ditos foram reembolsados na sua conta.",
    "Modal_Button_GotIt": "Aceitar",
    "Modal_Button_Later": "Mais tarde",
    "Text_Vip_Open": "Assinar",
    "Menu_Title_Invite": "Indicar um amigo",
    "Text_Button_Invite": "Ganhar cr\xe9ditos",
    "Title_Dialog_Invite": "Indicar um amigo",
    "Desc_Dialog_Invite": "Compartilhe seu link com amigos nas redes sociais. Quando algu\xe9m se inscreve usando seu link, voc\xea e essa pessoa recebem ${0} cr\xe9ditos. Se ela assinar, voc\xea receber\xe1 at\xe9 ${1} cr\xe9ditos extras.  ",
    "Detail_Dialog_Invite": "Detalhes",
    "Text_Copy_Invite": "Copiar link",
    "Title_Rewards_Invite": "Recompensas",
    "SubTitle_Rewards1_Invite": "Total de cr\xe9ditos ganhos",
    "SubTitle_Rewards2_Invite": "Usu\xe1rios n\xe3o pagantes indicados",
    "SubTitle_Rewards3_Invite": "Usu\xe1rios pagantes indicados",
    "Success_Copy_Invite": "Link copiado",
    "Title1_Invited_Invite": "Voc\xea recebeu um convite!",
    "Text_Rule1_Invite": "Para cada pessoa que assinar usando seu link, voc\xea e essa pessoa ganham <strong>${0} cr\xe9ditos</strong>.",
    "Text_Rule2_Invite": "Se seu amigo assinar, cada um de voc\xeas receber\xe1 cr\xe9ditos extras (<strong>${0} para o plano Plus, ${1} para o Pro</strong>).",
    "Text_Rule3_Invite": "As assinaturas adquiridas n\xe3o poder\xe3o ser reembolsadas se o plano tiver sido usado ou se algum cr\xe9dito concedido tiver sido gasto. Al\xe9m disso, cr\xe9ditos gratuitos n\xe3o podem ser revogados depois de utilizados.",
    "Text_Rule4_Invite": "Cada usu\xe1rio pode convidar at\xe9 ${0} amigos.",
    "Text_Rule5_Invite": "Recompensas por indica\xe7\xf5es n\xe3o s\xe3o concedidas no caso de contas existentes, auto-indica\xe7\xf5es, contas duplicadas ou atividades fraudulentas.",
    "Text_Rule6_Invite": "${0} se reserva o direito de ajustar o programa e revogar recompensas de contas anormais.",
    "Text_Divider_Invite": "ou compartilhe o link",
    "Title2_Invited_Invite": "Participe de ${0} e reivindique suas recompensas",
    "SubTitle1_Invited_Invite": "Um amigo convidou voc\xea para experimentar nosso agente de IA profissional. Crie designs de marketing com alta qualidade para marcas, como logotipos, cartazes, card\xe1pios e materiais de m\xeddias sociais com facilidade ",
    "SubTitle2_Invited_Invite": "<strong>Cadastre-se agora</strong> e voc\xea e seu amigo <strong>receber\xe3o ${0} cr\xe9ditos</strong>. <strong>Se voc\xea assinar,</strong> cada um receber\xe1 cr\xe9ditos adicionais de acordo com o plano escolhido: <strong>${1} cr\xe9ditos com o Plus ou ${2} cr\xe9ditos com o Pro</strong>. Cadastre-se agora para resgatar suas recompensas.",
    "Button_Invited_Invite": "Inscreva-se para reivindicar suas recompensas",
    "Success_Invited_Invite": "Voc\xea entrou por meio de uma indica\xe7\xe3o e recebeu ${0} cr\xe9ditos.",
    "Error_Invited_Invite": "Voc\xea j\xe1 tem uma conta.",
    "Text_Share_Invite": "Tenho usado o ${0} para criar logotipos, visuais e v\xeddeos de modo realmente muito r\xe1pido. Inscreva-se com meu link e n\xf3s dois receberemos cr\xe9ditos de b\xf4nus.",
    "Title_Share_Invite": "Fa\xe7a parte de ${0} e ganhem cr\xe9ditos juntos!",
    "Share_Email_Invite": "E-mail",
    "Text_Rule7_Invite": "Voc\xea pode usar os cr\xe9ditos com o Agente de IA. Eles expiram depois de um m\xeas. ",
    "Text_AdvanceSetting": "Especialista",
    "Text_MainImage": "Imagem principal",
    "Text_ProductAgentUploadGuide1": "1. Carregue fotos de \xe2ngulos diferentes para que a IA possa reconhecer e restaurar com precis\xe3o os detalhes do produto.",
    "Text_ProductAgentUploadGuide2": "2. Voc\xea pode carregar at\xe9 10 fotos. A primeira ser\xe1 usada como a imagem principal. Recomendamos escolher uma foto que mostre claramente o produto completo.",
    "Text_Optional": " (Opcional)",
    "Tip_ClickDragImageWithSize": "Carregue ou solte imagens JPEG, JPG ou PNG de at\xe9 ${0} MB.",
    "Button_AddReferenceImage": "Carregar",
    "Title_ReferenceImage": "Imagem de refer\xeancia",
    "Input_Placeholder": "Selecione",
    "Radio_ReferenceColor": "Cor de refer\xeancia",
    "Radio_ReferenceLayout": "Layout de refer\xeancia",
    "Tag_FirstImage": "Primeira imagem",
    "Tag_FirstImageNoPartial": "Primeira imagem parcial",
    "Tag_Blur": "Desfoque",
    "Tag_Jigsaw": "Colagem",
    "Button_Understood": "Entendi",
    "Text_ReferenceImageIndex": "A imagem ${0} deve ser usada como refer\xeancia",
    "Text_ReferenceDimensions": "Usar ${0} da refer\xeancia",
    "Tag_Cropped": "Cortada",
    "Tag_Underexposed": "Subexposta",
    "Tag_Blurry": "Desfoque",
    "SelectOption_ColorPalette": "Paleta de cores",
    "SelectOption_Layout": "Layout",
    "SelectOption_Fonts": "Fontes",
    "SelectOption_Style": "Estilo",
    "SelectOption_ShapeElements": "Elementos de forma",
    "Text_SocialMediaAgentUploadGuide": "Carregue o produto em destaque primeiro. Verifique se a imagem est\xe1 n\xedtida e completa.",
    "Menu_Manage_Subscriptions": "Gerenciar assinaturas",
    "Menu_Text_Subscriptions": "Assinaturas",
    "Menu_View_Subscriptions": "Ver assinaturas",
    "Text_Download_XdesignApp": "Por favor, baixe o aplicativo <span>X-Design</span> para usar os recursos",
    "Text_Free_Trial": "Fa\xe7a o download para um teste gratuito de 7 dias",
    "Text_Install_App": "Instalar app",
    "Text_Scan_Download": "Escaneie para baixar",
    "Text_Download_the": "Baixar na",
    "Text_Available_On": "Dispon\xedvel em",
    "SecondTitle_Header6_Home": "Gerador de imagens de produtos com IA",
    "SecondTitle_Header7_Home": "Gerador de modelos de moda com IA",
    "SecondTitle_Header8_Home": "Modificador de cor de roupas",
    "SecondTitle_Header9_Home": "Gerador de v\xeddeos de produtos",
    "SecondTitle_Header10_Home": "Ferramentas de IA",
    "SecondTitle_Header11_Home": "Editor de fotos com IA",
    "SecondTitle_Header12_Home": "Editor de fotos com IA online",
    "SecondTitle_Header13_Home": "Editor de fotos em lote",
    "SecondTitle_Header14_Home": "Editor de fotos com IA em lote",
    "SecondTitle_Header15_Home": "Aprimorador de imagens em lote",
    "SecondTitle_Header16_Home": "Removedor de marcas d'\xe1gua em lote",
    "SecondTitle_Header17_Home": "Gerador de fundos em lote",
    "SecondTitle_Header18_Home": "Removedor de fundo de imagens em lote",
    "Title_Footer3_Home": "Ferramentas de design",
    "Subtitle_Footer8_Home": "Editor de imagens com IA",
    "Subtitle_Footer7_Home": "Alterador de fundo com IA",
    "Subtitle_Footer9_Home": "Fundo transparente",
    "Subtitle_Footer10_Home": "Alterar a cor do fundo",
    "Subtitle_Footer11_Home": "Removedor de marcas d'\xe1gua em imagens",
    "Subtitle_Footer12_Home": "Remover texto da imagem",
    "Subtitle_Footer13_Home": "Adicione adesivos \xe0s fotos",
    "Subtitle_Footer14_Home": "Adicionar marca d'\xe1gua \xe0s fotos",
    "Title_Footer4_Home": "Modelos de imagem",
    "Subtitle_Footer15_Home": "Nano Banana Pro (Gemini 3.0 Pro)",
    "Title_Footer5_Home": "Baixe gratuitamente",
    "Subtitle_Footer16_Home": "APP iOS",
    "Subtitle_Footer17_Home": "APP Android",
    "Title_Footer6_Home": "Siga-nos",
    "Subtitle_Footer18_Home": "Kling 3.0",
    "Subtitle_Footer19_Home": "Seedance 2.0",
    "Title_Footer7_Home": "Modelos de v\xeddeo",
    "Video_SR_Success": "Nitidez de v\xeddeo aprimorada",
    "Video_Desubtitle_Success": "Legenda removida",
    "Video_Dewatermark_Success": "Marca d'\xe1gua removida",
    "Video_Process_Failed": "Falha no processamento. Os cr\xe9ditos ser\xe3o reembolsados na sua conta.",
    "Video_SR": "Nitidez com IA",
    "Video_Dewatermark": "Remover a marca d'\xe1gua",
    "Video_Desubtitle": "Remover legenda",
    "Text_TouchEditFastMode": "Edi\xe7\xe3o r\xe1pida",
    "Text_Pan": "Texto panor\xe2mico",
    "Title_Canvas": "Tela",
    "Title_Edit": "Editar",
    "Title_Elements": "Elementos",
    "Title_Tools": "Ferramentas",
    "Text_CanvasZoom": "Aumentar/Diminuir",
    "Tooltip_Color_Fill": "Cor",
    "Tootip_StartPoint": "Iniciar",
    "Tootip_ChangePoint": "Mudar",
    "Tootip_EndPoint": "Fim",
    "Retouch_Filter_Clear": "Limpar",
    "Retouch_Filter_Enhance": "V\xedvido",
    "Retouch_Filter_Dehaze": "Desemba\xe7ar",
    "Retouch_Filter_Texture": "Textura",
    "Retouch_Filter_Nature": "Natural",
    "Retouch_Filter_Fade": "Desvanecer",
    "Tooltip_Downloading": "Baixando...",
    "Tooltip_Download_Video": "Baixe os v\xeddeos separadamente, um de cada vez.",
    "Tooltip_Download_NoneSelected": "Por favor, selecione o conte\xfado que deseja baixar",
    "Text_AI_Thinking": "A IA est\xe1 trabalhando nisso.",
    "Text_Server_Busy": "O servidor est\xe1 ocupado. Por favor, tente novamente mais tarde.",
    "Text_Prompt_Help_Placeholder": "Digite suas palavras-chave e eu as transformarei em um prompt pronto para uso.",
    "Text_Prompt_Helping": "Processando... Por favor, aguarde.",
    "Button_Retry": "Tentar de novo",
    "Button_Rewrite": "Tente novamente",
    "Button_Start_Prompt_Help": "Comece a escrever",
    "Title_Prompt_Helper": "Reda\xe7\xe3o com IA",
    "Desc_ExpireDate": "Expira em:",
    "DownloadApp_Title_Widgets": "Para usar os recursos, baixe o aplicativo ${0}",
    "DownloadApp_SubTitle_Widgets": "Baixe para uma avalia\xe7\xe3o gratuita de ${0} dias",
    "InstallApp_Title_Widgets": "Instalar app",
    "InstallApp_Desc_Widgets": "Escaneie para baixar",
    "AppStore_Desc_Widgets": "Baixar na",
    "GooglePlay_Desc_Widgets": "Dispon\xedvel em",
    "Video_Task_Price_Estimate": "${0} cr\xe9ditos necess\xe1rios",
    "Video_SR_Start": "Aprimorando a nitidez... Ser\xe3o usados ${0} cr\xe9ditos.",
    "Video_Dewatermark_Start": "Removendo marcas d'\xe1gua... Ser\xe3o usados ${0} cr\xe9ditos.",
    "Video_Desubtitle_Start": "Removendo legendas... Ser\xe3o usados ${0} cr\xe9ditos.",
    "Text_Help_Center": "Centro de ajuda"
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/figma/zh-Hans.js
/* harmony default export */ const zh_Hans = ({
    "Tab_Design": "设计",
    "Button_Send": "发送",
    "Input_Describe_Workspace": "输入一句话AI帮你做图",
    "Tab_AgentCase": "Agent 案例",
    "Tab_RecentCreations": "最近打开",
    "Tag_Hot": "热门",
    "Tag_BrandDesign": "品牌设计",
    "Tag_Logo": "Logo",
    "Tag_Posters": "海报设计",
    "Tab_Agent": "Agent",
    "Tool_AiPhotoEditor": "图片编辑",
    "Button_Upload": "上传",
    "Tool_Designer": "创建设计",
    "Title_AiTool": "AI工具",
    "Tool_ImageBackgroundRemover": "智能抠图",
    "Tool_AiBackgroundGenerator": "AI背景生成",
    "Tool_ImageEnhancer": "变清晰",
    "Tool_AiObjectsRemover": "AI消除",
    "Tool_AiModelMannequin": "AI模特",
    "Tool_AiModelFlatlay": "AI试衣",
    "Tool_AiImageRecolor": "服装换色",
    "Tool_AiImageExtender": "AI扩图",
    "Tool_ImageUpscaler": "无损改尺寸",
    "Tool_AiLogo": "AI Logo",
    "Button_BlankCanvas": "创建画布",
    "Sidebar_Create": "主页",
    "Sidebar_Tools": "AI工具箱",
    "Sidebar_Batch": "批处理",
    "Sidebar_MyDesigns": "我的设计",
    "Sidebar_Inspire": "灵感广场",
    "Sidebar_Brand": "品牌库",
    "Sidebar_PackUp": "收起菜单",
    "Tag_All": "全部",
    "Tag_Design": "设计",
    "Sidebar_Unfold": "展开菜单",
    "Menu_Edit": "编辑",
    "Menu_Download": "下载",
    "Menu_Delete": "删除",
    "Tab_RecentlyCreated": "最近创作",
    "Tab_GenerateRecords": "生成记录",
    "Menu_Total": "合计",
    "Menu_Total_Explain_AgentCredits": "仅可在AI Agent中使用，优先消耗",
    "Menu_DueToday": "今日到期",
    "Menu_DueToday_Explain": "每日会自动更新",
    "Menu_Else_AgentCredits": "其他Credits",
    "Button_GoPro_GetMore": "获得更多Credits",
    "Menu_Total_Explain_PaidCredits": "会员阶段可以在所有功能里使用",
    "Menu_Pro": "会员Credits",
    "Menu_Pro_Explain": "会员专属赠送，会员有效期内可用",
    "Menu_Else": "其他Credits",
    "Menu_Else_Explain_PaidCredits": "其他来源的credit，会员有效期内可用",
    "Menu_Else_Explain_AgentCredits": "其他渠道获得，有效期更长",
    "Menu_UsageDetail": "使用详情",
    "Menu_Total_Explain_SuspendCredits": "已暂停使用重新激活会员后可使用",
    "Tab_Invite": "邀请",
    "Menu_InviteReward": "邀请好友奖励",
    "Tab_Reward": "奖励",
    "Title_AgentCreditForRewards": "奖励的Agent credit：",
    "Table_Time": "时间",
    "Table_Invitee": "被邀请者",
    "Title_ShareWithFriends": "分享给您的朋友",
    "Title_ShareWithFriends_ExplainOne": '<span style="color:#616266;">每邀请1位新朋友，您和朋友都可以获得</span><span style="color:#2D990C;">${0} 个Agent credits</span>',
    "Title_InvitationLink": "用此链接邀请",
    "Button_Copy": "复制",
    "Title_Tips": "Tips:",
    "Title_Tips_ExplainOne": "1.Agent Credits 只能在 AI Agent中使用.邀请奖励的Agent credit有效期为两年.",
    "Title_Tips_ExplainTwo": "2.新朋友需要注册成功后会放发奖励，如有问题，请联系支持团队.",
    "Title_GetRewarded": "获得邀请奖励",
    "Title_GetRewarded_Explain": "仅在Ai agent里使用,有效期为两年",
    "Button_Ok": "好的",
    "Title_FailedToReceiveReward": "获得奖励失败",
    "Title_FailedToReceiveReward_Explain": "如有问题，请联系支持团队",
    "Input_Describe_workspace": "输入一句话AI帮你做图",
    "Tool_AiBackgroundGenrator": "AI背景生成",
    "Title_YouCannotUseYourOwnLink": "不能使用自己的邀请链接",
    "Table_AgentCredit": "Agent Credits",
    "Title_ShareWithFriends_ExplainTwo": '<span style="color:#616266;">您最多可邀请</span><span style="color:#2D990C;">${0}个新朋友 </span><span style="color:#616266;">，即最高可获得${1}个Agent credits</span>',
    "Button_Invite": "邀请",
    "Menu_Title_Invite": "Refer a Friend",
    "Text_Button_Invite": "Earn Credits",
    "Title_Dialog_Invite": "Refer a Friend",
    "Desc_Dialog_Invite": "Share your link with friends or on social media. When a friend signs up via your link, both you and your friend will receive ${0} credits. If they subscribe, you will each receive up to ${1} extra credits.  ",
    "Detail_Dialog_Invite": "Details",
    "Text_Copy_Invite": "Copy link",
    "Title_Rewards_Invite": "Rewards",
    "SubTitle_Rewards1_Invite": "Total earned credits",
    "SubTitle_Rewards2_Invite": "Referred free users",
    "SubTitle_Rewards3_Invite": "Referred paid users",
    "Success_Copy_Invite": "Link copied",
    "Title1_Invited_Invite": "You've been invited!",
    "Text_Rule1_Invite": "For every friend who signs up using your link, you both earn <strong>${0} credits</strong>.",
    "Text_Rule2_Invite": "If your friend subscribes, you each get extra credits (<strong>${0} for Plus, ${1} for Pro</strong>).",
    "Text_Rule3_Invite": "Purchased subscriptions cannot be refunded if the plan has been used or any granted credits have been spent. Also, free credits cannot be revoked once used.",
    "Text_Rule4_Invite": "Each user can invite up to ${0} friends.",
    "Text_Rule5_Invite": "Rewards are not granted for referrals with existing accounts, self-referrals, duplicate accounts, or fraudulent activity.",
    "Text_Rule6_Invite": "${0} reserves the right to adjust the program and revoke rewards from abnormal accounts.",
    "Text_Divider_Invite": "or share the link",
    "Title2_Invited_Invite": "Join ${0} and claim your rewards",
    "SubTitle1_Invited_Invite": "A friend invited you to try our professional brand Al agent. Create high-quality brand marketing designs such as logos, posters, menus, and social media assets with ease. ",
    "SubTitle2_Invited_Invite": "<strong>Sign up now</strong> and both you and your friend will <strong>receive ${0} credits</strong>.<strong> If you subscribe,</strong> you will each receive additional credits based on the plan you choose (<strong>${1} credits with Plus or ${2} credits with Pro</strong>). Sign up now to claim your rewards.",
    "Button_Invited_Invite": "Sign up to claim your rewards",
    "Success_Invited_Invite": "You joined via a referral and received ${0} credits.",
    "Error_Invited_Invite": "You already have an account.",
    "Text_Share_Invite": "I’ve been using ${0} to create logos, visuals, and videos really fast. Sign up with my link and we’ll both get bonus credits.",
    "Title_Share_Invite": "Join ${0} and earn credits together!",
    "Share_Email_Invite": "Email",
    "Text_Rule7_Invite": "You can use the credits for AI Agent. Credits expire after one month. ",
    "Title_AgentCredits": "+50 Agent credits",
    "Input_Models": "模型",
    "Button_TryItNow": "做同款",
    "\xa0Tab_RecentCreations_Agent": "agent",
    "\xa0Tab_RecentCreations_Design": "智能工具",
    "Account_Pricing": "会员套餐和价格",
    "Account_Language": "语言",
    "Account_Language_English": "英文",
    "Account_Language_Chinese": "中文",
    "Tips_Adding": "添加中...",
    "Tips_Loading": "加载中...",
    "Tips_Creating": "正在创建中...",
    "Tips_Downloading": "正在下载中...",
    "Tips_Sending": "正在发送中...",
    "Tips_AddSuccess": "添加成功",
    "Tips_MakeSameError": "系统不支持，无法做同款",
    "Tips_UnsupportedGradientColor": "不支持渐变色",
    "Tips_CanNotAdding": "无法添加",
    "Tips_Uninitialized": "未初始化，无法发送",
    "Tips_UploadFailed": "上传失败，请重试",
    "Tips_UploadMaxCountLimit": "最多允许上传 ${n} 个${type}文件",
    "Tips_UploadMaxFileSize": "无法上传 ${file}，最大允许上传 ${n}MB 的文件",
    "Tips_UploadImageAndVideoLimit": "仅支持单张图片和视频混合上传哦～",
    "Tips_UnsupportedSvgFile": "不支持 SVG 文件",
    "Tips_UnsupportedUploadFileFormats:": "不支持上传的文件格式 ${files}",
    "Tips_CanNotAddSameFileTips": "已有相同文件存在，无法添加",
    "Tips_TextMinLengthTips": "至少需要输入 ${n} 个字符",
    "Tips_TextMaxLengthTips": "最多允许输入 ${n} 个字符，其中中文和 Emoji 算 2 个字符",
    "Tips_AccessDenied": "没有权限访问",
    "Tips_CreateFailed": "对话创建失败",
    "Tips_Error": "出错啦！",
    "Tips_NotFound": "对话不存在",
    "Tips_RequestAgentModelListError": "Agent 模型列表获取失败",
    "Desc_Ended": "结束",
    "Button_PeopleUse_Agent": "${n} 人使用",
    "Dropdown_AddToChat": "添加到聊天",
    "Dropdown_AddToBrandKit": "添加到品牌",
    "Dropdown_SaveToBrandKit": "保存为品牌 logo",
    "Dropdown_SaveToBrandTemplate": "保存为品牌模板",
    "Title_Design_Agent": "设计",
    "Title_MainColor": "主色",
    "Title_SecondaryColor": "辅助色",
    "Bitton_ViewTheBrandKit": "点击查看品牌资产库",
    "Dropdown_InportImages": "导入图片",
    "Title_Upgrade_Pro": "升级计划",
    "Desc_SubscribeToUnlock_Pro": "现在订阅解锁更多",
    "Desc_RunOutOfFreeUses_Pro": "对不起，您已经没有免费的使用了",
    "Desc_RunOutOfUsesForToday_Pro": "今天没有剩余的免费使用了，请明天再来",
    "Desc_PurchaseCompleted_Pro": "购买成功",
    "Desc_ContinueDesign_Pro": "准备就绪了，尽情使用吧",
    "Button_UnlockNow": "立即解锁",
    "Tips_Copied": "Copied!",
    "Tips_Credit_Explain_Paid": "什么是付费积分",
    "Title_Total_InactiveCredits": "合计 - 冻结积分",
    "Title_Total_PaidCredits": "合计 - 付费积分",
    "Menu_SuspendCredits": "冻结积分",
    "Menu_Credits": "积分",
    "Tab_RecentCreations_Agent": "agent",
    "Tab_RecentCreations_Design": "智能工具",
    "Menu_FunctionalPricing": "Agent功能定价",
    "Title_Total_AgentCredits": "合计 - Agent积分",
    "Tips_Credit_Explain_Agent": "什么是agent积分",
    "Title_FeaturePricing": "Agent功能定价",
    "Tab_Category": "大类",
    "Tab_TaskType": "任务类型",
    "Tab_Consume": "消耗美豆",
    "Tab_ExampleContent": "内容举例",
    "Tips_CreditExplain_Inactive": "什么是冻结积分",
    "langding_more_bg_remover": "Background Remover",
    "langding_more_enhancer": "Image Enhancer",
    "langding_more_objects_remover": "AI Object Remover",
    "langding_more_bg_generator": "Ai Background Generator",
    "Title_More1_Home": "变清晰",
    "Title_More2_Home": "智能消除",
    "Title_More3_Home": "AI商品图",
    "Title_More4_Home": "智能抠图",
    "Title_More5_Home": "批量编辑器",
    "Title_Home": "你的<span>电商</span>设计AI助手",
    "Placeholder_Input_Home": "描述下你的想法，我会来帮你创作…",
    "Title_Card4_Home": "一句话生成亚马逊套图",
    "Title_Card1_Home": "服装首饰试穿套图生成",
    "Title_Card3_Home": "商品详情图生成",
    "Title_Card2_Home": "智能换背景",
    "Desc_Features1_Home": "AI自动提炼品类特征与风格偏好，构思最合适的设计方案。",
    "Desc_Features2_Home": "只需输入一句话，AI自动生成整套电商图片，从主图、副图到详情页一次搞定。",
    "Text_Btn_Home": "免费开始",
    "Desc_Features3_Home": "自动匹配 Amazon、Etsy、TEMU、eBay 等平台规范与流量偏好，生成符合各平台标准的专属视觉套组。",
    "Desc_Features4_Home": "输入一句话即可可智能转换语言、模特、色调与文化视觉，自动生成多国家本地化版本。",
    "Desc_Features5_Home": "作图流程可一键保存为配方并复用，AI自动批量生成所有SKU图片。",
    "Desc_Features6_Home": "无论是10款还是1000款商品，都能一键完成整套视觉。",
    "Title_Qualification_Home": "超500万电商卖家都在用",
    "Text_Btn_Qualification_Home": "查看资质",
    "Title_Carousel_Home": "更多AI工具",
    "Title_Footer_Home": "你的电商设计助手",
    "Title_Footer1_Home": "官方社媒",
    "Subtitle_Footer1_Home": "YouTube",
    "Subtitle_Footer2_Home": "X",
    "Subtitle_Footer3_Home": "Instagram",
    "Subtitle_Footer4_Home": "TikTok",
    "Title_Footer2_Home": "支持与服务",
    "Subtitle_Footer5_Home": "服务条款",
    "Subtitle_Footer6_Home": "隐私政策",
    "Copyright_Footer_Home": "版权 ${0} 美图（中国）有限公司",
    "Desc_Evaluation1_Home": "我真的很喜欢 Designkit！AI 生成的生活方式图片看起来很自然——温馨、北欧风，非常适合我的香薰蜡烛店。我店铺的商品图变得更专业了，销售额也有所提升。总之物超所值。",
    "Job_Evaluation5_Home": "TEMU 墨西哥卖家",
    "Job_Evaluation6_Home": "亚马逊运营",
    "Job_Evaluation12_Home": "Amazon 印尼多 SKU 店铺店长",
    "Job_Evaluation2_Home": "亚马逊 & Mercado Libre 店主",
    "Name_Evaluation12_Home": "Arif",
    "Desc_Evaluation11_Home": "生成的生活方式场景图挺自然，看起来像拍出来的一样，客户也比较喜欢，转化率有提升。",
    "Name_Evaluation11_Home": "Siti",
    "Job_Evaluation10_Home": "Lazada & Shopee 印尼跨境店主",
    "Name_Evaluation10_Home": "Nina",
    "Job_Evaluation3_Home": "独立站 设计师",
    "Job_Evaluation8_Home": "Walmart 美国户外店主",
    "Name_Evaluation8_Home": "Jason",
    "Job_Evaluation9_Home": "Mercado Libre 阿根廷卖家",
    "Desc_Evaluation7_Home": "生成的宠物用品场景挺可爱的，猫狗比例自然，不会怪怪的。而且尺寸比例基本符合 ML 平台的要求，用起来挺方便的。",
    "Job_Evaluation7_Home": "Mercado Livre 巴西店铺老板",
    "Desc_Evaluation8_Home": "我卖帐篷，用它生成的露营场景挺真实，光线和角度都挺自然，比例也没问题。总体来说，比自己拍摄省了不少时间。",
    "Name_Evaluation7_Home": "Thiago",
    "Desc_Evaluation9_Home": "这个工具用起来挺快的，生成的图基本可以直接上传到美客多和亚马逊，不用再调来调去。",
    "Desc_Evaluation6_Home": "我以前最担心 AI 会改掉衣服材质，但它几乎完全保持了原样。针织是针织，牛仔是牛仔，也符合亚马逊主图规范，新品上架效率提升了不少。",
    "Name_Evaluation9_Home": "Lucas",
    "Name_Evaluation6_Home": "Emma",
    "Desc_Evaluation5_Home": "AI 做的产品图挺准的，数据线的长度、接口形状都保持得很好，还能适配 TEMU 的风格，整体上比自己拍图省事很多。",
    "Desc_Evaluation12_Home": "只需要一句话就能生成可用素材，比以前等设计师出图快太多了，挺省心的。",
    "Name_Evaluation3_Home": "Chloe",
    "Name_Evaluation1_Home": "Sofia",
    "Desc_Evaluation4_Home": "金属材质和结构细节都很清楚，整体感觉挺专业的，生成的图直接能用。",
    "Name_Evaluation4_Home": "Leon",
    "Desc_Evaluation10_Home": "批量生成很方便，几十个 SKU 一次性搞定，比以前自己做快多了。",
    "Name_Evaluation2_Home": "Mariana",
    "Desc_Evaluation3_Home": "我是卖服装的，原本担心 AI 会把颜色或布料质感弄得不真实，但结果非常出乎意料！模特姿势很自然，基本上出图就能立即上架使用了。",
    "Job_Evaluation1_Home": "SHEIN 店铺运营",
    "Name_Evaluation5_Home": "Diego",
    "Job_Evaluation11_Home": "亚马逊运营专员",
    "Desc_Evaluation2_Home": "这个工具非常快速，生成的图片几乎可以直接上传到 Mercado Libre 或 Amazon。它甚至会根据当地喜好调整背景和模特，效果非常专业。",
    "Job_Evaluation4_Home": "eBay 德国卖家",
    "Title_Evaluation_Home": "来自我们Designkit社区的故事",
    "Title_Introduction_Home": "更高效、更专业的AI设计工具，助力你成为电商大卖",
    "Desc_Qualification_Home": "亚马逊SPN认证服务商",
    "Title_Seo_Home": "适用于电商的AI产品图像和视频生成器",
    "Desc_Seo_Home": "使用 Designkit 的 AI 智能助手，即可立即为亚马逊、TikTok 等在线商店生成产品图片、海报和视频。立即开始免费设计！<br>",
    "Keywords_Seo_Home": "电商AI代理、电商AI工具、AI产品图片生成器、AI产品视频生成器、AI产品照片编辑器、AI背景去除",
    "Title_Features1_Home": "一句话即可做一整套电商物料图",
    "Title_Features2_Home": "一句话卖全球，多平台多国家全自动本地化",
    "Title_Features3_Home": "多SKU也可批量自动划出图，上新变得更高效",
    "Title_Designkit_Home": "Designkit",
    "Tips_AboveTheFold2_Home": "向下滚动探索",
    "Tips_Material1_Home": "电商套图",
    "Tips_Material2_Home": "服饰穿戴",
    "Tips_Material3_Home": "A+ 详情页",
    "Tips_Material4_Home": "商品换背景",
    "Free_Button_Home": "免费试用",
    "Title_Header1_Home": "功能",
    "Title_Header2_Home": "解决方案",
    "Title_Header3_Home": "灵感",
    "Title_Header4_Home": "学习",
    "Title_Header5_Home": "价格",
    "SecondTitle_Header1_Home": "AI电商设计Agent",
    "SecondTitle_Header2_Home": "AI图片工具",
    "SecondTitle_Header3_Home": "AI视频工具",
    "SecondTitle_Header4_Home": "Amazon Design Solution",
    "SecondTitle_Header5_Home": "Social Media E-Commerce Solution",
    "SecondTitle_Header6_Home": "AI Product Image Generator",
    "SecondTitle_Header7_Home": "AI Fashion Model Generator",
    "SecondTitle_Header8_Home": "Clothes Color Changer",
    "SecondTitle_Header9_Home": "Product Video Generator",
    "SecondTitle_Header10_Home": "AI Tools",
    "SecondTitle_Header11_Home": "AI Photo Editor",
    "SecondTitle_Header12_Home": "AI Photo Editor Online",
    "SecondTitle_Header13_Home": "Bulk Photo Editor",
    "SecondTitle_Header14_Home": "Bulk AI Photo Editor",
    "SecondTitle_Header15_Home": "Bulk Image Enhancer",
    "SecondTitle_Header16_Home": "Bulk Watermark Remover",
    "SecondTitle_Header17_Home": "Bulk Background Generator",
    "SecondTitle_Header18_Home": "Bulk Image Background Remover",
    "Title_Footer3_Home": "Design Tools",
    "Subtitle_Footer8_Home": "AI Image Editor",
    "Subtitle_Footer7_Home": "AI Background Changer",
    "Subtitle_Footer9_Home": "Transparent Background",
    "Subtitle_Footer10_Home": "Change Background Color",
    "Subtitle_Footer11_Home": "Image Watermark Remover",
    "Subtitle_Footer12_Home": "Remove Text from Image",
    "Subtitle_Footer13_Home": "Add Stickers to Photos",
    "Subtitle_Footer14_Home": "Add Watermark to Photos",
    "Title_Footer4_Home": "Image Models",
    "Subtitle_Footer15_Home": "Nano Banana Pro (Gemini 3.0 Pro)",
    "Title_Footer5_Home": "Download for Free",
    "Subtitle_Footer16_Home": "iOS APP",
    "Subtitle_Footer17_Home": "Android APP",
    "Title_Footer6_Home": "Follow Us",
    "Subtitle_Footer18_Home": "Kling 3.0",
    "Subtitle_Footer19_Home": "Seedance 2.0",
    "Title_Footer7_Home": "Video Models",
    "Button_Export": "下载",
    "Title_Layer": "图层",
    "InputNumber_Opacity": "不透明度",
    "Buttom_Comfirm": "确定",
    "Button_Share": "分享",
    "Button_Delete": "删除",
    "Title_LoginPopup": " Log in to unlock your free trial",
    "SubTitle_LoginPopup": "Start creating with X-Design today",
    "Tip_ModalTitle": "提示",
    "TipContent_HistoryDelete": "删除后，该记录将不可恢复，确认删除吗？",
    "Title_Logo": "Logo",
    "Title_BrandKit": "品牌模板",
    "Tab_BrandKit": "品牌资产",
    "Tab_UploadLocal": "本地上传",
    "Button_UploadImage": "上传图片",
    "Tip_ClickDragParseImage": "点击/拖拽/粘贴图片至此处",
    "Tip_UploadMax": "支持上传${0}M以内JPG、JPEG、PNG，最多支持N张",
    "Tooltip_SwitchBrandKit": "切换品牌库",
    "Discribe_BrandKitSelect": "选择对应品牌后，本次会话将参考其品牌规范进行设计～",
    "Title_Models": "Models",
    "Switch_Auto": "Auto",
    "Tab_Image": "Image",
    "Tab_Video": "Video",
    "MenuItem_AddToBrandLogo": "添加为品牌Logo",
    "MenuItem_AddToBrandTemplate": "添加为品牌模板",
    "Button_ExportImage": "导入图片",
    "Button_ExportMedia": "导入视频",
    "Button_ExportFromBrandkit": "从资产库中导入",
    "Dropdown_AddFromBrandkit": "从资产库中添加",
    "Placeholder_ChatInput": "和我一起玩图吧～",
    "MenuItem_AiChange": "AI改图",
    "MenuItem_AiExpend": "AI扩图",
    "MenuItem_AiHD": "AI超清",
    "MenuItem_Eliminate": "AI无痕消除",
    "MenuItem_SplitLayers": "拆分图层",
    "MenuItem_Cutout": "抠图",
    "MenuItem_ChangeText": "无痕改字",
    "MenuItem_Crop": "调整尺寸",
    "MenuItem_AddToChat": "添加到聊天",
    "MenuItem_AddToBrand": "添加到品牌库",
    "Tooltip_Layer": "图层",
    "Tooltip_Grab": "抓手",
    "Tooltip_Select": "选择",
    "Tooltip_Redo": "重做",
    "Tooltip_Undo": "撤销",
    "Tooltip_Add": "添加",
    "Tooltip_ShowAll": "显示全部",
    "Tip_UploadType": "文件格式不支持",
    "Tip_UploadSize": "仅支持${0}MB以内的文件",
    "Tip_UploadWH": "仅支持宽高均为${0} * ${1}以内的图片",
    "Tip_UploadTypeTranslate": "文件格式转换错误",
    "Tip_UploadFail": "文件上传失败",
    "Tooltip_AddText": "添加文本",
    "Text_AddDefault": "我是一段文本",
    "Tooltip_OverflowImageSize": "请将图片缩放到${0}px以内",
    "Placeholder_ImageFusion": "将融图灵感发送给我，我来帮你执行",
    "Button_ImageFusion": "融图",
    "Button_Cancel": "取消",
    "Button_AiChange": "改图",
    "Placeholder_AiChange": "将改图灵感发送给我，我来帮你执行",
    "Button_Eliminate": "消除",
    "Label_OriginSize": "原图尺寸",
    "Label_CropRadio": "裁剪比例",
    "Button_Free": "自由",
    "Button_Origin": "原始",
    "Button_Crop": "裁剪",
    "Placeholder_ChangeText": "输入你想修改成的目标文案，如：你好",
    "Button_ChangeText": "改字",
    "InputNumber_PanSize": "笔刷大小",
    "Label_TargetSize": "目标尺寸",
    "Tooltip_ImageFusion": "支持${0}-${1}张图的快速融合",
    "Title_Workspace": "Your Creative AI Agent for Branding.",
    "Button_Pro": "免费体验Pro版本",
    "Title_NanoPro": "\uD83C\uDF4C\uD83C\uDF4CNano Banana Pro is now available on X-Design.",
    "Dropdown_AdvancedFeatures_Title": "Advanced Features",
    "Dropdown_AdvancedFeatures_Conent": "Full access to all AI-powered tools to enhance your efficiency.",
    "Dropdown_MassiveContent_Title": "Extensive Content",
    "Dropdown_MassiveContent_Content": "Unlimited access to premium templates and a vast array of Plus stock assets.",
    "Dropdown_CommercialRights_Title": "Commercial Rights",
    "Dropdown_CommercialRights_Content": "Use your personal creations with confidence, backed by guaranteed copyright protection.",
    "Popup_SubscribeIntl_Desc": "Get the most from X-Design with Pro",
    "Popup_SubscribeIntl_Desc1": "Unlock more creations with credits",
    "Popup_SubscribeIntl_Detail": "View plan details & Help",
    "Popup_StripeCheckout": "Stripe checkout",
    "Popup_LiveSupport": "Live support",
    "Popup_CancelAnytime": "Cancel anytime",
    "Menu_Language": "Language",
    "Menu_ManageSubscription": "Manage Subscriptions",
    "Menu_TermsPolices": "Terms and Policies",
    "Menu_ManageSubscriptions": "订阅管理",
    "Menu_ReferralLink": "Referral Link",
    "Menu_BenefitsUpgraded": "Benefits",
    "Menu_TermsPolicies": "Terms and Policies",
    "Menu_AccountManagement": "账号管理",
    "Title_ReferralCode": "Referral Code",
    "Title_ReferralLink": "Referral Link",
    "Desc_NoActiveSubscription": "暂无有效订阅",
    "Button_ClickToSubscibe": "点击订阅",
    "Title_SubscriptionCancel": "您的订阅已取消",
    "Title_SeeYou": "对于您的取消深表遗憾\uD83D\uDE2D",
    "Desc_NextBillingDate": "下一次续费将会在",
    "Desc_EstimatedAmount": "预计扣费金额",
    "Button_CancelSubscription": "取消订阅",
    "Button_StaySubscribed": "继续订阅",
    "Title_ReasonCancelling": "请选择取消订阅的原因：",
    "Desc_BenefitsContinue": "您可以继续享受会员权益",
    "Desc_GiftedCredits": "订阅到期后，赠送的积分",
    "Desc_SeeYou": "感谢你一直以来的支持，我们很遗憾看到你离开。",
    "Desc_NoNoreCharges": "你将不会再次被扣费，你的会员权益将继续有效，直至",
    "Desc_MayBeRevoked": "将会被收回。",
    "Desc_CancelingNoRefund": "Cancellation does <span>not include a refund<span>. For refund inquiries, please contact online support.",
    "Button_ClearSelection": "清除选区",
    "Button_Confirm": "确认",
    "Message_Processing": "处理中...",
    "Title_Opacity": "透明度",
    "Button_ExpandImage": "扩图",
    "Button_ExpandRadio": "扩图比例",
    "Title_NoDesigns": "No designs yet",
    "Title_NoGenerations": "No generations yet",
    "Desc_NoDesigns": "Your designs will show up here.",
    "Desc_NoGenerations": "Your generations will show up here.",
    "Title_DeleteDesign": "Delete this design",
    "Popup_DeleteDesign": "Are you sure you want to delete this design permanently? This action can't be undone.",
    "Message_SaveFail": "保存失败",
    "Title_Pricing": "选择适合您的方案",
    "Title_Tags1_Pricing": "按月",
    "Text_Discount_Pricing": "${0}折",
    "Title_Tags2_Pricing": "按年",
    "Title_Plan1_Pricing": "免费",
    "Current_Plan_Pricing": "当前计划",
    "Title_Instruction1_Pricing": "首次登录赠送20积分",
    "Title_Instruction2_Pricing": "使用AI Agent最多生成20张",
    "Title_Instruction3_Pricing": "使用AI商品图最多生成10张",
    "Title_Rights1_Pricing": "限次体验智能抠图",
    "Title_Rights3_Pricing": "限次体验变清晰（高清）",
    "Title_Plan2_Pricing": "基础会员",
    "Month_Plan_Pricing": "月",
    "Title_Button1_Pricing": "立即开通",
    "Title_Instruction4_Pricing": "500积分/月",
    "Title_Instruction5_Pricing": "使用AI Agent最多生成 500 张",
    "Title_Instruction6_Pricing": "AI商品图：最多250张/月",
    "Title_Plan3_Pricing": "高级会员",
    "Desc_Plan_Pricing": "7天免费试用，到期后${0}/年续费",
    "Title_Button2_Pricing": "7天免费试用",
    "Title_Instruction7_Pricing": "1500积分/月",
    "Title_Instruction8_Pricing": "使用AI Agent最多生成 1500 张",
    "Title_Instruction9_Pricing": "AI商品图：最多750张/月",
    "Title_Rights4_Pricing": "无限次使用智能抠图",
    "Title_Rights5_Pricing": "无限次使用AI消除",
    "Title_Rights6_Pricing": "无限次使用变清晰（超清）",
    "Title_Rights7_Pricing": "批量编辑器",
    "Title_Best_Pricing": "90%的人选择",
    "Title_AllFeatures_Pricing": "对比所有方案",
    "Desc_AllFeatures_Pricing": "使用基础会员/高级会员中的先进 AI 工具，轻松创作惊艳设计",
    "Month_AllFeatures_Pricing": "月",
    "Title_Features1_Pricing": "AI Agent",
    "SubTitle_Features1_Pricing": "图片编辑",
    "SubTitle_Features15_Pricing": "最多生成 ${0} 张",
    "SubTitle_Features16_Pricing": "最多生成 ${0} 张/月",
    "SubTitle_Features2_Pricing": "图片生成",
    "SubTitle_Features3_Pricing": "电商套图生成",
    "SubTitle_Features4_Pricing": "海报生成",
    "Title_Features2_Pricing": "AI 图像处理",
    "SubTitle_Features5_Pricing": "智能抠图",
    "SubTitle_Features17_Pricing": "有限次",
    "SubTitle_Features19_Pricing": "无限次",
    "SubTitle_Features6_Pricing": "AI 消除",
    "SubTitle_Features7_Pricing": "变清晰",
    "SubTitle_Features18_Pricing": "有限次（高清）",
    "SubTitle_Features20_Pricing": "无限次（高清/超清）",
    "SubTitle_Features8_Pricing": "无损改尺寸",
    "SubTitle_Features9_Pricing": "AI 扩图",
    "SubTitle_Features10_Pricing": "AI 商品图",
    "Title_Features3_Pricing": "更多设计功能",
    "SubTitle_Features11_Pricing": "高级功能与模板",
    "SubTitle_Features12_Pricing": "去水印下载",
    "SubTitle_Features13_Pricing": "批量编辑器",
    "SubTitle_Features14_Pricing": "基础编辑功能",
    "Title_Credits_Pricing": "\xa0\xa0积分快用完了？ 我们帮你搞定",
    "Desc_Credits_Pricing": "按需购买，一次性付费，无需订阅！",
    "TransactionPrice_Credits_Pricing": "价格： ${0}",
    "Credit_Credits_Pricing": "积分",
    "Popular_Credits_Pricing": "最受欢迎",
    "Buy_Credits_Pricing": "立即购买",
    "Title_FAQ_Pricing": "常见问题",
    "Title_Button4_Pricing": "7天免费试用/立即升级",
    "Title_Button3_Pricing   ": "已解锁权益",
    "SubTitle_FAQ1_Pricing": "什么是积分?",
    "Content_FAQ1_Pricing": "积分可用于使用AI工具，不同AI工具需要消耗对应的积分",
    "Content_FAQ2_Pricing": "单独购买的积分有效期为1年。",
    "Content_FAQ3_Pricing": "购买会员赠送的积分当月有效。",
    "SubTitle_FAQ2_Pricing": "如何取消订阅?取消后我的积分会怎样",
    "Content_FAQ4_Pricing": "如果您取消订阅:",
    "Content_FAQ5_Pricing": "-会员到期后您的积分也会随之到期，单独购买的积分不受影响。",
    "Content_FAQ6_Pricing": "如需取消订阅，请至少在下一个账单周期开始前24 小时按照以下步骤操作:",
    "Content_FAQ7_Pricing": "- 打开Designkit并登录。",
    "Content_FAQ8_Pricing": "- 打开会员订阅弹窗。",
    "Content_FAQ9_Pricing": "- 选择[管理订阅]。",
    "Content_FAQ10_Pricing": "- 选择您的订阅选项，然后点击【取消订阅】。",
    "Content_FAQ11_Pricing": "您的订阅将持续有效至当前计费周期结束。如果您无法取消订阅，请截图并尽快联系我们的在线客服。",
    "SubTitle_FAQ3_Pricing": "你们的退款政策是什么？",
    "Content_FAQ12_Pricing": "1. 7天退款保证:",
    "SubTitle_FAQ4_Pricing": "如何升级或降级我的订阅？",
    "Content_FAQ25_Pricing": "1. 升级:你可以直接订阅更高档位的会员套餐。新的套餐立即扣费和生效，旧的套餐将按比例退款并解约;",
    "SubTitle_FAQ5_Pricing": "我可以要一份发票副本吗？",
    "Content_FAQ27_Pricing": "是的!付款成功后，您将收到支付服务提供商发送的包含电子发票的电子邮件。如果您没有收到发票，请联系我们的客服团队。",
    "SubTitle_FAQ6_Pricing": "你们支持那些支付方式？",
    "Content_FAQ28_Pricing": "我们使用 Stripe 管理支付和订阅。我们接受所有主流信用卡、PayPal 和 Google Pay。",
    "SubTitle_FAQ7_Pricing": "我该如何联系客服?",
    "Content_FAQ29_Pricing": "请发送邮件至support@designkit.com，回复时间:3-10个工作日",
    "Content_FAQ13_Pricing": "- 如果您购买了会员套餐但7天内未使用，您可能有资格获得全额退款。",
    "Content_FAQ14_Pricing": "- 如果您购买了积分，您可以在7天内申请退还任何未使用的积分。",
    "Content_FAQ15_Pricing": "2. 对服务不满意:",
    "Content_FAQ16_Pricing": "- 如果您对结果不满意，请邮箱联系我们的线客服团队。我们将根据具体情况提供补偿或退款。",
    "Content_FAQ17_Pricing": "3. 通过 Google Play 或 App Store 购买:",
    "Content_FAQ18_Pricing": "- 如果您是通过 Google Play 商店或 App Store 订阅的，则需要直接向 Google 或 Apple 申请退款。",
    "Content_FAQ19_Pricing": "重要提示:",
    "Content_FAQ20_Pricing": "本退款政策不适用于API用户。如果您使用我们的API，请联系我们了解退款资格。",
    "Content_FAQ21_Pricing": "对干滥用、误用或违反我们条款的情况，我们保留拒绝退款的权利。",
    "Content_FAQ22_Pricing": "退款可能需要几个工作日才能处理完毕，具体取决于您的付款方式。",
    "Content_FAQ23_Pricing": "我们可能会不时更新此退款政策。请定期查看以了解任何变更。",
    "Content_FAQ24_Pricing": "如需进一步帮助，请联系我们的支持团队。",
    "Content_FAQ26_Pricing": "2. 降级:您需要先取消当前的订阅，等账单周期结束后在订阅新的套餐。",
    "Content_Modal_Pricing": "Thank you for your support! Get ready to take your creativity to the next level.",
    "Tip_Modal_Pricing": "Tips: If your membership isn't showing up yet, please refresh the page.",
    "Title_Modal_Pricing": "Successfully purchased",
    "Title_Rights2_Pricing": "限时体验AI消除",
    "Title_Button3_Pricing": "已解锁权益",
    "Title_Button5_Pricing": "立即升级",
    "Tool_ImageBgRemover": "Image Background Remover",
    "Tool_AiBgGenerator": "Al Background Generator",
    "Tool_AiLogoGenerator": "AI LOGO Generator",
    "Tool_FootwearModel": "Footwear Model",
    "Tool_ImageTranslation": "Image Translation",
    "Tool_BatchImageBgRemover": "Batch Image Background Remover",
    "Tool_BatchImageEnhancer": "Batch Image Enhancer",
    "Tool_BatchAiObjectsRemover": "Batch Al Object Remover",
    "Tool_VideoEnhancer": "Video Enhancer",
    "Tool_VideoBgRemover": "Video Background Remover",
    "Tool_VideoWatermarkRemover": "Video Watermark Remover",
    "Title_Models_Dropdown": "Models",
    "Tips_Uninitialized_Chat": "Failed to send messages",
    "Tips_Uninitialized_chat": "Failed to send messages",
    "Dropdown_AddImage": "Add image",
    "Action_SeeAll": "See all",
    "Desc_Seedream": "Realistic and detailed image creation.",
    "Dropdown_AddVideo": "Add video",
    "Tips_NotFound_Chat": "Chat does not exist",
    "Desc_Seedance": "Realistic and expressive video creation.",
    "Dropdown_SupportedFormatFile": "Supports Word, Excel, Text and PDF files.",
    "Dropdown_Example_Option": "Example",
    "Dropdown_NoReference_Option": "No reference available",
    "Menu_AgentCredits": "Agent Credits",
    "Desc_SeedEdit": "Precise and natural image editing.",
    "Dropdown_BrandKit_Title": "Brand Kit",
    "Desc_GeminiNanoBanana": "Fast, editable, and consistent image generation.",
    "Dropdown_Models_Title": "Models",
    "Dropdown_AddDocument": "Add document",
    "Dropdown_BrandKit_Desc": "Select a brand style as the reference for this design.",
    "Desc_MidjourneyVideo": "Creative and artistic video generation.",
    "Desc_MidjourneyImage": "Artistic and imaginative image generation.",
    "Dropdown_SaveAsBrandTemplate": "Save as brand template",
    "Dropdown_SaveAsBrandLogo": "Save as brand logo",
    "BatchProcessTable_ImageType": "图片类型",
    "BatchProcessTable_PictureRequirement": "画面需求",
    "BatchProcessTable_CopywritingRequirements": "文案需求",
    "BatchProcessTable_Proportion": "画图比例",
    "BatchProcessTable_Actions": "操作",
    "BatchProcessTable_AddOneRow": "新增一行",
    "BatchProcessList_DeleteError": "删除失败",
    "BatchProcessList_SurePrompt": "确认删除这个工作流吗？",
    "BatchProcessList_SurePrompt_SureText": "确认",
    "BatchProcessList_SurePrompt_CancelText": "取消",
    "BatchProcessList_EmptyText": "空",
    "EditBatchProcess_NameLimitTip": "请输入10字内的名称",
    "EditBatchProcess_Tip": "修改下方表格内容，将影响工作流生成图片的结果",
    "EditBatchProcess_Start": "从工作流开始",
    "EditBatchProcess_GenerateTip": "上传商品图，将批量生成每个商品的工作流图片",
    "Text_AdvanceSetting": "专家设置",
    "Text_MainImage": "主图",
    "Text_ProductAgentUploadGuide1": "1. 可上传同一商品的多视角原图，帮助 AI 更准确还原商品细节。",
    "Text_ProductAgentUploadGuide2": "2. 最多支持 10 张图片，第一张将作为主图重点参考，建议选择角度最全的一张。",
    "Text_Optional": " (可选）",
    "Tip_ClickDragImageWithSize": "拖拽或点击上传JPEG/JPG/PNG，${0}M以内",
    "Button_AddReferenceImage": "上传参考图",
    "Title_ReferenceImage": "参考图",
    "Input_Placeholder": "请选择",
    "Radio_ReferenceColor": "参考配色",
    "Radio_ReferenceLayout": "参考布局",
    "Tag_FirstImage": "首张",
    "Tag_FirstImageNoPartial": "首张非局部",
    "Tag_Blur": "模糊",
    "Tag_Jigsaw": "拼图",
    "Button_Understood": "知道了",
    "Text_ReferenceImageIndex": "第${0}张图为参考图",
    "Text_ReferenceDimensions": "参考的维度是${0}",
    "Tag_Cropped": "Cropped",
    "Tag_Underexposed": "Underexposed",
    "Tag_Blurry": "Blurry",
    "SelectOption_ColorPalette": "Color Palette",
    "SelectOption_Layout": "Layout",
    "SelectOption_Fonts": "Fonts",
    "SelectOption_Style": "Style",
    "SelectOption_ShapeElements": "Shape Elements",
    "Text_SocialMediaAgentUploadGuide": "Upload your featured product first. Ensure the picture is clear and complete.",
    "Video_SR_Success": "视频AI超清成功",
    "Video_Desubtitle_Success": "视频去字幕成功",
    "Video_Dewatermark_Success": "视频去水印成功",
    "Video_Process_Failed": "处理失败，请重试！消耗的积分将会原路退回。",
    "Video_SR": "AI超清",
    "Video_Dewatermark": "去水印",
    "Video_Desubtitle": "去字幕",
    "Video_Task_Price_Estimate": "预计消耗${0}",
    "Video_SR_Start": "开始AI超清，消耗${0}美豆",
    "Video_Dewatermark_Start": "开始去水印，消耗${0}美豆",
    "Video_Desubtitle_Start": "开始去字幕，消耗${0}美豆",
    "Text_Help_Center": "帮助中心",
    "Title_Request": "询问",
    "Button_Continue": "继续",
    "Button_EditContent": "编辑内容",
    "Title_ChooseImageType": "请选择您希望生成的图片类型（可多选）:",
    "Button_BatchGenerate": "已确认，开始执行电商套图批跑流程",
    "Text_ChatCancelStatus": "任务中止",
    "Text_ChatRespondedStatus": "任务执行",
    "BatchProcess_SaveSuccessTip": "套图配方已保存至此处\n可一键复用",
    "Button_GotIt": "Got it",
    "Title_Congrats": "Congrats",
    "SubTitle_BrandCreate": "You've built your first brand kit—time to explore its potential",
    "Button_CheckUse": "Check it out now",
    "Chat_Prompt_Brand": "Create a promo poster",
    "Tooltip_UseBrand": "You can switch or add your brand kit here!",
    "Tooltip_PosterBrand": "Tap to create your first poster based on your brand kit",
    "Popup_CreateBrand": "Create a brand from scratch",
    "Desc_CreateBrand": "Create stunning, original logos with our AI Agent.",
    "Popup_UploadBrand": "Upload your brand information",
    "Desc_UploadBrand": "Upload it and X-Design will keep every design aligned.",
    "Title_BrandEntry": "Get a tailored brand system now",
    "Desc_BrandEntry": "Let our Al be your stylist. Answer a few questions and receive a complete brand system tailored to your vision.",
    "Tooltip_UseBrand_Agent": "Once the brand kit is applied, the design will automatically reference the logo, color palette, and overall style.",
    "Tooltip_PosterBrand_Agent": "You're all set to design with your brand kit",
    "BatchProcess_createText": "套图配方",
    "Label_NormalMode": "普通模式：",
    "Label_AdvancedMode": "高级模式：",
    "Text_NormalMode": "普通模式",
    "Text_AdvancedMode": "高级模式",
    "BatchProcess_DefaultPrompt": "帮我生成套图",
    "Title_CreateBrand": "Don't have a brand?",
    "Title_UploadBrand": "Already have a logo?",
    "Button_CreateBrand": "Create a brand",
    "BatchProcess_EditContent": "编辑内容",
    "BatchProcess_PleaseSelect": "请选择套图配方",
    "BatchProcess_SelectTip": "选择后将按照选择的套图配方，对所有上传图片进行批量生成～",
    "BatchProcess_ListEmptyTip": "生成套图后可保存配方，一键批量生成同类套图",
    "BatchProcess_Tip": "套图配方",
    "BatchProcess_Generate": "前往生成套图",
    "BatchProcess_Save": "保存",
    "BatchProcess_GeneratingFormula": "正在生成套图配方",
    "BatchProcess_GenerateCancel": "取消",
    "BatchProcess_WorkFlowCreateError": "创建失败",
    "ProductInfo_PleaseUploadImage": "请上传商品图片",
    "BatchProcess_IntelligenceGenerate": "智能生成套图配方表格",
    "BatchProcess_CreateWorkflow": "创建工作流",
    "BatchProcess_Formula": "套图配方",
    "BatchProcess_WorkFlowSaveSuccess": "套图配方已保存成功",
    "ProductInfo_ImageSizeLimit": "图片最大仅支持${0}M~",
    "ProductInfo_ImageUpload": "上传商品图",
    "ProductInfo_UploadDemo": "商品案例上传参考：",
    "ProductInfo_ECPlatform": "电商平台",
    "ProductInfo_PleaseSelect": "请选择",
    "ProductInfo_InputCustomize": "自定义",
    "ProductInfo_CountryAndLanguage": "销售国家/语言",
    "ProductInfo_Name": "商品名称",
    "ProductInfo_Desc": "商品详情（卖点/尺寸/场景）",
    "ProductInfo_DescPlaceholder": "可输入商品相关详细信息，如商品卖点、尺寸规格、期望场景、适用人群等",
    "ProductInfo_NamePrompt": "商品名称是${0}，",
    "ProductInfo_ECPlatformPrompt": "电商平台是${0}，",
    "ProductInfo_CountryAndLanguagePrompt": "国家语言是${0}，",
    "ProductInfo_DescPrompt": "商品详情是${0}，",
    "ProductInfo_PleaseInput": "请输入",
    "Button_UnlockPro": "解锁Pro版本",
    "Button_UpgradeToPro": "升级到Pro版本",
    "Button_RenewNow": "立即续费",
    "AgentEmpty_CaseUseBtn": "使用",
    "AgentEmpty_CaseRefreshBtn": "换一批",
    "MenuItem_Effect": "特效",
    "MenuItem_Shadow": "阴影",
    "MenuItem_Stroke": "描边",
    "Title_ChangeText": "无痕改字",
    "Button_Logout": "退出登录",
    "Message_ExtractText": "提取文字中",
    "Message_ExtractTextError": "文字提取失败，请重试",
    "Tip_CreditConsume": "本次生成将消耗${0}美豆",
    "Tip_EstimatedTime": "预计等待${0}分钟",
    "BatchProcess_SaveSuccessTip_GotIt": "知道了",
    "BatchProcess_SaveSuccessTip_Title": "套图配方指引",
    "BatchProcess_SaveSuccessTip_Desc": "点击这里查看你保存的套图配方，一键复用可生成相似套图",
    "BatchProcess_tutorial": "使用教程",
    "Text_HandTool": "抓手",
    "Text_Function": "功能",
    "Text_WindowsSystem": "Windows系统",
    "Text_MacSystem": "Mac系统",
    "Menu_KeyboardShortcuts": "快捷键",
    "Title_KeyboardShortcuts": "快捷键",
    "Text_Undo": "撤销",
    "Text_MouseLeft": "鼠标左键",
    "Text_Redo": "重做",
    "Text_Delete": "删除",
    "Text_Cut": "剪切",
    "Text_Copy": "复制",
    "Text_Paste": "粘贴",
    "Text_PasteFixed": "固定位置粘贴",
    "Text_CreateCopy": "创建副本",
    "Text_SelectAll": "全选",
    "Text_SelectMultiple": "多选",
    "Text_Group": "成组",
    "Text_Ungroup": "解组",
    "Text_LockLayer": "锁定图层",
    "Text_Save": "保存",
    "Text_Move": "移动",
    "Text_MoveWithCombinedKeys": "快速移动",
    "Text_TouchEditFastMode": "快速标注改图",
    "Text_Pan": "平移",
    "Title_Canvas": "画布",
    "Title_Edit": "编辑",
    "Title_Elements": "元素",
    "Title_Tools": "工具",
    "Text_NewText": "新建文字",
    "Text_NewLine": "新增直线",
    "Text_NewRectangle": "新建矩形",
    "Text_NewCircle": "新建圆形",
    "Text_ExitFullScreen": "退出全屏",
    "Text_MoveUpOneLayer": "上移一层",
    "Text_MoveDownOneLayer": "下移一层",
    "Text_Top": "置顶",
    "Text_Bottom": "置底",
    "Text_CanvasZoom": "画布缩放",
    "Text_ToggleReferenceLine": "显示/隐藏参考线",
    "Text_ToggleRulerBar": "显示/隐藏标尺",
    "Text_ArrowKey": "方向键",
    "Text_CanvasShowAll": "显示画布全部内容",
    "Title_Unsupported_Multilayer": "该功能暂不支持多图层进入操作～",
    "Btn_CreateBatchProcessFormula": "创建配方",
    "Button_Hide_Otherlayers": "隐藏其他图层仅画布原图进入",
    "Button_Merge_Alllayers": "合并所有图层进入",
    "Checkbox_Disable_Remind": "不再提示",
    "Button_Tool": "工具",
    "Button_Custom_Ratio": "自定比例",
    "Label_Spacing": "间距",
    "Button_Download_Whole": "整图下载",
    "Button_Download_Layer": "分层下载",
    "Button_Origin_Ratio": "原比例",
    "Text_TouchEdit_Title": "使用“标注改图”功能",
    "Text_TouchEdit_Description": "精确指出想要修改的地方，让改图精确又便捷 ",
    "Tooltip_TouchEdit_Max_Count": "最多只能添加${0}个标注",
    "Tooltip_TouchEdit_Usage": "${0} + 点击，快捷标注改图",
    "Text_TouchEdit_Recognition_Custom": "自定义",
    "Text_TouchEdit_Recognition_Title1": "标注识别",
    "Text_TouchEdit_Recognition_Title2": "未识别到物品，请填写",
    "Text_TouchEdit_Name": "标注改图",
    "Btn_LoginToViewBatchProcess": "请登录后查看套图配方",
    "Btn_Login": "立即登录",
    "Menu_Main_Beautify": "美化",
    "Text_Model_Pricing": "模型定价",
    "Text_Pro_discount": "Pro Plan 视频生成半价",
    "Text_TemplatePrompt": "Let’s start with inspirations",
    "Text_Hi": "Hi, ${0}!",
    "Text_Account_Popup_Left": "您值得信赖的电商设计助手 —— 让每一次产品发布都更快、更完美、更盈利。",
    "Text_PleaseWaitImageUploaded": "请等待图片上传完成",
    "Menu_Redeem_Rights": "兑换权益",
    "Text_Redeem_Now": "立即兑换",
    "Text_Redeem_Placeholder": "请输入兑换码，区分大小写",
    "Text_Redeem_Success": "兑换成功！",
    "Text_Redeem_Use": "使用兑换码",
    "Tooltip_BrandAutoUse": "Your new brand kit is applied!",
    "Redeem_Redeem_Note": "兑换须知：\n登录用户账号后，输入兑换码即可完成兑换\n兑换成功后，即可享受对应的权益和服务\n请在兑换码有效期内使用，过期作废，不可退款\n请妥善保管，遗失、泄露、登错账号等不补\n此卡严谨倒卖、转让，不可兑换现金，不支持开发票",
    "Tooltip_Color_Fill": "颜色填充",
    "Tootip_StartPoint": "起始端点",
    "Tootip_ChangePoint": "交换端点",
    "Tootip_EndPoint": "结束端点",
    "Sidebar_NewDesign": "New chat",
    "Retouch_Filter_Clear": "清透",
    "Retouch_Filter_Enhance": "增色",
    "Retouch_Filter_Dehaze": "去雾",
    "Retouch_Filter_Texture": "质感",
    "Retouch_Filter_Nature": "自然",
    "Retouch_Filter_Fade": "褪色",
    "Modal_Button_Known": "我知道了",
    "Modal_Button_GotIt": "收下",
    "Modal_Button_Later": "再想想",
    "Text_Appeal_Confirm": "确认申诉",
    "Text_Vip_Open": "开通会员",
    "Text_Appeal_ReGenerate": "当前生成结果已二次编辑，不支持效果申诉",
    "Text_Appeal_Left": "本月剩余次数\n<i>${0}</i>/${1}次",
    "Text_Appeal_Refunded": "美豆已退回至您的美豆账号，请查收。",
    "MenuItem_Appeal": "效果申诉",
    "Tooltip_Downloading": "正在下载中...",
    "Tooltip_Download_Video": "视频仅支持单个下载",
    "Tooltip_Download_NoneSelected": "请先选中想下载的内容",
    "Text_AI_Thinking": "AI 深度思考中...",
    "Text_Server_Busy": "服务器繁忙，请稍后再试",
    "Text_Prompt_Help_Placeholder": "请输入一些关键词，我会帮您扩写成完整的商业提示词",
    "Text_Prompt_Helping": "正在帮写，请稍等...",
    "Button_Retry": "重试",
    "Button_Rewrite": "重写",
    "Button_Start_Prompt_Help": "开始智能优化",
    "Title_Prompt_Helper": "AI 帮写",
    "Menu_Text_Subscriptions": "订阅",
    "Menu_View_Subscriptions": "查看订阅",
    "Text_Download_XdesignApp": "Please download the <span>X-Design</span> app to use features",
    "Text_Free_Trial": "Download for a 7-day Free Trial",
    "Text_Install_App": "Install App",
    "Text_Scan_Download": "Scan to download",
    "Text_Download_the": "Download on the",
    "Text_Available_On": "Available on",
    "Desc_ExpireDate": "到期时间",
    "DownloadApp_Title_Widgets": "Please download the ${0} app to use features",
    "DownloadApp_SubTitle_Widgets": "Download for a ${0}-day Free Trial",
    "InstallApp_Title_Widgets": "Install App",
    "InstallApp_Desc_Widgets": "Scan to download",
    "AppStore_Desc_Widgets": "Download on the",
    "GooglePlay_Desc_Widgets": "Available on"
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/projectA/de.js
/* harmony default export */ const projectA_de = ({
    "brandSDK": {
        "bgInput": {
            "placeholder": "Beschreiben Sie Ihr Markenkonzept, Ihre Branche und Ihre Stilvorlieben."
        },
        "brandCard": {
            "nameLimitTip": "Geben Sie einen Namen ein (maximal 10 Zeichen)"
        },
        "delBrandSureModal": {
            "okText": "Best\xe4tigen",
            "cancelText": "Abbrechen",
            "title": "Dieses Marken-Kit l\xf6schen?",
            "message": "Bereits angewendete Designs sind davon nicht betroffen."
        },
        "brandList": {
            "createBrandText": "Hinzuf\xfcgen",
            "emptyText": "Leer"
        },
        "logoCard": {
            "coverCornerText1": "Cover",
            "coverCornerText2": "Hauptlogo",
            "delSureModal": {
                "okText": "Best\xe4tigen",
                "cancelText": "Abbrechen",
                "title": "Dieses Logo l\xf6schen?"
            },
            "nameLimitTip": "Geben Sie einen Namen ein (maximal ${0} Zeichen)",
            "replaceText": "Ersetzen"
        },
        "colorList": {
            "countLimitTip": "F\xfcgen Sie jeder Farbpalette bis zu ${0} Farben hinzu"
        },
        "colorCard": {
            "colorCountLimitTip": "F\xfcgen Sie jeder Farbpalette bis zu ${0} Farben hinzu",
            "nameLimitTip": "Geben Sie einen Namen ein (maximal ${0} Zeichen)",
            "nameInputPlaceholder": "Geben Sie einen Namen ein (maximal ${0} Zeichen)",
            "colorEmptyText": "Leer"
        },
        "page": {
            "brandStandards": "Marken-Kit",
            "createStandard": "Hinzuf\xfcgen",
            "createBrand": "Marken-Kit"
        },
        "editBrand": {
            "sections": {
                "logo": "Logos",
                "colorCard": "Farbsysteme",
                "textStyle": "Textstile",
                "template": "Vorlagen",
                "primaryColor": "Hauptfarbe",
                "secondaryColor": "Zweitfarbe"
            },
            "brandBackground": "Markenbeschreibung",
            "nameLimitTip": "Geben Sie einen Namen ein (maximal 10 Zeichen)",
            "saveLastStyle": "\xc4nderungen speichern, um fortzufahren",
            "saveLastColorCard": "\xc4nderungen speichern, um fortzufahren",
            "saveLastElement": "\xc4nderungen speichern, um fortzufahren",
            "addColorCard": "Neu hinzuf\xfcgen",
            "addStyle": "Neu hinzuf\xfcgen",
            "addPrimaryColor": "Hauptfarbe hinzuf\xfcgen",
            "addSecondaryColor": "Zweitfarbe hinzuf\xfcgen",
            "bgInput": {
                "openBtnText": "Erweitern",
                "foldBtnText": "Minimieren",
                "title": "Stilvorgabe"
            },
            "addPrimaryLogo": "Hauptlogo hinzuf\xfcgen"
        },
        "textCard": {
            "nameLimitTip": "Geben Sie einen Namen ein (maximal ${0} Zeichen)",
            "selectFont": "W\xe4hlen Sie eine Schriftart",
            "selectFontSize": "Schriftgr\xf6\xdfe ausw\xe4hlen",
            "fontSizePlaceholder": "Gr\xf6\xdfe",
            "save": "Speichern",
            "bold": "Fett",
            "standard": "Standard",
            "italic": "Kursiv",
            "defaultCategoryName": "Allgemein"
        },
        "templateCard": {
            "delSureModal": {
                "title": "Diese Vorlage l\xf6schen?",
                "okText": "Best\xe4tigen",
                "cancelText": "Abbrechen"
            },
            "nameLimitTip": "Geben Sie einen Namen ein (maximal ${0} Zeichen)",
            "defaultName": "Vorlagen"
        },
        "selectBrandElementModal": {
            "brandAssets": "Marken-Kit",
            "localUpload": "Von Ger\xe4t hochladen",
            "brandLogo": "Logos",
            "brandTemplate": "Vorlagen",
            "uploadImage": "Hochladen",
            "uploadDragTips": "Bilder hier hochladen oder ablegen",
            "uploadTips": "Laden Sie bis zu ${1} JPG- oder PNG-Bilder hoch (maximal ${0} MB pro Bild)"
        },
        "tooltip": {
            "message": "Die Funktion „Markenposter“ ist nun verf\xfcgbar.",
            "desc": "Laden Sie Ihre Markenposter hoch und lassen Sie den KI-Agenten sie begutachten. Er wird Ihre Stimmung erfassen und zuk\xfcnftige Grafiken erstellen, die zu Ihrem Markenstil passen."
        }
    },
    "satisfaction": {
        "effectSatisfaction": "Zufriedenheit",
        "noWarn": "Nicht mehr anzeigen",
        "dissatisfied": "Unzufrieden",
        "normal": "Neutral",
        "satisfied": "Zufrieden",
        "placeholder": "Geben Sie Ihr Feedback ein (maximal 200 Zeichen)",
        "submitBtn": "Senden"
    },
    "userInfo": {
        "notVipTip": "Das X-Design Pro-Abonnement gew\xe4hrt Zugriff auf umfangreiche urheberrechtlich gesch\xfctzte Elemente und Funktionen.",
        "notLoginText": "Sie sind noch kein Mitglied",
        "businessText": "Online-Beratung",
        "feedbackText": "Feedback",
        "downloadText": "App herunterladen",
        "settingText": "Einstellungen",
        "loginText": "Anmelden",
        "copyText": "Kopie",
        "svipExpires": "Ablaufdatum von X-Design Pro: ${0}",
        "renewalText": "Verl\xe4ngern",
        "openText": "Abonnieren",
        "tips": "W\xe4hrend Ihrer Mitgliedschaft genie\xdfen Sie sorgenfreie kommerzielle Nutzung urheberrechtlich gesch\xfctzter Werke.",
        "logoutText": "Abmelden",
        "lightText": "Hell",
        "dartText": "Dunkel",
        "teamExpires": "Die Teammitgliedschaft endet am: ${0}",
        "teamNotVipTitle": "Teammitgliedschaft abonnieren",
        "teamNotVipTip": "Profitieren Sie von exklusiven Mitgliedervorteilen und Teamzusammenarbeit",
        "teamExpiresDays": "Ihre Teammitgliedschaft ist vor ${0} Tagen abgelaufen.",
        "copySuccess": "Kopiert!",
        "notVipTipTitle": "Werden Sie Mitglied, um auf alle Designressourcen und -tools zugreifen zu k\xf6nnen",
        "notVipTipSubscript": "Kommerzielle Rechte abgedeckt",
        "teamVersion": "Team",
        "personalVersion": "Pers\xf6nlich",
        "vipExpiresDays": "Ihr Abonnement ist vor ${0} Tagen abgelaufen",
        "countAmount": "Ausschnittmenge",
        "meidouAmount": "Credits",
        "owner": "Super-Administrator",
        "admin": "Administrator",
        "vipValidUntil": "L\xe4uft ab am: ${0}",
        "teamNotVipTip2": "Erleben Sie die Vorteile und exklusiven Funktionen von SVIP",
        "enterpriseVersion": "Unternehmen",
        "freeTeamVersion": "Gratis",
        "initialFreeDesc": "Werden Sie Mitglied, um auf alle Designressourcen und -tools zugreifen zu k\xf6nnen",
        "initialFreeTeamDesc": "Abonnieren Sie, um Teamressourcen und -tools zu teilen",
        "languageSwitch": "Sprache",
        "pro": "Pro",
        "renewOn": "Erneuern am",
        "tryProForFree": "Pro kostenlos testen",
        "expiresOn": "L\xe4uft ab am",
        "upgradeToPro": "Auf Profi-Version aktualisieren",
        "credit": "Credit",
        "manageSubscriptions": "Abonnements verwalten",
        "termsAndPolicies": "Bedingungen und Richtlinien",
        "benefitsUpgraded": "Vorteile aktualisiert",
        "deductionTipsIntl": "Es m\xfcssen ${0} Credits verbraucht werden",
        "deductionTips2Intl": "F\xfcr diese Generation werden ${0} Credits abgezogen. M\xf6chten Sie fortfahren?",
        "autoDeductCredits": "Credits automatisch abziehen",
        "generate": "Erstellen",
        "close": "Schlie\xdfen",
        "basic": "Einfach"
    },
    "utils": {
        "requestErrorText": "Netzwerkfehler. Verbindung zum Server nicht m\xf6glich."
    },
    "upload": {
        "errorText": "Hochladen fehlgeschlagen",
        "cancelText": "Abbrechen",
        "uploadingText": "Wird hochgeladen...",
        "fileText": "Datei",
        "picText": "Bilder",
        "blockText": "Hochladen abgebrochen",
        "cancelUploadText": "Hochladen abbrechen",
        "maxLengthTips": "Sie k\xf6nnen bis zu 20 Bilder gleichzeitig hochladen",
        "formatFailTips": "Das Hochladen von ${0} Bildern ist fehlgeschlagen. Derzeit werden nur Bilder in den Formaten ${1} unterst\xfctzt.",
        "formatFailTips1": "Derzeit werden nur Bilder im ${0}-Format unterst\xfctzt.",
        "formatFailTips2": "Das Hochladen von ${0} Bildern ist fehlgeschlagen. Derzeit werden nur Bilder in den Formaten JPG, JPEG und PNG unterst\xfctzt.",
        "sizeFailTips": "Das Hochladen von ${0} Bildern ist fehlgeschlagen. Bitte stellen Sie sicher, dass jedes Bild kleiner als 20 MB und nicht gr\xf6\xdfer als 8000 \xd7 8000 Pixel ist.",
        "sizeFailTips1": "Bitte stellen Sie sicher, dass jedes Bild weniger als 20 MB gro\xdf ist und eine Aufl\xf6sung von maximal 8000 \xd7 8000 Pixel aufweist.",
        "widthHeightFailTips": "Only supports images within 8000px(H&W)",
        "sizeFailTips2": "Only supports images up to ${0} MB"
    },
    "meidouInfo": {
        "emptyText": "Aufladen",
        "buyText": "Purchase credits plan",
        "openText": "Abonnieren",
        "rechargeText": "Aufladen",
        "remainingText": "Meine Credits",
        "tips1": "Priorisieren Sie auslaufende Guthaben f\xfcr den Verbrauch.",
        "tips2": "Ihre erworbenen Credits verfallen niemals.",
        "tips3": "Einschlie\xdflich ${0} dauerhaft g\xfcltiger bezahlter Guthaben.",
        "tips4": "Bei jeder Erzeugung werden Credits automatisch abgezogen.",
        "detailText": "Details",
        "whatIsMeidou": "Was sind Credits?",
        "giftTips": "40 Credits wurden Ihrem Konto gutgeschrieben!",
        "giftTips1": "L\xe4uft am Ende des heutigen Tages aus. Nicht vergessen, sie zu verwenden!",
        "genText": "Erstellen",
        "deductionTips": "F\xfcr diese Generation werden ${0} Credits abgezogen. M\xf6chten Sie fortfahren?",
        "genBtnText": "Erstellen",
        "inadequateTips": "Nicht gen\xfcgend Guthaben. Bitte laden Sie zun\xe4chst mindestens ${0} Credits auf.",
        "tryTimes": "Testzeiten ${0} /${1}",
        "meidouCountModalTitle": "Verbleibende Credits",
        "meidouCountModalTips": "Ablaufende Credits werden zuerst verbraucht.",
        "meidouCountModalTips1": "\xdcber Credits",
        "meidouCountModalEmpty": "Keine Credits erforderlich. Jetzt erwerben!",
        "meidouCountModalBtn": "OK",
        "meidouCountModalPermanent": "Dauerhaft g\xfcltig",
        "meidouCountModalExpired": "Ablaufdatum: ${0} Tag(e)",
        "creditTransactionDetails": "Credit-\xdcbersicht",
        "deductionTipsIntl": "Es m\xfcssen ${0} Credits verbraucht werden",
        "deductionTips2Intl": "F\xfcr diese Generation werden ${0} Credits abgezogen. M\xf6chten Sie fortfahren?",
        "autoDeductCredits": "Credits automatisch abziehen",
        "generate": "Erstellen",
        "close": "Schlie\xdfen",
        "creditsBalance": "Credits Balance",
        "whatAreCredits": "Was sind Credits?",
        "usageDetail": "Details zur Nutzung",
        "getMoreCredits": "Mehr Credits"
    },
    "floatHelp": {
        "modalTitle": "Meitu-Assistent",
        "businessTitle": "Online-Beratung",
        "communityText1": "Use WeChat or Wecom to scan the QR code to join",
        "communityText2": "Treten Sie der [X-Design User Group] bei",
        "communityText3": "Als fr\xfcher Beta-Nutzer ist Ihr Feedback von entscheidender Bedeutung. Bitte teilen Sie uns Ihre Meinung mit.",
        "feedbackTitle": "Feedback"
    },
    "designCreater": {
        "tab1": "Erstellen",
        "tab2": "Hochladen",
        "uploadFail": "Hochladen fehlgeschlagen",
        "uploadDragTips": "Klicken Sie auf die Taste „Hochladen“ oder ziehen Sie die Datei per Drag & Drop hierher",
        "uploadBtn": "Hochladen",
        "uploadTips": "Hinweise: Wir empfehlen, JPG- oder PNG-Bilder mit einer Gr\xf6\xdfe von maximal 20 MB hochzuladen.",
        "unitPxText": "Pixel",
        "unitMmText": "mm",
        "unitCmText": "cm",
        "sizeMinText": "Kleiner als die erforderliche Gr\xf6\xdfe von ${0} * ${1}",
        "sizeMaxText": "\xdcberschreitet die erforderliche Gr\xf6\xdfe von ${0} * ${1}",
        "createBtn": "Erstellen",
        "widthText": "B",
        "widthText1": "B",
        "heightText": "H",
        "heightText1": "H",
        "customText": "Benutzerdefiniert",
        "uploadDragTips_v2": "Bilder hier hochladen oder ablegen",
        "uploadBtn_v2": "Hochladen",
        "uploadTips_v2": "JPG- und PNG-Bilder mit einer Gr\xf6\xdfe von bis zu 20 MB werden unterst\xfctzt",
        "sizeMinText_v2": "Kleiner als die erforderliche Gr\xf6\xdfe von ${0} * ${1} ${2}",
        "sizeMaxText_v2": "\xdcberschreitet die erforderliche Gr\xf6\xdfe von ${0} * ${1} ${2}",
        "canvasSize": "Leinwandgr\xf6\xdfe",
        "canvasBackground": "Hintergrund"
    },
    "space": {
        "onlyU": "Nur Sie",
        "anyone": "Jede Person mit dem Link",
        "viewAble": "Anzeigen",
        "editAble": "Bearbeiten",
        "viewAble2": "Besuchen",
        "shareTitle": "Teilen Sie Ihre Sch\xf6pfungen",
        "copyLink": "Link kopieren",
        "copied": "Kopiert"
    },
    "imageBatchUpload": {
        "buttonText": "Hochladen",
        "uploadDirText": "Ordner hochladen >",
        "buttonDescription": "Einf\xfcgen oder Ziehen Sie ein Bild oder eine URL hierher.",
        "buttonDescription1": "Stapelverarbeitung von bis zu ${0} Bildern",
        "batchButtonText": "Stapelhochladen",
        "upperUploadLimit": "Sie k\xf6nnen bis zu ${0} Bilder hochladen",
        "errTipTitle": "Die Dateien \xfcberschreiten die Hochladegrenzen oder sind au\xdferhalb des Formats",
        "errTipSubTitle": "Bitte laden Sie ${1} Bilder innerhalb von ${0} MB hoch.",
        "maxValueAndSize": "Unterst\xfctzt nur Bilder mit einer maximalen Dateigr\xf6\xdfe von ${0} MB",
        "maxWidthAndHeight": "Unterst\xfctzt nur Bilder mit einer maximalen Gr\xf6\xdfe von ${0} px auf beiden Seiten",
        "errTipUpload": "Hochladen",
        "errTipConfirm": "Verstanden",
        "getFormatText": "Derzeit werden nur Bilder im ${0}-Format unterst\xfctzt",
        "heicResolveFailed": "Das HEIC-Bild konnte nicht geladen werden. Wir empfehlen, es vor dem Hochladen in ein anderes Bildformat zu konvertieren.",
        "imageUploadFailed": "Hochladen fehlgeschlagen",
        "cvDescription": "Bild einf\xfcgen",
        "demoDesc": "Versuchen Sie eines von diesen"
    },
    "logo": {
        "homeTip": "Klicken Sie, um zur Startseite zu gelangen.",
        "toolTip": "Drag X-Design's logo to the bookmarks bar for convenient access in the future."
    },
    "cutoutInfo": {
        "remainingText": "Verbleibende Anzahl von Ausschnitten",
        "openText": "Abonnieren",
        "rechargeText": "Aufladen",
        "emptyText": "Aufladen"
    },
    "textFontFamily": {
        "empty": "Kein Inhalt",
        "changeSearchWord": "Versuchen Sie es mit einem anderen Suchbegriff",
        "fontFamily": "Schriftart",
        "searchFont": "Schriftart suchen",
        "buyVipEnjoyFontFamily": "Kostenlos f\xfcr die kommerzielle Nutzung",
        "currentFontFamily": "In dieser Vorlage verwendete Schriftarten"
    },
    "infiniteScroll": {
        "loading": "Wird geladen..."
    },
    "colorGroup": {
        "emptyText": "Leer",
        "upgradeTeamEdition": "Aktualisieren",
        "systemColor": "Systemfarbe",
        "teamColor": "Markenfarbkarte",
        "cover": "F\xfcllen",
        "repeat": "Kachelartig",
        "fillingMode": "Anzeigemodus",
        "recommendedTexture": "Empfohlen",
        "uploadImage": "Hochladen",
        "replaceImage": "Ersetzen"
    },
    "downloadBtn": {
        "downloadBtnTxt": "Herunterladen",
        "modalTitle": "Herunterladen",
        "editMoreTitle": "Erweiterte Bearbeitung",
        "downloadNow": "Herunterladen",
        "addTxt": "Text hinzuf\xfcgen",
        "addMaterial": "Element hinzuf\xfcgen",
        "eraser": "Radierer",
        "cutout": "Hintergrundentferner",
        "quality": "Bildverbesserung",
        "editMore": "Foto-Editor",
        "customSize": "Benutzerdefiniert",
        "customSizeInputTips": "Gr\xf6\xdfenlimit eingeben",
        "customSizeError": "Dateigr\xf6\xdfe eingeben",
        "processing": "Verarbeitung l\xe4uft...",
        "aicp": "KI-Hintergrunderzeuger",
        "upscale": "Bild-Hochskalierer"
    },
    "interceptModal": {
        "title": "Pop-up Fenster f\xfcr X-Design zulassen.",
        "desc": "Erlauben Sie X-Design, mehrere Fenster in Ihrem Browser zu \xf6ffnen.",
        "stepTitle": "Schritt ${0}",
        "btnText": "Verstanden",
        "firstStep": "Klicken Sie auf die Sperrwarnung, die oben rechts in Ihrem Browser angezeigt wird",
        "secondStep": "Klicken Sie auf „Pop-ups und Weiterleitungen immer zulassen“.",
        "thirdStep": "Klicken Sie auf „Fertig“, um X-Design zu verwenden.",
        "xDesignTitle": "Pop-up Fenster f\xfcr X-Design zulassen.",
        "xDesignDesc": "Erlauben Sie X-Design, mehrere Fenster in Ihrem Browser zu \xf6ffnen.",
        "xDesignThirdStep": "Klicken Sie auf „Fertig“, um X-Design zu verwenden.",
        "safariFirstStep": "Klicken Sie auf die Men\xfcleiste links > Safari und w\xe4hlen Sie dann designkit.com aus.",
        "safariSecondStep": "In the pop-up window, select “Pop-ups” > “Allow” to access X-Design features smoothly."
    },
    "workListPanel": {
        "history": "Sch\xf6pfungen",
        "upload": "Hochladen",
        "failed": "Fehlgeschlagen",
        "pending": "Wird geladen...",
        "cancelText": "Abbrechen",
        "confirmText": "Best\xe4tigen",
        "deleteText": "Nach dem L\xf6schen gehen die generierten Ergebnisse verloren. M\xf6chten Sie wirklich l\xf6schen?",
        "generating": "Wird erstellt"
    },
    "feedbackVoting": {
        "defaultText": "Bewerten Sie das Ergebnis",
        "thanks": "Danke f\xfcr Ihr Feedback.",
        "modalTitle": "Feedback",
        "modalDesc": "Ihr Feedback wird uns dabei helfen, unseren Service zu verbessern.",
        "modalIpt": "Bitte beschreiben Sie, mit welchem Teil Sie nicht zufrieden sind",
        "iptMaxLength": "Der Inhalt \xfcberschreitet das Limit. Bitte halten Sie ihn unter ${0} Zeichen oder kontaktieren Sie den Kundenservice.",
        "cancel": "Schlie\xdfen",
        "submit": "Senden",
        "other": "Sonstiges"
    },
    "newDesignCreater": {
        "title": "Leere Leinwand erstellen",
        "allCategory": "Alles",
        "openImage": "Hochladen",
        "openFile": "Datei",
        "pleaseInputSize": "Gr\xf6\xdfe eingeben",
        "categorySection": {
            "lookMore": "Mehr",
            "canvasSize": {
                "create": "Erstellen"
            }
        },
        "create": "Erstellen",
        "commonSize": "Common size"
    },
    "psdModal": {
        "uploadTemplate": "Hochladen",
        "uploadFile": "Hochladen",
        "uploadSuccess": "Hochgeladen",
        "uploadFailed": "Hochladen fehlgeschlagen",
        "uploadPSD": "PSD hochladen"
    },
    "userPolicy": {
        "btnTomorrow": "Nicht jetzt",
        "btnVip": "Jetzt aktualisieren",
        "btnMy": "Mehr Credits",
        "buyVip": "T\xe4gliches Testlimit erreicht. Werden Sie VIP f\xfcr unbegrenzten Zugang!",
        "buyMy": "You’ve reached your trial limit. Get more credits to keep going!",
        "buyVipOrBackTomorrow": "T\xe4gliches Testlimit erreicht. Werden Sie VIP f\xfcr unbegrenzten Zugang!",
        "backTomorrow": "T\xe4gliches Testlimit erreicht. Werden Sie VIP f\xfcr unbegrenzten Zugang!",
        "trialLimitReached": "Trial Limit Reached"
    },
    "batchTaskList": {
        "loading": "Wird geladen",
        "fail": "Erzeugung fehlgeschlagen",
        "batchEdit": "Stapelbearbeitung",
        "upload": "Mehr hochladen"
    },
    "userReviews": {
        "hello": "Hallo ${0},",
        "wordsOfThanks": "vielen Dank, dass Sie Teil von X-Design sind.",
        "desc": "Ihr Feedback ist f\xfcr uns von gro\xdfer Bedeutung. Wenn Ihnen X-Design gef\xe4llt, w\xfcrden wir uns sehr freuen, wenn Sie uns eine Bewertung auf Trustpilot hinterlassen k\xf6nnten – dies unterst\xfctzt uns sehr bei unserem Wachstum und unserer Weiterentwicklung.",
        "leave": "Bewertung abgeben"
    },
    "aih5DownloadBtn": {
        "signInText": "Anmelden",
        "fullQualityText": "Volle Qualit\xe4t",
        "previewText": "Vorschau",
        "freeText": "Gratis",
        "downloadText": "Herunterladen",
        "fullQualityLimitReached": "Die Grenze f\xfcr volle Qualit\xe4t wurde erreicht. Bitte versuchen Sie es morgen erneut.",
        "todayLimitReached": "Das heutige Limit wurde erreicht. Versuchen Sie es morgen erneut oder aktualisieren Sie jetzt."
    },
    "navVipEntrance": {
        "getFreePro": "Pro kostenlos holen",
        "unlockPro": "Pro freischalten",
        "renewNow": "Jetzt erneuern",
        "upgradeToPro": "Auf Pro aktualisieren"
    }
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/projectA/es-MX.js
/* harmony default export */ const projectA_es_MX = ({
    "brandSDK": {
        "bgInput": {
            "placeholder": "Describe el concepto de tu marca, industria y preferencia de estilo."
        },
        "brandCard": {
            "nameLimitTip": "Ingresa un nombre (hasta 10\xa0caracteres)"
        },
        "delBrandSureModal": {
            "okText": "Confirmar",
            "cancelText": "Cancelar",
            "title": "\xbfDeseas borrar este kit de marca?",
            "message": "Los dise\xf1os aplicados no se ver\xe1n afectados."
        },
        "brandList": {
            "createBrandText": "Agregar",
            "emptyText": "Vac\xedo"
        },
        "logoCard": {
            "coverCornerText1": "Portada",
            "coverCornerText2": "Logotipo principal",
            "delSureModal": {
                "okText": "Confirmar",
                "cancelText": "Cancelar",
                "title": "\xbfDeseas eliminar este logotipo?"
            },
            "nameLimitTip": "Ingresa un nombre (hasta ${0}\xa0caracteres)",
            "replaceText": "Reemplazar"
        },
        "colorList": {
            "countLimitTip": "Agrega hasta ${0} color(es) a cada paleta de color"
        },
        "colorCard": {
            "colorCountLimitTip": "Agrega hasta ${0} color(es) a cada paleta de color",
            "nameLimitTip": "Ingresa un nombre (hasta ${0}\xa0caracteres)",
            "nameInputPlaceholder": "Ingresa un nombre (hasta ${0}\xa0caracteres)",
            "colorEmptyText": "Vac\xedo"
        },
        "page": {
            "brandStandards": "Kit de marca",
            "createStandard": "Agregar",
            "createBrand": "Kit de marca"
        },
        "editBrand": {
            "sections": {
                "logo": "Logotipos",
                "colorCard": "Paleta de colores",
                "textStyle": "Estilos de texto",
                "template": "Plantillas",
                "primaryColor": "Color principal",
                "secondaryColor": "Color secundario"
            },
            "brandBackground": "Descripci\xf3n de marca",
            "nameLimitTip": "Ingresa un nombre (hasta 10\xa0caracteres)",
            "saveLastStyle": "Guarda los cambios para continuar",
            "saveLastColorCard": "Guarda los cambios para continuar",
            "saveLastElement": "Guarda los cambios para continuar",
            "addColorCard": "Agregar nuevo",
            "addStyle": "Agregar nuevo",
            "addPrimaryColor": "Agregar color principal",
            "addSecondaryColor": "Agregar color secundario",
            "bgInput": {
                "openBtnText": "Expandir",
                "foldBtnText": "Contraer",
                "title": "Gu\xeda de estilo"
            },
            "addPrimaryLogo": "Agregar logotipo principal"
        },
        "textCard": {
            "nameLimitTip": "Ingresa un nombre (hasta ${0}\xa0caracteres)",
            "selectFont": "Selecciona una fuente",
            "selectFontSize": "Seleccionar tama\xf1o de fuente",
            "fontSizePlaceholder": "Tama\xf1o",
            "save": "Guardar",
            "bold": "Negrita",
            "standard": "Est\xe1ndar",
            "italic": "Cursiva",
            "defaultCategoryName": "General"
        },
        "templateCard": {
            "delSureModal": {
                "title": "\xbfDeseas borrar esta plantilla?",
                "okText": "Confirmar",
                "cancelText": "Cancelar"
            },
            "nameLimitTip": "Ingresa un nombre (hasta ${0}\xa0caracteres)",
            "defaultName": "Plantillas"
        },
        "selectBrandElementModal": {
            "brandAssets": "Kit de marca",
            "localUpload": "Subir desde dispositivo",
            "brandLogo": "Logotipos",
            "brandTemplate": "Plantillas",
            "uploadImage": "Subir",
            "uploadDragTips": "Sube tu imagen o su\xe9ltala aqu\xed",
            "uploadTips": "Sube hasta ${1}\xa0im\xe1genes JPG o PNG (m\xe1x. ${0}\xa0MB cada una)"
        },
        "tooltip": {
            "message": "\xa1La funci\xf3n P\xf3ster de marca ya est\xe1 disponible!",
            "desc": "Sube tus p\xf3sters de marca y permite que el Agente de IA eche un vistazo. Aprender\xe1 tus gustos y en el futuro crear\xe1 recursos visuales que coincidan con el estilo de tu marca."
        }
    },
    "satisfaction": {
        "effectSatisfaction": "Satisfacci\xf3n",
        "noWarn": "No mostrar de nuevo",
        "dissatisfied": "Insatisfecho",
        "normal": "Neutral",
        "satisfied": "Satisfecho",
        "placeholder": "Ingresa tus comentarios (l\xedmite 200\xa0caracteres)",
        "submitBtn": "Enviar"
    },
    "userInfo": {
        "notVipTip": "La suscripci\xf3n a X-Design Pro te da acceso a numerosos elementos y funciones con derechos de autor.",
        "notLoginText": "A\xfan no eres miembro",
        "businessText": "Consulta en l\xednea",
        "feedbackText": "Comentarios",
        "downloadText": "Descarga la app",
        "settingText": "Configuraci\xf3n",
        "loginText": "Iniciar sesi\xf3n",
        "copyText": "Copiar",
        "svipExpires": "Fecha de expiraci\xf3n de X-Design Pro: ${0}",
        "renewalText": "Renovar",
        "openText": "Suscr\xedbete",
        "tips": "Usa obras con derechos de autor de manera comercial sin preocupaciones durante el periodo de tu membres\xeda.",
        "logoutText": "Cerrar sesi\xf3n",
        "lightText": "Claro",
        "dartText": "Oscuro",
        "teamExpires": "La membres\xeda equipo expira el: ${0}",
        "teamNotVipTitle": "Suscr\xedbete a la membres\xeda de equipo",
        "teamNotVipTip": "Disfruta beneficios exclusivos de tu membres\xeda y colaboraci\xf3n en equipo",
        "teamExpiresDays": "Tu membres\xeda de equipo expir\xf3 hace ${0} d\xedas",
        "copySuccess": "\xa1Copiado!",
        "notVipTipTitle": "Convi\xe9rtete en miembro para acceder a todos los recursos y herramientas de dise\xf1o",
        "notVipTipSubscript": "Derechos comerciales cubiertos",
        "teamVersion": "Equipo",
        "personalVersion": "Personal",
        "vipExpiresDays": "Tu suscripci\xf3n expir\xf3 hace ${0} d\xedas",
        "countAmount": "Cantidad de recorte",
        "meidouAmount": "Cr\xe9ditos",
        "owner": "S\xfaper Administrador",
        "admin": "Administrador",
        "vipValidUntil": "Expira el: ${0}",
        "teamNotVipTip2": "Disfruta beneficios SVIP y funciones exclusivas",
        "enterpriseVersion": "Grandes empresas",
        "freeTeamVersion": "Gratis",
        "initialFreeDesc": "Convi\xe9rtete en miembro para acceder a todos los recursos y herramientas de dise\xf1o",
        "initialFreeTeamDesc": "Suscr\xedbete para compartir recursos y herramientas con tu equipo",
        "languageSwitch": "Idioma",
        "pro": "Pro",
        "renewOn": "Renovaci\xf3n el",
        "tryProForFree": "Prueba Pro gratis",
        "expiresOn": "Expira el",
        "upgradeToPro": "Actualizar a Pro",
        "credit": "Cr\xe9dito",
        "manageSubscriptions": "Administrar suscripciones",
        "termsAndPolicies": "T\xe9rminos y pol\xedticas",
        "benefitsUpgraded": "Beneficios mejorados",
        "deductionTipsIntl": "Necesita consumir ${0} cr\xe9ditos",
        "deductionTips2Intl": "Se descontar\xe1n ${0} cr\xe9ditos para esta generaci\xf3n. \xbfDeseas continuar?",
        "autoDeductCredits": "Descontar cr\xe9ditos autom\xe1ticamente",
        "generate": "Generar",
        "close": "Cerrar",
        "basic": "B\xe1sico"
    },
    "utils": {
        "requestErrorText": "Error de red. No se pudo conectar con el servidor."
    },
    "upload": {
        "errorText": "Error al subir",
        "cancelText": "Cancelar",
        "uploadingText": "Subiendo…",
        "fileText": "Archivo",
        "picText": "Im\xe1genes",
        "blockText": "Carga cancelada",
        "cancelUploadText": "Cancelar carga",
        "maxLengthTips": "Puedes subir hasta 20\xa0im\xe1genes a la vez",
        "formatFailTips": "Error al subir ${0} im\xe1genes. Por el momento, solo se admiten im\xe1genes en formato${1}.",
        "formatFailTips1": "Solo se admiten im\xe1genes en formato ${0} por ahora",
        "formatFailTips2": "Error al subir ${0} im\xe1genes. Por el momento, solo se admiten im\xe1genes en formato JPG, JPEG y PNG.",
        "sizeFailTips": "Error al subir ${0} im\xe1genes. Aseg\xfarate de que cada imagen sea menor a 20\xa0MB y no mayor a 8,000\xd78,000\xa0pixeles.",
        "sizeFailTips1": "Aseg\xfarate de que cada imagen sea menor a 20\xa0MB y no mayor a 8,000\xd78,000\xa0pixeles.",
        "widthHeightFailTips": "Solo se admiten im\xe1genes de hasta 8000\xa0px (alto \xd7 ancho)",
        "sizeFailTips2": "Solo se admiten im\xe1genes de hasta ${0}\xa0MB"
    },
    "meidouInfo": {
        "emptyText": "Recargar",
        "buyText": "Compra un plan de cr\xe9ditos",
        "openText": "Suscr\xedbete",
        "rechargeText": "Recargar",
        "remainingText": "Mis cr\xe9ditos",
        "tips1": "Prioriza los cr\xe9ditos pr\xf3ximos a expirar para su consumo.",
        "tips2": "Tus cr\xe9ditos comprados nunca expiran",
        "tips3": "Incluye ${0}\xa0cr\xe9ditos pagados con validez permanente.",
        "tips4": "Los cr\xe9ditos se descontar\xe1n autom\xe1ticamente con cada generaci\xf3n.",
        "detailText": "Detalles",
        "whatIsMeidou": "\xbfQu\xe9 son los cr\xe9ditos?",
        "giftTips": "Se agregaron 40 cr\xe9ditos a tu cuenta.",
        "giftTips1": "Expira al final del d\xeda. \xa1No olvides usarlos!",
        "genText": "Generar",
        "deductionTips": "Se descontar\xe1n ${0} cr\xe9ditos para esta generaci\xf3n. \xbfDeseas continuar?",
        "genBtnText": "Generar",
        "inadequateTips": "Cr\xe9ditos insuficientes. Primero recarga al menos ${0} cr\xe9ditos.",
        "tryTimes": "Tiempos de prueba ${0}/${1}",
        "meidouCountModalTitle": "Cr\xe9ditos restantes",
        "meidouCountModalTips": "Los cr\xe9ditos pr\xf3ximos a expirar se usar\xe1n primero.",
        "meidouCountModalTips1": "Acerca de los cr\xe9ditos",
        "meidouCountModalEmpty": "No tienes cr\xe9ditos. Compra ahora.",
        "meidouCountModalBtn": "Aceptar",
        "meidouCountModalPermanent": "Validez permanente",
        "meidouCountModalExpired": "Expira en ${0} d\xeda(s)",
        "creditTransactionDetails": "Resumen de los cr\xe9ditos",
        "deductionTipsIntl": "Necesita consumir ${0} cr\xe9ditos",
        "deductionTips2Intl": "Se descontar\xe1n ${0} cr\xe9ditos para esta generaci\xf3n. \xbfDeseas continuar?",
        "autoDeductCredits": "Descontar cr\xe9ditos autom\xe1ticamente",
        "generate": "Generar",
        "close": "Cerrar",
        "creditsBalance": "Saldo de cr\xe9ditos",
        "whatAreCredits": "\xbfQu\xe9 son los cr\xe9ditos?",
        "usageDetail": "Detalles de uso",
        "getMoreCredits": "Obt\xe9n m\xe1s cr\xe9ditos"
    },
    "floatHelp": {
        "modalTitle": "Asistente de Meitu",
        "businessTitle": "Consulta en l\xednea",
        "communityText1": "Usa WeChat o WeCom para escanear el c\xf3digo QR y unirte",
        "communityText2": "\xdanete al [grupo de usuarios de X-Design]",
        "communityText3": "Como usuario beta, tus comentarios son cruciales. Comparte tus opiniones con nosotros.",
        "feedbackTitle": "Comentarios"
    },
    "designCreater": {
        "tab1": "Crear",
        "tab2": "Subir",
        "uploadFail": "Error al subir",
        "uploadDragTips": "Haz clic en el bot\xf3n “Subir” o arrastra y suelta aqu\xed",
        "uploadBtn": "Subir",
        "uploadTips": "Sugerencias: te recomendamos subir im\xe1genes JPG o PNG de menos de 20\xa0MB.",
        "unitPxText": "Pixeles",
        "unitMmText": "mm",
        "unitCmText": "cm",
        "sizeMinText": "M\xe1s peque\xf1o que el tama\xf1o requerido de ${0} * ${1}",
        "sizeMaxText": "Supera el tama\xf1o requerido de ${0} * ${1}",
        "createBtn": "Crear",
        "widthText": "Ancho",
        "widthText1": "Ancho",
        "heightText": "Alto",
        "heightText1": "Alto",
        "customText": "Personalizado",
        "uploadDragTips_v2": "Sube tu imagen o su\xe9ltala aqu\xed",
        "uploadBtn_v2": "Subir",
        "uploadTips_v2": "Se admiten im\xe1genes JPG y PNG de menos de 20\xa0MB",
        "sizeMinText_v2": "M\xe1s peque\xf1o que el tama\xf1o requerido de ${0} * ${1} ${2}",
        "sizeMaxText_v2": "Supera el tama\xf1o requerido de ${0} * ${1} ${2}",
        "canvasSize": "Tama\xf1o del lienzo",
        "canvasBackground": "Fondo"
    },
    "space": {
        "onlyU": "Solo t\xfa",
        "anyone": "Cualquier persona que tenga el enlace",
        "viewAble": "Ver",
        "editAble": "Editar",
        "viewAble2": "Visitar",
        "shareTitle": "Comparte tu creaci\xf3n",
        "copyLink": "Copiar enlace",
        "copied": "Copiado"
    },
    "imageBatchUpload": {
        "buttonText": "Subir",
        "uploadDirText": "Subir carpeta\xa0>",
        "buttonDescription": "Pega o arrastra una imagen o URL aqu\xed.",
        "buttonDescription1": "Procesa por lotes hasta ${0} im\xe1genes",
        "batchButtonText": "Carga por lotes",
        "upperUploadLimit": "Puedes subir hasta ${0} im\xe1genes",
        "errTipTitle": "Los archivos superan los l\xedmites de carga o no tienen el formato correcto",
        "errTipSubTitle": "Sube ${1} im\xe1genes de menos de ${0}\xa0MB.",
        "maxValueAndSize": "Solo se admiten im\xe1genes con un tama\xf1o de archivo m\xe1ximo de ${0}\xa0MB",
        "maxWidthAndHeight": "Solo se admiten im\xe1genes de hasta ${0}\xa0px de ambos lados",
        "errTipUpload": "Subir",
        "errTipConfirm": "Entendido",
        "getFormatText": "Solo se admiten im\xe1genes en formato ${0} por ahora",
        "heicResolveFailed": "Error al cargar la imagen HEIC. Te recomendamos convertirla a otro formato de imagen antes de subirla.",
        "imageUploadFailed": "Error al subir",
        "cvDescription": "Pegar imagen",
        "demoDesc": "Prueba uno de estos"
    },
    "logo": {
        "homeTip": "Haz clic para navegar a la p\xe1gina de inicio",
        "toolTip": "Arrastra el logotipo de X-Design a la barra de favoritos para tener un acceso conveniente en el futuro."
    },
    "cutoutInfo": {
        "remainingText": "Cantidad restante de recortes",
        "openText": "Suscr\xedbete",
        "rechargeText": "Recargar",
        "emptyText": "Recargar"
    },
    "textFontFamily": {
        "empty": "Sin contenido",
        "changeSearchWord": "Prueba un t\xe9rmino de b\xfasqueda diferente",
        "fontFamily": "Fuente",
        "searchFont": "Buscar fuente",
        "buyVipEnjoyFontFamily": "Gratis para uso comercial",
        "currentFontFamily": "Fuentes usadas en esta plantilla"
    },
    "infiniteScroll": {
        "loading": "Cargando…"
    },
    "colorGroup": {
        "emptyText": "Vac\xedo",
        "upgradeTeamEdition": "Actualizar",
        "systemColor": "Color del sistema",
        "teamColor": "Tarjeta de colores de marca",
        "cover": "Rellenar",
        "repeat": "Mosaico",
        "fillingMode": "Modo de visualizaci\xf3n",
        "recommendedTexture": "Recomendado",
        "uploadImage": "Subir",
        "replaceImage": "Reemplazar"
    },
    "downloadBtn": {
        "downloadBtnTxt": "Descargar",
        "modalTitle": "Descargar",
        "editMoreTitle": "Edici\xf3n avanzada",
        "downloadNow": "Descargar",
        "addTxt": "Agregar texto",
        "addMaterial": "Agregar elemento",
        "eraser": "Borrador",
        "cutout": "Eliminador de fondo",
        "quality": "Mejorador de imagen",
        "editMore": "Editor de fotos",
        "customSize": "Personalizado",
        "customSizeInputTips": "Ingresa el l\xedmite de tama\xf1o",
        "customSizeError": "Llena el tama\xf1o del archivo",
        "processing": "Procesando…",
        "aicp": "Generador de fondos con IA",
        "upscale": "Ampliador de imagen"
    },
    "interceptModal": {
        "title": "Permite ventanas emergentes para X-Design.",
        "desc": "Autoriza que X-Design abra m\xfaltiples ventanas en tu navegador.",
        "stepTitle": "Paso ${0}",
        "btnText": "Entendido",
        "firstStep": "Haz clic en la alerta de bloqueo que aparece en la esquina superior derecha de tu navegador",
        "secondStep": "Haz clic en “Siempre permitir ventanas emergentes y redireccionamientos”.",
        "thirdStep": "Haz clic en “Listo” para comenzar a usar X-Design.",
        "xDesignTitle": "Permite ventanas emergentes para X-Design.",
        "xDesignDesc": "Autoriza que X-Design abra m\xfaltiples ventanas en tu navegador.",
        "xDesignThirdStep": "Haz clic en “Listo” para comenzar a usar X-Design.",
        "safariFirstStep": "Haz clic en la barra de men\xfa de la izquierda\xa0> Safari, luego selecciona designkit.com.",
        "safariSecondStep": "En la ventana emergente, selecciona Ventanas emergentes\xa0> Permitir para acceder f\xe1cilmente a las funciones de X-Design."
    },
    "workListPanel": {
        "history": "Creaciones",
        "upload": "Subir",
        "failed": "Error",
        "pending": "Cargando…",
        "cancelText": "Cancelar",
        "confirmText": "Confirmar",
        "deleteText": "Despu\xe9s de eliminarlos, los resultados generados se perder\xe1n. \xbfDesear borrarlos?",
        "generating": "Generando"
    },
    "feedbackVoting": {
        "defaultText": "Califica el resultado",
        "thanks": "Gracias por tus comentarios.",
        "modalTitle": "Comentarios",
        "modalDesc": "Tus comentarios nos ayudar\xe1n a mejorar nuestro servicio.",
        "modalIpt": "Describe qu\xe9 parte no te pareci\xf3 satisfactoria",
        "iptMaxLength": "El contenido excede el l\xedmite. Sigue el l\xedmite de ${0}\xa0caracteres o comun\xedcate con el servicio de atenci\xf3n al cliente.",
        "cancel": "Cerrar",
        "submit": "Enviar",
        "other": "Otro"
    },
    "newDesignCreater": {
        "title": "Crear lienzo en blanco",
        "allCategory": "Todo",
        "openImage": "Subir",
        "openFile": "Archivo",
        "pleaseInputSize": "Ingresa el tama\xf1o",
        "categorySection": {
            "lookMore": "M\xe1s",
            "canvasSize": {
                "create": "Crear"
            }
        },
        "create": "Crear",
        "commonSize": "Tama\xf1o com\xfan"
    },
    "psdModal": {
        "uploadTemplate": "Subir",
        "uploadFile": "Subir",
        "uploadSuccess": "Subido",
        "uploadFailed": "Error al subir",
        "uploadPSD": "Subir PSD"
    },
    "userPolicy": {
        "btnTomorrow": "Ahora no",
        "btnVip": "Actualizar ahora",
        "btnMy": "Obt\xe9n m\xe1s cr\xe9ditos",
        "buyVip": "Llegaste al l\xedmite diario de prueba. Con VIP obtienes acceso ilimitado.",
        "buyMy": "Llegaste a tu l\xedmite de prueba. Obt\xe9n m\xe1s cr\xe9ditos para continuar.",
        "buyVipOrBackTomorrow": "Llegaste al l\xedmite diario de prueba. Con VIP obtienes acceso ilimitado.",
        "backTomorrow": "Llegaste al l\xedmite diario de prueba. Con VIP obtienes acceso ilimitado.",
        "trialLimitReached": "Alcanzaste el l\xedmite de prueba"
    },
    "batchTaskList": {
        "loading": "Cargando",
        "fail": "Error al generar",
        "batchEdit": "Edici\xf3n por lotes",
        "upload": "Subir m\xe1s"
    },
    "userReviews": {
        "hello": "Hola ${0}",
        "wordsOfThanks": "\xa1Gracias por ser parte de X-Design!",
        "desc": "Tus comentarios son muy importantes para nosotros. Si est\xe1s disfrutando X-Design, nos encantar\xeda que dejaras una rese\xf1a en Trustpilot. Nos ayuda mucho a crecer y mejorar.",
        "leave": "Deja una rese\xf1a"
    },
    "aih5DownloadBtn": {
        "signInText": "Iniciar sesi\xf3n",
        "fullQualityText": "Calidad total",
        "previewText": "Vista previa",
        "freeText": "Gratis",
        "downloadText": "Descargar",
        "fullQualityLimitReached": "Se alcanz\xf3 el l\xedmite de calidad total. Vuelve ma\xf1ana.",
        "todayLimitReached": "Se alcanz\xf3 el l\xedmite de hoy. Vuelve ma\xf1ana o actualiza ahora."
    },
    "navVipEntrance": {
        "getFreePro": "Obt\xe9n Pro gratis",
        "unlockPro": "Desbloquear Pro",
        "renewNow": "Renovar ahora",
        "upgradeToPro": "Actualizar a Pro"
    }
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/projectA/id.js
/* harmony default export */ const projectA_id = ({
    "brandSDK": {
        "bgInput": {
            "placeholder": "Jelaskan konsep merek, industri, dan preferensi gayamu."
        },
        "brandCard": {
            "nameLimitTip": "Masukkan nama (maksimal 10 karakter)"
        },
        "delBrandSureModal": {
            "okText": "Konfirmasi",
            "cancelText": "Batal",
            "title": "Hapus kit merek ini?",
            "message": "Desain yang diterapkan tidak terpengaruh."
        },
        "brandList": {
            "createBrandText": "Tambah",
            "emptyText": "Kosong"
        },
        "logoCard": {
            "coverCornerText1": "Kover",
            "coverCornerText2": "Logo utama",
            "delSureModal": {
                "okText": "Konfirmasi",
                "cancelText": "Batal",
                "title": "Hapus logo ini?"
            },
            "nameLimitTip": "Masukkan nama (maksimal ${0} karakter)",
            "replaceText": "Ganti"
        },
        "colorList": {
            "countLimitTip": "Tambahkan maksimal ${0} warna ke setiap palet warna"
        },
        "colorCard": {
            "colorCountLimitTip": "Tambahkan maksimal ${0} warna ke setiap palet warna",
            "nameLimitTip": "Masukkan nama (maksimal ${0} karakter)",
            "nameInputPlaceholder": "Masukkan nama (maksimal ${0} karakter)",
            "colorEmptyText": "Kosong"
        },
        "page": {
            "brandStandards": "Kit Merek",
            "createStandard": "Tambah",
            "createBrand": "Kit Merek"
        },
        "editBrand": {
            "sections": {
                "logo": "Logo",
                "colorCard": "Sistem warna",
                "textStyle": "Gaya teks",
                "template": "Templat",
                "primaryColor": "Warna primer",
                "secondaryColor": "Warna sekunder"
            },
            "brandBackground": "Deskripsi merek",
            "nameLimitTip": "Masukkan nama (maksimal 10 karakter)",
            "saveLastStyle": "Simpan perubahan untuk melanjutkan",
            "saveLastColorCard": "Simpan perubahan untuk melanjutkan",
            "saveLastElement": "Simpan perubahan untuk melanjutkan",
            "addColorCard": "Tambahkan baru",
            "addStyle": "Tambahkan baru",
            "addPrimaryColor": "Tambahkan warna primer",
            "addSecondaryColor": "Tambahkan warna sekunder",
            "bgInput": {
                "openBtnText": "Perluas",
                "foldBtnText": "Susutkan",
                "title": "Panduan Gaya"
            },
            "addPrimaryLogo": "Tambahkan logo utama"
        },
        "textCard": {
            "nameLimitTip": "Masukkan nama (maksimal ${0} karakter)",
            "selectFont": "Pilih fon",
            "selectFontSize": "Pilih ukuran fon",
            "fontSizePlaceholder": "Ukuran",
            "save": "Simpan",
            "bold": "Tebal",
            "standard": "Standar",
            "italic": "Miring",
            "defaultCategoryName": "Umum"
        },
        "templateCard": {
            "delSureModal": {
                "title": "Hapus templat ini?",
                "okText": "Konfirmasi",
                "cancelText": "Batal"
            },
            "nameLimitTip": "Masukkan nama (maksimal ${0} karakter)",
            "defaultName": "Templat"
        },
        "selectBrandElementModal": {
            "brandAssets": "Kit Merek",
            "localUpload": "Unggah dari Perangkat",
            "brandLogo": "Logo",
            "brandTemplate": "Templat",
            "uploadImage": "Unggah",
            "uploadDragTips": "Unggah atau seret foto di sini",
            "uploadTips": "Unggah maksimal ${1} gambar JPG atau PNG (masing-masing maks ${0} MB)"
        },
        "tooltip": {
            "message": "Fitur Poster Merek kini sudah tersedia!",
            "desc": "Unggah poster merek sebagai referensi Agen AI. AI akan mempelajari gaya dan membuat visual yang sesuai dengan gaya merekmu!"
        }
    },
    "satisfaction": {
        "effectSatisfaction": "Kepuasan",
        "noWarn": "Jangan tampilkan lagi",
        "dissatisfied": "Tidak puas",
        "normal": "Netral",
        "satisfied": "Puas",
        "placeholder": "Berikan masukan (maksimal 200 karakter)",
        "submitBtn": "Kirim"
    },
    "userInfo": {
        "notVipTip": "Langganan X-Design Pro memberikan akses ke berbagai elemen dan fitur yang memiliki hak cipta.",
        "notLoginText": "Anda belum jadi anggota",
        "businessText": "Konsultasi online",
        "feedbackText": "Masukan",
        "downloadText": "Unduh Aplikasi",
        "settingText": "Pengaturan",
        "loginText": "Login",
        "copyText": "Salin",
        "svipExpires": "Tanggal kedaluwarsa X-Design Pro: ${0}",
        "renewalText": "Perpanjang",
        "openText": "Berlangganan",
        "tips": "Nikmati penggunaan komersial karya berhak cipta sepuasnya selama periode keanggotaan.",
        "logoutText": "Logout",
        "lightText": "Terang",
        "dartText": "Gelap",
        "teamExpires": "Keanggotaan tim berakhir pada: ${0}",
        "teamNotVipTitle": "Berlangganan Keanggotaan Tim",
        "teamNotVipTip": "Dapatkan manfaat keanggotaan eksklusif dan kolaborasi tim",
        "teamExpiresDays": "Keanggotaan tim Anda berakhir ${0} hari lalu",
        "copySuccess": "Disalin!",
        "notVipTipTitle": "Daftar anggota untuk mengakses semua sumber daya dan alat desain",
        "notVipTipSubscript": "Termasuk hak komersial",
        "teamVersion": "Tim",
        "personalVersion": "Personal",
        "vipExpiresDays": "Langganan Anda berakhir ${0} hari lalu",
        "countAmount": "Jumlah pemotongan",
        "meidouAmount": "Kredit",
        "owner": "Admin Super",
        "admin": "Administrator",
        "vipValidUntil": "Berakhir pada: ${0}",
        "teamNotVipTip2": "Nikmati manfaat SVIP dan fitur eksklusif",
        "enterpriseVersion": "Perusahaan",
        "freeTeamVersion": "Gratis",
        "initialFreeDesc": "Daftar anggota untuk mengakses semua sumber daya dan alat desain",
        "initialFreeTeamDesc": "Berlangganan untuk berbagi sumber daya dan alat tim",
        "languageSwitch": "Bahasa",
        "pro": "Pro",
        "renewOn": "Perpanjang pada",
        "tryProForFree": "Coba Pro Gratis",
        "expiresOn": "Berakhir pada",
        "upgradeToPro": "Upgrade ke Pro",
        "credit": "Kredit",
        "manageSubscriptions": "Kelola Langganan",
        "termsAndPolicies": "Ketentuan dan Kebijakan",
        "benefitsUpgraded": "Manfaat Diupgrade",
        "deductionTipsIntl": "Perlu menggunakan ${0} kredit",
        "deductionTips2Intl": "${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?",
        "autoDeductCredits": "Otomatis potong kredit",
        "generate": "Proses",
        "close": "Tutup",
        "basic": "Dasar"
    },
    "utils": {
        "requestErrorText": "Kesalahan jaringan. Tidak dapat terhubung ke server."
    },
    "upload": {
        "errorText": "Gagal mengunggah",
        "cancelText": "Batal",
        "uploadingText": "Mengunggah...",
        "fileText": "File",
        "picText": "Gambar",
        "blockText": "Unggahan dibatalkan",
        "cancelUploadText": "Batalkan unggahan",
        "maxLengthTips": "Anda dapat mengunggah maksimal 20 foto sekaligus",
        "formatFailTips": "Unggahan ${0} gambar gagal. Saat ini hanya mendukung format gambar ${1}.",
        "formatFailTips1": "Saat ini hanya mendukung format gambar ${0}",
        "formatFailTips2": "Unggahan ${0} gambar gagal. Saat ini hanya mendukung format gambar JPG, JPEG, dan PNG.",
        "sizeFailTips": "Unggahan ${0} gambar gagal. Pastikan setiap gambar berukuran maksimal 20 MB dan tidak lebih dari 8000\xd78000 piksel.",
        "sizeFailTips1": "Pastikan setiap gambar berukuran maksimal 20 MB dan tidak lebih dari 8000\xd78000 piksel.",
        "widthHeightFailTips": "Hanya mendukung gambar maks 8000px (P&L)",
        "sizeFailTips2": "Hanya mendukung gambar maks ${0} MB"
    },
    "meidouInfo": {
        "emptyText": "Isi ulang",
        "buyText": "Beli paket kredit",
        "openText": "Berlangganan",
        "rechargeText": "Isi ulang",
        "remainingText": "Kredit saya",
        "tips1": "Prioritaskan penggunaan kredit yang akan segera kedaluwarsa.",
        "tips2": "Kredit yang dibeli tidak akan pernah kedaluwarsa",
        "tips3": "Termasuk ${0} kredit berbayar yang berlaku permanen.",
        "tips4": "Kredit akan otomatis berkurang setiap kali memproses.",
        "detailText": "Detail",
        "whatIsMeidou": "Apa itu kredit?",
        "giftTips": "40 kredit ditambahkan ke akun Anda!",
        "giftTips1": "Kedaluwarsa di penghujung hari ini. Jangan lupa untuk menggunakannya!",
        "genText": "Proses",
        "deductionTips": "${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?",
        "genBtnText": "Proses",
        "inadequateTips": "Kredit tidak cukup. Harap isi ulang dahulu minimal ${0} kredit.",
        "tryTimes": "Waktu uji coba ${0} /${1}",
        "meidouCountModalTitle": "Kredit tersisa",
        "meidouCountModalTips": "Kredit yang akan kedaluwarsa digunakan terlebih dahulu.",
        "meidouCountModalTips1": "Tentang Kredit",
        "meidouCountModalEmpty": "Tidak ada kredit. Beli sekarang!",
        "meidouCountModalBtn": "OK",
        "meidouCountModalPermanent": "Valid permanen",
        "meidouCountModalExpired": "Berakhir dalam ${0} hari",
        "creditTransactionDetails": "Gambaran Umum Kredit",
        "deductionTipsIntl": "Perlu menggunakan ${0} kredit",
        "deductionTips2Intl": "${0} kredit akan dipotong untuk pemrosesan ini. Anda ingin melanjutkan?",
        "autoDeductCredits": "Otomatis potong kredit",
        "generate": "Proses",
        "close": "Tutup",
        "creditsBalance": "Saldo Kredit",
        "whatAreCredits": "Apa itu kredit?",
        "usageDetail": "Detail penggunaan",
        "getMoreCredits": "Dapatkan Lebih Banyak Kredit"
    },
    "floatHelp": {
        "modalTitle": "Asisten Meitu",
        "businessTitle": "Konsultasi online",
        "communityText1": "Gunakan WeChat atau Wecom untuk memindai kode QR dan bergabung",
        "communityText2": "Bergabung [Grup Pengguna X-Design]",
        "communityText3": "Sebagai pengguna versi beta awal, masukan Anda sangat penting. Sampaikan pendapat Anda kepada kami.",
        "feedbackTitle": "Masukan"
    },
    "designCreater": {
        "tab1": "Buat",
        "tab2": "Unggah",
        "uploadFail": "Gagal mengunggah",
        "uploadDragTips": 'Klik tombol "Unggah" atau seret dan lepaskan di sini',
        "uploadBtn": "Unggah",
        "uploadTips": "Tips: Sebaiknya unggah gambar JPG atau PNG dengan ukuran maks 20 MB.",
        "unitPxText": "Piksel",
        "unitMmText": "mm",
        "unitCmText": "cm",
        "sizeMinText": "Lebih kecil dari ukuran minimal ${0} * ${1}",
        "sizeMaxText": "Melampaui ukuran maksimal ${0} * ${1}",
        "createBtn": "Buat",
        "widthText": "P",
        "widthText1": "P",
        "heightText": "L",
        "heightText1": "L",
        "customText": "Kustom",
        "uploadDragTips_v2": "Unggah atau seret foto di sini",
        "uploadBtn_v2": "Unggah",
        "uploadTips_v2": "Mendukung gambar JPG dan PNG berukuran maks 20 MB",
        "sizeMinText_v2": "Lebih kecil dari ukuran minimal ${0} * ${1} ${2}",
        "sizeMaxText_v2": "Melampaui ukuran maksimal ${0} * ${1} ${2}",
        "canvasSize": "Ukuran kanvas",
        "canvasBackground": "Background"
    },
    "space": {
        "onlyU": "Hanya Anda",
        "anyone": "Semua yang punya tautan",
        "viewAble": "Lihat",
        "editAble": "Edit",
        "viewAble2": "Kunjungi",
        "shareTitle": "Bagikan kreasi Anda",
        "copyLink": "Salin tautan",
        "copied": "Disalin"
    },
    "imageBatchUpload": {
        "buttonText": "Unggah",
        "uploadDirText": "Folder unggahan >",
        "buttonDescription": "Rekatkan atau seret gambar atau URL di sini.",
        "buttonDescription1": "Proses massal hingga ${0} foto",
        "batchButtonText": "Unggah massal",
        "upperUploadLimit": "Anda dapat mengunggah maksimal ${0} foto",
        "errTipTitle": "Unggahan melebihi batas ukuran atau format file salah",
        "errTipSubTitle": "Unggah ${1} gambar maks ${0} MB.",
        "maxValueAndSize": "Hanya mendukung gambar berukuran maks ${0} MB",
        "maxWidthAndHeight": "Hanya mendukung gambar berukuran maks ${0} px PxL",
        "errTipUpload": "Unggah",
        "errTipConfirm": "Mengerti",
        "getFormatText": "Saat ini hanya mendukung format gambar ${0}",
        "heicResolveFailed": "Gagal memuat gambar HEIC. Sebaiknya konversi ke format lain sebelum mengunggah.",
        "imageUploadFailed": "Gagal mengunggah",
        "cvDescription": "Rekatkan gambar",
        "demoDesc": "Cobalah salah satu"
    },
    "logo": {
        "homeTip": "Klik untuk kembali ke beranda",
        "toolTip": "Seret logo X-Design ke bilah bookmark untuk memudahkan akses."
    },
    "cutoutInfo": {
        "remainingText": "Jumlah pemotongan tersisa",
        "openText": "Berlangganan",
        "rechargeText": "Isi ulang",
        "emptyText": "Isi ulang"
    },
    "textFontFamily": {
        "empty": "Tidak ada konten",
        "changeSearchWord": "Coba istilah pencarian lain",
        "fontFamily": "Fon",
        "searchFont": "Cari fon",
        "buyVipEnjoyFontFamily": "Gratis untuk penggunaan komersial",
        "currentFontFamily": "Fon yang digunakan di templat ini"
    },
    "infiniteScroll": {
        "loading": "Memuat..."
    },
    "colorGroup": {
        "emptyText": "Kosong",
        "upgradeTeamEdition": "Upgrade",
        "systemColor": "Warna sistem",
        "teamColor": "Kartu warna merek",
        "cover": "Isi",
        "repeat": "Ubin",
        "fillingMode": "Mode tampilan",
        "recommendedTexture": "Disarankan",
        "uploadImage": "Unggah",
        "replaceImage": "Ganti"
    },
    "downloadBtn": {
        "downloadBtnTxt": "Unduh",
        "modalTitle": "Unduh",
        "editMoreTitle": "Editing Lanjutan",
        "downloadNow": "Unduh",
        "addTxt": "Tambah Teks",
        "addMaterial": "Tambah Elemen",
        "eraser": "Penghapus",
        "cutout": "Penghapus Background",
        "quality": "Penyempurna Foto",
        "editMore": "Editor Foto",
        "customSize": "Kustom",
        "customSizeInputTips": "Masukkan batasan ukuran",
        "customSizeError": "Masukkan ukuran file",
        "processing": "Memproses...",
        "aicp": "AI Background",
        "upscale": "Upscale"
    },
    "interceptModal": {
        "title": "Izinkan jendela pop-up untuk X-Design.",
        "desc": "Izinkan X-Design membuka beberapa jendela di browser.",
        "stepTitle": "Langkah ${0}",
        "btnText": "Mengerti",
        "firstStep": "Klik peringatan pemblokiran yang muncul di kanan atas browser",
        "secondStep": 'Klik "Always allow pop-ups and redirects" (Selalu izinkan pop-up dan pengalihan).',
        "thirdStep": 'Klik "Done" (Selesai) untuk mulai menggunakan X-Design.',
        "xDesignTitle": "Izinkan jendela pop-up untuk X-Design.",
        "xDesignDesc": "Izinkan X-Design membuka beberapa jendela di browser.",
        "xDesignThirdStep": 'Klik "Done" (Selesai) untuk mulai menggunakan X-Design.',
        "safariFirstStep": "Klik bilah menu di kiri > Safari, lalu pilih designkit.com.",
        "safariSecondStep": "Di jendela pop-up, pilih “Pop-up” > “Allow” (Izinkan) untuk mengakses fitur X-Design."
    },
    "workListPanel": {
        "history": "Kreasi",
        "upload": "Unggah",
        "failed": "Gagal",
        "pending": "Memuat...",
        "cancelText": "Batal",
        "confirmText": "Konfirmasi",
        "deleteText": "Setelah dihapus, hasil yang dibuat akan hilang. Anda yakin ingin menghapus?",
        "generating": "Memproses"
    },
    "feedbackVoting": {
        "defaultText": "Nilai hasil",
        "thanks": "Terima kasih atas masukan Anda.",
        "modalTitle": "Masukan",
        "modalDesc": "Masukan Anda akan membantu meningkatkan layanan kami.",
        "modalIpt": "Jelaskan pada bagian mana Anda tidak puas",
        "iptMaxLength": "Konten melampaui batas. Dibatasi maksimal ${0} karakter atau hubungi layanan pelanggan.",
        "cancel": "Tutup",
        "submit": "Kirim",
        "other": "Lainnya"
    },
    "newDesignCreater": {
        "title": "Buat kanvas kosong",
        "allCategory": "Semua",
        "openImage": "Unggah",
        "openFile": "File",
        "pleaseInputSize": "Masukkan ukuran",
        "categorySection": {
            "lookMore": "Lainnya",
            "canvasSize": {
                "create": "Buat"
            }
        },
        "create": "Buat",
        "commonSize": "Ukuran umum"
    },
    "psdModal": {
        "uploadTemplate": "Unggah",
        "uploadFile": "Unggah",
        "uploadSuccess": "Diunggah",
        "uploadFailed": "Gagal mengunggah",
        "uploadPSD": "Unggah PSD"
    },
    "userPolicy": {
        "btnTomorrow": "Lain kali",
        "btnVip": "Perbarui Sekarang",
        "btnMy": "Dapatkan Lebih Banyak Kredit",
        "buyVip": "Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!",
        "buyMy": "Uji coba sudah maksimal. Dapatkan lebih banyak kredit untuk melanjutkan!",
        "buyVipOrBackTomorrow": "Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!",
        "backTomorrow": "Uji coba harian sudah maksimal. Daftar VIP untuk akses sepuasnya!",
        "trialLimitReached": "Uji Coba Sudah Maksimal"
    },
    "batchTaskList": {
        "loading": "Memuat",
        "fail": "Pemrosesan gagal",
        "batchEdit": "Teks massal",
        "upload": "Unggah Lainnya"
    },
    "userReviews": {
        "hello": "Hai ${0},",
        "wordsOfThanks": "Terima kasih telah menggunakan X-Design!",
        "desc": "Masukan Anda sangat berarti bagi kami. Jika Anda suka X-Design, kami akan sangat berterima kasih jika Anda bisa memberikan ulasan di Trustpilot untuk membantu kami memperbaiki dan meningkatkan layanan.",
        "leave": "Tulis Ulasan"
    },
    "aih5DownloadBtn": {
        "signInText": "Masuk",
        "fullQualityText": "Kualitas Penuh",
        "previewText": "Pratinjau",
        "freeText": "Bebas",
        "downloadText": "Unduh",
        "fullQualityLimitReached": "Kualitas penuh sudah maksimal. Silakan kembali besok.",
        "todayLimitReached": "Batasan harian tercapai. Kembali lagi besok atau upgrade sekarang."
    },
    "navVipEntrance": {
        "getFreePro": "Dapatkan Pro Gratis",
        "unlockPro": "Dapatkan Pro",
        "renewNow": "Perpanjang Sekarang",
        "upgradeToPro": "Upgrade ke Pro"
    }
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/projectA/pt-BR.js
/* harmony default export */ const projectA_pt_BR = ({
    "brandSDK": {
        "bgInput": {
            "placeholder": "Descreva o conceito da sua marca, o setor e suas prefer\xeancias de estilo."
        },
        "brandCard": {
            "nameLimitTip": "Insira um nome (at\xe9 10 caracteres)"
        },
        "delBrandSureModal": {
            "okText": "Confirmar",
            "cancelText": "Cancelar",
            "title": "Apagar este kit de marca?",
            "message": "Os projetos aplicados n\xe3o ser\xe3o afetados."
        },
        "brandList": {
            "createBrandText": "Adicionar",
            "emptyText": "Vazio"
        },
        "logoCard": {
            "coverCornerText1": "Capa",
            "coverCornerText2": "Logotipo principal",
            "delSureModal": {
                "okText": "Confirmar",
                "cancelText": "Cancelar",
                "title": "Excluir este logotipo?"
            },
            "nameLimitTip": "Insira um nome (at\xe9 ${0} caracteres)",
            "replaceText": "Substituir"
        },
        "colorList": {
            "countLimitTip": "Adicione at\xe9 ${0} cor(es) a cada paleta de cores"
        },
        "colorCard": {
            "colorCountLimitTip": "Adicione at\xe9 ${0} cor(es) a cada paleta de cores",
            "nameLimitTip": "Insira um nome (at\xe9 ${0} caracteres)",
            "nameInputPlaceholder": "Insira um nome (at\xe9 ${0} caracteres)",
            "colorEmptyText": "Vazio"
        },
        "page": {
            "brandStandards": "Kit de marca",
            "createStandard": "Adicionar",
            "createBrand": "Kit de marca"
        },
        "editBrand": {
            "sections": {
                "logo": "Logotipos",
                "colorCard": "Sistemas de cores",
                "textStyle": "Estilos de texto",
                "template": "Modelos",
                "primaryColor": "Cor principal",
                "secondaryColor": "Cor secund\xe1ria"
            },
            "brandBackground": "Descri\xe7\xe3o da marca",
            "nameLimitTip": "Insira um nome (at\xe9 10 caracteres)",
            "saveLastStyle": "Salve as altera\xe7\xf5es para continuar",
            "saveLastColorCard": "Salve as altera\xe7\xf5es para continuar",
            "saveLastElement": "Salve as altera\xe7\xf5es para continuar",
            "addColorCard": "Adicionar novo",
            "addStyle": "Adicionar novo",
            "addPrimaryColor": "Adicionar cor principal",
            "addSecondaryColor": "Adicionar cor secund\xe1ria",
            "bgInput": {
                "openBtnText": "Expandir",
                "foldBtnText": "Recolher",
                "title": "Guia de estilo"
            },
            "addPrimaryLogo": "Adicionar logotipo principal"
        },
        "textCard": {
            "nameLimitTip": "Insira um nome (at\xe9 ${0} caracteres)",
            "selectFont": "Selecione uma fonte",
            "selectFontSize": "Selecione o tamanho da fonte",
            "fontSizePlaceholder": "Tamanho",
            "save": "Salvar",
            "bold": "Negrito",
            "standard": "Padr\xe3o",
            "italic": "It\xe1lico",
            "defaultCategoryName": "Geral"
        },
        "templateCard": {
            "delSureModal": {
                "title": "Excluir este modelo?",
                "okText": "Confirmar",
                "cancelText": "Cancelar"
            },
            "nameLimitTip": "Insira um nome (at\xe9 ${0} caracteres)",
            "defaultName": "Modelos"
        },
        "selectBrandElementModal": {
            "brandAssets": "Kit de marca",
            "localUpload": "Carregar a partir do dispositivo",
            "brandLogo": "Logotipos",
            "brandTemplate": "Modelos",
            "uploadImage": "Carregar",
            "uploadDragTips": "Carregue ou solte a imagem aqui",
            "uploadTips": "Carregue at\xe9 ${1} imagens JPG ou PNG (m\xe1ximo de ${0} MB cada)"
        },
        "tooltip": {
            "message": "O recurso Cartaz da Marca j\xe1 est\xe1 dispon\xedvel!",
            "desc": "Carregue os cartazes da sua marca e deixe o Agente de IA dar uma olhada. Ele aprender\xe1 o seu estilo e criar\xe1 visuais futuros que combinam com a sua marca!"
        }
    },
    "satisfaction": {
        "effectSatisfaction": "Satisfa\xe7\xe3o",
        "noWarn": "N\xe3o mostrar novamente",
        "dissatisfied": "Insatisfa\xe7\xe3o",
        "normal": "Neutral",
        "satisfied": "Satisfeito/a",
        "placeholder": "Insira o feedback (limite de 200 caracteres)",
        "submitBtn": "Enviar"
    },
    "userInfo": {
        "notVipTip": "A assinatura do X-Design Pro concede acesso a diversos elementos e recursos protegidos por direitos autorais.",
        "notLoginText": "Voc\xea ainda n\xe3o \xe9 assinante",
        "businessText": "Consulta online",
        "feedbackText": "Feedback",
        "downloadText": "Baixar aplicativo",
        "settingText": "Configura\xe7\xf5es",
        "loginText": "Entrar",
        "copyText": "Copiar",
        "svipExpires": "Data de expira\xe7\xe3o do X-Design Pro: ${0}",
        "renewalText": "Renovar",
        "openText": "Assinar",
        "tips": "Aproveite o uso comercial sem preocupa\xe7\xf5es de obras protegidas por direitos autorais durante o per\xedodo de sua assinatura.",
        "logoutText": "Sair",
        "lightText": "Claro",
        "dartText": "Escuro",
        "teamExpires": "A assinatura de equipe expira em: ${0}",
        "teamNotVipTitle": "Inscreva-se na Assinatura de equipe",
        "teamNotVipTip": "Aproveite os benef\xedcios exclusivos da associa\xe7\xe3o e a colabora\xe7\xe3o em equipe",
        "teamExpiresDays": "Sua assinatura de equipe expirou h\xe1 ${0} dias",
        "copySuccess": "Copiado!",
        "notVipTipTitle": "Torne-se membro para acessar todos os recursos e ferramentas de design",
        "notVipTipSubscript": "Direitos comerciais cobertos",
        "teamVersion": "Equipe",
        "personalVersion": "Pessoal",
        "vipExpiresDays": "Sua assinatura expirou h\xe1 ${0} dias.",
        "countAmount": "Valor de recorte ",
        "meidouAmount": "Cr\xe9ditos",
        "owner": "Superadministrador ",
        "admin": "Administrador",
        "vipValidUntil": "Expira em: ${0}",
        "teamNotVipTip2": "Experimente os benef\xedcios SVIP e recursos exclusivos",
        "enterpriseVersion": "Empresa",
        "freeTeamVersion": "Gratuito",
        "initialFreeDesc": "Torne-se membro para acessar todos os recursos e ferramentas de design",
        "initialFreeTeamDesc": "Assine para compartilhar recursos e ferramentas de equipe",
        "languageSwitch": "Idioma",
        "pro": "Pro",
        "renewOn": "Renovar agora",
        "tryProForFree": "Experimente a vers\xe3o Pro gratuitamente",
        "expiresOn": "Expira em",
        "upgradeToPro": "Atualizar para Pro",
        "credit": "Cr\xe9dito",
        "manageSubscriptions": "Gerenciar Assinaturas",
        "termsAndPolicies": "Termos e Pol\xedticas",
        "benefitsUpgraded": "Benef\xedcios atualizados",
        "deductionTipsIntl": "Precisa consumir ${0} cr\xe9ditos",
        "deductionTips2Intl": "${0} cr\xe9ditos ser\xe3o deduzidos para esta gera\xe7\xe3o. Deseja continuar?",
        "autoDeductCredits": "Deduzir cr\xe9ditos automaticamente",
        "generate": "Gerar",
        "close": "Fechar",
        "basic": "B\xe1sico"
    },
    "utils": {
        "requestErrorText": "Erro de rede. N\xe3o foi poss\xedvel conectar-se ao servidor."
    },
    "upload": {
        "errorText": "Falha ao carregar",
        "cancelText": "Cancelar",
        "uploadingText": "Carregando...",
        "fileText": "Arquivo",
        "picText": "Imagens",
        "blockText": "Carregamento cancelado",
        "cancelUploadText": "Cancelar carregamento",
        "maxLengthTips": "Voc\xea pode carregar at\xe9 20 imagens ao mesmo tempo.",
        "formatFailTips": "Falha ao carregar ${0} imagens. Atualmente, apenas imagens nos formatos ${1} s\xe3o suportadas.",
        "formatFailTips1": "Por enquanto, s\xf3 suporta imagens no formato ${0}",
        "formatFailTips2": "Falha ao carregar ${0} imagens. Atualmente, apenas imagens nos formatos JPG, JPEG e PNG s\xe3o suportadas.",
        "sizeFailTips": "Falha ao carregar ${0}imagens. Certifique-se de que cada imagem tenha menos de 20 MB e n\xe3o exceda 8000\xd78000 pixels.",
        "sizeFailTips1": "Certifique-se de que cada imagem tenha menos de 20 MB e n\xe3o exceda 8000\xd78000 pixels.",
        "widthHeightFailTips": "Suporta apenas imagens com 8000 px (altura e largura)",
        "sizeFailTips2": "Suporta apenas imagens at\xe9 ${0} MB"
    },
    "meidouInfo": {
        "emptyText": "Recarregar",
        "buyText": "Comprar plano de cr\xe9ditos",
        "openText": "Assinar",
        "rechargeText": "Recarregar",
        "remainingText": "Meus cr\xe9ditos",
        "tips1": "Priorize o consumo dos cr\xe9ditos que est\xe3o prestes a expirar.",
        "tips2": "Os cr\xe9ditos adquiridos nunca expiram",
        "tips3": "Incluindo ${0} cr\xe9ditos pagos com validade permanente.",
        "tips4": "Os cr\xe9ditos ser\xe3o deduzidos automaticamente a cada gera\xe7\xe3o.",
        "detailText": "Detalhes",
        "whatIsMeidou": "O que s\xe3o os cr\xe9ditos?",
        "giftTips": "40 cr\xe9ditos adicionados \xe0 sua conta!",
        "giftTips1": "Expira no final do dia de hoje. N\xe3o se esque\xe7a de us\xe1-los!",
        "genText": "Gerar",
        "deductionTips": "${0} cr\xe9ditos ser\xe3o deduzidos para esta gera\xe7\xe3o. Deseja continuar?",
        "genBtnText": "Gerar",
        "inadequateTips": "Cr\xe9ditos insuficientes. Por favor, recarregue pelo menos ${0} cr\xe9ditos primeiro.",
        "tryTimes": "Per\xedodos de avalia\xe7\xe3o ${0} /${1}",
        "meidouCountModalTitle": "Cr\xe9ditos restantes",
        "meidouCountModalTips": "Os cr\xe9ditos que estiverem expirando ser\xe3o usados primeiro.",
        "meidouCountModalTips1": "Sobre os cr\xe9ditos",
        "meidouCountModalEmpty": "Sem cr\xe9ditos. Compre agora mesmo!",
        "meidouCountModalBtn": "OK",
        "meidouCountModalPermanent": "Validade permanente",
        "meidouCountModalExpired": "Expira em ${0} dia(s)",
        "creditTransactionDetails": "Vis\xe3o geral do cr\xe9dito",
        "deductionTipsIntl": "Precisa consumir ${0} cr\xe9ditos",
        "deductionTips2Intl": "${0} cr\xe9ditos ser\xe3o deduzidos por esta gera\xe7\xe3o. Deseja continuar?",
        "autoDeductCredits": "Deduzir cr\xe9ditos automaticamente",
        "generate": "Gerar",
        "close": "Fechar",
        "creditsBalance": "Balan\xe7o de cr\xe9ditos",
        "whatAreCredits": "O que s\xe3o os cr\xe9ditos?",
        "usageDetail": "Detalhes de uso",
        "getMoreCredits": "Obter mais cr\xe9ditos"
    },
    "floatHelp": {
        "modalTitle": "Assistente Meitu",
        "businessTitle": "Consulta online",
        "communityText1": "Use WeChat ou Wecom para escanear o c\xf3digo QR e ingressar",
        "communityText2": "Junte-se ao [Grupo de Usu\xe1rios X-Design]",
        "communityText3": "Como um dos primeiros usu\xe1rios beta, sua opini\xe3o \xe9 fundamental. Compartilhe suas ideias conosco.",
        "feedbackTitle": "Feedback"
    },
    "designCreater": {
        "tab1": "Criar",
        "tab2": "Carregar",
        "uploadFail": "Falha ao carregar",
        "uploadDragTips": "Clique no bot\xe3o “Carregar” ou arraste e solte aqui",
        "uploadBtn": "Carregar",
        "uploadTips": "Dicas: Recomendamos enviar imagens JPG ou PNG com tamanho inferior a 20 MB.",
        "unitPxText": "Pixels",
        "unitMmText": "mm",
        "unitCmText": "cm",
        "sizeMinText": "Menor que o tamanho exigido de ${0} * ${1}",
        "sizeMaxText": "Excede o tamanho exigido de ${0} * ${1}",
        "createBtn": "Criar",
        "widthText": "b",
        "widthText1": "b",
        "heightText": "h",
        "heightText1": "h",
        "customText": "Personalizar",
        "uploadDragTips_v2": "Carregue ou solte imagens aqui",
        "uploadBtn_v2": "Carregar",
        "uploadTips_v2": "Imagens JPG e PNG com tamanho inferior a 20 MB s\xe3o suportadas",
        "sizeMinText_v2": "Menor que o tamanho exigido de ${0} * ${1} ${2}",
        "sizeMaxText_v2": "Excede o tamanho exigido de ${0} * ${1} ${2}",
        "canvasSize": "Tamanho da tela",
        "canvasBackground": "Fundo"
    },
    "space": {
        "onlyU": "Somente voc\xea",
        "anyone": "Qualquer pessoa com o link",
        "viewAble": "Visualizar",
        "editAble": "Editar",
        "viewAble2": "Visitar",
        "shareTitle": "Compartilhar sua cria\xe7\xe3o  ",
        "copyLink": "Copiar link",
        "copied": "Copiado"
    },
    "imageBatchUpload": {
        "buttonText": "Carregar",
        "uploadDirText": "Carregar pasta >",
        "buttonDescription": "Cole ou arraste uma imagem ou URL aqui.",
        "buttonDescription1": "Processe em lote at\xe9 ${0} imagens",
        "batchButtonText": "Carregar em lote",
        "upperUploadLimit": "Voc\xea pode carregar at\xe9 ${0} imagens",
        "errTipTitle": "Os arquivos excedem os limites de carregamento ou est\xe3o fora do formato",
        "errTipSubTitle": "Por favor, carregue ${1} imagens com tamanho m\xe1ximo de ${0} MB.",
        "maxValueAndSize": "Suporta apenas imagens com tamanho m\xe1ximo de arquivo de ${0} MB",
        "maxWidthAndHeight": "Suporta apenas imagens com at\xe9 ${0} px em ambos os lados",
        "errTipUpload": "Carregar",
        "errTipConfirm": "Entendi",
        "getFormatText": "Por enquanto, s\xf3 suporta imagens no formato ${0}",
        "heicResolveFailed": "Falha ao carregar a imagem HEIC. Recomendamos convert\xea-la para outro formato antes de fazer o upload.",
        "imageUploadFailed": "Falha ao carregar",
        "cvDescription": "Colar imagem",
        "demoDesc": "Experimente uma destas op\xe7\xf5es"
    },
    "logo": {
        "homeTip": "Clique para ir para a p\xe1gina inicial",
        "toolTip": "Arraste o logotipo do X-Design para a barra de favoritos a fim de facilitar o acesso no futuro."
    },
    "cutoutInfo": {
        "remainingText": "N\xfamero restante de recortes",
        "openText": "Assinar",
        "rechargeText": "Recarregar",
        "emptyText": "Recarregar"
    },
    "textFontFamily": {
        "empty": "Nenhum conte\xfado",
        "changeSearchWord": "Tente usar um termo de busca diferente",
        "fontFamily": "Fonte",
        "searchFont": "Procurar fonte",
        "buyVipEnjoyFontFamily": "Gratuito para uso comercial",
        "currentFontFamily": "Fontes utilizadas neste modelo"
    },
    "infiniteScroll": {
        "loading": "Carregando..."
    },
    "colorGroup": {
        "emptyText": "Vazio",
        "upgradeTeamEdition": "Atualizar",
        "systemColor": "Cor do sistema",
        "teamColor": "Cart\xe3o de cores da marca",
        "cover": "Preencher",
        "repeat": "Aplica\xe7\xe3o de azulejos",
        "fillingMode": "Modo de exibi\xe7\xe3o",
        "recommendedTexture": "Recomendado",
        "uploadImage": "Carregar",
        "replaceImage": "Substituir"
    },
    "downloadBtn": {
        "downloadBtnTxt": "Baixar",
        "modalTitle": "Baixar",
        "editMoreTitle": "Edi\xe7\xe3o avan\xe7ada",
        "downloadNow": "Baixar",
        "addTxt": "Adicionar texto",
        "addMaterial": "Adicionar elemento",
        "eraser": "Borracha",
        "cutout": "Removedor de fundo",
        "quality": "Aprimorador de imagens",
        "editMore": "Editor de fotos",
        "customSize": "Personalizado",
        "customSizeInputTips": "Insira o limite de tamanho",
        "customSizeError": "Insira o tamanho do arquivo",
        "processing": "Processando...",
        "aicp": "Gerador de fundo com IA",
        "upscale": "Aumentador de resolu\xe7\xe3o de imagem"
    },
    "interceptModal": {
        "title": "Permitir janelas pop-up para o X-Design.",
        "desc": "Autorize o X-Design a abrir v\xe1rias janelas no seu navegador.",
        "stepTitle": "Passo ${0}",
        "btnText": "Entendi",
        "firstStep": "Clique no alerta de bloqueio que aparece no canto superior direito do seu navegador",
        "secondStep": "Clique em “Sempre permitir pop-ups e redirecionamentos”.",
        "thirdStep": "Clique em “Conclu\xeddo” para come\xe7ar a usar o X-Design.",
        "xDesignTitle": "Permitir janelas pop-up para o X-Design.",
        "xDesignDesc": "Autorize o X-Design a abrir v\xe1rias janelas no seu navegador.",
        "xDesignThirdStep": "Clique em “Conclu\xeddo” para come\xe7ar a usar o X-Design.",
        "safariFirstStep": "Clique na barra de menus \xe0 esquerda > Safari e selecione designkit.com.",
        "safariSecondStep": "Na janela pop-up, selecione “Pop-ups” > “Permitir” para acessar os recursos do X-Design sem problemas."
    },
    "workListPanel": {
        "history": "Cria\xe7\xf5es",
        "upload": "Carregar",
        "failed": "Falhou",
        "pending": "Carregando...",
        "cancelText": "Cancelar",
        "confirmText": "Confirmar",
        "deleteText": "Ap\xf3s a exclus\xe3o, os resultados gerados ser\xe3o perdidos. Tem certeza de que deseja excluir?",
        "generating": "Gerando"
    },
    "feedbackVoting": {
        "defaultText": "Avalie o resultado",
        "thanks": "Agradecemos pelo seu feedback.",
        "modalTitle": "Feedback",
        "modalDesc": "Seus coment\xe1rios nos ajudar\xe3o a melhorar nosso servi\xe7o.",
        "modalIpt": "Descreva qual parte voc\xea n\xe3o est\xe1 satisfeito.",
        "iptMaxLength": "O conte\xfado excede o limite. Mantenha-o abaixo de ${0} caracteres ou entre em contato com o atendimento ao cliente.",
        "cancel": "Fechar",
        "submit": "Enviar",
        "other": "Outros"
    },
    "newDesignCreater": {
        "title": "Criar tela em branco",
        "allCategory": "Tudo",
        "openImage": "Carregar",
        "openFile": "Arquivo",
        "pleaseInputSize": "Insira o tamanho",
        "categorySection": {
            "lookMore": "Mais",
            "canvasSize": {
                "create": "Criar"
            }
        },
        "create": "Criar",
        "commonSize": "Tamanho padr\xe3o"
    },
    "psdModal": {
        "uploadTemplate": "Carregar",
        "uploadFile": "Carregar",
        "uploadSuccess": "Carregado",
        "uploadFailed": "Falha ao carregar",
        "uploadPSD": "Carregar PSD"
    },
    "userPolicy": {
        "btnTomorrow": "Agora n\xe3o",
        "btnVip": "Atualizar agora",
        "btnMy": "Obter mais cr\xe9ditos",
        "buyVip": "Limite di\xe1rio de teste atingido. Torne-se VIP para ter acesso ilimitado!",
        "buyMy": "Voc\xea atingiu o limite da sua vers\xe3o de teste. Adquira mais cr\xe9ditos para continuar!",
        "buyVipOrBackTomorrow": "Limite di\xe1rio de teste atingido. Torne-se VIP para ter acesso ilimitado!",
        "backTomorrow": "Limite di\xe1rio de teste atingido. Torne-se VIP para ter acesso ilimitado!",
        "trialLimitReached": "Limite de avalia\xe7\xe3o atingido"
    },
    "batchTaskList": {
        "loading": "Carregando",
        "fail": "Falha na gera\xe7\xe3o",
        "batchEdit": "Editar lote",
        "upload": "Carregar mais"
    },
    "userReviews": {
        "hello": "Ol\xe1 ${0},",
        "wordsOfThanks": "Agradecemos por fazer parte do X-Design!",
        "desc": "A sua opini\xe3o \xe9 muito importante para n\xf3s. Se voc\xea est\xe1 gostando do X-Design, adorar\xedamos que deixasse uma avalia\xe7\xe3o no Trustpilot — isso nos ajuda muito a crescer e melhorar.",
        "leave": "Deixe uma avalia\xe7\xe3o"
    },
    "aih5DownloadBtn": {
        "signInText": "Fazer login",
        "fullQualityText": "Qualidade total",
        "previewText": "Pr\xe9-visualizar",
        "freeText": "Gratuito",
        "downloadText": "Baixar",
        "fullQualityLimitReached": "Limite de qualidade total atingido. Volte amanh\xe3.",
        "todayLimitReached": "Limite di\xe1rio atingido. Volte amanh\xe3 ou fa\xe7a um upgrade agora."
    },
    "navVipEntrance": {
        "getFreePro": "Obtenha o Pro gratuitamente",
        "unlockPro": "Desbloquear Pro",
        "renewNow": "Renovar Agora",
        "upgradeToPro": "Atualizar para Pro"
    }
});

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/locales/zh-Hans.js
/* harmony default export */ const locales_zh_Hans = ({
    "satisfaction": {
        "effectSatisfaction": "效果满意度",
        "noWarn": "不再提醒",
        "dissatisfied": "不满意",
        "normal": "一般",
        "satisfied": "满意",
        "placeholder": "请输入您的建议(200字内)",
        "submitBtn": "提交"
    },
    "userInfo": {
        "notVipTip": "开通会员SVIP享海量版权素材和功能权益",
        "notLoginText": "您还未开通会员",
        "businessText": "在线咨询",
        "feedbackText": "意见反馈",
        "downloadText": "下载客户端",
        "settingText": "设置",
        "loginText": "立即登录",
        "copyText": "复制",
        "svipExpires": "SVIP到期: ${0}",
        "renewalText": "立即续费",
        "openText": "立即开通",
        "tips": "会员期间享作品商用版权无忧",
        "logoutText": "退出登录",
        "lightText": "浅色",
        "dartText": "深色",
        "teamExpires": "团队会员到期: ${0}",
        "teamNotVipTitle": "开通团队版会员",
        "teamNotVipTip": "畅享会员权益与团队协作",
        "teamExpiresDays": "团队会员已过期${0}天",
        "copySuccess": "复制成功",
        "notVipTipTitle": "开通会员畅享全站设计资源和工具",
        "notVipTipSubscript": "商用版权无忧",
        "teamVersion": "团队版",
        "personalVersion": "个人版",
        "vipExpiresDays": "会员已过期${0}天",
        "countAmount": "张数",
        "meidouAmount": "美豆",
        "owner": "超级管理员",
        "admin": "管理员",
        "vipValidUntil": "有效期至: ${0}",
        "teamNotVipTip2": "畅享SVIP权益与团队专属功能",
        "enterpriseVersion": "企业版",
        "freeTeamVersion": "免费版",
        "initialFreeDesc": "开通会员畅享全站设计资源和工具",
        "initialFreeTeamDesc": "开通会员共享团队资源和协作工具",
        "languageSwitch": "语言",
        "pro": "Pro Plan",
        "plus": "Plus Plan",
        "renewOn": "续费",
        "tryProForFree": "免费体验pro版本",
        "expiresOn": "到期",
        "upgradeToPro": "升级到pro版本",
        "credit": "积分",
        "manageSubscriptions": "管理订阅",
        "termsAndPolicies": "条款与政策",
        "benefitsUpgraded": "权益已升级",
        "basic": "Basic",
        "startFreeTrial": "开始免费试用",
        "upgradeNow": "立即升级"
    },
    "utils": {
        "requestErrorText": "您的网络发生异常，无法连接服务器"
    },
    "upload": {
        "errorText": "图片上传失败",
        "cancelText": "取消",
        "uploadingText": "上传中",
        "fileText": "文件",
        "picText": "图片",
        "blockText": "上传过程中取消了上传",
        "cancelUploadText": "取消上传",
        "maxLengthTips": "最多允许同时上传20张图片",
        "formatFailTips": "${0}张图片上传失败，暂时只支持${1}格式的图片",
        "formatFailTips1": "暂时只支持${0}格式的图片",
        "formatFailTips2": "${0}张图片上传失败，暂时只支持JPG/JPEG/PNG格式的图片",
        "sizeFailTips": "${0}张图片上传失败，仅支持20M，宽高均为8000px以内的图片",
        "sizeFailTips1": "仅支持20M，宽高均为8000px以内的图片",
        "widthHeightFailTips": "仅支持宽高均为8000px以内的图片",
        "sizeFailTips2": "仅支持${0}M以内的图片"
    },
    "meidouInfo": {
        "emptyText": "充值",
        "buyText": "购买美豆套餐",
        "openText": "开通会员送美豆",
        "rechargeText": "立即充值",
        "remainingText": "我的美豆",
        "tips1": "优先消耗临期的美豆",
        "tips2": "付费美豆永久有效",
        "tips3": "含${0}个付费美豆，永久有效",
        "tips4": "每次生成后自动扣除美豆",
        "detailText": "美豆消耗明细",
        "whatIsMeidou": "什么是美豆",
        "giftTips": "Hi! 今日登录奖励40美豆已到账~",
        "giftTips1": "当天有效，尽快使用吧！",
        "genText": "生成",
        "deductionTips": "生成将扣除${0}美豆，是否生成？",
        "genBtnText": "去生成",
        "inadequateTips": "您的美豆数不足，请先至少充值${0}个美豆",
        "inadequateTipsForNoVip": "您的美豆数不足，可开通会员送美豆",
        "inadequateTipsForVip": "您的美豆数不足，请充值",
        "tryTimes": "试用次数${0}/${1}",
        "meidouCountModalTitle": "剩余美豆",
        "meidouCountModalTips": "优先消耗临期美豆",
        "meidouCountModalTips1": "美豆介绍 &gt;",
        "meidouCountModalEmpty": "没有美豆哦～请前往购买吧",
        "meidouCountModalBtn": "好的",
        "meidouCountModalPermanent": "永久有效",
        "meidouCountModalExpired": "${0}天过期",
        "creditTransactionDetails": "积分交易详情",
        "deductionTipsIntl": "需要消耗${0}积分",
        "deductionTips2Intl": "本次生成需要消耗${0}积分，您是否还要继续？",
        "autoDeductCredits": "自动扣除积分",
        "generate": "生成",
        "close": "关闭",
        "creditsBalance": "积分余额",
        "whatAreCredits": "什么是积分",
        "usageDetail": "使用详情",
        "getMoreCredits": "获取更多积分"
    },
    "floatHelp": {
        "modalTitle": "美图小助手",
        "businessTitle": "在线咨询",
        "communityText1": "使用微信或企业微信扫码加入",
        "communityText2": "加入【美图设计室AI用户群】",
        "communityText3": "作为首批内测用户，你的使用体验和反馈对我们非常重要，欢迎与我们交流你的想法或需求。",
        "feedbackTitle": "意见反馈"
    },
    "designCreater": {
        "tab1": "创建设计",
        "tab2": "打开图片",
        "uploadFail": "上传失败",
        "uploadDragTips": "点击“上传文件”按钮或拖放到这里",
        "uploadBtn": "上传文件",
        "uploadTips": "Tips:建议上传 200M以内 jpg、png 图片",
        "unitPxText": "像素",
        "unitMmText": "毫米",
        "unitCmText": "厘米",
        "sizeMinText": "低于画布尺寸${0} * ${1}",
        "sizeMaxText": "超出画布尺寸${0} * ${1}",
        "createBtn": "创建",
        "widthText": "宽度",
        "widthText1": "宽",
        "heightText": "高度",
        "heightText1": "高",
        "customText": "自定义尺寸",
        "uploadDragTips_v2": "点击/拖拽图片至此处",
        "uploadBtn_v2": "上传图片",
        "uploadTips_v2": "支持上传 20M以内 jpg、png 图片",
        "sizeMinText_v2": "低于画布尺寸限制：${0} * ${1} ${2}",
        "sizeMaxText_v2": "超出画布尺寸限制：${0} * ${1} ${2}",
        "canvasSize": "画布尺寸",
        "canvasBackground": "画布背景"
    },
    "space": {
        "onlyU": "仅你自己获得链接",
        "anyone": "任何获得链接的人",
        "viewAble": "可查看",
        "editAble": "可编辑",
        "viewAble2": "可访问",
        "shareTitle": "分享你的作品",
        "copyLink": "复制链接",
        "copied": "已复制"
    },
    "imageBatchUpload": {
        "buttonText": "上传图片",
        "uploadDirText": "上传文件夹 >",
        "buttonDescription": "粘贴图片、网址，或拖拽图片至此。",
        "buttonDescription1": "支持批量处理${0}张图片。",
        "batchButtonText": "批量上传",
        "upperUploadLimit": "批量模式最多支持${0}张图片",
        "errTipTitle": "以下文件超过上传限制或不符合格式",
        "errTipSubTitle": "请上传${0}M以内的${1}格式图片",
        "maxValueAndSize": "仅支持${0}M以内的图片",
        "maxWidthAndHeight": "仅支持宽高均为${0}px以内的图片",
        "errTipUpload": "上传图片",
        "errTipConfirm": "我知道了",
        "getFormatText": "暂时只支持${0}格式的图片",
        "heicResolveFailed": "HEIC图片解析失败，建议您转换为其他图片格式上传",
        "imageUploadFailed": "图片上传失败",
        "cvDescription": "粘贴图片",
        "demoDesc": "试试这些"
    },
    "logo": {
        "homeTip": "点击可以前往首页",
        "toolTip": "拖动Logo到书签栏，收藏美图设计室，打开更便捷～"
    },
    "cutoutInfo": {
        "remainingText": "剩余抠图张数",
        "openText": "立即开通",
        "rechargeText": "充值张数",
        "emptyText": "充值"
    },
    "textFontFamily": {
        "empty": "暂无内容",
        "changeSearchWord": "换个搜索词再试试",
        "fontFamily": "字体",
        "searchFont": "搜索字体",
        "buyVipEnjoyFontFamily": "开通会员，可免费商用该字体",
        "currentFontFamily": "当前模版使用的字体"
    },
    "infiniteScroll": {
        "loading": "玩命加载中..."
    },
    "colorGroup": {
        "emptyText": "空",
        "upgradeTeamEdition": "升级团队版",
        "systemColor": "系统颜色",
        "teamColor": "品牌色卡",
        "cover": "充满图框",
        "repeat": "平铺",
        "fillingMode": "填充方式",
        "recommendedTexture": "推荐图案",
        "uploadImage": "上传图片",
        "replaceImage": "替换图片"
    },
    "downloadBtn": {
        "downloadBtnTxt": "下载",
        "modalTitle": "下载",
        "editMoreTitle": "去更多功能中使用",
        "downloadNow": "立即下载",
        "addTxt": "添加文字",
        "addMaterial": "添加素材",
        "eraser": "消除笔",
        "cutout": "智能抠图",
        "quality": "变清晰",
        "editMore": "图片编辑",
        "customSize": "自定义大小",
        "customSizeInputTips": "输入限定大小",
        "customSizeError": "请填写文件大小",
        "processing": "处理中…",
        "aicp": "AI换背景",
        "upscale": "无损放大"
    },
    "interceptModal": {
        "title": "允许显示美图设计室弹出窗口",
        "desc": "你需要授权美图设计室在浏览器打开多个窗口。",
        "stepTitle": "第${0}步",
        "btnText": "我知道啦",
        "firstStep": "点击浏览器右侧顶部弹出的阻止程序图标。",
        "secondStep": "点击始终允许显示弹出式窗口和进行重定向。",
        "thirdStep": "点击完成按钮，即可正常使用美图设计室的功能啦～",
        "xDesignTitle": "允许显示美图设计室弹出窗口",
        "xDesignDesc": "你需要授权美图设计室在浏览器打开多个窗口。",
        "xDesignThirdStep": "点击完成按钮，即可正常使用美图设计室的功能啦～",
        "safariFirstStep": "点击左侧菜单栏-Safari浏览器, 选择designkit.com设置",
        "safariSecondStep": "在弹窗中选择【弹出式窗口】，点击【允许】即可正常使用美图设计室的功能啦~"
    },
    "workListPanel": {
        "history": "历史记录",
        "upload": "上传",
        "failed": "失败",
        "pending": "生成中",
        "cancelText": "取消",
        "confirmText": "确定",
        "deleteText": "删除后，此次生成结果将会丢失，确定删除吗？",
        "generating": "处理中"
    },
    "feedbackVoting": {
        "defaultText": "给这个结果评分",
        "thanks": "感谢您的反馈。",
        "modalTitle": "反馈详情",
        "modalDesc": "您的反馈将会帮助我们进一步优化美图设计室的AI功能",
        "modalIpt": "请详细描述您对结果不满意的原因",
        "iptMaxLength": "内容超出长度限制，输入字数最多为${0}。如需更多帮助，请联系客服。",
        "cancel": "关闭",
        "submit": "提交",
        "other": "其他"
    },
    "newDesignCreater": {
        "title": "创建设计",
        "allCategory": "全部",
        "openImage": "打开图片",
        "openFile": "打开文件",
        "pleaseInputSize": "请输入尺寸",
        "categorySection": {
            "lookMore": "查看更多",
            "canvasSize": {
                "create": "创建"
            }
        },
        "create": "创建",
        "commonSize": "常用尺寸"
    },
    "psdModal": {
        "uploadTemplate": "上传模板",
        "uploadFile": "上传文件",
        "uploadSuccess": "上传成功",
        "uploadFailed": "上传失败",
        "uploadPSD": "上传PSD"
    },
    "userPolicy": {
        "btnTomorrow": "明日再来",
        "btnVip": "立即开通",
        "btnMy": "立即获取",
        "buyVip": "今日试用次数已达上限，开通会员不受限。",
        "buyMy": "试用次数已达上限，充值美豆获得更多使用机会。",
        "buyVipOrBackTomorrow": "今日试用次数已达上限，开通会员不受限。",
        "backTomorrow": "今日试用次数已达上限，开通会员不受限。",
        "trialLimitReached": "试用已达上限"
    },
    "batchTaskList": {
        "loading": "加载中",
        "fail": "生成失败",
        "batchEdit": "批量编辑",
        "upload": "上传"
    },
    "navVipEntrance": {
        "getFreePro": "免费体验Pro版本",
        "unlockPro": "解锁Pro版本",
        "renewNow": "立即续费",
        "upgradeToPro": "升级到Pro版本",
        "upgradeForFree": "免费升级"
    },
    "brandSDK": {
        "bgInput": {
            "placeholder": "请简短描述你的品牌理念、服务行业、偏好风格"
        },
        "brandCard": {
            "nameLimitTip": "请输入10字内的名称"
        },
        "delBrandSureModal": {
            "okText": "确定",
            "cancelText": "取消",
            "title": "确认删除这个品牌资产吗？",
            "message": "已应用的作图记录不会受到影响"
        },
        "brandList": {
            "createBrandText": "创建品牌规范",
            "emptyText": "空"
        },
        "logoCard": {
            "coverCornerText1": "封面",
            "coverCornerText2": "主Logo",
            "delSureModal": {
                "okText": "确定",
                "cancelText": "取消",
                "title": "确定要删除该logo吗？"
            },
            "nameLimitTip": "请输入${0}字以内的名称",
            "replaceText": "替换"
        },
        "colorList": {
            "countLimitTip": "每套色卡仅支持添加${0}个色块"
        },
        "colorCard": {
            "colorCountLimitTip": "每套色卡仅支持添加${0}个色块",
            "nameLimitTip": "请输入${0}字以内的名称",
            "nameInputPlaceholder": "请输入${0}字以内的名称",
            "colorEmptyText": "空"
        },
        "page": {
            "brandStandards": "品牌规范",
            "createStandard": "创建规范",
            "createBrand": "品牌规范"
        },
        "editBrand": {
            "sections": {
                "logo": "logo",
                "colorCard": "色卡",
                "textStyle": "文字样式",
                "template": "模板",
                "reference": "Reference",
                "primaryColor": "主色",
                "secondaryColor": "辅助色"
            },
            "brandBackground": "你的品牌背景是？",
            "nameLimitTip": "请输入10字内的名称",
            "saveLastStyle": "请保存上个样式",
            "saveLastColorCard": "请保存上个色卡",
            "saveLastElement": "请先保存上个元素",
            "addColorCard": "新建色卡",
            "addStyle": "新建样式",
            "addPrimaryColor": "新建主色",
            "addSecondaryColor": "新建辅助色",
            "referenceDesc": "Upload your posters and favorite reference images — X-Design will learn their style to craft unique visual assets that reflect your taste.",
            "bgInput": {
                "openBtnText": "展开",
                "foldBtnText": "收起",
                "title": "设计指导"
            },
            "addPrimaryLogo": "新建主Logo"
        },
        "textCard": {
            "nameLimitTip": "请输入${0}字以内的名称",
            "selectFont": "请选择字体",
            "selectFontSize": "请选择字号大小",
            "fontSizePlaceholder": "字号",
            "save": "保存",
            "fontSize": "号",
            "bold": "粗体",
            "standard": "标准",
            "italic": "斜体",
            "defaultCategoryName": "通用"
        },
        "templateCard": {
            "delSureModal": {
                "title": "确认删除此项吗？",
                "okText": "确定",
                "cancelText": "取消"
            },
            "nameLimitTip": "请输入${0}字以内的名称",
            "defaultName": "品牌模板"
        },
        "selectBrandElementModal": {
            "brandAssets": "品牌资产",
            "localUpload": "本地上传",
            "brandLogo": "品牌logo",
            "brandTemplate": "品牌模板",
            "reference": "Reference",
            "uploadImage": "上传图片",
            "uploadDragTips": "点击/拖拽图片至此处",
            "uploadTips": "支持上传 ${0}M以内 jpg、png 图片，最多支持${1}张"
        },
        "tooltip": {
            "message": "品牌海报上线啦！",
            "desc": "上传你的海报，Agent将学习你的品牌调性，后续在对话中调用品牌库时可生成与品牌风格契合的海报～"
        }
    },
    "userReviews": {
        "hello": "你好${0}，",
        "wordsOfThanks": "感谢加入x-design",
        "desc": "你的反馈对我们非常重要。如果你喜欢x-design，欢迎您在Trustpilot上留下评论，我们将不胜感激。这可以帮助我们提升和成长",
        "leave": "去评价"
    },
    "aih5DownloadBtn": {
        "signInText": "登录",
        "fullQualityText": "大图",
        "previewText": "小图",
        "freeText": "免费",
        "downloadText": "下载",
        "fullQualityLimitReached": "今日高清图下载次数已用完",
        "todayLimitReached": "今日次数已用完，立即升级"
    }
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/createLocale.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function replacer(template, data) {
  var strTemplate = Array.isArray(template) ? template.join('') : template;
  var arrays = strTemplate.split(/(\${\d+})/);
  var results = [];
  for (var i = 0; i < arrays.length; i += 1) {
    var match = arrays[i].match(/^\$\{(\d+)\}$/);
    if (match) {
      var index = parseInt(match[1], 10);
      results.push(data[index]);
    } else {
      results.push(arrays[i]);
    }
  }
  return results;
}
function nodeReplacer(template, data) {
  return replacer(template, data);
}
function textReplacer(template, data) {
  return replacer(template, data).join('');
}
function textWrapper(template, data) {
  var strTemplate = Array.isArray(template) ? template.join('') : template;
  var arrays = strTemplate.split(/<>|<\/>/);
  var count = Math.floor(arrays.length / 2);
  var results = [];
  for (var i = 0; i < arrays.length; i += 1) {
    if (i % 2 === 1 && i <= count + 1) {
      var wrapper = data[(i - 1) / 2];
      results.push(wrapper ? wrapper(arrays[i]) : arrays[i]);
    } else {
      results.push(arrays[i]);
    }
  }
  return results;
}

/**
 * 解析 HTML 代码字符串为 HTML 节点对象
 *
 * @since 0.1.0
 * @param html - HTML 代码字符串
 */
function parseHtmlString(html) {
  var result = [];
  var regex = /<([a-z]+)([^>]*)>(.*?)<\/\1>/gi;
  var match;
  while ((match = regex.exec(html)) !== null) {
    var tagName = match[1].toLowerCase();
    var attributes = match[2];
    var content = match[3];
    var styleRegex = /style\s*=\s*"([^"]*)"/i;
    var styleMatch = attributes.match(styleRegex);
    var styleObj = {};
    if (styleMatch && styleMatch[1]) {
      var styles = styleMatch[1].split(';');
      var _iterator = _createForOfIteratorHelper(styles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var style = _step.value;
          if (style.trim()) {
            var colonIndex = style.indexOf(':');
            if (colonIndex > -1) {
              var key = style.substring(0, colonIndex).trim();
              var value = style.substring(colonIndex + 1).trim();
              if (key && value) {
                styleObj[key] = value;
              }
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    result.push({
      tag: tagName,
      props: {
        style: styleObj
      },
      children: [content]
    });
  }
  return result;
}

/**
 * HTML 标签节点替换方法
 *
 * @since 0.1.0
 * @param template - 模板
 * @param replacer - 替换方法
 */
function htmlReplacer(template, replacer) {
  return replacer(parseHtmlString(template));
}

/**
 * 创建多语言本地化翻译文本数据映射及替换方法
 *
 * @param textResource - 翻译文本源数据
 */
function createLocaleText(textResource) {
  return function (print) {
    if (!textResource) return '';
    try {
      return print(textResource, {
        r: textReplacer,
        w: textWrapper,
        n: nodeReplacer,
        h: htmlReplacer
      });
    } catch (_e) {
      return '';
    }
  };
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/context.js

var context_LocaleTextContext = /*#__PURE__*/(0,react.createContext)('');
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/useLocale.js


var localeInstance = '';
var getLocale = function getLocale() {
  return localeInstance;
};
var useLocale_setLocale = function setLocale(_locale) {
  localeInstance = _locale;
};
var useLocaleText = function useLocaleText() {
  var locale = (0,react.useContext)(context_LocaleTextContext) || getLocale();
  return locale;
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/LocaleProvider.js



function LocaleProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  return /*#__PURE__*/_jsx(LocaleTextContext.Provider, {
    value: locale,
    children: children
  });
}
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-i18n/lib/index.js




;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/i18n/index.js














var localeTextMap = {
    en: (0,lodash.merge)({}, zh_Hans, figma_en, en),
    cn: (0,lodash.merge)({}, figma_en, zh_Hans, locales_zh_Hans),
    "zh-Hans": (0,lodash.merge)({}, figma_en, zh_Hans, locales_zh_Hans),
    pt: (0,lodash.merge)({}, figma_en, en, pt_BR, projectA_pt_BR),
    es: (0,lodash.merge)({}, figma_en, en, es_MX, projectA_es_MX),
    de: (0,lodash.merge)({}, figma_en, en, de, projectA_de),
    id: (0,lodash.merge)({}, figma_en, en, id, projectA_id)
};
var localStoreCache = {};
var initLocaleStore = function initLocaleStore(locale) {
    setLocale(locale);
};
var getLocaleStore = function getLocaleStore(_locale) {
    var locale = _locale || getLocale() || "cn";
    var localeText = localeTextMap[locale];
    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale: locale,
            $t: createLocaleText(localeText)
        };
    }
    return localStoreCache[locale];
};
var useLocaleStore = function useLocaleStore() {
    var locale = useLocaleText();
    return getLocaleStore(locale);
};
/**
 * useLocaleStore 的别名，不再推荐使用
 */ var useLocale = useLocaleStore;


/***/ }),

/***/ 85776:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export createLoading */
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58509);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24996);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30341);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_4__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}





var createLoading = function createLoading() {
    var Loading = function Loading(props) {
        var tip = props.tip, _props$allowClickMask = props.allowClickMask, allowClickMask = _props$allowClickMask === void 0 ? false : _props$allowClickMask, className = props.className, style = props.style;
        (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
            (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .disableBodyScroll */ .Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return function() {
                return (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__/* .enableBodyScroll */ .tG)(document.body);
            };
        }, []);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("xdesign-loading", className),
            style: _objectSpread(_objectSpread({}, style), {}, {
                minWidth: tip ? 100 : "auto"
            })
        }, allowClickMask ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("style", {
            dangerouslySetInnerHTML: {
                __html: "html, body {\n                          user-select: none;\n                          pointer-events: none;\n                      }"
            }
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: "xdesign-loading__wrap"
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
            className: "xdesign-loading__content"
        })), tip ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            className: "xdesign-loading__tip"
        }, tip) : null);
    };
    var el = null;
    var show = function show(tip) {
        if (!el) {
            el = document.createElement("div");
        }
        document.body.appendChild(el);
        (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement(Loading, {
            tip: tip
        }), el);
    };
    var hidden = function hidden() {
        if (el && el.parentNode) {
            (0,rc_util_lib_React_render__WEBPACK_IMPORTED_MODULE_2__/* .unmount */ .vE)(el);
            el.parentNode.removeChild(el);
            el = null;
        }
    };
    Loading.show = show;
    Loading.hidden = hidden;
    return Loading;
};
var Loading = createLoading();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loading);


/***/ }),

/***/ 67890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": () => (/* binding */ modalLocalStorageKey),
/* harmony export */   "Tk": () => (/* binding */ bannerLocalStorageKey),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "rW": () => (/* binding */ modalDomesticLocalStorageKey)
/* harmony export */ });
// 定义功能路径的映射类型
// 功能路径映射表
var pathMappings = [
    {
        accessPath: "/",
        targetPath: "/",
        pageName: "home",
        project: "home"
    },
    // 官网
    {
        accessPath: "/tools",
        targetPath: "/tools",
        pageName: "404",
        project: "home"
    },
    // 工具页
    {
        accessPath: "/templates",
        targetPath: "/templates",
        pageName: "404",
        project: "home"
    },
    // 模版页
    {
        accessPath: "/space",
        targetPath: "/space",
        pageName: "404",
        project: "home"
    },
    // 我的空间
    {
        accessPath: "/share",
        targetPath: "/share",
        pageName: "404",
        project: "home"
    },
    // 与我分享
    {
        accessPath: "/editor",
        targetPath: "/editor",
        pageName: "tpbj",
        project: "tpbj"
    },
    // 图片编辑
    {
        accessPath: "/design",
        targetPath: "/design",
        pageName: "hbsj",
        project: "hbsj"
    },
    // 海报编辑
    {
        accessPath: "/aieraser",
        targetPath: "/aieraser",
        pageName: "znxc",
        project: "znxc"
    },
    // 消除
    {
        accessPath: "/quality",
        targetPath: "/quality",
        pageName: "hzxf",
        project: "hzxf"
    },
    // 变清晰
    {
        accessPath: "/upscale",
        targetPath: "/upscale",
        pageName: "upscale",
        project: "upscale"
    },
    // 无损改尺寸
    {
        accessPath: "/puzzle",
        targetPath: "/puzzle",
        pageName: "404",
        project: "pt"
    },
    // 拼图
    {
        accessPath: "/certified",
        targetPath: "/certified",
        pageName: "404",
        project: "zjzsj"
    },
    // 证件照
    {
        accessPath: "/logo-design",
        targetPath: "/logo-design",
        pageName: "ailogo",
        project: "ailogo"
    },
    // AI logo
    {
        accessPath: "/ppt",
        targetPath: "/ppt",
        pageName: "404",
        project: "home"
    },
    // LivePPT
    {
        accessPath: "/poster",
        targetPath: "/poster",
        pageName: "404",
        project: "aihb"
    },
    // AI海报
    {
        accessPath: "/copywriting",
        targetPath: "/copywriting",
        pageName: "404",
        project: "ai_copywriting_web"
    },
    // AI文案
    {
        accessPath: "/product-shoot",
        targetPath: "/product-shoot",
        pageName: "aispt",
        project: "aispt"
    },
    // AI商品图
    {
        accessPath: "/person-shoot",
        targetPath: "/person-shoot",
        pageName: "404",
        project: "personbg"
    },
    // 人像背景
    {
        accessPath: "/model",
        targetPath: "/model",
        pageName: "aimodel",
        project: "aimodel"
    },
    // AI模特
    {
        accessPath: "/clothes",
        targetPath: "/clothes",
        pageName: "404",
        project: "znhz"
    },
    // AI试衣
    {
        accessPath: "/recolor",
        targetPath: "/recolor",
        pageName: "ai_color_change",
        project: "ai_color_change"
    },
    // 服装换色
    {
        accessPath: "/rmwrinkle",
        targetPath: "/rmwrinkle",
        pageName: "404",
        project: "ai_rmwrinkle"
    },
    // 服装去皱
    // 海外项目现有网址
    {
        accessPath: "/ai-background-generator/edit",
        targetPath: "/product-shoot",
        pageName: "aispt",
        project: "aispt"
    },
    {
        accessPath: "/object-remover/edit",
        targetPath: "/aieraser",
        pageName: "znxc",
        project: "znxc"
    },
    {
        accessPath: "/image-upscaler/edit",
        targetPath: "/upscale",
        pageName: "upscale",
        project: "upscale"
    },
    {
        accessPath: "/image-enhancer/edit",
        targetPath: "/quality",
        pageName: "hzxf",
        project: "hzxf"
    },
    {
        accessPath: "/photo-editor/create",
        targetPath: "/editor",
        pageName: "tpbj",
        project: "tpbj"
    }
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (pathMappings);
var modalLocalStorageKey = "xdesign-widgets_overseasAccessModal";
var modalDomesticLocalStorageKey = "xdesign-widgets_overseasDomesticAccessModal";
var bannerLocalStorageKey = "xdesign-widgets_overseasAccessBanner";


/***/ }),

/***/ 30106:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ getJumpQuery)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1082);

var jumpQuery = undefined;
/**
 * 获取跳转参数，并删除跳转参数。
 * @param notRemoveJumpParams 传入 true 时，不会删除 URL 参数
 * @returns 跳转参数
 */ var getJumpQuery = function getJumpQuery(notRemoveJumpParams) {
    if (!jumpQuery) {
        jumpQuery = {
            original_referrer: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("referrer"),
            came_from: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)("came_from")
        };
        !notRemoveJumpParams && (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeUrlParameterFromAddressBar */ .k4)([
            "referrer",
            "came_from"
        ]);
    }
    return jumpQuery;
};


/***/ }),

/***/ 1082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": () => (/* binding */ getTargetsUrl),
/* harmony export */   "HJ": () => (/* binding */ rebuildForceTargetUrl),
/* harmony export */   "Ht": () => (/* binding */ setBannerShowTimer),
/* harmony export */   "Ph": () => (/* binding */ getQueryParam),
/* harmony export */   "U3": () => (/* binding */ canShow),
/* harmony export */   "_8": () => (/* binding */ setDataInStorage),
/* harmony export */   "cs": () => (/* binding */ canShowBanner),
/* harmony export */   "dI": () => (/* binding */ formatPath),
/* harmony export */   "g7": () => (/* binding */ trackPopupClick),
/* harmony export */   "k4": () => (/* binding */ removeUrlParameterFromAddressBar),
/* harmony export */   "sD": () => (/* binding */ getTargetPath),
/* harmony export */   "vt": () => (/* binding */ trackPopupShow)
/* harmony export */ });
/* unused harmony export getTargetData */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97303);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84999);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67890);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}





/**
 * 获取指定localStorage key 是否存在
 */ var canShow = function canShow(key) {
    return localStorage.getItem(key) !== "true";
};
/**
 * 写入 localStorage
 */ var setDataInStorage = function setDataInStorage(key) {
    localStorage.setItem(key, "true");
};
/**
 * 写入 banner 唤醒时间
 */ var setBannerShowTimer = function setBannerShowTimer(key) {
    var expiredTime = new Date().getTime();
    localStorage.setItem(key, String(expiredTime));
};
/**
 * 判断 banner 是否还可以展示，过期时间 3 个月
 */ var canShowBanner = function canShowBanner(key) {
    var expiredTime = localStorage.getItem(key);
    if (!expiredTime) return true;
    // 3个月过期时间，如果 banner 唤醒时间 + 3 个月大于当前时间，则可以展示
    return Number(expiredTime) + 3 * 30 * 24 * 60 * 60 * 1000 > new Date().getTime();
};
var getTargetData = function getTargetData(currentPath) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.find)(_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, function(item) {
        return item.accessPath === currentPath || currentPath.startsWith(item.accessPath + "/");
    });
};
/**
 * 获取目标路径映射数据
 * @param currentPath
 * @returns
 */ var getTargetPath = function getTargetPath(currentPath) {
    var mapping = getTargetData(currentPath);
    return (mapping === null || mapping === void 0 ? void 0 : mapping.targetPath) || undefined;
};
var getServerJumpURL = function getServerJumpURL(url) {
    return "https://".concat((0,_utils_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnvPrefix */ .HN)((0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)().env), "webapi.designkit.com/v1/designkitcn/redirect?redirect_url=").concat(url, "&referrer=").concat(document.referrer);
};
/**
 * 获取跳转目标连接
 */ var getTargetsUrl = function getTargetsUrl(targetPath) {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)(), env = _getConfig.env, appName = _getConfig.appName, isIntl = _getConfig.isIntl;
    var isDesignkit = appName === "designkit" && isIntl;
    // 避免和其他的 key 冲突
    var query = {
        came_from: isDesignkit ? "designkit" : "xdesign",
        referrer: document.referrer
    };
    var prefix = env === "release" ? "www" : env;
    var url = "https://".concat(prefix, ".designkit.cn").concat(targetPath, "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_4__.stringify)(query));
    return getServerJumpURL(url);
};
/**
 * 获取跳转目标连接
 */ var rebuildForceTargetUrl = function rebuildForceTargetUrl(targetUrl) {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .iE)(), appName = _getConfig2.appName, isIntl = _getConfig2.isIntl;
    var isDesignkit = appName === "designkit" && isIntl;
    var extraQuery = {
        came_from: isDesignkit ? "designkit" : "xdesign",
        referrer: document.referrer
    };
    var url = new URL(targetUrl);
    // 合并 query（不覆盖已有的同名参数）
    Object.entries(extraQuery).forEach(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (value && !url.searchParams.has(key)) {
            url.searchParams.set(key, value);
        }
    });
    return getServerJumpURL(url.toString());
};
/**
 * 格式化path
 */ var formatPath = function formatPath(path) {
    // 小写
    var newPath = path.toLowerCase();
    // 去掉末尾的斜杠
    return path !== "/" && newPath.endsWith("/") ? newPath.slice(0, -1) : newPath;
};
/**
 * 弹窗曝光
 * @param track
 * @param pageName
 */ var trackPopupShow = function trackPopupShow(_ref3) {
    var track = _ref3.track, pageName = _ref3.pageName, isBanner = _ref3.isBanner, popupType = _ref3.popupType, popupName = _ref3.popupName;
    var targetData = getTargetData(formatPath(window.location.pathname));
    if (!targetData) return;
    track("design_popup_show", {
        page_name: pageName || targetData.pageName,
        popup_type: popupType || isBanner ? "redirect_banner" : "redirect",
        popup_name: popupName || "redirect_domestic"
    });
};
/**
 * 弹窗点击
 * @param track
 * @param isJump
 * @param pageName
 */ var trackPopupClick = function trackPopupClick(_ref4) {
    var track = _ref4.track, isJump = _ref4.isJump, pageName = _ref4.pageName, popupType = _ref4.popupType, popupName = _ref4.popupName, isBanner = _ref4.isBanner;
    var targetData = getTargetData(formatPath(window.location.pathname));
    if (!targetData) return;
    track("design_popup_click", {
        page_name: pageName || targetData.pageName,
        popup_type: popupType || isBanner ? "redirect_banner" : "redirect",
        popup_name: popupName || "redirect_domestic",
        click_type: isJump ? 1 : 0
    });
};
var removeUrlParameterFromAddressBar = function removeUrlParameterFromAddressBar(params) {
    var url = new URL(window.location.href);
    params.forEach(function(p) {
        url.searchParams.delete(p);
    });
    window.history.replaceState(null, "", url.toString());
};
var getQueryParam = function getQueryParam(key) {
    try {
        return new URLSearchParams(decodeURIComponent(window.location.search)).get(key) || "";
    } catch (e) {
        var reg = new RegExp("[?&]".concat(key, "=([^&]*)"));
        var search = decodeURIComponent(window.location.search);
        var match = search.match(reg);
        return (match ? match[1] : null) || "";
    }
};


/***/ }),

/***/ 12749:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": () => (/* binding */ fetchUserInfo),
/* harmony export */   "N1": () => (/* binding */ fetchEnterpriseConfigs),
/* harmony export */   "rm": () => (/* binding */ refreshUserRights),
/* harmony export */   "tH": () => (/* binding */ fetchAccessTokenByCode)
/* harmony export */ });
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57526);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

/**
 * Refresh user rights
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/139048
 */ var refreshUserRights = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
                        url: "/v1/websdk/activate",
                        method: "GET"
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function refreshUserRights() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch access token by code
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/139568
 * @param code - meitu account code
 * @returns
 */ var fetchAccessTokenByCode = /*#__PURE__*/ function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(code) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
                        method: "POST",
                        url: "/user/get_token_by_code",
                        params: {
                            code: code
                        },
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function fetchAccessTokenByCode(_x) {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * Check login status (use `/user/info` api)
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/116813
 * @returns - login or not
 */ var fetchUserInfo = /*#__PURE__*/ function() {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
                        method: "GET",
                        url: "/user/info",
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function fetchUserInfo() {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * 企业配置信息
 * @param oid
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/158452
 * @returns
 */ var fetchEnterpriseConfigs = /*#__PURE__*/ function() {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee4(oid) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    return _context4.abrupt("return", (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
                        method: "GET",
                        // url: '/v1/websdk/get_third_authorized_info',
                        url: "/enterprise/config",
                        params: {
                            oid: oid
                        },
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function fetchEnterpriseConfigs(_x2) {
        return _ref4.apply(this, arguments);
    };
}();


/***/ }),

/***/ 37057:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Op": () => (/* binding */ copyDirToMyTeamSpace),
  "tH": () => (/* binding */ createTeamApi),
  "bE": () => (/* binding */ fetchMemberPermission),
  "sN": () => (/* binding */ fetchTeamAdminInfo),
  "hc": () => (/* binding */ fetchTeamIdentityList),
  "Ay": () => (/* binding */ fetchTeamMemberInfo),
  "tc": () => (/* binding */ generateInvite),
  "lh": () => (/* binding */ handleDownloadRecord)
});

// UNUSED EXPORTS: fetchTeamMemberList

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js
var utils_request = __webpack_require__(57526);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/share/api/index.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

/**
 * 分享给指定成员
 * @param param
 * @returns
 */ var createShareToMember = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(_ref) {
        var uids, current_node, node_id, permissionMode, oid, formData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    uids = _ref.uids, current_node = _ref.current_node, node_id = _ref.node_id, permissionMode = _ref.permissionMode, oid = _ref.oid;
                    formData = new FormData();
                    formData.set("uids", uids.join(","));
                    if (oid) {
                        formData.set("oid", "".concat(oid));
                    }
                    formData.set("current_node", current_node);
                    formData.set("node_id", node_id);
                    formData.set("permission_mode", "".concat(permissionMode));
                    _context.next = 9;
                    return request.post("/yunpan/share/to_users", formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 9:
                    return _context.abrupt("return", _context.sent);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function createShareToMember(_x) {
        return _ref2.apply(this, arguments);
    };
}()));
var generateShortUrl = /*#__PURE__*/ function() {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(_ref3) {
        var path, parameter, formData, headers;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    path = _ref3.path, parameter = _ref3.parameter;
                    formData = new FormData();
                    formData.set("path", path);
                    formData.set("parameter", parameter);
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    _context2.next = 7;
                    return utils_request/* default.post */.ZP.post("/fs/generate_short_url", formData, {
                        headers: headers
                    });
                case 7:
                    return _context2.abrupt("return", _context2.sent);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function generateShortUrl(_x2) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * 管理员创建分享
 * @param node_id
 * @param current_node
 * @returns
 */ var createShareToOther = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(_ref5) {
        var _identity$ouid, _identity$oid;
        var current_node, node_id, oid, type, entrance, _ref5$isPersonalFolde, isPersonalFolderToTeamBiz, teamInfo, identity, formData, headers, res, parameter, _yield$generateShortU, short_url;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    current_node = _ref5.current_node, node_id = _ref5.node_id, oid = _ref5.oid, type = _ref5.type, entrance = _ref5.entrance, _ref5$isPersonalFolde = _ref5.isPersonalFolderToTeamBiz, isPersonalFolderToTeamBiz = _ref5$isPersonalFolde === void 0 ? false : _ref5$isPersonalFolde, teamInfo = _ref5.teamInfo;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === (oid !== null && oid !== void 0 ? oid : teamInfo.identity.oid);
                    });
                    formData = new FormData();
                    if (current_node) {
                        formData.set("current_node", current_node);
                    }
                    formData.set("node_id", node_id);
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    if (typeof oid !== "undefined") {
                        headers["client-ogroupid"] = oid;
                        headers["client-oid"] = oid;
                    }
                    _context3.next = 9;
                    return request.post("/yunpan/share/to_other", formData, {
                        headers: headers
                    });
                case 9:
                    res = _context3.sent;
                    // 用于生成短链的query参数
                    parameter = "share_key=".concat(res.share_key, "&").concat(type === "folder" ? "current_node_type" : "editorType", "=").concat(type, "&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid !== void 0 ? _identity$ouid : "unknown",
                        oid: (_identity$oid = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid !== void 0 ? _identity$oid : "unknown",
                        entrance: entrance
                    })));
                    if (type !== "folder") {
                        parameter += "&from=share&channel=share";
                    }
                    _context3.next = 14;
                    return generateShortUrl({
                        path: isPersonalFolderToTeamBiz || type !== "folder" ? "design/share" : "share",
                        parameter: parameter
                    });
                case 14:
                    _yield$generateShortU = _context3.sent;
                    short_url = _yield$generateShortU.short_url;
                    return _context3.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 17:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function createShareToOther(_x3) {
        return _ref6.apply(this, arguments);
    };
}()));
/** 获取分享详情 */ /** 获取分享详情及短链 */ function fetchShareInfo(_x4) {
    return _fetchShareInfo.apply(this, arguments);
}
/**
 * 协作者列表
 * @param
 * @returns
 */ function _fetchShareInfo() {
    _fetchShareInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee7(arg) {
        var _identity$ouid2, _identity$oid2;
        var res, _ref12, type, entrance, teamInfo, identity, parameter, _yield$generateShortU2, short_url;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    _context7.next = 2;
                    return request.get("/yunpan/share/get_share_other", {
                        params: {
                            id: arg.shareOtherId
                        }
                    });
                case 2:
                    res = _context7.sent;
                    if (!(Object.keys(arg).length === 1 && Object.keys(arg)[0] === "shareOtherId")) {
                        _context7.next = 5;
                        break;
                    }
                    return _context7.abrupt("return", res);
                case 5:
                    _ref12 = arg, type = _ref12.type, entrance = _ref12.entrance, teamInfo = _ref12.teamInfo;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === teamInfo.identity.oid;
                    }); // 用于生成短链的query参数
                    parameter = "share_key=".concat(res.share_key).concat(type === "folder" ? "" : "&editorType=".concat(type), "&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid2 = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid2 !== void 0 ? _identity$ouid2 : "unknown",
                        oid: (_identity$oid2 = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid2 !== void 0 ? _identity$oid2 : "unknown",
                        entrance: entrance
                    })));
                    if (type !== "folder") {
                        parameter += "&from=share&channel=share";
                    }
                    _context7.next = 11;
                    return generateShortUrl({
                        path: type === "folder" ? "share" : "design/share",
                        parameter: parameter
                    });
                case 11:
                    _yield$generateShortU2 = _context7.sent;
                    short_url = _yield$generateShortU2.short_url;
                    return _context7.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 14:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return _fetchShareInfo.apply(this, arguments);
}
var fetchCollaborator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee4(currentNode, nodeId) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return request.get("/yunpan/share/collaborator?current_node=".concat(currentNode, "&node_id=").concat(nodeId));
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function fetchCollaborator(_x5, _x6) {
        return _ref7.apply(this, arguments);
    };
}()));
/**
 * 设置协作者权限
 * @param param
 * @returns
 */ var setCollaboratorPermission = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee5(_ref8) {
        var nodeId, currentNode, permissionMode, uid, askPermissionId, formData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    nodeId = _ref8.nodeId, currentNode = _ref8.currentNode, permissionMode = _ref8.permissionMode, uid = _ref8.uid, askPermissionId = _ref8.askPermissionId;
                    formData = new FormData();
                    formData.set("node_id", "".concat(nodeId));
                    formData.set("current_node", currentNode);
                    formData.set("uid", "".concat(uid));
                    formData.set("permission_mode", "".concat(permissionMode));
                    if (askPermissionId) {
                        formData.set("ask_permission_id", "".concat(askPermissionId));
                    }
                    _context5.next = 9;
                    return request.post("/yunpan/share/set_collaborator_permission", formData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 9:
                    return _context5.abrupt("return", _context5.sent);
                case 10:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function setCollaboratorPermission(_x7) {
        return _ref9.apply(this, arguments);
    };
}()));
/**
 * 设置分享的权限
 * @param param
 * @returns
 */ var setSharePermission = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee6(_ref10) {
        var current_node, node_id, permissionMode, userType, oid, formData, headers;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    current_node = _ref10.current_node, node_id = _ref10.node_id, permissionMode = _ref10.permissionMode, userType = _ref10.userType, oid = _ref10.oid;
                    formData = new FormData();
                    formData.set("current_node", current_node);
                    formData.set("node_id", node_id);
                    formData.set("permission_mode", "".concat(permissionMode));
                    formData.set("user_type", userType || "");
                    headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    if (typeof oid !== "undefined") {
                        headers["client-ogroupid"] = oid;
                        headers["client-oid"] = oid;
                    }
                    _context6.next = 10;
                    return request.post("/yunpan/share/set_permission", formData, {
                        headers: headers
                    });
                case 10:
                    return _context6.abrupt("return", _context6.sent);
                case 11:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return function setSharePermission(_x8) {
        return _ref11.apply(this, arguments);
    };
}()));
/** 个人版移除所有人，团队版移除团队之外的人 */ var removeAllCollaborator = function removeAllCollaborator(data) {
    var formData = new FormData();
    formData.set("current_node", data.current_node);
    formData.set("node_id", "".concat(data.node_id));
    return request.post("/yunpan/share/remove_all_collaborator", formData, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/index.js + 1 modules
var query_string = __webpack_require__(25431);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js
function api_typeof(obj) {
    "@babel/helpers - typeof";
    return api_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, api_typeof(obj);
}
var _excluded = [
    "teamInfo",
    "entrance"
];
function api_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function api_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? api_ownKeys(Object(source), !0).forEach(function(key) {
            api_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : api_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function api_defineProperty(obj, key, value) {
    key = api_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function api_toPropertyKey(arg) {
    var key = api_toPrimitive(arg, "string");
    return api_typeof(key) === "symbol" ? key : String(key);
}
function api_toPrimitive(input, hint) {
    if (api_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (api_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function api_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    api_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == api_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function api_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function api_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                api_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                api_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 多次请求合并成一次
var fetchTeamIdentityListResolveList = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/145971
 * [团队]可选身份列表
 */ var fetchTeamIdentityList = function fetchTeamIdentityList() {
    return new Promise(function(resolve, reject) {
        fetchTeamIdentityListResolveList.push(resolve);
        if (fetchTeamIdentityListResolveList.length === 1) {
            utils_request/* default.get */.ZP.get("/enterprise/identity_list", {
                hiddenMessage: true
            }).then(function(data) {
                // 处理个人设计师显示昵称
                data.list.forEach(function(item) {
                    if (!item.oid) {
                        item.alias = "个人设计师";
                    }
                });
                for(var i = 0; i < fetchTeamIdentityListResolveList.length; i++){
                    var element = fetchTeamIdentityListResolveList[i];
                    element(data);
                }
                fetchTeamIdentityListResolveList.length = 0;
            // console.log(
            //   'fetchTeamIdentityList',
            //   fetchTeamIdentityListResolveList.length,
            // );
            }).catch(function(e) {
                fetchTeamIdentityListResolveList.length = 0;
                reject(e);
            });
        }
    });
};
var fetchTeamMemberInfoResolveList = [];
/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/149033
 * [团队]获取我的成员信息
 */ var fetchTeamMemberInfo = /*#__PURE__*/ function() {
    var _ref = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee() {
        return api_regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", new Promise(function(resolve) {
                        fetchTeamMemberInfoResolveList.push(resolve);
                        if (fetchTeamMemberInfoResolveList.length === 1) {
                            utils_request/* default.get */.ZP.get("/enterprise/team/member_info", {
                                hiddenMessage: true
                            }).then(function(res) {
                                for(var i = 0; i < fetchTeamMemberInfoResolveList.length; i++){
                                    var element = fetchTeamMemberInfoResolveList[i];
                                    element(res);
                                }
                                fetchTeamMemberInfoResolveList.length = 0;
                            });
                        }
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchTeamMemberInfo() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 团队信息
 * @returns
 */ var fetchTeamAdminInfo = /*#__PURE__*/ function() {
    var _ref2 = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee2() {
        return api_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return utils_request/* default.get */.ZP.get("/enterprise/team/info", {});
                case 2:
                    return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function fetchTeamAdminInfo() {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * [团队]获取我成员列表
 */ var fetchTeamMemberList = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref3 = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee3() {
        return api_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return request.get("/enterprise/team/member_list", {
                        hiddenMessage: true
                    });
                case 2:
                    return _context3.abrupt("return", _context3.sent);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function fetchTeamMemberList() {
        return _ref3.apply(this, arguments);
    };
}()));
/**
 * [团队]创建团队 https://api-mock.meitu-int.com/project/2110/interface/api/145974
 * @param data
 * @returns
 */ var createTeamApi = /*#__PURE__*/ function() {
    var _ref4 = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee4(data) {
        return api_regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.next = 2;
                    return utils_request/* default.post */.ZP.post("/enterprise/team/create", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 2:
                    return _context4.abrupt("return", _context4.sent);
                case 3:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function createTeamApi(_x) {
        return _ref4.apply(this, arguments);
    };
}();
/** 复制个人版指定文件到团队版个人空间下 https://api-mock.meitu-int.com/project/2110/interface/api/163078 */ var copyDirToMyTeamSpace = /*#__PURE__*/ function() {
    var _ref6 = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee5(_ref5) {
        var current_node, node_id, oid;
        return api_regeneratorRuntime().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    current_node = _ref5.current_node, node_id = _ref5.node_id, oid = _ref5.oid;
                    _context5.next = 3;
                    return utils_request/* default.post */.ZP.post("/yunpan/node/copy_to_my_space", query_string["default"].stringify({
                        current_node: current_node,
                        id: node_id
                    }), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "client-ogroupid": oid,
                            "client-oid": oid
                        }
                    });
                case 3:
                    return _context5.abrupt("return", _context5.sent);
                case 4:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function copyDirToMyTeamSpace(_x2) {
        return _ref6.apply(this, arguments);
    };
}();
/**
 * [团队]生成邀请码 https://api-mock.meitu-int.com/project/2110/interface/api/146100
 * @returns
 */ var generateInvite = /*#__PURE__*/ function() {
    var _ref8 = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee6(_ref7) {
        var _identity$ouid, _identity$oid;
        var teamInfo, entrance, data, res, identity, parameter, _yield$generateShortU, short_url;
        return api_regeneratorRuntime().wrap(function _callee6$(_context6) {
            while(1)switch(_context6.prev = _context6.next){
                case 0:
                    teamInfo = _ref7.teamInfo, entrance = _ref7.entrance, data = _objectWithoutProperties(_ref7, _excluded);
                    _context6.next = 3;
                    return utils_request/* default.post */.ZP.post("/enterprise/team/generate_inviate_key", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 3:
                    res = _context6.sent;
                    identity = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.find(function(item) {
                        return item.oid === teamInfo.identity.oid;
                    });
                    parameter = "inviteKey=".concat(res.invite_key, "&channel=member_invite&trackMeta=").concat(encodeURIComponent(JSON.stringify({
                        uid: (_identity$ouid = identity === null || identity === void 0 ? void 0 : identity.ouid) !== null && _identity$ouid !== void 0 ? _identity$ouid : "unknown",
                        oid: (_identity$oid = identity === null || identity === void 0 ? void 0 : identity.oid) !== null && _identity$oid !== void 0 ? _identity$oid : "unknown",
                        entrance: entrance
                    })));
                    _context6.next = 8;
                    return generateShortUrl({
                        path: "",
                        parameter: parameter
                    });
                case 8:
                    _yield$generateShortU = _context6.sent;
                    short_url = _yield$generateShortU.short_url;
                    return _context6.abrupt("return", api_objectSpread(api_objectSpread({}, res), {}, {
                        shortUrl: short_url
                    }));
                case 11:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return function generateInvite(_x3) {
        return _ref8.apply(this, arguments);
    };
}();
/**
 * 接口 [上报下载资源↗](/common/sensitive_check)
 * https://api-mock.meitu-int.com/project/2110/interface/api/175621
 */ var handleDownloadRecord = /*#__PURE__*/ function() {
    var _ref9 = api_asyncToGenerator(/*#__PURE__*/ api_regeneratorRuntime().mark(function _callee7(data) {
        return api_regeneratorRuntime().wrap(function _callee7$(_context7) {
            while(1)switch(_context7.prev = _context7.next){
                case 0:
                    _context7.next = 2;
                    return utils_request/* default.post */.ZP.post("/zhanku/download_record", query_string["default"].stringify(data), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                case 2:
                    return _context7.abrupt("return", _context7.sent);
                case 3:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return function handleDownloadRecord(_x4) {
        return _ref9.apply(this, arguments);
    };
}();
/**
 * [团队]获取我的权限
 * https://api-mock.meitu-int.com/project/2110/interface/api/146159
 */ var fetchMemberPermission = function fetchMemberPermission() {
    return utils_request/* default.get */.ZP.get("/enterprise/team/member_permissions", {
        hiddenMessage: true
    });
};


/***/ }),

/***/ 6310:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": () => (/* binding */ openCreateTeamModal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(20134);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var render = __webpack_require__(24996);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/cls.js
var cls = __webpack_require__(51811);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/button/index.less
var ComUI_button = __webpack_require__(364);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/button/index.js
var _excluded = [
    "className",
    "icon",
    "type",
    "htmlType",
    "size",
    "children"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var subPrefix = "Button";
var cls$ = (0,cls/* default */.ZP)(subPrefix);
var Button = /*#__PURE__*/ react.forwardRef(function(_ref, ref) {
    var _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, icon = _ref.icon, _ref$type = _ref.type, type = _ref$type === void 0 ? "default" : _ref$type, _ref$htmlType = _ref.htmlType, htmlType = _ref$htmlType === void 0 ? "button" : _ref$htmlType, _ref$size = _ref.size, size = _ref$size === void 0 ? "large" : _ref$size, children = _ref.children, restProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement("button", _extends({
        /* eslint-disable-next-line react/button-has-type */ type: htmlType,
        className: classnames_default()(cls$(), className),
        "data-type": type,
        "data-size": size
    }, restProps, {
        ref: ref
    }), icon, /*#__PURE__*/ react.createElement("div", {
        className: cls$("children")
    }, children));
});
/* harmony default export */ const dist_ComUI_button = (Button);

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js + 35 modules
var utils = __webpack_require__(35601);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/createModal/index.less
var createModal = __webpack_require__(39618);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/createModal/index.js
var createModal_excluded = [
    "onClose"
];
function createModal_extends() {
    createModal_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return createModal_extends.apply(this, arguments);
}
function createModal_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = createModal_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function createModal_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}











var BannerImage = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/create-modal-banner.png";
var CreateTeamModal = function CreateTeamModal(_ref) {
    var _ref$project = _ref.project, project = _ref$project === void 0 ? "" : _ref$project, noSwitchIdentity = _ref.noSwitchIdentity, create_team_success_entrance = _ref.create_team_success_entrance, onCreatedComplete = _ref.onCreatedComplete, onClose = _ref.onClose, onTrack = _ref.onTrack;
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), userInfo = _useConfig.userInfo;
    var inputRef = (0,react.useRef)();
    var _useState = (0,react.useState)(""), _useState2 = _slicedToArray(_useState, 2), teamName = _useState2[0], setTeamName = _useState2[1];
    var isPending = (0,react.useRef)(false);
    var maxTeamNameLength = 21;
    (0,react.useEffect)(function() {
        var _inputRef$current;
        setTeamName("");
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }, []);
    (0,react.useEffect)(function() {
        if (!userInfo.screen_name) return;
        setTeamName("".concat(userInfo.screen_name, "的团队"));
    }, [
        userInfo.screen_name
    ]);
    ;
    var createHandle = function createHandle() {
        if (!teamName) {
            return message/* default.error */.Z.error("请填写完整团队信息");
        }
        if (teamName.length >= maxTeamNameLength) {
            return message/* default.error */.Z.error("请填输入20字内的团队/企业名称");
        }
        if (isPending.current) return;
        isPending.current = true;
        (0,utils/* createTeam */.Cm)({
            teamName: teamName
        }).then(function(res) {
            onTrack === null || onTrack === void 0 ? void 0 : onTrack("create_team_success", {
                entrance: create_team_success_entrance !== null && create_team_success_entrance !== void 0 ? create_team_success_entrance : "create_team_1",
                project: project,
                team_name: teamName,
                newcreate_oid: res.oid,
                newcreate_uid: res.ouid
            });
            onCreatedComplete === null || onCreatedComplete === void 0 ? void 0 : onCreatedComplete({
                group_id: res.groupId,
                oid: res.oid,
                ouid: res.ouid,
                team_name: res.teamName
            });
            message/* default.success */.Z.success("创建成功");
            // 会员弹窗关闭时回调函数
            onClose === null || onClose === void 0 ? void 0 : onClose();
            if (!noSwitchIdentity) {
                (0,teamInfo/* changeIdentity */.vv)({
                    ouid: res.ouid,
                    oid: res.oid,
                    groupId: res.groupId
                });
            }
        }).finally(function() {
            isPending.current = false;
            ;
        });
    };
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        open: true,
        destroyOnClose: true,
        className: "Widget teamSpaceCreateModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-inner"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: onClose
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-banner"
    }, /*#__PURE__*/ react.createElement("img", {
        src: BannerImage,
        alt: ""
    })), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-form"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-formTitle"
    }, "创建团队"), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceCreateModal-formLabel"
    }, "团队名称"), /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("teamSpaceCreateModal-input", {
            warn: teamName.length >= maxTeamNameLength
        })
    }, /*#__PURE__*/ react.createElement("input", {
        value: teamName,
        ref: inputRef,
        placeholder: "请输入团队名称",
        type: "text",
        maxLength: maxTeamNameLength,
        onChange: function onChange(e) {
            setTeamName(e.target.value);
        }
    })), /*#__PURE__*/ react.createElement(dist_ComUI_button, {
        type: "primary",
        style: {
            marginTop: 32,
            height: 48,
            fontSize: 16
        },
        onClick: function onClick() {
            createHandle();
        }
    }, "免费创建"), /*#__PURE__*/ react.createElement("p", {
        className: "teamSpaceCreateModal-renameTip"
    }, "团队名称可随时修改"))));
};
CreateTeamModal.displayName = "CreateTeamModal";
var el = null;
CreateTeamModal.open = function(_ref2) {
    var _onClose = _ref2.onClose, restProps = createModal_objectWithoutProperties(_ref2, createModal_excluded);
    if (!el) {
        el = document.createElement("div");
    }
    document.body.appendChild(el);
    (0,render/* render */.sY)(/*#__PURE__*/ react.createElement(CreateTeamModal, createModal_extends({}, restProps, {
        onClose: function onClose() {
            if (el && el.parentNode) {
                (0,render/* unmount */.vE)(el);
                el.parentNode.removeChild(el);
                el = null;
            }
            _onClose === null || _onClose === void 0 ? void 0 : _onClose();
        }
    })), el);
};
var openCreateTeamModal = CreateTeamModal.open;


/***/ }),

/***/ 40769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c7": () => (/* binding */ HIDE_EXPIRED_MODAL),
  "e1": () => (/* binding */ SHOW_EXPIRED_MODAL),
  "ZP": () => (/* binding */ teamInfo_expiredModal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/eventBus.js
var eventBus = __webpack_require__(77724);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/types/enum.js
/**
 * 环境变量枚举
 */
var enum_EnvEnum = /*#__PURE__*/function (EnvEnum) {
  EnvEnum["LOCAL"] = "local";
  EnvEnum["PRE"] = "pre";
  EnvEnum["BETA"] = "beta";
  EnvEnum["RELEASE"] = "release";
  return EnvEnum;
}({});
/**
 * 主题色
 */
var ThemeEnum = /*#__PURE__*/function (ThemeEnum) {
  ThemeEnum["DARK"] = "dark";
  ThemeEnum["LIGHT"] = "light";
  return ThemeEnum;
}({});
/**
 * 事件名称枚举
 */
var enum_EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["SUCCESS"] = "success";
  EventNameEnum["FAIL"] = "fail";
  EventNameEnum["LOGININVALID"] = "login-invalid";
  EventNameEnum["CLOSE"] = "close";
  return EventNameEnum;
}({});
var enum_CloseFromEnum = /*#__PURE__*/function (CloseFromEnum) {
  CloseFromEnum["PAYSUCCESS"] = "pay-success";
  CloseFromEnum["UNLOGIN"] = "unLogin";
  CloseFromEnum["CLOSE"] = "close";
  return CloseFromEnum;
}({});
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/lib/index.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var lib_SaasSubscription = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function SaasSubscription(_params) {
    var _this = this;
    _classCallCheck(this, SaasSubscription);
    _defineProperty(this, "env", void 0);
    _defineProperty(this, "theme", void 0);
    _defineProperty(this, "commonParams", void 0);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "shouldRetention", false);
    _defineProperty(this, "onTrack", void 0);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "ele", null);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "eleIframe", null);
    /**
     * 权益对比弹窗元素
     */
    _defineProperty(this, "elePopup", null);
    /**
     * 关闭按钮元素
     */
    _defineProperty(this, "eleClose", null);
    _defineProperty(this, "messageHandler", function (e) {
      var data = e.data || e.originalEvent && e.originalEvent.data;
      if (typeof data === "string" && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      // 关闭订阅弹窗通知
      if (data && data.action === "closeVipSubscribeDialog") {
        // 未登录
        if (data.data && data.data.needLogin) {
          var handler = _this.eventHandlers[EventNameEnum.LOGININVALID];
          if (handler) {
            handler();
          }
          _this.close(false, CloseFromEnum.UNLOGIN);
        }

        // 支付成功
        if (data.data && data.data.success) {
          var _handler = _this.eventHandlers[EventNameEnum.SUCCESS];
          if (_handler) {
            _handler();
          }
          _this.close(false, CloseFromEnum.PAYSUCCESS);
        }
      } else if (data && data.action === "changeCloseVipSubscribeDialogCloseIcon") {
        // 显示/隐藏弹窗关闭按钮
        if (data.data) {
          if (_this.eleClose) {
            var _data$data;
            _this.eleClose.style.visibility = (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.status ? "visible" : "hidden";
          }
        }
      } else if (data && data.action === "openVipComparePopup") {
        // 打开版本权益说明弹窗
        openVipComparePopup();
      }
    });
    /**
     * 获取最新的订阅访问URL
     * @param customParams 自定义参数
     * @returns
     */
    _defineProperty(this, "getLatestUrl", function (customParams) {
      var params = Object.assign({}, _this.commonParams, customParams);
      var queryString = Object.keys(params).reduce(function (str, key) {
        return str + "".concat(key, "=").concat(params[key] || "", "&");
      }, "");
      var preHost = "";
      if (/\.meitu\.com/.test(window.location.host) || /localhost/.test(window.location.host)) {
        // .meitu.com 域名，都统一走pc.meitu.com域名
        switch (_this.env) {
          case EnvEnum.PRE:
          case EnvEnum.LOCAL:
            preHost = "https://prepc.meitu.com";
            break;
          case EnvEnum.BETA:
            preHost = "https://beta-pc.meitu.com";
            break;
          case EnvEnum.RELEASE:
            preHost = "https://pc.meitu.com";
            break;
          default:
        }
      } else {
        // 非.meitu.com 域名，都统一走当前域名
        preHost = "".concat(window.location.protocol, "//").concat(window.location.host);
      }

      // 本地开发
      if (_this.env === EnvEnum.LOCAL) {
        preHost = "https://prepc.meitu.com";
      }
      return "".concat(preHost, "/vip?theme=").concat(_this.theme, "&").concat(queryString);
    });
    /**
     * 创建弹窗容器
     */
    _defineProperty(this, "createDialog", function () {
      // 创建容器
      var eleDialog = document.createElement("div");
      eleDialog.className = "saas-subscription-popup ".concat(_this.theme);
      var eleInner = document.createElement("div");
      eleInner.className = "saas-subscription-popup__inner";

      // 创建关闭安按钮
      var eleClose = document.createElement("img");
      eleClose.className = "saas-subscription-popup__close";
      eleClose.src = "https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png";
      eleClose.onclick = function () {
        var _window;
        // 重置为业务的uid
        // window.mtstat埋点login的uid值
        // 解决个人版打开团队版订阅弹窗场景，导致埋点的uid不对问题
        var uid = window.localStorage.getItem("uid");
        if (uid) (_window = window) === null || _window === void 0 || (_window = _window.mtstat) === null || _window === void 0 || _window.login(uid);
        _this.close();
      };

      // 创建iframe
      var iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = _this.getLatestUrl({});
      eleInner.appendChild(iframe);
      eleInner.appendChild(eleClose);
      eleDialog.appendChild(eleInner);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = dialogCss;
      document.head.appendChild(eleStyle);
      _this.ele = eleDialog;
      _this.eleClose = eleClose;
      _this.eleIframe = iframe;
    });
    /**
     *
     * 阻断弹窗
     */
    _defineProperty(this, "createRetentionDialog", function () {
      var _this$onTrack3;
      var ele = document.createElement("div");
      ele.className = "vip-retention-modal";
      var strDom = "\n        <div class=\"vip-retention-modal__inner\">\n            <img src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/retention-bg.png\" alt=\"\">\n            <div class=\"vip-retention-modal__close\"></div>\n            <div class=\"vip-retention-modal__btn\"></div>    \n        </div>\n        ";
      ele.innerHTML = strDom;
      document.body.appendChild(ele);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = retentionCss;
      document.head.appendChild(eleStyle);
      var eleClose = document.querySelector(".vip-retention-modal__close");
      var eleBtn = document.querySelector(".vip-retention-modal__btn");
      if (eleClose) {
        eleClose.onclick = function () {
          var _this$onTrack;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 关闭订阅弹窗
          _this.close(false);
          (_this$onTrack = _this.onTrack) === null || _this$onTrack === void 0 || _this$onTrack.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "close"
          });
        };
      }
      if (eleBtn) {
        eleBtn.onclick = function () {
          var _this$eleIframe, _this$onTrack2;
          // 重置阻拦状态
          _this.shouldRetention = false;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 通知订阅弹窗展示会员购买场景
          (_this$eleIframe = _this.eleIframe) === null || _this$eleIframe === void 0 || (_this$eleIframe = _this$eleIframe.contentWindow) === null || _this$eleIframe === void 0 || _this$eleIframe.postMessage(JSON.stringify({
            action: "viewSubscription" // 查看购买会员商品组
          }), _this.getLatestUrl({}).replace(/\/vip?.+/, ""));
          (_this$onTrack2 = _this.onTrack) === null || _this$onTrack2 === void 0 || _this$onTrack2.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "to_see"
          });
        };
      }
      (_this$onTrack3 = _this.onTrack) === null || _this$onTrack3 === void 0 || _this$onTrack3.call(_this, "operations_popup_show", {
        func: "retention_popup"
      });
    });
    this.env = _params.env || "release";
    this.theme = _params.theme || "light";
    this.commonParams = _params.commonParams || {};
  }

  /**
   * 监听事件
   *
   * @param eventName 事件名
   * @param handler 回调函数
   * @returns
   */
  _createClass(SaasSubscription, [{
    key: "on",
    value: function on(eventName, handler) {
      this.eventHandlers[eventName] = handler;
      return this;
    }

    /**
     * 打开弹窗
     * @param customParams 自定义参数
     * @returns
     */
  }, {
    key: "open",
    value: function open(customParams, otherParams) {
      this.shouldRetention = !!(otherParams !== null && otherParams !== void 0 && otherParams.shouldRetention);
      this.onTrack = otherParams === null || otherParams === void 0 ? void 0 : otherParams.onTrack;
      console.log(otherParams, "otherParams=========");
      if (!this.ele) {
        this.createDialog();
      }
      if (this.eleIframe) {
        this.eleIframe.src = this.getLatestUrl(customParams);
      }
      if (this.ele) {
        document.body.appendChild(this.ele);
      }
      window.addEventListener("message", this.messageHandler, false);
      return this;
    }

    /**
     * 关闭弹窗
     * @returns
     */
  }, {
    key: "close",
    value: function close() {
      var shouldCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CloseFromEnum.CLOSE;
      var curDate = "".concat(new Date().getFullYear(), "-").concat(new Date().getMonth() + 1, "-").concat(new Date().getDate());
      var local = JSON.parse(window.localStorage.getItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER) || "{}");
      var localNum = local.date === curDate ? +(local.value || "0") : 0;
      if (shouldCheck && this.shouldRetention && localNum < 3) {
        window.localStorage.setItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER, JSON.stringify({
          date: curDate,
          value: localNum + 1
        }));
        this.createRetentionDialog();
        return;
      }
      var handler = this.eventHandlers[EventNameEnum.CLOSE];
      if (handler) {
        handler(from);
      }
      if (this.ele) {
        document.body.removeChild(this.ele);
      }
      if (typeof window.removeEventListener !== "undefined") {
        window.removeEventListener("message", this.messageHandler, false);
      }
      return this;
    }

    /**
     * 动态设置更新公共参数
     * @param params
     * @returns
     */
  }, {
    key: "setCommonParams",
    value: function setCommonParams(params) {
      if (params) {
        this.commonParams = Object.assign({}, this.commonParams, params);
      }
    }

    /**
     * 动态设置更新主题色
     * @param val
     * @returns
     */
  }, {
    key: "setTheme",
    value: function setTheme(val) {
      if (val) {
        this.theme = val;
        if (this.ele) this.ele.className = "saas-subscription-popup ".concat(this.theme);
      }
    }
  }]);
  return SaasSubscription;
}()));
/* harmony default export */ const lib = ((/* unused pure expression or super */ null && (lib_SaasSubscription)));
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/constants/index.js
/**
 * 订阅弹窗样式
 */
var constants_dialogCss = "\n  .saas-subscription-popup {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .saas-subscription-popup__inner {\n    width: 931px;\n    height: 588px;\n    border-radius: 12px;\n    background-color: #fff;\n    position: relative;\n  }\n\n  .saas-subscription-popup.dark .saas-subscription-popup__inner {\n    background-color: #1C1D1F;\n  }\n\n  .saas-subscription-popup__inner iframe {\n    border-radius: 12px;\n  }\n\n  .saas-subscription-popup__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    transition: all 0.5s ease;\n  }\n\n  .saas-subscription-popup__close:hover {\n    transform: rotate(180deg);\n  }\n\n  @media screen and (max-height: 620px) {\n    .saas-subscription-popup {\n      display: block;\n      overflow: auto;\n      /* \u706B\u72D0\u7279\u5B9A\u6EDA\u52A8\u6761\u6837\u5F0F */\n      scrollbar-width: none;\n    }\n\n    .saas-subscription-popup::-webkit-scrollbar {\n      display: none;\n    }\n\n    .saas-subscription-popup__inner {\n      margin: 30px auto 0;\n    }\n  }\n";

/**
 * 权益对比弹窗样式
 */
var popupCss = "\n  .vip-compare-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-compare-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-compare-modal__inner {\n    width: 630px;\n    max-width: 100vw;\n    height: 565px;\n    max-height: 100vh;\n    padding: 16px 16px 20px;\n    border-radius: 12px;\n    background: var(--background-system-frame-floatpanel, #FFF);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 24px 128px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vip-compare-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .vip-compare-modal__title {\n    color: var(--content-system-primary, #1C1D1F);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n  }\n\n  .vip-compare-modal__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    transition: all 0.5s ease;\n  }\n\n  .vip-compare-modal__close:hover {\n    transform: rotate(180deg);\n  }\n\n  .vip-compare-modal__body {\n    flex: 1;\n    margin-top: 16px;\n    padding-right: 2px;\n    overflow-y: auto;\n  }\n\n  .vip-compare-modal__body-inner {\n    color: var(--content-web-primary, #17181A);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 4px;\n    border: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n    position: relative;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar {\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar:vertical {\n    width: 4px;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 4px solid rgba(0, 0, 0, 0.2);\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .vip-compare-modal__body-header {\n    position: sticky;\n    top: 0;\n    background: var(--background-system-frame-floatpanel, #FFF);\n  }\n\n  .vip-compare-modal__thead {\n    height: 40px;\n    background: var(--background-system-selected, #E5F2FF);\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__trow {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__cell {\n    width: 145px;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .vip-compare-modal__cell:nth-child(1) {\n    width: auto;\n    flex: 1;\n    text-align: left;\n  }\n\n  .vip-compare-modal__tbody .vip-compare-modal__trow:last-child {\n    border-bottom: none;\n  }\n\n  .vip-compare-modal__trow-title {\n    background: var(--background-web-secondary, rgba(0, 30, 89, 0.04));\n  }\n";

/**
 * 阻断弹窗样式
 */
var constants_retentionCss = "\n  .vip-retention-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-retention-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-retention-modal__inner {\n    width: 300px;\n    height: 400px;\n    max-width: 100vw;\n    max-height: 100vh;\n    position: relative;\n  }\n\n  .vip-retention-modal__inner img {\n    width: 100%;\n  }\n\n  .vip-retention-modal__close {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n  }\n\n  .vip-retention-modal__btn {\n    width: 170px;\n    height: 45px;\n    cursor: pointer;\n    position: absolute;\n    left: 50%;\n    bottom: 33px;\n    transform: translateX(-50%);\n  }\n";

// 弹窗阻断次数缓存
var constants_SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER = "saas-subscription-popup-retention-number";
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/utils/index.js

/**
 * 版本权益对比弹窗
 */
var utils_openVipComparePopup = function openVipComparePopup() {
  var dataSource = {
    内容服务: [["免费模版/PPT", true, true, true], ["免费字体", true, true, true], ["免费素材", true, true, true], ["付费模版/PPT", false, true, true], ["付费字体", false, true, true], ["付费素材", false, true, true], ["商用授权", false, "个人商用", "企业商用(1个主体)"]],
    创作工具: [["拼图", true, true, true], ["AI消除", false, true, true], ["AI尺寸延展", "限时免费", true, true], ["服装去皱", false, true, true], ["无损放大", false, true, true], ["变清晰", false, true, true]],
    多人协同: [["文件共享", true, true, true], ["文件夹共享", false, false, true], ["共享权限管理", false, false, true], ["品牌规范", false, false, true], ["模版库(PSD上传)", false, false, true]],
    团队管理: [["角色管理", false, false, true], ["数据看板", false, false, true], ["订单管理", false, false, true]],
    消耗品: [["智能抠图", false, "1200张/年", "100张*席位数/月"], ["会员美豆", false, "120个/月", "120个*席位数/月"]]
  };
  console.log(Object.keys(dataSource));
  var ele = document.createElement("div");
  ele.className = "vip-compare-modal";
  var strDom = "\n      <div class=\"vip-compare-modal__inner\">\n          <div class=\"vip-compare-modal__header\">\n              <span class=\"vip-compare-modal__title\">\u7248\u672C\u6743\u76CA\u8BF4\u660E</span>\n              <img class=\"vip-compare-modal__close\" src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png\" alt=\"\">\n          </div>\n          <div class=\"vip-compare-modal__body\">\n            <div class=\"vip-compare-modal__body-inner\">\n              <div class=\"vip-compare-modal__body-header\">\n                  <div class=\"vip-compare-modal__thead\">\n                      <div class=\"vip-compare-modal__cell\">\u7248\u672C</div>\n                      <div class=\"vip-compare-modal__cell\">\u514D\u8D39\u7248</div>\n                      <div class=\"vip-compare-modal__cell\">\u4E2A\u4EBA\u7248SVIP</div>\n                      <div class=\"vip-compare-modal__cell\">\u56E2\u961F\u7248VIP</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u4EF7\u683C</div>\n                      <div class=\"vip-compare-modal__cell\">\xA50/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5288/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5488/\u5E74\u8D77</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u9002\u7528\u4EBA\u6570</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">\u591A\u4EBA</div>\n                  </div>\n              </div>\n              <div class=\"vip-compare-modal__tbody\">\n                  ";
  Object.keys(dataSource).forEach(function (key) {
    strDom += "\n          <div class=\"vip-compare-modal__trow\">\n              <div class=\"vip-compare-modal__cell vip-compare-modal__trow-title\">".concat(key, "</div>\n          </div>\n      ");
    dataSource[key].forEach(function (item) {
      strDom += "\n              <div class=\"vip-compare-modal__trow\">\n                  ";
      item.forEach(function (data) {
        if (typeof data === "string") {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">".concat(data, "</div>\n                  ");
        } else if (!!data) {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                              <path d=\"M11.4018 2.21587C11.6968 2.50668 11.7001 2.98154 11.4093 3.2765L5.12216 9.6515C4.97783 9.79789 4.77975 9.87861 4.57421 9.87481C4.36868 9.87101 4.17372 9.78301 4.03491 9.63139L0.572068 5.86055C0.292363 5.55504 0.313286 5.08063 0.6188 4.80092C0.924313 4.52122 1.39873 4.54214 1.67843 4.84766L4.60823 8.03626L10.3412 2.22338C10.632 1.92842 11.1069 1.92506 11.4018 2.21587Z\" fill=\"#3388FF\"/>\n                          </svg>    \n                      </div>\n                  ";
        } else {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\"></div>\n                  ";
        }
      });
      strDom += "\n              </div>\n          ";
    });
  });
  strDom += "\n              </div>\n          </div>\n        </div>\n      </div>\n    ";
  ele.innerHTML = strDom;
  document.body.appendChild(ele);

  // 创建样式
  var eleStyle = document.createElement("style");
  eleStyle.innerHTML = popupCss;
  document.head.appendChild(eleStyle);
  var eleClose = document.querySelector(".vip-compare-modal__close");
  if (eleClose) {
    eleClose.onclick = function () {
      document.body.removeChild(ele);
      document.head.removeChild(eleStyle);
    };
  }
};
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/saas-subscription-popup/dist/esm/index.js





/* harmony default export */ const esm = ((/* unused pure expression or super */ null && (SaasSubscription)));
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var xdesign_identity_lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/expiredModal/index.less
var expiredModal = __webpack_require__(48674);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/expiredModal/index.js
function expiredModal_typeof(obj) {
    "@babel/helpers - typeof";
    return expiredModal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, expiredModal_typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            expiredModal_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function expiredModal_defineProperty(obj, key, value) {
    key = expiredModal_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function expiredModal_toPropertyKey(arg) {
    var key = expiredModal_toPrimitive(arg, "string");
    return expiredModal_typeof(key) === "symbol" ? key : String(key);
}
function expiredModal_toPrimitive(input, hint) {
    if (expiredModal_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (expiredModal_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}












var vipConfig = [
    {
        iconName: "VipBold",
        text: "畅享SVIP权益"
    },
    {
        iconName: "UserGroupBold",
        text: "团队权限管理"
    },
    {
        iconName: "FolderBold",
        text: "成员文件夹协作"
    }
];
var SHOW_EXPIRED_MODAL = "xdesign-widget-show-expired-modal";
var HIDE_EXPIRED_MODAL = "xdesign-widget-hide-expired-modal";
/**
 * 团队过期提示
 */ var ExpiredModal = function ExpiredModal(props) {
    var identityList = props.identityList;
    var showData = (0,react.useRef)({
        entrance: ""
    });
    var _useState = (0,react.useState)(false), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useConfig = (0,configProvider/* useConfig */.ZR)(), isIntl = _useConfig.isIntl, theme = _useConfig.theme;
    var curTeamIdentity = (0,dist_teamInfo/* useCurrentTeamIdentity */.q5)();
    // https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/expired-modal-dark.png
    // https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/expired-modal-light.png
    // https://x-design-static-release.stariicloud.com/xdesign-widgets/expired-modal-light.png
    var domain = isIntl ? "https://x-design-static-release.stariicloud.com/xdesign-widgets/" : "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/teamInfo/";
    function getStatArgs() {
        return {
            popup_type: "expire",
            entrance: showData.current.entrance
        };
    }
    function popupClickTrack(className) {
        var _showData$current$onT, _showData$current;
        (_showData$current$onT = (_showData$current = showData.current).onTrack) === null || _showData$current$onT === void 0 ? void 0 : _showData$current$onT.call(_showData$current, "popup_click", _objectSpread(_objectSpread({}, getStatArgs()), {}, {
            class: className
        }));
    }
    (0,react.useEffect)(function() {
        var onShowHandle = function onShowHandle(args) {
            if (args) {
                showData.current = args;
            }
            setOpen(true);
        };
        var onHideHandle = function onHideHandle() {
            setOpen(false);
        };
        eventBus/* default.addListener */.Z.addListener(SHOW_EXPIRED_MODAL, onShowHandle);
        eventBus/* default.addListener */.Z.addListener(HIDE_EXPIRED_MODAL, onHideHandle);
        return function() {
            eventBus/* default.removeListener */.Z.removeListener(SHOW_EXPIRED_MODAL, onShowHandle);
            eventBus/* default.removeListener */.Z.removeListener(HIDE_EXPIRED_MODAL, onHideHandle);
        };
    }, []);
    // 关闭
    var closeHandle = function closeHandle() {
        var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cancel";
        setOpen(false);
        popupClickTrack(className);
    };
    // 确定
    var okHandle = function okHandle() {
        var _showData$current$onO, _showData$current2;
        setOpen(false);
        (_showData$current$onO = (_showData$current2 = showData.current).onOK) === null || _showData$current$onO === void 0 ? void 0 : _showData$current$onO.call(_showData$current2, "expire_popup");
        popupClickTrack("renew_now");
    };
    (0,react.useEffect)(function() {
        if (open) {
            var _showData$current$onT2, _showData$current3;
            ;
            (_showData$current$onT2 = (_showData$current3 = showData.current).onTrack) === null || _showData$current$onT2 === void 0 ? void 0 : _showData$current$onT2.call(_showData$current3, "popup_show", getStatArgs());
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        destroyOnClose: true,
        open: open,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceExpiredModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "Widget teamSpaceExpiredModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: function onClick() {
            var _showData$current$onC, _showData$current4;
            closeHandle();
            (_showData$current$onC = (_showData$current4 = showData.current).onClose) === null || _showData$current$onC === void 0 ? void 0 : _showData$current$onC.call(_showData$current4, showData.current.entrance);
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "tip"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular,#8cc0ff)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "title"
    }, "当前团队已过期"), /*#__PURE__*/ react.createElement("div", {
        className: "description"
    }, "若需正常使用请续费升级"), /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("card", "card-".concat(theme)),
        style: {
            backgroundImage: "url(".concat("".concat(domain, "expired-bg-").concat(theme, ".png"), ")")
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "header"
    }, "VIP团队版权益", /*#__PURE__*/ react.createElement("span", {
        onClick: function onClick() {
            utils_openVipComparePopup();
        // closeHandle('view');
        }
    }, "查看详细权益", /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 12,
        name: "ChevronRightBold",
        color: "#35395D"
    }))), /*#__PURE__*/ react.createElement("div", {
        className: "body"
    }, vipConfig.map(function(item, key) {
        return /*#__PURE__*/ react.createElement("div", {
            className: "item",
            key: key
        }, /*#__PURE__*/ react.createElement("div", {
            className: "text"
        }, item.text));
    }))), (0,dist_teamInfo/* getEnterpriseID */.DG)() ? null : /*#__PURE__*/ react.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react.createElement("div", {
        className: (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? "ok" : "cancel",
        onClick: function onClick() {
            var info = identityList === null || identityList === void 0 ? void 0 : identityList.find(function(item) {
                return item.oid === 0;
            });
            if (info) {
                (0,uidKit/* setLocalUid */.Tc)(info.ouid);
            }
            // 标识一定要前置
            (0,dist_teamInfo/* changeIsSwitchIdentityInitiativeState */._U)(true);
            closeHandle();
            (0,xdesign_identity_lib/* setLocalIdentity */.kF)(0, 0);
        },
        style: {
            width: (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? "100%" : ""
        }
    }, "切换个人版"), (curTeamIdentity === null || curTeamIdentity === void 0 ? void 0 : curTeamIdentity.type) === teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? null : /*#__PURE__*/ react.createElement("div", {
        className: "ok",
        onClick: okHandle
    }, "立即续费"))));
};
/* harmony default export */ const teamInfo_expiredModal = (/*#__PURE__*/react.memo(ExpiredModal));


/***/ }),

/***/ 72715:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "hP": () => (/* binding */ SHOW_FREEZE_MODAL),
/* harmony export */   "sW": () => (/* binding */ HIDE_FREEZE_MODAL)
/* harmony export */ });
/* harmony import */ var _ComUI_commonModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40451);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77724);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74107);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50072);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}





var SHOW_FREEZE_MODAL = "xdesign-widget-show-freeze-modal";
var HIDE_FREEZE_MODAL = "xdesign-widget-hide-freeze-modal";
/**
 * 个人冻结
 */ var FreezeModal = function FreezeModal() {
    var showData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        entrance: ""
    });
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    function getStatArgs() {
        return {
            popup_type: "freeze",
            entrance: showData.current.entrance
        };
    }
    function popupClickTrack(className) {
        var _showData$current$onT, _showData$current;
        (_showData$current$onT = (_showData$current = showData.current).onTrack) === null || _showData$current$onT === void 0 ? void 0 : _showData$current$onT.call(_showData$current, "popup_click", _objectSpread(_objectSpread({}, getStatArgs()), {}, {
            class: className
        }));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onShowHandle = function onShowHandle(args) {
            if (args) {
                showData.current = args;
            }
            setOpen(true);
        };
        var onHideHandle = function onHideHandle() {
            setOpen(false);
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].addListener */ .Z.addListener(SHOW_FREEZE_MODAL, onShowHandle);
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].addListener */ .Z.addListener(HIDE_FREEZE_MODAL, onHideHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeListener */ .Z.removeListener(SHOW_FREEZE_MODAL, onShowHandle);
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeListener */ .Z.removeListener(HIDE_FREEZE_MODAL, onHideHandle);
        };
    }, []);
    // 关闭
    var closeHandle = function closeHandle() {
        var _showData$current$onC, _showData$current2;
        setOpen(false);
        popupClickTrack("cancel");
        (_showData$current$onC = (_showData$current2 = showData.current).onClose) === null || _showData$current$onC === void 0 ? void 0 : _showData$current$onC.call(_showData$current2, showData.current.entrance);
    };
    // 确定
    var okHandle = function okHandle() {
        var _showData$current$onO, _showData$current3;
        setOpen(false);
        popupClickTrack("cancel");
        (_showData$current$onO = (_showData$current3 = showData.current).onOK) === null || _showData$current$onO === void 0 ? void 0 : _showData$current$onO.call(_showData$current3, showData.current.entrance);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (open) {
            var _showData$current$onT2, _showData$current4;
            (_showData$current$onT2 = (_showData$current4 = showData.current).onTrack) === null || _showData$current$onT2 === void 0 ? void 0 : _showData$current$onT2.call(_showData$current4, "popup_show", getStatArgs());
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI_commonModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: open,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceFreezeModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "Widget teamSpaceFreezeModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "close",
        onClick: closeHandle
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary, rgba(147, 149, 153, 100%))"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular, rgba(140, 192, 255, 100%))"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "title"
    }, "你已被冻结"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "description"
    }, "当前成员数量超过上限", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null), "若需正常使用请联系团队所有者"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "ok",
        onClick: okHandle
    }, "我知道了"))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(FreezeModal));


/***/ }),

/***/ 11612:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ teamInfo_identitySwitch),
  "N": () => (/* binding */ getTeamTagType)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var types_teamInfo = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useLatest/index.js
var useLatest = __webpack_require__(25182);
// EXTERNAL MODULE: ./node_modules/ahooks/es/utils/index.js
var utils = __webpack_require__(20753);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/isBrowser.js
var isBrowser = !!( true && window.document && window.document.createElement);
/* harmony default export */ const utils_isBrowser = (isBrowser);

;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/domTarget.js


function domTarget_getTargetElement(target, defaultElement) {
    if (!utils_isBrowser) {
        return undefined;
    }
    if (!target) {
        return defaultElement;
    }
    var targetElement;
    if ((0,utils/* isFunction */.mf)(target)) {
        targetElement = target();
    } else if ("current" in target) {
        targetElement = target.current;
    } else {
        targetElement = target;
    }
    return targetElement;
}

// EXTERNAL MODULE: ./node_modules/ahooks/es/useUnmount/index.js
var useUnmount = __webpack_require__(45615);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/depsAreSame.js
function depsAreSame(oldDeps, deps) {
    if (oldDeps === deps) return true;
    for(var i = 0; i < oldDeps.length; i++){
        if (!Object.is(oldDeps[i], deps[i])) return false;
    }
    return true;
}

;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/createEffectWithTarget.js




var createEffectWithTarget = function(useEffectType) {
    /**
   *
   * @param effect
   * @param deps
   * @param target target should compare ref.current vs ref.current, dom vs dom, ()=>dom vs ()=>dom
   */ var useEffectWithTarget = function(effect, deps, target) {
        var hasInitRef = (0,react.useRef)(false);
        var lastElementRef = (0,react.useRef)([]);
        var lastDepsRef = (0,react.useRef)([]);
        var unLoadRef = (0,react.useRef)();
        useEffectType(function() {
            var _a;
            var targets = Array.isArray(target) ? target : [
                target
            ];
            var els = targets.map(function(item) {
                return domTarget_getTargetElement(item);
            });
            // init run
            if (!hasInitRef.current) {
                hasInitRef.current = true;
                lastElementRef.current = els;
                lastDepsRef.current = deps;
                unLoadRef.current = effect();
                return;
            }
            if (els.length !== lastElementRef.current.length || !depsAreSame(lastElementRef.current, els) || !depsAreSame(lastDepsRef.current, deps)) {
                (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
                lastElementRef.current = els;
                lastDepsRef.current = deps;
                unLoadRef.current = effect();
            }
        });
        (0,useUnmount/* default */.Z)(function() {
            var _a;
            (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
            // for react-refresh
            hasInitRef.current = false;
        });
    };
    return useEffectWithTarget;
};
/* harmony default export */ const utils_createEffectWithTarget = (createEffectWithTarget);

;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useEffectWithTarget.js


var useEffectWithTarget = utils_createEffectWithTarget(react.useEffect);
/* harmony default export */ const utils_useEffectWithTarget = (useEffectWithTarget);

;// CONCATENATED MODULE: ./node_modules/ahooks/es/useEventListener/index.js



function useEventListener(eventName, handler, options) {
    if (options === void 0) {
        options = {};
    }
    var _a = options.enable, enable = _a === void 0 ? true : _a;
    var handlerRef = (0,useLatest/* default */.Z)(handler);
    utils_useEffectWithTarget(function() {
        if (!enable) {
            return;
        }
        var targetElement = domTarget_getTargetElement(options.target, window);
        if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
            return;
        }
        var eventListener = function(event) {
            return handlerRef.current(event);
        };
        var eventNameArray = Array.isArray(eventName) ? eventName : [
            eventName
        ];
        eventNameArray.forEach(function(event) {
            targetElement.addEventListener(event, eventListener, {
                capture: options.capture,
                once: options.once,
                passive: options.passive
            });
        });
        return function() {
            eventNameArray.forEach(function(event) {
                targetElement.removeEventListener(event, eventListener, {
                    capture: options.capture
                });
            });
        };
    }, [
        eventName,
        options.capture,
        options.once,
        options.passive,
        enable
    ], options.target);
}
/* harmony default export */ const es_useEventListener = (useEventListener);

// EXTERNAL MODULE: ./node_modules/ahooks/es/useMemoizedFn/index.js
var useMemoizedFn = __webpack_require__(91442);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useUpdateEffect/index.js + 1 modules
var useUpdateEffect = __webpack_require__(78657);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/createUseStorageState/index.js






var SYNC_STORAGE_EVENT_NAME = "AHOOKS_SYNC_STORAGE_EVENT_NAME";
function createUseStorageState(getStorage) {
    function useStorageState(key, options) {
        if (options === void 0) {
            options = {};
        }
        var storage;
        var _a = options.listenStorageChange, listenStorageChange = _a === void 0 ? false : _a, _b = options.onError, onError = _b === void 0 ? function(e) {
            ;
        } : _b;
        // https://github.com/alibaba/hooks/issues/800
        try {
            storage = getStorage();
        } catch (err) {
            onError(err);
        }
        var serializer = function(value) {
            if (options.serializer) {
                return options.serializer(value);
            }
            return JSON.stringify(value);
        };
        var deserializer = function(value) {
            if (options.deserializer) {
                return options.deserializer(value);
            }
            return JSON.parse(value);
        };
        function getStoredValue() {
            try {
                var raw = storage === null || storage === void 0 ? void 0 : storage.getItem(key);
                if (raw) {
                    return deserializer(raw);
                }
            } catch (e) {
                onError(e);
            }
            if ((0,utils/* isFunction */.mf)(options.defaultValue)) {
                return options.defaultValue();
            }
            return options.defaultValue;
        }
        var _c = (0,tslib_es6.__read)((0,react.useState)(getStoredValue), 2), state = _c[0], setState = _c[1];
        (0,useUpdateEffect/* default */.Z)(function() {
            setState(getStoredValue());
        }, [
            key
        ]);
        var updateState = function(value) {
            var currentState = (0,utils/* isFunction */.mf)(value) ? value(state) : value;
            if (!listenStorageChange) {
                setState(currentState);
            }
            try {
                var newValue = void 0;
                var oldValue = storage === null || storage === void 0 ? void 0 : storage.getItem(key);
                if ((0,utils/* isUndef */.G7)(currentState)) {
                    newValue = null;
                    storage === null || storage === void 0 ? void 0 : storage.removeItem(key);
                } else {
                    newValue = serializer(currentState);
                    storage === null || storage === void 0 ? void 0 : storage.setItem(key, newValue);
                }
                dispatchEvent(// send custom event to communicate within same page
                // importantly this should not be a StorageEvent since those cannot
                // be constructed with a non-built-in storage area
                new CustomEvent(SYNC_STORAGE_EVENT_NAME, {
                    detail: {
                        key: key,
                        newValue: newValue,
                        oldValue: oldValue,
                        storageArea: storage
                    }
                }));
            } catch (e) {
                onError(e);
            }
        };
        var syncState = function(event) {
            if (event.key !== key || event.storageArea !== storage) {
                return;
            }
            setState(getStoredValue());
        };
        var syncStateFromCustomEvent = function(event) {
            syncState(event.detail);
        };
        // from another document
        es_useEventListener("storage", syncState, {
            enable: listenStorageChange
        });
        // from the same document but different hooks
        es_useEventListener(SYNC_STORAGE_EVENT_NAME, syncStateFromCustomEvent, {
            enable: listenStorageChange
        });
        return [
            state,
            (0,useMemoizedFn/* default */.Z)(updateState)
        ];
    }
    return useStorageState;
}

;// CONCATENATED MODULE: ./node_modules/ahooks/es/useLocalStorageState/index.js


var useLocalStorageState = createUseStorageState(function() {
    return utils_isBrowser ? localStorage : undefined;
});
/* harmony default export */ const es_useLocalStorageState = (useLocalStorageState);

// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var React_render = __webpack_require__(24996);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91033);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/react-help.js
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}






var useNewTag = function useNewTag(bizKey, VERSION) {
    var _localData$show;
    var _useLocalStorageState = es_useLocalStorageState("newTag-".concat(bizKey, "-").concat(VERSION), {
        defaultValue: {
            show: true
        }
    }), _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2), localData = _useLocalStorageState2[0], setLocalData = _useLocalStorageState2[1];
    return {
        show: (_localData$show = localData === null || localData === void 0 ? void 0 : localData.show) !== null && _localData$show !== void 0 ? _localData$show : false,
        consume: function consume() {
            setLocalData({
                show: false
            });
        }
    };
};
var renderPromise = function renderPromise(node, container) {
    return new Promise(function(resolve) {
        var Root = function Root(_ref) {
            var onMount = _ref.onMount, children = _ref.children;
            useEffect(function() {
                onMount();
            }, []);
            return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
        };
        render(/*#__PURE__*/ React.createElement(Root, {
            onMount: resolve
        }, node), container);
    });
};
var useRect = function useRect(target) {
    var _useRafState = useRafState(function() {
        var el = getTargetElement(target);
        return el ? el.getBoundingClientRect() : undefined;
    }), _useRafState2 = _slicedToArray(_useRafState, 2), state = _useRafState2[0], setState = _useRafState2[1];
    useIsomorphicLayoutEffectWithTarget(function() {
        var el = getTargetElement(target);
        if (!el) {
            return;
        }
        var resizeObserver = new ResizeObserver(function(entries) {
            entries.forEach(function(entry) {
                setState(entry.target.getBoundingClientRect());
            });
        });
        resizeObserver.observe(el);
        return function() {
            resizeObserver.disconnect();
        };
    }, [], target);
    return state;
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-custom-scrollbars/lib/index.js
var lib = __webpack_require__(31298);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/createModal/index.js + 1 modules
var createModal = __webpack_require__(6310);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/loginIdentitySwitchModal/identityRow.js
var identityRow = __webpack_require__(48778);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/teamTag/index.js
var teamTag = __webpack_require__(98053);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js + 35 modules
var teamInfo_utils = __webpack_require__(35601);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/identitySwitch/index.less
var identitySwitch = __webpack_require__(12047);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/identitySwitch/index.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function identitySwitch_slicedToArray(arr, i) {
    return identitySwitch_arrayWithHoles(arr) || identitySwitch_iterableToArrayLimit(arr, i) || identitySwitch_unsupportedIterableToArray(arr, i) || identitySwitch_nonIterableRest();
}
function identitySwitch_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function identitySwitch_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return identitySwitch_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return identitySwitch_arrayLikeToArray(o, minLen);
}
function identitySwitch_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function identitySwitch_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function identitySwitch_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/* eslint-disable @typescript-eslint/no-use-before-define */ 











/** 获取团队标签 */ function getTeamTagType(oid, type) {
    if (oid === 0) return teamTag/* TeamTagType.personal */.n.personal;
    if (type === types_teamInfo/* IdentityType.TEAM */.Mf.TEAM) return teamTag/* TeamTagType.team */.n.team;
    if (type === types_teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE) return teamTag/* TeamTagType.enterprise */.n.enterprise;
    return teamTag/* TeamTagType.free */.n.free;
}
/**
 * 身份选择
 */ var IdentitySwitch = function IdentitySwitch(props) {
    var _teamInfo$identity$li;
    var disabled = props.disabled, hideActions = props.hideActions, hideCreateBtn = props.hideCreateBtn, createTeamModalProps = props.createTeamModalProps, onTrack = props.onTrack;
    var _useState = (0,react.useState)(false), _useState2 = identitySwitch_slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var timer = (0,react.useRef)(0);
    var teamInfo = (0,dist_teamInfo/* useTeamInfoState */.fM)();
    var currentIdentity = (0,dist_teamInfo/* useCurrentTeamIdentity */.q5)();
    var newTagController = useNewTag("createTeam", "2024_v3.0.2");
    var toggleHandle = function toggleHandle(e) {
        setOpen(e);
        clearTimeout(timer.current);
    };
    if (!teamInfo || !currentIdentity) return null;
    var isPersonal = getTeamTagType(currentIdentity.oid, currentIdentity.type) === teamTag/* TeamTagType.personal */.n.personal;
    var hasTeamIdentity = teamInfo.identity.list.length > 1;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("Widget teamSpaceIdentitySwitch", _defineProperty({}, "enterprise-identity", currentIdentity.type === types_teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE))
    }, /*#__PURE__*/ react.createElement("div", {
        className: "header"
    }, hasTeamIdentity ? /*#__PURE__*/ react.createElement("div", {
        onMouseMove: function onMouseMove() {
            if (disabled) return;
            toggleHandle(true);
        },
        onMouseLeave: function onMouseLeave() {
            clearTimeout(timer.current);
            timer.current = setTimeout(function() {
                setOpen(false);
            }, 200);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("teamSpaceIdentitySwitch-trigger", {
            active: open
        }),
        "data-is-personal": isPersonal,
        style: {
            cursor: disabled ? "not-allowed" : "pointer"
        }
    }, currentIdentity.type !== types_teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE ? /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: isPersonal ? "UserBold" : "Enterprise",
        fontSize: isPersonal ? 14 : 18,
        color: "var(--content-web-primary, #17181A)"
    }) : null, /*#__PURE__*/ react.createElement("span", {
        className: "teamSpaceIdentitySwitch-teamName"
    }, isPersonal ? "个人" : (_teamInfo$identity$li = teamInfo.identity.list.find(function(item) {
        return item.oid === teamInfo.identity.oid;
    })) === null || _teamInfo$identity$li === void 0 ? void 0 : _teamInfo$identity$li.name), /*#__PURE__*/ react.createElement("div", {
        className: "teamSpaceIdentitySwitch-switchIcon"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "ChevronDownBlack",
        fontSize: 20
    }))), /*#__PURE__*/ react.createElement("div", {
        className: "IdentitySwitch-list",
        "data-active": open,
        onMouseMove: function onMouseMove() {
            toggleHandle(true);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        style: {
            height: teamInfo.identity.list.length > 3 ? 220 : teamInfo.identity.list.length * 64
        }
    }, /*#__PURE__*/ react.createElement(lib/* Scrollbars */.$B, null, teamInfo.identity.list.map(function(identity) {
        return /*#__PURE__*/ react.createElement(identityRow/* default */.Z, {
            key: identity.oid,
            identity: identity,
            isSelected: teamInfo.identity.oid === identity.oid && teamInfo.identity.groupId === identity.groups[0].id,
            onClick: function onClick() {
                setOpen(false);
                (0,dist_teamInfo/* changeIdentity */.vv)({
                    ouid: identity.ouid,
                    oid: identity.oid,
                    groupId: identity.groups[0].id
                });
            }
        });
    }))), !(0,teamInfo_utils/* isSSO */.yf)() && !hideCreateBtn && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: "divider"
    }), /*#__PURE__*/ react.createElement("div", {
        className: "IdentitySwitch-footer",
        onClick: function onClick() {
            onTrack === null || onTrack === void 0 ? void 0 : onTrack("home_lateral_click", {
                class: "create_team_1"
            });
            (0,createModal/* openCreateTeamModal */.l)({
                create_team_success_entrance: "create_team_1",
                noSwitchIdentity: createTeamModalProps === null || createTeamModalProps === void 0 ? void 0 : createTeamModalProps.noSwitchIdentity,
                onCreatedComplete: createTeamModalProps === null || createTeamModalProps === void 0 ? void 0 : createTeamModalProps.onCreatedComplete,
                onTrack: onTrack
            });
            setOpen(false);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "IdentitySwitch-createIcon"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 18,
        name: "PlusBlack",
        color: "var(--content-web-secondary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "IdentitySwitch-createText"
    }, "创建团队"))))) : !(0,teamInfo_utils/* isSSO */.yf)() && !hideCreateBtn && /*#__PURE__*/ react.createElement("div", {
        className: "create-team-btn",
        onClick: function onClick() {
            newTagController.consume();
            onTrack === null || onTrack === void 0 ? void 0 : onTrack("home_lateral_click", {
                class: "new_create_team"
            });
            (0,createModal/* openCreateTeamModal */.l)({
                create_team_success_entrance: "new_create_team",
                noSwitchIdentity: createTeamModalProps === null || createTeamModalProps === void 0 ? void 0 : createTeamModalProps.noSwitchIdentity,
                onCreatedComplete: createTeamModalProps === null || createTeamModalProps === void 0 ? void 0 : createTeamModalProps.onCreatedComplete,
                onTrack: onTrack
            });
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "EnterpriseAdd",
        fontSize: 14,
        color: "var(--content-web-primary, #17181A)"
    }), /*#__PURE__*/ react.createElement("span", null, "免费创建团队"), newTagController.show && /*#__PURE__*/ react.createElement("div", {
        className: "new-tag"
    }, /*#__PURE__*/ react.createElement(NewTag, null))), !!currentIdentity.oid && !hideActions && /*#__PURE__*/ react.createElement("div", {
        className: "user",
        onClick: function onClick() {
            onTrack === null || onTrack === void 0 ? void 0 : onTrack("home_lateral_click", {
                class: "team_manage"
            });
            window.location.href = "/admin/info";
        }
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "Gear",
        fontSize: 18
    }), /*#__PURE__*/ react.createElement("span", {
        className: "user__text"
    }, "团队管理")))));
};
/* harmony default export */ const teamInfo_identitySwitch = (/*#__PURE__*/react.memo(IdentitySwitch));
var NewTag = function NewTag() {
    return /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "14",
        viewBox: "0 0 24 14",
        fill: "none"
    }, /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_i_37133_66181)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M0 7C0 3.13401 3.13401 0 7 0H17C20.866 0 24 3.13401 24 7C24 10.866 20.866 14 17 14H7C3.13401 14 0 10.866 0 7Z",
        fill: "url(#paint0_linear_37133_66181)"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M4 10V4H5.32743L7.35841 8.65281L6.67699 7.90852H7.0885L7.08407 4H8.23451V10H6.92035L4.87168 5.35135L5.5531 6.09148H5.14159L5.15044 10H4Z",
        fill: "black"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M9.38053 10V4H12.6903V5.0104H10.6814V6.4948H12.5796V7.43451H10.6814V8.9896H12.6903V10H9.38053Z",
        fill: "black"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M14.5796 10L13.4779 4H14.7522L15.3451 8.3659H15.3805L16.0841 4H17.3938L18.1018 8.3659H18.1372L18.7301 4H20L18.9027 10H17.4513L16.7566 5.80457H16.7257L16.031 10H14.5796Z",
        fill: "black"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M3.75 10C3.75 10.1381 3.86193 10.25 4 10.25H5.15044C5.21684 10.25 5.28052 10.2236 5.32742 10.1766C5.37432 10.1296 5.40059 10.0658 5.40044 9.99943L5.394 7.15648L6.69158 10.1008C6.73154 10.1915 6.82127 10.25 6.92035 10.25H8.23451C8.37258 10.25 8.48451 10.1381 8.48451 10V4C8.48451 3.86193 8.37258 3.75 8.23451 3.75H7.08407C7.01772 3.75 6.95409 3.77638 6.90719 3.82332C6.8603 3.87027 6.834 3.93393 6.83407 4.00028L6.83728 6.83403L5.55656 3.89999C5.51679 3.80889 5.42683 3.75 5.32743 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V10ZM9.13053 10C9.13053 10.1381 9.24246 10.25 9.38053 10.25H12.6903C12.8283 10.25 12.9403 10.1381 12.9403 10V8.9896C12.9403 8.85153 12.8283 8.7396 12.6903 8.7396H10.9314V7.68451H12.5796C12.7177 7.68451 12.8296 7.57258 12.8296 7.43451V6.4948C12.8296 6.35673 12.7177 6.2448 12.5796 6.2448H10.9314V5.2604H12.6903C12.8283 5.2604 12.9403 5.14847 12.9403 5.0104V4C12.9403 3.86193 12.8283 3.75 12.6903 3.75H9.38053C9.24246 3.75 9.13053 3.86193 9.13053 4V10ZM14.3338 10.0452C14.3555 10.1638 14.459 10.25 14.5796 10.25H16.031C16.1533 10.25 16.2576 10.1615 16.2776 10.0408L16.7412 7.24142L17.2047 10.0408C17.2247 10.1615 17.329 10.25 17.4513 10.25H18.9027C19.0234 10.25 19.1269 10.1637 19.1486 10.045L20.2459 4.04498C20.2593 3.97201 20.2395 3.89689 20.192 3.83991C20.1445 3.78294 20.0742 3.75 20 3.75H18.7301C18.605 3.75 18.4992 3.84243 18.4824 3.96636L18.0992 6.78799L17.6406 3.95998C17.621 3.83894 17.5164 3.75 17.3938 3.75H16.0841C15.9614 3.75 15.8568 3.83907 15.8373 3.96023L15.3824 6.78274L14.9999 3.96636C14.9831 3.84243 14.8773 3.75 14.7522 3.75H13.4779C13.4037 3.75 13.3333 3.78297 13.2858 3.83998C13.2383 3.897 13.2186 3.97217 13.232 4.04515L14.3338 10.0452Z",
        stroke: "white",
        strokeOpacity: "0.5",
        strokeWidth: "0.5",
        strokeLinejoin: "round"
    })), /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_i_37133_66181",
        x: "0",
        y: "-0.5",
        width: "24",
        height: "14.5",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: "-0.5"
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ react.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        mode: "overlay",
        in2: "shape",
        result: "effect1_innerShadow_37133_66181"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_37133_66181",
        x1: "10.5517",
        y1: "-3.03315e-07",
        x2: "18.6896",
        y2: "10.9963",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: "0.134868",
        stopColor: "#C1FEDD"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: "0.538715",
        stopColor: "#AEECFF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: "1",
        stopColor: "#C7C2FF"
    }))));
};


/***/ }),

/***/ 46718:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": () => (/* binding */ getIsSwitchIdentityInitiative),
/* harmony export */   "DG": () => (/* binding */ getEnterpriseID),
/* harmony export */   "Gl": () => (/* binding */ openTeamFreezePopup),
/* harmony export */   "I3": () => (/* binding */ closeTeamFreezePopup),
/* harmony export */   "Iu": () => (/* binding */ getTeamInfo),
/* harmony export */   "O$": () => (/* binding */ checkTeamHadBuyVip),
/* harmony export */   "P3": () => (/* binding */ enterpriseInit),
/* harmony export */   "Qn": () => (/* binding */ closeTeamExpiredPopup),
/* harmony export */   "SN": () => (/* binding */ findTeamIdentity),
/* harmony export */   "Uy": () => (/* binding */ CHANGE_TEAM_OID),
/* harmony export */   "VF": () => (/* binding */ getCurrentTeamIdentity),
/* harmony export */   "VT": () => (/* binding */ closeIdentitySwitchPopup),
/* harmony export */   "Yr": () => (/* binding */ useHasFetchTeamInfoState),
/* harmony export */   "Yt": () => (/* binding */ checkTeamIsEnterprise),
/* harmony export */   "_U": () => (/* binding */ changeIsSwitchIdentityInitiativeState),
/* harmony export */   "b6": () => (/* binding */ isFromZhanKu),
/* harmony export */   "bl": () => (/* binding */ clearTeamInfo),
/* harmony export */   "fM": () => (/* binding */ useTeamInfoState),
/* harmony export */   "gS": () => (/* binding */ checkUserHasSeat),
/* harmony export */   "gm": () => (/* binding */ getIdentityChangeListenerStatus),
/* harmony export */   "hU": () => (/* binding */ checkIsTeam),
/* harmony export */   "hf": () => (/* binding */ checkTeamMemberState),
/* harmony export */   "kA": () => (/* binding */ openTeamExpiredPopup),
/* harmony export */   "lz": () => (/* binding */ openIdentitySwitchPopupAfterLogin),
/* harmony export */   "mP": () => (/* binding */ checkMemberIsResigned),
/* harmony export */   "mR": () => (/* binding */ fetchTeamInfo),
/* harmony export */   "od": () => (/* binding */ openIdentitySwitchPopup),
/* harmony export */   "q5": () => (/* binding */ useCurrentTeamIdentity),
/* harmony export */   "rM": () => (/* binding */ checkTeamStatusIsFree),
/* harmony export */   "sr": () => (/* binding */ enableIdentityChangeListener),
/* harmony export */   "t2": () => (/* binding */ disableIdentityChangeListener),
/* harmony export */   "vn": () => (/* binding */ checkUserSeatIsFreeze),
/* harmony export */   "vv": () => (/* binding */ changeIdentity),
/* harmony export */   "zb": () => (/* binding */ checkTeamStatusIsVip)
/* harmony export */ });
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97303);
/* harmony import */ var _utils_uidKit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83642);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _types_teamInfo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32485);
/* harmony import */ var _utils_browserKit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11747);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77724);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37057);
/* harmony import */ var _expiredModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40769);
/* harmony import */ var _freezeModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72715);
/* harmony import */ var _loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65229);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35601);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













/** @deprecated TODO: 过渡防止其他人本地使用报错, 下个版本去掉 (不需要从这导出, 根目录导出即可) */ 
var teamInfoData = null;
// 标识是否该项目是否用户主动切换身份动作
var isSwitchIdentityInitiative = false;
/** 标识是否该项目是否用户主动切换身份动作 */ var getIsSwitchIdentityInitiative = function getIsSwitchIdentityInitiative() {
    return isSwitchIdentityInitiative;
};
// 用来控制业务是否开启身份变化监听回掉
var identityChangeListenerStatus = false;
/** 用来控制业务是否开启身份变化监听回掉 */ var getIdentityChangeListenerStatus = function getIdentityChangeListenerStatus() {
    return identityChangeListenerStatus;
};
var hasFetchTeamInfo = false;
// 刷新是否获取团队信息状态事件
var REFRESH_FETCH_TEAM_INFO_STATUS = "xdesign-widget-refresh-fetch-team-info-status";
// 刷新团队信息事件
var REFRESH_TEAM_INFO = "xdesign-widget-refresh-team-info";
// 团队身份变更事件
var CHANGE_TEAM_OID = "xdesign-widget-change-team-oid";
// 开启身份变化监听
var enableIdentityChangeListener = function enableIdentityChangeListener() {
    identityChangeListenerStatus = true;
};
// 关闭身份变化监听
var disableIdentityChangeListener = function disableIdentityChangeListener() {
    identityChangeListenerStatus = false;
};
var changeIsSwitchIdentityInitiativeState = function changeIsSwitchIdentityInitiativeState(val) {
    isSwitchIdentityInitiative = val;
};
// 定制企业sso授权相关逻辑初始化
var enterpriseInit = _utils__WEBPACK_IMPORTED_MODULE_3__/* .init */ .S1;
// 获取enterprise企业标识
var getEnterpriseID = function getEnterpriseID() {
    var enterpriseID = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEnterpriseIDKey */ .bo)()) || "";
    return enterpriseID;
};
// 是否来自站酷的团队
var isFromZhanKu = function isFromZhanKu() {
    var _getLocalIdentity;
    return !!((_getLocalIdentity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) !== null && _getLocalIdentity !== void 0 && _getLocalIdentity.oid) && getEnterpriseID() === "zhanku";
};
/** 刷新团队信息 */ var fetchTeamInfo = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
        var local, changeIdentity, _local3, userIdentity, identity, identityPersonal, teamMember, _local4;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)();
                    changeIdentity = false;
                    if (!local) {
                        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .setLocalIdentity */ .kF)(0, 0, false);
                        local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)();
                        changeIdentity = true;
                    }
                    ;
                    _context.prev = 4;
                    _context.next = 7;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_4__/* .fetchTeamIdentityList */ .hc)();
                case 7:
                    userIdentity = _context.sent;
                    identity = userIdentity.list.find(function(v) {
                        var _local;
                        return v.oid === ((_local = local) === null || _local === void 0 ? void 0 : _local.oid) && !!v.groups.find(function(k) {
                            var _local2;
                            return k.id === ((_local2 = local) === null || _local2 === void 0 ? void 0 : _local2.groupId);
                        });
                    }); // 个人身份数据
                    identityPersonal = userIdentity.list.find(function(v) {
                        return v.oid === 0;
                    });
                    if (!((_local3 = local) !== null && _local3 !== void 0 && _local3.oid)) {
                        _context.next = 14;
                        break;
                    }
                    _context.next = 13;
                    return (0,_api__WEBPACK_IMPORTED_MODULE_4__/* .fetchTeamMemberInfo */ .Ay)();
                case 13:
                    teamMember = _context.sent;
                case 14:
                    // 离职身份需要停留在当前页面, 不做身份切换
                    if (!identity) {
                        identityPersonal && (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_5__/* .setLocalUid */ .Tc)(identityPersonal.ouid);
                        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .setLocalIdentity */ .kF)(0, 0);
                        local = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)();
                        changeIdentity = true;
                    }
                    teamInfoData = {
                        identity: _objectSpread(_objectSpread({}, local), userIdentity),
                        member: teamMember
                    };
                    _context.next = 28;
                    break;
                case 18:
                    _context.prev = 18;
                    _context.t0 = _context["catch"](4);
                    ;
                    // 页面跳转时, safari会中断请求, 并抛出异常, 这里不能将身份进行切换
                    if (!(0,_utils_browserKit__WEBPACK_IMPORTED_MODULE_6__/* .checkIsBeforeUnload */ .OF)()) {
                        _context.next = 23;
                        break;
                    }
                    return _context.abrupt("return");
                case 23:
                    teamInfoData = null;
                    ;
                    (// 如果团队身份列表接口挂了，当前身份角色非本人的话，需要移除本地uid
                    (_local4 = local) === null || _local4 === void 0 ? void 0 : _local4.oid) && (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_5__/* .removeLocalUid */ .Yz)();
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .setMemoryIdentity */ .LW)(0, 0);
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .setLocalIdentity */ .kF)(0, 0, false);
                case 28:
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(REFRESH_TEAM_INFO, teamInfoData);
                    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(REFRESH_FETCH_TEAM_INFO_STATUS);
                    hasFetchTeamInfo = true;
                    if (changeIdentity && teamInfoData && teamInfoData.identity.list.length >= 2) {
                        _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(CHANGE_TEAM_OID);
                    }
                case 32:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                18
            ]
        ]);
    }));
    return function fetchTeamInfo() {
        return _ref.apply(this, arguments);
    };
}();
/** 获取团队信息 */ var getTeamInfo = function getTeamInfo() {
    return teamInfoData;
};
/** 获取团队信息hook */ var useTeamInfoState = function useTeamInfoState() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(teamInfoData), _useState2 = _slicedToArray(_useState, 2), data = _useState2[0], setData = _useState2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var refreshHandle = function refreshHandle(e) {
            setData(e);
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].addListener */ .Z.addListener(REFRESH_TEAM_INFO, refreshHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].removeListener */ .Z.removeListener(REFRESH_TEAM_INFO, refreshHandle);
        };
    }, []);
    return data;
};
// 是否请求过团队信息接口标识
var useHasFetchTeamInfoState = function useHasFetchTeamInfoState() {
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(hasFetchTeamInfo), _useState4 = _slicedToArray(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleFn = function handleFn() {
            setStatus(true);
            hasFetchTeamInfo = true;
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].addListener */ .Z.addListener(REFRESH_FETCH_TEAM_INFO_STATUS, handleFn);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].removeListener */ .Z.removeListener(REFRESH_FETCH_TEAM_INFO_STATUS, handleFn);
        };
    }, []);
    return status;
};
/** 查找指定的团队身份 */ function findTeamIdentity(oid, groupId, teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return null;
    return usedTeamInfo.identity.list.find(function(v) {
        return v.oid === oid && v.groups[0].id === groupId;
    });
}
/** 获取当前团队的身份信息 */ function useCurrentTeamIdentity() {
    var teamInfo = useTeamInfoState();
    if (!teamInfo) return null;
    return findTeamIdentity(teamInfo.identity.oid, teamInfo.identity.groupId);
}
/** 获取当前团队的身份信息 */ function getCurrentTeamIdentity(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return null;
    return findTeamIdentity(usedTeamInfo.identity.oid, usedTeamInfo.identity.groupId);
}
/** 打开团队过期弹窗 */ var openTeamExpiredPopup = function openTeamExpiredPopup(args) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(_expiredModal__WEBPACK_IMPORTED_MODULE_8__/* .SHOW_EXPIRED_MODAL */ .e1, args);
};
/** 关闭团队过期弹窗 */ var closeTeamExpiredPopup = function closeTeamExpiredPopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(_expiredModal__WEBPACK_IMPORTED_MODULE_8__/* .HIDE_EXPIRED_MODAL */ .c7);
};
/** 打开团队冻结弹窗 */ var openTeamFreezePopup = function openTeamFreezePopup(args) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(_freezeModal__WEBPACK_IMPORTED_MODULE_9__/* .SHOW_FREEZE_MODAL */ .hP, args);
};
/** 关闭团队冻结弹窗 */ var closeTeamFreezePopup = function closeTeamFreezePopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(_freezeModal__WEBPACK_IMPORTED_MODULE_9__/* .HIDE_FREEZE_MODAL */ .sW);
};
/** 打开身份切换弹窗 */ var openIdentitySwitchPopup = function openIdentitySwitchPopup(opts) {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, opts !== null && opts !== void 0 ? opts : {});
};
/** 关闭身份切换弹窗 */ var closeIdentitySwitchPopup = function closeIdentitySwitchPopup() {
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM);
};
/** 检测当前成员是否已离职 */ var checkMemberIsResigned = function checkMemberIsResigned(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.job_status === 2;
};
/** 检测个人是否冻结 */ function checkUserSeatIsFreeze(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return !checkMemberIsResigned(usedTeamInfo) && usedTeamInfo.member.seat_status === _types_teamInfo__WEBPACK_IMPORTED_MODULE_11__/* .TeamSeatStatus.Freeze */ .cc.Freeze;
}
/** 检测个人是否有席位 */ function checkUserHasSeat(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.has_seat && usedTeamInfo.member.seat_status === _types_teamInfo__WEBPACK_IMPORTED_MODULE_11__/* .TeamSeatStatus.Effect */ .cc.Effect;
}
var checkIsTeam = function checkIsTeam(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return !!(usedTeamInfo !== null && usedTeamInfo !== void 0 && usedTeamInfo.identity.oid);
};
var checkTeamIsEnterprise = function checkTeamIsEnterprise(teamInfo) {
    var _getLocalIdentity2;
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo) return false;
    var oid = (_getLocalIdentity2 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity2 === void 0 ? void 0 : _getLocalIdentity2.oid;
    if (!oid) return false;
    var identity = usedTeamInfo.identity.list.find(function(item) {
        return item.oid === oid;
    });
    return (identity === null || identity === void 0 ? void 0 : identity.type) === _types_teamInfo__WEBPACK_IMPORTED_MODULE_11__/* .IdentityType.ENTERPRISE */ .Mf.ENTERPRISE;
};
/** 检测团队状态是否为vip */ function checkTeamStatusIsVip(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    if (!usedTeamInfo || !usedTeamInfo.member) return null;
    return usedTeamInfo.member.team.is_vip;
}
var checkTeamStatusIsFree = function checkTeamStatusIsFree(teamInfo) {
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return checkIsTeam(usedTeamInfo) && !checkTeamStatusIsVip(usedTeamInfo) && !checkTeamIsEnterprise(usedTeamInfo);
};
var checkTeamHadBuyVip = function checkTeamHadBuyVip(teamInfo) {
    var _usedTeamInfo$member;
    var usedTeamInfo = teamInfo !== null && teamInfo !== void 0 ? teamInfo : getTeamInfo();
    return checkIsTeam(usedTeamInfo) && !!(usedTeamInfo !== null && usedTeamInfo !== void 0 && (_usedTeamInfo$member = usedTeamInfo.member) !== null && _usedTeamInfo$member !== void 0 && _usedTeamInfo$member.team.had_buy);
};
/** 清空团队数据 */ function clearTeamInfo() {
    closeTeamExpiredPopup();
    closeTeamFreezePopup();
    teamInfoData = null;
    _utils_eventBus__WEBPACK_IMPORTED_MODULE_7__/* ["default"].emit */ .Z.emit(REFRESH_TEAM_INFO, null);
    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .removeLocalIdentity */ .mK)();
}
/** 切换个人/团队身份 */ var changeIdentity = function changeIdentity(identity) {
    var _teamInfo$identity$oi, _teamInfo$identity$gr;
    var teamInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getTeamInfo();
    var currentOid = (_teamInfo$identity$oi = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid) !== null && _teamInfo$identity$oi !== void 0 ? _teamInfo$identity$oi : 0;
    var currentGroupId = (_teamInfo$identity$gr = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId) !== null && _teamInfo$identity$gr !== void 0 ? _teamInfo$identity$gr : 0;
    if (currentOid !== identity.oid || currentGroupId !== identity.groupId) {
        // 标识一定要前置
        changeIsSwitchIdentityInitiativeState(true);
    }
    (0,_utils_uidKit__WEBPACK_IMPORTED_MODULE_5__/* .setLocalUid */ .Tc)(identity.ouid);
    // 切换身份同步cookie
    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .setLocalIdentity */ .kF)(identity.oid, identity.groupId);
};
/**
 * 登录后打开身份切换弹窗的相关逻辑
 * @param originUid 大账号登录后返回的uid
 * @param accessToken 大账号登录后返回的token
 * @returns
 */ var openIdentitySwitchPopupAfterLogin = /*#__PURE__*/ function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(originUid, accessToken) {
        var _teamInfoData, _teamInfoData$identit;
        var _getConfig, isIntl, isTeam, info, teamIdentity;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_12__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl, isTeam = _getConfig.isTeam;
                    ;
                    // 海外或者非团队版不走以下逻辑
                    if (!(isIntl || !isTeam)) {
                        _context2.next = 4;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 4:
                    if (accessToken) window.localStorage.setItem("access_token", accessToken);
                    // 1、如果本地缓存团队身份对应的原始ID(origin_id)与当前登录账号的ID一致，则自动切换成缓存的身份且刷新页面；
                    // 2、如果本地无缓存团队身份，则唤起身份切换弹窗：
                    //    2.1、如果无团队，则自动走个人身份，无需唤起身份切换弹窗；
                    //    2.2、如果有团队，则唤起身份切换弹窗。
                    // 更新cookie中的origin_uid
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .setLocalOriginUid */ .Nz)(originUid);
                    // 获取缓存中的最近身份信息
                    info = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalRecentIdentity */ .pB)();
                    if (!(info && info.originUid === originUid)) {
                        _context2.next = 13;
                        break;
                    }
                    // 最近登录的团队身份和当前账号匹配，直接切成最近登录的身份
                    changeIdentity({
                        oid: info.oid,
                        groupId: info.groupId,
                        ouid: info.ouid || 0
                    });
                    if (!info.oid) {
                        _context2.next = 12;
                        break;
                    }
                    window.location.reload();
                    return _context2.abrupt("return", false);
                case 12:
                    return _context2.abrupt("return", true);
                case 13:
                    (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .removeLocalRecentIdentity */ .tK)();
                    // 拉取团队数据接口
                    _context2.next = 16;
                    return fetchTeamInfo();
                case 16:
                    // 团队身份数据
                    teamIdentity = ((_teamInfoData = teamInfoData) === null || _teamInfoData === void 0 ? void 0 : (_teamInfoData$identit = _teamInfoData.identity.list) === null || _teamInfoData$identit === void 0 ? void 0 : _teamInfoData$identit.filter(function(v) {
                        return v.oid;
                    })) || [];
                    if (teamIdentity.length) {
                        _context2.next = 19;
                        break;
                    }
                    return _context2.abrupt("return", true);
                case 19:
                    return _context2.abrupt("return", new Promise(function(resolve) {
                        openIdentitySwitchPopup({
                            showCloseBtn: false,
                            hideCreateBtn: true,
                            hideSelectedStatus: true,
                            onSwitchComplete: function onSwitchComplete(_ref3) {
                                var oid = _ref3.oid;
                                if (oid) {
                                    // 选择的是团队身份，则刷新页面
                                    window.location.reload();
                                    resolve(false);
                                } else {
                                    // 选择的是个人身份，则继续走业务
                                    resolve(true);
                                }
                            }
                        });
                    }));
                case 20:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function openIdentitySwitchPopupAfterLogin(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var checkTeamMemberState = function checkTeamMemberState(_teamInfo) {
    var _teamInfo$identity$li, _teamInfo$identity$li2, _teamInfo$member$team, _teamInfo$member;
    var teamInfo = _teamInfo !== null && _teamInfo !== void 0 ? _teamInfo : getTeamInfo();
    var userCount = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 ? void 0 : (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(item) {
        var _getLocalIdentity3;
        return item.oid === ((_getLocalIdentity3 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity3 === void 0 ? void 0 : _getLocalIdentity3.oid);
    })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.member_num) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : 0;
    /** 可操作席位数 (当前成员数+剩余可邀请席位数) */ var operableNum = (_teamInfo$member$team = teamInfo === null || teamInfo === void 0 ? void 0 : (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.team.member_detail.operable_num) !== null && _teamInfo$member$team !== void 0 ? _teamInfo$member$team : 0;
    return {
        isExcess: userCount > operableNum,
        hasSeat: userCount < operableNum
    };
};


/***/ }),

/***/ 48778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97303);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8209);
/* harmony import */ var _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56874);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74107);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _identitySwitch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11612);
/* harmony import */ var _teamLogo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42155);
/* harmony import */ var _teamTag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98053);
/* harmony import */ var _identityRow_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38867);
/* harmony import */ var _identityRow_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_identityRow_less__WEBPACK_IMPORTED_MODULE_1__);









// eslint-disable-next-line @typescript-eslint/no-unused-vars
var IdentityRow_CheckBox = function IdentityRow_CheckBox(_ref) {
    var isSelected = _ref.isSelected;
    return /*#__PURE__*/ React.createElement("div", {
        className: "IdentityRow_CheckBox",
        "data-active": isSelected
    });
};
var IdentityRow_TickIcon = function IdentityRow_TickIcon(_ref2) {
    var isSelected = _ref2.isSelected;
    return isSelected ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        fontSize: 16,
        name: "CheckBold",
        color: "var(--content-system-link, #3388FF)"
    }) : null;
};
var IdentityRow = function IdentityRow(_ref3) {
    var _identity$groups$, _identity$groups$2, _identity$groups$3;
    var identity = _ref3.identity, isSelected = _ref3.isSelected, onClick = _ref3.onClick, _ref3$selectedIcon = _ref3.selectedIcon, selectedIcon = _ref3$selectedIcon === void 0 ? "TickIcon" : _ref3$selectedIcon;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)(), isIntl = _useConfig.isIntl;
    var teamType = (0,_identitySwitch__WEBPACK_IMPORTED_MODULE_4__/* .getTeamTagType */ .N)(identity.oid, identity.type);
    // const Icon =
    //   selectedIcon === 'CheckBox'
    //     ? IdentityRow_CheckBox
    //     : selectedIcon === 'TickIcon'
    //     ? IdentityRow_TickIcon
    //     : selectedIcon;
    var Icon = IdentityRow_TickIcon;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow",
        "data-identity-type": identity.type,
        "data-active": isSelected,
        onClick: onClick
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-left"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-avatar"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teamLogo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        src: identity.logo,
        size: "medium",
        name: identity.name,
        oid: identity.oid
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-infoBox"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-infoBox-top"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-name"
    }, identity.alias || identity.name), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-teamTag"
    }, ((_identity$groups$ = identity.groups[0]) === null || _identity$groups$ === void 0 ? void 0 : _identity$groups$.is_vip) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: identity.type === 0 ? isIntl ? ((_identity$groups$2 = identity.groups[0]) === null || _identity$groups$2 === void 0 ? void 0 : _identity$groups$2.vip_level) === _types__WEBPACK_IMPORTED_MODULE_6__/* .VipLevel.Pro */ .Dv.Pro ? _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_7__/* .userXdesignProVip */ .OY : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_7__/* .userXdesignPlusVip */ .ZB : ((_identity$groups$3 = identity.groups[0]) === null || _identity$groups$3 === void 0 ? void 0 : _identity$groups$3.vip_level) === _types__WEBPACK_IMPORTED_MODULE_6__/* .VipLevel.ProCn */ .Dv.ProCn ? _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_7__/* .userPrpVip */ .PS : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_7__/* .userVip */ .g : _userInfo_constants_inedx__WEBPACK_IMPORTED_MODULE_7__/* .teamVip */ .vD,
        style: identity.type === 0 ? {
            height: 16
        } : {
            width: 36,
            height: 15
        },
        alt: ""
    }))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-detailInfo"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        name: teamType === _teamTag__WEBPACK_IMPORTED_MODULE_8__/* .TeamTagType.personal */ .n.personal ? "User" : "Enterprise",
        fontSize: 12
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: "IdentityRow-memberNum"
    }, teamType === _teamTag__WEBPACK_IMPORTED_MODULE_8__/* .TeamTagType.personal */ .n.personal ? 1 : identity.member_num, "人")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "IdentityRow-selectedIcon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, {
        isSelected: isSelected
    })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (IdentityRow);


/***/ }),

/***/ 65229:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BM": () => (/* binding */ HIDDEN_IDENTITY_SWITCH_MODAL),
/* harmony export */   "Mg": () => (/* binding */ SHOW_IDENTITY_SWITCH_MODAL),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _ComUI__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40451);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97303);
/* harmony import */ var _loading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85776);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74107);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_custom_scrollbars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31298);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46718);
/* harmony import */ var _createModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6310);
/* harmony import */ var _identityRow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48778);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76511);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_3__);











// 展示身份切换弹窗事件
var SHOW_IDENTITY_SWITCH_MODAL = "xdesign-widget-show-identity-switch-modal";
// 隐藏身份切换弹窗事件
var HIDDEN_IDENTITY_SWITCH_MODAL = "xdesign-widget-hidden-identity-switch-modal";
/**
 * 登陆后身份选择
 */ var LoginIdentitySwitchModal = function LoginIdentitySwitchModal(_ref) {
    var _teamInfo$identity$li, _getLocalIdentity, _teamInfo$identity$li2;
    var _ref$showCloseBtn = _ref.showCloseBtn, showCloseBtn = _ref$showCloseBtn === void 0 ? false : _ref$showCloseBtn, hideCreateBtn = _ref.hideCreateBtn, create_team_success_entrance = _ref.create_team_success_entrance, _ref$project = _ref.project, project = _ref$project === void 0 ? "" : _ref$project, _ref$noSwitchIdentity = _ref.noSwitchIdentity, noSwitchIdentity = _ref$noSwitchIdentity === void 0 ? false : _ref$noSwitchIdentity, _ref$filterIdentities = _ref.filterIdentities, filterIdentities = _ref$filterIdentities === void 0 ? function() {
        return true;
    } : _ref$filterIdentities, onSwitchComplete = _ref.onSwitchComplete, onClose = _ref.onClose, onTrack = _ref.onTrack, topTip = _ref.topTip, hideSelectedStatus = _ref.hideSelectedStatus;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_4__/* .useConfig */ .ZR)(), loginIdentitySwitchModalConfig = _useConfig.loginIdentitySwitchModalConfig;
    var teamInfo = (0,___WEBPACK_IMPORTED_MODULE_5__/* .useTeamInfoState */ .fM)();
    // 关闭
    var handleConfirm = function handleConfirm(oid, groupId, ouid) {
        if (!teamInfo) return;
        onSwitchComplete === null || onSwitchComplete === void 0 ? void 0 : onSwitchComplete({
            oid: oid,
            groupId: groupId,
            ouid: ouid
        }, {
            isFromCreate: false
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
        if (!noSwitchIdentity) {
            (0,___WEBPACK_IMPORTED_MODULE_5__/* .changeIdentity */ .vv)({
                ouid: ouid,
                oid: oid,
                groupId: groupId
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (teamInfo) {
            _loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"].hidden */ .Z.hidden();
        } else {
            _loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"].show */ .Z.show("加载中...");
        }
    }, [
        teamInfo
    ]);
    var displayIdentities = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list.filter(filterIdentities)) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : [];
    var personlIsShow = displayIdentities.some(function(it) {
        return it.type === 0;
    });
    if (!teamInfo) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ComUI__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceLoginIdentitySwitchModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "Widget teamSpaceLoginIdentitySwitchModal"
    }, showCloseBtn && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "close",
        onClick: ___WEBPACK_IMPORTED_MODULE_5__/* .closeIdentitySwitchPopup */ .VT
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "title"
    }, personlIsShow ? "选择身份" : "选择团队身份"), loginIdentitySwitchModalConfig.showEditorSaveTip && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "editing-save-tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        style: {
            marginRight: 4
        },
        name: "InfoCircleBoldFill",
        fontSize: 16,
        color: "var(--content-system-info-icon-regular, #8CC0FF)"
    }), topTip !== null && topTip !== void 0 ? topTip : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, "如正在编辑，作图/生成记录将保存在", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, ((_getLocalIdentity = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity === void 0 ? void 0 : _getLocalIdentity.oid) === 0 ? "个人设计师" : (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(it) {
        var _getLocalIdentity2;
        return it.oid === ((_getLocalIdentity2 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity2 === void 0 ? void 0 : _getLocalIdentity2.oid);
    })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.name), "的空间")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "list",
        style: {
            height: teamInfo.identity.list.length > 3 ? 240 : teamInfo.identity.list.length * 74
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_custom_scrollbars__WEBPACK_IMPORTED_MODULE_2__/* .Scrollbars */ .$B, {
        className: "loginIdentitySwitchModal-scrollbars"
    }, displayIdentities.map(function(identity, key) {
        var _getLocalIdentity3;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
            key: key,
            style: {
                margin: "0 16px"
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_identityRow__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            identity: identity,
            isSelected: !hideSelectedStatus && identity.oid === ((_getLocalIdentity3 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) === null || _getLocalIdentity3 === void 0 ? void 0 : _getLocalIdentity3.oid),
            onClick: function onClick() {
                return handleConfirm(identity.oid, identity.groups[0].id, identity.ouid);
            }
        }));
    }))), !hideCreateBtn ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "team-create-box",
        onClick: function onClick() {
            (0,___WEBPACK_IMPORTED_MODULE_5__/* .closeIdentitySwitchPopup */ .VT)();
            (0,_createModal__WEBPACK_IMPORTED_MODULE_10__/* .openCreateTeamModal */ .l)({
                onTrack: onTrack,
                create_team_success_entrance: create_team_success_entrance,
                project: project,
                noSwitchIdentity: noSwitchIdentity,
                onCreatedComplete: function onCreatedComplete(data) {
                    return onSwitchComplete === null || onSwitchComplete === void 0 ? void 0 : onSwitchComplete({
                        oid: data.oid,
                        groupId: data.group_id,
                        ouid: data.ouid
                    }, {
                        isFromCreate: true
                    });
                }
            });
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "team-create-btn"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "team-create-icon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        fontSize: 18,
        name: "PlusBlack",
        color: "var(--content-web-secondary)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "team-create-text"
    }, "免费创建新团队"))) : null));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(LoginIdentitySwitchModal));


/***/ }),

/***/ 42155:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68795);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);



/**
 * 团队 logo
 */ var TeamLogo = function TeamLogo(_ref) {
    var size = _ref.size, src = _ref.src, name = _ref.name, grayscale = _ref.grayscale, oid = _ref.oid;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("Widget", "teamLogo", {
            grayscale: grayscale,
            "user-avatar": !oid
        })
    }, src ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
        src: src,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("img", size)
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("name", size)
    }, name.substring(0, 1)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TeamLogo));


/***/ }),

/***/ 98053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "n": () => (/* binding */ TeamTagType)
/* harmony export */ });
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74107);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57926);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}




var TeamTagType = /*#__PURE__*/ function(TeamTagType) {
    TeamTagType["personal"] = "personal";
    TeamTagType["team"] = "team";
    TeamTagType["enterprise"] = "enterprise";
    TeamTagType["free"] = "free";
    return TeamTagType;
}({});
var nameType = {
    personal: "个人版",
    team: "团队版",
    enterprise: "企业版",
    free: "免费版"
};
/**
 * 团队 tag
 */ var TeamTag = function TeamTag(_ref) {
    var size = _ref.size, type = _ref.type, selectIcon = _ref.selectIcon, grayscale = _ref.grayscale, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _onClick = _ref.onClick;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("Widget", "teamTag", type, size, {
            grayscale: grayscale,
            selectIcon: !!selectIcon
        }),
        style: _objectSpread({}, style),
        onClick: function onClick() {
            return _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        className: "txt"
    }, nameType[type]), selectIcon ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        style: {
            transform: "translate(1px, -50%) scale(".concat(8 / 12, ")"),
            position: "absolute",
            top: "50%"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fontSize: 12,
        name: "ChevronDownBlack"
    })) : null);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TeamTag));


/***/ }),

/***/ 35601:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cm": () => (/* binding */ createTeam),
  "W2": () => (/* binding */ getAccessTokenCookieKey),
  "bo": () => (/* binding */ getEnterpriseIDKey),
  "fZ": () => (/* binding */ handleReportDownloadResult),
  "S1": () => (/* binding */ init),
  "yf": () => (/* binding */ isSSO)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(20134);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/configProvider/index.js
var configProvider = __webpack_require__(97303);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/enum.js
/**
 * 上传环境
 */
var enum_UploadEnv;
(function (UploadEnv) {
    /**
     * 上传环境：正式环境
     */
    UploadEnv[UploadEnv["Release"] = 0] = "Release";
    /**
     * 上传环境：测试环境
     */
    UploadEnv[UploadEnv["Test"] = 1] = "Test";
})(enum_UploadEnv || (enum_UploadEnv = {}));
/**
 * 上传 Token 请求接口地址
 *
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=48137491
 */
var UploadTokenAPI;
(function (UploadTokenAPI) {
    /**
     * 上传 Token 请求接口地址：正式环境
     */
    UploadTokenAPI["Release"] = "https://strategy.app.meitudata.com/upload/policy";
    /**
     * 上传 Token 请求接口地址：测试环境
     */
    UploadTokenAPI["Test"] = "http://prestrategy.meitubase.com/upload/policy";
})(UploadTokenAPI || (UploadTokenAPI = {}));
/**
 * 云存储服务提供商枚举对象
 */
var enum_Cloud;
(function (Cloud) {
    /**
     * 云存储提供商：未知
     *
     * @since 4.4.0
     */
    Cloud["Unknown"] = "";
    /**
     * 云存储提供商：亚马逊 AWS S3
     */
    Cloud["AWSS3"] = "aws-s3";
    /**
     * 云存储提供商：华为云（实现的 AWS S3 访问协议）
     */
    Cloud["HuaweiS3"] = "hw-s3";
    /**
     * 云存储提供商：七牛云
     */
    Cloud["Qiniu"] = "qiniu";
    /**
     * 云存储提供商：美图云（基于七牛云）
     */
    Cloud["MeituYun"] = "mtyun";
    /**
     * 云存储提供商：阿里云 OSS
     *
     * @since 4.3.0
     */
    Cloud["OSS"] = "oss";
})(enum_Cloud || (enum_Cloud = {}));
/**
 * 云存储提供商列表
 */
const Clouds = Object.values(enum_Cloud).filter((value) => typeof value === 'string');

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/constants.js

/**
 * 控制台日志前缀
 *
 * @since 4.1.0
 */
const LOG_PREFIX = '[@meitu/upload]';
/**
 * 上传 Token 一次最少获取数量
 *
 * @since 4.4.0
 */
const MIN_TOKEN_COUNT = 1;
/**
 * 上传 Token 一次最多获取数量
 *
 * @since 4.4.0
 */
const constants_MAX_TOKEN_COUNT = 20;
/**
 * 默认的上传 Token 接口请求参数
 */
const constants_defaultUploadTokenRequestParams = {
    app: '',
    type: '',
    count: 1,
    suffix: '',
    sig: '',
    sigTime: '',
    sigVersion: '1.3',
    version: '2',
};
/**
 * 获取默认的上传配置选项
 *
 * @since 4.6.1
 * @param options 可选；自定义配置选项
 */
function constants_getDefaultUploaderOptions(options) {
    return Object.assign({ debug: false, env: enum_UploadEnv.Release, accessToken: '', appProxy: false, sign: (params) => params, progress: (data) => data }, options);
}
/**
 * 默认的上传配置选项
 *
 * @deprecated 至 `v4.6.1` 版本起弃用，请改用 `getDefaultUploaderOptions()`
 */
const defaultUploaderOptions = constants_getDefaultUploaderOptions();
/**
 * 默认的文件分片大小
 *
 * @since 4.6.0
 */
const DEFAULT_PART_SIZE = (/* unused pure expression or super */ null && (1024 * 1024 * 4));
/**
 * 默认的错误重试次数
 *
 * @since 4.8.0
 */
const DEFAULT_RETRY_COUNT = 3;
/**
 * 限制最小分片大小
 *
 * @since 4.6.0
 *
 * - 云服务器限制，单个分片不允许小于 100kb
 */
const MIN_PART_SIZE = (/* unused pure expression or super */ null && (1024 * 100));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/utils.js

/**
 * 键值对键名转换为小驼峰命名风格
 *
 * @param obj 键值对或键值对数组
 */
function utils_toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map((item) => utils_toCamelCase(item));
    }
    else if (typeof obj === 'object') {
        const temp = {};
        for (const i in obj) {
            const key = i.replace(/_([A-Za-z])/g, (_$0, $1) => $1.toUpperCase());
            temp[key] = typeof obj[i] === 'object' ? utils_toCamelCase(obj[i]) : obj[i];
        }
        return temp;
    }
    else {
        return obj;
    }
}
/**
 * 键值对对象转换为请求字符串
 *
 * @param kv     键值对对象
 * @param filter 自定义过滤方法
 */
function utils_keyValueToQueryStrings(kv, filter) {
    return Object.entries(kv)
        .filter((_) => {
        if (filter) {
            return filter(_);
        }
        return _[1] !== 'undefined' && _[1] !== '';
    })
        .map(([key, value]) => `${key}=${value}`)
        .sort()
        .join('&');
}
/**
 * 判断当前是不是 S3 云存储服务
 *
 * @since 4.2.0
 * @param cloud 云服务名称
 */
function isS3(cloud) {
    return cloud === enum_Cloud.HuaweiS3 || cloud === enum_Cloud.AWSS3 || cloud === enum_Cloud.OSS;
}
/**
 * 获取文件的扩展名
 *
 * @since 4.2.0
 * @param fileName 文件名
 */
function utils_getFileExtension(fileName) {
    var _a;
    return ((_a = fileName.match(/\.(\w+)$/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
}
/**
 * 从 Data URL 中获取文件的扩展名
 *
 * @since 4.2.0
 * @param dataURL Data URL 字符串
 */
function utils_getFileExtensionByDataURL(dataURL) {
    var _a, _b, _c, _d, _e, _f;
    return (((_f = (_e = (_d = (_c = (_b = (_a = dataURL
        .split(',')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.match) === null || _c === void 0 ? void 0 : _c.call(_b, /:(.*?);/)) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.split('/')) === null || _f === void 0 ? void 0 : _f[1]) || '');
}
/**
 * 生成 TaskId
 *
 * @since 4.7.0
 */
function generateTaskId() {
    var _a, _b;
    const _generateTaskId = () => {
        return '00000000-0000-4000-1000-000000000000'.replace(/[10]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === '0' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    try {
        if ((_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
            return window.crypto.randomUUID();
        }
        if ((_b = window === null || window === void 0 ? void 0 : window.crypto) === null || _b === void 0 ? void 0 : _b.getRandomValues) {
            const unsafeStringify = (arr) => {
                const byteToHex = [];
                let str = '';
                for (let i = 0; i < 256; ++i) {
                    byteToHex.push((i + 0x100).toString(16).slice(1));
                }
                for (let i = 0; i < 16; i++) {
                    str += byteToHex[arr[i]];
                    if ([3, 5, 7, 9].includes(i)) {
                        str += '-';
                    }
                }
                return str.toLowerCase();
            };
            return unsafeStringify(window.crypto.getRandomValues(new Uint8Array(16)));
        }
        return _generateTaskId();
    }
    catch (e) {
        return _generateTaskId();
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/common/index.js




;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/types/upload.js

/**
 * 创建上传结果数据
 *
 * @since 4.4.0
 * @param result 可选；结果数据
 */
function upload_createUploadResult(result = {}) {
    const _result = Object.assign({ data: '', url: '', key: '', etag: '', index: 0, fileSize: '', mimeType: '', type: '', size: 0, storage: enum_Cloud.Unknown }, result);
    return _result;
}
/**
 * 上传错误类
 */
class upload_UploaderError extends Error {
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/types/index.js


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/uploader.js



/**
 * 上传基类
 *
 * - 继承上传基类并实现抽象方法，可用于扩展实现新平台的上传功能；
 */
class UploaderBase {
    /**
     * 上传环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 是否为测试环境
     *
     * @getter
     * @readonly
     */
    get isTest() {
        return this.env === enum_UploadEnv.Test;
    }
    /**
     * 控制台日志前缀
     *
     * @getter
     * @since 4.5.0
     * @readonly
     */
    get logPrefix() {
        return '';
    }
    /**
     * 上传 Token 接口地址
     *
     * @getter
     * @readonly
     * @abstract 从 `v4.3.0` 起，为了支持海外版本（使用海外域名，借助 Tree Shaking，避免构建产出文件中有 `meitu` 域名相关代码），在基类默认返回空字符串，相当于改为 `getter` 抽象属性（并保持版本兼容），要求各端扩展类实现该属性
     */
    get tokenApi() {
        return '';
    }
    /**
     * 美图帐号 Access Token
     *
     * @getter
     * @readonly
     */
    get accessToken() {
        return this.options.accessToken;
    }
    constructor(options) {
        /**
         * 上传配置选项
         *
         * @default getDefaultUploaderOptions()
         */
        this.options = constants_getDefaultUploaderOptions();
        /**
         * 上传 Token 列表
         *
         * @default []
         */
        this.tokenList = [];
        /**
         * 上传重试次数/计数
         *
         * @default 0
         */
        this.retryCount = 0;
        /**
         * 当前 Token 列表序号
         *
         * @default 0
         */
        this.currentTokenIndex = 0;
        /**
         * 当前云厂商列表序号
         *
         * @default 0
         */
        this.currentCloudIndex = 0;
        /**
         * 代理上传类实例对象集合
         *
         * @protected
         * @since 4.5.0
         */
        this.proxies = {};
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.debugLog('options =>', options);
        const { appProxy } = this.options;
        if (!this.tokenApi.trim() && !appProxy) {
            throw new upload_UploaderError('成员属性 tokenApi 不能为空');
        }
        if (!/^https?:\/\//.test(this.tokenApi) && !appProxy) {
            throw new upload_UploaderError('tokenApi 必要是有效的 HTTP(S) 地址');
        }
        const originSign = typeof (options === null || options === void 0 ? void 0 : options.sign) === 'function' ? this.options.sign.bind(this) : null;
        this.options.sign = (params) => (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a, _b;
            if (appProxy) {
                return params;
            }
            // 默认允许不实现，但是在调试模式下，控制台显示警告日志
            if (typeof originSign !== 'function') {
                if (this.debug) {
                    console.warn(this.logPrefix, '检测到目前没有实现参数签名方法选项 sign，存在安全风险，建议实现。');
                }
                return params;
            }
            this.debugLog('开始进行参数签名...');
            params = yield originSign(Object.assign(Object.assign(Object.assign({}, constants_defaultUploadTokenRequestParams), { sigTime: `${Math.floor(new Date().getTime() / 1000)}` }), params));
            if (!(params === null || params === void 0 ? void 0 : params.sig) || ((_a = params === null || params === void 0 ? void 0 : params.sig) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                throw new upload_UploaderError('上传参数签名参数 sig 不能为空');
            }
            if (((_b = params === null || params === void 0 ? void 0 : params.sig) === null || _b === void 0 ? void 0 : _b.length) !== 32) {
                throw new upload_UploaderError('上传参数签名参数 sig 值不正确');
            }
            this.debugLog('参数签名完成！params =>', params);
            return params;
        });
    }
    /**
     * 获取文件扩展名
     *
     * @protected
     * @since 4.4.0
     * @param file 文件
     * @param params 上传请求参数
     */
    getFileSuffix(file, params) {
        let suffix = (params === null || params === void 0 ? void 0 : params.suffix) || '';
        if (typeof (params === null || params === void 0 ? void 0 : params.suffix) === 'undefined') {
            if (typeof file === 'string') {
                // 处理 DataURL 的文件形式
                if (/^data:/.test(file)) {
                    suffix = utils_getFileExtensionByDataURL(file);
                }
                else {
                    suffix = utils_getFileExtension(file);
                }
            }
            else if (file instanceof File) {
                suffix = utils_getFileExtension(file.name);
            }
        }
        return suffix;
    }
    /**
     * 请求接口获取上传 Token
     *
     * @protected
     * @since 4.5.0
     * @param params 上传请求参数
     * @param options 上传配置选项
     */
    getUploadToken(params_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (params, options = {}) {
            const { multiple = false } = options;
            this.debugLog('[getUploadToken] options =>', options);
            let currentToken;
            // 获取上传 Token 列表
            if (!multiple) {
                this.tokenList = (options === null || options === void 0 ? void 0 : options.tokenList) || (yield this.requestToken(params));
                currentToken = this.tokenList[this.currentTokenIndex];
            }
            else {
                if (typeof (options === null || options === void 0 ? void 0 : options.uploadToken) !== 'object') {
                    throw new upload_UploaderError('上传 Token 信息不存在');
                }
                currentToken = options.uploadToken;
            }
            return currentToken;
        });
    }
    /**
     * 多文件批量上传方法
     *
     * - 本方法是基于 [`upload()`](https://f2er.meitu.com/meitu-upload/api/upload/class/Uploader#upload) 方法扩展实现的，最多支持一次性上传 20 个文件；
     *
     * @async
     * @since 4.4.0
     * @param files 要批量上传的文件列表；值为 Data URL（Base64） 字符串 / 本地路径 / `File` 对象；微信等小程序端只支持传入本地文件路径字符串；
     * @param params 上传请求参数
     * @param options 可选；上传配置选项
     */
    uploadMultiple(files_1, params_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (files, params, options = {}) {
            var _a;
            this.debugLog('[uploadMultiple] files =>', files);
            this.debugLog('[uploadMultiple] params =>', params);
            this.debugLog('[uploadMultiple] options =>', options);
            if (files.length > constants_MAX_TOKEN_COUNT) {
                throw new upload_UploaderError('最多只允许一次性上传 20 个文件');
            }
            if ((params === null || params === void 0 ? void 0 : params.count) && (params === null || params === void 0 ? void 0 : params.count) !== files.length) {
                throw new upload_UploaderError('上传 Token 获取数量与文件数量不一致');
            }
            const { appProxy } = this.options;
            const _options = Object.assign(Object.assign({}, options), { multiple: true });
            params.suffix = this.getFileSuffix(files[0], params);
            params.count = (_a = params === null || params === void 0 ? void 0 : params.count) !== null && _a !== void 0 ? _a : files.length;
            this.tokenList = appProxy ? [] : yield this.requestToken(params);
            // 大部分主流浏览器的同一个源最大并发请求数限制为 6 个，多出的请求会自动排队等待，所以这里不需要在手动维护请求队列，直接一起发送，交由浏览器管理请求队列
            const results = yield Promise.allSettled(Array.from({ length: appProxy ? files.length : this.tokenList.length }, (v, i) => i).map((i) => {
                return this.upload(files[i], params, Object.assign(Object.assign({}, _options), { tokenList: this.tokenList, uploadToken: this.tokenList[i], index: i }));
            }));
            this.reset();
            return results.map((result, index) => {
                if (result.status === 'fulfilled') {
                    return result.value;
                }
                else {
                    return upload_createUploadResult({ index });
                }
            });
        });
    }
    /**
     * 请求上传所需的 Token
     *
     * @async
     * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=5313382
     * @param params 请求上传 Token 的参数
     * @returns 上传 Token 列表
     */
    requestToken(params) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            const { headers: headersParams = {} } = params, restParams = (0,tslib_es6.__rest)(params, ["headers"]);
            const headers = {};
            // 如果 MAAT 安全策略平台有配置需要登录才能获取 token，则需要传入 accessToken 配置项
            if (this.options.accessToken) {
                headers['Access-Token'] = this.options.accessToken;
            }
            this.debugLog('[requestToken] params =>', restParams);
            if ((restParams === null || restParams === void 0 ? void 0 : restParams.count) > constants_MAX_TOKEN_COUNT) {
                throw new upload_UploaderError(`最多只允许一次性获取 ${constants_MAX_TOKEN_COUNT} 个上传 Token`);
            }
            const signedParams = yield this.options.sign(restParams);
            this.debugLog('[requestToken] signedParams =>', signedParams);
            // 将键值对对象转换为请求字符串
            const queries = utils_keyValueToQueryStrings(signedParams, (_) => {
                return _[1] !== 'undefined';
            });
            const protocol = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) || '';
            // 针对 pre 环境，token 请求地址协议与 location.protocol 同步，仅对 protocol 为 http 或 https 时生效，防止本地包内请求错误
            const tokenApi = /^http(s|):/.test(protocol) ? this.tokenApi.replace('http:', protocol) : this.tokenApi;
            // 请求获取上传 token 的接口
            const result = yield this.request(`${tokenApi}?${queries}`, {
                headers: Object.assign(Object.assign({}, headers), headersParams),
            });
            if (!result) {
                throw result;
            }
            if (result.status !== 200) {
                throw result;
            }
            if (typeof (result === null || result === void 0 ? void 0 : result.json) !== 'function') {
                throw new upload_UploaderError('this.request() 方法的返回结果对象的 json() 方法没有实现');
            }
            // 将接口响应返回的所有字段转换为小驼峰
            const json = utils_toCamelCase(yield result.json());
            this.debugLog('[requestToken] tokenList =>', json);
            return json;
        });
    }
    /**
     * 重置上传状态数据
     *
     * @protected
     * @since 4.5.0
     */
    reset() {
        this.proxies = {};
        this.tokenList = [];
        this.currentTokenIndex = 0;
        this.currentCloudIndex = 0;
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(`${this.logPrefix}[${this.constructor.name}]`, ...args);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-core/dist/esm/index.js





;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/utils.js

/**
 * 获取当前 WebView 版本号
 *
 * @since 4.5.0
 */
function getMeituWebViewVersion() {
    const result = navigator.userAgent.match(/MTWebView\/((\d+)\.(\d+)\.(\d+))/);
    return (result === null || result === void 0 ? void 0 : result[1]) || '';
}
/**
 * HTTP 请求方法（基于 Fetch API 实现）
 *
 * @async
 * @since 4.5.0
 * @param url 请求地址
 * @param options 可选；请求配置项
 */
function utils_request(url_1) {
    return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
        const result = (yield window.fetch(url, Object.assign({ method: 'GET' }, options)));
        return result;
    });
}
/**
 * Data URL 转换为 File 对象的方法
 *
 * @since 4.5.0
 * @link https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * @param dataURL 前缀为 data: 协议的URL
 * @param fileName 自定义文件名
 */
function dataURLToFile(dataURL, fileName) {
    var _a, _b, _c;
    const arr = dataURL.split(',');
    const mime = ((_c = (_b = (_a = arr === null || arr === void 0 ? void 0 : arr[0]) === null || _a === void 0 ? void 0 : _a.match) === null || _b === void 0 ? void 0 : _b.call(_a, /:(.*?);/)) === null || _c === void 0 ? void 0 : _c[1]) || '';
    const bstr = window.atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}
/**
 * 检查或转换要上传的文件类型
 *
 * - 检查文件是否为空；
 * - 检查文件是否为 File 对象；
 * - 如果是 Data URL Base64 编码字符串形式，会自动转换为 File 对象；
 *
 * @since 4.5.0
 * @param file 文件
 * @param suffix 可选；文件扩展名后缀
 */
function checkUploadFileType(file, suffix) {
    if (!file) {
        throw new Error('文件不能为空');
    }
    // 处理 Data URL 的文件形式
    if (typeof file === 'string' && /^data:/.test(file)) {
        const fileName = `${new Date().getTime()}${suffix ? `.${suffix}` : ''}`;
        file = dataURLToFile(file, fileName);
    }
    if (!(file instanceof File)) {
        throw new Error('file 参数值只允许 File 对象或 Data URL (Base64 Encoded) 形式');
    }
    return file;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/app-bridge.js
/**
 * 美图 App 端 WebView JS Bridge 上传协议方法实现
 *
 * 作为基础组件，为了不依赖 @meitu/hogger 模块，避免额外的依赖模块安装，同时减小构建产物的文件大小，在这里简单实现 Hogger 相关上传协议方法
 */

/// <reference types="@meitu/mtjs" />


let t = 0;
/**
 * 通过 MTJs 发起 WebView JS Bridge 协议
 *
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=29749881
 * @param method 协议方法
 * @param params 可选；协议参数
 * @param options 可选；配置选项
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callWebViewJavaScriptBridge(method, params, options) {
    const logPrefix = `${LOG_PREFIX} callWebViewJavaScriptBridge: `;
    const { debug = false } = options || {};
    t++;
    if (typeof params === 'object' && !Array.isArray(params)) {
        params._t = t; // 解决并发问题，相关文档：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=320283764
    }
    if (debug) {
        console.log(logPrefix, method, { params, options });
    }
    return new Promise((resolve, reject) => {
        if (typeof (window === null || window === void 0 ? void 0 : window.MTJs) === 'undefined') {
            return reject(new Error('MTJs undefined'));
        }
        window.MTJs.nativeCall({ 'mt-hogger': method }, params || {}, (result) => {
            var _a, _b, _c, _d;
            if ((_a = result === null || result === void 0 ? void 0 : result.meta) === null || _a === void 0 ? void 0 : _a.params) {
                result.meta.params = Object.assign(Object.assign({}, result.meta.params), params);
            }
            if (debug) {
                console.log(logPrefix, method, 'result =>', result);
            }
            const code = (_b = result === null || result === void 0 ? void 0 : result.meta) === null || _b === void 0 ? void 0 : _b.code;
            if (!result || code !== 0) {
                (_c = options === null || options === void 0 ? void 0 : options.onFailure) === null || _c === void 0 ? void 0 : _c.call(options, result);
                return reject(result);
            }
            (_d = options === null || options === void 0 ? void 0 : options.onProgress) === null || _d === void 0 ? void 0 : _d.call(options, result);
            resolve(result);
        }, options);
    });
}
/**
 * 判断是否支持 App 上传协议
 *
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=303335231
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=297799315
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=296284887
 * @param webViewVersion 可选；WebView 版本号
 */
function isSupportUploadByApp(webViewVersion = getMeituWebViewVersion()) {
    const { userAgent } = navigator;
    const isiOS = /iPhone|iPad|iPod/.test(userAgent);
    const isAndroid = /Android\s/.test(userAgent);
    const versions = webViewVersion.split('.');
    if (versions.length < 3) {
        return false;
    }
    const [major, minor, patch] = versions.map((v) => parseInt(v));
    if (isiOS) {
        return major >= 3;
    }
    else if (isAndroid) {
        if (major === 4) {
            return minor === 9 ? patch >= 1 : minor > 9; // >= 4.9.1
        }
        else {
            return major > 4;
        }
    }
    else {
        return false;
    }
}
/**
 * 发起创建上传任务协议
 *
 * @async
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=303335231
 * @param params 协议参数
 * @param options 可选；配置选项
 */
function createUploadTask(params, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const method = 'createUploadTask';
        if (!isSupportUploadByApp()) {
            throw new Error(`不支持 mt-hogger://${method} 协议`);
        }
        const { response } = yield callWebViewJavaScriptBridge(method, params, options);
        const { taskId } = response;
        return {
            taskId,
        };
    });
}
/**
 * 发起监听上传任务进度协议
 *
 * @async
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=297799315
 * @param taskId 任务 ID
 * @param onProgress 可选；进度回调处理方法
 * @param options 可选；配置选项
 */
function observeUploadProgress(taskId, onProgress, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const method = 'observeUploadProgress';
        if (!isSupportUploadByApp()) {
            throw new Error(`不支持 mt-hogger://${method} 协议`);
        }
        return new Promise((resolve, reject) => {
            callWebViewJavaScriptBridge(method, {
                taskId,
            }, Object.assign(Object.assign({}, options), { once: false, onProgress: ({ response }) => {
                    const { progress = 0, data } = response;
                    onProgress === null || onProgress === void 0 ? void 0 : onProgress(Object.assign(Object.assign({}, response), { progress }));
                    if (progress === 100 && typeof data === 'string' && data) {
                        resolve(response);
                    }
                }, onFailure: (res) => {
                    reject(res);
                } })).catch(reject);
        });
    });
}
/**
 * 发起取消上传任务协议
 *
 * @since 4.5.0
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=296284887
 * @param taskId 任务 ID
 * @param options 可选；配置选项
 */
function abortUploadTask(taskId, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const method = 'abortUploadTask';
        if (!isSupportUploadByApp()) {
            throw new Error(`不支持 mt-hogger://${method} 协议`);
        }
        yield callWebViewJavaScriptBridge(method, { taskId }, options);
    });
}
/**
 * App 端文件上传方法 —— 通过当前美图 App 端宿主 JS Bridge 协议
 *
 * @async
 * @since 4.5.0
 * @param file 要上传的文件路径地址；
 * @param params 上传请求参数
 * @param options 可选；上传配置选项
 */
function uploadByApp(file_1, params_1) {
    return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (file, params, options = {}) {
        var _a;
        const { app: appKey, type } = params;
        const { index = 0, multiple = false, debug = false } = options;
        const logPrefix = `${LOG_PREFIX} [uploadByApp]`;
        if (debug) {
            console.log(logPrefix, { params, options });
        }
        if (typeof file !== 'string') {
            throw new upload_UploaderError('只允许传入文件路径地址字符串');
        }
        if (typeof file === 'string' && /^data:/.test(file)) {
            throw new upload_UploaderError('不支持上传 Data URL Base64 编码文件形式');
        }
        const { taskId } = yield createUploadTask({
            appKey,
            type,
            taskId: options === null || options === void 0 ? void 0 : options.taskId,
            filePath: file,
        }, { debug });
        if (debug) {
            console.log(logPrefix, 'taskId =>', taskId);
        }
        (_a = options === null || options === void 0 ? void 0 : options.getTaskId) === null || _a === void 0 ? void 0 : _a.call(options, taskId);
        let percent;
        let result = upload_createUploadResult({ index, type });
        const onProgress = (data) => {
            var _a;
            if (debug) {
                console.log(logPrefix, 'onProgress =>', { index }, data);
            }
            const { progress, totalBytesSent: loaded, totalBytesExpectedToSend: total, data: resultJsonData } = data;
            if (typeof progress !== 'number' || percent === progress || !total) {
                return;
            }
            percent = progress;
            (_a = options === null || options === void 0 ? void 0 : options.progress) === null || _a === void 0 ? void 0 : _a.call(options, {
                index,
                taskId: taskId,
                total: {
                    percent,
                    total,
                    loaded,
                    size: total,
                },
            });
            if (percent === 100 && resultJsonData) {
                const { etag, mimeType, data: url, storage = '', accessUrl = '', key = '' } = JSON.parse(resultJsonData);
                result = Object.assign(Object.assign({}, result), { etag,
                    url,
                    key,
                    mimeType,
                    storage, size: total, fileSize: `${total}`, data: url, previewUrl: accessUrl });
            }
        };
        yield observeUploadProgress(taskId, onProgress, { debug });
        if (!result.url) {
            const error = new upload_UploaderError('上传失败');
            if (!multiple) {
                throw error;
            }
        }
        return result;
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/app-proxy.js



/**
 * App 端代理上传基类
 *
 * - 使用场景：用于平替 `UploaderBase` 类，直接通过美图系 App 端协议代理上传（请求参数签名、获取上传 Token 和上传文件），去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：七牛云 `qiniu`、美图云 `mtyun`、华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss` —— App 端代理上传时，要看 App 端是否实际支持
 *
 * @since 4.5.0
 */
class AppProxyUploaderBase extends UploaderBase {
    constructor(options = {}) {
        options.appProxy = true;
        super(options);
        /**
         * 上传任务 ID 列表
         */
        this.taskIds = [];
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            this.debugLog('[request]', { url, options });
            throw new upload_UploaderError('该方法不可用，默认由 App 端代理请求接口获取 Token');
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a, _b;
            const { debug } = this.options;
            const { index = 0 } = options || {};
            let _taskId = '';
            this.debugLog('[upload] file =>', file);
            this.debugLog('[upload] params =>', params);
            this.debugLog('[upload] options =>', options);
            try {
                const result = yield uploadByApp(`${file}`, params, Object.assign(Object.assign({}, options), { debug, getTaskId: (taskId) => {
                        if (!this.taskIds.includes(taskId)) {
                            this.taskIds.push(taskId);
                            _taskId = taskId;
                        }
                    } }));
                this.taskIds = this.taskIds.filter((id) => id !== _taskId); // 移除已上传的任务 ID
                (_a = options === null || options === void 0 ? void 0 : options.complete) === null || _a === void 0 ? void 0 : _a.call(options, result);
                return result;
            }
            catch (error) {
                (_b = options === null || options === void 0 ? void 0 : options.failure) === null || _b === void 0 ? void 0 : _b.call(options, error, index);
                throw error;
            }
        });
    }
    cancel(taskId) {
        const { debug } = this.options;
        this.debugLog('[cancel] taskIds =>', this.taskIds);
        if (taskId) {
            abortUploadTask(taskId, { debug });
            return;
        }
        this.taskIds.forEach((_taskId) => {
            abortUploadTask(_taskId, { debug });
        });
    }
    // TODO：支持 App 代理上传时的断点续传
    resume() {
        throw new upload_UploaderError('目前不支持');
    }
}
/**
 * App 端代理上传类
 *
 * - 使用场景：用于平替 `Uploader` 类，直接通过美图系 App 端协议代理上传（请求参数签名、获取上传 Token 和上传文件），去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：七牛云 `qiniu`、美图云 `mtyun`、华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss` —— App 端代理上传时，要看 App 端是否实际支持
 *
 * @since 4.5.0
 */
class AppProxyUploader extends AppProxyUploaderBase {
    get logPrefix() {
        return LOG_PREFIX;
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/base.js




/**
 * Web 端上传基类
 *
 * @since 4.3.0 为了扩展支持海外版本，避免包含美图的域名，从原有的 Web 端上传类拆分出 Web 端上传基类
 */
class UploaderBaseWeb extends UploaderBase {
    /**
     * 美图系 App 端协议代理上传方法
     *
     * @async
     * @protected
     * @since 4.5.0
     * @param file 上传的文件
     * @param params 上传请求参数
     * @param options 上传配置选项
     */
    appProxyUpload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            const { multiple = false } = options || {};
            const { appProxy } = this.options;
            if (appProxy) {
                const proxy = new AppProxyUploader(this.options);
                let _taskId = '';
                const result = yield proxy.upload(file, params, Object.assign(Object.assign({}, options), { progress: (res) => {
                        var _a;
                        (_a = options === null || options === void 0 ? void 0 : options.progress) === null || _a === void 0 ? void 0 : _a.call(options, res);
                        if (res.taskId) {
                            _taskId = `${res.taskId}`;
                            this.proxies[_taskId] = proxy;
                        }
                    } }));
                delete this.proxies[_taskId];
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
        });
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            const result = yield utils_request(url, options);
            this.debugLog('[request] result =>', result);
            return result;
        });
    }
    /**
     * 代理上传方法
     *
     * @async
     * @since 4.5.0
     * @param proxy 自定义代理上传类实例对象获取方法
     * @param file 要上传的文件；值为 Data URL（Base64） 字符串 / 本地路径 / `File` 对象；微信等小程序端只支持传入本地文件路径字符串；
     * @param params 上传请求参数
     * @param options 可选；上传配置选项
     */
    uploadProxy(proxy, file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            const logTag = '[uploadProxy]';
            const { index = 0, multiple = false } = options || {};
            const { appProxy } = this.options;
            const failure = options === null || options === void 0 ? void 0 : options.failure;
            this.debugLog(logTag, 'file =>', file);
            this.debugLog(logTag, 'params =>', params);
            this.debugLog(logTag, 'options =>', options);
            this.debugLog(logTag, 'appProxy =>', appProxy);
            // 避免重复执行，改成统一在 catch 中执行
            const __opts = Object.assign(Object.assign({}, options), { failure: () => { } });
            try {
                params.suffix = this.getFileSuffix(file, params);
                if (appProxy) {
                    // APP 分片上传无法通过 catch 获取错误 因此需要传入 failure
                    return this.appProxyUpload(file, params, Object.assign(Object.assign({}, __opts), { failure }));
                }
                let tokenList = [];
                if (Array.isArray(__opts === null || __opts === void 0 ? void 0 : __opts.tokenList) && (__opts === null || __opts === void 0 ? void 0 : __opts.tokenList.length) > 0) {
                    tokenList = __opts.tokenList;
                }
                else {
                    tokenList = (__opts === null || __opts === void 0 ? void 0 : __opts.uploadToken) ? [] : yield this.requestToken(params);
                }
                const currentToken = yield this.getUploadToken(params, Object.assign(Object.assign({}, __opts), { tokenList }));
                const cloud = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.order) === null || _a === void 0 ? void 0 : _a[this.currentCloudIndex];
                const _proxy = proxy(cloud);
                // 非 S3 暂不支持配置分段大小，因此需要过滤掉分段大小配置
                if (!isS3(cloud)) {
                    __opts === null || __opts === void 0 ? true : delete __opts.partSize;
                }
                let _taskId = '';
                const result = yield _proxy.upload(file, params, Object.assign(Object.assign({}, __opts), { progress: (res) => {
                        var _a;
                        (_a = __opts === null || __opts === void 0 ? void 0 : __opts.progress) === null || _a === void 0 ? void 0 : _a.call(__opts, res);
                        if (res.taskId) {
                            _taskId = `${res.taskId}`;
                            this.proxies[_taskId] = _proxy;
                        }
                    }, tokenList }));
                delete this.proxies[_taskId];
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
            catch (error) {
                failure === null || failure === void 0 ? void 0 : failure(error, index);
                throw error;
            }
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            this.debugLog('[upload] =>', { file, params, options });
            throw new Error('上传方法未实现');
        });
    }
    cancel(taskId) {
        const _cancel = (i) => {
            const proxy = this.proxies[i];
            if (proxy) {
                proxy.options = this.options;
                proxy.cancel();
            }
        };
        if (taskId) {
            _cancel(taskId);
            return;
        }
        for (const i in this.proxies) {
            _cancel(i);
        }
    }
    resume(taskId) {
        const _resume = (i) => {
            const proxy = this.proxies[i];
            if (proxy) {
                proxy.options = this.options;
                proxy.resume();
            }
        };
        if (taskId) {
            _resume(taskId);
            return;
        }
        for (const i in this.proxies) {
            _resume(i);
        }
    }
}

// EXTERNAL MODULE: ./node_modules/qiniu-js/dist/qiniu.min.js
var qiniu_min = __webpack_require__(42723);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/qiniu.js




/**
 * 基于七牛云 JS SDK 的文件上传类
 *
 * 适用于：七牛云 `qiniu`、美图云 `mtyun`
 *
 * @since 4.5.0
 */
class QiniuUploader extends UploaderBase {
    get logPrefix() {
        return LOG_PREFIX;
    }
    get tokenApi() {
        return this.isTest ? UploadTokenAPI.Test : UploadTokenAPI.Release;
    }
    constructor(options) {
        super(options);
        /**
         * 上传任务对象
         */
        this.tasks = {};
        // 注意：仅用于临时解决七牛 X-ReqId 报错问题
        this.fixQiniuXReqIdError();
    }
    /**
     * 通过重写 XMLHttpRequest 的 getResponseHeader 原型方法
     *
     * 临时解决七牛上传时 X-ReqId 报错问题
     */
    fixQiniuXReqIdError() {
        // 在 SSR 服务端渲染场景下，避免在全局初始化时报错
        if (typeof XMLHttpRequest === 'undefined') {
            return;
        }
        const { getResponseHeader } = XMLHttpRequest.prototype;
        XMLHttpRequest.prototype.getResponseHeader = function (name) {
            // 当获取 x-reqId 响应头时，直接返回空字符串
            if (name === 'x-reqId') {
                return '';
            }
            return getResponseHeader.apply(this, [name]);
        };
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            const result = yield utils_request(url, options);
            this.debugLog('[request] result =>', result);
            return result;
        });
    }
    _upload(file, options) {
        var _a;
        const { index = 0, resumable = true, currentToken, maxConcurrent, retryBackupHost = true } = options || {};
        const { currentCloudIndex, retryCount } = this;
        const cloud = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.order) === null || _a === void 0 ? void 0 : _a[currentCloudIndex];
        const uploadToken = currentToken === null || currentToken === void 0 ? void 0 : currentToken[cloud];
        this.debugLog('[upload] 上传相关参数 =>', { currentCloudIndex, cloud, retryCount });
        if (!uploadToken) {
            throw new upload_UploaderError('上传 Token 数据不存在');
        }
        const { key, token, chunkSize, url: uploadHost, backupUrl: uploadBackupHost } = uploadToken;
        this.debugLog('[upload] 开始上传 =>', { key, uploadHost, uploadBackupHost, chunkSize });
        let errorTime = 0;
        return new Promise((resolve, reject) => {
            var _a;
            const { retryCount } = this;
            const { progress, complete } = options || {};
            if (!uploadHost) {
                return;
            }
            // const qiniu = await import('qiniu-js') // UMD 不支持动态加载
            const forceDirect = resumable ? false : true;
            this.debugLog('[upload] qiniu.upload =>', { uploadHost, errorTime, retryCount, resumable, forceDirect });
            const taskId = generateTaskId();
            const _retryCount = (_a = options === null || options === void 0 ? void 0 : options.retryCount) !== null && _a !== void 0 ? _a : DEFAULT_RETRY_COUNT;
            const _upload = (uphost = uploadHost) => {
                const qiniuUploadOptions = {
                    uphost: uphost.replace(/https?:\/\//, ''),
                    upprotocol: uphost.indexOf('https') >= 0 ? 'https' : 'http',
                    debugLogLevel: 'INFO',
                    disableStatisticsReport: true,
                    retryCount: _retryCount,
                    forceDirect,
                };
                // 值为 undefined 时 不能传入带入配置项内 不然会导致请求无法发出
                if (typeof maxConcurrent !== 'undefined') {
                    qiniuUploadOptions.concurrentRequestLimit = maxConcurrent;
                }
                const putExtra = {};
                /**
                 * 服务端错误的将 .webm 文件识别为 application/x-matroska
                 * 服务端错误的将 svg 文件识别为 text/plain
                 * 所以需要通过拓展配置手动修正 MIME 类型
                 */
                if (file === null || file === void 0 ? void 0 : file.type) {
                    putExtra.mimeType = [file.type];
                }
                const observable = (0,qiniu_min.upload)(file, key, token, putExtra, qiniuUploadOptions);
                const subObject = {
                    /**
                     * 接收上传进度信息的回调函数
                     */
                    next: (result) => {
                        this.debugLog('[upload] qiniu.upload.next =>', result);
                        // 第三方上传进度回调处理
                        if (typeof progress === 'function') {
                            progress(Object.assign(Object.assign({}, result), { taskId,
                                index }));
                        }
                    },
                    /**
                     * 上传错误后触发；自动重试本身并不会触发该错误，而当重试次数到达上限后则可以触发
                     *
                     * 通过在后台 `http://maat0.backstage.meitu.com/` 同时把当前 `app` 的 Access Key 和 Secret Key 加个错误字符来模拟触发上传错误事件，来触发重试操作
                     */
                    error: (err) => {
                        this.debugLog('[upload] qiniu.upload.error =>', err, { errorTime });
                        errorTime += 1;
                        this.retryCount += _retryCount;
                        // 七牛云上传 SDK 本身默认重试 3 次，达到后触发 error 事件回调，再尝试换成备份域名上传，如果再报错就切成另一个云，重复前面的过程一次，总计重试次数= (3 + 1 备份) * N个云
                        // 如果主备地址相同则不进行切换重试
                        if (errorTime === 1 && uploadBackupHost && uploadBackupHost !== uploadHost && retryBackupHost) {
                            this.debugLog('[upload] qiniu.upload.error >> try backup host =>', uploadBackupHost);
                            _upload(uploadBackupHost); // 尝试用备份域名上传
                            return;
                        }
                        // else if (errorTime === 2) {
                        //   // 上传错误超过 2 次时，换另一个云上传
                        //   // 如果已经把所有可用的云都重试了一遍，则直接报错
                        //   if (currentToken.order.length === this.currentCloudIndex - 1) {
                        //     return reject(err);
                        //   }
                        //   this.currentCloudIndex += 1; // 递增云序号，即换另一个云上传
                        //   this.debugLog(
                        //     '[upload] qiniu.upload.error >> try other cloud =>',
                        //     currentToken.order[this.currentCloudIndex]
                        //   );
                        //   this._upload(file, currentToken, resolve, reject);
                        // } else {
                        //   reject(err);
                        // }
                        reject(err);
                    },
                    /**
                     * 接收上传完成后的后端返回信息
                     */
                    complete: (result) => {
                        const _a = result, { url, data, fsize } = _a, rest = (0,tslib_es6.__rest)(_a, ["url", "data", "fsize"]);
                        const finalResult = Object.assign({ url: data, key, previewUrl: url, data,
                            index,
                            fsize, size: parseInt(`${fsize || 0}`), fileSize: fsize }, rest);
                        this.debugLog('[upload] qiniu.upload.complete: result =>', finalResult);
                        // 第三方上传成功回调处理
                        if (typeof complete === 'function') {
                            complete(finalResult);
                        }
                        resolve(finalResult);
                        delete this.tasks[`${taskId}`];
                    },
                };
                const subscription = observable.subscribe(subObject);
                this.tasks[`${taskId}`] = {
                    file,
                    subscription,
                    subObject,
                    observable,
                };
            };
            _upload();
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a;
            const { multiple = false, index = 0 } = options || {};
            try {
                params.suffix = this.getFileSuffix(file, params);
                const currentToken = yield this.getUploadToken(params, options);
                const _file = checkUploadFileType(file, params.suffix);
                const result = yield this._upload(_file, Object.assign({ currentToken }, options));
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
            catch (error) {
                (_a = options === null || options === void 0 ? void 0 : options.failure) === null || _a === void 0 ? void 0 : _a.call(options, error, index);
                throw error;
            }
        });
    }
    cancel(taskId) {
        const _unsubscribe = (id) => {
            const { subscription } = this.tasks[id];
            subscription.unsubscribe();
        };
        if (taskId) {
            _unsubscribe(taskId);
            return;
        }
        for (const i in this.tasks) {
            _unsubscribe(i);
        }
    }
    resume(taskId) {
        const _subscribe = (id) => {
            var _a;
            const { observable, subObject, subscription: _subscription } = this.tasks[id] || {};
            if (!observable) {
                return;
            }
            // 防止重复触发重新上传
            (_a = _subscription === null || _subscription === void 0 ? void 0 : _subscription.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(_subscription);
            const subscription = observable.subscribe(subObject);
            this.tasks[id].subscription = subscription;
        };
        if (taskId) {
            _subscribe(taskId);
            return;
        }
        for (const i in this.tasks) {
            _subscribe(i);
        }
    }
}

// EXTERNAL MODULE: ./node_modules/crypto-js/enc-hex.js
var enc_hex = __webpack_require__(63465);
var enc_hex_default = /*#__PURE__*/__webpack_require__.n(enc_hex);
// EXTERNAL MODULE: ./node_modules/crypto-js/enc-utf8.js
var enc_utf8 = __webpack_require__(55743);
var enc_utf8_default = /*#__PURE__*/__webpack_require__.n(enc_utf8);
// EXTERNAL MODULE: ./node_modules/crypto-js/enc-base64.js
var enc_base64 = __webpack_require__(98269);
var enc_base64_default = /*#__PURE__*/__webpack_require__.n(enc_base64);
// EXTERNAL MODULE: ./node_modules/crypto-js/hmac-sha256.js
var hmac_sha256 = __webpack_require__(88010);
var hmac_sha256_default = /*#__PURE__*/__webpack_require__.n(hmac_sha256);
;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/enum.js
/**
 * 上传环境
 */
var common_enum_UploadEnv;
(function (UploadEnv) {
    /**
     * 上传环境：正式环境
     */
    UploadEnv[UploadEnv["Release"] = 0] = "Release";
    /**
     * 上传环境：测试环境
     */
    UploadEnv[UploadEnv["Test"] = 1] = "Test";
})(common_enum_UploadEnv || (common_enum_UploadEnv = {}));
/**
 * 上传 Token 请求接口地址
 *
 * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=48137491
 */
var enum_UploadTokenAPI;
(function (UploadTokenAPI) {
    /**
     * 上传 Token 请求接口地址：正式环境
     */
    UploadTokenAPI["Release"] = "https://strategy.app.meitudata.com/upload/policy";
    /**
     * 上传 Token 请求接口地址：测试环境
     */
    UploadTokenAPI["Test"] = "http://prestrategy.meitubase.com/upload/policy";
})(enum_UploadTokenAPI || (enum_UploadTokenAPI = {}));
/**
 * 云存储服务提供商枚举对象
 */
var common_enum_Cloud;
(function (Cloud) {
    /**
     * 云存储提供商：未知
     *
     * @since 4.4.0
     */
    Cloud["Unknown"] = "";
    /**
     * 云存储提供商：亚马逊 AWS S3
     */
    Cloud["AWSS3"] = "aws-s3";
    /**
     * 云存储提供商：华为云（实现的 AWS S3 访问协议）
     */
    Cloud["HuaweiS3"] = "hw-s3";
    /**
     * 云存储提供商：七牛云
     */
    Cloud["Qiniu"] = "qiniu";
    /**
     * 云存储提供商：美图云（基于七牛云）
     */
    Cloud["MeituYun"] = "mtyun";
    /**
     * 云存储提供商：阿里云 OSS
     *
     * @since 4.3.0
     */
    Cloud["OSS"] = "oss";
})(common_enum_Cloud || (common_enum_Cloud = {}));
/**
 * 云存储提供商列表
 */
const enum_Clouds = Object.values(common_enum_Cloud).filter((value) => typeof value === 'string');

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/constants.js

/**
 * 控制台日志前缀
 *
 * @since 4.1.0
 */
const constants_LOG_PREFIX = '[@meitu/upload]';
/**
 * 上传 Token 一次最少获取数量
 *
 * @since 4.4.0
 */
const constants_MIN_TOKEN_COUNT = 1;
/**
 * 上传 Token 一次最多获取数量
 *
 * @since 4.4.0
 */
const common_constants_MAX_TOKEN_COUNT = 20;
/**
 * 默认的上传 Token 接口请求参数
 */
const common_constants_defaultUploadTokenRequestParams = {
    app: '',
    type: '',
    count: 1,
    suffix: '',
    sig: '',
    sigTime: '',
    sigVersion: '1.3',
    version: '2',
};
/**
 * 获取默认的上传配置选项
 *
 * @since 4.6.1
 * @param options 可选；自定义配置选项
 */
function common_constants_getDefaultUploaderOptions(options) {
    return Object.assign({ debug: false, env: common_enum_UploadEnv.Release, accessToken: '', appProxy: false, sign: (params) => params, progress: (data) => data }, options);
}
/**
 * 默认的上传配置选项
 *
 * @deprecated 至 `v4.6.1` 版本起弃用，请改用 `getDefaultUploaderOptions()`
 */
const constants_defaultUploaderOptions = common_constants_getDefaultUploaderOptions();
/**
 * 默认的文件分片大小
 *
 * @since 4.6.0
 */
const constants_DEFAULT_PART_SIZE = 1024 * 1024 * 4;
/**
 * 默认的错误重试次数
 *
 * @since 4.8.0
 */
const constants_DEFAULT_RETRY_COUNT = 3;
/**
 * 限制最小分片大小
 *
 * @since 4.6.0
 *
 * - 云服务器限制，单个分片不允许小于 100kb
 */
const constants_MIN_PART_SIZE = 1024 * 100;

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/utils.js

/**
 * 键值对键名转换为小驼峰命名风格
 *
 * @param obj 键值对或键值对数组
 */
function common_utils_toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map((item) => common_utils_toCamelCase(item));
    }
    else if (typeof obj === 'object') {
        const temp = {};
        for (const i in obj) {
            const key = i.replace(/_([A-Za-z])/g, (_$0, $1) => $1.toUpperCase());
            temp[key] = typeof obj[i] === 'object' ? common_utils_toCamelCase(obj[i]) : obj[i];
        }
        return temp;
    }
    else {
        return obj;
    }
}
/**
 * 键值对对象转换为请求字符串
 *
 * @param kv     键值对对象
 * @param filter 自定义过滤方法
 */
function common_utils_keyValueToQueryStrings(kv, filter) {
    return Object.entries(kv)
        .filter((_) => {
        if (filter) {
            return filter(_);
        }
        return _[1] !== 'undefined' && _[1] !== '';
    })
        .map(([key, value]) => `${key}=${value}`)
        .sort()
        .join('&');
}
/**
 * 判断当前是不是 S3 云存储服务
 *
 * @since 4.2.0
 * @param cloud 云服务名称
 */
function utils_isS3(cloud) {
    return cloud === Cloud.HuaweiS3 || cloud === Cloud.AWSS3 || cloud === Cloud.OSS;
}
/**
 * 获取文件的扩展名
 *
 * @since 4.2.0
 * @param fileName 文件名
 */
function common_utils_getFileExtension(fileName) {
    var _a;
    return ((_a = fileName.match(/\.(\w+)$/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
}
/**
 * 从 Data URL 中获取文件的扩展名
 *
 * @since 4.2.0
 * @param dataURL Data URL 字符串
 */
function common_utils_getFileExtensionByDataURL(dataURL) {
    var _a, _b, _c, _d, _e, _f;
    return (((_f = (_e = (_d = (_c = (_b = (_a = dataURL
        .split(',')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.match) === null || _c === void 0 ? void 0 : _c.call(_b, /:(.*?);/)) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.split('/')) === null || _f === void 0 ? void 0 : _f[1]) || '');
}
/**
 * 生成 TaskId
 *
 * @since 4.7.0
 */
function utils_generateTaskId() {
    var _a, _b;
    const _generateTaskId = () => {
        return '00000000-0000-4000-1000-000000000000'.replace(/[10]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === '0' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    try {
        if ((_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
            return window.crypto.randomUUID();
        }
        if ((_b = window === null || window === void 0 ? void 0 : window.crypto) === null || _b === void 0 ? void 0 : _b.getRandomValues) {
            const unsafeStringify = (arr) => {
                const byteToHex = [];
                let str = '';
                for (let i = 0; i < 256; ++i) {
                    byteToHex.push((i + 0x100).toString(16).slice(1));
                }
                for (let i = 0; i < 16; i++) {
                    str += byteToHex[arr[i]];
                    if ([3, 5, 7, 9].includes(i)) {
                        str += '-';
                    }
                }
                return str.toLowerCase();
            };
            return unsafeStringify(window.crypto.getRandomValues(new Uint8Array(16)));
        }
        return _generateTaskId();
    }
    catch (e) {
        return _generateTaskId();
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/common/index.js




;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/types/upload.js

/**
 * 创建上传结果数据
 *
 * @since 4.4.0
 * @param result 可选；结果数据
 */
function types_upload_createUploadResult(result = {}) {
    const _result = Object.assign({ data: '', url: '', key: '', etag: '', index: 0, fileSize: '', mimeType: '', type: '', size: 0, storage: Cloud.Unknown }, result);
    return _result;
}
/**
 * 上传错误类
 */
class types_upload_UploaderError extends Error {
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/types/index.js


;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/uploader.js



/**
 * 上传基类
 *
 * - 继承上传基类并实现抽象方法，可用于扩展实现新平台的上传功能；
 */
class uploader_UploaderBase {
    /**
     * 上传环境
     *
     * @getter
     * @readonly
     */
    get env() {
        return this.options.env;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 是否为测试环境
     *
     * @getter
     * @readonly
     */
    get isTest() {
        return this.env === UploadEnv.Test;
    }
    /**
     * 控制台日志前缀
     *
     * @getter
     * @since 4.5.0
     * @readonly
     */
    get logPrefix() {
        return '';
    }
    /**
     * 上传 Token 接口地址
     *
     * @getter
     * @readonly
     * @abstract 从 `v4.3.0` 起，为了支持海外版本（使用海外域名，借助 Tree Shaking，避免构建产出文件中有 `meitu` 域名相关代码），在基类默认返回空字符串，相当于改为 `getter` 抽象属性（并保持版本兼容），要求各端扩展类实现该属性
     */
    get tokenApi() {
        return '';
    }
    /**
     * 美图帐号 Access Token
     *
     * @getter
     * @readonly
     */
    get accessToken() {
        return this.options.accessToken;
    }
    constructor(options) {
        /**
         * 上传配置选项
         *
         * @default getDefaultUploaderOptions()
         */
        this.options = getDefaultUploaderOptions();
        /**
         * 上传 Token 列表
         *
         * @default []
         */
        this.tokenList = [];
        /**
         * 上传重试次数/计数
         *
         * @default 0
         */
        this.retryCount = 0;
        /**
         * 当前 Token 列表序号
         *
         * @default 0
         */
        this.currentTokenIndex = 0;
        /**
         * 当前云厂商列表序号
         *
         * @default 0
         */
        this.currentCloudIndex = 0;
        /**
         * 代理上传类实例对象集合
         *
         * @protected
         * @since 4.5.0
         */
        this.proxies = {};
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.debugLog('options =>', options);
        const { appProxy } = this.options;
        if (!this.tokenApi.trim() && !appProxy) {
            throw new UploaderError('成员属性 tokenApi 不能为空');
        }
        if (!/^https?:\/\//.test(this.tokenApi) && !appProxy) {
            throw new UploaderError('tokenApi 必要是有效的 HTTP(S) 地址');
        }
        const originSign = typeof (options === null || options === void 0 ? void 0 : options.sign) === 'function' ? this.options.sign.bind(this) : null;
        this.options.sign = (params) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (appProxy) {
                return params;
            }
            // 默认允许不实现，但是在调试模式下，控制台显示警告日志
            if (typeof originSign !== 'function') {
                if (this.debug) {
                    console.warn(this.logPrefix, '检测到目前没有实现参数签名方法选项 sign，存在安全风险，建议实现。');
                }
                return params;
            }
            this.debugLog('开始进行参数签名...');
            params = yield originSign(Object.assign(Object.assign(Object.assign({}, defaultUploadTokenRequestParams), { sigTime: `${Math.floor(new Date().getTime() / 1000)}` }), params));
            if (!(params === null || params === void 0 ? void 0 : params.sig) || ((_a = params === null || params === void 0 ? void 0 : params.sig) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                throw new UploaderError('上传参数签名参数 sig 不能为空');
            }
            if (((_b = params === null || params === void 0 ? void 0 : params.sig) === null || _b === void 0 ? void 0 : _b.length) !== 32) {
                throw new UploaderError('上传参数签名参数 sig 值不正确');
            }
            this.debugLog('参数签名完成！params =>', params);
            return params;
        });
    }
    /**
     * 获取文件扩展名
     *
     * @protected
     * @since 4.4.0
     * @param file 文件
     * @param params 上传请求参数
     */
    getFileSuffix(file, params) {
        let suffix = (params === null || params === void 0 ? void 0 : params.suffix) || '';
        if (typeof (params === null || params === void 0 ? void 0 : params.suffix) === 'undefined') {
            if (typeof file === 'string') {
                // 处理 DataURL 的文件形式
                if (/^data:/.test(file)) {
                    suffix = getFileExtensionByDataURL(file);
                }
                else {
                    suffix = getFileExtension(file);
                }
            }
            else if (file instanceof File) {
                suffix = getFileExtension(file.name);
            }
        }
        return suffix;
    }
    /**
     * 请求接口获取上传 Token
     *
     * @protected
     * @since 4.5.0
     * @param params 上传请求参数
     * @param options 上传配置选项
     */
    getUploadToken(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            const { multiple = false } = options;
            this.debugLog('[getUploadToken] options =>', options);
            let currentToken;
            // 获取上传 Token 列表
            if (!multiple) {
                this.tokenList = (options === null || options === void 0 ? void 0 : options.tokenList) || (yield this.requestToken(params));
                currentToken = this.tokenList[this.currentTokenIndex];
            }
            else {
                if (typeof (options === null || options === void 0 ? void 0 : options.uploadToken) !== 'object') {
                    throw new UploaderError('上传 Token 信息不存在');
                }
                currentToken = options.uploadToken;
            }
            return currentToken;
        });
    }
    /**
     * 多文件批量上传方法
     *
     * - 本方法是基于 [`upload()`](https://f2er.meitu.com/meitu-upload/api/upload/class/Uploader#upload) 方法扩展实现的，最多支持一次性上传 20 个文件；
     *
     * @async
     * @since 4.4.0
     * @param files 要批量上传的文件列表；值为 Data URL（Base64） 字符串 / 本地路径 / `File` 对象；微信等小程序端只支持传入本地文件路径字符串；
     * @param params 上传请求参数
     * @param options 可选；上传配置选项
     */
    uploadMultiple(files_1, params_1) {
        return __awaiter(this, arguments, void 0, function* (files, params, options = {}) {
            var _a;
            this.debugLog('[uploadMultiple] files =>', files);
            this.debugLog('[uploadMultiple] params =>', params);
            this.debugLog('[uploadMultiple] options =>', options);
            if (files.length > MAX_TOKEN_COUNT) {
                throw new UploaderError('最多只允许一次性上传 20 个文件');
            }
            if ((params === null || params === void 0 ? void 0 : params.count) && (params === null || params === void 0 ? void 0 : params.count) !== files.length) {
                throw new UploaderError('上传 Token 获取数量与文件数量不一致');
            }
            const { appProxy } = this.options;
            const _options = Object.assign(Object.assign({}, options), { multiple: true });
            params.suffix = this.getFileSuffix(files[0], params);
            params.count = (_a = params === null || params === void 0 ? void 0 : params.count) !== null && _a !== void 0 ? _a : files.length;
            this.tokenList = appProxy ? [] : yield this.requestToken(params);
            // 大部分主流浏览器的同一个源最大并发请求数限制为 6 个，多出的请求会自动排队等待，所以这里不需要在手动维护请求队列，直接一起发送，交由浏览器管理请求队列
            const results = yield Promise.allSettled(Array.from({ length: appProxy ? files.length : this.tokenList.length }, (v, i) => i).map((i) => {
                return this.upload(files[i], params, Object.assign(Object.assign({}, _options), { tokenList: this.tokenList, uploadToken: this.tokenList[i], index: i }));
            }));
            this.reset();
            return results.map((result, index) => {
                if (result.status === 'fulfilled') {
                    return result.value;
                }
                else {
                    return createUploadResult({ index });
                }
            });
        });
    }
    /**
     * 请求上传所需的 Token
     *
     * @async
     * @link https://cf.meitu.com/confluence/pages/viewpage.action?pageId=5313382
     * @param params 请求上传 Token 的参数
     * @returns 上传 Token 列表
     */
    requestToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { headers: headersParams = {} } = params, restParams = __rest(params, ["headers"]);
            const headers = {};
            // 如果 MAAT 安全策略平台有配置需要登录才能获取 token，则需要传入 accessToken 配置项
            if (this.options.accessToken) {
                headers['Access-Token'] = this.options.accessToken;
            }
            this.debugLog('[requestToken] params =>', restParams);
            if ((restParams === null || restParams === void 0 ? void 0 : restParams.count) > MAX_TOKEN_COUNT) {
                throw new UploaderError(`最多只允许一次性获取 ${MAX_TOKEN_COUNT} 个上传 Token`);
            }
            const signedParams = yield this.options.sign(restParams);
            this.debugLog('[requestToken] signedParams =>', signedParams);
            // 将键值对对象转换为请求字符串
            const queries = keyValueToQueryStrings(signedParams, (_) => {
                return _[1] !== 'undefined';
            });
            const protocol = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) || '';
            // 针对 pre 环境，token 请求地址协议与 location.protocol 同步，仅对 protocol 为 http 或 https 时生效，防止本地包内请求错误
            const tokenApi = /^http(s|):/.test(protocol) ? this.tokenApi.replace('http:', protocol) : this.tokenApi;
            // 请求获取上传 token 的接口
            const result = yield this.request(`${tokenApi}?${queries}`, {
                headers: Object.assign(Object.assign({}, headers), headersParams),
            });
            if (!result) {
                throw result;
            }
            if (result.status !== 200) {
                throw result;
            }
            if (typeof (result === null || result === void 0 ? void 0 : result.json) !== 'function') {
                throw new UploaderError('this.request() 方法的返回结果对象的 json() 方法没有实现');
            }
            // 将接口响应返回的所有字段转换为小驼峰
            const json = toCamelCase(yield result.json());
            this.debugLog('[requestToken] tokenList =>', json);
            return json;
        });
    }
    /**
     * 重置上传状态数据
     *
     * @protected
     * @since 4.5.0
     */
    reset() {
        this.proxies = {};
        this.tokenList = [];
        this.currentTokenIndex = 0;
        this.currentCloudIndex = 0;
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(`${this.logPrefix}[${this.constructor.name}]`, ...args);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/node_modules/@meitu/upload-core/dist/esm/index.js





// EXTERNAL MODULE: ./node_modules/crypto-js/hmac-sha1.js
var hmac_sha1 = __webpack_require__(68398);
var hmac_sha1_default = /*#__PURE__*/__webpack_require__.n(hmac_sha1);
;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/utils/multipart.js


/**
 * 请求头 Meta 信息前缀
 */
const headerMetaPrefix = 'x-obs-meta-';
/**
 * 请求头信息前缀
 */
const headerPrefix = 'x-amz-';
/**
 * 请求头信息字段列表
 */
const interestHeader = ['Content-MD5', 'Content-Type'];
/**
 * 获取请求头签名信息
 *
 * @since 4.6.0
 * @param options 请求配置
 */
function getHeaderSign(options) {
    let stringToSign = options.method + '\n';
    for (let i = 0; i < interestHeader.length; i++) {
        if (interestHeader[i] in options.headers) {
            stringToSign += options.headers[interestHeader[i]];
        }
        stringToSign += '\n';
    }
    if (!(headerPrefix + 'date' in options.headers)) {
        stringToSign += options.headers['Date'];
    }
    stringToSign += '\n';
    let temp = [];
    for (const originKey in options.headers) {
        if (Object.hasOwnProperty.call(options.headers, originKey)) {
            const lowerKey = originKey.toLowerCase();
            const value = options.headers[originKey];
            if (lowerKey.indexOf(headerPrefix) === 0) {
                temp.push({
                    key: lowerKey,
                    value,
                });
            }
        }
    }
    temp = temp.sort((a, b) => a.key - b.key);
    for (let i = 0; i < temp.length; i++) {
        const key = temp[i].key;
        const val = key.indexOf(headerMetaPrefix) === 0 ? temp[i].value.trim() : temp[i].value;
        stringToSign += key + ':' + val + '\n';
    }
    stringToSign += options.uri;
    return stringToSign;
}
/**
 * 获取请求头签名
 *
 * @since 4.6.0
 * @param ak 亚马逊 AWS S3 Access Key
 * @param sk 亚马逊 AWS S3 密钥
 * @param bucket 存储桶名
 * @param key 上传文件 Key
 * @param headers 请求头信息
 */
function getAuthorization(method, ak, sk, uri, headers) {
    const signString = getHeaderSign({
        method,
        headers,
        uri,
    });
    return `AWS ${ak}:${hmac_sha1_default()(signString, sk).toString((enc_base64_default()))}`;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/utils/request.js
/**
 * S3 上传通用请求类配置
 */
/**
 * S3 上传通用请求
 */
class AjaxRequest {
    /**
     * 获取请求实例
     */
    get request() {
        return this.xhr;
    }
    constructor(options) {
        this.options = {
            method: 'POST',
            url: '',
            headers: {},
        };
        /**
         * XMLHttpRequest 请求实例对象
         */
        this.xhr = null;
        this.options = Object.assign(Object.assign({}, this.options), options);
        return this.createRequest();
    }
    /**
     * 创建请求
     */
    createRequest() {
        var _a;
        const { method, url, params = {}, headers, body, progress, success, failure, timeout } = this.options;
        const xhr = new XMLHttpRequest();
        if (url === '' || url === undefined || url === null) {
            throw new Error(`请求失败: url 不能为空`);
        }
        const paramsString = objectToUrlParams(params);
        const reqUrl = paramsString ? `${url}${url.indexOf('?') > -1 ? '&' : '?'}${paramsString}` : url;
        xhr.open(method, reqUrl, true);
        if (timeout !== undefined) {
            xhr.timeout = timeout;
        }
        this.xhr = xhr;
        if (headers) {
            for (const key in headers) {
                if (Object.prototype.hasOwnProperty.call(headers, key)) {
                    xhr.setRequestHeader(key, headers[key]);
                }
            }
        }
        // 请求进度监听
        (_a = xhr.upload) === null || _a === void 0 ? void 0 : _a.addEventListener('progress', (event) => {
            if (!event.lengthComputable) {
                return;
            }
            const loaded = event.loaded;
            const total = event.total;
            const percent = Math.round((loaded / total) * 100);
            progress === null || progress === void 0 ? void 0 : progress({
                total: {
                    percent,
                    loaded,
                    total,
                    size: total,
                },
            }, xhr);
        });
        xhr.onload = () => {
            try {
                const result = formatResponse(xhr);
                // 状态码 2xx 都认为是成功
                if (xhr.status < 300) {
                    result.ETag = xhr.getResponseHeader('etag') || '';
                    success(result, xhr);
                }
                else {
                    failure(result, xhr);
                }
            }
            catch (e) {
                failure === null || failure === void 0 ? void 0 : failure(e, xhr);
            }
        };
        xhr.onerror = (error) => {
            failure === null || failure === void 0 ? void 0 : failure(error, xhr);
        };
        xhr.onabort = () => {
            failure(new Error('upload abort'), xhr);
        };
        xhr.ontimeout = () => {
            failure(new Error('upload timeout'), xhr);
        };
        xhr.send(body);
        return this;
    }
    /**
     * 取消请求
     */
    abort() {
        var _a, _b;
        (_b = (_a = this.xhr) === null || _a === void 0 ? void 0 : _a.abort) === null || _b === void 0 ? void 0 : _b.call(_a);
        return this;
    }
    /**
     * 恢复请求
     */
    resume() {
        this.createRequest();
        return this;
    }
}
/**
 * 格式化接口返回的信息
 *
 * @param xhr 响应信息对象
 */
function formatResponse(xhr) {
    var _a, _b;
    const xmlToRecord = (xml) => {
        const data = {};
        xml.match(/<(\w+)>.*?<\/\1>/g).forEach((match) => {
            const tagName = match.match(/^<(\w+)>/)[1].replace(/^./, (c) => c.toLowerCase());
            const tagContent = match.replace(/<.*?>/g, '');
            data[tagName] = tagContent;
        });
        return data;
    };
    if (xhr.status !== 200) {
        let errorCode = xhr.status;
        let errorMsg = '';
        let errorMessage = `upload failed! HTTP ${xhr.status} ${xhr.statusText}`;
        // 如果返回的是 XML
        if (xhr.responseXML && xhr.responseText) {
            const xml = xhr.responseText;
            errorCode = ((_a = xml.match(/<Code>([^>]+)<\/Code>/)) === null || _a === void 0 ? void 0 : _a[1]) || '上传错误';
            errorMsg = ((_b = xml.match(/<Message>([^>]+)<\/Message>/)) === null || _b === void 0 ? void 0 : _b[1]) || '未知原因';
            errorMessage = `${errorCode}: ${errorMsg}`;
        }
        return {
            code: xhr.status,
            msg: errorMsg,
            message: errorMessage,
        };
    }
    if (xhr.responseXML) {
        return xmlToRecord(xhr.responseText);
    }
    return JSON.parse(xhr.responseText || '{}');
}
/**
 * 对象转 url params
 *
 * @param obj 要转码的对象
 */
function objectToUrlParams(obj) {
    const params = [];
    if (typeof obj !== 'object') {
        return `${obj}`;
    }
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            let value = obj[key] || '';
            if (typeof value === 'object') {
                value = objectToUrlParams(value);
            }
            if (value !== undefined && value !== null) {
                params.push(`${key}=${encodeURIComponent(`${value}`)}`);
            }
        }
    }
    return params.join('&');
}
/**
 * 将对象抓换成 XML
 *
 * @param obj 要转码的对象
 * @param sentAs 发送方式，消息组容器标签名
 * @param wrapper 外层容器标签名称
 */
function objectToXML(obj, sentAs, wrapper) {
    const tag = '<{T}>{V}</{T}>';
    const replace = (k, v) => tag.replace(/{T}/g, k).replace('{V}', v).replace(/"/g, '&quot;');
    const values = obj.map((item) => {
        let str = '';
        for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
                str += replace(key, item[key]);
            }
        }
        return replace(sentAs, str);
    });
    return replace(wrapper, values.join(''));
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/utils/index.js



;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/multipart.js


/**
 * S3（AWS & 华为云）分段上传类
 *
 * @since 4.6.0
 */
class S3MultipartUploader {
    /**
     * 上传 Token 配置数据
     *
     * @getter
     * @readonly
     */
    get uploadToken() {
        return this.options.uploadToken;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 重试次数
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryCount() {
        var _a;
        return (_a = this.options.retryCount) !== null && _a !== void 0 ? _a : constants_DEFAULT_RETRY_COUNT;
    }
    /**
     * 当上传请求错误达到限定时，是否启用主备切换
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryBackupHost() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.retryBackupHost) !== null && _b !== void 0 ? _b : true;
    }
    constructor(options) {
        /**
         * XMLHttpRequest 请求实例对象
         *
         * @deprecated
         */
        this.xhr = null;
        /**
         * XMLHttpRequest 请求实例对象列表
         *
         * @since 4.7.0
         */
        this.xhrQueue = [];
        /**
         * 上传 ID
         */
        this.uploadId = '';
        /**
         * 分段缓存信息
         */
        this.cacheParts = {};
        /**
         * 初始化分段上传时的配置信息
         */
        this.formData = null;
        /**
         * 上传的分片
         */
        this.partNumber = 1;
        /**
         * 是否完成上传
         */
        this.isCompleted = true;
        /**
         * 是否有触发过取消上传
         */
        this.isCancel = false;
        /**
         * 分段上传方法配置信息
         */
        this.uploadPartOptions = {};
        /**
         * 缓存已经上传的切片数据
         *
         * @since 4.7.0
         */
        this.updatedPartCache = [];
        /**
         * 缓存已经上传的进度信息
         *
         * @since 4.7.0
         */
        this.updatedPartProgressCache = [];
        /**
         * 配置选项
         *
         * @protected
         */
        this.options = {
            debug: false,
            cloud: common_enum_Cloud.AWSS3,
            expirationSeconds: 600,
            partSize: constants_DEFAULT_PART_SIZE,
            index: 0,
            mimeType: '',
            file: '',
            tokenParams: {},
            uploadToken: {},
        };
        // 单个分片大小不能小于云服务器限制
        const partSize = Math.max((options === null || options === void 0 ? void 0 : options.partSize) || this.options.partSize, constants_MIN_PART_SIZE);
        this.options = Object.assign(Object.assign(Object.assign({ taskId: utils_generateTaskId() }, this.options), options), { partSize });
        this.debugLog('options =>', options);
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(constants_LOG_PREFIX + '[s3-multipart-uploader]', ...args);
    }
    /**
     * 获取分段上传链接
     *
     * @param queryString 额外的请求参数
     * @protected
     */
    getUploadUrl(queryString = '', useBackupHost = false) {
        const { url, bucket, key, backupUrl } = this.uploadToken;
        const uploadHost = useBackupHost && backupUrl ? backupUrl : url;
        return `${uploadHost.replace(/:\/\//, `://${bucket}.`)}/${key}${queryString ? `?${queryString}` : ''}`;
    }
    /**
     * 初始化分段上传
     *
     * 获取分段上传 uploadId
     *
     * @param formData 表单数据
     * @param success 请求成功回调
     * @param failure 请求失败回调
     */
    initMultipartUpload(formData, success, failure) {
        this.formData = formData;
        this.updatedPartCache = [];
        this.updatedPartProgressCache = [];
        this.xhrQueue = [];
        return new Promise((resolve, reject) => {
            try {
                this.request({
                    method: 'POST',
                    url: this.getUploadUrl('uploads'),
                    headers: {
                        'Content-Type': formData['Content-Type'],
                        'x-amz-meta-property': 'property-value',
                        'x-amz-security-token': formData['X-Amz-Security-Token'],
                    },
                    success: (result) => {
                        this.debugLog('initMultipartUpload result =>', result);
                        this.uploadId = result.uploadId;
                        success === null || success === void 0 ? void 0 : success(result);
                        resolve(result);
                    },
                    failure: (err) => {
                        var _a, _b;
                        this.debugLog('initMultipartUpload failure =>', err);
                        failure === null || failure === void 0 ? void 0 : failure(err);
                        (_b = (_a = this.options).failure) === null || _b === void 0 ? void 0 : _b.call(_a, err, this.options.index);
                        reject(err);
                    },
                });
            }
            catch (e) {
                reject(e);
            }
        });
    }
    /**
     * 上传指定的分段信息
     *
     * @param options 配置选项
     * @param retry 重试计数
     * @since 4.7.0
     * @protected
     */
    uploadSpecifiedPart(options) {
        const { url, backupUrl } = this.uploadToken;
        const { file, partNumber, uploadId: _uploadId, success, progress, failure } = options;
        const uploadId = _uploadId || this.uploadId || '';
        return new Promise((resolve, reject) => {
            const _upload = (retry = 0, useBackupHost = false) => {
                this.request({
                    method: 'PUT',
                    url: this.getUploadUrl('', useBackupHost),
                    headers: {
                        'Content-Type': 'binary/octet-stream',
                        'x-amz-security-token': this.formData['X-Amz-Security-Token'],
                    },
                    body: file,
                    params: {
                        partNumber,
                        uploadId,
                    },
                    failure: (err) => {
                        if (!this.isCancel) {
                            if (retry < this.retryCount) {
                                _upload(retry + 1, useBackupHost);
                                return;
                            }
                            // 主备切换并进行错误重试
                            if (!useBackupHost && this.retryBackupHost && backupUrl && url !== backupUrl) {
                                _upload(0, true);
                                return;
                            }
                        }
                        failure === null || failure === void 0 ? void 0 : failure(err, partNumber);
                        reject(err);
                    },
                    progress: ({ total }) => {
                        progress === null || progress === void 0 ? void 0 : progress({
                            index: this.options.index,
                            taskId: this.options.taskId,
                            total,
                        });
                    },
                    success: (result) => {
                        success === null || success === void 0 ? void 0 : success({
                            PartNumber: partNumber,
                            ETag: result.ETag,
                        });
                        resolve(result);
                    },
                });
            };
            _upload();
        });
    }
    /**
     * 上传分段信息
     *
     * @param options 配置选项
     */
    uploadPart(options = {}) {
        const { file, partSize, index, failure, progress, complete: _complete, maxConcurrent } = this.options;
        const { partNumber = 1, uploadId: _uploadId, autoComplete = true, complete } = options;
        const uploadId = _uploadId || this.uploadId || '';
        if (!this.formData || !uploadId) {
            throw new Error('请先执行 initMultipartUpload 获取配置信息');
        }
        this.uploadPartOptions = options;
        this.isCompleted = false;
        this.isCancel = false;
        // 上传的文件大小
        const fileSize = file.size;
        // 分段数量
        const partCount = Math.ceil(fileSize / partSize);
        const partCache = [];
        const _maxConcurrent = Math.max(1, maxConcurrent !== null && maxConcurrent !== void 0 ? maxConcurrent : partCount);
        let count = 0;
        while (count < partCount) {
            // 如果是断点续传 则仅上传未上传成功的内容
            partCache[count] = !this.updatedPartCache[count]
                ? file.slice(partSize * count, partSize * (count + 1))
                : undefined;
            count++;
        }
        const partCacheRequests = [];
        const counts = [...this.updatedPartProgressCache];
        let progressValue = 0;
        partCache.forEach((file, idx) => {
            if (!file || partCacheRequests.length >= _maxConcurrent) {
                return;
            }
            partCacheRequests.push(this.uploadSpecifiedPart({
                file,
                partNumber: idx + 1,
                progress: (result) => {
                    this.updatedPartProgressCache[idx] = counts[idx] = result.total.loaded;
                    progressValue = counts.reduce((a, b) => (a || 0) + (b || 0));
                    progress === null || progress === void 0 ? void 0 : progress({
                        index,
                        taskId: this.options.taskId,
                        total: {
                            total: fileSize,
                            loaded: progressValue,
                            size: fileSize,
                            percent: Math.min(Math.round((progressValue / fileSize) * 100), 100),
                        },
                    });
                },
                success: (res) => {
                    this.updatedPartCache[idx] = res;
                },
                failure: (err) => {
                    var _a;
                    // 失败后需要清除一下当前进度
                    delete this.updatedPartProgressCache[idx];
                    (_a = options.failure) === null || _a === void 0 ? void 0 : _a.call(options, err, partNumber);
                },
            }));
        });
        Promise.all(partCacheRequests)
            .then((...args) => {
            var _a;
            this.debugLog('UploadPart success =>', args);
            const updatedPartCache = [...this.updatedPartCache].filter((d) => !!d);
            if (updatedPartCache.length < partCount) {
                this.uploadPart(options);
                return;
            }
            this.cacheParts[uploadId] = [...this.updatedPartCache];
            this.updatedPartCache = [];
            if (updatedPartCache.length === partCount && autoComplete) {
                this.completeMultipartUpload({
                    success: (result) => {
                        complete === null || complete === void 0 ? void 0 : complete(result);
                        _complete === null || _complete === void 0 ? void 0 : _complete(result);
                    },
                });
            }
            (_a = options.success) === null || _a === void 0 ? void 0 : _a.call(options, this.cacheParts[uploadId]);
        })
            .catch((err) => {
            this.debugLog('UploadPart failure =>', err);
            failure === null || failure === void 0 ? void 0 : failure(err, index);
        });
    }
    /**
     * 完成分段上传
     *
     * @param options
     */
    completeMultipartUpload(options = {}) {
        const { index, cloud, mimeType, tokenParams, file, uploadToken: { data, accessUrl, key }, failure, } = this.options;
        const uploadId = options.uploadId || this.uploadId || '';
        const cacheParts = this.cacheParts[uploadId];
        this.isCancel = false;
        if (!this.formData || !uploadId) {
            throw new Error('请先执行 initMultipartUpload 获取配置信息');
        }
        if (cacheParts === undefined || cacheParts.length === 0) {
            throw new Error('请先上传分段信息');
        }
        this.request({
            method: 'POST',
            url: this.getUploadUrl(),
            exposureXHR: false, // 合并阶段不在允许中断操作
            headers: {
                'Content-Type': 'binary/octet-stream',
                'x-amz-security-token': this.formData['X-Amz-Security-Token'],
            },
            body: objectToXML(cacheParts, 'Part', 'CompleteMultipartUpload'),
            params: {
                uploadId,
            },
            failure: (err) => {
                var _a;
                (_a = options.failure) === null || _a === void 0 ? void 0 : _a.call(options, err);
                failure === null || failure === void 0 ? void 0 : failure(err, index);
            },
            success: () => {
                var _a;
                delete this.cacheParts[uploadId];
                this.isCompleted = true;
                const fileSize = (file === null || file === void 0 ? void 0 : file.size) || 0;
                const result = {
                    data,
                    key,
                    url: data,
                    etag: '',
                    size: fileSize,
                    fileSize: `${fileSize}`,
                    previewUrl: accessUrl,
                    storage: cloud,
                    mimeType,
                    type: tokenParams.type,
                    index,
                };
                this.debugLog('ComputeMultipartUploadRequest Result =>', result);
                (_a = options === null || options === void 0 ? void 0 : options.success) === null || _a === void 0 ? void 0 : _a.call(options, result);
            },
        });
    }
    /**
     * 取消指定桶中的分段上传任务
     */
    abortMultipartUpload(id = '', success, failure) {
        const uploadId = id || this.uploadId;
        if (!uploadId) {
            return;
        }
        this.request({
            method: 'DELETE',
            url: this.getUploadUrl(),
            headers: {
                'Content-Type': 'binary/octet-stream',
                'x-amz-security-token': this.formData['X-Amz-Security-Token'],
            },
            params: {
                uploadId,
            },
            failure: (error) => {
                failure === null || failure === void 0 ? void 0 : failure(error);
            },
            success: () => {
                delete this.cacheParts[uploadId];
                this.xhrQueue = [];
                this.updatedPartCache = [];
                this.partNumber = 1;
                this.uploadId = '';
                this.uploadPartOptions = {};
                success === null || success === void 0 ? void 0 : success();
            },
        });
    }
    /**
     * 取消上传
     */
    cancel() {
        this.isCancel = true;
        if (this.xhrQueue.length) {
            this.xhrQueue.forEach((xhr) => { var _a; return (_a = xhr === null || xhr === void 0 ? void 0 : xhr.abort) === null || _a === void 0 ? void 0 : _a.call(xhr); });
        }
        // 如果没有启用断点续传则需要删除
        if (this.uploadId && this.options.resumable === false) {
            this.abortMultipartUpload();
        }
    }
    /**
     * 同  cancel 用于兼容自定义请求
     */
    abort() {
        this.cancel();
    }
    /**
     * 断点续传
     */
    resume() {
        // 只允许未完成并且触发过取消的任务执行断点续传
        if (this.isCompleted || !this.isCancel) {
            return;
        }
        // 如果没有启用断点续传则不进行任何处理
        if (this.options.resumable === false) {
            this.initMultipartUpload(this.formData).then(() => {
                this.uploadPart();
            });
            return;
        }
        this.uploadPart(this.uploadPartOptions);
    }
    /**
     * 创建分段上传相关请求
     *
     * @param options
     * @protected
     */
    request(options) {
        const { url, method, params, exposureXHR = true } = options;
        const headers = Object.assign({ 'x-amz-date': new Date().toUTCString() }, options === null || options === void 0 ? void 0 : options.headers);
        const settings = Object.assign(Object.assign({}, options), { exposureXHR, headers: Object.assign(Object.assign({}, headers), { Authorization: this.getAuthorization({
                    url,
                    method,
                    params,
                    headers,
                }) }) });
        const xhr = this.options.request ? this.options.request.bind(this)(settings) : new AjaxRequest(settings);
        this.xhr = xhr;
        if (exposureXHR) {
            this.xhrQueue.push(xhr);
        }
    }
    /**
     * 获取请求头签名
     *
     * @param options 获取请求头签名配置
     */
    getAuthorization(options) {
        const { credentials, key, bucket } = this.uploadToken;
        const { url, method, headers, params = {} } = options;
        const paramsString = objectToUrlParams(params);
        const uri = paramsString ? `${url}${url.indexOf('?') > -1 ? '&' : '?'}${paramsString}` : url;
        const urlSearch = uri.split('?')[1];
        return getAuthorization(method, credentials.accessKey, credentials.secretKey, `/${bucket}/${key}${urlSearch ? `?${urlSearch}` : ''}`, headers);
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/upload-s3/dist/esm/index.js









/**
 * 获取 S2 参数签名值（v4 版本）
 *
 * @param secretKey 上传 Token 接口下发的密钥
 * @param dateStamp 上传日期（`yyyymmdd`）
 * @param region 云存储区位/位置
 * @param service 可选；云服务名称；默认值为 `s3`
 */
function getSignatureKey(secretKey, dateStamp, region, service = 's3') {
    const dateKey = hmac_sha256_default()(dateStamp, 'AWS4' + secretKey);
    const regionKey = hmac_sha256_default()(region, dateKey);
    const serviceKey = hmac_sha256_default()(service, regionKey);
    const signingKey = hmac_sha256_default()('aws4_request', serviceKey);
    return signingKey;
}
/**
 * S3（AWS & 华为云）表单上传类
 *
 * @since 4.2.0
 * @link https://docs.aws.amazon.com/zh_cn/AmazonS3/latest/API/sigv4-UsingHTTPPOST.html
 * @link https://docs.aws.amazon.com/zh_cn/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
 */
class S3Uploader {
    /**
     * 任务 ID
     *
     * @since 4.7.0
     * @getter
     * @readonly
     */
    get taskId() {
        return this._taskId;
    }
    /**
     * 云存储服务名称
     *
     * @getter
     * @readonly
     */
    get cloud() {
        return this.options.cloud;
    }
    /**
     * 当前是否为调试模式
     *
     * @getter
     * @readonly
     */
    get debug() {
        return this.options.debug;
    }
    /**
     * 上传的文件
     *
     * @getter
     * @readonly
     */
    get file() {
        return this.options.file;
    }
    /**
     * 上传 Token 配置数据
     *
     * @getter
     * @readonly
     */
    get uploadToken() {
        return this.options.uploadToken;
    }
    /**
     * 上传链接地址
     *
     * @getter
     * @readonly
     */
    get uploadUrl() {
        return this.getUploadUrl();
    }
    /**
     * 错误重试次数
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryCount() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.retryCount) !== null && _b !== void 0 ? _b : constants_DEFAULT_RETRY_COUNT;
    }
    /**
     * 当上传请求错误达到限定时，是否启用主备切换
     *
     * @since 4.8.0
     * @getter
     * @readonly
     */
    get retryBackupHost() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.retryBackupHost) !== null && _b !== void 0 ? _b : true;
    }
    /**
     * 获取上传链接地址
     *
     * @since 4.8.0
     * @param useBackupHost 是否使用备份
     */
    getUploadUrl(useBackupHost = false) {
        const { url, bucket, backupUrl } = this.uploadToken;
        const uploadHost = useBackupHost && backupUrl ? backupUrl : url;
        if (uploadHost.indexOf(`${bucket}.`) >= 0) {
            return uploadHost;
        }
        return uploadHost.replace(/(https?:\/\/)/, `$1${bucket}.`);
    }
    constructor(options) {
        /**
         * 配置选项
         *
         * @protected
         */
        this.options = {
            debug: false,
            cloud: common_enum_Cloud.AWSS3,
            expirationSeconds: 600,
            index: 0,
            file: '',
            tokenParams: {},
            mimeType: '',
            uploadToken: {},
        };
        /**
         * XMLHttpRequest 请求实例对象
         *
         * @since 4.5.0
         */
        this.xhr = null;
        /**
         * 分段上传实例对象
         *
         * @since 4.5.2
         * @protected
         */
        this.multipartUploader = null;
        /**
         * 是否完成上传
         *
         * @since 4.5.2
         * @protected
         */
        this.isCompleted = true;
        /**
         * 是否有触发过取消上传
         *
         * @since 4.6.0
         * @protected
         */
        this.isCancel = false;
        /**
         * 表单上传配置信息缓存
         *
         *  @since 4.8.0
         *  @protected
         */
        this._uploadOptionsCache = {};
        this.options = Object.assign(Object.assign({}, this.options), options);
        this._taskId = utils_generateTaskId();
        this.debugLog('options =>', options);
    }
    /**
     * 调试模式下，输出控制台日志
     *
     * @param args 参数
     */
    debugLog(...args) {
        if (!this.debug) {
            return;
        }
        console.log(constants_LOG_PREFIX + '[s3-uploader]', ...args);
    }
    /**
     * 获取 S3 上传凭证标识
     *
     * @param YYYYMMDD 上传日期；格式：`yyyymmdd`
     */
    getCredential(YYYYMMDD) {
        const { credentials, region } = this.uploadToken;
        return `${credentials.accessKey}/${YYYYMMDD}/${region}/s3/aws4_request`;
    }
    /**
     * 参与签名的表单数据
     *
     * 与上传的表单数据顺序要一一对应，否则无法通过参数签名校验
     *
     * @param date 上传日期时间对象
     */
    getSingedFormData(date) {
        const { credentials } = this.uploadToken;
        return {
            // eslint-disable-next-line camelcase
            success_action_status: '200',
            'X-Amz-Credential': this.getCredential(date.YYYYMMDD),
            'X-Amz-Algorithm': 'AWS4-HMAC-SHA256',
            'X-Amz-Security-Token': credentials.sessionToken,
            'X-Amz-Date': date.iso8601,
        };
    }
    /**
     * 获取当前上传及过期日期时间
     */
    getUploadDateTime() {
        const { expirationSeconds } = this.options;
        const now = Date.now();
        const isoDate = new Date(now).toISOString();
        return {
            YYYYMMDD: isoDate.match(/\d+-\d+-\d+/)[0].replace(/-/g, ''),
            iso8601: isoDate.replace(/\.\d{3}Z$/, 'Z').replace(/[:-]|\.\d{3}/g, ''),
            expiration: new Date(now + expirationSeconds * 1000).toISOString(),
        };
    }
    /**
     * 创建上传策略配置
     *
     * 用于创建上传签名数据
     *
     * @param date 上传及过期日期时间数据
     * @param fileKeyPrefix 可选；允许上传的文件名 Key 前缀
     * @param contentType 可选；允许上传的文件内容类型（前缀）
     */
    createPolicy(date, fileKeyPrefix, contentType) {
        const { mimeType = '' } = this.options;
        const { bucket, key } = this.uploadToken;
        const policy = {
            expiration: date.expiration,
            // 在表单中指定的每个表单字段（具有 x-ignore- 前缀的 、file、policy 和 x-amz-signature 字段名称除外）都必须出现在条件列表中。
            conditions: [
                { bucket },
                ['starts-with', '$key', fileKeyPrefix !== null && fileKeyPrefix !== void 0 ? fileKeyPrefix : `${key.indexOf('/') >= 0 ? key.split('/')[0] + '/' : ''}`],
                [
                    'starts-with',
                    '$Content-Type',
                    contentType !== null && contentType !== void 0 ? contentType : `${mimeType.indexOf('/') >= 0 ? mimeType.split('/')[0] + '/' : ''}`,
                ],
                ...Object.entries(this.getSingedFormData(date)).map(([key, value]) => {
                    return { [key]: value };
                }),
            ],
        };
        const policyBase64 = enc_base64_default().stringify(enc_utf8_default().parse(JSON.stringify(policy)));
        this.debugLog('policy =>', JSON.stringify(policy, null, '    '));
        return {
            policy,
            policyBase64,
        };
    }
    /**
     * 获取上传参数签名值
     *
     * @param date 上传日期时间对象
     * @param policyBase64 上传策略（Base64 编码）
     */
    createSignature(date, policyBase64) {
        const { credentials, region } = this.uploadToken;
        const { secretKey } = credentials;
        const signingKey = getSignatureKey(secretKey, date.YYYYMMDD, region);
        const signature = hmac_sha256_default()(policyBase64, signingKey).toString((enc_hex_default()));
        return signature;
    }
    /**
     * 创建上传表单数据键值对对象
     */
    createFormData() {
        const { mimeType } = this.options;
        const { key } = this.uploadToken;
        const date = this.getUploadDateTime();
        const { policyBase64 } = this.createPolicy(date);
        const signature = this.createSignature(date, policyBase64);
        const formData = Object.assign(Object.assign({ key, 'Content-Type': mimeType }, this.getSingedFormData(date)), { Policy: policyBase64, 'X-Amz-Signature': signature });
        this.debugLog('formData =>', JSON.stringify(formData, null, '    '));
        return formData;
    }
    /**
     * POST 表单上传方法
     */
    upload() {
        if (typeof FormData === 'undefined') {
            throw new Error('FormData undefined');
        }
        const formData = new FormData();
        const data = this.createFormData();
        const file = this.file;
        const { index, partSize = constants_DEFAULT_PART_SIZE } = this.options;
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });
        formData.append('file', file);
        if (typeof XMLHttpRequest === 'undefined') {
            throw new Error('XMLHttpRequest undefined');
        }
        this.isCompleted = false;
        this.isCancel = false;
        this.multipartUploader = null;
        return new Promise((resolve, reject) => {
            const onComplete = (result) => {
                var _a, _b;
                this.debugLog('result =>', result);
                this.isCompleted = true;
                this.isCancel = false;
                (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a, result);
                resolve(result);
            };
            const onError = (error) => {
                var _a, _b;
                this.debugLog('upload: error > xhr =>', this.xhr, error);
                (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.failure) === null || _b === void 0 ? void 0 : _b.call(_a, error, index);
                // 非用户主动触发的中止操作才结束任务
                if (!this.isCancel) {
                    reject(error);
                }
            };
            if (typeof file !== 'string' && file.size > constants_MIN_PART_SIZE && file.size > partSize) {
                const multipartUploader = new S3MultipartUploader(Object.assign(Object.assign({}, this.options), { complete: onComplete, failure: (err) => {
                        onError(err);
                    } }));
                this.multipartUploader = multipartUploader;
                multipartUploader.initMultipartUpload(data).then(() => {
                    multipartUploader.uploadPart();
                });
                return;
            }
            this._upload({
                formData,
                onComplete,
                onError,
            });
        });
    }
    /**
     * POST 表单上传方法
     *
     * @since 4.8.0
     * @protected
     */
    _upload(options) {
        const { index } = this.options;
        const { url, backupUrl } = this.uploadToken;
        const { onComplete, onError, useBackupHost = false, retry = 0, formData } = options;
        let fileSize = 0;
        this._uploadOptionsCache = {
            formData,
            onComplete,
            onError,
        };
        if (!formData) {
            return;
        }
        const instance = new AjaxRequest({
            method: 'POST',
            url: this.getUploadUrl(useBackupHost),
            body: formData,
            progress: (result) => {
                var _a, _b, _c;
                if (fileSize === 0) {
                    fileSize = (_a = result.total) === null || _a === void 0 ? void 0 : _a.total;
                }
                (_c = (_b = this.options) === null || _b === void 0 ? void 0 : _b.progress) === null || _c === void 0 ? void 0 : _c.call(_b, Object.assign({ index, taskId: this.taskId }, result));
            },
            success: (_res, xhr) => {
                this.debugLog('upload: onload xhr =>', xhr);
                const { tokenParams, mimeType } = this.options;
                const { data, accessUrl, key } = this.uploadToken;
                const result = {
                    data,
                    url: data,
                    key,
                    etag: '',
                    index,
                    size: fileSize,
                    fileSize: `${fileSize}`,
                    previewUrl: accessUrl,
                    storage: this.cloud,
                    mimeType,
                    type: tokenParams.type,
                };
                onComplete(result);
            },
            failure: (error) => {
                // 非用户主动触发的中止操作时进行错误重试
                if (!this.isCancel) {
                    // 进行错误重试
                    if (retry < this.retryCount) {
                        this._upload(Object.assign(Object.assign({}, options), { retry: retry + 1 }));
                        return;
                    }
                    // 主备切换并进行错误重试
                    if (!useBackupHost && this.retryBackupHost && backupUrl && backupUrl !== url) {
                        this._upload(Object.assign(Object.assign({}, options), { retry: 0, useBackupHost: true }));
                        return;
                    }
                }
                onError(error);
            },
        });
        this.xhr = instance.request;
    }
    /**
     * 取消上传
     *
     * @since 4.5.0
     */
    cancel() {
        var _a, _b, _c;
        this.isCancel = true;
        (_a = this.xhr) === null || _a === void 0 ? void 0 : _a.abort();
        (_c = (_b = this.multipartUploader) === null || _b === void 0 ? void 0 : _b.cancel) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    /**
     * 断点续传
     *
     * @since 4.6.0
     */
    resume() {
        var _a, _b;
        if (this.multipartUploader) {
            (_b = (_a = this.multipartUploader) === null || _a === void 0 ? void 0 : _a.resume) === null || _b === void 0 ? void 0 : _b.call(_a);
            return;
        }
        // 只允许未完成并且触发过取消的任务执行断点续传
        if (this.isCompleted || !this.isCancel) {
            return;
        }
        if (this._uploadOptionsCache.formData) {
            this.isCancel = false;
            this._upload(Object.assign({}, this._uploadOptionsCache));
            return;
        }
        this.upload();
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/s3.js




/**
 * S3 上传基类
 *
 * - 使用场景：如果固定配置使用 AWS / 华为云 S3 上传时，可以用于平替 `UploaderBase` 类，去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss`
 *
 * @since 4.5.0
 */
class S3UploaderBase extends UploaderBase {
    constructor() {
        super(...arguments);
        this.tasks = {};
    }
    request(url_1) {
        return (0,tslib_es6.__awaiter)(this, arguments, void 0, function* (url, options = {}) {
            const result = yield utils_request(url, options);
            this.debugLog('[request] result =>', result);
            return result;
        });
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            var _a, _b;
            const { debug } = this.options;
            const { index = 0, multiple = false } = options || {};
            try {
                params.suffix = this.getFileSuffix(file, params);
                const currentToken = yield this.getUploadToken(params, options);
                const cloud = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.order) === null || _a === void 0 ? void 0 : _a[this.currentCloudIndex];
                const uploadToken = currentToken === null || currentToken === void 0 ? void 0 : currentToken[cloud];
                const _file = checkUploadFileType(file, params.suffix);
                const uploader = new S3Uploader({
                    file: _file,
                    cloud,
                    debug,
                    index,
                    uploadToken,
                    mimeType: _file.type,
                    progress: options === null || options === void 0 ? void 0 : options.progress,
                    complete: options === null || options === void 0 ? void 0 : options.complete,
                    resumable: options === null || options === void 0 ? void 0 : options.resumable,
                    retryCount: options === null || options === void 0 ? void 0 : options.retryCount,
                    partSize: options === null || options === void 0 ? void 0 : options.partSize,
                    maxConcurrent: options === null || options === void 0 ? void 0 : options.maxConcurrent,
                    retryBackupHost: options === null || options === void 0 ? void 0 : options.retryBackupHost,
                    tokenParams: params,
                });
                this.tasks[`${uploader.taskId}`] = uploader;
                const result = yield uploader.upload();
                delete this.tasks[`${uploader.taskId}}`];
                if (!multiple) {
                    this.reset();
                }
                return result;
            }
            catch (error) {
                (_b = options === null || options === void 0 ? void 0 : options.failure) === null || _b === void 0 ? void 0 : _b.call(options, error, index);
                throw error;
            }
        });
    }
    cancel(taskId) {
        var _a, _b, _c, _d;
        if (taskId) {
            (_b = (_a = this.tasks) === null || _a === void 0 ? void 0 : _a[taskId]) === null || _b === void 0 ? void 0 : _b.cancel();
            return;
        }
        for (const i in this.tasks) {
            (_d = (_c = this.tasks) === null || _c === void 0 ? void 0 : _c[i]) === null || _d === void 0 ? void 0 : _d.cancel();
        }
    }
    resume(taskId) {
        var _a, _b, _c, _d;
        if (taskId) {
            (_b = (_a = this.tasks) === null || _a === void 0 ? void 0 : _a[taskId]) === null || _b === void 0 ? void 0 : _b.resume();
            return;
        }
        for (const i in this.tasks) {
            (_d = (_c = this.tasks) === null || _c === void 0 ? void 0 : _c[i]) === null || _d === void 0 ? void 0 : _d.resume();
        }
    }
}
/**
 * S3 上传类
 *
 * - 使用场景：如果固定配置使用 AWS / 华为云 S3 上传时，可以用于平替 `Uploader` 类，去掉不必要的依赖模块，并借助 Tree Shaking 减小构建文件大小
 * - 支持的云存储服务：华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss`
 *
 * @since 4.5.0
 */
class s3_S3Uploader extends S3UploaderBase {
    get logPrefix() {
        return LOG_PREFIX;
    }
    get tokenApi() {
        return this.isTest ? UploadTokenAPI.Test : UploadTokenAPI.Release;
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/uploader.js





/**
 * Web 端上传类
 *
 * 支持的云存储服务：七牛云 `qiniu`、美图云 `mtyun`、华为云 `hw-s3`、亚马逊 AWS `aws-s3`、阿里云 `oss` —— App 端代理上传时，要看 App 端是否实际支持
 */
class Uploader extends UploaderBaseWeb {
    get logPrefix() {
        return LOG_PREFIX;
    }
    get tokenApi() {
        return this.isTest ? UploadTokenAPI.Test : UploadTokenAPI.Release;
    }
    upload(file, params, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
            const getProxy = (cloud) => {
                let uploader;
                if (isS3(cloud)) {
                    uploader = new s3_S3Uploader(this.options);
                }
                else {
                    uploader = new QiniuUploader(this.options);
                }
                this.debugLog('[upload] getProxy =>', { cloud, uploader });
                return uploader;
            };
            return this.uploadProxy(getProxy, file, params, options);
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload-web/dist/esm/index.js







;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/upload/dist/esm/index.js
/* eslint-disable import/export */


const $class = Uploader; // 可根据不同环境使用不同平台的上传类实现
class esm_Uploader extends $class {
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/request.js
var dist_utils_request = __webpack_require__(57526);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/services/index.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fopCreate = function fopCreate(data) {
    var _getConfig = getConfig(), isIntl = _getConfig.isIntl, env = _getConfig.env, appName = _getConfig.appName;
    var requestConfig = {};
    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === "x-design") {
        if (env === "pre") {
            requestConfig.baseURL = webApiUrlStariiMap["beta"];
        }
    }
    return request.post("/v1/fop/create", data, requestConfig);
};
var fopQuery = function fopQuery(params) {
    var _getConfig2 = getConfig(), isIntl = _getConfig2.isIntl, env = _getConfig2.env, appName = _getConfig2.appName;
    var baseURL;
    // 由于海外 Preview 环境没有部署图片文件格式云转换服务，暂时改用 Beta 环境的
    if (isIntl && appName === "x-design") {
        if (env === "pre") {
            baseURL = webApiUrlStariiMap["beta"];
        }
    }
    return request.get("/v1/fop/query", {
        params: params,
        baseURL: baseURL
    });
};
/**
 * 获取obs app 配置
 * @docs https://api-mock.meitu-int.com/project/2110/interface/api/153151
 * @returns
 */ var fetchObsConfig = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(params) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0,dist_utils_request/* default */.ZP)({
                        method: "GET",
                        url: "/v1/obs_config/get_app",
                        params: params,
                        hiddenMessage: true
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchObsConfig(_x) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/config.js
function config_typeof(obj) {
    "@babel/helpers - typeof";
    return config_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, config_typeof(obj);
}
function config_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    config_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == config_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function config_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function config_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                config_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                config_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var config_UploadEnv = /*#__PURE__*/ function(UploadEnv) {
    UploadEnv["Release"] = "Release";
    UploadEnv["Test"] = "Test";
    return UploadEnv;
}({});
var config_DEFAULT_PART_SIZE = 4 * 1024 * 1024;
var defaultConfig = {
    app: "xiuxiu-pro",
    env: config_UploadEnv.Release,
    type: "",
    partSize: config_DEFAULT_PART_SIZE
};
var setUploadConfig = function setUploadConfig(config) {
    Object.assign(defaultConfig, config);
};
var getUploadConfig = function getUploadConfig() {
    return defaultConfig;
};
var getDefaultObsConfig = function getDefaultObsConfig() {
    var _getConfig = (0,configProvider/* getConfig */.iE)(), isIntl = _getConfig.isIntl, appName = _getConfig.appName;
    var obsConfig = {
        sig: false,
        // 是否需要加签
        app: isIntl && appName === "x-design" ? "x-design" : "xiuxiu-pro",
        // 默认非定制版的
        uploadOptions: {}
    };
    return obsConfig;
};
// 异步获取配置信息
var getObsConfigAsync = /*#__PURE__*/ function() {
    var _ref = config_asyncToGenerator(/*#__PURE__*/ config_regeneratorRuntime().mark(function _callee(params) {
        var obsConfig, resObsCfg;
        return config_regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    obsConfig = getDefaultObsConfig();
                    _context.prev = 1;
                    _context.next = 4;
                    return fetchObsConfig(params);
                case 4:
                    resObsCfg = _context.sent;
                    if (resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.app) {
                        obsConfig.app = resObsCfg === null || resObsCfg === void 0 ? void 0 : resObsCfg.app;
                        obsConfig.sig = !!(resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.sig);
                        // 上传配置信息
                        if (resObsCfg.config.partSize) obsConfig.uploadOptions.partSize = resObsCfg.config.partSize;
                        if (resObsCfg.config.concurrency) obsConfig.uploadOptions.maxConcurrent = resObsCfg.config.concurrency;
                    }
                    _context.next = 11;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](1);
                    ;
                case 11:
                    return _context.abrupt("return", obsConfig);
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
    return function getObsConfigAsync(_x) {
        return _ref.apply(this, arguments);
    };
}();
// 分片配置获取, 只获取一次
var sliceConfig;
var sliceConfigPromise = null;
var getSliceConfigAsync = /*#__PURE__*/ function() {
    var _ref2 = config_asyncToGenerator(/*#__PURE__*/ config_regeneratorRuntime().mark(function _callee3() {
        return config_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    if (!sliceConfig) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return", sliceConfig);
                case 2:
                    if (!sliceConfigPromise) {
                        _context3.next = 4;
                        break;
                    }
                    return _context3.abrupt("return", sliceConfigPromise);
                case 4:
                    // 创建新的 Promise 并缓存
                    sliceConfigPromise = config_asyncToGenerator(/*#__PURE__*/ config_regeneratorRuntime().mark(function _callee2() {
                        var _getConfig2, module_id, config, resObsCfg;
                        return config_regeneratorRuntime().wrap(function _callee2$(_context2) {
                            while(1)switch(_context2.prev = _context2.next){
                                case 0:
                                    _getConfig2 = (0,configProvider/* getConfig */.iE)(), module_id = _getConfig2.module_id;
                                    config = {
                                        partSize: config_DEFAULT_PART_SIZE
                                    };
                                    _context2.prev = 2;
                                    _context2.next = 5;
                                    return fetchObsConfig({
                                        project: module_id
                                    });
                                case 5:
                                    resObsCfg = _context2.sent;
                                    if (resObsCfg.config.partSize) config.partSize = resObsCfg.config.partSize;
                                    if (resObsCfg.config.concurrency) config.maxConcurrent = resObsCfg.config.concurrency;
                                    _context2.next = 13;
                                    break;
                                case 10:
                                    _context2.prev = 10;
                                    _context2.t0 = _context2["catch"](2);
                                    ;
                                case 13:
                                    sliceConfig = config;
                                    sliceConfigPromise = null;
                                    return _context2.abrupt("return", config);
                                case 16:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, null, [
                            [
                                2,
                                10
                            ]
                        ]);
                    }))();
                    return _context3.abrupt("return", sliceConfigPromise);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getSliceConfigAsync() {
        return _ref2.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/file-type/index.js
var file_type = __webpack_require__(97769);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/utils/file.js
function file_typeof(obj) {
    "@babel/helpers - typeof";
    return file_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, file_typeof(obj);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function file_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    file_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == file_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function file_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function file_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                file_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                file_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 获取文件类型，兼容file.type为空的情况
function getFileType(file) {
    return new Promise(function(resolve, reject) {
        /**
     * TODO，mimeType获取待优化。先默认获取file.type
     * 依赖file-type获取svg的mimeType不同文件也有各种问题，变成application/xml或空的
     */ if (file.type && file.type === "image/svg+xml") return resolve(file.type);
        // ATTENTION: safari < 14 不支持 file.arrayBuffer
        var reader = new FileReader();
        reader.onload = /*#__PURE__*/ function() {
            var _ref = file_asyncToGenerator(/*#__PURE__*/ file_regeneratorRuntime().mark(function _callee(e) {
                var _e$target;
                var fileType;
                return file_regeneratorRuntime().wrap(function _callee$(_context) {
                    while(1)switch(_context.prev = _context.next){
                        case 0:
                            if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.result) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", reject(new Error("no result")));
                        case 2:
                            _context.next = 4;
                            return (0,file_type.fromBuffer)(new Uint8Array(e.target.result));
                        case 4:
                            fileType = _context.sent;
                            if (fileType !== null && fileType !== void 0 && fileType.mime) {
                                _context.next = 7;
                                break;
                            }
                            return _context.abrupt("return", reject(new Error("getFiletype error")));
                        case 7:
                            return _context.abrupt("return", resolve(fileType.mime));
                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }();
        reader.onerror = reject;
        reader.onabort = reject;
        reader.readAsArrayBuffer(file);
    });
}
// blob转file
function blobToFile(blob, name) {
    var type = blob.type;
    return new File([
        blob
    ], name, {
        type: type
    });
}
// 文件转图片
function file2Image(file) {
    return new Promise(function(resolve, reject) {
        if (!file || !file.type.startsWith("image/")) {
            reject(new Error("Please provide a valid image file."));
            return;
        }
        var reader = new FileReader();
        // 读取文件完成后触发
        reader.onload = function() {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = function(err) {
                return reject(err);
            };
            img.src = reader.result;
        };
        // 文件读取失败
        reader.onerror = function() {
            reject(new Error("Error reading file."));
        };
        // 开始读取文件
        reader.readAsDataURL(file);
    });
}
// IOS13.4.1和chrome81版本以上的浏览器不用手动翻转
var __AutoCanvasNormalize;
var autoCanvasNormalize = function autoCanvasNormalize() {
    if (__AutoCanvasNormalize !== undefined) {
        return __AutoCanvasNormalize;
    }
    var ua = navigator.userAgent;
    // 判断 iPhone 操作系统版本
    var iosVersionMatch = ua.match(/iPhone OS (\d+_\d+(_\d+)?)/);
    var iosVersionValid = false;
    if (iosVersionMatch) {
        var versionString = iosVersionMatch[1];
        ;
        var _versionString$split$ = versionString.split("_").map(Number), _versionString$split$2 = _slicedToArray(_versionString$split$, 3), major = _versionString$split$2[0], minor = _versionString$split$2[1], patch = _versionString$split$2[2];
        var currentVersion = major * 10000 + minor * 100 + (patch || 0);
        var targetVersion = 13 * 10000 + 4 * 100 + 1; // 13.4.1 -> 13401
        iosVersionValid = currentVersion > targetVersion;
    }
    // 判断 Chrome 内核版本大于 81
    var chromeVersionMatch = ua.match(/Chrome\/(\d+)/);
    var chromeVersionValid = false;
    if (chromeVersionMatch) {
        var chromeVersion = parseInt(chromeVersionMatch[1], 10);
        ;
        chromeVersionValid = chromeVersion > 81;
    }
    // 判断 Safari 版本
    var safariVersionMatch = ua.match(/Version\/(\d+\.\d+)/);
    var safariVersionValid = false;
    if (safariVersionMatch) {
        var safariVersion = parseFloat(safariVersionMatch[1]);
        ;
        safariVersionValid = safariVersion >= 13.1; // 设定目标版本为 13.1
    }
    // 判断 Firefox 版本
    var firefoxVersionMatch = ua.match(/Firefox\/(\d+)/);
    var firefoxVersionValid = false;
    if (firefoxVersionMatch) {
        var firefoxVersion = parseInt(firefoxVersionMatch[1], 10);
        ;
        firefoxVersionValid = firefoxVersion >= 78; // 设定目标版本为 78
    }
    __AutoCanvasNormalize = iosVersionValid || chromeVersionValid || safariVersionValid || firefoxVersionValid;
    return __AutoCanvasNormalize;
};
// 修改旋转方向
function changeOrientation(file, orientation) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(/*#__PURE__*/ function() {
        var _ref2 = file_asyncToGenerator(/*#__PURE__*/ file_regeneratorRuntime().mark(function _callee2(resolve) {
            var blobURL, image, width, height, canvas, ctx;
            return file_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        // 这个在safari16以下 如果有旋转的会有问题
                        // const image = await createImageBitmap(file);
                        blobURL = URL.createObjectURL(file);
                        _context2.next = 3;
                        return urlToImage(blobURL);
                    case 3:
                        image = _context2.sent;
                        URL.revokeObjectURL(blobURL);
                        width = image.width, height = image.height;
                        ;
                        canvas = document.createElement("canvas");
                        ctx = canvas.getContext("2d");
                        if (!autoCanvasNormalize()) {
                            _context2.next = 15;
                            break;
                        }
                        // canvas会自动摆正
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(image, 0, 0, width, height);
                        _context2.next = 37;
                        break;
                    case 15:
                        _context2.t0 = orientation;
                        _context2.next = _context2.t0 === 3 ? 18 : _context2.t0 === 6 ? 23 : _context2.t0 === 8 ? 28 : 33;
                        break;
                    case 18:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.rotate(Math.PI);
                        ctx.drawImage(image, -width, -height, width, height);
                        return _context2.abrupt("break", 37);
                    case 23:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(0.5 * Math.PI);
                        ctx.drawImage(image, 0, -height, width, height);
                        return _context2.abrupt("break", 37);
                    case 28:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(3 * Math.PI / 2);
                        ctx.drawImage(image, -width, 0, width, height);
                        return _context2.abrupt("break", 37);
                    case 33:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(image, 0, 0, width, height);
                        return _context2.abrupt("break", 37);
                    case 37:
                        canvas.toBlob(function(blob) {
                            resolve(blob);
                        }, file.type === "image/png" ? "image/png" : "image/jpeg");
                    case 38:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x2) {
            return _ref2.apply(this, arguments);
        };
    }());
}
// 获取图片旋转信息
function getImageOrientation(_x3) {
    return _getImageOrientation.apply(this, arguments);
}
// 摆正图片
function _getImageOrientation() {
    _getImageOrientation = file_asyncToGenerator(/*#__PURE__*/ file_regeneratorRuntime().mark(function _callee4(arrayBuffer) {
        var _tags$Orientation, tags, orientation, value, parsedValue, firstValidValue;
        return file_regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return ExifReader.load(arrayBuffer);
                case 3:
                    tags = _context4.sent;
                    orientation = 1;
                    if ((_tags$Orientation = tags.Orientation) !== null && _tags$Orientation !== void 0 && _tags$Orientation.value) {
                        value = tags.Orientation.value;
                        if (typeof value === "number") {
                            // 直接使用数值
                            orientation = value;
                        } else if (typeof value === "string") {
                            // 转数字
                            parsedValue = parseInt(value, 10);
                            if (!isNaN(parsedValue)) {
                                orientation = parsedValue;
                            }
                        } else if (Array.isArray(value)) {
                            // XmpTags[]
                            firstValidValue = value.find(function(v) {
                                return typeof v.value === "number";
                            });
                            if (firstValidValue !== undefined && "value" in firstValidValue && typeof firstValidValue.value === "number") {
                                orientation = firstValidValue.value;
                            }
                        } else if (file_typeof(value) === "object" && value !== null) {
                            // XmpTags
                            if ("value" in value && typeof value.value === "number") {
                                orientation = value.value;
                            }
                        }
                    }
                    return _context4.abrupt("return", orientation || 1);
                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4["catch"](0);
                    ;
                    return _context4.abrupt("return", 1);
                case 13:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _getImageOrientation.apply(this, arguments);
}
function normalizeImageFile(file) {
    if (file.type !== "image/jpeg") return file;
    ;
    var orientation = 1;
    return new Promise(function(resolve, reject) {
        // ATTENTION: safari < 14 不支持 file.arrayBuffer
        var reader = new FileReader();
        reader.onload = /*#__PURE__*/ function() {
            var _ref3 = file_asyncToGenerator(/*#__PURE__*/ file_regeneratorRuntime().mark(function _callee3(e) {
                var _e$target2;
                var arrayBuffer, blob, normalizedFile;
                return file_regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while(1)switch(_context3.prev = _context3.next){
                        case 0:
                            if ((_e$target2 = e.target) !== null && _e$target2 !== void 0 && _e$target2.result) {
                                _context3.next = 2;
                                break;
                            }
                            return _context3.abrupt("return", reject(new Error("no result")));
                        case 2:
                            // 读取文件为 ArrayBuffer
                            arrayBuffer = e.target.result;
                            _context3.next = 5;
                            return getImageOrientation(arrayBuffer);
                        case 5:
                            orientation = _context3.sent;
                            if (!(!orientation || orientation === 1)) {
                                _context3.next = 8;
                                break;
                            }
                            return _context3.abrupt("return", resolve(file));
                        case 8:
                            _context3.next = 10;
                            return changeOrientation(file, orientation);
                        case 10:
                            blob = _context3.sent;
                            // 如果有处理后的 blob，转换为 File 对象并返回
                            normalizedFile = blob ? blobToFile(blob, file.name) : file;
                            return _context3.abrupt("return", resolve(normalizedFile));
                        case 13:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x4) {
                return _ref3.apply(this, arguments);
            };
        }();
        reader.onerror = reject;
        reader.onabort = reject;
        reader.readAsArrayBuffer(file);
    });
}
function readFileAsArrayBuffer(file) {
    if (typeof file.arrayBuffer === "function") {
        return file.arrayBuffer();
    }
    // ATTENTION: safari < 14 不支持 file.arrayBuffer
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function(e) {
            var _e$target3;
            if ((_e$target3 = e.target) !== null && _e$target3 !== void 0 && _e$target3.result) {
                resolve(e.target.result);
            } else {
                reject(new Error("no result"));
            }
        };
        reader.onerror = reject;
        reader.onabort = reject;
        reader.readAsArrayBuffer(file);
    });
}
/**
 * 将 Base64 字符串转换为 ArrayBuffer
 */ function base64ToArrayBuffer(base64) {
    var binaryString = atob(base64); // 解码 Base64
    var length = binaryString.length;
    var bytes = new Uint8Array(length);
    for(var i = 0; i < length; i++){
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
function fileToBase64(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            var base64 = reader.result;
            resolve(base64);
        };
        reader.onerror = function() {
            return reject(new Error("读取文件失败"));
        };
        reader.readAsDataURL(file);
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/utils/stat.js
function getBase64FileSize(base64String) {
    // 去掉 data URL 前缀（如果有的话）
    var base64 = base64String.split(",")[1] || base64String;
    // 计算原始字节大小
    var padding = (base64.match(/=+$/) || [
        ""
    ])[0].length;
    var sizeInBytes = base64.length * 3 / 4 - padding;
    return sizeInBytes;
}
function statUpload(fileData, type, extra) {
    var _window, _window$mtstat;
    if (!((_window = window) !== null && _window !== void 0 && (_window$mtstat = _window.mtstat) !== null && _window$mtstat !== void 0 && _window$mtstat.track)) return;
    var startTime = extra.startTime, success = extra.success, partSize = extra.partSize, maxConcurrent = extra.maxConcurrent;
    var fileSize = 0;
    if (typeof fileData === "string") {
        fileSize = getBase64FileSize(fileData);
    } else {
        fileSize = fileData.size;
    }
    window.mtstat.track("upload_file_to_obs", {
        type: type,
        file_size: (fileSize / 1024 / 1024).toFixed(2),
        duraction: ((performance.now() - startTime) / 1000).toFixed(2),
        success: success ? 1 : 0,
        file_type: fileData instanceof File ? fileData.type : "base64",
        part_size: partSize || 0,
        max_concurrent: maxConcurrent || 0
    });
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/uploadManager/obs.js
function obs_typeof(obj) {
    "@babel/helpers - typeof";
    return obs_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, obs_typeof(obj);
}
function obs_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    obs_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == obs_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function obs_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function obs_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                obs_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                obs_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return obs_typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (obs_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (obs_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get.bind();
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(arguments.length < 3 ? target : receiver);
            }
            return desc.value;
        };
    }
    return _get.apply(this, arguments);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (obs_typeof(call) === "object" || typeof call === "function")) {
        return call;
    } else if (call !== void 0) {
        throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}




var uploaderInstance = null;
// 获取上传实例
var getUploaderInstance = function getUploaderInstance() {
    if (uploaderInstance) return uploaderInstance;
    var _getUploadConfig = getUploadConfig(), env = _getUploadConfig.env;
    var XDUploader = /*#__PURE__*/ function(_Uploader) {
        _inherits(XDUploader, _Uploader);
        var _super = _createSuper(XDUploader);
        function XDUploader() {
            _classCallCheck(this, XDUploader);
            return _super.apply(this, arguments);
        }
        _createClass(XDUploader, [
            {
                key: "request",
                value: function() {
                    var _request = obs_asyncToGenerator(/*#__PURE__*/ obs_regeneratorRuntime().mark(function _callee(url, options) {
                        var res;
                        return obs_regeneratorRuntime().wrap(function _callee$(_context) {
                            while(1)switch(_context.prev = _context.next){
                                case 0:
                                    url = url.indexOf("?") > -1 ? "".concat(url, "&t=1") : "".concat(url, "?t=1");
                                    _context.next = 3;
                                    return _get(_getPrototypeOf(XDUploader.prototype), "request", this).call(this, url, options);
                                case 3:
                                    res = _context.sent;
                                    return _context.abrupt("return", res);
                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this);
                    }));
                    function request(_x, _x2) {
                        return _request.apply(this, arguments);
                    }
                    return request;
                }()
            }
        ]);
        return XDUploader;
    }(esm_Uploader);
    uploaderInstance = new XDUploader({
        debug: false,
        env: enum_UploadEnv[env]
    });
    return uploaderInstance;
};
// 重置上传实例
var resetUploaderInstance = function resetUploaderInstance() {
    uploaderInstance = null;
};
/**
 * @param fileData 文件
 * @returns
 */ var uploadFileToObs = /*#__PURE__*/ function() {
    var _ref = obs_asyncToGenerator(/*#__PURE__*/ obs_regeneratorRuntime().mark(function _callee2(fileData, options) {
        var _getUploadConfig2, type, app, partSizeConfig, maxConcurrentConfig, needStat, asyncSliceConfig, _ref2, customMaatType, customSuffix, maxConcurrentOption, partSizeOption, onUploadProgress, _ref2$maxRetries, maxRetries, maatType, partSize, maxConcurrent, sliceConfig, suffix, match, fileType, _fileType, uploader, ops, startTime, lastError, attempt, data, url;
        return obs_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _getUploadConfig2 = getUploadConfig(), type = _getUploadConfig2.type, app = _getUploadConfig2.app, partSizeConfig = _getUploadConfig2.partSize, maxConcurrentConfig = _getUploadConfig2.maxConcurrent, needStat = _getUploadConfig2.needStat, asyncSliceConfig = _getUploadConfig2.asyncSliceConfig;
                    _ref2 = options || {}, customMaatType = _ref2.customMaatType, customSuffix = _ref2.customSuffix, maxConcurrentOption = _ref2.maxConcurrent, partSizeOption = _ref2.partSize, onUploadProgress = _ref2.onUploadProgress, _ref2$maxRetries = _ref2.maxRetries, maxRetries = _ref2$maxRetries === void 0 ? 3 : _ref2$maxRetries;
                    maatType = customMaatType || type;
                    /* 分片配置 */ partSize = partSizeOption || partSizeConfig;
                    maxConcurrent = maxConcurrentOption || maxConcurrentConfig;
                    /**
           * 异步获取分片数据
           * 优先级：入参 > 异步获取 > 全局配置 > 默认值
           */ if (!(asyncSliceConfig && (!partSizeOption || !maxConcurrentOption))) {
                        _context2.next = 11;
                        break;
                    }
                    _context2.next = 8;
                    return getSliceConfigAsync();
                case 8:
                    sliceConfig = _context2.sent;
                    if (!partSizeOption && sliceConfig.partSize) partSize = sliceConfig.partSize;
                    if (!maxConcurrentOption && sliceConfig.maxConcurrent) maxConcurrent = sliceConfig.maxConcurrent;
                case 11:
                    /* 文件后缀 */ suffix = customSuffix || "jpeg";
                    if (customSuffix) {
                        _context2.next = 26;
                        break;
                    }
                    if (!(typeof fileData === "string")) {
                        _context2.next = 19;
                        break;
                    }
                    // 提取 Base64 前缀中的 MIME 类型
                    match = fileData.match(/^data:(.+?);base64,/);
                    fileType = match ? match[1] : "image/jpeg";
                    suffix = fileType === "image/svg+xml" ? "svg" : fileType.split("/")[1];
                    _context2.next = 26;
                    break;
                case 19:
                    _context2.t0 = fileData.type;
                    if (_context2.t0) {
                        _context2.next = 24;
                        break;
                    }
                    _context2.next = 23;
                    return getFileType(fileData);
                case 23:
                    _context2.t0 = _context2.sent;
                case 24:
                    _fileType = _context2.t0;
                    suffix = _fileType === "image/svg+xml" ? "svg" : _fileType === null || _fileType === void 0 ? void 0 : _fileType.split("/")[1];
                case 26:
                    uploader = getUploaderInstance();
                    ops = {
                        app: app,
                        count: 1,
                        suffix: suffix,
                        type: maatType
                    };
                    startTime = performance.now();
                    attempt = 1;
                case 30:
                    if (!(attempt <= maxRetries)) {
                        _context2.next = 50;
                        break;
                    }
                    _context2.prev = 31;
                    _context2.next = 34;
                    return uploader.upload(fileData, ops, {
                        partSize: partSize,
                        maxConcurrent: maxConcurrent,
                        progress: onUploadProgress
                    });
                case 34:
                    data = _context2.sent;
                    url = data.previewUrl || data.url; // 埋点
                    if (needStat) statUpload(fileData, maatType, {
                        startTime: startTime,
                        success: true,
                        partSize: partSize,
                        maxConcurrent: maxConcurrent
                    });
                    return _context2.abrupt("return", {
                        url: url,
                        previewUrl: data.previewUrl
                    });
                case 40:
                    _context2.prev = 40;
                    _context2.t1 = _context2["catch"](31);
                    lastError = _context2.t1;
                    // 如果还有重试机会，继续尝试
                    if (!(attempt < maxRetries)) {
                        _context2.next = 45;
                        break;
                    }
                    return _context2.abrupt("continue", 47);
                case 45:
                    // 最后一次尝试失败，记录埋点并抛出错误
                    if (needStat) statUpload(fileData, maatType, {
                        startTime: startTime,
                        success: false,
                        partSize: partSize,
                        maxConcurrent: maxConcurrent
                    });
                    throw _context2.t1;
                case 47:
                    attempt++;
                    _context2.next = 30;
                    break;
                case 50:
                    throw lastError;
                case 51:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                31,
                40
            ]
        ]);
    }));
    return function uploadFileToObs(_x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 上传base64到obs
 * @param base64
 * @returns
 */ var uploadBase64ToObs = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    var _ref3 = obs_asyncToGenerator(/*#__PURE__*/ obs_regeneratorRuntime().mark(function _callee3(base64, options) {
        return obs_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", uploadFileToObs(base64, options));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function uploadBase64ToObs(_x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}()));
/**
 * 根据obs地址获取宽高信息
 * @param url obs地址
 * @returns
 */ function fetchObsURLWH(url) {
    var reqInfo = new Request(url.includes("?") ? url + "&imageWH" : url + "?imageWH");
    return new Promise(function(resolve, reject) {
        fetch(reqInfo, {
            method: "GET",
            headers: new Headers(),
            mode: "cors",
            cache: "default"
        }).then(function(res) {
            if (res.status < 200 || res.status >= 400) {
                throw new Error("get error");
            }
            return res.json();
        }).then(function(res) {
            resolve(res);
        }).catch(function(e) {
            reject(e);
        });
    });
}

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/index.js
var utils = __webpack_require__(16197);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js + 1 modules
var api = __webpack_require__(37057);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/enterprise.js
var enterprise = __webpack_require__(12749);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js
function utils_typeof(obj) {
    "@babel/helpers - typeof";
    return utils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, utils_typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = utils_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function utils_toPropertyKey(arg) {
    var key = utils_toPrimitive(arg, "string");
    return utils_typeof(key) === "symbol" ? key : String(key);
}
function utils_toPrimitive(input, hint) {
    if (utils_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (utils_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function utils_slicedToArray(arr, i) {
    return utils_arrayWithHoles(arr) || utils_iterableToArrayLimit(arr, i) || utils_unsupportedIterableToArray(arr, i) || utils_nonIterableRest();
}
function utils_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function utils_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function utils_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    utils_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == utils_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function utils_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return utils_arrayLikeToArray(arr);
}
function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}










var getEnterpriseIDKey = function getEnterpriseIDKey() {
    return "enterprise_id".concat((0,utils/* getSuffix */._A)());
};
var getAccessTokenCookieKey = function getAccessTokenCookieKey() {
    return "access_token".concat((0,utils/* getSuffix */._A)());
};
// 是否走SSO授权登录方式
var isSSOLogin = false;
var isSSO = function isSSO() {
    return isSSOLogin;
};
var getEnterpriseSearchParams = function getEnterpriseSearchParams() {
    var _getIdentityFromCooki;
    var searchParams = new URLSearchParams(window.location.search);
    var localOid = (_getIdentityFromCooki = (0,lib/* getIdentityFromCookie */.Rw)()) === null || _getIdentityFromCooki === void 0 ? void 0 : _getIdentityFromCooki.oid;
    return {
        code: searchParams.get("code"),
        organizationID: Number(searchParams.get("oid")) || localOid
    };
};
/**
 * Clear redundant url params
 * (remove some params from `meitu account`)
 * @param keys - keys to remove
 */ var clearURL = function clearURL(keys) {
    var searchParams = new URLSearchParams(window.location.search);
    var redundantKeys = [
        "op_type",
        "code",
        "platform",
        "client_from_sdk",
        "redirect_uri",
        "client_referer",
        "client_params"
    ];
    if (keys) {
        redundantKeys.push.apply(redundantKeys, _toConsumableArray(keys));
    }
    redundantKeys.forEach(function(key) {
        searchParams.delete(key);
    });
    // 构建新的查询字符串
    var newQueryString = searchParams.toString();
    // 获取当前 URL 的路径部分
    var path = window.location.pathname;
    // 更新 URL，不包括被移除的参数
    var newUrl = newQueryString ? "".concat(path, "?").concat(newQueryString) : path;
    window.history.replaceState("", "", newUrl);
};
var checkLoginStatus = /*#__PURE__*/ function() {
    var _ref = utils_asyncToGenerator(/*#__PURE__*/ utils_regeneratorRuntime().mark(function _callee() {
        var _res$userInfo, res, uid;
        return utils_regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0,enterprise/* fetchUserInfo */.CS)();
                case 3:
                    res = _context.sent;
                    if (!(res !== null && res !== void 0 && (_res$userInfo = res.userInfo) !== null && _res$userInfo !== void 0 && _res$userInfo.id)) {
                        _context.next = 8;
                        break;
                    }
                    uid = res.userInfo.id; // 非个人版下，利用该接口同步最新ouid，用于埋点上报的uid的准确性
                    (0,uidKit/* setLocalUid */.Tc)(uid);
                    return _context.abrupt("return", true);
                case 8:
                    return _context.abrupt("return", false);
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);
                    return _context.abrupt("return", false);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function checkLoginStatus() {
        return _ref.apply(this, arguments);
    };
}();
var getEnterpriseConfigs = /*#__PURE__*/ function() {
    var _ref2 = utils_asyncToGenerator(/*#__PURE__*/ utils_regeneratorRuntime().mark(function _callee2(oid) {
        var res;
        return utils_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(1)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0,enterprise/* fetchEnterpriseConfigs */.N1)(oid);
                case 3:
                    res = _context2.sent;
                    return _context2.abrupt("return", {
                        enterpriseID: res.enterprise,
                        authPageURL: res.authorized_redirect_url
                    });
                case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    return _context2.abrupt("return", null);
                case 10:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getEnterpriseConfigs(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var init = /*#__PURE__*/ function() {
    var _ref3 = utils_asyncToGenerator(/*#__PURE__*/ utils_regeneratorRuntime().mark(function _callee3() {
        var _getEnterpriseSearchP, code, organizationID, obsConfig, TOKEN_KEY_COOKIE, tokenCookie, ENTERPRISE_ID, _tokenCookie, _yield$Promise$all, _yield$Promise$all2, isLogin, resObsCfg, resEnterpriseCfg, res, accessToken, _yield$Promise$all3, _yield$Promise$all4, _, _resObsCfg, _resEnterpriseCfg;
        return utils_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(1)switch(_context3.prev = _context3.next){
                case 0:
                    _getEnterpriseSearchP = getEnterpriseSearchParams(), code = _getEnterpriseSearchP.code, organizationID = _getEnterpriseSearchP.organizationID;
                    obsConfig = getDefaultObsConfig();
                    TOKEN_KEY_COOKIE = getAccessTokenCookieKey();
                    ;
                    ;
                    // Check whether it is enterprise client
                    if (!(!organizationID && !code)) {
                        _context3.next = 9;
                        break;
                    }
                    // 同步cookie中的token到缓存
                    tokenCookie = js_cookie/* default.get */.Z.get(TOKEN_KEY_COOKIE) || "";
                    tokenCookie && window.localStorage.setItem("access_token", tokenCookie);
                    return _context3.abrupt("return", obsConfig);
                case 9:
                    ENTERPRISE_ID = getEnterpriseIDKey(); // 更新本地cookie
                    (0,lib/* setLocalIdentity */.kF)(Number(organizationID), Number(organizationID));
                    // 更内存身份
                    (0,lib/* setMemoryIdentity */.LW)(Number(organizationID), Number(organizationID));
                    // If no `code` url param, then checking login status
                    if (code) {
                        _context3.next = 35;
                        break;
                    }
                    // 同步cookie中的token到缓存
                    _tokenCookie = js_cookie/* default.get */.Z.get(TOKEN_KEY_COOKIE) || "";
                    _tokenCookie && window.localStorage.setItem("access_token", _tokenCookie);
                    // check login status
                    _context3.prev = 15;
                    _context3.next = 18;
                    return Promise.all([
                        checkLoginStatus(),
                        getObsConfigAsync({
                            oid: organizationID
                        }),
                        getEnterpriseConfigs(organizationID)
                    ]);
                case 18:
                    _yield$Promise$all = _context3.sent;
                    _yield$Promise$all2 = utils_slicedToArray(_yield$Promise$all, 3);
                    isLogin = _yield$Promise$all2[0];
                    resObsCfg = _yield$Promise$all2[1];
                    resEnterpriseCfg = _yield$Promise$all2[2];
                    if (resObsCfg !== null && resObsCfg !== void 0 && resObsCfg.app) {
                        obsConfig = _objectSpread(_objectSpread({}, obsConfig), resObsCfg);
                    }
                    isSSOLogin = !!(resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.authPageURL);
                    if (!isLogin) {
                        // not login, then redirect to auth page
                        window.localStorage.removeItem("access_token");
                        js_cookie/* default.remove */.Z.remove(TOKEN_KEY_COOKIE, {
                            domain: (0,utils/* getRootDomain */.wf)()
                        });
                    }
                    if (resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.enterpriseID) {
                        // 更新企业标识
                        js_cookie/* default.set */.Z.set(ENTERPRISE_ID, resEnterpriseCfg.enterpriseID, {
                            domain: (0,utils/* getRootDomain */.wf)(),
                            expires: 36500 // 100年有效期
                        });
                    } else {
                        js_cookie/* default.remove */.Z.remove(ENTERPRISE_ID, {
                            domain: (0,utils/* getRootDomain */.wf)()
                        });
                    }
                    if (!isLogin && resEnterpriseCfg !== null && resEnterpriseCfg !== void 0 && resEnterpriseCfg.authPageURL) {
                        // 未登录，跳转去授权登录
                        window.open(resEnterpriseCfg.authPageURL, "_self");
                    }
                    clearURL([
                        "enterprise",
                        "oid"
                    ]);
                    return _context3.abrupt("return", obsConfig);
                case 32:
                    _context3.prev = 32;
                    _context3.t0 = _context3["catch"](15);
                    return _context3.abrupt("return", obsConfig);
                case 35:
                    _context3.prev = 35;
                    _context3.next = 38;
                    return (0,enterprise/* fetchAccessTokenByCode */.tH)(code);
                case 38:
                    res = _context3.sent;
                    accessToken = res["access_token"];
                    if (accessToken) {
                        _context3.next = 42;
                        break;
                    }
                    throw new Error("Get access token failed.");
                case 42:
                    window.localStorage.setItem("access_token", accessToken);
                    js_cookie/* default.set */.Z.set(TOKEN_KEY_COOKIE, accessToken, {
                        domain: (0,utils/* getRootDomain */.wf)(),
                        expires: 36500 // 100年有效期
                    });
                    // refresh user rights
                    _context3.next = 46;
                    return Promise.all([
                        (0,enterprise/* refreshUserRights */.rm)(),
                        getObsConfigAsync({
                            oid: organizationID
                        }),
                        getEnterpriseConfigs(organizationID)
                    ]);
                case 46:
                    _yield$Promise$all3 = _context3.sent;
                    _yield$Promise$all4 = utils_slicedToArray(_yield$Promise$all3, 3);
                    _ = _yield$Promise$all4[0];
                    _resObsCfg = _yield$Promise$all4[1];
                    _resEnterpriseCfg = _yield$Promise$all4[2];
                    if (_resObsCfg !== null && _resObsCfg !== void 0 && _resObsCfg.app) {
                        obsConfig.app = _resObsCfg === null || _resObsCfg === void 0 ? void 0 : _resObsCfg.app;
                    }
                    isSSOLogin = !!(_resEnterpriseCfg !== null && _resEnterpriseCfg !== void 0 && _resEnterpriseCfg.authPageURL);
                    if (_resEnterpriseCfg !== null && _resEnterpriseCfg !== void 0 && _resEnterpriseCfg.enterpriseID) {
                        // 更新企业标识
                        js_cookie/* default.set */.Z.set(ENTERPRISE_ID, _resEnterpriseCfg.enterpriseID, {
                            domain: (0,utils/* getRootDomain */.wf)(),
                            expires: 36500 // 100年有效期
                        });
                    }
                    return _context3.abrupt("return", obsConfig);
                case 57:
                    _context3.prev = 57;
                    _context3.t1 = _context3["catch"](35);
                case 59:
                    _context3.prev = 59;
                    clearURL([
                        "enterprise",
                        "oid"
                    ]);
                    return _context3.finish(59);
                case 62:
                    return _context3.abrupt("return", obsConfig);
                case 63:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                15,
                32
            ],
            [
                35,
                57,
                59,
                62
            ]
        ]);
    }));
    return function init() {
        return _ref3.apply(this, arguments);
    };
}();
// 同步海洛下载结果
var handleReportDownloadResult = /*#__PURE__*/ function() {
    var _ref4 = utils_asyncToGenerator(/*#__PURE__*/ utils_regeneratorRuntime().mark(function _callee4(blob, options) {
        var url, filesize, file, res;
        return utils_regeneratorRuntime().wrap(function _callee4$(_context4) {
            while(1)switch(_context4.prev = _context4.next){
                case 0:
                    _context4.prev = 0;
                    url = "";
                    filesize = undefined;
                    if (!(typeof blob === "string" && /^https?:\/\//i.test(blob))) {
                        _context4.next = 7;
                        break;
                    }
                    url = blob;
                    _context4.next = 14;
                    break;
                case 7:
                    if (!(blob instanceof Blob)) {
                        _context4.next = 14;
                        break;
                    }
                    file = new File([
                        blob
                    ], "", {
                        type: blob.type
                    });
                    _context4.next = 11;
                    return uploadFileToObs(file, {
                        customMaatType: "image_tmp",
                        customSuffix: options === null || options === void 0 ? void 0 : options.extension
                    });
                case 11:
                    res = _context4.sent;
                    url = res.url;
                    filesize = blob.size;
                case 14:
                    _context4.next = 16;
                    return (0,api/* handleDownloadRecord */.lh)(_objectSpread({
                        url: url,
                        filesize: filesize
                    }, options));
                case 16:
                    message/* default.success */.Z.success("已为您保存至海洛数字资产");
                    _context4.next = 22;
                    break;
                case 19:
                    _context4.prev = 19;
                    _context4.t0 = _context4["catch"](0);
                    ;
                case 22:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                0,
                19
            ]
        ]);
    }));
    return function handleReportDownloadResult(_x2, _x3) {
        return _ref4.apply(this, arguments);
    };
}();
var createTeam = /*#__PURE__*/ function() {
    var _ref5 = utils_asyncToGenerator(/*#__PURE__*/ utils_regeneratorRuntime().mark(function _callee5(params) {
        var _params$teamName;
        var _getConfig, userInfo, res;
        return utils_regeneratorRuntime().wrap(function _callee5$(_context5) {
            while(1)switch(_context5.prev = _context5.next){
                case 0:
                    _getConfig = (0,configProvider/* getConfig */.iE)(), userInfo = _getConfig.userInfo;
                    _context5.next = 3;
                    return (0,api/* createTeamApi */.tH)({
                        name: (_params$teamName = params === null || params === void 0 ? void 0 : params.teamName) !== null && _params$teamName !== void 0 ? _params$teamName : "".concat(userInfo.screen_name, "的团队"),
                        rebate_code: params === null || params === void 0 ? void 0 : params.rebateCode
                    });
                case 3:
                    res = _context5.sent;
                    return _context5.abrupt("return", {
                        groupId: res.group_id,
                        oid: res.oid,
                        ouid: res.ouid,
                        teamName: res.team_name
                    });
                case 5:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return function createTeam(_x4) {
        return _ref5.apply(this, arguments);
    };
}();


/***/ }),

/***/ 32485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mf": () => (/* binding */ IdentityType),
/* harmony export */   "cc": () => (/* binding */ TeamSeatStatus),
/* harmony export */   "iJ": () => (/* binding */ TeamShareNodeType),
/* harmony export */   "xO": () => (/* binding */ TeamRoleType)
/* harmony export */ });
/* unused harmony exports CollaboratorPermissionType, TeamShareChangeType */
/** 协作者权限 */ var CollaboratorPermissionType = /*#__PURE__*/ function(CollaboratorPermissionType) {
    CollaboratorPermissionType[CollaboratorPermissionType["Views"] = 2] = "Views";
    CollaboratorPermissionType[CollaboratorPermissionType["Edit"] = 3] = "Edit";
    CollaboratorPermissionType[CollaboratorPermissionType["Manage"] = 4] = "Manage";
    CollaboratorPermissionType[CollaboratorPermissionType["Remove"] = 5] = "Remove";
    CollaboratorPermissionType[CollaboratorPermissionType["Reject"] = 6] = "Reject";
    CollaboratorPermissionType[CollaboratorPermissionType["Owner"] = 999999] = "Owner";
    return CollaboratorPermissionType;
}({});
// 身份类型，type: 0-个人版，1-团队版，2-企业版
var IdentityType = /*#__PURE__*/ function(IdentityType) {
    IdentityType[IdentityType["PERSONAL"] = 0] = "PERSONAL";
    IdentityType[IdentityType["TEAM"] = 1] = "TEAM";
    IdentityType[IdentityType["ENTERPRISE"] = 2] = "ENTERPRISE";
    return IdentityType;
}({});
/**
 * 团队身份
 */ /**
 * 团队信息
 */ /**
 * 团队席位状态
 */ /** 席位状态 */ var TeamSeatStatus = /*#__PURE__*/ function(TeamSeatStatus) {
    TeamSeatStatus[TeamSeatStatus["Unbound"] = 0] = "Unbound";
    TeamSeatStatus[TeamSeatStatus["Effect"] = 1] = "Effect";
    TeamSeatStatus[TeamSeatStatus["Pending"] = 2] = "Pending";
    TeamSeatStatus[TeamSeatStatus["Freeze"] = 10] = "Freeze";
    return TeamSeatStatus;
}({});
/**
 * 团队角色
 */ var TeamRoleType = /*#__PURE__*/ function(TeamRoleType) {
    TeamRoleType["owner"] = "owner";
    TeamRoleType["admin"] = "admin";
    TeamRoleType["member"] = "member";
    return TeamRoleType;
}({});
/**
 * 协作列表
 */ /**
 * 团队成员
 */ /**
 * 团队信息
 */ /**
 * 回调的type
 */ var TeamShareChangeType = /*#__PURE__*/ function(TeamShareChangeType) {
    TeamShareChangeType["USER_TYPE"] = "user_type";
    TeamShareChangeType["MODE"] = "mode";
    return TeamShareChangeType;
}({});
/**
 * 分享文件类型
 */ var TeamShareNodeType = /*#__PURE__*/ function(TeamShareNodeType) {
    TeamShareNodeType["RECORD"] = "RECORD";
    TeamShareNodeType["TEMPLATE"] = "TEMPLATE";
    TeamShareNodeType["FOLDER"] = "FOLDER";
    return TeamShareNodeType;
}({}); /**
 * 创建团队
 */  /**
 * [团队]生成邀请码
 */ 


/***/ }),

/***/ 8209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dv": () => (/* binding */ VipLevel),
/* harmony export */   "FW": () => (/* binding */ UserType),
/* harmony export */   "dE": () => (/* binding */ ListKeyType)
/* harmony export */ });
/* unused harmony export BalanceListKeyType */
/**
 * 用户信息数据类型
 *
 * @see https://api-mock.meitu-int.com/project/2110/interface/api/116813
 */ var VipLevel = /*#__PURE__*/ function(VipLevel) {
    VipLevel[VipLevel["Basic"] = 1] = "Basic";
    VipLevel[VipLevel["Pro"] = 2] = "Pro";
    VipLevel[VipLevel["ProCn"] = 3] = "ProCn";
    return VipLevel;
}({});
var ListKeyType = /*#__PURE__*/ function(ListKeyType) {
    ListKeyType["FEEDBACK"] = "feedBack";
    ListKeyType["BUSINESS"] = "business";
    ListKeyType["DOWNLOAD"] = "download";
    ListKeyType["CREDIT"] = "credit";
    ListKeyType["ManageSubscriptions"] = "manageSubscriptions";
    ListKeyType["Subscription"] = "subscription";
    ListKeyType["TermsPolicies"] = "termsPolicies";
    ListKeyType["Pricing"] = "pricing";
    ListKeyType["ChangeIdentity"] = "changeIdentity";
    ListKeyType["Compensation"] = "compensation";
    ListKeyType["Language"] = "language";
    ListKeyType["Redeem"] = "redeem";
    ListKeyType["Invite"] = "invite";
    ListKeyType["Account"] = "account";
    ListKeyType["DOWNLOAD_APP"] = "downloadApp";
    return ListKeyType;
}({});
var BalanceListKeyType = /*#__PURE__*/ function(BalanceListKeyType) {
    BalanceListKeyType["MEIDOU"] = "meidou";
    BalanceListKeyType["CUTOUT"] = "cutout";
    return BalanceListKeyType;
}({});
/**
 * 用户信息组件属性
 */ /**
 * 用户类型
 */ var UserType = /*#__PURE__*/ function(UserType) {
    UserType["PERSONAL"] = "personal";
    UserType["TEAM"] = "team";
    UserType["COMPANY"] = "company";
    return UserType;
}({});


/***/ }),

/***/ 56874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": () => (/* binding */ userNotVipPc),
/* harmony export */   "CX": () => (/* binding */ CHANGE_IDENTITY_TIP_KEY),
/* harmony export */   "Do": () => (/* binding */ userIntlNotVip),
/* harmony export */   "Mv": () => (/* binding */ userNotVip),
/* harmony export */   "OY": () => (/* binding */ userXdesignProVip),
/* harmony export */   "PS": () => (/* binding */ userPrpVip),
/* harmony export */   "T8": () => (/* binding */ teamIntlVip),
/* harmony export */   "Um": () => (/* binding */ userProVipDk),
/* harmony export */   "V2": () => (/* binding */ userBasicVipDk),
/* harmony export */   "Vj": () => (/* binding */ teamIntlNotVip),
/* harmony export */   "ZB": () => (/* binding */ userXdesignPlusVip),
/* harmony export */   "ZF": () => (/* binding */ ChangeIdentityTipSourceEnum),
/* harmony export */   "g": () => (/* binding */ userVip),
/* harmony export */   "jU": () => (/* binding */ teamNotVip),
/* harmony export */   "pI": () => (/* binding */ userVipPc),
/* harmony export */   "vD": () => (/* binding */ teamVip)
/* harmony export */ });
/* unused harmony export changeIdentityTipInfo */
/**
 * ########### 权益图标 ###########
 */ // 国内版 团队vip
var teamVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip.png";
// 海外版 团队vip
var teamIntlVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip.png";
// 国内版 非团队vip
var teamNotVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip-not.png";
// 海外版 非团队vip
var teamIntlNotVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip-not.png";
// 国内版 个人vip（PC内嵌）
var userVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon.png";
// 国内版 个人vip（web端）
var userVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon-web.png";
// 国内版 个人pro_vip（web端）
var userPrpVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-web.png";
// 海外版 个人vip
var userXdesignProVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/pro-icon-xd.png";
var userXdesignPlusVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/plus-icon-xd.png";
// 国内版 非个人vip（PC内嵌）
var userNotVipPc = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon.png";
// 国内版 非个人vip（web端）
var userNotVip = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon-web.png";
// 海外版 非个人vip
var userIntlNotVip = "https://x-design-static-release.stariicloud.com/xdesign-widgets/not-vip-pro-icon-intl.png";
// designkit 个人 Basic Vip
var userBasicVipDk = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/basic-vip-icon-dk.png";
// designkit 个人 Pro Vip
var userProVipDk = "https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-dk.png";
// 身份切换引导提示缓存
var CHANGE_IDENTITY_TIP_KEY = "xdesign-widgets_change-identity-tip";
var ChangeIdentityTipSourceEnum = /*#__PURE__*/ function(ChangeIdentityTipSourceEnum) {
    ChangeIdentityTipSourceEnum["PROMOTION_MODAL"] = "promotionModal";
    ChangeIdentityTipSourceEnum["MEIDOU_PANEL"] = "meidouPanel";
    return ChangeIdentityTipSourceEnum;
}({});
// 记录强引导提示场景的相关状态
var changeIdentityTipInfo = {
    source: "",
    shouldShowTip: 0,
    hasShowTipMap: {
        promotionModal: 0,
        meidouPanel: 0
    }
};


/***/ }),

/***/ 11747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OF": () => (/* binding */ checkIsBeforeUnload),
/* harmony export */   "uU": () => (/* binding */ copy2Clipboard)
/* harmony export */ });
/* unused harmony exports isSafari, registerStyleSheet, isPad */
var isSafari = function isSafari() {
    var ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome|Chromium/.test(ua) && navigator.vendor === "Apple Computer, Inc.";
};
var registerStyleSheet = function registerStyleSheet(styleCode, id) {
    var style = document.createElement("style");
    style.innerHTML = styleCode;
    if (id) {
        style.id = id;
    }
    document.body.appendChild(style);
    var remove = function remove() {
        document.body.removeChild(style);
    };
    return remove;
};
var copy2Clipboard = function copy2Clipboard(text) {
    return new Promise(function(resolve) {
        // safari的复制api不能在promise内部调用
        setTimeout(function() {
            navigator.clipboard.writeText(text).then(function() {
                return resolve({
                    success: true
                });
            }).catch(function(error) {
                ;
                resolve({
                    success: false,
                    error: error
                });
            });
        });
    });
};
/** 检查是否处于beforeunload的时机之后 (防止safari中断请求导致报错并继续执行catch逻辑) */ var checkIsBeforeUnload = function() {
    var isBeforeUnload = false;
    if (true) {
        window.addEventListener("beforeunload", function() {
            isBeforeUnload = true;
        });
    }
    return function() {
        return isBeforeUnload;
    };
}();
/**
 * 判断是否是平板设备（SSR 安全）
 */ var isPad = function isPad() {
    // SSR 环境（无 window/navigator/screen）
    if ( false || typeof navigator === "undefined" || typeof screen === "undefined") {
        return true; // SSR 下默认返回 true
    }
    var ua = navigator.userAgent.toLowerCase();
    var maxTouch = navigator.maxTouchPoints || 0;
    var dpr = window.devicePixelRatio || 1;
    var width = Math.min(window.screen.width, window.screen.height);
    // 1. iPad / iPadOS（iPadOS 13+ 会伪装成 Mac）
    if (/ipad/.test(ua) || /macintosh/.test(ua) && maxTouch > 1) {
        return true;
    }
    // 2. Android 平板（非手机）
    if (/android/.test(ua) && !/mobile/.test(ua)) {
        return true;
    }
    // 3. Windows / Linux / X11 平板（触屏设备）
    if ((/windows/.test(ua) || /linux/.test(ua) || /x11/.test(ua)) && maxTouch > 1) {
        // 增加 DPI 判断：一般平板 >= 1.5，触屏电脑多为 1.0~1.25
        var isHighDPI = dpr >= 1.5;
        // 宽度小于 1280 且高 DPI 视作平板，否则视作触屏电脑
        return width < 1280 && isHighDPI;
    }
    return false;
};


/***/ }),

/***/ 84999:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": () => (/* binding */ ENV_ENUM),
/* harmony export */   "G3": () => (/* binding */ getApiHost),
/* harmony export */   "HN": () => (/* binding */ getEnvPrefix),
/* harmony export */   "n8": () => (/* binding */ getSubApiHost),
/* harmony export */   "p7": () => (/* binding */ getDomainName)
/* harmony export */ });
/* unused harmony exports webApiUrlDesignKitMap, getWebApiUrlMap, webApiUrlStariiMap, subApiUrlMap, subApiUrlStariiMap */
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97303);
var _webApiUrlDesignKitMa, _webApiUrlStariiMap, _subApiUrlMap, _subApiUrlStariiMap;
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var ENV_ENUM = /*#__PURE__*/ function(ENV_ENUM) {
    ENV_ENUM["dev"] = "dev";
    ENV_ENUM["pre"] = "pre";
    ENV_ENUM["beta"] = "beta";
    ENV_ENUM["release"] = "release";
    return ENV_ENUM;
}({});
// 判断国际化产品域名后缀,
// 国内为 cn
// designkit 和海外为 com
var getDomainName = function getDomainName() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), appName = _getConfig.appName, isIntl = _getConfig.isIntl;
    return appName === "designkit" && isIntl || isIntl ? "com" : "cn";
};
/**
 * DesignKit全球化api域名
 */ var webApiUrlDesignKitMap = (_webApiUrlDesignKitMa = {}, _defineProperty(_webApiUrlDesignKitMa, ENV_ENUM.dev, "https://predesignkit-webapi.designkit.com"), _defineProperty(_webApiUrlDesignKitMa, ENV_ENUM.pre, "https://predesignkit-webapi.designkit.com"), _defineProperty(_webApiUrlDesignKitMa, ENV_ENUM.beta, "https://betadesignkit-webapi.designkit.com"), _defineProperty(_webApiUrlDesignKitMa, ENV_ENUM.release, "https://designkit-webapi.designkit.com"), _webApiUrlDesignKitMa);
/**
 * 国内api域名
 */ var getWebApiUrlMap = function getWebApiUrlMap() {
    var _ref;
    var domainName = getDomainName();
    return _ref = {}, _defineProperty(_ref, ENV_ENUM.dev, "https://prewebapi.designkit.".concat(domainName)), _defineProperty(_ref, ENV_ENUM.pre, "https://prewebapi.designkit.".concat(domainName)), _defineProperty(_ref, ENV_ENUM.beta, "https://betawebapi.designkit.".concat(domainName)), _defineProperty(_ref, ENV_ENUM.release, "https://webapi.designkit.".concat(domainName)), _ref;
};
/**
 * 海外api域名
 */ var webApiUrlStariiMap = (_webApiUrlStariiMap = {}, _defineProperty(_webApiUrlStariiMap, ENV_ENUM.dev, "https://pre.x-design.com/api"), _defineProperty(_webApiUrlStariiMap, ENV_ENUM.pre, "https://pre.x-design.com/api"), _defineProperty(_webApiUrlStariiMap, ENV_ENUM.beta, "https://beta.x-design.com/api"), _defineProperty(_webApiUrlStariiMap, ENV_ENUM.release, "https://www.x-design.com/api"), _webApiUrlStariiMap);
/**
 * 国内api域名
 */ var subApiUrlMap = (_subApiUrlMap = {}, _defineProperty(_subApiUrlMap, ENV_ENUM.dev, "https://pre-api-h5-sub.meitu.com"), _defineProperty(_subApiUrlMap, ENV_ENUM.pre, "https://pre-api-h5-sub.meitu.com"), _defineProperty(_subApiUrlMap, ENV_ENUM.beta, "https://beta-api-h5-sub.meitu.com"), _defineProperty(_subApiUrlMap, ENV_ENUM.release, "https://api-h5-sub.meitu.com"), _subApiUrlMap);
/**
 * 海外api域名
 */ var subApiUrlStariiMap = (_subApiUrlStariiMap = {}, _defineProperty(_subApiUrlStariiMap, ENV_ENUM.dev, "https://pre-api-h5-sub.starii.com"), _defineProperty(_subApiUrlStariiMap, ENV_ENUM.pre, "https://pre-api-h5-sub.starii.com"), _defineProperty(_subApiUrlStariiMap, ENV_ENUM.beta, "https://beta-api-h5-sub.starii.com"), _defineProperty(_subApiUrlStariiMap, ENV_ENUM.release, "https://api-h5-sub.starii.com"), _subApiUrlStariiMap);
var getEnvPrefix = function getEnvPrefix(env) {
    return env === "beta" ? "beta" : env === "release" ? "" : "pre";
};
var getApiHost = function getApiHost() {
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl, appName = _getConfig2.appName;
    var baseURL = getWebApiUrlMap()[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    if (isIntl && appName === "x-design") {
        baseURL = webApiUrlStariiMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    } else if (isIntl && appName === "designkit") {
        baseURL = webApiUrlDesignKitMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
    }
    return baseURL;
};
var getSubApiHost = function getSubApiHost() {
    var _getConfig3 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), isIntl = _getConfig3.isIntl, appName = _getConfig3.appName;
    return isIntl && appName === "x-design" ? subApiUrlStariiMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env] : subApiUrlMap[(0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)().env];
};


/***/ }),

/***/ 77724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (new events__WEBPACK_IMPORTED_MODULE_0__.EventEmitter());


/***/ }),

/***/ 16197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XF": () => (/* binding */ getClientLanguage),
/* harmony export */   "_A": () => (/* binding */ getSuffix),
/* harmony export */   "so": () => (/* binding */ getCountryCode),
/* harmony export */   "wf": () => (/* binding */ getRootDomain)
/* harmony export */ });
/* unused harmony export sleep */
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97303);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

function getRootDomain() {
    var hostname = window.location.hostname;
    // 分割域名为各个部分
    var parts = hostname.split(".").reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    var commonTlds = [
        "co",
        "com",
        "org",
        "net",
        "gov",
        "edu",
        "mil"
    ];
    // 获取根域名
    var rootDomain = parts[1] + "." + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + "." + rootDomain;
    }
    return rootDomain;
}
var getSuffix = function getSuffix() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .iE)(), env = _getConfig.env;
    var suffix = "--".concat(env);
    if (env === _configProvider__WEBPACK_IMPORTED_MODULE_0__/* .ENV_ENUM.release */ .BD.release) {
        suffix = "";
    }
    return suffix;
};
/**
 * 获取服务端真正需要上报的语言值
 * @param locale 语言
 * @returns
 */ var getClientLanguage = function getClientLanguage(locale) {
    var fankuiLangMap = {
        cn: "zh-Hans",
        tw: "zh-Hant",
        en: "en",
        jp: "ja",
        kr: "ko",
        pt: "pt",
        es: "es",
        de: "de"
    };
    return fankuiLangMap[locale] || "";
};
/**
 * 获取country_code
 * @param language  通过navigator.language获取的值
 * @returns
 */ var getCountryCode = function getCountryCode() {
    var language = navigator.language;
    var regionMap = {
        "zh-CN": "CN",
        "zh-TW": "TW",
        "ja-JP": "JP",
        "ko-KR": "KR",
        "en-US": "US",
        "en-AU": "AU",
        "en-CA": "CA",
        "zh-HK": "HK",
        "th-TH": "TH",
        "en-GB": "GB",
        "en-SG": "SG",
        "ms-SG": "SG",
        "zh-SG": "SG",
        "vi-VN": "VN",
        "zh-MO": "MO",
        "pt-MO": "MO",
        "tl-PH": "PH",
        "en-PH": "PH",
        "id-ID": "ID",
        "en-NZ": "NZ",
        "mi-NZ": "NZ",
        fil: "PH"
    };
    if (regionMap[language]) {
        return regionMap[language];
    }
    // 如果有区域代码，格式是 <language>-<region>，
    // 例如：en-US — 英语（美国）、zh-CN — 简体中文（中国）
    if (language && language.includes("-")) {
        var _language$split = language.split("-"), _language$split2 = _slicedToArray(_language$split, 2), _ = _language$split2[0], rg = _language$split2[1];
        if (rg) {
            return rg;
        }
    }
    // 用语言匹配
    var keys = Object.keys(regionMap);
    for(var i = 0; i < keys.length; i++){
        var element = keys[i];
        if (element.includes(language)) {
            return regionMap[element];
        }
    }
    return "";
};
var sleep = function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};


/***/ }),

/***/ 57526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": () => (/* binding */ getCommonParams),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "s6": () => (/* binding */ RESIGNED_CODE)
/* harmony export */ });
/* harmony import */ var _ComUI_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20134);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97303);
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84999);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5121);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57632);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16197);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84704);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}








var getCommonParams = function getCommonParams() {
    var _getConfig$userInfo$e, _getConfig$userInfo;
    return {
        gid: (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().gid,
        education_role: (_getConfig$userInfo$e = (_getConfig$userInfo = (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().userInfo) === null || _getConfig$userInfo === void 0 ? void 0 : _getConfig$userInfo.education_role) !== null && _getConfig$userInfo$e !== void 0 ? _getConfig$userInfo$e : "",
        client_id: (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().client_id,
        preview_mode: (0,_configProvider__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .iE)().env === _env__WEBPACK_IMPORTED_MODULE_2__/* .ENV_ENUM.release */ .BD.release ? 0 : 1,
        client_language: (0,___WEBPACK_IMPORTED_MODULE_3__/* .getClientLanguage */ .XF)((0,_i18n__WEBPACK_IMPORTED_MODULE_4__/* .getLocaleStore */ .IK)().locale),
        country_code: (0,___WEBPACK_IMPORTED_MODULE_3__/* .getCountryCode */ .so)(),
        ts_random_id: (0,uuid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(),
        client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
};
var request = axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].create */ .Z.create({
    withCredentials: true
});
var getDefaultError = function getDefaultError() {
    var _getLocaleStore = (0,_i18n__WEBPACK_IMPORTED_MODULE_4__/* .getLocaleStore */ .IK)(), $t = _getLocaleStore.$t;
    return {
        code: 1024,
        message: $t(function(v) {
            return v.utils.requestErrorText;
        })
    };
};
/** 用户被团队移除的状态码 */ var RESIGNED_CODE = 402;
request.interceptors.request.use(function(config) {
    var _config$baseURL, _window$localStorage$;
    config.baseURL = (_config$baseURL = config.baseURL) !== null && _config$baseURL !== void 0 ? _config$baseURL : (0,_env__WEBPACK_IMPORTED_MODULE_2__/* .getApiHost */ .G3)();
    var customHeader =  false ? 0 : _objectSpread({
        access_token: (_window$localStorage$ = window.localStorage.getItem("access_token")) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : ""
    }, (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getRequestIdentityHeader */ .AW)());
    config.headers = _objectSpread(_objectSpread(_objectSpread({}, customHeader), config.headers.common), config.headers);
    config.params = _objectSpread(_objectSpread({}, getCommonParams()), config.params);
    return config;
}, function() {
    return Promise.reject(getDefaultError());
});
request.interceptors.response.use(/*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(response) {
        var _response$config, _response$data;
        var code, messageText, _response$config2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1)switch(_context.prev = _context.next){
                case 0:
                    if (!((_response$config = response.config) !== null && _response$config !== void 0 && _response$config.directReturn)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", response.data);
                case 2:
                    code = response.data.code;
                    messageText = response.data.message || getDefaultError().message;
                    if (!code) {
                        _context.next = 7;
                        break;
                    }
                    !(response !== null && response !== void 0 && (_response$config2 = response.config) !== null && _response$config2 !== void 0 && _response$config2.hiddenMessage) && _ComUI_message__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .Z.error(messageText);
                    throw {
                        code: code,
                        message: messageText
                    };
                case 7:
                    return _context.abrupt("return", (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data);
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function(_x) {
        return _ref.apply(this, arguments);
    };
}(), function(error) {
    var _error$response, _error$config;
    var data = (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || getDefaultError();
    var code = data.code;
    var messageText = data.message;
    if (!(error !== null && error !== void 0 && (_error$config = error.config) !== null && _error$config !== void 0 && _error$config.hiddenMessage)) {
        _ComUI_message__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .Z.error(messageText);
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        code: code,
        message: messageText
    });
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (request);


/***/ }),

/***/ 83642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tc": () => (/* binding */ setLocalUid),
/* harmony export */   "Yz": () => (/* binding */ removeLocalUid),
/* harmony export */   "sw": () => (/* binding */ initLocalUid)
/* harmony export */ });
/* unused harmony export getLocalUid */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16197);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97303);




var getUIDKey = function getUIDKey() {
    return "ouid".concat((0,___WEBPACK_IMPORTED_MODULE_1__/* .getSuffix */ ._A)());
};
/**
 * 海外版本不进行cookie存储
 */ /**
 * 初始化同步uid
 */ var initLocalUid = function initLocalUid() {
    var _getConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig.isIntl;
    if (isIntl) return;
    var uid = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(getUIDKey());
    if (uid) {
        window.localStorage.setItem("uid", String(uid));
    } else {
        window.localStorage.removeItem("uid");
    }
};
/**
 * 更新本地uid缓存和cookie中的uid
 * @param uid
 */ var setLocalUid = function setLocalUid(uid) {
    if (!uid) return;
    var _getConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig2.isIntl;
    if (!isIntl) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(getUIDKey(), String(uid), {
            domain: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getRootDomain */ .wf)(),
            expires: 36500 // 100年有效期
        });
    }
    window.localStorage.setItem("uid", String(uid));
};
var getLocalUid = function getLocalUid() {
    var data = window.localStorage.getItem("uid");
    return data ? Number(data) : null;
};
/**
 * 移除本地uid缓存和cookie中的uid
 */ var removeLocalUid = function removeLocalUid() {
    var _getConfig3 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .iE)(), isIntl = _getConfig3.isIntl;
    if (!isIntl) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(getUIDKey(), {
            domain: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getRootDomain */ .wf)()
        });
    }
    window.localStorage.removeItem("uid");
};


/***/ }),

/***/ 25182:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useLatest(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    ref.current = value;
    return ref;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLatest);


/***/ }),

/***/ 91442:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20753);
/* harmony import */ var _utils_isDev__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73786);



function useMemoizedFn(fn) {
    if (_utils_isDev__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
        if (!(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(fn)) {
            ;
        }
    }
    var fnRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
    // why not write `fnRef.current = fn`?
    // https://github.com/alibaba/hooks/issues/728
    fnRef.current = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return fn;
    }, [
        fn
    ]);
    var memoizedFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    if (!memoizedFn.current) {
        memoizedFn.current = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++){
                args[_i] = arguments[_i];
            }
            return fnRef.current.apply(this, args);
        };
    }
    return memoizedFn.current;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMemoizedFn);


/***/ }),

/***/ 45615:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useLatest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25182);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20753);
/* harmony import */ var _utils_isDev__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73786);




var useUnmount = function(fn) {
    if (_utils_isDev__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
        if (!(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(fn)) {
            ;
        }
    }
    var fnRef = (0,_useLatest__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(fn);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            fnRef.current();
        };
    }, []);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUnmount);


/***/ }),

/***/ 78657:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useUpdateEffect)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/createUpdateEffect/index.js

var createUpdateEffect = function(hook) {
    return function(effect, deps) {
        var isMounted = (0,react.useRef)(false);
        // for react-refresh
        hook(function() {
            return function() {
                isMounted.current = false;
            };
        }, []);
        hook(function() {
            if (!isMounted.current) {
                isMounted.current = true;
            } else {
                return effect();
            }
        }, deps);
    };
};
/* harmony default export */ const es_createUpdateEffect = ((/* unused pure expression or super */ null && (createUpdateEffect)));

;// CONCATENATED MODULE: ./node_modules/ahooks/es/useUpdateEffect/index.js


/* harmony default export */ const useUpdateEffect = (createUpdateEffect(react.useEffect));


/***/ }),

/***/ 20753:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G7": () => (/* binding */ isUndef),
/* harmony export */   "mf": () => (/* binding */ isFunction)
/* harmony export */ });
/* unused harmony exports isObject, isString, isBoolean, isNumber */
var isObject = function(value) {
    return value !== null && typeof value === "object";
};
var isFunction = function(value) {
    return typeof value === "function";
};
var isString = function(value) {
    return typeof value === "string";
};
var isBoolean = function(value) {
    return typeof value === "boolean";
};
var isNumber = function(value) {
    return typeof value === "number";
};
var isUndef = function(value) {
    return typeof value === "undefined";
};


/***/ }),

/***/ 73786:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var isDev =  false || "production" === "test";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isDev);


/***/ }),

/***/ 81167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ query_string)
});

// NAMESPACE OBJECT: ./node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": () => (exclude),
  "extract": () => (extract),
  "parse": () => (parse),
  "parseUrl": () => (parseUrl),
  "pick": () => (pick),
  "stringify": () => (stringify),
  "stringifyUrl": () => (stringifyUrl)
});

// EXTERNAL MODULE: ./node_modules/decode-uri-component/index.js
var decode_uri_component = __webpack_require__(93696);
// EXTERNAL MODULE: ./node_modules/filter-obj/index.js
var filter_obj = __webpack_require__(85252);
// EXTERNAL MODULE: ./node_modules/split-on-first/index.js
var split_on_first = __webpack_require__(33920);
;// CONCATENATED MODULE: ./node_modules/query-string/base.js



const isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = (string)=>encodeURIComponent(string).replaceAll(/[!'()*]/g, (x)=>"%".concat(x.charCodeAt(0).toString(16).toUpperCase()));
const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            {
                return (key)=>(result, value)=>{
                        const index = result.length;
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[",
                                    index,
                                    "]"
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "[",
                                encode(index, options),
                                "]=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "bracket":
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[]"
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "[]=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "colon-list-separator":
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    ":list="
                                ].join("")
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                ":list=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSeparator = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) {
                            return [
                                [
                                    encode(key, options),
                                    keyValueSeparator,
                                    encode(value, options)
                                ].join("")
                            ];
                        }
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            {
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") {
                            return result;
                        }
                        if (value === null) {
                            return [
                                ...result,
                                encode(key, options)
                            ];
                        }
                        return [
                            ...result,
                            [
                                encode(key, options),
                                "=",
                                encode(value, options)
                            ].join("")
                        ];
                    };
            }
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            {
                return (key, value, accumulator)=>{
                    result = /\[(\d*)]$/.exec(key);
                    key = key.replace(/\[\d*]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = {};
                    }
                    accumulator[key][result[1]] = value;
                };
            }
        case "bracket":
            {
                return (key, value, accumulator)=>{
                    result = /(\[])$/.exec(key);
                    key = key.replace(/\[]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        value
                    ];
                };
            }
        case "colon-list-separator":
            {
                return (key, value, accumulator)=>{
                    result = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        value
                    ];
                };
            }
        case "comma":
        case "separator":
            {
                return (key, value, accumulator)=>{
                    const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                    value = isEncodedArray ? decode(value, options) : value;
                    const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                    accumulator[key] = newValue;
                };
            }
        case "bracket-separator":
            {
                return (key, value, accumulator)=>{
                    const isArray = /(\[])$/.test(key);
                    key = key.replace(/\[]$/, "");
                    if (!isArray) {
                        accumulator[key] = value ? decode(value, options) : value;
                        return;
                    }
                    const arrayValue = value === null ? [] : decode(value, options).split(options.arrayFormatSeparator);
                    if (accumulator[key] === undefined) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [
                        ...accumulator[key],
                        ...arrayValue
                    ];
                };
            }
        default:
            {
                return (key, value, accumulator)=>{
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [
                        ...[
                            accumulator[key]
                        ].flat(),
                        value
                    ];
                };
            }
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) {
        throw new TypeError("arrayFormatSeparator must be single character string");
    }
}
function encode(value, options) {
    if (options.encode) {
        return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }
    return value;
}
function decode(value, options) {
    if (options.decode) {
        return (0,decode_uri_component/* default */.Z)(value);
    }
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) {
        return input.sort();
    }
    if (typeof input === "object") {
        return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    }
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) {
        input = input.slice(0, hashStart);
    }
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) {
        hash = url.slice(hashStart);
    }
    return hash;
}
function parseValue(value, options, type) {
    if (type === "string" && typeof value === "string") {
        return value;
    }
    if (typeof type === "function" && typeof value === "string") {
        return type(value);
    }
    if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
        return value.toLowerCase() === "true";
    }
    if (type === "number" && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
        return Number(value);
    }
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
        return Number(value);
    }
    return value;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) {
        return "";
    }
    return input.slice(queryStart + 1);
}
function parse(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        types: Object.create(null),
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") {
        return returnValue;
    }
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) {
        return returnValue;
    }
    for (const parameter of query.split("&")){
        if (parameter === "") {
            continue;
        }
        const parameter_ = options.decode ? parameter.replaceAll("+", " ") : parameter;
        let [key, value] = (0,split_on_first/* default */.Z)(parameter_, "=");
        if (key === undefined) {
            key = parameter_;
        }
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, returnValue);
    }
    for (const [key1, value1] of Object.entries(returnValue)){
        if (typeof value1 === "object" && value1 !== null && options.types[key1] !== "string") {
            for (const [key2, value2] of Object.entries(value1)){
                const type = options.types[key1] ? options.types[key1].replace("[]", "") : undefined;
                value1[key2] = parseValue(value2, options, type);
            }
        } else if (typeof value1 === "object" && value1 !== null && options.types[key1] === "string") {
            returnValue[key1] = Object.values(value1).join(options.arrayFormatSeparator);
        } else {
            returnValue[key1] = parseValue(value1, options, options.types[key1]);
        }
    }
    if (options.sort === false) {
        return returnValue;
    }
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function stringify(object, options) {
    if (!object) {
        return "";
    }
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object)){
        if (!shouldFilter(key)) {
            objectCopy[key] = value;
        }
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) {
        keys.sort(options.sort);
    }
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) {
            return "";
        }
        if (value === null) {
            return encode(key, options);
        }
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") {
                return encode(key, options) + "[]";
            }
            return value.reduce(formatter(key), []).join("&");
        }
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function parseUrl(url, options) {
    var ref;
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0,split_on_first/* default */.Z)(url, "#");
    if (url_ === undefined) {
        url_ = url;
    }
    var ref1;
    return {
        url: (ref1 = (ref = url_ === null || url_ === void 0 ? void 0 : url_.split("?")) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : "",
        query: parse(extract(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: decode(hash, options)
        } : {}
    };
}
function stringifyUrl(object, options) {
    options = {
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true,
        ...options
    };
    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = extract(object.url);
    const query = {
        ...parse(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = stringify(query, options);
    queryString && (queryString = "?".concat(queryString));
    let hash = getHash(object.url);
    if (typeof object.fragmentIdentifier === "string") {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : "#".concat(object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
}
function pick(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false,
        ...options
    };
    const { url , query , fragmentIdentifier  } = parseUrl(input, options);
    return stringifyUrl({
        url,
        query: (0,filter_obj/* includeKeys */.T)(query, filter),
        fragmentIdentifier
    }, options);
}
function exclude(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/query-string/index.js

/* harmony default export */ const query_string = (base_namespaceObject);


/***/ }),

/***/ 364:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3965:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77477:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30341:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39618:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48674:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50072:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 12047:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 38867:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 76511:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68795:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57926:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 14222:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 28985:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Deferred = void 0;
class Deferred {
    constructor() {
        this.resolve = () => null;
        this.reject = () => null;
        this.promise = new Promise((resolve, reject) => {
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
exports.Deferred = Deferred;


/***/ }),

/***/ 37279:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EndOfStreamError = exports.defaultMessages = void 0;
exports.defaultMessages = 'End-Of-Stream';
/**
 * Thrown on read operation of the end of file or stream has been reached
 */
class EndOfStreamError extends Error {
    constructor() {
        super(exports.defaultMessages);
    }
}
exports.EndOfStreamError = EndOfStreamError;


/***/ }),

/***/ 56654:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamReader = exports.EndOfStreamError = void 0;
const EndOfFileStream_1 = __webpack_require__(37279);
const Deferred_1 = __webpack_require__(28985);
var EndOfFileStream_2 = __webpack_require__(37279);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return EndOfFileStream_2.EndOfStreamError; } }));
const maxStreamReadSize = 1 * 1024 * 1024; // Maximum request length on read-stream operation
class StreamReader {
    constructor(s) {
        this.s = s;
        /**
         * Deferred used for postponed read request (as not data is yet available to read)
         */
        this.deferred = null;
        this.endOfStream = false;
        /**
         * Store peeked data
         * @type {Array}
         */
        this.peekQueue = [];
        if (!s.read || !s.once) {
            throw new Error('Expected an instance of stream.Readable');
        }
        this.s.once('end', () => this.reject(new EndOfFileStream_1.EndOfStreamError()));
        this.s.once('error', err => this.reject(err));
        this.s.once('close', () => this.reject(new Error('Stream closed')));
    }
    /**
     * Read ahead (peek) from stream. Subsequent read or peeks will return the same data
     * @param uint8Array - Uint8Array (or Buffer) to store data read from stream in
     * @param offset - Offset target
     * @param length - Number of bytes to read
     * @returns Number of bytes peeked
     */
    async peek(uint8Array, offset, length) {
        const bytesRead = await this.read(uint8Array, offset, length);
        this.peekQueue.push(uint8Array.subarray(offset, offset + bytesRead)); // Put read data back to peek buffer
        return bytesRead;
    }
    /**
     * Read chunk from stream
     * @param buffer - Target Uint8Array (or Buffer) to store data read from stream in
     * @param offset - Offset target
     * @param length - Number of bytes to read
     * @returns Number of bytes read
     */
    async read(buffer, offset, length) {
        if (length === 0) {
            return 0;
        }
        if (this.peekQueue.length === 0 && this.endOfStream) {
            throw new EndOfFileStream_1.EndOfStreamError();
        }
        let remaining = length;
        let bytesRead = 0;
        // consume peeked data first
        while (this.peekQueue.length > 0 && remaining > 0) {
            const peekData = this.peekQueue.pop(); // Front of queue
            if (!peekData)
                throw new Error('peekData should be defined');
            const lenCopy = Math.min(peekData.length, remaining);
            buffer.set(peekData.subarray(0, lenCopy), offset + bytesRead);
            bytesRead += lenCopy;
            remaining -= lenCopy;
            if (lenCopy < peekData.length) {
                // remainder back to queue
                this.peekQueue.push(peekData.subarray(lenCopy));
            }
        }
        // continue reading from stream if required
        while (remaining > 0 && !this.endOfStream) {
            const reqLen = Math.min(remaining, maxStreamReadSize);
            const chunkLen = await this.readFromStream(buffer, offset + bytesRead, reqLen);
            bytesRead += chunkLen;
            if (chunkLen < reqLen)
                break;
            remaining -= chunkLen;
        }
        return bytesRead;
    }
    /**
     * Read chunk from stream
     * @param buffer Target Uint8Array (or Buffer) to store data read from stream in
     * @param offset Offset target
     * @param length Number of bytes to read
     * @returns Number of bytes read
     */
    async readFromStream(buffer, offset, length) {
        const readBuffer = this.s.read(length);
        if (readBuffer) {
            buffer.set(readBuffer, offset);
            return readBuffer.length;
        }
        else {
            const request = {
                buffer,
                offset,
                length,
                deferred: new Deferred_1.Deferred()
            };
            this.deferred = request.deferred;
            this.s.once('readable', () => {
                this.readDeferred(request);
            });
            return request.deferred.promise;
        }
    }
    /**
     * Process deferred read request
     * @param request Deferred read request
     */
    readDeferred(request) {
        const readBuffer = this.s.read(request.length);
        if (readBuffer) {
            request.buffer.set(readBuffer, request.offset);
            request.deferred.resolve(readBuffer.length);
            this.deferred = null;
        }
        else {
            this.s.once('readable', () => {
                this.readDeferred(request);
            });
        }
    }
    reject(err) {
        this.endOfStream = true;
        if (this.deferred) {
            this.deferred.reject(err);
            this.deferred = null;
        }
    }
}
exports.StreamReader = StreamReader;


/***/ }),

/***/ 55167:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamReader = exports.EndOfStreamError = void 0;
var EndOfFileStream_1 = __webpack_require__(37279);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return EndOfFileStream_1.EndOfStreamError; } }));
var StreamReader_1 = __webpack_require__(56654);
Object.defineProperty(exports, "StreamReader", ({ enumerable: true, get: function () { return StreamReader_1.StreamReader; } }));


/***/ }),

/***/ 75:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 87236:
/***/ ((module) => {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),

/***/ 34155:
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 1798:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this || __webpack_require__.g, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 42723:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}("undefined"!=typeof self?self:this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=58)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:"2.6.9"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(31)("wks"),o=n(22),i=n(0).Symbol,a="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))}).store=r},function(t,e,n){var r=n(8);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){t.exports=!n(10)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(0),o=n(1),i=n(19),a=n(6),s=n(9),u=function(t,e,n){var c,f,l,h=t&u.F,p=t&u.G,d=t&u.S,g=t&u.P,m=t&u.B,v=t&u.W,y=p?o:o[e]||(o[e]={}),b=y.prototype,w=p?r:d?r[e]:(r[e]||{}).prototype;for(c in p&&(n=e),n)(f=!h&&w&&void 0!==w[c])&&s(y,c)||(l=f?w[c]:n[c],y[c]=p&&"function"!=typeof w[c]?n[c]:m&&f?i(l,r):v&&w[c]==l?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(l):g&&"function"==typeof l?i(Function.call,l):l,g&&((y.virtual||(y.virtual={}))[c]=l,t&u.R&&b&&!b[c]&&a(b,c,l)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,t.exports=u},function(t,e,n){var r=n(7),o=n(21);t.exports=n(4)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(3),o=n(43),i=n(29),a=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(47),o=n(27);t.exports=function(t){return r(o(t))}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){var e=t+864e5;return(new Date).getTime()>e}function i(t){return(0,m.default)(t).filter(function(t){return t.startsWith("x:")}).map(function(e){return[e,t[e].toString()]})}function a(t){return"qiniu_js_sdk_upload_file_"+t.name+"_size_"+t.size}function s(t){try{return JSON.parse(localStorage.getItem(a(t)))||[]}catch(t){return window.console&&window.console.warn&&console.warn("getLocalFileInfo failed"),[]}}function u(t){return{Authorization:"UpToken "+t}}function c(){return window.XMLHttpRequest?new XMLHttpRequest:new window.ActiveXObject("Microsoft.XMLHTTP")}function f(t){return new p.default(function(e,n){var r=new FileReader;r.readAsArrayBuffer(t),r.onload=function(t){var n=t.target.result;e(n)},r.onerror=function(){n(new Error("fileReader 读取错误"))}})}function l(t,e){return new p.default(function(n,r){var o=c();o.open(e.method,t),e.onCreate&&e.onCreate(o),e.headers&&(0,m.default)(e.headers).forEach(function(t){return o.setRequestHeader(t,e.headers[t])}),o.upload.addEventListener("progress",function(t){t.lengthComputable&&e.onProgress&&e.onProgress({loaded:t.loaded,total:t.total})}),o.onreadystatechange=function(){var t=o.responseText;if(4===o.readyState){var e=o.getResponseHeader("x-reqId")||"";if(200!==o.status){var i="xhr request failed, code: "+o.status+";";return t&&(i=i+" response: "+t),void r({code:o.status,message:i,reqId:e,isRequestError:!0})}try{n({data:JSON.parse(t),reqId:e})}catch(t){r(t)}}},o.send(e.body)})}function h(){return"http:"===window.location.protocol?"http:":"https:"}e.__esModule=!0;var p=r(n(18)),d=r(n(34)),g=r(n(86)),m=r(n(36));e.isChunkExpired=o,e.getChunks=function(t,e){for(var n=[],r=Math.ceil(t.size/e),o=0;o<r;o++){var i=t.slice(e*o,o===r-1?t.size:e*(o+1));n.push(i)}return n},e.filterParams=i,e.sum=function(t){return t.reduce(function(t,e){return t+e},0)},e.setLocalFileInfo=function(t,e){try{localStorage.setItem(a(t),(0,g.default)(e))}catch(t){window.console&&window.console.warn&&console.warn("setLocalFileInfo failed")}},e.removeLocalFileInfo=function(t){try{localStorage.removeItem(a(t))}catch(t){window.console&&window.console.warn&&console.warn("removeLocalFileInfo failed")}},e.getLocalFileInfo=s,e.getResumeUploadedSize=function(t){return s(t).filter(function(t){return t&&!o(t.time)}).reduce(function(t,e){return t+e.size},0)},e.createMkFileUrl=function(t,e,n,r){var o=t+"/mkfile/"+e.size;null!=n&&(o+="/key/"+(0,v.urlSafeBase64Encode)(n)),r.mimeType&&(o+="/mimeType/"+(0,v.urlSafeBase64Encode)(e.type));var a=r.fname;return a&&(o+="/fname/"+(0,v.urlSafeBase64Encode)(a)),r.params&&i(r.params).forEach(function(t){return o+="/"+encodeURIComponent(t[0])+"/"+(0,v.urlSafeBase64Encode)(t[1])}),o},e.getHeadersForChunkUpload=function(t){var e=u(t);return(0,d.default)({"content-type":"application/octet-stream"},e)},e.getHeadersForMkFile=function(t){var e=u(t);return(0,d.default)({"content-type":"text/plain"},e)},e.createXHR=c,e.computeMd5=function(t){return f(t).then(function(t){var e=new b.default.ArrayBuffer;return e.append(t),e.end()})},e.readAsArrayBuffer=f,e.request=l,e.getPortFromUrl=function(t){if(t&&t.match){var e=t.match(/(^https?)/);if(!e)return"";var n=e[1];return(e=t.match(/^https?:\/\/([^:^\/]*):(\d*)/))?e[2]:"http"===n?"80":"443"}return""},e.getDomainFromUrl=function(t){if(t&&t.match){var e=t.match(/^https?:\/\/([^:^\/]*)/);return e?e[1]:""}return""},e.getUploadUrl=function(t,e){var n=h();if(null!=t.uphost)return p.default.resolve(n+"//"+t.uphost);if(null!=t.region){var r=y.regionUphostMap[t.region],o=t.useCdnDomain?r.cdnUphost:r.srcUphost;return p.default.resolve(n+"//"+o)}return function(t){try{var e=function(t){var e=t.split(":"),n=e[0],r=JSON.parse((0,v.urlSafeBase64Decode)(e[2]));return r.ak=n,r.bucket=r.scope.split(":")[0],r}(t);return l(h()+"//api.qiniu.com/v2/query?ak="+e.ak+"&bucket="+e.bucket,{method:"GET"})}catch(t){return p.default.reject(t)}}(e).then(function(t){var e=t.data.up.acc.main;return n+"//"+e[0]})},e.isContainFileMimeType=function(t,e){return e.indexOf(t)>-1},e.createObjectURL=function(t){return(window.URL||window.webkitURL||window.mozURL).createObjectURL(t)},e.getTransform=function(t,e){var n=t.width,r=t.height;switch(e){case 1:return{width:n,height:r,matrix:[1,0,0,1,0,0]};case 2:return{width:n,height:r,matrix:[-1,0,0,1,n,0]};case 3:return{width:n,height:r,matrix:[-1,0,0,-1,n,r]};case 4:return{width:n,height:r,matrix:[1,0,0,-1,0,r]};case 5:return{width:r,height:n,matrix:[0,1,1,0,0,0]};case 6:return{width:r,height:n,matrix:[0,1,-1,0,r,0]};case 7:return{width:r,height:n,matrix:[0,-1,-1,0,r,n]};case 8:return{width:r,height:n,matrix:[0,-1,1,0,0,n]}}};var v=n(56),y=n(39),b=r(n(91))},function(t,e){t.exports=!0},function(t,e){t.exports={}},function(t,e,n){var r=n(46),o=n(32);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){t.exports={default:n(59),__esModule:!0}},function(t,e,n){var r=n(20);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){var r=n(7).f,o=n(9),i=n(2)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(27);t.exports=function(t){return Object(r(t))}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(8),o=n(0).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(8);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(31)("keys"),o=n(22);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(1),o=n(0),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(13)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){"use strict";var r=n(20);t.exports.f=function(t){return new function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=r(e),this.reject=r(n)}(t)}},function(t,e,n){t.exports={default:n(83),__esModule:!0}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){t.exports={default:n(88),__esModule:!0}},function(t,e,n){e.f=n(2)},function(t,e,n){var r=n(0),o=n(1),i=n(13),a=n(37),s=n(7).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:a.f(t)})}},function(t,e,n){"use strict";e.__esModule=!0,e.regionUphostMap={z0:{srcUphost:"up.qiniup.com",cdnUphost:"upload.qiniup.com"},z1:{srcUphost:"up-z1.qiniup.com",cdnUphost:"upload-z1.qiniup.com"},z2:{srcUphost:"up-z2.qiniup.com",cdnUphost:"upload-z2.qiniup.com"},na0:{srcUphost:"up-na0.qiniup.com",cdnUphost:"upload-na0.qiniup.com"},as0:{srcUphost:"up-as0.qiniup.com",cdnUphost:"upload-as0.qiniup.com"}},e.region={z0:"z0",z1:"z1",z2:"z2",na0:"na0",as0:"as0"}},function(t,e){},function(t,e,n){"use strict";var r=n(60)(!0);n(42)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var r=n(13),o=n(5),i=n(44),a=n(6),s=n(14),u=n(61),c=n(23),f=n(65),l=n(2)("iterator"),h=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,n,d,g,m,v){u(n,e,d);var y,b,w,x=function(t){if(!h&&t in C)return C[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},S=e+" Iterator",P="values"==g,_=!1,C=t.prototype,U=C[l]||C["@@iterator"]||g&&C[g],F=U||x(g),I=g?P?x("entries"):F:void 0,k="Array"==e&&C.entries||U;if(k&&(w=f(k.call(new t)))!==Object.prototype&&w.next&&(c(w,S,!0),r||"function"==typeof w[l]||a(w,l,p)),P&&U&&"values"!==U.name&&(_=!0,F=function(){return U.call(this)}),r&&!v||!h&&!_&&C[l]||a(C,l,F),s[e]=F,s[S]=p,g)if(y={values:P?F:x("values"),keys:m?F:x("keys"),entries:I},v)for(b in y)b in C||i(C,b,y[b]);else o(o.P+o.F*(h||_),e,y);return y}},function(t,e,n){t.exports=!n(4)&&!n(10)(function(){return 7!=Object.defineProperty(n(28)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){t.exports=n(6)},function(t,e,n){var r=n(3),o=n(62),i=n(32),a=n(30)("IE_PROTO"),s=function(){},u=function(){var t,e=n(28)("iframe"),r=i.length;for(e.style.display="none",n(49).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),u=t.F;r--;)delete u.prototype[i[r]];return u()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=r(t),n=new s,s.prototype=null,n[a]=t):n=u(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(9),o=n(11),i=n(63)(!1),a=n(30)("IE_PROTO");t.exports=function(t,e){var n,s=o(t),u=0,c=[];for(n in s)n!=a&&r(s,n)&&c.push(n);for(;e.length>u;)r(s,n=e[u++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){var r=n(16);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(26),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(0).document;t.exports=r&&r.documentElement},function(t,e,n){n(66);for(var r=n(0),o=n(6),i=n(14),a=n(2)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),u=0;u<s.length;u++){var c=s[u],f=r[c],l=f&&f.prototype;l&&!l[a]&&o(l,a,c),i[c]=i.Array}},function(t,e,n){var r=n(16),o=n(2)("toStringTag"),i="Arguments"==r(function(){return arguments}());t.exports=function(t){var e,n,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:i?r(e):"Object"==(a=r(e))&&"function"==typeof e.callee?"Arguments":a}},function(t,e,n){var r=n(3),o=n(20),i=n(2)("species");t.exports=function(t,e){var n,a=r(t).constructor;return void 0===a||void 0==(n=r(a)[i])?e:o(n)}},function(t,e,n){var r,o,i,a=n(19),s=n(75),u=n(49),c=n(28),f=n(0),l=f.process,h=f.setImmediate,p=f.clearImmediate,d=f.MessageChannel,g=f.Dispatch,m=0,v={},y=function(){var t=+this;if(v.hasOwnProperty(t)){var e=v[t];delete v[t],e()}},b=function(t){y.call(t.data)};h&&p||(h=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return v[++m]=function(){s("function"==typeof t?t:Function(t),e)},r(m),m},p=function(t){delete v[t]},"process"==n(16)(l)?r=function(t){l.nextTick(a(y,t,1))}:g&&g.now?r=function(t){g.now(a(y,t,1))}:d?(i=(o=new d).port2,o.port1.onmessage=b,r=a(i.postMessage,i,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",b,!1)):r="onreadystatechange"in c("script")?function(t){u.appendChild(c("script")).onreadystatechange=function(){u.removeChild(this),y.call(t)}}:function(t){setTimeout(a(y,t,1),0)}),t.exports={set:h,clear:p}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r=n(3),o=n(8),i=n(33);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){"use strict";e.__esModule=!0,e.urlSafeBase64Encode=function(t){return(t=function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=void 0,r=void 0,o=void 0,i=void 0,a=void 0,s=void 0,u=void 0,c=void 0,f=0,l=0,h="",p=[];if(!t)return t;t=function(t){if(null===t||void 0===t)return"";var e=t+"",n="",r=void 0,o=void 0,i=0;r=o=0,i=e.length;for(var a=0;a<i;a++){var s=e.charCodeAt(a),u=null;if(s<128)o++;else if(s>127&&s<2048)u=String.fromCharCode(s>>6|192,63&s|128);else if(63488&s^!0)u=String.fromCharCode(s>>12|224,s>>6&63|128,63&s|128);else{if(64512&s^!0)throw new RangeError("Unmatched trail surrogate at "+a);var c=e.charCodeAt(++a);if(64512&c^!0)throw new RangeError("Unmatched lead surrogate at "+(a-1));s=((1023&s)<<10)+(1023&c)+65536,u=String.fromCharCode(s>>18|240,s>>12&63|128,s>>6&63|128,63&s|128)}null!==u&&(o>r&&(n+=e.slice(r,o)),n+=u,r=o=a+1)}return o>r&&(n+=e.slice(r,i)),n}(t+"");do{n=t.charCodeAt(f++),r=t.charCodeAt(f++),o=t.charCodeAt(f++),i=(c=n<<16|r<<8|o)>>18&63,a=c>>12&63,s=c>>6&63,u=63&c,p[l++]=e.charAt(i)+e.charAt(a)+e.charAt(s)+e.charAt(u)}while(f<t.length);switch(h=p.join(""),t.length%3){case 1:h=h.slice(0,-2)+"==";break;case 2:h=h.slice(0,-1)+"="}return h}(t)).replace(/\//g,"_").replace(/\+/g,"-")},e.urlSafeBase64Decode=function(t){return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=void 0,r=void 0,o=void 0,i=void 0,a=void 0,s=void 0,u=void 0,c=void 0,f=0,l=0,h=[];if(!t)return t;t+="";do{i=e.indexOf(t.charAt(f++)),a=e.indexOf(t.charAt(f++)),s=e.indexOf(t.charAt(f++)),u=e.indexOf(t.charAt(f++)),n=(c=i<<18|a<<12|s<<6|u)>>16&255,r=c>>8&255,o=255&c,h[l++]=64===s?String.fromCharCode(n):64===u?String.fromCharCode(n,r):String.fromCharCode(n,r,o)}while(f<t.length);return h.join("")}(t=t.replace(/_/g,"/").replace(/-/g,"+"))}},function(t,e,n){var r=n(46),o=n(32).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){"use strict";e.__esModule=!0,e.pipeline=e.compressImage=e.exif=e.imageInfo=e.watermark=e.imageMogr2=e.getUploadUrl=e.filterParams=e.getHeadersForMkFile=e.getResumeUploadedSize=e.getHeadersForChunkUpload=e.createMkFileUrl=e.region=e.upload=void 0;var r=n(39),o=n(12),i=n(92),a=n(94),s=n(95),u=n(109),c=function(t){return t&&t.__esModule?t:{default:t}}(n(110)),f=new u.StatisticsLogger;e.upload=function(t,e,n,r,o){var a={file:t,key:e,token:n,putExtra:r,config:o};return new s.Observable(function(t){var e=new i.UploadManager(a,{onData:function(e){return t.next(e)},onError:function(e){return t.error(e)},onComplete:function(e){return t.complete(e)}},f);return e.putFile(),e.stop.bind(e)})},e.region=r.region,e.createMkFileUrl=o.createMkFileUrl,e.getHeadersForChunkUpload=o.getHeadersForChunkUpload,e.getResumeUploadedSize=o.getResumeUploadedSize,e.getHeadersForMkFile=o.getHeadersForMkFile,e.filterParams=o.filterParams,e.getUploadUrl=o.getUploadUrl,e.imageMogr2=a.imageMogr2,e.watermark=a.watermark,e.imageInfo=a.imageInfo,e.exif=a.exif,e.compressImage=c.default,e.pipeline=a.pipeline},function(t,e,n){n(40),n(41),n(50),n(69),n(81),n(82),t.exports=n(1).Promise},function(t,e,n){var r=n(26),o=n(27);t.exports=function(t){return function(e,n){var i,a,s=String(o(e)),u=r(n),c=s.length;return u<0||u>=c?t?"":void 0:(i=s.charCodeAt(u))<55296||i>56319||u+1===c||(a=s.charCodeAt(u+1))<56320||a>57343?t?s.charAt(u):i:t?s.slice(u,u+2):a-56320+(i-55296<<10)+65536}}},function(t,e,n){"use strict";var r=n(45),o=n(21),i=n(23),a={};n(6)(a,n(2)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){var r=n(7),o=n(3),i=n(15);t.exports=n(4)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),s=a.length,u=0;s>u;)r.f(t,n=a[u++],e[n]);return t}},function(t,e,n){var r=n(11),o=n(48),i=n(64);t.exports=function(t){return function(e,n,a){var s,u=r(e),c=o(u.length),f=i(a,c);if(t&&n!=n){for(;c>f;)if((s=u[f++])!=s)return!0}else for(;c>f;f++)if((t||f in u)&&u[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(26),o=Math.max,i=Math.min;t.exports=function(t,e){return(t=r(t))<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(9),o=n(24),i=n(30)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){"use strict";var r=n(67),o=n(68),i=n(14),a=n(11);t.exports=n(42)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";var r,o,i,a,s=n(13),u=n(0),c=n(19),f=n(51),l=n(5),h=n(8),p=n(20),d=n(70),g=n(71),m=n(52),v=n(53).set,y=n(76)(),b=n(33),w=n(54),x=n(77),S=n(55),P=u.TypeError,_=u.process,C=_&&_.versions,U=C&&C.v8||"",F=u.Promise,I="process"==f(_),k=function(){},E=o=b.f,M=!!function(){try{var t=F.resolve(1),e=(t.constructor={})[n(2)("species")]=function(t){t(k,k)};return(I||"function"==typeof PromiseRejectionEvent)&&t.then(k)instanceof e&&0!==U.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),O=function(t){var e;return!(!h(t)||"function"!=typeof(e=t.then))&&e},T=function(t,e){if(!t._n){t._n=!0;var n=t._c;y(function(){for(var r=t._v,o=1==t._s,i=0;n.length>i;)!function(e){var n,i,a,s=o?e.ok:e.fail,u=e.resolve,c=e.reject,f=e.domain;try{s?(o||(2==t._h&&L(t),t._h=1),!0===s?n=r:(f&&f.enter(),n=s(r),f&&(f.exit(),a=!0)),n===e.promise?c(P("Promise-chain cycle")):(i=O(n))?i.call(n,u,c):u(n)):c(r)}catch(t){f&&!a&&f.exit(),c(t)}}(n[i++]);t._c=[],t._n=!1,e&&!t._h&&R(t)})}},R=function(t){v.call(u,function(){var e,n,r,o=t._v,i=A(t);if(i&&(e=w(function(){I?_.emit("unhandledRejection",o,t):(n=u.onunhandledrejection)?n({promise:t,reason:o}):(r=u.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=I||A(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},A=function(t){return 1!==t._h&&0===(t._a||t._c).length},L=function(t){v.call(u,function(){var e;I?_.emit("rejectionHandled",t):(e=u.onrejectionhandled)&&e({promise:t,reason:t._v})})},D=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),T(e,!0))},j=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw P("Promise can't be resolved itself");(e=O(t))?y(function(){var r={_w:n,_d:!1};try{e.call(t,c(j,r,1),c(D,r,1))}catch(t){D.call(r,t)}}):(n._v=t,n._s=1,T(n,!1))}catch(t){D.call({_w:n,_d:!1},t)}}};M||(F=function(t){d(this,F,"Promise","_h"),p(t),r.call(this);try{t(c(j,this,1),c(D,this,1))}catch(t){D.call(this,t)}},(r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n(78)(F.prototype,{then:function(t,e){var n=E(m(this,F));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=I?_.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&T(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=c(j,t,1),this.reject=c(D,t,1)},b.f=E=function(t){return t===F||t===a?new i(t):o(t)}),l(l.G+l.W+l.F*!M,{Promise:F}),n(23)(F,"Promise"),n(79)("Promise"),a=n(1).Promise,l(l.S+l.F*!M,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),l(l.S+l.F*(s||!M),"Promise",{resolve:function(t){return S(s&&this===a?F:this,t)}}),l(l.S+l.F*!(M&&n(80)(function(t){F.all(t).catch(k)})),"Promise",{all:function(t){var e=this,n=E(e),r=n.resolve,o=n.reject,i=w(function(){var n=[],i=0,a=1;g(t,!1,function(t){var s=i++,u=!1;n.push(void 0),a++,e.resolve(t).then(function(t){u||(u=!0,n[s]=t,--a||r(n))},o)}),--a||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=E(e),r=n.reject,o=w(function(){g(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(19),o=n(72),i=n(73),a=n(3),s=n(48),u=n(74),c={},f={};(e=t.exports=function(t,e,n,l,h){var p,d,g,m,v=h?function(){return t}:u(t),y=r(n,l,e?2:1),b=0;if("function"!=typeof v)throw TypeError(t+" is not iterable!");if(i(v)){for(p=s(t.length);p>b;b++)if((m=e?y(a(d=t[b])[0],d[1]):y(t[b]))===c||m===f)return m}else for(g=v.call(t);!(d=g.next()).done;)if((m=o(g,y,d.value,e))===c||m===f)return m}).BREAK=c,e.RETURN=f},function(t,e,n){var r=n(3);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(14),o=n(2)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(51),o=n(2)("iterator"),i=n(14);t.exports=n(1).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(0),o=n(53).set,i=r.MutationObserver||r.WebKitMutationObserver,a=r.process,s=r.Promise,u="process"==n(16)(a);t.exports=function(){var t,e,n,c=function(){var r,o;for(u&&(r=a.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(u)n=function(){a.nextTick(c)};else if(!i||r.navigator&&r.navigator.standalone)if(s&&s.resolve){var f=s.resolve(void 0);n=function(){f.then(c)}}else n=function(){o.call(r,c)};else{var l=!0,h=document.createTextNode("");new i(c).observe(h,{characterData:!0}),n=function(){h.data=l=!l}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e,n){var r=n(0).navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var r=n(6);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){"use strict";var r=n(0),o=n(1),i=n(7),a=n(4),s=n(2)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:r[t];a&&e&&!e[s]&&i.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(2)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},t(i)}catch(t){}return n}},function(t,e,n){"use strict";var r=n(5),o=n(1),i=n(0),a=n(52),s=n(55);r(r.P+r.R,"Promise",{finally:function(t){var e=a(this,o.Promise||i.Promise),n="function"==typeof t;return this.then(n?function(n){return s(e,t()).then(function(){return n})}:t,n?function(n){return s(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";var r=n(5),o=n(33),i=n(54);r(r.S,"Promise",{try:function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){n(84),t.exports=n(1).Object.assign},function(t,e,n){var r=n(5);r(r.S+r.F,"Object",{assign:n(85)})},function(t,e,n){"use strict";var r=n(4),o=n(15),i=n(35),a=n(25),s=n(24),u=n(47),c=Object.assign;t.exports=!c||n(10)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=c({},t)[n]||Object.keys(c({},e)).join("")!=r})?function(t,e){for(var n=s(t),c=arguments.length,f=1,l=i.f,h=a.f;c>f;)for(var p,d=u(arguments[f++]),g=l?o(d).concat(l(d)):o(d),m=g.length,v=0;m>v;)p=g[v++],r&&!h.call(d,p)||(n[p]=d[p]);return n}:c},function(t,e,n){t.exports={default:n(87),__esModule:!0}},function(t,e,n){var r=n(1),o=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,e,n){n(89),t.exports=n(1).Object.keys},function(t,e,n){var r=n(24),o=n(15);n(90)("keys",function(){return function(t){return o(r(t))}})},function(t,e,n){var r=n(5),o=n(1),i=n(10);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],a={};a[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(t,e,n){!function(e){t.exports=function(t){"use strict";function e(t,e){var n=t[0],r=t[1],o=t[2],i=t[3];r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[0]-680876936|0)<<7|n>>>25)+r|0)&r|~n&o)+e[1]-389564586|0)<<12|i>>>20)+n|0)&n|~i&r)+e[2]+606105819|0)<<17|o>>>15)+i|0)&i|~o&n)+e[3]-1044525330|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[4]-176418897|0)<<7|n>>>25)+r|0)&r|~n&o)+e[5]+1200080426|0)<<12|i>>>20)+n|0)&n|~i&r)+e[6]-1473231341|0)<<17|o>>>15)+i|0)&i|~o&n)+e[7]-45705983|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[8]+1770035416|0)<<7|n>>>25)+r|0)&r|~n&o)+e[9]-1958414417|0)<<12|i>>>20)+n|0)&n|~i&r)+e[10]-42063|0)<<17|o>>>15)+i|0)&i|~o&n)+e[11]-1990404162|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&o|~r&i)+e[12]+1804603682|0)<<7|n>>>25)+r|0)&r|~n&o)+e[13]-40341101|0)<<12|i>>>20)+n|0)&n|~i&r)+e[14]-1502002290|0)<<17|o>>>15)+i|0)&i|~o&n)+e[15]+1236535329|0)<<22|r>>>10)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[1]-165796510|0)<<5|n>>>27)+r|0)&o|r&~o)+e[6]-1069501632|0)<<9|i>>>23)+n|0)&r|n&~r)+e[11]+643717713|0)<<14|o>>>18)+i|0)&n|i&~n)+e[0]-373897302|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[5]-701558691|0)<<5|n>>>27)+r|0)&o|r&~o)+e[10]+38016083|0)<<9|i>>>23)+n|0)&r|n&~r)+e[15]-660478335|0)<<14|o>>>18)+i|0)&n|i&~n)+e[4]-405537848|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[9]+568446438|0)<<5|n>>>27)+r|0)&o|r&~o)+e[14]-1019803690|0)<<9|i>>>23)+n|0)&r|n&~r)+e[3]-187363961|0)<<14|o>>>18)+i|0)&n|i&~n)+e[8]+1163531501|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r&i|o&~i)+e[13]-1444681467|0)<<5|n>>>27)+r|0)&o|r&~o)+e[2]-51403784|0)<<9|i>>>23)+n|0)&r|n&~r)+e[7]+1735328473|0)<<14|o>>>18)+i|0)&n|i&~n)+e[12]-1926607734|0)<<20|r>>>12)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[5]-378558|0)<<4|n>>>28)+r|0)^r^o)+e[8]-2022574463|0)<<11|i>>>21)+n|0)^n^r)+e[11]+1839030562|0)<<16|o>>>16)+i|0)^i^n)+e[14]-35309556|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[1]-1530992060|0)<<4|n>>>28)+r|0)^r^o)+e[4]+1272893353|0)<<11|i>>>21)+n|0)^n^r)+e[7]-155497632|0)<<16|o>>>16)+i|0)^i^n)+e[10]-1094730640|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[13]+681279174|0)<<4|n>>>28)+r|0)^r^o)+e[0]-358537222|0)<<11|i>>>21)+n|0)^n^r)+e[3]-722521979|0)<<16|o>>>16)+i|0)^i^n)+e[6]+76029189|0)<<23|r>>>9)+o|0,r=((r+=((o=((o+=((i=((i+=((n=((n+=(r^o^i)+e[9]-640364487|0)<<4|n>>>28)+r|0)^r^o)+e[12]-421815835|0)<<11|i>>>21)+n|0)^n^r)+e[15]+530742520|0)<<16|o>>>16)+i|0)^i^n)+e[2]-995338651|0)<<23|r>>>9)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[0]-198630844|0)<<6|n>>>26)+r|0)|~o))+e[7]+1126891415|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[14]-1416354905|0)<<15|o>>>17)+i|0)|~n))+e[5]-57434055|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[12]+1700485571|0)<<6|n>>>26)+r|0)|~o))+e[3]-1894986606|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[10]-1051523|0)<<15|o>>>17)+i|0)|~n))+e[1]-2054922799|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[8]+1873313359|0)<<6|n>>>26)+r|0)|~o))+e[15]-30611744|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[6]-1560198380|0)<<15|o>>>17)+i|0)|~n))+e[13]+1309151649|0)<<21|r>>>11)+o|0,r=((r+=((i=((i+=(r^((n=((n+=(o^(r|~i))+e[4]-145523070|0)<<6|n>>>26)+r|0)|~o))+e[11]-1120210379|0)<<10|i>>>22)+n|0)^((o=((o+=(n^(i|~r))+e[2]+718787259|0)<<15|o>>>17)+i|0)|~n))+e[9]-343485551|0)<<21|r>>>11)+o|0,t[0]=n+t[0]|0,t[1]=r+t[1]|0,t[2]=o+t[2]|0,t[3]=i+t[3]|0}function n(t){var e,n=[];for(e=0;e<64;e+=4)n[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return n}function r(t){var e,n=[];for(e=0;e<64;e+=4)n[e>>2]=t[e]+(t[e+1]<<8)+(t[e+2]<<16)+(t[e+3]<<24);return n}function o(t){var r,o,i,a,s,u,c=t.length,f=[1732584193,-271733879,-1732584194,271733878];for(r=64;r<=c;r+=64)e(f,n(t.substring(r-64,r)));for(o=(t=t.substring(r-64)).length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],r=0;r<o;r+=1)i[r>>2]|=t.charCodeAt(r)<<(r%4<<3);if(i[r>>2]|=128<<(r%4<<3),r>55)for(e(f,i),r=0;r<16;r+=1)i[r]=0;return a=(a=8*c).toString(16).match(/(.*?)(.{0,8})$/),s=parseInt(a[2],16),u=parseInt(a[1],16)||0,i[14]=s,i[15]=u,e(f,i),f}function i(t){var e,n="";for(e=0;e<4;e+=1)n+=f[t>>8*e+4&15]+f[t>>8*e&15];return n}function a(t){var e;for(e=0;e<t.length;e+=1)t[e]=i(t[e]);return t.join("")}function s(t){return/[\u0080-\uFFFF]/.test(t)&&(t=unescape(encodeURIComponent(t))),t}function u(t){var e,n=[],r=t.length;for(e=0;e<r-1;e+=2)n.push(parseInt(t.substr(e,2),16));return String.fromCharCode.apply(String,n)}function c(){this.reset()}var f=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"];return a(o("hello")),"undefined"==typeof ArrayBuffer||ArrayBuffer.prototype.slice||function(){function e(t,e){return(t=0|t||0)<0?Math.max(t+e,0):Math.min(t,e)}ArrayBuffer.prototype.slice=function(n,r){var o,i,a,s,u=this.byteLength,c=e(n,u),f=u;return r!==t&&(f=e(r,u)),c>f?new ArrayBuffer(0):(o=f-c,i=new ArrayBuffer(o),a=new Uint8Array(i),s=new Uint8Array(this,c,o),a.set(s),i)}}(),c.prototype.append=function(t){return this.appendBinary(s(t)),this},c.prototype.appendBinary=function(t){this._buff+=t,this._length+=t.length;var r,o=this._buff.length;for(r=64;r<=o;r+=64)e(this._hash,n(this._buff.substring(r-64,r)));return this._buff=this._buff.substring(r-64),this},c.prototype.end=function(t){var e,n,r=this._buff,o=r.length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<o;e+=1)i[e>>2]|=r.charCodeAt(e)<<(e%4<<3);return this._finish(i,o),n=a(this._hash),t&&(n=u(n)),this.reset(),n},c.prototype.reset=function(){return this._buff="",this._length=0,this._hash=[1732584193,-271733879,-1732584194,271733878],this},c.prototype.getState=function(){return{buff:this._buff,length:this._length,hash:this._hash}},c.prototype.setState=function(t){return this._buff=t.buff,this._length=t.length,this._hash=t.hash,this},c.prototype.destroy=function(){delete this._hash,delete this._buff,delete this._length},c.prototype._finish=function(t,n){var r,o,i,a=n;if(t[a>>2]|=128<<(a%4<<3),a>55)for(e(this._hash,t),a=0;a<16;a+=1)t[a]=0;r=(r=8*this._length).toString(16).match(/(.*?)(.{0,8})$/),o=parseInt(r[2],16),i=parseInt(r[1],16)||0,t[14]=o,t[15]=i,e(this._hash,t)},c.hash=function(t,e){return c.hashBinary(s(t),e)},c.hashBinary=function(t,e){var n=a(o(t));return e?u(n):n},c.ArrayBuffer=function(){this.reset()},c.ArrayBuffer.prototype.append=function(t){var n,o=function(t,e,n){var r=new Uint8Array(t.byteLength+e.byteLength);return r.set(new Uint8Array(t)),r.set(new Uint8Array(e),t.byteLength),r}(this._buff.buffer,t),i=o.length;for(this._length+=t.byteLength,n=64;n<=i;n+=64)e(this._hash,r(o.subarray(n-64,n)));return this._buff=n-64<i?new Uint8Array(o.buffer.slice(n-64)):new Uint8Array(0),this},c.ArrayBuffer.prototype.end=function(t){var e,n,r=this._buff,o=r.length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<o;e+=1)i[e>>2]|=r[e]<<(e%4<<3);return this._finish(i,o),n=a(this._hash),t&&(n=u(n)),this.reset(),n},c.ArrayBuffer.prototype.reset=function(){return this._buff=new Uint8Array(0),this._length=0,this._hash=[1732584193,-271733879,-1732584194,271733878],this},c.ArrayBuffer.prototype.getState=function(){var t=c.prototype.getState.call(this);return t.buff=function(t){return String.fromCharCode.apply(null,new Uint8Array(t))}(t.buff),t},c.ArrayBuffer.prototype.setState=function(t){return t.buff=function(t,e){var n,r=t.length,o=new ArrayBuffer(r),i=new Uint8Array(o);for(n=0;n<r;n+=1)i[n]=t.charCodeAt(n);return i}(t.buff),c.prototype.setState.call(this,t)},c.ArrayBuffer.prototype.destroy=c.prototype.destroy,c.ArrayBuffer.prototype._finish=c.prototype._finish,c.ArrayBuffer.hash=function(t,n){var o=a(function(t){var n,o,i,a,s,u,c=t.length,f=[1732584193,-271733879,-1732584194,271733878];for(n=64;n<=c;n+=64)e(f,r(t.subarray(n-64,n)));for(o=(t=n-64<c?t.subarray(n-64):new Uint8Array(0)).length,i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],n=0;n<o;n+=1)i[n>>2]|=t[n]<<(n%4<<3);if(i[n>>2]|=128<<(n%4<<3),n>55)for(e(f,i),n=0;n<16;n+=1)i[n]=0;return a=(a=8*c).toString(16).match(/(.*?)(.{0,8})$/),s=parseInt(a[2],16),u=parseInt(a[1],16)||0,i[14]=s,i[15]=u,e(f,i),f}(new Uint8Array(t)));return n?u(o):o},c}()}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.UploadManager=void 0;var o=r(n(18)),i=r(n(34)),a=r(n(17)),s=n(12),u=n(93);e.UploadManager=function(){function t(e,n,r){var o=this;(0,a.default)(this,t),this.config=(0,i.default)({useCdnDomain:!0,disableStatisticsReport:!1,retryCount:3,checkByMD5:!1,uphost:null,forceDirect:!1,concurrentRequestLimit:3,region:null},e.config),this.putExtra=(0,i.default)({fname:"",params:{},mimeType:null},e.putExtra),this.statisticsLogger=r,this.progress=null,this.xhrList=[],this.xhrHandler=function(t){return o.xhrList.push(t)},this.aborted=!1,this.file=e.file,this.key=e.key,this.token=e.token,this.onData=function(){},this.onError=function(){},this.onComplete=function(){},this.retryCount=0,(0,i.default)(this,n)}return t.prototype.putFile=function(){var t=this;if(this.aborted=!1,this.putExtra.fname||(this.putExtra.fname=this.file.name),!this.putExtra.mimeType||!this.putExtra.mimeType.length||(0,s.isContainFileMimeType)(this.file.type,this.putExtra.mimeType)){var e=(0,s.getUploadUrl)(this.config,this.token).then(function(e){return t.uploadUrl=e,t.uploadAt=(new Date).getTime(),t.config.forceDirect?t.directUpload():t.file.size>4194304?t.resumeUpload():t.directUpload()});return e.then(function(e){t.onComplete(e.data),t.config.disableStatisticsReport||t.sendLog(e.reqId,200)},function(e){if(t.clear(),e.isRequestError&&!t.config.disableStatisticsReport){var n=t.aborted?"":e.reqId,r=t.aborted?-2:e.code;t.sendLog(n,r)}var o=e.isRequestError&&0===e.code&&!t.aborted,i=++t.retryCount<=t.config.retryCount;o&&i?t.putFile():t.onError(e)}),e}var n=new Error("file type doesn't match with what you specify");this.onError(n)},t.prototype.clear=function(){this.xhrList.forEach(function(t){return t.abort()}),this.xhrList=[]},t.prototype.stop=function(){this.clear(),this.aborted=!0},t.prototype.sendLog=function(t,e){this.statisticsLogger.log({code:e,reqId:t,host:(0,s.getDomainFromUrl)(this.uploadUrl),remoteIp:"",port:(0,s.getPortFromUrl)(this.uploadUrl),duration:((new Date).getTime()-this.uploadAt)/1e3,time:Math.floor(this.uploadAt/1e3),bytesSent:this.progress?this.progress.total.loaded:0,upType:"jssdk-h5",size:this.file.size},this.token)},t.prototype.directUpload=function(){var t=this,e=new FormData;return e.append("file",this.file),e.append("token",this.token),null!=this.key&&e.append("key",this.key),e.append("fname",this.putExtra.fname),(0,s.filterParams)(this.putExtra.params).forEach(function(t){return e.append(t[0],t[1])}),(0,s.request)(this.uploadUrl,{method:"POST",body:e,onProgress:function(e){t.updateDirectProgress(e.loaded,e.total)},onCreate:this.xhrHandler}).then(function(e){return t.finishDirectProgress(),e})},t.prototype.resumeUpload=function(){var t=this;this.loaded={mkFileProgress:0,chunks:null},this.ctxList=[],this.localInfo=(0,s.getLocalFileInfo)(this.file),this.chunks=(0,s.getChunks)(this.file,4194304),this.initChunksProgress();var e=new u.Pool(function(e){return t.uploadChunk(e)},this.config.concurrentRequestLimit),n=this.chunks.map(function(t,n){return e.enqueue({chunk:t,index:n})}),r=o.default.all(n).then(function(){return t.mkFileReq()});return r.then(function(e){(0,s.removeLocalFileInfo)(t.file)},function(e){701!==e.code||(0,s.removeLocalFileInfo)(t.file)}),r},t.prototype.uploadChunk=function(t){var e=this,n=t.index,r=t.chunk,i=this.localInfo[n],a=this.uploadUrl+"/mkblk/"+r.size,u=i&&!(0,s.isChunkExpired)(i.time),c=this.config.checkByMD5,f=function(){return e.updateChunkProgress(r.size,n),e.ctxList[n]={ctx:i.ctx,size:i.size,time:i.time,md5:i.md5},o.default.resolve(null)};return u&&!c?f():(0,s.computeMd5)(r).then(function(t){if(u&&t===i.md5)return f();var o=(0,s.getHeadersForChunkUpload)(e.token),c=function(t){e.updateChunkProgress(t.loaded,n)},l=e.xhrHandler;return(0,s.request)(a,{method:"POST",headers:o,body:r,onProgress:c,onCreate:l}).then(function(o){c({loaded:r.size}),e.ctxList[n]={time:(new Date).getTime(),ctx:o.data.ctx,size:r.size,md5:t},(0,s.setLocalFileInfo)(e.file,e.ctxList)})})},t.prototype.mkFileReq=function(){var t=this,e=(0,i.default)({mimeType:"application/octet-stream"},this.putExtra),n=(0,s.createMkFileUrl)(this.uploadUrl,this.file,this.key,e),r=this.ctxList.map(function(t){return t.ctx}).join(","),a=(0,s.getHeadersForMkFile)(this.token),u=this.xhrHandler;return(0,s.request)(n,{method:"POST",body:r,headers:a,onCreate:u}).then(function(e){return t.updateMkFileProgress(1),o.default.resolve(e)})},t.prototype.updateDirectProgress=function(t,e){this.progress={total:this.getProgressInfoItem(t,e+1)},this.onData(this.progress)},t.prototype.finishDirectProgress=function(){if(!this.progress)return this.progress={total:this.getProgressInfoItem(this.file.size,this.file.size)},void this.onData(this.progress);var t=this.progress.total;this.progress={total:this.getProgressInfoItem(t.loaded+1,t.size)},this.onData(this.progress)},t.prototype.initChunksProgress=function(){this.loaded.chunks=this.chunks.map(function(t){return 0}),this.notifyResumeProgress()},t.prototype.updateChunkProgress=function(t,e){this.loaded.chunks[e]=t,this.notifyResumeProgress()},t.prototype.updateMkFileProgress=function(t){this.loaded.mkFileProgress=t,this.notifyResumeProgress()},t.prototype.notifyResumeProgress=function(){var t=this;this.progress={total:this.getProgressInfoItem((0,s.sum)(this.loaded.chunks)+this.loaded.mkFileProgress,this.file.size+1),chunks:this.chunks.map(function(e,n){return t.getProgressInfoItem(t.loaded.chunks[n],e.size)})},this.onData(this.progress)},t.prototype.getProgressInfoItem=function(t,e){return{loaded:t,size:e,percent:t/e*100}},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.Pool=void 0;var o=r(n(18)),i=r(n(17));e.Pool=function(){function t(e,n){(0,i.default)(this,t),this.runTask=e,this.queue=[],this.processing=[],this.limit=n}return t.prototype.enqueue=function(t){var e=this;return new o.default(function(n,r){e.queue.push({task:t,resolve:n,reject:r}),e.check()})},t.prototype.run=function(t){var e=this;this.queue=this.queue.filter(function(e){return e!==t}),this.processing.push(t),this.runTask(t.task).then(function(){e.processing=e.processing.filter(function(e){return e!==t}),t.resolve(),e.check()},function(e){return t.reject(e)})},t.prototype.check=function(){var t=this,e=this.processing.length,n=this.limit-e;this.queue.slice(0,n).forEach(function(e,n){t.run(e)})},t}()},function(t,e,n){"use strict";function r(t,e){return t=encodeURIComponent(t),"/"!==e.slice(e.length-1)&&(e+="/"),e+t}function o(t,e,n){if(!/^\d$/.test(t.mode))throw"mode should be number in imageView2";var o=t.mode,i=t.w,a=t.h,s=t.q,u=t.format;if(!i&&!a)throw"param w and h is empty in imageView2";var c="imageView2/"+encodeURIComponent(o);return c+=i?"/w/"+encodeURIComponent(i):"",c+=a?"/h/"+encodeURIComponent(a):"",c+=s?"/q/"+encodeURIComponent(s):"",c+=u?"/format/"+encodeURIComponent(u):"",e&&(c=r(e,n)+"?"+c),c}function i(t,e,n){var o=t["auto-orient"],i=t.thumbnail,a=t.strip,s=t.gravity,u=t.crop,c=t.quality,f=t.rotate,l=t.format,h=t.blur,p="imageMogr2";return p+=o?"/auto-orient":"",p+=i?"/thumbnail/"+encodeURIComponent(i):"",p+=a?"/strip":"",p+=s?"/gravity/"+encodeURIComponent(s):"",p+=c?"/quality/"+encodeURIComponent(c):"",p+=u?"/crop/"+encodeURIComponent(u):"",p+=f?"/rotate/"+encodeURIComponent(f):"",p+=l?"/format/"+encodeURIComponent(l):"",p+=h?"/blur/"+encodeURIComponent(h):"",e&&(p=r(e,n)+"?"+p),p}function a(t,e,n){var o=t.mode;if(!o)throw"mode can't be empty in watermark";var i="watermark/"+o;if(1!==o&&2!==o)throw"mode is wrong";if(1===o){var a=t.image;if(!a)throw"image can't be empty in watermark";i+=a?"/image/"+(0,u.urlSafeBase64Encode)(a):""}if(2===o){var s=t.text,c=t.font,f=t.fontsize,l=t.fill;if(!s)throw"text can't be empty in watermark";i+=s?"/text/"+(0,u.urlSafeBase64Encode)(s):"",i+=c?"/font/"+(0,u.urlSafeBase64Encode)(c):"",i+=f?"/fontsize/"+f:"",i+=l?"/fill/"+(0,u.urlSafeBase64Encode)(l):""}var h=t.dissolve,p=t.gravity,d=t.dx,g=t.dy;return i+=h?"/dissolve/"+encodeURIComponent(h):"",i+=p?"/gravity/"+encodeURIComponent(p):"",i+=d?"/dx/"+encodeURIComponent(d):"",i+=g?"/dy/"+encodeURIComponent(g):"",e&&(i=r(e,n)+"?"+i),i}e.__esModule=!0,e.imageView2=o,e.imageMogr2=i,e.watermark=a,e.imageInfo=function(t,e){var n=r(t,e)+"?imageInfo";return(0,s.request)(n,{method:"GET"})},e.exif=function(t,e){var n=r(t,e)+"?exif";return(0,s.request)(n,{method:"GET"})},e.pipeline=function(t,e,n){var s=void 0,u=void 0,c="";if("[object Array]"===Object.prototype.toString.call(t)){for(var f=0,l=t.length;f<l;f++){if(!(s=t[f]).fop)throw"fop can't be empty in pipeline";switch(s.fop){case"watermark":c+=a(s)+"|";break;case"imageView2":c+=o(s)+"|";break;case"imageMogr2":c+=i(s)+"|";break;default:u=!0}if(u)throw"fop is wrong in pipeline"}if(e){var h=(c=r(e,n)+"?"+c).length;"|"===c.slice(h-1)&&(c=c.slice(0,h-1))}return c}throw"pipeline's first param should be array"};var s=n(12),u=n(56)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.Observable=void 0;var o=r(n(96)),i=r(n(17));e.Observable=function(){function t(e){(0,i.default)(this,t),this.subscribeAction=e}return t.prototype.subscribe=function(t,e,n){var r=new a(t,e,n),o=this.subscribeAction(r);return new s(r,o)},t}();var a=function(){function t(e,n,r){(0,i.default)(this,t),this.isStopped=!1,"object"===(void 0===e?"undefined":(0,o.default)(e))?(this._onNext=e.next,this._onError=e.error,this._onCompleted=e.complete):(this._onNext=e,this._onError=n,this._onCompleted=r)}return t.prototype.next=function(t){!this.isStopped&&this._onNext&&this._onNext(t)},t.prototype.error=function(t){!this.isStopped&&this._onError&&(this.isStopped=!0,this._onError(t))},t.prototype.complete=function(t){!this.isStopped&&this._onCompleted&&(this.isStopped=!0,this._onCompleted(t))},t}(),s=function(){function t(e,n){(0,i.default)(this,t),this.observer=e,this.result=n}return t.prototype.unsubscribe=function(){this.observer.isStopped=!0,this.result()},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=r(n(97)),i=r(n(99)),a="function"==typeof i.default&&"symbol"==typeof o.default?function(t){return typeof t}:function(t){return t&&"function"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?"symbol":typeof t};e.default="function"==typeof i.default&&"symbol"===a(o.default)?function(t){return void 0===t?"undefined":a(t)}:function(t){return t&&"function"==typeof i.default&&t.constructor===i.default&&t!==i.default.prototype?"symbol":void 0===t?"undefined":a(t)}},function(t,e,n){t.exports={default:n(98),__esModule:!0}},function(t,e,n){n(41),n(50),t.exports=n(37).f("iterator")},function(t,e,n){t.exports={default:n(100),__esModule:!0}},function(t,e,n){n(101),n(40),n(107),n(108),t.exports=n(1).Symbol},function(t,e,n){"use strict";var r=n(0),o=n(9),i=n(4),a=n(5),s=n(44),u=n(102).KEY,c=n(10),f=n(31),l=n(23),h=n(22),p=n(2),d=n(37),g=n(38),m=n(103),v=n(104),y=n(3),b=n(8),w=n(24),x=n(11),S=n(29),P=n(21),_=n(45),C=n(105),U=n(106),F=n(35),I=n(7),k=n(15),E=U.f,M=I.f,O=C.f,T=r.Symbol,R=r.JSON,A=R&&R.stringify,L=p("_hidden"),D=p("toPrimitive"),j={}.propertyIsEnumerable,B=f("symbol-registry"),G=f("symbols"),q=f("op-symbols"),N=Object.prototype,z="function"==typeof T&&!!F.f,H=r.QObject,V=!H||!H.prototype||!H.prototype.findChild,W=i&&c(function(){return 7!=_(M({},"a",{get:function(){return M(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=E(N,e);r&&delete N[e],M(t,e,n),r&&t!==N&&M(N,e,r)}:M,J=function(t){var e=G[t]=_(T.prototype);return e._k=t,e},X=z&&"symbol"==typeof T.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof T},Y=function(t,e,n){return t===N&&Y(q,e,n),y(t),e=S(e,!0),y(n),o(G,e)?(n.enumerable?(o(t,L)&&t[L][e]&&(t[L][e]=!1),n=_(n,{enumerable:P(0,!1)})):(o(t,L)||M(t,L,P(1,{})),t[L][e]=!0),W(t,e,n)):M(t,e,n)},K=function(t,e){y(t);for(var n,r=m(e=x(e)),o=0,i=r.length;i>o;)Y(t,n=r[o++],e[n]);return t},$=function(t){var e=j.call(this,t=S(t,!0));return!(this===N&&o(G,t)&&!o(q,t))&&(!(e||!o(this,t)||!o(G,t)||o(this,L)&&this[L][t])||e)},Q=function(t,e){if(t=x(t),e=S(e,!0),t!==N||!o(G,e)||o(q,e)){var n=E(t,e);return!n||!o(G,e)||o(t,L)&&t[L][e]||(n.enumerable=!0),n}},Z=function(t){for(var e,n=O(x(t)),r=[],i=0;n.length>i;)o(G,e=n[i++])||e==L||e==u||r.push(e);return r},tt=function(t){for(var e,n=t===N,r=O(n?q:x(t)),i=[],a=0;r.length>a;)!o(G,e=r[a++])||n&&!o(N,e)||i.push(G[e]);return i};z||(s((T=function(){if(this instanceof T)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),e=function(n){this===N&&e.call(q,n),o(this,L)&&o(this[L],t)&&(this[L][t]=!1),W(this,t,P(1,n))};return i&&V&&W(N,t,{configurable:!0,set:e}),J(t)}).prototype,"toString",function(){return this._k}),U.f=Q,I.f=Y,n(57).f=C.f=Z,n(25).f=$,F.f=tt,i&&!n(13)&&s(N,"propertyIsEnumerable",$,!0),d.f=function(t){return J(p(t))}),a(a.G+a.W+a.F*!z,{Symbol:T});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)p(et[nt++]);for(var rt=k(p.store),ot=0;rt.length>ot;)g(rt[ot++]);a(a.S+a.F*!z,"Symbol",{for:function(t){return o(B,t+="")?B[t]:B[t]=T(t)},keyFor:function(t){if(!X(t))throw TypeError(t+" is not a symbol!");for(var e in B)if(B[e]===t)return e},useSetter:function(){V=!0},useSimple:function(){V=!1}}),a(a.S+a.F*!z,"Object",{create:function(t,e){return void 0===e?_(t):K(_(t),e)},defineProperty:Y,defineProperties:K,getOwnPropertyDescriptor:Q,getOwnPropertyNames:Z,getOwnPropertySymbols:tt});var it=c(function(){F.f(1)});a(a.S+a.F*it,"Object",{getOwnPropertySymbols:function(t){return F.f(w(t))}}),R&&a(a.S+a.F*(!z||c(function(){var t=T();return"[null]"!=A([t])||"{}"!=A({a:t})||"{}"!=A(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(b(e)||void 0!==t)&&!X(t))return v(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!X(e))return e}),r[1]=e,A.apply(R,r)}}),T.prototype[D]||n(6)(T.prototype,D,T.prototype.valueOf),l(T,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,e,n){var r=n(22)("meta"),o=n(8),i=n(9),a=n(7).f,s=0,u=Object.isExtensible||function(){return!0},c=!n(10)(function(){return u(Object.preventExtensions({}))}),f=function(t){a(t,r,{value:{i:"O"+ ++s,w:{}}})},l=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!u(t))return"F";if(!e)return"E";f(t)}return t[r].i},getWeak:function(t,e){if(!i(t,r)){if(!u(t))return!0;if(!e)return!1;f(t)}return t[r].w},onFreeze:function(t){return c&&l.NEED&&u(t)&&!i(t,r)&&f(t),t}}},function(t,e,n){var r=n(15),o=n(35),i=n(25);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,s=n(t),u=i.f,c=0;s.length>c;)u.call(t,a=s[c++])&&e.push(a);return e}},function(t,e,n){var r=n(16);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(11),o=n(57).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?function(t){try{return o(t)}catch(t){return a.slice()}}(t):o(r(t))}},function(t,e,n){var r=n(25),o=n(21),i=n(11),a=n(29),s=n(9),u=n(43),c=Object.getOwnPropertyDescriptor;e.f=n(4)?c:function(t,e){if(t=i(t),e=a(e,!0),u)try{return c(t,e)}catch(t){}if(s(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){n(38)("asyncIterator")},function(t,e,n){n(38)("observable")},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.StatisticsLogger=void 0;var o=r(n(36)),i=r(n(17)),a=n(12);e.StatisticsLogger=function(){function t(){(0,i.default)(this,t)}return t.prototype.log=function(t,e){var n="";(0,o.default)(t).forEach(function(e){return n+=t[e]+","}),this.send(n,e,0)},t.prototype.send=function(t,e,n){var r=(0,a.createXHR)(),o=this;r.open("POST","https://uplog.qbox.me/log/3"),r.setRequestHeader("Content-type","application/x-www-form-urlencoded"),r.setRequestHeader("Authorization","UpToken "+e),r.onreadystatechange=function(){4===r.readyState&&200!==r.status&&++n<=3&&o.send(t,e,n)},r.send(t)},t}()},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=r(n(18)),i=r(n(34)),a=r(n(17)),s=r(n(36)),u=n(111),c=n(12),f={PNG:"image/png",JPEG:"image/jpeg",WEBP:"image/webp",BMP:"image/bmp"},l=Math.log(2),h=(0,s.default)(f).map(function(t){return f[t]}),p=f.JPEG,d=function(){function t(e,n){(0,a.default)(this,t),this.config=(0,i.default)({quality:.92,noCompressIfLarger:!1},n),this.file=e}return t.prototype.process=function(){var t=this;this.outputType=this.file.type;var e={};return function(t){return h.includes(t)}(this.file.type)?this.getOriginImage().then(function(e){return t.getCanvas(e)}).then(function(n){var r=1;return t.config.maxWidth&&(r=Math.min(1,t.config.maxWidth/n.width)),t.config.maxHeight&&(r=Math.min(1,r,t.config.maxHeight/n.height)),e.width=n.width,e.height=n.height,t.doScale(n,r)}).then(function(n){var r=t.toBlob(n);return r.size>t.file.size&&t.config.noCompressIfLarger?{dist:t.file,width:e.width,height:e.height}:{dist:r,width:n.width,height:n.height}}):o.default.reject(new Error("unsupported file type: "+this.file.type))},t.prototype.clear=function(t,e,n){this.outputType===p?(t.fillStyle="#fff",t.fillRect(0,0,e,n)):t.clearRect(0,0,e,n)},t.prototype.getOriginImage=function(){var t=this;return new o.default(function(e,n){var r=(0,c.createObjectURL)(t.file),o=new Image;o.onload=function(){e(o)},o.onerror=function(){n("image load error")},o.src=r})},t.prototype.getCanvas=function(t){var e=this;return new o.default(function(n,r){u.EXIF.getData(t,function(){var r=u.EXIF.getTag(t,"Orientation")||1,o=(0,c.getTransform)(t,r),i=o.width,a=o.height,s=o.matrix,f=document.createElement("canvas"),l=f.getContext("2d");f.width=i,f.height=a,e.clear(l,i,a),l.transform.apply(l,s),l.drawImage(t,0,0),n(f)})})},t.prototype.doScale=function(t,e){if(1===e)return o.default.resolve(t);var n=t.getContext("2d"),r=Math.min(4,Math.ceil(1/e/l)),i=Math.pow(e,1/r),a=document.createElement("canvas"),s=a.getContext("2d"),u=t.width,c=t.height,f=u,h=c;a.width=u,a.height=c;for(var p=void 0,d=void 0,g=0;g<r;g++){var m=u*i|0,v=c*i|0;g===r-1&&(m=f*e,v=h*e),g%2==0?(p=t,d=s):(p=a,d=n),this.clear(d,u,c),d.drawImage(p,0,0,u,c,0,0,m,v),u=m,c=v}var y=p===t?a:t,b=d.getImageData(0,0,u,c);return y.width=u,y.height=c,d.putImageData(b,0,0),o.default.resolve(y)},t.prototype.toBlob=function(t){var e=t.toDataURL(this.outputType,this.config.quality),n=atob(e.split(",")[1]).split("").map(function(t){return t.charCodeAt(0)});return new Blob([new Uint8Array(n)],{type:this.outputType})},t}();e.default=function(t,e){return new d(t,e).process()}},function(t,e,r){var o;(function(){function r(t){return!!t.exifdata}function i(t,e){function n(n){var r=a(n);t.exifdata=r||{};var o=function(t){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n=2,r=t.byteLength;n<r;){if(function(t,e){return 56===t.getUint8(e)&&66===t.getUint8(e+1)&&73===t.getUint8(e+2)&&77===t.getUint8(e+3)&&4===t.getUint8(e+4)&&4===t.getUint8(e+5)}(e,n)){var o=e.getUint8(n+7);o%2!=0&&(o+=1),0===o&&(o=4);return s(t,n+8+o,e.getUint16(n+6+o))}n++}}(n);if(t.iptcdata=o||{},g.isXmpEnabled){var i=function(t){if("DOMParser"in self){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n=2,r=t.byteLength,o=new DOMParser;n<r-4;){if("http"==f(e,n,4)){var i=n-1,a=e.getUint16(n-2)-1,s=f(e,i,a),u=s.indexOf("xmpmeta>")+8,c=(s=s.substring(s.indexOf("<x:xmpmeta"),u)).indexOf("x:xmpmeta")+10;s=s.slice(0,c)+'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:tiff="http://ns.adobe.com/tiff/1.0/" xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" xmlns:exif="http://ns.adobe.com/exif/1.0/" xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '+s.slice(c);return p(o.parseFromString(s,"text/xml"))}n++}}}(n);t.xmpdata=i||{}}e&&e.call(t)}if(t.src)if(/^data\:/i.test(t.src))n(function(t,e){e=e||t.match(/^data\:([^\;]+)\;base64,/im)[1]||"",t=t.replace(/^data\:([^\;]+)\;base64,/gim,"");for(var n=atob(t),r=n.length,o=new ArrayBuffer(r),i=new Uint8Array(o),a=0;a<r;a++)i[a]=n.charCodeAt(a);return o}(t.src));else if(/^blob\:/i.test(t.src))(o=new FileReader).onload=function(t){n(t.target.result)},function(t,e){var n=new XMLHttpRequest;n.open("GET",t,!0),n.responseType="blob",n.onload=function(t){200!=this.status&&0!==this.status||e(this.response)},n.send()}(t.src,function(t){o.readAsArrayBuffer(t)});else{var r=new XMLHttpRequest;r.onload=function(){if(200!=this.status&&0!==this.status)throw"Could not load image";n(r.response),r=null},r.open("GET",t.src,!0),r.responseType="arraybuffer",r.send(null)}else if(self.FileReader&&(t instanceof self.Blob||t instanceof self.File)){var o;(o=new FileReader).onload=function(t){d&&console.log("Got file of length "+t.target.result.byteLength),n(t.target.result)},o.readAsArrayBuffer(t)}}function a(t){var e=new DataView(t);if(d&&console.log("Got file of length "+t.byteLength),255!=e.getUint8(0)||216!=e.getUint8(1))return d&&console.log("Not a valid JPEG"),!1;for(var n,r=2,o=t.byteLength;r<o;){if(255!=e.getUint8(r))return d&&console.log("Not a valid marker at offset "+r+", found: "+e.getUint8(r)),!1;if(n=e.getUint8(r+1),d&&console.log(n),225==n)return d&&console.log("Found 0xFFE1 marker"),l(e,r+4,e.getUint16(r+2));r+=2+e.getUint16(r+2)}}function s(t,e,n){for(var r,o,i,a,s=new DataView(t),u={},c=e;c<e+n;)28===s.getUint8(c)&&2===s.getUint8(c+1)&&(a=s.getUint8(c+2))in x&&(i=s.getInt16(c+3),o=x[a],r=f(s,c+5,i),u.hasOwnProperty(o)?u[o]instanceof Array?u[o].push(r):u[o]=[u[o],r]:u[o]=r),c++;return u}function u(t,e,n,r,o){var i,a,s,u=t.getUint16(n,!o),f={};for(s=0;s<u;s++)i=n+12*s+2,!(a=r[t.getUint16(i,!o)])&&d&&console.log("Unknown tag: "+t.getUint16(i,!o)),f[a]=c(t,i,e,n,o);return f}function c(t,e,n,r,o){var i,a,s,u,c,l,h=t.getUint16(e+2,!o),p=t.getUint32(e+4,!o),d=t.getUint32(e+8,!o)+n;switch(h){case 1:case 7:if(1==p)return t.getUint8(e+8,!o);for(i=p>4?d:e+8,a=[],u=0;u<p;u++)a[u]=t.getUint8(i+u);return a;case 2:return f(t,i=p>4?d:e+8,p-1);case 3:if(1==p)return t.getUint16(e+8,!o);for(i=p>2?d:e+8,a=[],u=0;u<p;u++)a[u]=t.getUint16(i+2*u,!o);return a;case 4:if(1==p)return t.getUint32(e+8,!o);for(a=[],u=0;u<p;u++)a[u]=t.getUint32(d+4*u,!o);return a;case 5:if(1==p)return c=t.getUint32(d,!o),l=t.getUint32(d+4,!o),(s=new Number(c/l)).numerator=c,s.denominator=l,s;for(a=[],u=0;u<p;u++)c=t.getUint32(d+8*u,!o),l=t.getUint32(d+4+8*u,!o),a[u]=new Number(c/l),a[u].numerator=c,a[u].denominator=l;return a;case 9:if(1==p)return t.getInt32(e+8,!o);for(a=[],u=0;u<p;u++)a[u]=t.getInt32(d+4*u,!o);return a;case 10:if(1==p)return t.getInt32(d,!o)/t.getInt32(d+4,!o);for(a=[],u=0;u<p;u++)a[u]=t.getInt32(d+8*u,!o)/t.getInt32(d+4+8*u,!o);return a}}function f(t,e,r){var o="";for(n=e;n<e+r;n++)o+=String.fromCharCode(t.getUint8(n));return o}function l(t,e){if("Exif"!=f(t,e,4))return d&&console.log("Not valid EXIF data! "+f(t,e,4)),!1;var n,r,o,i,a,s=e+6;if(18761==t.getUint16(s))n=!1;else{if(19789!=t.getUint16(s))return d&&console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"),!1;n=!0}if(42!=t.getUint16(s+2,!n))return d&&console.log("Not valid TIFF data! (no 0x002A)"),!1;var c=t.getUint32(s+4,!n);if(c<8)return d&&console.log("Not valid TIFF data! (First offset less than 8)",t.getUint32(s+4,!n)),!1;if((r=u(t,s,s+c,v,n)).ExifIFDPointer)for(o in i=u(t,s,s+r.ExifIFDPointer,m,n)){switch(o){case"LightSource":case"Flash":case"MeteringMode":case"ExposureProgram":case"SensingMethod":case"SceneCaptureType":case"SceneType":case"CustomRendered":case"WhiteBalance":case"GainControl":case"Contrast":case"Saturation":case"Sharpness":case"SubjectDistanceRange":case"FileSource":i[o]=w[o][i[o]];break;case"ExifVersion":case"FlashpixVersion":i[o]=String.fromCharCode(i[o][0],i[o][1],i[o][2],i[o][3]);break;case"ComponentsConfiguration":i[o]=w.Components[i[o][0]]+w.Components[i[o][1]]+w.Components[i[o][2]]+w.Components[i[o][3]]}r[o]=i[o]}if(r.GPSInfoIFDPointer)for(o in a=u(t,s,s+r.GPSInfoIFDPointer,y,n)){switch(o){case"GPSVersionID":a[o]=a[o][0]+"."+a[o][1]+"."+a[o][2]+"."+a[o][3]}r[o]=a[o]}return r.thumbnail=function(t,e,n,r){var o=function(t,e,n){var r=t.getUint16(e,!n);return t.getUint32(e+2+12*r,!n)}(t,e+n,r);if(!o)return{};if(o>t.byteLength)return{};var i=u(t,e,e+o,b,r);if(i.Compression)switch(i.Compression){case 6:if(i.JpegIFOffset&&i.JpegIFByteCount){var a=e+i.JpegIFOffset,s=i.JpegIFByteCount;i.blob=new Blob([new Uint8Array(t.buffer,a,s)],{type:"image/jpeg"})}break;case 1:console.log("Thumbnail image format is TIFF, which is not implemented.");break;default:console.log("Unknown thumbnail image format '%s'",i.Compression)}else 2==i.PhotometricInterpretation&&console.log("Thumbnail image format is RGB, which is not implemented.");return i}(t,s,c,n),r}function h(t){var e={};if(1==t.nodeType){if(t.attributes.length>0){e["@attributes"]={};for(var n=0;n<t.attributes.length;n++){var r=t.attributes.item(n);e["@attributes"][r.nodeName]=r.nodeValue}}}else if(3==t.nodeType)return t.nodeValue;if(t.hasChildNodes())for(var o=0;o<t.childNodes.length;o++){var i=t.childNodes.item(o),a=i.nodeName;if(null==e[a])e[a]=h(i);else{if(null==e[a].push){var s=e[a];e[a]=[],e[a].push(s)}e[a].push(h(i))}}return e}function p(t){try{var e={};if(t.children.length>0)for(var n=0;n<t.children.length;n++){var r=t.children.item(n),o=r.attributes;for(var i in o){var a=o[i],s=a.nodeName,u=a.nodeValue;void 0!==s&&(e[s]=u)}var c=r.nodeName;if(void 0===e[c])e[c]=h(r);else{if(void 0===e[c].push){var f=e[c];e[c]=[],e[c].push(f)}e[c].push(h(r))}}else e=t.textContent;return e}catch(t){console.log(t.message)}}var d=!1,g=function(t){return t instanceof g?t:this instanceof g?void(this.EXIFwrapped=t):new g(t)};void 0!==t&&t.exports&&(e=t.exports=g),e.EXIF=g;var m=g.Tags={36864:"ExifVersion",40960:"FlashpixVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",37121:"ComponentsConfiguration",37122:"CompressedBitsPerPixel",37500:"MakerNote",37510:"UserComment",40964:"RelatedSoundFile",36867:"DateTimeOriginal",36868:"DateTimeDigitized",37520:"SubsecTime",37521:"SubsecTimeOriginal",37522:"SubsecTimeDigitized",33434:"ExposureTime",33437:"FNumber",34850:"ExposureProgram",34852:"SpectralSensitivity",34855:"ISOSpeedRatings",34856:"OECF",37377:"ShutterSpeedValue",37378:"ApertureValue",37379:"BrightnessValue",37380:"ExposureBias",37381:"MaxApertureValue",37382:"SubjectDistance",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37396:"SubjectArea",37386:"FocalLength",41483:"FlashEnergy",41484:"SpatialFrequencyResponse",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41492:"SubjectLocation",41493:"ExposureIndex",41495:"SensingMethod",41728:"FileSource",41729:"SceneType",41730:"CFAPattern",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41988:"DigitalZoomRation",41989:"FocalLengthIn35mmFilm",41990:"SceneCaptureType",41991:"GainControl",41992:"Contrast",41993:"Saturation",41994:"Sharpness",41995:"DeviceSettingDescription",41996:"SubjectDistanceRange",40965:"InteroperabilityIFDPointer",42016:"ImageUniqueID"},v=g.TiffTags={256:"ImageWidth",257:"ImageHeight",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer",40965:"InteroperabilityIFDPointer",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",274:"Orientation",277:"SamplesPerPixel",284:"PlanarConfiguration",530:"YCbCrSubSampling",531:"YCbCrPositioning",282:"XResolution",283:"YResolution",296:"ResolutionUnit",273:"StripOffsets",278:"RowsPerStrip",279:"StripByteCounts",513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength",301:"TransferFunction",318:"WhitePoint",319:"PrimaryChromaticities",529:"YCbCrCoefficients",532:"ReferenceBlackWhite",306:"DateTime",270:"ImageDescription",271:"Make",272:"Model",305:"Software",315:"Artist",33432:"Copyright"},y=g.GPSTags={0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude",5:"GPSAltitudeRef",6:"GPSAltitude",7:"GPSTimeStamp",8:"GPSSatellites",9:"GPSStatus",10:"GPSMeasureMode",11:"GPSDOP",12:"GPSSpeedRef",13:"GPSSpeed",14:"GPSTrackRef",15:"GPSTrack",16:"GPSImgDirectionRef",17:"GPSImgDirection",18:"GPSMapDatum",19:"GPSDestLatitudeRef",20:"GPSDestLatitude",21:"GPSDestLongitudeRef",22:"GPSDestLongitude",23:"GPSDestBearingRef",24:"GPSDestBearing",25:"GPSDestDistanceRef",26:"GPSDestDistance",27:"GPSProcessingMethod",28:"GPSAreaInformation",29:"GPSDateStamp",30:"GPSDifferential"},b=g.IFD1Tags={256:"ImageWidth",257:"ImageHeight",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",273:"StripOffsets",274:"Orientation",277:"SamplesPerPixel",278:"RowsPerStrip",279:"StripByteCounts",282:"XResolution",283:"YResolution",284:"PlanarConfiguration",296:"ResolutionUnit",513:"JpegIFOffset",514:"JpegIFByteCount",529:"YCbCrCoefficients",530:"YCbCrSubSampling",531:"YCbCrPositioning",532:"ReferenceBlackWhite"},w=g.StringValues={ExposureProgram:{0:"Not defined",1:"Manual",2:"Normal program",3:"Aperture priority",4:"Shutter priority",5:"Creative program",6:"Action program",7:"Portrait mode",8:"Landscape mode"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{0:"Unknown",1:"Daylight",2:"Fluorescent",3:"Tungsten (incandescent light)",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 - 5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},SensingMethod:{1:"Not defined",2:"One-chip color area sensor",3:"Two-chip color area sensor",4:"Three-chip color area sensor",5:"Color sequential area sensor",7:"Trilinear sensor",8:"Color sequential linear sensor"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},SceneType:{1:"Directly photographed"},CustomRendered:{0:"Normal process",1:"Custom process"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},GainControl:{0:"None",1:"Low gain up",2:"High gain up",3:"Low gain down",4:"High gain down"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},SubjectDistanceRange:{0:"Unknown",1:"Macro",2:"Close view",3:"Distant view"},FileSource:{3:"DSC"},Components:{0:"",1:"Y",2:"Cb",3:"Cr",4:"R",5:"G",6:"B"}},x={120:"caption",110:"credit",25:"keywords",55:"dateCreated",80:"byline",85:"bylineTitle",122:"captionWriter",105:"headline",116:"copyright",15:"category"};g.enableXmp=function(){g.isXmpEnabled=!0},g.disableXmp=function(){g.isXmpEnabled=!1},g.getData=function(t,e){return!((self.Image&&t instanceof self.Image||self.HTMLImageElement&&t instanceof self.HTMLImageElement)&&!t.complete||(r(t)?e&&e.call(t):i(t,e),0))},g.getTag=function(t,e){if(r(t))return t.exifdata[e]},g.getIptcTag=function(t,e){if(r(t))return t.iptcdata[e]},g.getAllTags=function(t){if(!r(t))return{};var e,n=t.exifdata,o={};for(e in n)n.hasOwnProperty(e)&&(o[e]=n[e]);return o},g.getAllIptcTags=function(t){if(!r(t))return{};var e,n=t.iptcdata,o={};for(e in n)n.hasOwnProperty(e)&&(o[e]=n[e]);return o},g.pretty=function(t){if(!r(t))return"";var e,n=t.exifdata,o="";for(e in n)n.hasOwnProperty(e)&&("object"==typeof n[e]?n[e]instanceof Number?o+=e+" : "+n[e]+" ["+n[e].numerator+"/"+n[e].denominator+"]\r\n":o+=e+" : ["+n[e].length+" values]\r\n":o+=e+" : "+n[e]+"\r\n");return o},g.readFromBinaryFile=function(t){return a(t)},void 0===(o=function(){return g}.apply(e,[]))||(t.exports=o)}).call(this)}])});
//# sourceMappingURL=qiniu.min.js.map

/***/ }),

/***/ 55798:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 54087:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var now = __webpack_require__(75)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 29372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V4": () => (/* reexport */ CSSMotionList),
  "ZP": () => (/* binding */ rc_motion_es)
});

// UNUSED EXPORTS: Provider

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js
var findDOMNode = __webpack_require__(34203);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/context.js

var _excluded = (/* unused pure expression or super */ null && (["children"]));

var Context = /*#__PURE__*/react.createContext({});
function MotionProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: props
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(29388);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/DomWrapper.js





var DomWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DomWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(DomWrapper);
  function DomWrapper() {
    (0,classCallCheck/* default */.Z)(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(react.Component);
/* harmony default export */ const es_DomWrapper = (DomWrapper);
// EXTERNAL MODULE: ./node_modules/rc-util/es/index.js
var es = __webpack_require__(56790);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useState.js
var useState = __webpack_require__(30470);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useEvent.js
var useEvent = __webpack_require__(66680);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useSyncState.js



/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */
function useSyncState(defaultValue) {
  var _React$useReducer = react.useReducer(function (x) {
      return x + 1;
    }, 0),
    _React$useReducer2 = (0,slicedToArray/* default */.Z)(_React$useReducer, 2),
    forceUpdate = _React$useReducer2[1];
  var currentValueRef = react.useRef(defaultValue);
  var getValue = (0,useEvent/* default */.Z)(function () {
    return currentValueRef.current;
  });
  var setValue = (0,useEvent/* default */.Z)(function (updater) {
    currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue, setValue];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/interface.js
var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';
/**
 * Used for disabled motion case.
 * Prepare stage will still work but start & active will be skipped.
 */
var STEP_PREPARED = 'prepared';
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(98924);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/motion.js


// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };
  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }
    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes((0,canUseDom/* default */.Z)(), typeof window !== 'undefined' ? window : {});
var style = {};
if ((0,canUseDom/* default */.Z)()) {
  var _document$createEleme = document.createElement('div');
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if ((0,esm_typeof/* default */.Z)(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useDomMotionEvents.js



/* harmony default export */ const useDomMotionEvents = (function (onInternalMotionEnd) {
  var cacheElementRef = (0,react.useRef)();

  // Remove events
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }

  // Patch events
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);

      // Save as cache in case dom removed trigger by `motionDeadline`
      cacheElementRef.current = element;
    }
  }

  // Clean up when removed
  react.useEffect(function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js



// It's safe to use `useLayoutEffect` but the warning is annoying
var useIsomorphicLayoutEffect = (0,canUseDom/* default */.Z)() ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ const hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(75164);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useNextFrame.js


/* harmony default export */ const useNextFrame = (function () {
  var nextFrameRef = react.useRef(null);
  function cancelNextFrame() {
    raf/* default.cancel */.Z.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = (0,raf/* default */.Z)(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStepQueue.js






var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];

/** Skip current step */
var SkipStep = false;
/** Current step should be update in */
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
/* harmony default export */ const useStepQueue = (function (status, prepareOnly, callback) {
  var _useState = (0,useState/* default */.Z)(STEP_NONE),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useNextFrame = useNextFrame(),
    _useNextFrame2 = (0,slicedToArray/* default */.Z)(_useNextFrame, 2),
    nextFrame = _useNextFrame2[0],
    cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  hooks_useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);
      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else if (nextStep) {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  react.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStatus.js












function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
    motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
    _ref$motionAppear = _ref.motionAppear,
    motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
    _ref$motionLeave = _ref.motionLeave,
    motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
    motionDeadline = _ref.motionDeadline,
    motionLeaveImmediately = _ref.motionLeaveImmediately,
    onAppearPrepare = _ref.onAppearPrepare,
    onEnterPrepare = _ref.onEnterPrepare,
    onLeavePrepare = _ref.onLeavePrepare,
    onAppearStart = _ref.onAppearStart,
    onEnterStart = _ref.onEnterStart,
    onLeaveStart = _ref.onLeaveStart,
    onAppearActive = _ref.onAppearActive,
    onEnterActive = _ref.onEnterActive,
    onLeaveActive = _ref.onLeaveActive,
    onAppearEnd = _ref.onAppearEnd,
    onEnterEnd = _ref.onEnterEnd,
    onLeaveEnd = _ref.onLeaveEnd,
    onVisibleChanged = _ref.onVisibleChanged;
  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = (0,useState/* default */.Z)(),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    asyncVisible = _useState2[0],
    setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE),
    _useSyncState2 = (0,slicedToArray/* default */.Z)(_useSyncState, 2),
    getStatus = _useSyncState2[0],
    setStatus = _useSyncState2[1];
  var _useState3 = (0,useState/* default */.Z)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    style = _useState4[0],
    setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = (0,react.useRef)(false);
  var deadlineRef = (0,react.useRef)(null);

  // =========================== Dom Node ===========================
  function getDomElement() {
    return getElement();
  }

  // ========================== Motion End ==========================
  var activeRef = (0,react.useRef)(false);

  /**
   * Clean up status & style
   */
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = (0,es/* useEvent */.zX)(function (event) {
    var status = getStatus();
    // Do nothing since not in any transition status.
    // This may happen when `motionDeadline` trigger.
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }

    // Only update status when `canEnd` and not destroyed
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
    _useDomMotionEvents2 = (0,slicedToArray/* default */.Z)(_useDomMotionEvents, 1),
    patchMotionEvents = _useDomMotionEvents2[0];

  // ============================= Step =============================
  var getEventHandlers = function getEventHandlers(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = react.useMemo(function () {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function (newStep) {
      // Only prepare step can be skip
      if (newStep === STEP_PREPARE) {
        var onPrepare = eventHandlers[STEP_PREPARE];
        if (!onPrepare) {
          return SkipStep;
        }
        return onPrepare(getDomElement());
      }

      // Rest step is sync update
      if (step in eventHandlers) {
        var _eventHandlers$step;
        setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
      }
      if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
        // Patch events when motion needed
        patchMotionEvents(getDomElement());
        if (motionDeadline > 0) {
          clearTimeout(deadlineRef.current);
          deadlineRef.current = setTimeout(function () {
            onInternalMotionEnd({
              deadline: true
            });
          }, motionDeadline);
        }
      }
      if (step === STEP_PREPARED) {
        updateMotionEndStatus();
      }
      return DoStep;
    }),
    _useStepQueue2 = (0,slicedToArray/* default */.Z)(_useStepQueue, 2),
    startStep = _useStepQueue2[0],
    step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;

  // ============================ Status ============================
  // Update with new status
  hooks_useIsomorphicLayoutEffect(function () {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    // if (!supportMotion) {
    //   return;
    // }

    var nextStatus;

    // Appear
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }

    // Enter
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }

    // Leave
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);

    // Update to next status
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      // Set back in case no motion but prev status has prepare step
      setStatus(STATUS_NONE);
    }
  }, [visible]);

  // ============================ Effect ============================
  // Reset when motion changed
  (0,react.useEffect)(function () {
    if (
    // Cancel appear
    currentStatus === STATUS_APPEAR && !motionAppear ||
    // Cancel enter
    currentStatus === STATUS_ENTER && !motionEnter ||
    // Cancel leave
    currentStatus === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  (0,react.useEffect)(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);

  // Trigger `onVisibleChanged`
  var firstMountChangeRef = react.useRef(false);
  (0,react.useEffect)(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== undefined && currentStatus === STATUS_NONE) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);

  // ============================ Styles ============================
  var mergedStyle = style;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = (0,objectSpread2/* default */.Z)({
      transition: 'none'
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotion.js




/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */











/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  if ((0,esm_typeof/* default */.Z)(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /*#__PURE__*/react.forwardRef(function (props, ref) {
    var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      _props$removeOnLeave = props.removeOnLeave,
      removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
      forceRender = props.forceRender,
      children = props.children,
      motionName = props.motionName,
      leavedClassName = props.leavedClassName,
      eventProps = props.eventProps;
    var _React$useContext = react.useContext(Context),
      contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);

    // Ref to the react node, it may be a HTMLElement
    var nodeRef = (0,react.useRef)();
    // Ref to the dom wrapper in case ref can not pass to HTMLElement
    var wrapperNodeRef = (0,react.useRef)();
    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0,findDOMNode/* default */.ZP)(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
      _useStatus2 = (0,slicedToArray/* default */.Z)(_useStatus, 4),
      status = _useStatus2[0],
      statusStep = _useStatus2[1],
      statusStyle = _useStatus2[2],
      mergedVisible = _useStatus2[3];

    // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`
    var renderedRef = react.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }

    // ====================== Refs ======================
    var setNodeRef = react.useCallback(function (node) {
      nodeRef.current = node;
      (0,es_ref/* fillRef */.mH)(ref, node);
    }, [ref]);

    // ===================== Render =====================
    var motionChildren;
    var mergedProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, eventProps), {}, {
      visible: visible
    });
    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children((0,objectSpread2/* default */.Z)({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      // In motion
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, mergedProps), {}, {
        className: classnames_default()(getTransitionName(motionName, status), (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
        style: statusStyle
      }), setNodeRef);
    }

    // Auto inject ref if child node not have `ref` props
    if ( /*#__PURE__*/react.isValidElement(motionChildren) && (0,es_ref/* supportRef */.Yr)(motionChildren)) {
      var originNodeRef = (0,es_ref/* getNodeRef */.C4)(motionChildren);
      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/react.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /*#__PURE__*/react.createElement(es_DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
/* harmony default export */ const es_CSSMotion = (genCSSMotion(supportTransition));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/diff.js


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;
  if (key && (0,esm_typeof/* default */.Z)(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);

  // Check prev keys to insert or keep
  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }

    // If not hit, it means key is removed
    if (!hit) {
      list.push((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });

  // Add rest to the list
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }

  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */
  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
        status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });

    // Update `STATUS_ADD` to `STATUS_KEEP`
    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotionList.js









var CSSMotionList_excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
  _excluded2 = ["status"];
/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearPrepare', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : es_CSSMotion;
  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    (0,inherits/* default */.Z)(CSSMotionList, _React$Component);
    var _super = (0,createSuper/* default */.Z)(CSSMotionList);
    function CSSMotionList() {
      var _this;
      (0,classCallCheck/* default */.Z)(this, CSSMotionList);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
        keyEntities: []
      });
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
      (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "removeKey", function (removeKey) {
        _this.setState(function (prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function (entity) {
            if (entity.key !== removeKey) return entity;
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function () {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function (_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    (0,createClass/* default */.Z)(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props,
          component = _this$props.component,
          children = _this$props.children,
          _onVisibleChanged = _this$props.onVisibleChanged,
          onAllRemoved = _this$props.onAllRemoved,
          restProps = (0,objectWithoutProperties/* default */.Z)(_this$props, CSSMotionList_excluded);
        var Component = component || react.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/react.createElement(Component, restProps, keyEntities.map(function (_ref2, index) {
          var status = _ref2.status,
            eventProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /*#__PURE__*/react.createElement(CSSMotion, (0,esm_extends/* default */.Z)({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function (props, ref) {
            return children((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
              index: index
            }), ref);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });

            // Remove if already mark as removed
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList;
  }(react.Component);
  (0,defineProperty/* default */.Z)(CSSMotionList, "defaultProps", {
    component: 'div'
  });
  return CSSMotionList;
}
/* harmony default export */ const CSSMotionList = (genCSSMotionList(supportTransition));
;// CONCATENATED MODULE: ./node_modules/rc-motion/es/index.js




/* harmony default export */ const rc_motion_es = (es_CSSMotion);

/***/ }),

/***/ 98924:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ canUseDom)
/* harmony export */ });
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),

/***/ 34203:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sh": () => (/* binding */ isDOM),
/* harmony export */   "ZP": () => (/* binding */ findDOMNode)
/* harmony export */ });
/* unused harmony export getDOM */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);



function isDOM(node) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element
  // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
  return node instanceof HTMLElement || node instanceof SVGElement;
}

/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */
function getDOM(node) {
  if (node && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node) === 'object' && isDOM(node.nativeElement)) {
    return node.nativeElement;
  }
  if (isDOM(node)) {
    return node;
  }
  return null;
}

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  var domNode = getDOM(node);
  if (domNode) {
    return domNode;
  }
  if (node instanceof react__WEBPACK_IMPORTED_MODULE_0__.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(react_dom__WEBPACK_IMPORTED_MODULE_1__, node);
  }
  return null;
}

/***/ }),

/***/ 25517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isFragment)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);

var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');

/**
 * Compatible with React 18 or 19 to check if node is a Fragment.
 */
function isFragment(object) {
  return (
    // Base object type
    object && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object) === 'object' && (
    // React Element type
    object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) &&
    // React Fragment type
    object.type === REACT_FRAGMENT_TYPE
  );
}

/***/ }),

/***/ 66680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useEvent)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useEvent(callback) {
  var fnRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  fnRef.current = callback;
  var memoFn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

/***/ }),

/***/ 8410:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "o": () => (/* binding */ useLayoutUpdateEffect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98924);



/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useInternalLayoutEffect =  true && (0,_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
  var firstMountRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
  useInternalLayoutEffect(function () {
    return callback(firstMountRef.current);
  }, deps);

  // We tell react that first mount has passed
  useInternalLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  useLayoutEffect(function (firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLayoutEffect);

/***/ }),

/***/ 56982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useMemo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

/***/ }),

/***/ 21770:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useMergedState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97685);
/* harmony import */ var _useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66680);
/* harmony import */ var _useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8410);
/* harmony import */ var _useState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30470);




/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(onChange);
  var _useState3 = (0,_useState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([mergedValue]),
    _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  (0,_useLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutUpdateEffect */ .o)(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = (0,_useEvent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/***/ }),

/***/ 30470:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useSafeState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultValue),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/***/ }),

/***/ 56790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": () => (/* reexport safe */ _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__.Z),
/* harmony export */   "zX": () => (/* reexport safe */ _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__.Z)
/* harmony export */ });
/* harmony import */ var _hooks_useEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66680);
/* harmony import */ var _hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21770);
/* harmony import */ var _ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42550);
/* harmony import */ var _utils_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84774);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80334);







/***/ }),

/***/ 75164:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);

      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      });

      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
if (false) {}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (wrapperRaf);

/***/ }),

/***/ 42550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": () => (/* binding */ getNodeRef),
/* harmony export */   "Yr": () => (/* binding */ supportRef),
/* harmony export */   "mH": () => (/* binding */ fillRef),
/* harmony export */   "sQ": () => (/* binding */ composeRef),
/* harmony export */   "x1": () => (/* binding */ useComposeRef)
/* harmony export */ });
/* unused harmony export supportNodeRef */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59864);
/* harmony import */ var _hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56982);
/* harmony import */ var _React_isFragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25517);





var fillRef = function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
};

/**
 * Merge refs into one ref function to support ref passing.
 */
var composeRef = function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
};
var useComposeRef = function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return (0,_hooks_useMemo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length !== next.length || prev.every(function (ref, i) {
      return ref !== next[i];
    });
  });
};
var supportRef = function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }

  // React 19 no need `forwardRef` anymore. So just pass if is a React element.
  if (isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) {
    return true;
  }
  var type = (0,react_is__WEBPACK_IMPORTED_MODULE_1__.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== react_is__WEBPACK_IMPORTED_MODULE_1__.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(node) && !(0,_React_isFragment__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(node);
}
var supportNodeRef = function supportNodeRef(node) {
  return isReactElement(node) && supportRef(node);
};

/**
 * In React 19. `ref` is not a property from node.
 * But a property from `props.ref`.
 * To check if `props.ref` exist or fallback to `ref`.
 */
var getNodeRef = function getNodeRef(node) {
  if (node && isReactElement(node)) {
    var ele = node;

    // Source from:
    // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
    return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
  }
  return null;
};

/***/ }),

/***/ 84774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* binding */ merge)
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(84506);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/utils/get.js
function get(entity, path) {
  var current = entity;
  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }
    current = current[path[i]];
  }
  return current;
}
;// CONCATENATED MODULE: ./node_modules/rc-util/es/utils/set.js





function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = (0,toArray/* default */.Z)(paths),
    path = _paths[0],
    restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path === 'number') {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = (0,toConsumableArray/* default */.Z)(entity);
  } else {
    clone = (0,objectSpread2/* default */.Z)({}, entity);
  }

  // Delete prop if `removeIfUndefined` and value is undefined
  if (removeIfUndefined && value === undefined && restPath.length === 1) {
    delete clone[path][restPath[0]];
  } else {
    clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // Do nothing if `removeIfUndefined` and parent object not exist
  if (paths.length && removeIfUndefined && value === undefined && !get(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
  return (0,esm_typeof/* default */.Z)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
  return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;

/**
 * Merge objects which will create
 */
function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  var clone = createEmpty(sources[0]);
  sources.forEach(function (src) {
    function internalMerge(path, parentLoopSet) {
      var loopSet = new Set(parentLoopSet);
      var value = get(src, path);
      var isArr = Array.isArray(value);
      if (isArr || isObject(value)) {
        // Only add not loop obj
        if (!loopSet.has(value)) {
          loopSet.add(value);
          var originValue = get(clone, path);
          if (isArr) {
            // Array will always be override
            clone = set(clone, path, []);
          } else if (!originValue || (0,esm_typeof/* default */.Z)(originValue) !== 'object') {
            // Init container if not exist
            clone = set(clone, path, createEmpty(value));
          }
          keys(value).forEach(function (key) {
            internalMerge([].concat((0,toConsumableArray/* default */.Z)(path), [key]), loopSet);
          });
        }
      } else {
        clone = set(clone, path, value);
      }
    }
    internalMerge([]);
  });
  return clone;
}

/***/ }),

/***/ 80334:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kp": () => (/* binding */ warning),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports preMessage, note, resetWarned, call, warningOnce, noteOnce */
/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};

/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */
function warning(valid, message) {
  if (false) { var finalMessage; }
}

/** @see Similar to {@link warning} */
function note(valid, message) {
  if (false) { var finalMessage; }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

/** @see Same as {@link warning}, but only warn once for the same message */
function warningOnce(valid, message) {
  call(warning, valid, message);
}

/** @see Same as {@link warning}, but only warn once for the same message */
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (warningOnce);

/***/ }),

/***/ 24996:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


var _interopRequireWildcard = (__webpack_require__(75263)["default"]);
var _interopRequireDefault = (__webpack_require__(64836)["default"]);
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = _r;
__webpack_unused_export__ = _u;
exports.sY = render;
exports.vE = unmount;
var _regeneratorRuntime2 = _interopRequireDefault(__webpack_require__(17061));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _objectSpread2 = _interopRequireDefault(__webpack_require__(42122));
var ReactDOM = _interopRequireWildcard(__webpack_require__(73935));
// Let compiler not to search module usage
var fullClone = (0, _objectSpread2.default)({}, ReactDOM);
var version = fullClone.version,
  reactRender = fullClone.render,
  unmountComponentAtNode = fullClone.unmountComponentAtNode;
var createRoot;
try {
  var mainVersion = Number((version || '').split('.')[0]);
  if (mainVersion >= 18) {
    createRoot = fullClone.createRoot;
  }
} catch (e) {
  // Do nothing;
}
function toggleWarning(skip) {
  var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, _typeof2.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') {
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
  }
}
var MARK = '__rc_react_root__';

// ========================== Render ==========================

function modernRender(node, container) {
  toggleWarning(true);
  var root = container[MARK] || createRoot(container);
  toggleWarning(false);
  root.render(node);
  container[MARK] = root;
}
function legacyRender(node, container) {
  reactRender(node, container);
}

/** @private Test usage. Not work in prod */
function _r(node, container) {
  if (false) {}
}
function render(node, container) {
  if (createRoot) {
    modernRender(node, container);
    return;
  }
  legacyRender(node, container);
}

// ========================= Unmount ==========================
function modernUnmount(_x) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  _modernUnmount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(container) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", Promise.resolve().then(function () {
            var _container$MARK;
            (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
            delete container[MARK];
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _modernUnmount.apply(this, arguments);
}
function legacyUnmount(container) {
  unmountComponentAtNode(container);
}

/** @private Test usage. Not work in prod */
function _u(container) {
  if (false) {}
}
function unmount(_x2) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(container) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(createRoot !== undefined)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", modernUnmount(container));
        case 2:
          legacyUnmount(container);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _unmount.apply(this, arguments);
}

/***/ }),

/***/ 88682:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),

/***/ 14608:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(54087);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(53879);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(95205);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(13305);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(78669);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(4749);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(56839);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(7679);

var _defaultRenderElements = __webpack_require__(88682);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),

/***/ 7679:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),

/***/ 31298:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.$B = undefined;

var _Scrollbars = __webpack_require__(14608);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.ZP = _Scrollbars2["default"];
exports.$B = _Scrollbars2["default"];

/***/ }),

/***/ 56839:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),

/***/ 4749:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),

/***/ 13305:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(53879);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),

/***/ 95205:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),

/***/ 78669:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),

/***/ 69921:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;exports.ForwardRef=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 91033:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (index);


/***/ }),

/***/ 35747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 23595:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 80842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AbstractTokenizer = void 0;
const peek_readable_1 = __webpack_require__(55167);
/**
 * Core tokenizer
 */
class AbstractTokenizer {
    constructor(fileInfo) {
        /**
         * Tokenizer-stream position
         */
        this.position = 0;
        this.numBuffer = new Uint8Array(8);
        this.fileInfo = fileInfo ? fileInfo : {};
    }
    /**
     * Read a token from the tokenizer-stream
     * @param token - The token to read
     * @param position - If provided, the desired position in the tokenizer-stream
     * @returns Promise with token data
     */
    async readToken(token, position = this.position) {
        const uint8Array = Buffer.alloc(token.len);
        const len = await this.readBuffer(uint8Array, { position });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(uint8Array, 0);
    }
    /**
     * Peek a token from the tokenizer-stream.
     * @param token - Token to peek from the tokenizer-stream.
     * @param position - Offset where to begin reading within the file. If position is null, data will be read from the current file position.
     * @returns Promise with token data
     */
    async peekToken(token, position = this.position) {
        const uint8Array = Buffer.alloc(token.len);
        const len = await this.peekBuffer(uint8Array, { position });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(uint8Array, 0);
    }
    /**
     * Read a numeric token from the stream
     * @param token - Numeric token
     * @returns Promise with number
     */
    async readNumber(token) {
        const len = await this.readBuffer(this.numBuffer, { length: token.len });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(this.numBuffer, 0);
    }
    /**
     * Read a numeric token from the stream
     * @param token - Numeric token
     * @returns Promise with number
     */
    async peekNumber(token) {
        const len = await this.peekBuffer(this.numBuffer, { length: token.len });
        if (len < token.len)
            throw new peek_readable_1.EndOfStreamError();
        return token.get(this.numBuffer, 0);
    }
    /**
     * Ignore number of bytes, advances the pointer in under tokenizer-stream.
     * @param length - Number of bytes to ignore
     * @return resolves the number of bytes ignored, equals length if this available, otherwise the number of bytes available
     */
    async ignore(length) {
        if (this.fileInfo.size !== undefined) {
            const bytesLeft = this.fileInfo.size - this.position;
            if (length > bytesLeft) {
                this.position += bytesLeft;
                return bytesLeft;
            }
        }
        this.position += length;
        return length;
    }
    async close() {
        // empty
    }
    normalizeOptions(uint8Array, options) {
        if (options && options.position !== undefined && options.position < this.position) {
            throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
        }
        if (options) {
            return {
                mayBeLess: options.mayBeLess === true,
                offset: options.offset ? options.offset : 0,
                length: options.length ? options.length : (uint8Array.length - (options.offset ? options.offset : 0)),
                position: options.position ? options.position : this.position
            };
        }
        return {
            mayBeLess: false,
            offset: 0,
            length: uint8Array.length,
            position: this.position
        };
    }
}
exports.AbstractTokenizer = AbstractTokenizer;


/***/ }),

/***/ 30778:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BufferTokenizer = void 0;
const peek_readable_1 = __webpack_require__(55167);
const AbstractTokenizer_1 = __webpack_require__(80842);
class BufferTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
    /**
     * Construct BufferTokenizer
     * @param uint8Array - Uint8Array to tokenize
     * @param fileInfo - Pass additional file information to the tokenizer
     */
    constructor(uint8Array, fileInfo) {
        super(fileInfo);
        this.uint8Array = uint8Array;
        this.fileInfo.size = this.fileInfo.size ? this.fileInfo.size : uint8Array.length;
    }
    /**
     * Read buffer from tokenizer
     * @param uint8Array - Uint8Array to tokenize
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */
    async readBuffer(uint8Array, options) {
        if (options && options.position) {
            if (options.position < this.position) {
                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
            }
            this.position = options.position;
        }
        const bytesRead = await this.peekBuffer(uint8Array, options);
        this.position += bytesRead;
        return bytesRead;
    }
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param uint8Array
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */
    async peekBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        const bytes2read = Math.min(this.uint8Array.length - normOptions.position, normOptions.length);
        if ((!normOptions.mayBeLess) && bytes2read < normOptions.length) {
            throw new peek_readable_1.EndOfStreamError();
        }
        else {
            uint8Array.set(this.uint8Array.subarray(normOptions.position, normOptions.position + bytes2read), normOptions.offset);
            return bytes2read;
        }
    }
    async close() {
        // empty
    }
}
exports.BufferTokenizer = BufferTokenizer;


/***/ }),

/***/ 27859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromFile = exports.FileTokenizer = void 0;
const AbstractTokenizer_1 = __webpack_require__(80842);
const peek_readable_1 = __webpack_require__(55167);
const fs = __webpack_require__(77209);
class FileTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
    constructor(fd, fileInfo) {
        super(fileInfo);
        this.fd = fd;
    }
    /**
     * Read buffer from file
     * @param uint8Array - Uint8Array to write result to
     * @param options - Read behaviour options
     * @returns Promise number of bytes read
     */
    async readBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        this.position = normOptions.position;
        const res = await fs.read(this.fd, uint8Array, normOptions.offset, normOptions.length, normOptions.position);
        this.position += res.bytesRead;
        if (res.bytesRead < normOptions.length && (!options || !options.mayBeLess)) {
            throw new peek_readable_1.EndOfStreamError();
        }
        return res.bytesRead;
    }
    /**
     * Peek buffer from file
     * @param uint8Array - Uint8Array (or Buffer) to write data to
     * @param options - Read behaviour options
     * @returns Promise number of bytes read
     */
    async peekBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        const res = await fs.read(this.fd, uint8Array, normOptions.offset, normOptions.length, normOptions.position);
        if ((!normOptions.mayBeLess) && res.bytesRead < normOptions.length) {
            throw new peek_readable_1.EndOfStreamError();
        }
        return res.bytesRead;
    }
    async close() {
        return fs.close(this.fd);
    }
}
exports.FileTokenizer = FileTokenizer;
async function fromFile(sourceFilePath) {
    const stat = await fs.stat(sourceFilePath);
    if (!stat.isFile) {
        throw new Error(`File not a file: ${sourceFilePath}`);
    }
    const fd = await fs.open(sourceFilePath, 'r');
    return new FileTokenizer(fd, { path: sourceFilePath, size: stat.size });
}
exports.fromFile = fromFile;


/***/ }),

/***/ 77209:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/**
 * Module convert fs functions to promise based functions
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.readFile = exports.writeFileSync = exports.writeFile = exports.read = exports.open = exports.close = exports.stat = exports.createReadStream = exports.pathExists = void 0;
const fs = __webpack_require__(4059);
exports.pathExists = fs.existsSync;
exports.createReadStream = fs.createReadStream;
async function stat(path) {
    return new Promise((resolve, reject) => {
        fs.stat(path, (err, stats) => {
            if (err)
                reject(err);
            else
                resolve(stats);
        });
    });
}
exports.stat = stat;
async function close(fd) {
    return new Promise((resolve, reject) => {
        fs.close(fd, err => {
            if (err)
                reject(err);
            else
                resolve();
        });
    });
}
exports.close = close;
async function open(path, mode) {
    return new Promise((resolve, reject) => {
        fs.open(path, mode, (err, fd) => {
            if (err)
                reject(err);
            else
                resolve(fd);
        });
    });
}
exports.open = open;
async function read(fd, buffer, offset, length, position) {
    return new Promise((resolve, reject) => {
        fs.read(fd, buffer, offset, length, position, (err, bytesRead, _buffer) => {
            if (err)
                reject(err);
            else
                resolve({ bytesRead, buffer: _buffer });
        });
    });
}
exports.read = read;
async function writeFile(path, data) {
    return new Promise((resolve, reject) => {
        fs.writeFile(path, data, err => {
            if (err)
                reject(err);
            else
                resolve();
        });
    });
}
exports.writeFile = writeFile;
function writeFileSync(path, data) {
    fs.writeFileSync(path, data);
}
exports.writeFileSync = writeFileSync;
async function readFile(path) {
    return new Promise((resolve, reject) => {
        fs.readFile(path, (err, buffer) => {
            if (err)
                reject(err);
            else
                resolve(buffer);
        });
    });
}
exports.readFile = readFile;


/***/ }),

/***/ 20599:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReadStreamTokenizer = void 0;
const AbstractTokenizer_1 = __webpack_require__(80842);
const peek_readable_1 = __webpack_require__(55167);
const maxBufferSize = 256000;
class ReadStreamTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
    constructor(stream, fileInfo) {
        super(fileInfo);
        this.streamReader = new peek_readable_1.StreamReader(stream);
    }
    /**
     * Get file information, an HTTP-client may implement this doing a HEAD request
     * @return Promise with file information
     */
    async getFileInfo() {
        return this.fileInfo;
    }
    /**
     * Read buffer from tokenizer
     * @param uint8Array - Target Uint8Array to fill with data read from the tokenizer-stream
     * @param options - Read behaviour options
     * @returns Promise with number of bytes read
     */
    async readBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        const skipBytes = normOptions.position - this.position;
        if (skipBytes > 0) {
            await this.ignore(skipBytes);
            return this.readBuffer(uint8Array, options);
        }
        else if (skipBytes < 0) {
            throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
        }
        if (normOptions.length === 0) {
            return 0;
        }
        const bytesRead = await this.streamReader.read(uint8Array, normOptions.offset, normOptions.length);
        this.position += bytesRead;
        if ((!options || !options.mayBeLess) && bytesRead < normOptions.length) {
            throw new peek_readable_1.EndOfStreamError();
        }
        return bytesRead;
    }
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param uint8Array - Uint8Array (or Buffer) to write data to
     * @param options - Read behaviour options
     * @returns Promise with number of bytes peeked
     */
    async peekBuffer(uint8Array, options) {
        const normOptions = this.normalizeOptions(uint8Array, options);
        let bytesRead = 0;
        if (normOptions.position) {
            const skipBytes = normOptions.position - this.position;
            if (skipBytes > 0) {
                const skipBuffer = new Uint8Array(normOptions.length + skipBytes);
                bytesRead = await this.peekBuffer(skipBuffer, { mayBeLess: normOptions.mayBeLess });
                uint8Array.set(skipBuffer.subarray(skipBytes), normOptions.offset);
                return bytesRead - skipBytes;
            }
            else if (skipBytes < 0) {
                throw new Error('Cannot peek from a negative offset in a stream');
            }
        }
        if (normOptions.length > 0) {
            try {
                bytesRead = await this.streamReader.peek(uint8Array, normOptions.offset, normOptions.length);
            }
            catch (err) {
                if (options && options.mayBeLess && err instanceof peek_readable_1.EndOfStreamError) {
                    return 0;
                }
                throw err;
            }
            if ((!normOptions.mayBeLess) && bytesRead < normOptions.length) {
                throw new peek_readable_1.EndOfStreamError();
            }
        }
        return bytesRead;
    }
    async ignore(length) {
        // debug(`ignore ${this.position}...${this.position + length - 1}`);
        const bufSize = Math.min(maxBufferSize, length);
        const buf = new Uint8Array(bufSize);
        let totBytesRead = 0;
        while (totBytesRead < length) {
            const remaining = length - totBytesRead;
            const bytesRead = await this.readBuffer(buf, { length: Math.min(bufSize, remaining) });
            if (bytesRead < 0) {
                return bytesRead;
            }
            totBytesRead += bytesRead;
        }
        return totBytesRead;
    }
}
exports.ReadStreamTokenizer = ReadStreamTokenizer;


/***/ }),

/***/ 35849:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBuffer = exports.fromStream = exports.EndOfStreamError = void 0;
const ReadStreamTokenizer_1 = __webpack_require__(20599);
const BufferTokenizer_1 = __webpack_require__(30778);
var peek_readable_1 = __webpack_require__(55167);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return peek_readable_1.EndOfStreamError; } }));
/**
 * Construct ReadStreamTokenizer from given Stream.
 * Will set fileSize, if provided given Stream has set the .path property/
 * @param stream - Read from Node.js Stream.Readable
 * @param fileInfo - Pass the file information, like size and MIME-type of the corresponding stream.
 * @returns ReadStreamTokenizer
 */
function fromStream(stream, fileInfo) {
    fileInfo = fileInfo ? fileInfo : {};
    return new ReadStreamTokenizer_1.ReadStreamTokenizer(stream, fileInfo);
}
exports.fromStream = fromStream;
/**
 * Construct ReadStreamTokenizer from given Buffer.
 * @param uint8Array - Uint8Array to tokenize
 * @param fileInfo - Pass additional file information to the tokenizer
 * @returns BufferTokenizer
 */
function fromBuffer(uint8Array, fileInfo) {
    return new BufferTokenizer_1.BufferTokenizer(uint8Array, fileInfo);
}
exports.fromBuffer = fromBuffer;


/***/ }),

/***/ 26597:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromStream = exports.fromBuffer = exports.EndOfStreamError = exports.fromFile = void 0;
const fs = __webpack_require__(77209);
const core = __webpack_require__(35849);
var FileTokenizer_1 = __webpack_require__(27859);
Object.defineProperty(exports, "fromFile", ({ enumerable: true, get: function () { return FileTokenizer_1.fromFile; } }));
var core_1 = __webpack_require__(35849);
Object.defineProperty(exports, "EndOfStreamError", ({ enumerable: true, get: function () { return core_1.EndOfStreamError; } }));
Object.defineProperty(exports, "fromBuffer", ({ enumerable: true, get: function () { return core_1.fromBuffer; } }));
/**
 * Construct ReadStreamTokenizer from given Stream.
 * Will set fileSize, if provided given Stream has set the .path property.
 * @param stream - Node.js Stream.Readable
 * @param fileInfo - Pass additional file information to the tokenizer
 * @returns Tokenizer
 */
async function fromStream(stream, fileInfo) {
    fileInfo = fileInfo ? fileInfo : {};
    if (stream.path) {
        const stat = await fs.stat(stream.path);
        fileInfo.path = stream.path;
        fileInfo.size = stat.size;
    }
    return core.fromStream(stream, fileInfo);
}
exports.fromStream = fromStream;


/***/ }),

/***/ 6189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var space = __webpack_require__(7966)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),

/***/ 71788:
/***/ ((module) => {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),

/***/ 7966:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var clean = __webpack_require__(71788)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),

/***/ 83416:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnsiStringType = exports.StringType = exports.BufferType = exports.Uint8ArrayType = exports.IgnoreType = exports.Float80_LE = exports.Float80_BE = exports.Float64_LE = exports.Float64_BE = exports.Float32_LE = exports.Float32_BE = exports.Float16_LE = exports.Float16_BE = exports.INT64_BE = exports.UINT64_BE = exports.INT64_LE = exports.UINT64_LE = exports.INT32_LE = exports.INT32_BE = exports.INT24_BE = exports.INT24_LE = exports.INT16_LE = exports.INT16_BE = exports.INT8 = exports.UINT32_BE = exports.UINT32_LE = exports.UINT24_BE = exports.UINT24_LE = exports.UINT16_BE = exports.UINT16_LE = exports.UINT8 = void 0;
const ieee754 = __webpack_require__(80645);
// Primitive types
function dv(array) {
    return new DataView(array.buffer, array.byteOffset);
}
/**
 * 8-bit unsigned integer
 */
exports.UINT8 = {
    len: 1,
    get(array, offset) {
        return dv(array).getUint8(offset);
    },
    put(array, offset, value) {
        dv(array).setUint8(offset, value);
        return offset + 1;
    }
};
/**
 * 16-bit unsigned integer, Little Endian byte order
 */
exports.UINT16_LE = {
    len: 2,
    get(array, offset) {
        return dv(array).getUint16(offset, true);
    },
    put(array, offset, value) {
        dv(array).setUint16(offset, value, true);
        return offset + 2;
    }
};
/**
 * 16-bit unsigned integer, Big Endian byte order
 */
exports.UINT16_BE = {
    len: 2,
    get(array, offset) {
        return dv(array).getUint16(offset);
    },
    put(array, offset, value) {
        dv(array).setUint16(offset, value);
        return offset + 2;
    }
};
/**
 * 24-bit unsigned integer, Little Endian byte order
 */
exports.UINT24_LE = {
    len: 3,
    get(array, offset) {
        const dataView = dv(array);
        return dataView.getUint8(offset) + (dataView.getUint16(offset + 1, true) << 8);
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint8(offset, value & 0xff);
        dataView.setUint16(offset + 1, value >> 8, true);
        return offset + 3;
    }
};
/**
 * 24-bit unsigned integer, Big Endian byte order
 */
exports.UINT24_BE = {
    len: 3,
    get(array, offset) {
        const dataView = dv(array);
        return (dataView.getUint16(offset) << 8) + dataView.getUint8(offset + 2);
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint16(offset, value >> 8);
        dataView.setUint8(offset + 2, value & 0xff);
        return offset + 3;
    }
};
/**
 * 32-bit unsigned integer, Little Endian byte order
 */
exports.UINT32_LE = {
    len: 4,
    get(array, offset) {
        return dv(array).getUint32(offset, true);
    },
    put(array, offset, value) {
        dv(array).setUint32(offset, value, true);
        return offset + 4;
    }
};
/**
 * 32-bit unsigned integer, Big Endian byte order
 */
exports.UINT32_BE = {
    len: 4,
    get(array, offset) {
        return dv(array).getUint32(offset);
    },
    put(array, offset, value) {
        dv(array).setUint32(offset, value);
        return offset + 4;
    }
};
/**
 * 8-bit signed integer
 */
exports.INT8 = {
    len: 1,
    get(array, offset) {
        return dv(array).getInt8(offset);
    },
    put(array, offset, value) {
        dv(array).setInt8(offset, value);
        return offset + 1;
    }
};
/**
 * 16-bit signed integer, Big Endian byte order
 */
exports.INT16_BE = {
    len: 2,
    get(array, offset) {
        return dv(array).getInt16(offset);
    },
    put(array, offset, value) {
        dv(array).setInt16(offset, value);
        return offset + 2;
    }
};
/**
 * 16-bit signed integer, Little Endian byte order
 */
exports.INT16_LE = {
    len: 2,
    get(array, offset) {
        return dv(array).getInt16(offset, true);
    },
    put(array, offset, value) {
        dv(array).setInt16(offset, value, true);
        return offset + 2;
    }
};
/**
 * 24-bit signed integer, Little Endian byte order
 */
exports.INT24_LE = {
    len: 3,
    get(array, offset) {
        const unsigned = exports.UINT24_LE.get(array, offset);
        return unsigned > 0x7fffff ? unsigned - 0x1000000 : unsigned;
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint8(offset, value & 0xff);
        dataView.setUint16(offset + 1, value >> 8, true);
        return offset + 3;
    }
};
/**
 * 24-bit signed integer, Big Endian byte order
 */
exports.INT24_BE = {
    len: 3,
    get(array, offset) {
        const unsigned = exports.UINT24_BE.get(array, offset);
        return unsigned > 0x7fffff ? unsigned - 0x1000000 : unsigned;
    },
    put(array, offset, value) {
        const dataView = dv(array);
        dataView.setUint16(offset, value >> 8);
        dataView.setUint8(offset + 2, value & 0xff);
        return offset + 3;
    }
};
/**
 * 32-bit signed integer, Big Endian byte order
 */
exports.INT32_BE = {
    len: 4,
    get(array, offset) {
        return dv(array).getInt32(offset);
    },
    put(array, offset, value) {
        dv(array).setInt32(offset, value);
        return offset + 4;
    }
};
/**
 * 32-bit signed integer, Big Endian byte order
 */
exports.INT32_LE = {
    len: 4,
    get(array, offset) {
        return dv(array).getInt32(offset, true);
    },
    put(array, offset, value) {
        dv(array).setInt32(offset, value, true);
        return offset + 4;
    }
};
/**
 * 64-bit unsigned integer, Little Endian byte order
 */
exports.UINT64_LE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigUint64(offset, true);
    },
    put(array, offset, value) {
        dv(array).setBigUint64(offset, value, true);
        return offset + 8;
    }
};
/**
 * 64-bit signed integer, Little Endian byte order
 */
exports.INT64_LE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigInt64(offset, true);
    },
    put(array, offset, value) {
        dv(array).setBigInt64(offset, value, true);
        return offset + 8;
    }
};
/**
 * 64-bit unsigned integer, Big Endian byte order
 */
exports.UINT64_BE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigUint64(offset);
    },
    put(array, offset, value) {
        dv(array).setBigUint64(offset, value);
        return offset + 8;
    }
};
/**
 * 64-bit signed integer, Big Endian byte order
 */
exports.INT64_BE = {
    len: 8,
    get(array, offset) {
        return dv(array).getBigInt64(offset);
    },
    put(array, offset, value) {
        dv(array).setBigInt64(offset, value);
        return offset + 8;
    }
};
/**
 * IEEE 754 16-bit (half precision) float, big endian
 */
exports.Float16_BE = {
    len: 2,
    get(dataView, offset) {
        return ieee754.read(dataView, offset, false, 10, this.len);
    },
    put(dataView, offset, value) {
        ieee754.write(dataView, value, offset, false, 10, this.len);
        return offset + this.len;
    }
};
/**
 * IEEE 754 16-bit (half precision) float, little endian
 */
exports.Float16_LE = {
    len: 2,
    get(array, offset) {
        return ieee754.read(array, offset, true, 10, this.len);
    },
    put(array, offset, value) {
        ieee754.write(array, value, offset, true, 10, this.len);
        return offset + this.len;
    }
};
/**
 * IEEE 754 32-bit (single precision) float, big endian
 */
exports.Float32_BE = {
    len: 4,
    get(array, offset) {
        return dv(array).getFloat32(offset);
    },
    put(array, offset, value) {
        dv(array).setFloat32(offset, value);
        return offset + 4;
    }
};
/**
 * IEEE 754 32-bit (single precision) float, little endian
 */
exports.Float32_LE = {
    len: 4,
    get(array, offset) {
        return dv(array).getFloat32(offset, true);
    },
    put(array, offset, value) {
        dv(array).setFloat32(offset, value, true);
        return offset + 4;
    }
};
/**
 * IEEE 754 64-bit (double precision) float, big endian
 */
exports.Float64_BE = {
    len: 8,
    get(array, offset) {
        return dv(array).getFloat64(offset);
    },
    put(array, offset, value) {
        dv(array).setFloat64(offset, value);
        return offset + 8;
    }
};
/**
 * IEEE 754 64-bit (double precision) float, little endian
 */
exports.Float64_LE = {
    len: 8,
    get(array, offset) {
        return dv(array).getFloat64(offset, true);
    },
    put(array, offset, value) {
        dv(array).setFloat64(offset, value, true);
        return offset + 8;
    }
};
/**
 * IEEE 754 80-bit (extended precision) float, big endian
 */
exports.Float80_BE = {
    len: 10,
    get(array, offset) {
        return ieee754.read(array, offset, false, 63, this.len);
    },
    put(array, offset, value) {
        ieee754.write(array, value, offset, false, 63, this.len);
        return offset + this.len;
    }
};
/**
 * IEEE 754 80-bit (extended precision) float, little endian
 */
exports.Float80_LE = {
    len: 10,
    get(array, offset) {
        return ieee754.read(array, offset, true, 63, this.len);
    },
    put(array, offset, value) {
        ieee754.write(array, value, offset, true, 63, this.len);
        return offset + this.len;
    }
};
/**
 * Ignore a given number of bytes
 */
class IgnoreType {
    /**
     * @param len number of bytes to ignore
     */
    constructor(len) {
        this.len = len;
    }
    // ToDo: don't read, but skip data
    get(array, off) {
    }
}
exports.IgnoreType = IgnoreType;
class Uint8ArrayType {
    constructor(len) {
        this.len = len;
    }
    get(array, offset) {
        return array.subarray(offset, offset + this.len);
    }
}
exports.Uint8ArrayType = Uint8ArrayType;
class BufferType {
    constructor(len) {
        this.len = len;
    }
    get(uint8Array, off) {
        return Buffer.from(uint8Array.subarray(off, off + this.len));
    }
}
exports.BufferType = BufferType;
/**
 * Consume a fixed number of bytes from the stream and return a string with a specified encoding.
 */
class StringType {
    constructor(len, encoding) {
        this.len = len;
        this.encoding = encoding;
    }
    get(uint8Array, offset) {
        return Buffer.from(uint8Array).toString(this.encoding, offset, offset + this.len);
    }
}
exports.StringType = StringType;
/**
 * ANSI Latin 1 String
 * Using windows-1252 / ISO 8859-1 decoding
 */
class AnsiStringType {
    constructor(len) {
        this.len = len;
    }
    static decode(buffer, offset, until) {
        let str = '';
        for (let i = offset; i < until; ++i) {
            str += AnsiStringType.codePointToString(AnsiStringType.singleByteDecoder(buffer[i]));
        }
        return str;
    }
    static inRange(a, min, max) {
        return min <= a && a <= max;
    }
    static codePointToString(cp) {
        if (cp <= 0xFFFF) {
            return String.fromCharCode(cp);
        }
        else {
            cp -= 0x10000;
            return String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    static singleByteDecoder(bite) {
        if (AnsiStringType.inRange(bite, 0x00, 0x7F)) {
            return bite;
        }
        const codePoint = AnsiStringType.windows1252[bite - 0x80];
        if (codePoint === null) {
            throw Error('invaliding encoding');
        }
        return codePoint;
    }
    get(buffer, offset = 0) {
        return AnsiStringType.decode(buffer, offset, offset + this.len);
    }
}
exports.AnsiStringType = AnsiStringType;
AnsiStringType.windows1252 = [8364, 129, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352,
    8249, 338, 141, 381, 143, 144, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732,
    8482, 353, 8250, 339, 157, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168,
    169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184,
    185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200,
    201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216,
    217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
    233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
    248, 249, 250, 251, 252, 253, 254, 255];


/***/ }),

/***/ 57632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ esm_browser_v4)
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ const esm_browser_v4 = (v4);

/***/ }),

/***/ 42480:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 24654:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 4059:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 17156:
/***/ ((module) => {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 38416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPropertyKey = __webpack_require__(64062);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64836:
/***/ ((module) => {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 75263:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 42122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(38416);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95036:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64062:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(18698)["default"]);
var toPrimitive = __webpack_require__(95036);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93967:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 30907:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayWithHoles)
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _assertThisInitialized)
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 29388:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _createSuper)
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61120);
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78814);
/* harmony import */ var _possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82963);



function _createSuper(t) {
  var r = (0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  return function () {
    var e,
      o = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
    if (r) {
      var s = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return (0,_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, e);
  };
}


/***/ }),

/***/ 4942:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 61120:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _getPrototypeOf)
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 60136:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _inherits)
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, e);
}


/***/ }),

/***/ 78814:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _isNativeReflectConstruct)
/* harmony export */ });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),

/***/ 59199:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _iterableToArray)
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 25267:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _nonIterableRest)
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 1413:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectSpread2)
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ 45987:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutProperties)
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 63366:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 82963:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _possibleConstructorReturn)
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 89611:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _setPrototypeOf)
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 97685:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _slicedToArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 84506:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _toArray)
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83878);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59199);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40181);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25267);




function _toArray(r) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(r) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(r) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 74902:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 83997:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 25431:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ query_string)
});

// NAMESPACE OBJECT: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": () => (exclude),
  "extract": () => (extract),
  "parse": () => (parse),
  "parseUrl": () => (parseUrl),
  "pick": () => (pick),
  "stringify": () => (stringify),
  "stringifyUrl": () => (stringifyUrl)
});

// EXTERNAL MODULE: ./node_modules/decode-uri-component/index.js
var decode_uri_component = __webpack_require__(93696);
// EXTERNAL MODULE: ./node_modules/split-on-first/index.js
var split_on_first = __webpack_require__(33920);
// EXTERNAL MODULE: ./node_modules/filter-obj/index.js
var filter_obj = __webpack_require__(85252);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/base.js




const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index': {
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result, [encode(key, options), '[', index, ']'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join(''),
				];
			};
		}

		case 'bracket': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), '[]'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[]=', encode(value, options)].join(''),
				];
			};
		}

		case 'colon-list-separator': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), ':list='].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), ':list=', encode(value, options)].join(''),
				];
			};
		}

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator'
				? '[]='
				: '=';

			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default: {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						encode(key, options),
					];
				}

				return [
					...result,
					[encode(key, options), '=', encode(value, options)].join(''),
				];
			};
		}
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index': {
			return (key, value, accumulator) => {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		}

		case 'bracket': {
			return (key, value, accumulator) => {
				result = /(\[])$/.exec(key);
				key = key.replace(/\[]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'colon-list-separator': {
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'comma':
		case 'separator': {
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : (value === null ? value : decode(value, options));
				accumulator[key] = newValue;
			};
		}

		case 'bracket-separator': {
			return (key, value, accumulator) => {
				const isArray = /(\[])$/.test(key);
				key = key.replace(/\[]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null
					? []
					: value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [...accumulator[key], ...arrayValue];
			};
		}

		default: {
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [...[accumulator[key]].flat(), value];
			};
		}
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return (0,decode_uri_component/* default */.Z)(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parse(query, options) {
	options = {
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false,
		...options,
	};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const returnValue = Object.create(null);

	if (typeof query !== 'string') {
		return returnValue;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return returnValue;
	}

	for (const parameter of query.split('&')) {
		if (parameter === '') {
			continue;
		}

		const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;

		let [key, value] = (0,split_on_first/* default */.Z)(parameter_, '=');

		if (key === undefined) {
			key = parameter_;
		}

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : (['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options));
		formatter(decode(key, options), value, returnValue);
	}

	for (const [key, value] of Object.entries(returnValue)) {
		if (typeof value === 'object' && value !== null) {
			for (const [key2, value2] of Object.entries(value)) {
				value[key2] = parseValue(value2, options);
			}
		} else {
			returnValue[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return returnValue;
	}

	// TODO: Remove the use of `reduce`.
	// eslint-disable-next-line unicorn/no-array-reduce
	return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
		const value = returnValue[key];
		result[key] = Boolean(value) && typeof value === 'object' && !Array.isArray(value) ? keysSorter(value) : value;
		return result;
	}, Object.create(null));
}

function stringify(object, options) {
	if (!object) {
		return '';
	}

	options = {encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',', ...options};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key]))
		|| (options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const [key, value] of Object.entries(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = value;
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
}

function parseUrl(url, options) {
	options = {
		decode: true,
		...options,
	};

	let [url_, hash] = (0,split_on_first/* default */.Z)(url, '#');

	if (url_ === undefined) {
		url_ = url;
	}

	return {
		url: url_?.split('?')?.[0] ?? '',
		query: parse(extract(url), options),
		...(options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}),
	};
}

function stringifyUrl(object, options) {
	options = {
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true,
		...options,
	};

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = extract(object.url);

	const query = {
		...parse(queryFromUrl, {sort: false}),
		...object.query,
	};

	let queryString = stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		const urlObjectForFragmentEncode = new URL(url);
		urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
		hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
}

function pick(input, filter, options) {
	options = {
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false,
		...options,
	};

	const {url, query, fragmentIdentifier} = parseUrl(input, options);

	return stringifyUrl({
		url,
		query: (0,filter_obj/* includeKeys */.T)(query, filter),
		fragmentIdentifier,
	}, options);
}

function exclude(input, filter, options) {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/query-string/index.js


/* harmony default export */ const query_string = (base_namespaceObject);


/***/ }),

/***/ 5121:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ lib_axios)
});

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": () => (hasBrowserEnv),
  "hasStandardBrowserEnv": () => (hasStandardBrowserEnv),
  "hasStandardBrowserWebWorkerEnv": () => (hasStandardBrowserWebWorkerEnv)
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ const utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ const helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ const defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ const classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ const classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ const classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ const browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



/* harmony default export */ const platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ const lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ const core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ const cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ const cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ const isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ const adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.6.8";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';

        if (!err.stack) {
          err.stack = stack;
          // match without the 2 top stack lines
        } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
          err.stack += '\n' + stack
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const lib_axios = (axios);


/***/ }),

/***/ 93696:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ decodeUriComponent)
/* harmony export */ });
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}


/***/ }),

/***/ 85252:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ includeKeys)
/* harmony export */ });
/* unused harmony export excludeKeys */
function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

function excludeKeys(object, predicate) {
	if (Array.isArray(predicate)) {
		const set = new Set(predicate);
		return includeKeys(object, key => !set.has(key));
	}

	return includeKeys(object, (key, value, object) => !predicate(key, value, object));
}


/***/ }),

/***/ 31955:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ api)
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ }),

/***/ 33920:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ splitOnFirst)
/* harmony export */ });
function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}


/***/ }),

/***/ 97582:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__addDisposableResource": () => (/* binding */ __addDisposableResource),
/* harmony export */   "__assign": () => (/* binding */ __assign),
/* harmony export */   "__asyncDelegator": () => (/* binding */ __asyncDelegator),
/* harmony export */   "__asyncGenerator": () => (/* binding */ __asyncGenerator),
/* harmony export */   "__asyncValues": () => (/* binding */ __asyncValues),
/* harmony export */   "__await": () => (/* binding */ __await),
/* harmony export */   "__awaiter": () => (/* binding */ __awaiter),
/* harmony export */   "__classPrivateFieldGet": () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   "__classPrivateFieldIn": () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   "__classPrivateFieldSet": () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   "__createBinding": () => (/* binding */ __createBinding),
/* harmony export */   "__decorate": () => (/* binding */ __decorate),
/* harmony export */   "__disposeResources": () => (/* binding */ __disposeResources),
/* harmony export */   "__esDecorate": () => (/* binding */ __esDecorate),
/* harmony export */   "__exportStar": () => (/* binding */ __exportStar),
/* harmony export */   "__extends": () => (/* binding */ __extends),
/* harmony export */   "__generator": () => (/* binding */ __generator),
/* harmony export */   "__importDefault": () => (/* binding */ __importDefault),
/* harmony export */   "__importStar": () => (/* binding */ __importStar),
/* harmony export */   "__makeTemplateObject": () => (/* binding */ __makeTemplateObject),
/* harmony export */   "__metadata": () => (/* binding */ __metadata),
/* harmony export */   "__param": () => (/* binding */ __param),
/* harmony export */   "__propKey": () => (/* binding */ __propKey),
/* harmony export */   "__read": () => (/* binding */ __read),
/* harmony export */   "__rest": () => (/* binding */ __rest),
/* harmony export */   "__rewriteRelativeImportExtension": () => (/* binding */ __rewriteRelativeImportExtension),
/* harmony export */   "__runInitializers": () => (/* binding */ __runInitializers),
/* harmony export */   "__setFunctionName": () => (/* binding */ __setFunctionName),
/* harmony export */   "__spread": () => (/* binding */ __spread),
/* harmony export */   "__spreadArray": () => (/* binding */ __spreadArray),
/* harmony export */   "__spreadArrays": () => (/* binding */ __spreadArrays),
/* harmony export */   "__values": () => (/* binding */ __values),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [9774,179], () => (__webpack_exec__(6840), __webpack_exec__(80880)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);